/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An arbitrary precision signed decimal */
  BigDecimal: { input: number; output: number; }
  /** An RFC-3339 compliant Full Date Scalar */
  Date: { input: string; output: string; }
  /** An RFC-3339 compliant DateTime Scalar */
  DateTime: { input: string; output: string; }
  /** A JSON scalar */
  JSON: { input: any; output: any; }
  /** A 64-bit signed integer */
  Long: { input: number; output: number; }
  /** An object scalar */
  Object: { input: any; output: any; }
  /** 24-hour clock time value string in the format `hh:mm:ss` or `hh:mm:ss.sss`. */
  Time: { input: string; output: string; }
};

export type AcademicNamespace = {
  __typename?: 'AcademicNamespace';
  academicNamespaceId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['Date']['output'];
  isActiveDefaultNamespace: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
  type: AcademicNamespaceType;
  year: Scalars['Int']['output'];
};

export type AcademicNamespaceFilter = {
  academicNamespaceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tenants?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export enum AcademicNamespaceType {
  WaitingList = 'WAITING_LIST',
  Year = 'YEAR'
}

export enum AccessUserType {
  Contact = 'CONTACT',
  Staff = 'STAFF',
  Student = 'STUDENT'
}

export type AccountAction = {
  block: Scalars['Boolean']['input'];
  partyId: Scalars['Long']['input'];
};

export type AccountReset = {
  email: Scalars['String']['input'];
  globalUserId?: InputMaybe<Scalars['Int']['input']>;
  invitedEmail?: InputMaybe<Scalars['String']['input']>;
  partyId: Scalars['Long']['input'];
};

export type AccountingCode = {
  __typename?: 'AccountingCode';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  /** deep linked */
  createdBy: Person;
  createdByPartyId: Scalars['Long']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type AccountingCodeFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Active = {
  __typename?: 'Active';
  active?: Maybe<Scalars['Boolean']['output']>;
  studentPartyId?: Maybe<Scalars['Long']['output']>;
};

export type ActiveFilter = {
  studentPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export enum Activity {
  GuidanceAndCounselling = 'GUIDANCE_AND_COUNSELLING',
  HomeSchoolLiaison = 'HOME_SCHOOL_LIAISON',
  OtherActivity = 'OTHER_ACTIVITY',
  ProgrammeCoordination = 'PROGRAMME_COORDINATION',
  Support = 'SUPPORT',
  TimetabledHoursInOtherSchools = 'TIMETABLED_HOURS_IN_OTHER_SCHOOLS'
}

export type Address = {
  __typename?: 'Address';
  active?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  line4?: Maybe<Scalars['String']['output']>;
  line5?: Maybe<Scalars['String']['output']>;
  partyId: Scalars['Long']['output'];
  postCode?: Maybe<Scalars['String']['output']>;
  primaryAddress?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminLookupFilter = {
  email: Scalars['String']['input'];
};

export enum AggregationFunction {
  Avg = 'AVG',
  Count = 'COUNT',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export type AppVersion = {
  __typename?: 'AppVersion';
  minimumSupportedVersion: Scalars['String']['output'];
};

export type ArchiveMailInput = {
  archive: Scalars['Boolean']['input'];
  schoolMailbox: Scalars['Boolean']['input'];
  threadId: Scalars['Long']['input'];
  threadMessageId: Scalars['Long']['input'];
};

export type ArchiveStudentContactInput = {
  contactPartyIds: Array<Scalars['Long']['input']>;
};

export type Assessment = {
  __typename?: 'Assessment';
  academicNamespaceId: Scalars['Int']['output'];
  allowLearnerPrint: Scalars['Boolean']['output'];
  archived: Scalars['Boolean']['output'];
  assessmentType: AssessmentType;
  canEnterOverallComments: Scalars['Boolean']['output'];
  captureHouseMasterComment: Scalars['Boolean']['output'];
  capturePrincipalComment: Scalars['Boolean']['output'];
  captureTarget: Scalars['Boolean']['output'];
  captureTutorComment: Scalars['Boolean']['output'];
  captureYearHeadComment: Scalars['Boolean']['output'];
  commentBank?: Maybe<AssessmentCommentBank>;
  commentLength?: Maybe<Scalars['Int']['output']>;
  commentType: CommentType;
  /** deep linked */
  createdBy: Person;
  createdByPartyId: Scalars['Long']['output'];
  createdOn: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  docxFileTransferId?: Maybe<Scalars['Long']['output']>;
  endDate: Scalars['Date']['output'];
  externalSystemId?: Maybe<Scalars['String']['output']>;
  extraFields?: Maybe<Array<AssessmentExtraField>>;
  gradeSetIds?: Maybe<Array<Scalars['Long']['output']>>;
  gradeSets?: Maybe<Array<GradeSet>>;
  gradeType: GradeType;
  housemasterCommentBank?: Maybe<AssessmentCommentBank>;
  housemasterCommentLength?: Maybe<Scalars['Int']['output']>;
  housemasterCommentType?: Maybe<CommentType>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  openForResultEntry: Scalars['Boolean']['output'];
  passFailThreshold?: Maybe<Scalars['Int']['output']>;
  ppodSyncedSubjectGroupCount?: Maybe<Scalars['Int']['output']>;
  ppodTotalSubjectGroupCount?: Maybe<Scalars['Int']['output']>;
  principalCommentBank?: Maybe<AssessmentCommentBank>;
  principalCommentLength?: Maybe<Scalars['Int']['output']>;
  principalCommentType?: Maybe<CommentType>;
  programmeStageEnrollmentPartyIds?: Maybe<Array<Scalars['Long']['output']>>;
  programmeStageEnrollments?: Maybe<Array<ProgrammeStageEnrollment>>;
  programmeStageIds?: Maybe<Array<Scalars['Int']['output']>>;
  programmeStages?: Maybe<Array<ProgrammeStage>>;
  publish: Scalars['Boolean']['output'];
  publishLearner: Scalars['Boolean']['output'];
  publishedFrom?: Maybe<Scalars['Date']['output']>;
  showType: GradeType;
  startDate: Scalars['Date']['output'];
  stateCbaType?: Maybe<StateCbaType>;
  subjectGroupIds?: Maybe<Array<Scalars['Long']['output']>>;
  subjectGroups?: Maybe<Array<SubjectGroup>>;
  tutorCommentBank?: Maybe<AssessmentCommentBank>;
  tutorCommentLength?: Maybe<Scalars['Int']['output']>;
  tutorCommentType?: Maybe<CommentType>;
  yearGroupEnrollmentPartyIds?: Maybe<Array<Scalars['Long']['output']>>;
  yearGroupEnrolments?: Maybe<Array<YearGroupEnrollment>>;
  yearGroupIds?: Maybe<Array<Scalars['Int']['output']>>;
  yearHeadCommentBank?: Maybe<AssessmentCommentBank>;
  yearHeadCommentLength?: Maybe<Scalars['Int']['output']>;
  yearHeadCommentType?: Maybe<CommentType>;
  /** deep linked */
  years?: Maybe<Array<YearGroup>>;
};

export type AssessmentComment = {
  __typename?: 'AssessmentComment';
  assessmentId: Scalars['Long']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  commentBankCommentId?: Maybe<Scalars['Long']['output']>;
  commenterPartyId: Scalars['Long']['output'];
  commenterUserType: CommenterUserType;
  id: Scalars['Long']['output'];
  studentPartyId: Scalars['Long']['output'];
  subjectGroupPartyId: Scalars['Long']['output'];
};

export type AssessmentCommentBank = {
  __typename?: 'AssessmentCommentBank';
  commentBankId: Scalars['Long']['output'];
  commentBankName?: Maybe<Scalars['String']['output']>;
};

export type AssessmentCommentFilter = {
  assessmentId?: InputMaybe<Scalars['Long']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  studentPartyId?: InputMaybe<Scalars['Long']['input']>;
  studentPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type AssessmentExtraField = {
  __typename?: 'AssessmentExtraField';
  assessmentId: Scalars['Long']['output'];
  commentBankId?: Maybe<Scalars['Long']['output']>;
  commentBankName?: Maybe<Scalars['String']['output']>;
  commentLength?: Maybe<Scalars['Int']['output']>;
  externalSystemId?: Maybe<Scalars['String']['output']>;
  extraFieldType: ExtraFieldType;
  gradeSetId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  resultsEntered: Scalars['Boolean']['output'];
  selectOptions?: Maybe<Array<Scalars['String']['output']>>;
};

export type AssessmentFilter = {
  academicNameSpaceId?: InputMaybe<Scalars['Int']['input']>;
  assessmentType?: InputMaybe<AssessmentType>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subjectGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  yearGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type AssessmentGradeSet = {
  __typename?: 'AssessmentGradeSet';
  gradeSetId: Scalars['Long']['output'];
  gradeSetName?: Maybe<Scalars['String']['output']>;
};

export type AssessmentResult = {
  __typename?: 'AssessmentResult';
  absent: Scalars['Boolean']['output'];
  assessmentId?: Maybe<Scalars['Long']['output']>;
  createdBy: Person;
  createdByPartyId: Scalars['Long']['output'];
  examinable: Scalars['Boolean']['output'];
  externalSystemId?: Maybe<Scalars['String']['output']>;
  extraFields?: Maybe<Array<ResultExtraField>>;
  gradeId?: Maybe<Scalars['Long']['output']>;
  gradeNameTextId?: Maybe<Scalars['Int']['output']>;
  gradeResult?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  ppodErrorMessage?: Maybe<Scalars['String']['output']>;
  ppodPublished?: Maybe<Scalars['Boolean']['output']>;
  ppodPublishedOn?: Maybe<Scalars['DateTime']['output']>;
  ppodResult?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['Int']['output']>;
  student: Student;
  studentClassGroup: Scalars['String']['output'];
  studentPartyId: Scalars['Long']['output'];
  studentProgramme?: Maybe<Programme>;
  studentStudyLevel?: Maybe<StudyLevel>;
  subjectGroup: SubjectGroup;
  subjectGroupId: Scalars['Long']['output'];
  targetGrade?: Maybe<Scalars['String']['output']>;
  targetGradeId?: Maybe<Scalars['Long']['output']>;
  targetGradeNameTextId?: Maybe<Scalars['Int']['output']>;
  targetGradeResult?: Maybe<Scalars['String']['output']>;
  targetResult?: Maybe<Scalars['Int']['output']>;
  teacherComment?: Maybe<AssessmentComment>;
};

export type AssessmentResultFilter = {
  assessmentId?: InputMaybe<Scalars['Long']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  studentPartyId?: InputMaybe<Scalars['Long']['input']>;
  subjectGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type AssessmentSubjectGroup = {
  __typename?: 'AssessmentSubjectGroup';
  commentsEntered: Scalars['Int']['output'];
  commentsTotal: Scalars['Int']['output'];
  extraFieldResultsEntered: Scalars['Int']['output'];
  extraFieldResultsTotal: Scalars['Int']['output'];
  ppodErrorMessages?: Maybe<Array<Scalars['String']['output']>>;
  ppodSyncStatus?: Maybe<SyncStatus>;
  published?: Maybe<Scalars['Boolean']['output']>;
  resultsEntered: Scalars['Int']['output'];
  resultsTotal: Scalars['Int']['output'];
  subjectGroup: SubjectGroup;
};

export type AssessmentSubjectGroupsFilter = {
  assessmentId?: InputMaybe<Scalars['Long']['input']>;
  subjectGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export enum AssessmentType {
  InClass = 'IN_CLASS',
  StateCba = 'STATE_CBA',
  Term = 'TERM'
}

export enum Assessment_GradeSetType {
  Custom = 'CUSTOM',
  IrishStandard = 'IRISH_STANDARD',
  JuniorCycleStateCba = 'JUNIOR_CYCLE_STATE_CBA'
}

export type AssignLabelInput = {
  labelId: Scalars['Long']['input'];
  mailId: Scalars['Long']['input'];
  threadId: Scalars['Long']['input'];
  threadMessageId: Scalars['Long']['input'];
};

export type Attachment = {
  __typename?: 'Attachment';
  id: Scalars['Long']['output'];
  url: Scalars['String']['output'];
};

export type AttachmentInput = {
  forwarded: Scalars['Boolean']['input'];
  id: Scalars['Long']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AttendanceCode = {
  __typename?: 'AttendanceCode';
  active: Scalars['Boolean']['output'];
  code?: Maybe<TuslaCode>;
  codeType: AttendanceCodeType;
  custom: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId?: Maybe<Scalars['Int']['output']>;
  sessionCodeType: AttendanceCodeType;
  visibleForContact: Scalars['Boolean']['output'];
  visibleForTeacher: Scalars['Boolean']['output'];
};

export type AttendanceCodeFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  teachingGroupCodes?: InputMaybe<Scalars['Boolean']['input']>;
  visibleForContacts?: InputMaybe<Scalars['Boolean']['input']>;
  visibleForTeachers?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AttendanceCodeType {
  ExplainedAbsence = 'EXPLAINED_ABSENCE',
  Late = 'LATE',
  NotTaken = 'NOT_TAKEN',
  Present = 'PRESENT',
  UnexplainedAbsence = 'UNEXPLAINED_ABSENCE'
}

export type AttendanceEventId = {
  /** the date for which this event is scheduled */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** the calendar event id that this attendance event related to */
  eventId?: InputMaybe<Scalars['Int']['input']>;
};

export enum AttendanceThreshold {
  Lower = 'LOWER',
  Middle = 'MIDDLE',
  Upper = 'UPPER'
}

export type Attendance_BulkAttendanceAction = {
  __typename?: 'Attendance_BulkAttendanceAction';
  action?: Maybe<Attendance_BulkAttendanceActionType>;
  attendanceCode: AttendanceCode;
  attendanceCodeId: Scalars['Int']['output'];
  attendanceForPartyIds: Array<Scalars['Long']['output']>;
  createdBy: AuditPerson;
  createdByPartyId: Scalars['Long']['output'];
  createdByUserId: Scalars['Int']['output'];
  createdOn: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  leavesAt: Scalars['Time']['output'];
  note?: Maybe<Scalars['String']['output']>;
  partial: Scalars['Boolean']['output'];
  parties: Array<Maybe<Party>>;
  returnsAt?: Maybe<Scalars['Time']['output']>;
  startDate: Scalars['Date']['output'];
};

export type Attendance_BulkAttendanceActionFilter = {
  from?: InputMaybe<Scalars['Date']['input']>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  schoolActivityId?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export enum Attendance_BulkAttendanceActionType {
  Created = 'CREATED',
  Reverted = 'REVERTED'
}

export type Attendance_MergeAttendanceCodeInput = {
  attendanceCodeIdToDelete: Scalars['Int']['input'];
  attendanceCodeIdToKeep: Scalars['Int']['input'];
};

export enum Attendance_OverrideAttendance {
  OverwriteAll = 'OVERWRITE_ALL',
  OverwriteNonAdmin = 'OVERWRITE_NON_ADMIN',
  SkipOnConflict = 'SKIP_ON_CONFLICT'
}

export type Attendance_ParentalRequestCounter = {
  __typename?: 'Attendance_ParentalRequestCounter';
  count: Scalars['Int']['output'];
};

export type Attendance_PeriodAttendance = {
  __typename?: 'Attendance_PeriodAttendance';
  adminSubmitted: Scalars['Boolean']['output'];
  attendanceCode?: Maybe<AttendanceCode>;
  eventId: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  periodIdx: Scalars['Int']['output'];
};

export type Attendance_PeriodDateAttendance = {
  __typename?: 'Attendance_PeriodDateAttendance';
  date: Scalars['Date']['output'];
  periodIdxs: Array<Scalars['Int']['output']>;
};

export type Attendance_RollBackAndSaveBulkAttendanceInput = {
  bulkAttendanceInput: Attendance_SaveBulkAttendanceInput;
  rollBackId: Scalars['Int']['input'];
};

export type Attendance_RollBackBulkAttendanceInput = {
  id: Scalars['Int']['input'];
};

export type Attendance_RollBackSignInOutAttendanceInput = {
  id: Scalars['Long']['input'];
};

export type Attendance_RollBookAttendance = {
  __typename?: 'Attendance_RollBookAttendance';
  date: Scalars['Date']['output'];
  eventAttendance: Array<EventAttendance>;
  times: Array<Scalars['Time']['output']>;
};

export type Attendance_RollBookDateAttendance = {
  __typename?: 'Attendance_RollBookDateAttendance';
  date: Scalars['Date']['output'];
  periodAttendance: Array<Attendance_PeriodAttendance>;
};

export type Attendance_RollBookFilter = {
  from: Scalars['Date']['input'];
  groupId: Scalars['Long']['input'];
  to: Scalars['Date']['input'];
};

export type Attendance_RollBookStudent = {
  __typename?: 'Attendance_RollBookStudent';
  classGroup?: Maybe<GeneralGroup>;
  dateAttendance: Array<Attendance_RollBookDateAttendance>;
  student: Student;
  studentPartyId: Scalars['Long']['output'];
};

export type Attendance_RollbackParentalAttendanceInput = {
  id: Scalars['Long']['input'];
};

export type Attendance_SaveBulkAttendanceInput = {
  attendanceCodeId: Scalars['Int']['input'];
  attendanceForPartyIds: Array<Scalars['Long']['input']>;
  attendanceOverride?: InputMaybe<Attendance_OverrideAttendance>;
  excludeEventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  exclusionPersonPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  multiDate?: InputMaybe<Attendance_SaveBulkAttendanceMultiDateInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  partialDate?: InputMaybe<Attendance_SaveBulkAttendancePartialDateInput>;
  schoolActivityId?: InputMaybe<Scalars['Int']['input']>;
  /** either singleDate or multiDate or partialDate should be provided */
  singleDate?: InputMaybe<Attendance_SaveBulkAttendanceSingleDateInput>;
};

export type Attendance_SaveBulkAttendanceMultiDateInput = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type Attendance_SaveBulkAttendancePartialDateInput = {
  date: Scalars['Date']['input'];
  leavesAt: Scalars['Time']['input'];
  returnsAt: Scalars['Time']['input'];
};

export type Attendance_SaveBulkAttendanceSingleDateInput = {
  date: Scalars['Date']['input'];
};

export type Attendance_SignInOutDeleteInput = {
  id: Scalars['Long']['input'];
  personType: Attendance_SignInOutPersonType;
};

export type Attendance_SignInOutInput = {
  attendanceCodeId?: InputMaybe<Scalars['Long']['input']>;
  collectedBy?: InputMaybe<Scalars['String']['input']>;
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  eventAttendance?: InputMaybe<Array<InputMaybe<SaveEventAttendanceInput>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  overrideThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  parentalRequestId?: InputMaybe<Scalars['Long']['input']>;
  personType: Attendance_SignInOutPersonType;
  sessionAttendance?: InputMaybe<Array<InputMaybe<SaveStudentSessionAttendanceInput>>>;
  signInOutStatus?: InputMaybe<Attendance_SignInOutStatus>;
  signInOutType: Attendance_SignInOutType;
  studentPartyId?: InputMaybe<Scalars['Long']['input']>;
  visitingPartyId?: InputMaybe<Scalars['Long']['input']>;
};

export enum Attendance_SignInOutPersonType {
  Student = 'STUDENT',
  Visitor = 'VISITOR'
}

export type Attendance_SignInOutReportFilter = {
  filterStatus?: InputMaybe<Array<Attendance_SignInOutStatus>>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  studentPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Attendance_SignInOutStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Reverted = 'REVERTED'
}

export enum Attendance_SignInOutType {
  SignIn = 'SIGN_IN',
  SignOut = 'SIGN_OUT'
}

export type Attendance_StudentRollBook = {
  __typename?: 'Attendance_StudentRollBook';
  classGroup?: Maybe<GeneralGroup>;
  dateAttendance: Array<Attendance_RollBookAttendance>;
  student: Student;
  studentPartyId: Scalars['Long']['output'];
};

export type Attendance_StudentRollBookAttendance = {
  __typename?: 'Attendance_StudentRollBookAttendance';
  events: Array<CalendarEvent>;
  periods: Array<Attendance_PeriodDateAttendance>;
  students: Array<Attendance_RollBookStudent>;
};

export type Attendance_StudentRollBookFilter = {
  from: Scalars['Date']['input'];
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  to: Scalars['Date']['input'];
};

export type AuditId = {
  __typename?: 'AuditId';
  partyId?: Maybe<Scalars['Long']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AuditPerson = {
  __typename?: 'AuditPerson';
  partyId?: Maybe<Scalars['Long']['output']>;
  person?: Maybe<Person>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum AwardingBody {
  Cidesco = 'CIDESCO',
  CityAndGuilds = 'CITY_AND_GUILDS',
  Itec = 'ITEC',
  Qqi = 'QQI'
}

export type BankTransferInstructions = {
  __typename?: 'BankTransferInstructions';
  accountHolderName: Scalars['String']['output'];
  amountDue: Scalars['Float']['output'];
  bic: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type BellTimeAttendance = {
  __typename?: 'BellTimeAttendance';
  adminSubmitted: Scalars['Boolean']['output'];
  attendanceCode?: Maybe<AttendanceCode>;
  bellTime: Calendar_BellTime;
  bellTimeId: Scalars['Int']['output'];
  createdBy: Person;
  createdByPartyId: Scalars['Long']['output'];
  note?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Person;
  updatedByPartyId: Scalars['Long']['output'];
};

export type BellTimeFilter = {
  ids: Array<InputMaybe<Scalars['Int']['input']>>;
};

export enum BellTimeType {
  Am = 'AM',
  Pm = 'PM'
}

export type BlockFilter = {
  blockIds?: InputMaybe<Array<Scalars['String']['input']>>;
  classGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  yearGroupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type BlockRotation = {
  __typename?: 'BlockRotation';
  endDate: Scalars['Date']['output'];
  iteration: Scalars['Int']['output'];
  startDate: Scalars['Date']['output'];
  subjectGroupIds: Array<Scalars['Long']['output']>;
};

export enum Blocked {
  GeoBlocked = 'GEO_BLOCKED',
  UserBlocked = 'USER_BLOCKED'
}

export type Building = {
  __typename?: 'Building';
  campus: Campus;
  campusId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BuildingFilter = {
  campusIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum BulkAction {
  Remove = 'REMOVE',
  Upsert = 'UPSERT'
}

/**
 * Target population for BULK_PERSONAL_DRIVE uploads. Admins must pick one
 * and cannot mix staff and student in a single upload — prevents
 * cross-population leakage when matching party IDs.
 */
export enum BulkPersonalDriveTarget {
  Staff = 'STAFF',
  Student = 'STUDENT'
}

export enum ClmPrintFormat {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export enum ClmPrintType {
  Block = 'BLOCK',
  Class = 'CLASS'
}

export type CalculateCaoPointsFilter = {
  grade: Scalars['String']['input'];
  studyLevel: StudyLevel;
};

export type CalculateGradeFilter = {
  gradeSetId: Scalars['Long']['input'];
  programmeShortName?: InputMaybe<Scalars['String']['input']>;
  result: Scalars['Int']['input'];
  studyLevel?: InputMaybe<StudyLevel>;
};

export type CalculatePaymentPlanFilter = {
  ids: Array<CalculatePaymentPlanId>;
};

export type CalculatePaymentPlanId = {
  feeId: Scalars['Int']['input'];
  studentPartyId: Scalars['Long']['input'];
};

export type CalculatedGrade = {
  __typename?: 'CalculatedGrade';
  grade?: Maybe<Scalars['String']['output']>;
};

export type Calendar = {
  __typename?: 'Calendar';
  academicEndDate: Scalars['Date']['output'];
  academicNamespaceId: Scalars['Int']['output'];
  academicStartDate: Scalars['Date']['output'];
  /** deep linked */
  dayInfo: Array<CalendarDayInfo>;
  /** end Date of the Calendar this will typically be after the end of the academic year */
  endDate: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  /** start Date of the Calendar this will typically be the before start of the academic year */
  startDate: Scalars['Date']['output'];
};

export type CalendarAttendance = {
  __typename?: 'CalendarAttendance';
  attendances: Array<CalendarAttendanceDay>;
  totalAbsent: Scalars['Int']['output'];
  totalHolidays: Scalars['Int']['output'];
  totalLate: Scalars['Int']['output'];
  totalNotTaken: Scalars['Int']['output'];
  totalPartial: Scalars['Int']['output'];
  totalPresent: Scalars['Int']['output'];
  totalUnexplained: Scalars['Int']['output'];
};

export type CalendarAttendanceDay = {
  __typename?: 'CalendarAttendanceDay';
  date: Scalars['Date']['output'];
  partiallyTaken: Scalars['Boolean']['output'];
  status: CalendarCodeType;
};

export type CalendarAttendanceFilter = {
  from: Scalars['Date']['input'];
  partyId: Scalars['Long']['input'];
  to: Scalars['Date']['input'];
};

export enum CalendarCodeType {
  ExplainedAbsence = 'EXPLAINED_ABSENCE',
  Holiday = 'HOLIDAY',
  Late = 'LATE',
  NotTaken = 'NOT_TAKEN',
  Present = 'PRESENT',
  UnexplainedAbsence = 'UNEXPLAINED_ABSENCE'
}

export type CalendarDayBellTime = {
  __typename?: 'CalendarDayBellTime';
  bellTimeIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** deep linked */
  bellTimes?: Maybe<Array<Calendar_BellTime>>;
  date: Scalars['Date']['output'];
  dayType: DayType;
};

export type CalendarDayBellTimeFilter = {
  bellTimeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  calendarId?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};

/** Information about the grid for a specific date */
export type CalendarDayInfo = {
  __typename?: 'CalendarDayInfo';
  date: Scalars['Date']['output'];
  dayType: DayType;
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  gridPeriods: Array<CalendarGridPeriodsInfo>;
  overrideEndTime?: Maybe<Scalars['Time']['output']>;
  /** manually set start/end time can be set to mark a day as starting late or finishing early */
  overrideStartTime?: Maybe<Scalars['Time']['output']>;
  /** only for one grid, depricated use gridPeriods */
  periods: Array<CalendarGridPeriodInfo>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
};

export type CalendarDayInfoFilter = {
  calendarIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CalendarDayInfoId = {
  __typename?: 'CalendarDayInfoId';
  date?: Maybe<Scalars['Date']['output']>;
  eventId: Scalars['Int']['output'];
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  allDayEvent: Scalars['Boolean']['output'];
  alsoShowForParties: Array<Scalars['Long']['output']>;
  attendees: Array<CalendarEventAttendee>;
  calendarEventId: CalendarEventId;
  calendarIds: Array<Maybe<Scalars['Int']['output']>>;
  cancellations: Array<Calendar_EventCancelled>;
  colour?: Maybe<Colour>;
  createdByUserId: Scalars['Int']['output'];
  dayIdx?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  endTime: Scalars['DateTime']['output'];
  eventId: Scalars['Int']['output'];
  eventTagIds?: Maybe<Array<Scalars['Int']['output']>>;
  eventTags?: Maybe<Array<Calendar_EventTag>>;
  exclusions: Array<CalendarEventAttendee>;
  extensions?: Maybe<CalendarEventExtension>;
  followInfo: Array<CalendarEvent_FollowInfo>;
  gridIdx?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  lessonInfo?: Maybe<CalendarEventLessonRaw>;
  name: Scalars['String']['output'];
  periodIdx?: Maybe<Scalars['Int']['output']>;
  publicContactCalendar: Scalars['Boolean']['output'];
  publicStaffCalendar: Scalars['Boolean']['output'];
  publicStudentCalendar: Scalars['Boolean']['output'];
  roomIds: Array<Scalars['Int']['output']>;
  rooms: Array<Room>;
  sourceId?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  status: CalendarEventStatus;
  tags: Array<CalendarTag>;
  type: CalendarEventType;
};

export type CalendarEventAttendee = {
  __typename?: 'CalendarEventAttendee';
  isAugment: Scalars['Boolean']['output'];
  partyId: Scalars['Long']['output'];
  /** deep linked */
  partyInfo?: Maybe<Party>;
  type: CalendarEventAttendeeType;
};

export enum CalendarEventAttendeeType {
  Additional = 'ADDITIONAL',
  Attendee = 'ATTENDEE',
  Organiser = 'ORGANISER'
}

export type CalendarEventExtension = {
  __typename?: 'CalendarEventExtension';
  doeNotUser?: Maybe<Scalars['String']['output']>;
  /** attendance for this event. The list is empty if no attendance has been taken */
  eventAttendance?: Maybe<Array<Maybe<EventAttendance>>>;
  previousEventAttendance?: Maybe<Array<Maybe<EventAttendance>>>;
};

export type CalendarEventFilter = {
  alsoShowForParties?: InputMaybe<Calender_EventFilterAlsoShowForParties>;
  calendarIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  cancellationStatus?: InputMaybe<Calendar_CancellationStatusFilter>;
  customTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** excludes events based on whether a school day or not. Default value false */
  disableDayTypeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  eventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  eventStatus?: InputMaybe<Array<CalendarEventStatus>>;
  eventTypeFilter?: InputMaybe<Array<CalendarEventType>>;
  excludeEventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** best effort reperesent a general week in the school. set this instead of start/end date */
  genericSchoolTimetableCycle?: InputMaybe<Scalars['Boolean']['input']>;
  individualEventFilter?: InputMaybe<IndividualEventFilter>;
  resources: CalendarResourceFilter;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** default to Internal */
  visibility?: InputMaybe<Calendar_RootVisibilityFilter>;
};

export type CalendarEventId = {
  __typename?: 'CalendarEventId';
  date?: Maybe<Scalars['Date']['output']>;
  eventId: Scalars['Int']['output'];
};

export type CalendarEventIdInput = {
  date: Scalars['Date']['input'];
  eventId: Scalars['Int']['input'];
};

export type CalendarEventIteratorFilter = {
  calendarIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eventStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  iterator?: InputMaybe<Iterator>;
  partyId: Scalars['Long']['input'];
};

export type CalendarEventLessonRaw = {
  __typename?: 'CalendarEventLessonRaw';
  lessonId?: Maybe<Scalars['Int']['output']>;
  subjectGroupId: Scalars['Long']['output'];
};

export type CalendarEventRaw = {
  __typename?: 'CalendarEventRaw';
  attendeeAugments: Array<Calendar_EventAttendeeAugment>;
  calendarIds: Array<Scalars['Int']['output']>;
  cancellations: Array<Calendar_EventCancellation>;
  colour?: Maybe<Colour>;
  createdByPartyId: Scalars['Long']['output'];
  createdByUserId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['Int']['output'];
  eventTagIds?: Maybe<Array<Scalars['Int']['output']>>;
  eventTags?: Maybe<Array<Calendar_EventTag>>;
  icon?: Maybe<Scalars['String']['output']>;
  lessonInfo?: Maybe<CalendarEventLessonRaw>;
  name: Scalars['String']['output'];
  publicCalendar: Scalars['Boolean']['output'];
  publicContactCalendar: Scalars['Boolean']['output'];
  publicStaffCalendar: Scalars['Boolean']['output'];
  publicStudentCalendar: Scalars['Boolean']['output'];
  roomAugments: Array<Calendar_EventRoomAugment>;
  schedule: Array<CalendarEventRawSchedule>;
  source?: Maybe<CalendarEventSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  status: CalendarEventStatus;
  tags: Array<CalendarTag>;
  type: CalendarEventType;
};

export type CalendarEventRawAttendee = {
  __typename?: 'CalendarEventRawAttendee';
  /** ... Defaults to event End Date. Used in cases where attendee will not be attending all events */
  endDate?: Maybe<Scalars['Date']['output']>;
  partyId: Scalars['Long']['output'];
  partyInfo?: Maybe<Party>;
  /** ... Defaults to event Recurrence Rule. Used in cases where attendee will not be attending all events */
  recurrenceRule?: Maybe<Scalars['String']['output']>;
  /** ... Defaults to event Start Date. Used in cases where attendee will not be attending all events */
  startDate?: Maybe<Scalars['Date']['output']>;
  type: CalendarEventAttendeeType;
};

export type CalendarEventRawExcludedAttendee = {
  __typename?: 'CalendarEventRawExcludedAttendee';
  endDate?: Maybe<Scalars['Date']['output']>;
  /** either this or other date fields can be set */
  individualDates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  partyId: Scalars['Long']['output'];
  /** ... Defaults to event Recurrence Rule.  Used in cases where attendee will not excluded from all events */
  recurrenceRule?: Maybe<Scalars['String']['output']>;
  /** ... Defaults to event Start Date. Used in cases where attendee will not excluded from all events */
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type CalendarEventRawExcludedRoom = {
  __typename?: 'CalendarEventRawExcludedRoom';
  /** ... Defaults to event End Date. Used in cases where attendee will not be attending all events */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** ... Defaults to event Recurrence Rule. Used in cases where attendee will not be attending all events */
  recurrenceRule?: Maybe<Scalars['String']['output']>;
  roomId: Scalars['Int']['output'];
  /** ... Defaults to event Start Date. Used in cases where attendee will not be attending all events */
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type CalendarEventRawFilter = {
  calendarId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  customTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  eventId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eventSources?: InputMaybe<Array<Calender_EventSourceInput>>;
  eventStatus?: InputMaybe<Array<CalendarEventStatus>>;
  eventTypes?: InputMaybe<Array<CalendarEventType>>;
  /** default to Internal */
  visibility?: InputMaybe<Calendar_RootVisibilityFilter>;
};

export type CalendarEventRawRoom = {
  __typename?: 'CalendarEventRawRoom';
  /** ... Defaults to event End Date. Used in cases where attendee will not be attending all events */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** ... Defaults to event Recurrence Rule. Used in cases where attendee will not be attending all events */
  recurrenceRule?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Room>;
  roomId: Scalars['Int']['output'];
  /** ... Defaults to event Start Date. Used in cases where attendee will not be attending all events */
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type CalendarEventRawSchedule = {
  __typename?: 'CalendarEventRawSchedule';
  allDayEvent?: Maybe<Scalars['Boolean']['output']>;
  attendees: Array<CalendarEventRawAttendee>;
  dayIdx?: Maybe<Scalars['Int']['output']>;
  /** end date of the recurrence */
  endDate?: Maybe<Scalars['Date']['output']>;
  endTime: Scalars['Time']['output'];
  eventId: Scalars['Int']['output'];
  exclusions: Array<CalendarEventRawExcludedAttendee>;
  gridIdx?: Maybe<Scalars['Int']['output']>;
  periodIdx?: Maybe<Scalars['Int']['output']>;
  /** iCal/rfc5545 recurrence rule for event. Null means single */
  recurrenceRule?: Maybe<Scalars['String']['output']>;
  roomExclusions: Array<CalendarEventRawExcludedRoom>;
  rooms?: Maybe<Array<Maybe<CalendarEventRawRoom>>>;
  scheduleId: Scalars['Int']['output'];
  startDate: Scalars['Date']['output'];
  startTime: Scalars['Time']['output'];
};

export type CalendarEventRawScheduleSimple = {
  __typename?: 'CalendarEventRawScheduleSimple';
  allDayEvent?: Maybe<Scalars['Boolean']['output']>;
  dayIdx?: Maybe<Scalars['Int']['output']>;
  /** end date of the recurrence */
  endDate?: Maybe<Scalars['Date']['output']>;
  endTime: Scalars['Time']['output'];
  eventId: Scalars['Int']['output'];
  gridIdx?: Maybe<Scalars['Int']['output']>;
  periodIdx?: Maybe<Scalars['Int']['output']>;
  recurrenceEnum?: Maybe<RecurrenceEnum>;
  /** iCal/rfc5545 recurrence rule for event. Null means single */
  recurrenceRule?: Maybe<Scalars['String']['output']>;
  scheduleId: Scalars['Int']['output'];
  startDate: Scalars['Date']['output'];
  startTime: Scalars['Time']['output'];
};

export type CalendarEventRawSimple = {
  __typename?: 'CalendarEventRawSimple';
  attendees: Array<CalendarEventRawAttendee>;
  calendarIds: Array<Scalars['Int']['output']>;
  colour?: Maybe<Colour>;
  createdBy: AuditPerson;
  createdByPartyId: Scalars['Long']['output'];
  createdByUserId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  eventId: Scalars['Int']['output'];
  eventTags?: Maybe<Array<Calendar_EventTag>>;
  exclusions: Array<CalendarEventRawExcludedAttendee>;
  lessonInfo?: Maybe<CalendarEventLessonRaw>;
  name: Scalars['String']['output'];
  publicContactCalendar: Scalars['Boolean']['output'];
  publicStaffCalendar: Scalars['Boolean']['output'];
  publicStudentCalendar: Scalars['Boolean']['output'];
  roomExclusions: Array<CalendarEventRawExcludedRoom>;
  rooms?: Maybe<Array<Maybe<CalendarEventRawRoom>>>;
  schedule: CalendarEventRawScheduleSimple;
  source?: Maybe<CalendarEventSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  tags: Array<CalendarTag>;
  type: CalendarEventType;
};

export enum CalendarEventSource {
  Manual = 'MANUAL',
  Rotations = 'ROTATIONS',
  SchoolActivity = 'SCHOOL_ACTIVITY',
  Timetable = 'TIMETABLE'
}

export enum CalendarEventStatus {
  Deleted = 'DELETED',
  Proposed = 'PROPOSED',
  Published = 'PUBLISHED'
}

export enum CalendarEventType {
  General = 'GENERAL',
  Lesson = 'LESSON',
  OpeningHours = 'OPENING_HOURS',
  RoomBooking = 'ROOM_BOOKING',
  SchoolActivity = 'SCHOOL_ACTIVITY'
}

export type CalendarEvent_FollowInfo = {
  __typename?: 'CalendarEvent_FollowInfo';
  followId: Scalars['Int']['output'];
  followedParties: Array<Party>;
  followedPartyIds: Array<Scalars['Long']['output']>;
  followerParties: Array<Party>;
  followerPartyIds: Array<Scalars['Long']['output']>;
};

export type CalendarFilter = {
  academicNameSpaceId?: InputMaybe<Scalars['Int']['input']>;
  calendarId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CalendarGrid = {
  __typename?: 'CalendarGrid';
  calendarId: Scalars['Int']['output'];
  days?: Maybe<Array<Maybe<CalendarGridDay>>>;
  /** date grid is active from. default to calendar dates if null */
  fromDate?: Maybe<Scalars['Date']['output']>;
  gridIdx: Scalars['Int']['output'];
  gridVersion: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** date grid is active to. default to calendar dates if null */
  toDate?: Maybe<Scalars['Date']['output']>;
};

export type CalendarGridDay = {
  __typename?: 'CalendarGridDay';
  dayIdx: Scalars['Int']['output'];
  endTime: Scalars['Time']['output'];
  isoDayOfWeek: Scalars['Int']['output'];
  periods: Array<CalendarGridPeriod>;
  startTime: Scalars['Time']['output'];
};

export type CalendarGridDayRaw = {
  __typename?: 'CalendarGridDayRaw';
  /** iso day of week. 1 monday .. 7 sunday */
  dayOfWeek: Scalars['Int']['output'];
  /** the distinct number and order for the days */
  idx: Scalars['Int']['output'];
  periods: Array<CalendarGridPeriodRaw>;
};

export type CalendarGridFilter = {
  gridIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CalendarGridPeriod = {
  __typename?: 'CalendarGridPeriod';
  conbinedWithPeriodIdx?: Maybe<Scalars['Int']['output']>;
  dayIdx: Scalars['Int']['output'];
  endTime: Scalars['Time']['output'];
  /** periods are sequential with no gapes between them */
  gridIdx: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  periodIdx: Scalars['Int']['output'];
  startTime: Scalars['Time']['output'];
  type: CalendarGridPeriodType;
};

export type CalendarGridPeriodInfo = {
  __typename?: 'CalendarGridPeriodInfo';
  endTime: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  periodIdx?: Maybe<Scalars['Int']['output']>;
  /** periods are sequential with no gapes between them */
  startTime: Scalars['DateTime']['output'];
  type: CalendarGridPeriodType;
};

export type CalendarGridPeriodRaw = {
  __typename?: 'CalendarGridPeriodRaw';
  endTime: Scalars['Time']['output'];
  /** the distinct number and order for the periods */
  idx: Scalars['Int']['output'];
  /** periods are sequential with no gapes between them */
  startTime: Scalars['Time']['output'];
  type: CalendarGridPeriodType;
};

export enum CalendarGridPeriodType {
  Break = 'BREAK',
  Class = 'CLASS'
}

export type CalendarGridPeriodsInfo = {
  __typename?: 'CalendarGridPeriodsInfo';
  gridIdx: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  periods: Array<CalendarGridPeriodInfo>;
};

/** ## Raw information about the grid. i.e. it is not tied to a date */
export type CalendarGridRaw = {
  __typename?: 'CalendarGridRaw';
  idx: Scalars['Int']['output'];
  versions?: Maybe<Array<Maybe<CalendarGridVersionRaw>>>;
};

export type CalendarGridVersionRaw = {
  __typename?: 'CalendarGridVersionRaw';
  days?: Maybe<Array<Maybe<CalendarGridDayRaw>>>;
  idx: Scalars['Int']['output'];
  /** date grid is val from. null means the start of the calendar date */
  validFrom?: Maybe<Scalars['Date']['output']>;
  version: Scalars['Int']['output'];
};

export type CalendarResourceFilter = {
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** defaults to false */
  showOverlappingEventsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CalendarResourceTypeEnum {
  Party = 'PARTY',
  Room = 'ROOM'
}

export type CalendarTag = {
  __typename?: 'CalendarTag';
  context: Calendar_TagContext;
  label: Scalars['String']['output'];
};

export type CalendarTagInput = {
  context?: InputMaybe<Calendar_TagContext>;
  label: Scalars['String']['input'];
};

export type Calendar_AugmentEvent = {
  addAttendees?: InputMaybe<Array<InputMaybe<Calendar_AugmentEventAddAttendee>>>;
  addRooms?: InputMaybe<Array<InputMaybe<Calendar_AugmentEventAddRoom>>>;
  augmentId: CalendarTagInput;
  eventId: Scalars['Int']['input'];
  excludeAttendees?: InputMaybe<Array<InputMaybe<Calendar_AugmentEventExcludeAttendee>>>;
  excludeRooms?: InputMaybe<Array<InputMaybe<Calendar_AugmentEventExcludeRoom>>>;
  tags?: InputMaybe<Array<CalendarTagInput>>;
};

export type Calendar_AugmentEventAddAttendee = {
  continuousEndDate?: InputMaybe<Scalars['Date']['input']>;
  continuousStartDate?: InputMaybe<Scalars['Date']['input']>;
  /** set either dates or continuousStartDate and continuousEndDate */
  dates: Array<Scalars['Date']['input']>;
  partyId: Scalars['Long']['input'];
  type: CalendarEventAttendeeType;
};

export type Calendar_AugmentEventAddRoom = {
  continuousEndDate?: InputMaybe<Scalars['Date']['input']>;
  continuousStartDate?: InputMaybe<Scalars['Date']['input']>;
  /** set either dates or continuousStartDate and continuousEndDate */
  dates: Array<Scalars['Date']['input']>;
  roomId: Scalars['Int']['input'];
};

export type Calendar_AugmentEventExcludeAttendee = {
  continuousEndDate?: InputMaybe<Scalars['Date']['input']>;
  continuousStartDate?: InputMaybe<Scalars['Date']['input']>;
  /** set either dates or continuousStartDate and continuousEndDate */
  dates: Array<Scalars['Date']['input']>;
  partyId: Scalars['Long']['input'];
};

export type Calendar_AugmentEventExcludeRoom = {
  continuousEndDate?: InputMaybe<Scalars['Date']['input']>;
  continuousStartDate?: InputMaybe<Scalars['Date']['input']>;
  /** set either dates or continuousStartDate and continuousEndDate */
  dates: Array<Scalars['Date']['input']>;
  roomId: Scalars['Int']['input'];
};

export type Calendar_AugmentEvents = {
  augments: Array<Calendar_AugmentEvent>;
};

export type Calendar_BellTime = {
  __typename?: 'Calendar_BellTime';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nameTextId: Scalars['Int']['output'];
  time: Scalars['Time']['output'];
};

export type Calendar_CalendarSourceInput = {
  calendarId: Scalars['Int']['input'];
  source: CalendarEventSource;
};

export type Calendar_CalendarUnavailabilityDate = {
  continuousEndDate?: InputMaybe<Scalars['Date']['input']>;
  continuousStartDate?: InputMaybe<Scalars['Date']['input']>;
  individualDates?: InputMaybe<Array<Scalars['Date']['input']>>;
  leavesAt?: InputMaybe<Scalars['Time']['input']>;
  /** if is a partial wither leavesAt or  returnsAt must be set */
  partial: Scalars['Boolean']['input'];
  returnsAt?: InputMaybe<Scalars['Time']['input']>;
};

export type Calendar_CancelEvent = {
  context: Calendar_CancellationContext;
  contextId: Scalars['String']['input'];
  dates: Array<InputMaybe<Scalars['Date']['input']>>;
  eventId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Calendar_CancelEvents = {
  events: Array<Calendar_CancelEvent>;
};

export enum Calendar_CancellationContext {
  Manual = 'MANUAL',
  SchoolActivity = 'SCHOOL_ACTIVITY',
  StaffAbsent = 'STAFF_ABSENT'
}

export type Calendar_CancellationRecommendation = {
  __typename?: 'Calendar_CancellationRecommendation';
  awayStudents: Scalars['Int']['output'];
  event: CalendarEvent;
  remainingStudents: Scalars['Int']['output'];
  studentAwayReasons: Array<Calendar_StudentAwayReason>;
  totalStudents: Scalars['Int']['output'];
};

export type Calendar_CancellationRecommendationFilter = {
  endDate: Scalars['Date']['input'];
  eventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  eventTypes?: InputMaybe<Array<CalendarEventType>>;
  minAwayPercentage?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['Date']['input'];
};

export type Calendar_CancellationRecommendationsResult = {
  __typename?: 'Calendar_CancellationRecommendationsResult';
  eventsProcessed: Scalars['Int']['output'];
  recommendations: Array<Calendar_CancellationRecommendation>;
};

export enum Calendar_CancellationStatusFilter {
  All = 'ALL',
  Cancelled = 'CANCELLED',
  NotCancelled = 'NOT_CANCELLED'
}

export type Calendar_Clash = {
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Calendar_ClashType>;
};

export type Calendar_ClashError = {
  __typename?: 'Calendar_ClashError';
  clashingParties: Array<Party>;
  clashingPartyIds: Array<Scalars['Long']['output']>;
  clashingRoomIds: Array<Scalars['Int']['output']>;
  clashingRooms: Array<Room>;
  endTime?: Maybe<Scalars['Time']['output']>;
  event: Scalars['String']['output'];
  eventId: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['Time']['output']>;
};

export enum Calendar_ClashType {
  Conflict = 'CONFLICT',
  Unavailable = 'UNAVAILABLE'
}

export type Calendar_CloneEvent = {
  overrideAllDayEvent?: InputMaybe<Scalars['Boolean']['input']>;
  overrideAttendees?: InputMaybe<Array<Scalars['Long']['input']>>;
  overrideCalendarIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  overrideColour?: InputMaybe<Colour>;
  overrideCustomTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  overrideDayIdx?: InputMaybe<Scalars['Int']['input']>;
  overrideDescription?: InputMaybe<Scalars['String']['input']>;
  overrideEndDate?: InputMaybe<Scalars['Date']['input']>;
  overrideEndTime?: InputMaybe<Scalars['Time']['input']>;
  overrideEventSource?: InputMaybe<CalendarEventSource>;
  overrideEventSourceId?: InputMaybe<Scalars['String']['input']>;
  overrideGridIdx?: InputMaybe<Scalars['Int']['input']>;
  overrideLessonId?: InputMaybe<Scalars['Int']['input']>;
  overrideLessonSubjectGroupId?: InputMaybe<Scalars['Long']['input']>;
  overrideName?: InputMaybe<Scalars['String']['input']>;
  overrideOrganisers?: InputMaybe<Array<Scalars['Long']['input']>>;
  overridePeriodIdx?: InputMaybe<Scalars['Int']['input']>;
  overridePublicContactCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  overridePublicStaffCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  overridePublicStudentCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  overrideRecurrenceRule?: InputMaybe<Scalars['String']['input']>;
  overrideRoom?: InputMaybe<Array<Scalars['Int']['input']>>;
  overrideStartDate?: InputMaybe<Scalars['Date']['input']>;
  overrideStartTime?: InputMaybe<Scalars['Time']['input']>;
  overrideType?: InputMaybe<CalendarEventType>;
  sourceEventId: Scalars['Int']['input'];
};

export type Calendar_CreateBellTimeInput = {
  bellTimeId?: InputMaybe<Scalars['Int']['input']>;
  name: Array<TranslationInput>;
  time: Scalars['Time']['input'];
};

export type Calendar_CreateCalendarDayInput = {
  date: Scalars['Date']['input'];
  dayType: DayType;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  schoolDayTypeId?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
};

export type Calendar_CreateSchoolDayTypeInput = {
  bellTimeIds: Array<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type Calendar_DatetimeFilterCondition = {
  afterTime?: InputMaybe<Scalars['Time']['input']>;
  attendeePartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  beforeTime?: InputMaybe<Scalars['Time']['input']>;
  /** filters for only these dates within the range */
  dateArray?: InputMaybe<Array<Scalars['Date']['input']>>;
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  overlapEndTime?: InputMaybe<Scalars['Time']['input']>;
  overlapStartTime?: InputMaybe<Scalars['Time']['input']>;
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Calendar_DeleteEvent = {
  /**
   * Delete every event of the given source type within a calendar, regardless of source id.
   * Used by full republish to clear stale/orphaned timetable events that no longer match a
   * current lesson's source id.
   */
  deleteAllEventsByCalendarSource?: InputMaybe<Array<Calendar_CalendarSourceInput>>;
  deleteByEventId: Array<Scalars['Int']['input']>;
  deleteBySource: Array<Calender_EventSourceInput>;
  deleteFromDate?: InputMaybe<Scalars['Date']['input']>;
  mode?: InputMaybe<Calender_EventDeleteMode>;
};

export type Calendar_DeleteEventAugments = {
  augments: Array<Scalars['String']['input']>;
};

export type Calendar_DeleteEventCancellationInput = {
  eventCancellationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Calendar_DeleteUnavailability = {
  unavailabilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Calendar_EditEvent = {
  /** if present will replace existing values else no update */
  attendees?: InputMaybe<Array<CreateCalendarEventAttendeeInput>>;
  /** possibly edit these here or possibly serperate method for it as these are at the root event level */
  colour?: InputMaybe<Colour>;
  customTagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** either eventId or eventSource and eventSourceId must be provided */
  eventId?: InputMaybe<Scalars['Int']['input']>;
  /** if present will replace existing values else no update */
  exclusions?: InputMaybe<Array<CreateCalendarEventAttendeeInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicContactCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  publicStaffCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  publicStudentCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  /** if present will replace existing values else no update */
  rooms?: InputMaybe<Array<CreateCalendarEventRoomInput>>;
  /** if present will replace existing values else no update */
  schedule?: InputMaybe<Calendar_EditEventSchedule>;
  sourceId?: InputMaybe<Calender_EventSourceInput>;
  status?: InputMaybe<CalendarEventStatus>;
  updateSourceId?: InputMaybe<Calender_EventSourceInput>;
};

export type Calendar_EditEventSchedule = {
  dayIdx?: InputMaybe<Scalars['Int']['input']>;
  /** end date of the recurrence. This is set Or occurrences is set */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endTime: Scalars['Time']['input'];
  gridIdx?: InputMaybe<Scalars['Int']['input']>;
  /** number of occurrences. This is set Or endDate is set */
  occurrences?: InputMaybe<Scalars['Int']['input']>;
  periodIdx?: InputMaybe<Scalars['Int']['input']>;
  /** Tyro Enum for iCal/rfc5545 recurrence rule for event. Null means single. Set either this or recurrenceRule */
  recurrenceEnum?: InputMaybe<RecurrenceEnum>;
  /** iCal/rfc5545 recurrence rule for event. Null means single. Set either this or recurrenceEnum */
  recurrenceRule?: InputMaybe<Scalars['String']['input']>;
  /**
   * this should take into account the effective start date and the day of the week of the event
   * the date has to be set here there may ne multi week timetables and we cannot infer the date from nextOrSame day after the effective from date
   */
  startDate: Scalars['Date']['input'];
  startTime: Scalars['Time']['input'];
};

export enum Calendar_EditEventSource {
  Timetable = 'TIMETABLE'
}

export type Calendar_EditEvents = {
  /** default true */
  allowClashes?: InputMaybe<Scalars['Boolean']['input']>;
  calendarId: Scalars['Int']['input'];
  editSource: CalendarEventSource;
  /** defaults to tomorrow if not present */
  effectiveFromDate?: InputMaybe<Scalars['Date']['input']>;
  events: Array<Calendar_EditEvent>;
};

export type Calendar_EventAttendeeAugment = {
  __typename?: 'Calendar_EventAttendeeAugment';
  endDate?: Maybe<Scalars['Date']['output']>;
  inclusionType: Calendar_InclusionType;
  individualDates: Array<Scalars['Date']['output']>;
  partyId: Scalars['Long']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  tags: Array<CalendarTag>;
  type: CalendarEventAttendeeType;
};

export type Calendar_EventCancellation = {
  __typename?: 'Calendar_EventCancellation';
  context: Calendar_CancellationContext;
  contextId: Scalars['String']['output'];
  dates: Array<Scalars['Date']['output']>;
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type Calendar_EventCancelled = {
  __typename?: 'Calendar_EventCancelled';
  context: Calendar_CancellationContext;
  contextId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type Calendar_EventIteratorResult = {
  __typename?: 'Calendar_EventIteratorResult';
  event?: Maybe<CalendarEvent>;
  eventsOnSameDayForSameGroup?: Maybe<Array<CalendarEvent>>;
};

export type Calendar_EventRoomAugment = {
  __typename?: 'Calendar_EventRoomAugment';
  endDate?: Maybe<Scalars['Date']['output']>;
  inclusionType: Calendar_InclusionType;
  individualDates: Array<Scalars['Date']['output']>;
  roomId: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  tags: Array<CalendarTag>;
};

export type Calendar_EventTag = {
  __typename?: 'Calendar_EventTag';
  colour?: Maybe<Colour>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
  refId?: Maybe<Scalars['String']['output']>;
  systemTag: Scalars['Boolean']['output'];
  type: Calendar_EventTagType;
  uniqueName: Scalars['String']['output'];
};

export type Calendar_EventTagFilter = {
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tagTypes?: InputMaybe<Array<InputMaybe<Calendar_EventTagType>>>;
};

export enum Calendar_EventTagType {
  Ana = 'ANA',
  Detention = 'DETENTION',
  Follow = 'FOLLOW',
  OpeningHours = 'OPENING_HOURS',
  ParentTeacherMeeting = 'PARENT_TEACHER_MEETING',
  PublicCalendar = 'PUBLIC_CALENDAR'
}

export type Calendar_Follow = {
  __typename?: 'Calendar_Follow';
  createdBy: AuditPerson;
  createdByPartyId: Scalars['Long']['output'];
  createdByUserId: Scalars['Int']['output'];
  eventIds: Array<Scalars['Int']['output']>;
  events: Array<CalendarEvent>;
  followId: Scalars['Int']['output'];
  followTagIds: Array<Scalars['Int']['output']>;
  followedParties: Array<Party>;
  followedPartyIds: Array<Scalars['Long']['output']>;
  followerParties: Array<Party>;
  followerPartyIds: Array<Scalars['Long']['output']>;
  fromDate?: Maybe<Scalars['Date']['output']>;
  toDate?: Maybe<Scalars['Date']['output']>;
  updatedBy: AuditPerson;
  updatedByPartyId: Scalars['Long']['output'];
  updatedByUserId: Scalars['Int']['output'];
};

export type Calendar_FollowClashDetails = {
  __typename?: 'Calendar_FollowClashDetails';
  clashingParties: Array<Party>;
  eventName: Scalars['String']['output'];
  startTime: Scalars['Time']['output'];
};

export type Calendar_FollowClashError = {
  __typename?: 'Calendar_FollowClashError';
  clashingEvents: Array<Calendar_FollowClashDetails>;
  followEventId: Scalars['Int']['output'];
  followEventName?: Maybe<Scalars['String']['output']>;
};

export type Calendar_FollowDelete = {
  deleteAllFollowsForEventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  followIds: Array<Scalars['Int']['input']>;
};

export type Calendar_FollowUpsert = {
  /** defaults to false */
  allowClashes?: InputMaybe<Scalars['Boolean']['input']>;
  eventIds: Array<Scalars['Int']['input']>;
  followTagIds: Array<Scalars['Int']['input']>;
  followedPartyIds: Array<Scalars['Long']['input']>;
  followerId?: InputMaybe<Scalars['Int']['input']>;
  followerPartyIds: Array<Scalars['Long']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Calendar_FollowUpsertResult = {
  __typename?: 'Calendar_FollowUpsertResult';
  clashes: Array<Calendar_FollowClashError>;
  followId: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type Calendar_FreeSlot = {
  __typename?: 'Calendar_FreeSlot';
  date: Scalars['Date']['output'];
  dayIdx?: Maybe<Scalars['Int']['output']>;
  endDateTime: Scalars['DateTime']['output'];
  gridIdx?: Maybe<Scalars['Int']['output']>;
  periodIdx?: Maybe<Scalars['Int']['output']>;
  startDateTime: Scalars['DateTime']['output'];
};

export type Calendar_Ical_SchoolCalendar = {
  __typename?: 'Calendar_Ical_SchoolCalendar';
  enabled: Scalars['Boolean']['output'];
  externalCalendarId?: Maybe<Scalars['String']['output']>;
  externalCalendarLink?: Maybe<Scalars['String']['output']>;
};

export type Calendar_Ical_SchoolCalendarConfigure = {
  enable: Scalars['Boolean']['input'];
};

export enum Calendar_InclusionType {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export type Calendar_InternalEventIdFilter = {
  calendarId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  customTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  eventId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eventStatus?: InputMaybe<Array<CalendarEventStatus>>;
  eventTypes?: InputMaybe<Array<CalendarEventType>>;
};

export type Calendar_ManuallyCancelEventInput = {
  events: Array<Calendar_ManuallyCancelEvent_Event>;
  note?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Calendar_ManuallyCancelEvent_Event = {
  dates: Array<Scalars['Date']['input']>;
  eventId: Scalars['Int']['input'];
};

export type Calendar_NextFreeSlot = {
  __typename?: 'Calendar_NextFreeSlot';
  freeSlots: Array<Calendar_FreeSlot>;
};

export type Calendar_NextFreeSlotFilter = {
  fromDateTime: Scalars['DateTime']['input'];
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  partyId: Scalars['Long']['input'];
  toDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Calendar_PeriodId = {
  __typename?: 'Calendar_PeriodId';
  dayIdx: Scalars['Int']['output'];
  gridIdx: Scalars['Int']['output'];
  periodIdx: Scalars['Int']['output'];
};

export type Calendar_RootVisibilityFilter = {
  publicFilter?: InputMaybe<Calendar_RootVisibilityPublicFilter>;
  types?: InputMaybe<Array<InputMaybe<Calender_RootVisibilityType>>>;
};

export type Calendar_RootVisibilityPublicFilter = {
  visibleToContacts?: InputMaybe<Scalars['Boolean']['input']>;
  visibleToStaff?: InputMaybe<Scalars['Boolean']['input']>;
  visibleToStudents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Calendar_ScheduleClash = Calendar_Clash & {
  __typename?: 'Calendar_ScheduleClash';
  event?: Maybe<CalendarEvent>;
  eventId?: Maybe<Scalars['Int']['output']>;
  isCancelled: Scalars['Boolean']['output'];
  startTime?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Calendar_ClashType>;
};

export type Calendar_SchoolDayType = {
  __typename?: 'Calendar_SchoolDayType';
  bellTimeIds: Array<Scalars['Int']['output']>;
  bellTimes: Array<Calendar_BellTime>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  time: Scalars['Time']['output'];
};

export type Calendar_StudentAwayReason = {
  __typename?: 'Calendar_StudentAwayReason';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  studentCount: Scalars['Int']['output'];
  studentIds: Array<Scalars['Long']['output']>;
  type: Calendar_StudentAwayReasonType;
};

export enum Calendar_StudentAwayReasonType {
  SchoolActivity = 'SCHOOL_ACTIVITY'
}

export enum Calendar_TagContext {
  Augment = 'AUGMENT',
  EventType = 'EVENT_TYPE',
  Follow = 'FOLLOW',
  FollowedAnaParty = 'FOLLOWED_ANA_PARTY',
  FollowerAnaParty = 'FOLLOWER_ANA_PARTY',
  Substitution = 'SUBSTITUTION'
}

export type Calendar_Unavailability = {
  dates?: InputMaybe<Calendar_CalendarUnavailabilityDate>;
  partyIds: Array<Scalars['Long']['input']>;
  tags: Array<Calendar_UnavailabilityTag>;
  unavailabilityId?: InputMaybe<Scalars['Int']['input']>;
};

export type Calendar_UnavailabilityClash = Calendar_Clash & {
  __typename?: 'Calendar_UnavailabilityClash';
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Calendar_ClashType>;
};

export type Calendar_UnavailabilityFilter = {
  excludeContexts?: InputMaybe<Array<Calendar_UnavailabilityTagContext>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  orConditions?: InputMaybe<Array<Calendar_UnavailabilityFilterCondition>>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  unavailabilityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Calendar_UnavailabilityFilterCondition = {
  afterTime?: InputMaybe<Scalars['Time']['input']>;
  beforeTime?: InputMaybe<Scalars['Time']['input']>;
  /** filters for only these dates within the range */
  dateArray?: InputMaybe<Array<Scalars['Date']['input']>>;
  onOrAfterDate?: InputMaybe<Scalars['Date']['input']>;
  onOrBeforeDate?: InputMaybe<Scalars['Date']['input']>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type Calendar_UnavailabilityTag = {
  context: Calendar_UnavailabilityTagContext;
  contextId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export enum Calendar_UnavailabilityTagContext {
  LongTermAbsence = 'LONG_TERM_ABSENCE',
  SchoolActivity = 'SCHOOL_ACTIVITY',
  ShortTermAbsence = 'SHORT_TERM_ABSENCE'
}

export type Calendar_UnavailabilityTagInput = {
  context: Calendar_UnavailabilityTagContext;
  contextId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Calendar_UncancelEvent = {
  context: Calendar_CancellationContext;
  contextId: Scalars['String']['input'];
  eventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludeEventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Calendar_UncancelEvents = {
  events: Array<Calendar_UncancelEvent>;
};

export type Calendar_UpdateCalendarBellTimesInput = {
  copyEventAttendance: Scalars['Boolean']['input'];
  dowBellTimes: Array<Calendar_UpdateDowBellTimeInput>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Calendar_UpdateCalendarDayInput = {
  date: Scalars['Date']['input'];
  dayType: DayType;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
};

export type Calendar_UpdateCalendarDayTimesInput = {
  amBellTime?: InputMaybe<Scalars['Time']['input']>;
  date: Scalars['Date']['input'];
  endTime?: InputMaybe<Scalars['Time']['input']>;
  pmBellTime?: InputMaybe<Scalars['Time']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
};

export type Calendar_UpdateCalendarInput = {
  calendarId: Scalars['Int']['input'];
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type Calendar_UpdateDays = {
  calendarId: Scalars['Int']['input'];
  days: Array<Calendar_CreateCalendarDayInput>;
};

export type Calendar_UpdateDowBellTimeInput = {
  amBellTime?: InputMaybe<Scalars['Time']['input']>;
  dow: Scalars['Int']['input'];
  pmBellTime?: InputMaybe<Scalars['Time']['input']>;
};

export type Calendar_UpdateEventResult = {
  __typename?: 'Calendar_UpdateEventResult';
  clashes?: Maybe<Array<Maybe<Calendar_ClashError>>>;
  success: Scalars['Boolean']['output'];
};

export type Calendar_UpsertCalendarUnavailability = {
  dates?: InputMaybe<Calendar_UpsertCalendarUnavailabilityDate>;
  partyIds: Array<Scalars['Long']['input']>;
  tags: Array<Calendar_UnavailabilityTagInput>;
  unavailabilityId?: InputMaybe<Scalars['Int']['input']>;
};

export type Calendar_UpsertCalendarUnavailabilityDate = {
  continuousEndDate?: InputMaybe<Scalars['Date']['input']>;
  continuousStartDate?: InputMaybe<Scalars['Date']['input']>;
  individualDates?: InputMaybe<Array<Scalars['Date']['input']>>;
  leavesAt?: InputMaybe<Scalars['Time']['input']>;
  /** if is a partial wither leavesAt or  returnsAt must be set */
  partial: Scalars['Boolean']['input'];
  returnsAt?: InputMaybe<Scalars['Time']['input']>;
};

export type Calendar_UpsertEventTag = {
  colour?: InputMaybe<Colour>;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  groupTagType: Calendar_EventTagType;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Array<InputMaybe<TranslationInput>>;
};

export enum Calender_EventDeleteMode {
  DeleteFromDate = 'DELETE_FROM_DATE',
  DeleteHistoric = 'DELETE_HISTORIC',
  KeepHistoric = 'KEEP_HISTORIC'
}

export type Calender_EventFilterAlsoShowForParties = {
  /**
   * add ability to include people who are exluded from an event to have the event displayed on their calendar
   * e.g. a teacher has been substituted but still wants it to show on their timetable  partiesForAugments: [Calendar_TagContext.SUBSTITUTION]
   */
  partiesForAugments?: InputMaybe<Array<Calendar_TagContext>>;
};

export type Calender_EventSourceInput = {
  source: CalendarEventSource;
  sourceId: Scalars['String']['input'];
};

export type Calender_FollowFilter = {
  followIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  followedPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  followerPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export enum Calender_RootVisibilityType {
  Internal = 'INTERNAL',
  Public = 'PUBLIC'
}

export type Campus = {
  __typename?: 'Campus';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CampusFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CampusTravelTime = {
  __typename?: 'CampusTravelTime';
  fromCampusId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  minutes: Scalars['Int']['output'];
  toCampusId: Scalars['Int']['output'];
};

export type CampusTravelTimeFilter = {
  campusIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CardPaymentPlan = {
  __typename?: 'CardPaymentPlan';
  feeName: Scalars['String']['output'];
  paymentMethodId: Scalars['String']['output'];
  paymentPlanId: Scalars['Int']['output'];
  paymentPlanStartDate: Scalars['Date']['output'];
  status: PaymentPlanStatus;
};

export type CardPaymentPlanFilter = {
  paymentMethodId: Scalars['String']['input'];
  status?: InputMaybe<PaymentPlanStatus>;
};

export type CatalogueSuccess = {
  __typename?: 'CatalogueSuccess';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Catalogue_DeleteGroupTag = {
  ids: Array<Scalars['Int']['input']>;
};

export type Catalogue_DeletePeopleTag = {
  ids: Array<Scalars['Int']['input']>;
};

export enum Catalogue_FeatureFlag {
  Marketing = 'MARKETING',
  Off = 'OFF',
  On = 'ON',
  TyroOnly = 'TYRO_ONLY'
}

export type Catalogue_GroupTagFilter = {
  /**
   * Hide PROGRAMME/PROGRAMME_STAGE tags whose linked programme/stage is discontinued
   * for the current school + namespace. Defaults to true so callers don't have to
   * filter again downstream — discontinued tags are a central pivot and most consumers
   * never want to see them.
   */
  excludeDiscontinued?: InputMaybe<Scalars['Boolean']['input']>;
  filterOnlyUsedProgrammesStages?: InputMaybe<Scalars['Boolean']['input']>;
  filterOnlyUsedYears?: InputMaybe<Scalars['Boolean']['input']>;
  refIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tagTypes?: InputMaybe<Array<InputMaybe<GroupTagType>>>;
};

export type Catalogue_ImportProgramme = {
  awardingBody?: InputMaybe<AwardingBody>;
  description?: InputMaybe<Scalars['String']['input']>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nationalCode: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
};

export type Catalogue_ImportProgrammeData = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  programmes?: InputMaybe<Array<Catalogue_ImportProgramme>>;
  stageSubjects?: InputMaybe<Array<Catalogue_ImportStageSubject>>;
  stages?: InputMaybe<Array<Catalogue_ImportProgrammeStage>>;
  subjects?: InputMaybe<Array<Catalogue_ImportSubject>>;
};

export type Catalogue_ImportProgrammeDataResult = {
  __typename?: 'Catalogue_ImportProgrammeDataResult';
  dryRun: Scalars['Boolean']['output'];
  errors: Array<Catalogue_ImportProgrammeRowError>;
  programmesCreated: Scalars['Int']['output'];
  programmesUpdated: Scalars['Int']['output'];
  stageSubjectsAlreadyLinked: Scalars['Int']['output'];
  stageSubjectsLinked: Scalars['Int']['output'];
  stagesCreated: Scalars['Int']['output'];
  stagesUpdated: Scalars['Int']['output'];
  subjectsAlreadyExisted: Scalars['Int']['output'];
  subjectsCreated: Scalars['Int']['output'];
};

export type Catalogue_ImportProgrammeRowError = {
  __typename?: 'Catalogue_ImportProgrammeRowError';
  message: Scalars['String']['output'];
  nationalCode?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  section: Scalars['String']['output'];
};

export type Catalogue_ImportProgrammeStage = {
  description?: InputMaybe<Scalars['String']['input']>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nationalCode: Scalars['String']['input'];
  programmeNationalCode: Scalars['String']['input'];
  programmeOrder: Scalars['Int']['input'];
  shortName: Scalars['String']['input'];
  yearGroupName: Scalars['String']['input'];
};

export type Catalogue_ImportStageSubject = {
  stageNationalCode: Scalars['String']['input'];
  subjectNationalCode: Scalars['String']['input'];
};

export type Catalogue_ImportSubject = {
  colour?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nationalCode: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
};

export type Catalogue_PeopleTagFilter = {
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tagTypes?: InputMaybe<Array<InputMaybe<PeopleTagType>>>;
};

export type Catalogue_SystemSettingDropDown = {
  __typename?: 'Catalogue_SystemSettingDropDown';
  label: Scalars['String']['output'];
  value: Scalars['Object']['output'];
};

export enum Catalogue_SystemSettingFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Integer = 'INTEGER',
  MultiselectInt = 'MULTISELECT_INT',
  MultiselectString = 'MULTISELECT_STRING',
  SelectInt = 'SELECT_INT',
  SelectString = 'SELECT_STRING',
  String = 'STRING',
  UiManagedJson = 'UI_MANAGED_JSON'
}

export type Catalogue_SystemSettings = {
  __typename?: 'Catalogue_SystemSettings';
  categoryName: Scalars['String']['output'];
  categoryNameTextId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  descriptionTextId: Scalars['Int']['output'];
  fieldType: Catalogue_SystemSettingFieldType;
  id: Catalogue_SystemSettingsId;
  label: Scalars['String']['output'];
  labelTextId: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  moduleName: Scalars['String']['output'];
  moduleNameTextId: Scalars['Int']['output'];
  selectValues: Array<Catalogue_SystemSettingDropDown>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByPartyId: Scalars['Long']['output'];
  value?: Maybe<Scalars['Object']['output']>;
};

export type Catalogue_SystemSettingsFilter = {
  module: Array<Scalars['String']['input']>;
  type: Catalogue_SystemSettingsViewType;
};

export type Catalogue_SystemSettingsId = {
  __typename?: 'Catalogue_SystemSettingsId';
  category: Scalars['String']['output'];
  module: Scalars['String']['output'];
  nameId: Scalars['String']['output'];
};

export type Catalogue_SystemSettingsInputId = {
  category: Scalars['String']['input'];
  module: Scalars['String']['input'];
  nameId: Scalars['String']['input'];
};

export type Catalogue_SystemSettingsUpdate = {
  id: Catalogue_SystemSettingsInputId;
  metadata?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Object']['input']>;
};

export type Catalogue_SystemSettingsUpdateResult = {
  __typename?: 'Catalogue_SystemSettingsUpdateResult';
  id: Catalogue_SystemSettingsId;
  success: Scalars['Boolean']['output'];
};

export type Catalogue_SystemSettingsUpdates = {
  type: Catalogue_SystemSettingsViewType;
  updates: Array<Catalogue_SystemSettingsUpdate>;
};

export enum Catalogue_SystemSettingsViewType {
  Personal = 'PERSONAL',
  Tenant = 'TENANT'
}

export type Catalogue_UpsertGroupTag = {
  colour?: InputMaybe<Colour>;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  groupTagType: GroupTagType;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Array<InputMaybe<TranslationInput>>;
  refId?: InputMaybe<Scalars['String']['input']>;
};

export type Catalogue_UpsertPeopleTag = {
  colour?: InputMaybe<Colour>;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Array<InputMaybe<TranslationInput>>;
  peopleTagType: PeopleTagType;
};

export type Catalogue_UpsertProgramme = {
  awardingBody?: InputMaybe<AwardingBody>;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  nationalCode?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
};

export type Catalogue_UpsertProgrammeStage = {
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Array<InputMaybe<TranslationInput>>;
  nationalCode: Scalars['String']['input'];
  programmeId: Scalars['Int']['input'];
  programmeOrder: Scalars['Int']['input'];
  shortName: Array<InputMaybe<TranslationInput>>;
  yearGroupId: Scalars['Int']['input'];
};

export type Catalogue_UpsertProgrammeStageSubjects = {
  programmeStageId: Scalars['Int']['input'];
  subjectIdsToAdd?: InputMaybe<Array<Scalars['Int']['input']>>;
  subjectIdsToRemove?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Catalogue_UpsertProgrammeStages = {
  programmeId: Scalars['Int']['input'];
  stageIdsToAdd?: InputMaybe<Array<Scalars['Int']['input']>>;
  stageIdsToRemove?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Category = {
  __typename?: 'Category';
  active: Scalars['Boolean']['output'];
  /** deep linked */
  createdBy: Person;
  createdByPartyId: Scalars['Long']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CategoryFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ChairPerson = {
  __typename?: 'ChairPerson';
  chairPersonId?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  forename?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type Charge = {
  amount: Scalars['Float']['input'];
  feeId: Scalars['Int']['input'];
};

export type ChargesFilter = {
  charges: Array<Charge>;
  paymentMethod: PaymentMethod;
};

export type Charts_Chart = {
  __typename?: 'Charts_Chart';
  categories: Array<Scalars['String']['output']>;
  datasets: Array<Charts_Dataset>;
  labels: Array<Scalars['String']['output']>;
  rows: Array<Charts_Row>;
  title: Scalars['String']['output'];
  type: Charts_ChartType;
};

export enum Charts_ChartType {
  Bar = 'BAR',
  Column = 'COLUMN',
  Donut = 'DONUT',
  StackedBar = 'STACKED_BAR',
  StackedColumn = 'STACKED_COLUMN'
}

export type Charts_Datapoint = {
  __typename?: 'Charts_Datapoint';
  drilldownUrl?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['JSON']['output']>;
  ids?: Maybe<Array<Scalars['ID']['output']>>;
  label?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  value: Scalars['Float']['output'];
};

export type Charts_Dataset = {
  __typename?: 'Charts_Dataset';
  data: Array<Charts_Datapoint>;
  label: Scalars['String']['output'];
  meta?: Maybe<Scalars['JSON']['output']>;
};

export type Charts_Row = {
  __typename?: 'Charts_Row';
  group: Scalars['JSON']['output'];
  meta?: Maybe<Scalars['JSON']['output']>;
  value: Scalars['Float']['output'];
};

export type ClashingParty = {
  __typename?: 'ClashingParty';
  clash: Array<Scalars['String']['output']>;
  clashInfo: Array<Calendar_Clash>;
  party: Party;
  partyId: Scalars['Long']['output'];
};

export type ClashingRooms = {
  __typename?: 'ClashingRooms';
  clash: Array<Scalars['String']['output']>;
  clashInfo: Array<Calendar_Clash>;
  room: Room;
  roomId: Scalars['Int']['output'];
};

export type ClassGroupInfo = {
  __typename?: 'ClassGroupInfo';
  yearGroupId: Scalars['Int']['output'];
};

export type ClassGroupInfoInput = {
  yearGroupId: Scalars['Int']['input'];
};

export type Cms_Config = {
  __typename?: 'Cms_Config';
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum CollectedByMode {
  Hidden = 'Hidden',
  Optional = 'Optional',
  Required = 'Required'
}

export enum CollisionPolicy {
  AppendCharacter = 'APPEND_CHARACTER',
  AppendNumber = 'APPEND_NUMBER',
  Skip = 'SKIP'
}

export enum Colour {
  Amber = 'amber',
  Blue = 'blue',
  Cyan = 'cyan',
  Emerald = 'emerald',
  Fuchsia = 'fuchsia',
  Green = 'green',
  Lime = 'lime',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  Rose = 'rose',
  Sky = 'sky',
  Teal = 'teal',
  Violet = 'violet',
  Yellow = 'yellow'
}

export type ColumnFilter = {
  columnName: Scalars['String']['input'];
  operation?: InputMaybe<ColumnFilterOperation>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ColumnFilterOperation {
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Ilike = 'ILIKE',
  Like = 'LIKE',
  Lt = 'LT',
  Lte = 'LTE',
  Neq = 'NEQ'
}

export type Comment = {
  __typename?: 'Comment';
  active: Scalars['Boolean']['output'];
  comment: Scalars['String']['output'];
  externalSystemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
};

export type CommentBank = {
  __typename?: 'CommentBank';
  active: Scalars['Boolean']['output'];
  comments?: Maybe<Array<Comment>>;
  description?: Maybe<Scalars['String']['output']>;
  externalSystemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type CommentBankFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export enum CommentStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type CommentStudent = {
  __typename?: 'CommentStudent';
  commentStatus: CommentStatus;
  principalComment: Scalars['Boolean']['output'];
  student: Student;
  studentPartyId: Scalars['Long']['output'];
  tutorComment: Scalars['Boolean']['output'];
  yearHeadComment: Scalars['Boolean']['output'];
};

export enum CommentType {
  Both = 'BOTH',
  CommentBank = 'COMMENT_BANK',
  FreeForm = 'FREE_FORM',
  None = 'NONE'
}

export enum CommenterUserType {
  HouseMaster = 'HOUSE_MASTER',
  Principal = 'PRINCIPAL',
  Teacher = 'TEACHER',
  Tutor = 'TUTOR',
  YearHead = 'YEAR_HEAD'
}

export type Communications_NoticeboardConfig = {
  __typename?: 'Communications_NoticeboardConfig';
  enabled: Scalars['Boolean']['output'];
  publicNoticeboardId?: Maybe<Scalars['String']['output']>;
  publicNoticeboardLink?: Maybe<Scalars['String']['output']>;
};

export type Communications_NoticeboardConfigInput = {
  enable: Scalars['Boolean']['input'];
};

export type Composite_TenantSettings = {
  __typename?: 'Composite_TenantSettings';
  comregName?: Maybe<Scalars['String']['output']>;
  eircode?: Maybe<Scalars['String']['output']>;
  goLiveOn?: Maybe<Scalars['Date']['output']>;
  latitude?: Maybe<Scalars['BigDecimal']['output']>;
  longitude?: Maybe<Scalars['BigDecimal']['output']>;
  organizationTenant?: Maybe<Tenant>;
  xeroId?: Maybe<Scalars['String']['output']>;
};

export type Configure2faInput = {
  enable: Scalars['Boolean']['input'];
  partyIds: Array<InputMaybe<Scalars['Long']['input']>>;
};

export enum Context {
  All = 'ALL',
  Calendar = 'CALENDAR',
  Mail = 'MAIL',
  Party = 'PARTY',
  SessionAttendance = 'SESSION_ATTENDANCE',
  Sms = 'SMS',
  TempHide = 'TEMP_HIDE'
}

export type CoreBlock = {
  __typename?: 'CoreBlock';
  blockId: Scalars['String']['output'];
  classGroupIds: Array<Scalars['Long']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isRotation: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rotations: Array<BlockRotation>;
  subjectGroupIds: Array<Scalars['Long']['output']>;
  subjectGroupNamesJoined?: Maybe<Scalars['String']['output']>;
  subjectGroups: Array<SubjectGroup>;
  yearGroupIds: Array<Scalars['Int']['output']>;
};

export type Core_AddRotationResponse = {
  __typename?: 'Core_AddRotationResponse';
  newlyCreatedRotationSubjectGroupIds: Array<Scalars['Long']['output']>;
  previousRotationIteration: Scalars['Int']['output'];
  previousRotationIterationStartDate: Scalars['Date']['output'];
  previousRotationSubjectGroups: Array<SubjectGroup>;
};

export type Core_AdminPartyPeopleFilter = {
  tenants: Array<Scalars['Int']['input']>;
};

export type Core_AdminPersonalInfo = {
  __typename?: 'Core_AdminPersonalInfo';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  partyId: Scalars['Long']['output'];
  primaryEmail?: Maybe<EmailAddress>;
  type?: Maybe<PartyPersonType>;
};

export type Core_ContactInput = {
  allowAccessToStudentData?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToContact?: InputMaybe<Scalars['Boolean']['input']>;
  contactPartyId: Scalars['Long']['input'];
  includeInSms?: InputMaybe<Scalars['Boolean']['input']>;
  includeInTemplating?: InputMaybe<Scalars['Boolean']['input']>;
  includeInTmail?: InputMaybe<Scalars['Boolean']['input']>;
  legalGuardian?: InputMaybe<Scalars['Boolean']['input']>;
  pickupRights?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  relationshipType: StudentContactType;
  studentPartyId: Scalars['Long']['input'];
};

export type Core_CopyGroupMembershipsMembers = {
  copyStaff: Scalars['Boolean']['input'];
  copyStudents: Scalars['Boolean']['input'];
  deleteStaffNotMatching: Scalars['Boolean']['input'];
  deleteStudentNotMatching: Scalars['Boolean']['input'];
  onlyIncludeStaffRoles?: InputMaybe<Array<StaffGroupMembershipRoles>>;
  sourceGroupAcademicNamespace: Scalars['Int']['input'];
  sourceGroupPartyId: Scalars['Long']['input'];
  sourceGroupType: PartyGroupType;
  targetGroupAcademicNamespace: Scalars['Int']['input'];
  targetGroupPartyId: Scalars['Long']['input'];
  targetGroupType: PartyGroupType;
};

export type Core_CopyGroups = {
  copyStaff: Scalars['Boolean']['input'];
  copyStudents: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  onlyIncludeStaffRoles?: InputMaybe<Array<StaffGroupMembershipRoles>>;
  sourceGroupAcademicNamespace: Scalars['Int']['input'];
  sourceGroupPartyId: Scalars['Long']['input'];
  sourceGroupType: PartyGroupType;
  targetGroupAcademicNamespace: Scalars['Int']['input'];
  /** created new group if empty */
  targetGroupPartyId?: InputMaybe<Scalars['Long']['input']>;
  targetGroupType: PartyGroupType;
};

export enum Core_CurrentlyEnrolledOption {
  All = 'ALL',
  CurrentlyEnrolled = 'CURRENTLY_ENROLLED',
  CurrentlyNotEnrolled = 'CURRENTLY_NOT_ENROLLED'
}

export type Core_CustomField = {
  __typename?: 'Core_CustomField';
  externalSystemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
  source: Core_CustomFieldPartySource;
  type: Core_CustomFieldType;
};

export type Core_CustomFieldFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  type?: InputMaybe<Core_CustomFieldPartySource>;
};

export enum Core_CustomFieldPartySource {
  Contact = 'CONTACT',
  Staff = 'STAFF',
  Student = 'STUDENT'
}

export enum Core_CustomFieldType {
  Date = 'DATE',
  Dropdown = 'DROPDOWN',
  String = 'STRING'
}

export type Core_CustomGroupDefinition = {
  __typename?: 'Core_CustomGroupDefinition';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  name: Scalars['String']['output'];
  organiserIds?: Maybe<Array<Scalars['Long']['output']>>;
  organisers?: Maybe<Array<Person>>;
  source: Core_PartySource;
  staffDynamic?: Maybe<Core_CustomGroupQuery>;
  staffIdsStatic?: Maybe<Array<Scalars['Long']['output']>>;
  staffStatic?: Maybe<Array<Person>>;
  studentIdsStatic?: Maybe<Array<Scalars['Long']['output']>>;
  studentsDynamic?: Maybe<Core_CustomGroupQuery>;
  studentsStatic?: Maybe<Array<Student>>;
};

export type Core_CustomGroupDefinitionFilter = {
  partyId: Scalars['Long']['input'];
};

export type Core_CustomGroupFieldOptions = {
  __typename?: 'Core_CustomGroupFieldOptions';
  staff: Array<QueryBuilderField>;
  student: Array<QueryBuilderField>;
};

export type Core_CustomGroupQuery = {
  __typename?: 'Core_CustomGroupQuery';
  params: Array<Scalars['String']['output']>;
  query: Scalars['String']['output'];
};

export type Core_CustomGroupQueryInput = {
  params: Array<Scalars['String']['input']>;
  query: Scalars['String']['input'];
};

export type Core_DeleteCustomFields = {
  ids: Array<Scalars['Long']['input']>;
};

export type Core_DeleteGroupInput = {
  groupPartyIds: Array<Scalars['Long']['input']>;
  /** only delete from specified sources */
  sources?: InputMaybe<Array<Core_PartySource>>;
};

export type Core_DeleteStudentContactLink = {
  contactPartyId: Scalars['Long']['input'];
  relationshipType: StudentContactType;
  studentPartyId: Scalars['Long']['input'];
};

export type Core_DiscontinueAcademicNamespaceInput = {
  academicNamespaceId: Scalars['Int']['input'];
  partyIds: Array<Scalars['Long']['input']>;
  removeFromGroups?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Core_EnableBlockRotationInput = {
  blockId: Scalars['String']['input'];
  iterations: Array<Core_EnableBlockRotationIterationInput>;
  rotationName: Scalars['String']['input'];
};

export type Core_EnableBlockRotationIterationInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Core_EnrolInAcademicNamespaceInput = {
  academicNamespaceId: Scalars['Int']['input'];
  partyIds: Array<Scalars['Long']['input']>;
};

export type Core_ExemptionFilter = {
  partyIds: Array<InputMaybe<Scalars['Long']['input']>>;
};

export type Core_LinkContacts = {
  delete?: InputMaybe<Array<InputMaybe<Core_DeleteStudentContactLink>>>;
  upsert?: InputMaybe<Array<InputMaybe<Core_ContactInput>>>;
};

export type Core_LinkSiblings = {
  delete?: InputMaybe<Array<InputMaybe<Core_SiblingInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<Core_SiblingInput>>>;
};

export type Core_LinkSiblingsAndContacts = {
  /** add these contacts with default permissions if they are not already linked */
  linkContacts: Array<Core_LinkSiblingsAndContactsContactInfo>;
  linkSiblings: Array<Scalars['Long']['input']>;
  studentPartyId: Scalars['Long']['input'];
  unlinkContacts: Array<Core_LinkSiblingsAndContactsContactInfo>;
  unlinkSiblings: Array<Scalars['Long']['input']>;
};

export type Core_LinkSiblingsAndContactsContactInfo = {
  allowAccessToStudentData?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToContact?: InputMaybe<Scalars['Boolean']['input']>;
  contactPartyId?: InputMaybe<Scalars['Long']['input']>;
  includeInSms?: InputMaybe<Scalars['Boolean']['input']>;
  includeInTemplating?: InputMaybe<Scalars['Boolean']['input']>;
  includeInTmail?: InputMaybe<Scalars['Boolean']['input']>;
  legalGuardian?: InputMaybe<Scalars['Boolean']['input']>;
  pickupRights?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  relationshipType?: InputMaybe<StudentContactType>;
};

export type Core_ModifyAcademicNamespaceMembership = {
  academicNamespaceId: Scalars['Int']['input'];
  change: Core_ModifyMembershipEnum;
  nameOverride?: InputMaybe<Scalars['String']['input']>;
  partyId: Scalars['Long']['input'];
};

export type Core_ModifyBlockClassGroup = {
  blockId: Scalars['String']['input'];
  change: Core_ModifyMembershipEnum;
  classGroupId: Scalars['Long']['input'];
};

export type Core_ModifyBlocks = {
  changeClassGroups?: InputMaybe<Array<Core_ModifyBlockClassGroup>>;
};

export enum Core_ModifyMembershipEnum {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type Core_ModifyMemberships = {
  staffGroupMemberships?: InputMaybe<Array<Core_ModifyStaffGroupMembership>>;
  studentGroupMemberships?: InputMaybe<Array<Core_ModifyStudentGroupMembership>>;
};

export type Core_ModifyStaffGroupMembership = {
  change: Core_ModifyMembershipEnum;
  /** defaults to false as staff may be added to with different roles on different dates */
  doNotAddIfStaffMemberAlreadyPresent?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  groupPartyId: Scalars['Long']['input'];
  /**
   * mandatory on adding a member
   * on delete will only remove if the role matches the existing role or will delete all if blank
   */
  roles?: InputMaybe<Array<InputMaybe<StaffGroupMembershipRoles>>>;
  staffPartyId: Scalars['Long']['input'];
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Core_ModifyStudentGroupMembership = {
  change: Core_ModifyMembershipEnum;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  groupPartyId: Scalars['Long']['input'];
  studentPartyId: Scalars['Long']['input'];
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Core_ModifySubjectGroupMembershipType = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  classGroupId?: InputMaybe<Scalars['Long']['input']>;
  membershipType: SubjectGroupStudentMembershipTypeEnum;
  subjectGroupId: Scalars['Long']['input'];
};

export type Core_NonEnrolledSibling = {
  __typename?: 'Core_NonEnrolledSibling';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  partyId: Scalars['Long']['output'];
};

export type Core_PartyCustomField = {
  __typename?: 'Core_PartyCustomField';
  customFieldId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  partyId: Scalars['Long']['output'];
  source: Core_CustomFieldPartySource;
  type: Core_CustomFieldType;
  value: Scalars['String']['output'];
};

export type Core_PartyCustomFieldInput = {
  customFieldId: Scalars['Long']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Core_PartyInAcademicNamespace = {
  __typename?: 'Core_PartyInAcademicNamespace';
  academicNamespaceId: Scalars['Int']['output'];
  partyId: Scalars['Long']['output'];
};

export type Core_PartyInAcademicNamespaceFilter = {
  academicNamespaceId?: InputMaybe<Scalars['Int']['input']>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export enum Core_PartySource {
  Core = 'CORE',
  SchoolActivity = 'SCHOOL_ACTIVITY',
  Timetable = 'TIMETABLE'
}

export type Core_PartySourceId = {
  source?: InputMaybe<Core_PartySource>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

export type Core_PeopleFilter = {
  partyIds: Array<InputMaybe<Scalars['Long']['input']>>;
};

export type Core_ReinstateMemberInput = {
  partyId: Scalars['Long']['input'];
};

export type Core_RolloverEntity = {
  entity: RolloverEntityType;
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
};

export type Core_RotateBlockStudentsInput = {
  blockId: Scalars['String']['input'];
  direction: Core_RotateDirection;
  rotationIteration: Scalars['Int']['input'];
};

export enum Core_RotateDirection {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type Core_SiblingInput = {
  studentPartyId1: Scalars['Long']['input'];
  studentPartyId2: Scalars['Long']['input'];
};

export type Core_Siblings = {
  __typename?: 'Core_Siblings';
  enrolledSiblings: Array<Student>;
  enrolledSiblingsPartyIds: Array<Scalars['Long']['output']>;
  nonEnrolledSiblings: Array<Core_NonEnrolledSibling>;
  studentPartyId: Scalars['Long']['output'];
};

export type Core_SiblingsFilter = {
  studentId: Array<Scalars['Long']['input']>;
};

export type Core_StaffAvailability = {
  __typename?: 'Core_StaffAvailability';
  activeInYear: Scalars['Boolean']['output'];
  availableForSubstitution: Scalars['Boolean']['output'];
  availableForSubstitutionIsOverridden: Scalars['Boolean']['output'];
  availableForTeaching: Scalars['Boolean']['output'];
  availableForTeachingIsOverridden: Scalars['Boolean']['output'];
  defaultAvailableForSubstitution: Scalars['Boolean']['output'];
  defaultAvailableForSupportClasses: Scalars['Boolean']['output'];
  defaultAvailableForTeaching: Scalars['Boolean']['output'];
  noLongerStaffMember: Scalars['Boolean']['output'];
  person: Person;
  staffPartyId: Scalars['Long']['output'];
};

export type Core_StaffAvailabilityFilter = {
  academicNamespaceId: Scalars['Int']['input'];
};

export enum Core_StaffNameDisplayType {
  Abbreviated = 'abbreviated',
  FirstNameLastName = 'first_name_last_name',
  LastNameFirstName = 'last_name_first_name'
}

export type Core_SwitchSubjectGroupType = {
  subjectGroupPartyId: Array<InputMaybe<Scalars['Long']['input']>>;
  type: SubjectGroupType;
};

export type Core_UpdateCustomGroupDefinition = {
  id: Scalars['Long']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Core_UpdateStaffAvailabilityInput = {
  academicNamespaceId: Scalars['Int']['input'];
  updates: Array<Core_UpdateStaffAvailabilityRow>;
};

export type Core_UpdateStaffAvailabilityRow = {
  activeInYear?: InputMaybe<Scalars['Boolean']['input']>;
  availableForSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  availableForTeaching?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAvailableForSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAvailableForSupportClasses?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAvailableForTeaching?: InputMaybe<Scalars['Boolean']['input']>;
  noLongerStaffMember?: InputMaybe<Scalars['Boolean']['input']>;
  staffPartyId: Scalars['Long']['input'];
};

export type Core_UpdateStudentContactRelationshipInput = {
  allowAccessToStudentData?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToContact?: InputMaybe<Scalars['Boolean']['input']>;
  contactPartyId: Scalars['Long']['input'];
  includeInSms?: InputMaybe<Scalars['Boolean']['input']>;
  includeInTemplating?: InputMaybe<Scalars['Boolean']['input']>;
  includeInTmail?: InputMaybe<Scalars['Boolean']['input']>;
  legalGuardian?: InputMaybe<Scalars['Boolean']['input']>;
  pickupRights?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  relationshipType?: InputMaybe<StudentContactType>;
  studentPartyId: Scalars['Long']['input'];
};

export type Core_UpdateStudentSubjectGroupInput = {
  examinable?: InputMaybe<Scalars['Boolean']['input']>;
  studentId: Scalars['Long']['input'];
  studyLevel?: InputMaybe<StudyLevel>;
  subjectGroupId: Scalars['Long']['input'];
};

export type Core_UpsertCustomFields = {
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source: Core_CustomFieldPartySource;
  type: Core_CustomFieldType;
};

export type Core_UpsertCustomGroupDefinition = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  organisers?: InputMaybe<Array<Scalars['Long']['input']>>;
  partySourceId?: InputMaybe<Core_PartySourceId>;
  staffDynamic?: InputMaybe<Core_CustomGroupQueryInput>;
  staffStatic?: InputMaybe<Array<Scalars['Long']['input']>>;
  studentsDynamic?: InputMaybe<Core_CustomGroupQueryInput>;
  studentsStatic?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type CreateCalendarEventAttendeeInput = {
  partyId: Scalars['Long']['input'];
  /** ... Defaults to event Recurrence Rule. Used in cases where attendee will not be attending all events */
  recurrenceRule?: InputMaybe<Scalars['String']['input']>;
  /** ... Defaults to event Start Date. Used in cases where attendee will not be attending all events */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  tags: Array<CalendarTagInput>;
  type: CalendarEventAttendeeType;
};

export type CreateCalendarEventExcludedAttendeeInput = {
  partyId: Scalars['Int']['input'];
  /** ... Defaults to event Recurrence Rule.  Used in cases where attendee will not excluded from all events */
  recurrenceRule?: InputMaybe<Scalars['String']['input']>;
  /** ... Defaults to event Start Date. Used in cases where attendee will not excluded from all events */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateCalendarEventInput = {
  allDayEvent?: InputMaybe<Scalars['Boolean']['input']>;
  attendees?: InputMaybe<Array<CreateCalendarEventAttendeeInput>>;
  calendarIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colour?: InputMaybe<Colour>;
  customTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dayIdx?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** end date of the recurrence. This is set Or occurrences is set */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endTime: Scalars['Time']['input'];
  /** defaults to manual */
  eventSource?: InputMaybe<CalendarEventSource>;
  eventSourceId?: InputMaybe<Scalars['String']['input']>;
  exclusions?: InputMaybe<Array<CreateCalendarEventAttendeeInput>>;
  gridIdx?: InputMaybe<Scalars['Int']['input']>;
  lessonInfo?: InputMaybe<CreateCalendarEventLessonInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** number of occurrences. This is set Or endDate is set */
  occurrences?: InputMaybe<Scalars['Int']['input']>;
  periodIdx?: InputMaybe<Scalars['Int']['input']>;
  publicContactCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  publicStaffCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  publicStudentCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tyro Enum for iCal/rfc5545 recurrence rule for event. Null means single. Set either this or recurrenceRule */
  recurrenceEnum?: InputMaybe<RecurrenceEnum>;
  /** iCal/rfc5545 recurrence rule for event. Null means single. Set either this or recurrenceEnum */
  recurrenceRule?: InputMaybe<Scalars['String']['input']>;
  rooms?: InputMaybe<Array<CreateCalendarEventRoomInput>>;
  startDate: Scalars['Date']['input'];
  startTime: Scalars['Time']['input'];
  status?: InputMaybe<CalendarEventStatus>;
  tags?: InputMaybe<Array<CalendarTagInput>>;
  type: CalendarEventType;
};

export type CreateCalendarEventLessonInput = {
  lessonId?: InputMaybe<Scalars['Int']['input']>;
  subjectGroupId: Scalars['Long']['input'];
};

export type CreateCalendarEventRoomInput = {
  /** ... Defaults to event Recurrence Rule. Used in cases where attendee will not be attending all events */
  recurrenceRule?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  /** ... Defaults to event Start Date. Used in cases where attendee will not be attending all events */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  tags: Array<CalendarTagInput>;
};

export type CreateCalendarEventsInput = {
  allowClashes?: InputMaybe<Scalars['Boolean']['input']>;
  events: Array<InputMaybe<CreateCalendarEventInput>>;
};

export type CreateCalendarInput = {
  academicNamespaceId: Scalars['Int']['input'];
  calendarDayInput?: InputMaybe<Array<Calendar_CreateCalendarDayInput>>;
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type CreateGeneralGroupAcademicNamespacesInput = {
  academicNamespaceId: Scalars['Int']['input'];
  classGroupInfo?: InputMaybe<ClassGroupInfoInput>;
  groupTagIds: Array<Scalars['Int']['input']>;
  nameOverride?: InputMaybe<Scalars['String']['input']>;
  staffMembers?: InputMaybe<Array<InputMaybe<StaffGroupMembershipInput>>>;
  studentMembers?: InputMaybe<Array<InputMaybe<CreateGeneralGroupStudentMembershipInput>>>;
};

export type CreateGeneralGroupInput = {
  academicNamespaces: Array<CreateGeneralGroupAcademicNamespacesInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  externalSystemInfo?: InputMaybe<Array<InputMaybe<ExternalSystemInfo>>>;
  generalGroupType: GeneralGroupType;
  includeInTimetable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partySourceId?: InputMaybe<Core_PartySourceId>;
};

export type CreateGeneralGroupStudentMembershipInput = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  partyId: Scalars['Long']['input'];
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateGroupAcademicNamespacesInput = {
  academicNamespaceId: Scalars['Int']['input'];
  groupTagIds: Array<Scalars['Int']['input']>;
  nameOverride?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGroupMembershipInput = {
  academicNamespaceId: Scalars['Int']['input'];
  examinable?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  partyId?: InputMaybe<Scalars['Long']['input']>;
  studyLevel?: InputMaybe<StudyLevel>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CreatePaymentResponse = {
  __typename?: 'CreatePaymentResponse';
  bankTransferInstructions?: Maybe<BankTransferInstructions>;
  clientSecret?: Maybe<Scalars['String']['output']>;
};

export type CreateProfileForGlobalUserInput = {
  globalUserId: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  partyPersonId: Scalars['Long']['input'];
  profileTypeId: Scalars['Int']['input'];
};

export type CreateProfileType = {
  description: Array<InputMaybe<TranslationInput>>;
  name: Array<InputMaybe<TranslationInput>>;
  profileType?: InputMaybe<UserType>;
  roles: Array<InputMaybe<Scalars['Int']['input']>>;
  uniqueName: Scalars['String']['input'];
};

export type CreateProgramStageStaffMembership = {
  academicNamespaceId: Scalars['Int']['input'];
  programmeId: Scalars['Int']['input'];
  programmeStageId: Scalars['Int']['input'];
  roles?: InputMaybe<Array<InputMaybe<StaffProgrammeStageMembershipRoles>>>;
  staffId: Scalars['Long']['input'];
};

export type CreateRoleInput = {
  description: Array<InputMaybe<TranslationInput>>;
  name: Array<InputMaybe<TranslationInput>>;
  permissions: Array<InputMaybe<PermissionForGroup>>;
  uniqueName: Scalars['String']['input'];
};

export type CreateStaffGroupMembershipInput = {
  academicNamespaceId: Scalars['Int']['input'];
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  partyId?: InputMaybe<Scalars['Long']['input']>;
  roles?: InputMaybe<Array<InputMaybe<StaffGroupMembershipRoles>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateStudentEnrollment = {
  academicNamespaceId: Scalars['Int']['input'];
  programmeId: Scalars['Int']['input'];
  programmeStageId: Scalars['Int']['input'];
  studentId: Scalars['Long']['input'];
  yearGroupId: Scalars['Int']['input'];
};

export type CreateStudentInput = {
  addresses?: InputMaybe<Array<InputMaybe<InputAddress>>>;
  birthCertFirstName?: InputMaybe<Scalars['String']['input']>;
  birthCertSurname?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  emails?: InputMaybe<Array<InputMaybe<InputEmailAddress>>>;
  exitDate?: InputMaybe<Scalars['Date']['input']>;
  externalSystemInfo?: InputMaybe<ExternalSystemInfo>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  guardianshipNote?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leavingReason?: InputMaybe<Scalars['String']['input']>;
  leftEarly?: InputMaybe<Scalars['Boolean']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<InputPhoneNumber>>>;
  preferredFirstName?: InputMaybe<Scalars['String']['input']>;
  repeatYear?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  studentIre?: InputMaybe<CreateStudentIreInput>;
  studentIrePP?: InputMaybe<CreateStudentIrePpInput>;
};

export type CreateStudentIreInput = {
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  pps?: InputMaybe<Scalars['String']['input']>;
  religion?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStudentIrePpInput = {
  boardingDays?: InputMaybe<Scalars['String']['input']>;
  borderIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  deceased?: InputMaybe<Scalars['Boolean']['input']>;
  deceasedDate?: InputMaybe<Scalars['Date']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  destinationRollNo?: InputMaybe<Scalars['String']['input']>;
  dpin?: InputMaybe<Scalars['Long']['input']>;
  examEntrant?: InputMaybe<Scalars['Boolean']['input']>;
  examNumber?: InputMaybe<Scalars['String']['input']>;
  languageSupportApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  lockerNumber?: InputMaybe<Scalars['String']['input']>;
  medicalCard?: InputMaybe<Scalars['Boolean']['input']>;
  mothersMaidenName?: InputMaybe<Scalars['String']['input']>;
  previousSchoolRollNumber?: InputMaybe<Scalars['String']['input']>;
  previousSchoolType?: InputMaybe<Scalars['String']['input']>;
  shortTermPupil?: InputMaybe<Scalars['Boolean']['input']>;
  shortTermPupilNumWeeks?: InputMaybe<Scalars['Int']['input']>;
  travellerHeritage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateSubjectGroupInput = {
  academicNamespaces: Array<CreateGroupAcademicNamespacesInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  externalSystemInfo?: InputMaybe<Array<InputMaybe<ExternalSystemInfo>>>;
  includeInTimetable?: InputMaybe<Scalars['Boolean']['input']>;
  irePP?: InputMaybe<Array<InputMaybe<CreateSubjectGroupIrePpInput>>>;
  membershipTypes: Array<SubjectGroupMembershipTypeInput>;
  name: Scalars['String']['input'];
  partySourceId?: InputMaybe<Core_PartySourceId>;
  staffMembers?: InputMaybe<Array<InputMaybe<CreateStaffGroupMembershipInput>>>;
  studentMembers?: InputMaybe<Array<InputMaybe<CreateGroupMembershipInput>>>;
  subjectGroupType?: InputMaybe<SubjectGroupType>;
  subjects: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type CreateSubjectGroupIrePpInput = {
  academicNamespaceId: Scalars['Int']['input'];
  examinable: Scalars['Boolean']['input'];
  level?: InputMaybe<StudyLevel>;
};

export type CreateSubjectInput = {
  active: Scalars['Boolean']['input'];
  colour: Colour;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  examinable: Scalars['Boolean']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Array<InputMaybe<TranslationInput>>;
  shortCode: Array<InputMaybe<TranslationInput>>;
};

export type CreateTenantInput = {
  __typename?: 'CreateTenantInput';
  goLiveOn?: Maybe<Scalars['Date']['output']>;
  imgUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  region: Scalars['Int']['output'];
  tenant: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type CreateYearGroupStaffMembership = {
  academicNamespaceId: Scalars['Int']['input'];
  roles?: InputMaybe<Array<InputMaybe<StaffYearGroupMembershipRoles>>>;
  staffId: Scalars['Long']['input'];
  yearGroupId: Scalars['Int']['input'];
};

export type CurrentAttendance = {
  __typename?: 'CurrentAttendance';
  attendanceCodeName?: Maybe<Scalars['String']['output']>;
  codeType?: Maybe<AttendanceCodeType>;
};

export type CurrentLocation = {
  __typename?: 'CurrentLocation';
  currentAttendance?: Maybe<CurrentAttendance>;
  eventId?: Maybe<Scalars['Int']['output']>;
  lesson?: Maybe<Scalars['String']['output']>;
  partyId?: Maybe<Scalars['Long']['output']>;
  room?: Maybe<Array<Maybe<Room>>>;
  teacher?: Maybe<Scalars['String']['output']>;
};

export type CurrentTimetableEvent = {
  __typename?: 'CurrentTimetableEvent';
  eventId?: Maybe<Scalars['Int']['output']>;
  lesson?: Maybe<Scalars['String']['output']>;
  partyId?: Maybe<Scalars['Long']['output']>;
  room: Array<Room>;
  teacher?: Maybe<Scalars['String']['output']>;
};

export type DashboardAssessment = {
  __typename?: 'DashboardAssessment';
  allowLearnerPrint?: Maybe<Scalars['Boolean']['output']>;
  assessmentType: AssessmentType;
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['Date']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedFrom?: Maybe<Scalars['Date']['output']>;
  results?: Maybe<Array<DashboardAssessmentResult>>;
  startDate: Scalars['Date']['output'];
};

export type DashboardAssessmentFilter = {
  published: Scalars['Boolean']['input'];
  studentPartyId: Scalars['Long']['input'];
};

export type DashboardAssessmentResult = {
  __typename?: 'DashboardAssessmentResult';
  assessmentId: Scalars['Long']['output'];
  grade?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  result?: Maybe<Scalars['Int']['output']>;
  studentPartyId: Scalars['Long']['output'];
  studyLevel?: Maybe<StudyLevel>;
  subject: Scalars['String']['output'];
  subjectGroupId: Scalars['Long']['output'];
};

export enum DataExtraction_Category {
  Assessment = 'ASSESSMENT',
  Fees = 'FEES',
  Other = 'OTHER',
  Personal = 'PERSONAL',
  SessionAttendance = 'SESSION_ATTENDANCE',
  SessionAttendanceSummary = 'SESSION_ATTENDANCE_SUMMARY',
  Wellbeing = 'WELLBEING'
}

export type DataExtraction_ExtractInput = {
  academicNamespaceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categories?: InputMaybe<Array<DataExtraction_Category>>;
  studentPartyId: Scalars['Long']['input'];
};

export type DataExtraction_ExtractorInfo = {
  __typename?: 'DataExtraction_ExtractorInfo';
  category: DataExtraction_Category;
  displayName: Scalars['String']['output'];
};

export type DateAttendance = {
  __typename?: 'DateAttendance';
  bellTimeAttendance: Array<BellTimeAttendance>;
  date: Scalars['Date']['output'];
};

export enum Day {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum DayType {
  Extracurricular = 'EXTRACURRICULAR',
  Holiday = 'HOLIDAY',
  Partial = 'PARTIAL',
  SchoolDay = 'SCHOOL_DAY',
  StaffDay = 'STAFF_DAY'
}

export type DeactivateProfiles = {
  partyIds: Array<Scalars['Long']['input']>;
};

export type Debtor = {
  __typename?: 'Debtor';
  amount: Scalars['Float']['output'];
  amountDiscounted: Scalars['Float']['output'];
  amountDue: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  amountWrittenOff: Scalars['Float']['output'];
  /** deep linked */
  classGroup: GeneralGroup;
  discounts: Array<Discount>;
  discountsAppliedIds: Array<Scalars['Int']['output']>;
  feeId: Scalars['Int']['output'];
  feeStatus: FeeStatus;
  id: Scalars['Int']['output'];
  installments?: Maybe<Array<DebtorInstallment>>;
  partyId: Scalars['Long']['output'];
  /** deep linked */
  person: Person;
  writeOffNote?: Maybe<Scalars['String']['output']>;
};

export type DebtorFilter = {
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type DebtorInstallment = {
  __typename?: 'DebtorInstallment';
  absorbFees: Scalars['Boolean']['output'];
  amount: Scalars['Float']['output'];
  cardUsed: Scalars['String']['output'];
  debtorId: Scalars['Int']['output'];
  feeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  installment: Scalars['Int']['output'];
  installmentDate: Scalars['Date']['output'];
  installmentStatus?: Maybe<InstallmentStatus>;
  payee: Person;
  payeePartyId: Scalars['Long']['output'];
  personPartyId: Scalars['Long']['output'];
  serviceCharges: Scalars['Float']['output'];
};

export type DebtorInstallmentFilter = {
  debtorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  feeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type DefaultProfileInput = {
  profileId: Scalars['Int']['input'];
};

export type DeleteCardInput = {
  paymentMethodId: Scalars['String']['input'];
};

export type DeleteDiscountInput = {
  id: Scalars['Int']['input'];
};

export type DeleteFeeInput = {
  id: Scalars['Int']['input'];
};

export type DeleteFileTransferInput = {
  feature: FileTransferFeature;
  ids: Array<Scalars['Long']['input']>;
};

export type DeleteNonClassContactHoursInput = {
  nonClassContactHoursIds: Array<Scalars['Int']['input']>;
};

export type DeleteOption = {
  optionId: Scalars['Int']['input'];
};

export type DeleteScheduledMailInput = {
  scheduledMailId: Scalars['Long']['input'];
  schoolMailbox: Scalars['Boolean']['input'];
};

export type DeleteScheduledSmsInput = {
  scheduledSmsId: Scalars['Long']['input'];
};

export type DeleteStudentMedicalConditionInput = {
  id: Scalars['Int']['input'];
  studentPartyId: Scalars['Long']['input'];
};

export type DeleteStudentMedicalContactInput = {
  id: Scalars['Int']['input'];
  studentPartyId: Scalars['Long']['input'];
};

export type DeleteStudentsInput = {
  partyIds: Array<Scalars['Long']['input']>;
};

export type DeleteSubjectInput = {
  id: Scalars['Int']['input'];
};

export type DeviceRegistration = {
  __typename?: 'DeviceRegistration';
  deviceId: Scalars['String']['output'];
  deviceMake: Scalars['String']['output'];
  deviceType: DeviceType;
  globalUserId: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  osVersion: Scalars['String']['output'];
  personPartyId?: Maybe<Scalars['Long']['output']>;
};

export type DeviceRegistrationFilter = {
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  globalUserIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  tenant?: InputMaybe<Scalars['Int']['input']>;
};

export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type DisconnectPlatformInput = {
  platform: SocialPlatform;
};

export type Discount = {
  __typename?: 'Discount';
  active: Scalars['Boolean']['output'];
  /** deep linked */
  createdBy: Person;
  createdByPartyId: Scalars['Long']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountType: DiscountType;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  siblingDiscount?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['Float']['output'];
};

export type DiscountAssignee = {
  __typename?: 'DiscountAssignee';
  assigneeType: DiscountAssigneeType;
  discountId: Scalars['Int']['output'];
  feeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  partyId: Scalars['Long']['output'];
};

export type DiscountAssigneeFilter = {
  discountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export enum DiscountAssigneeType {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL'
}

export type DiscountFilter = {
  ids: Array<Scalars['Int']['input']>;
};

export enum DiscountType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type Documentation_ActiveChangeRequestForPage = {
  __typename?: 'Documentation_ActiveChangeRequestForPage';
  changeRequest: Documentation_ChangeRequest;
  contentMd?: Maybe<Scalars['String']['output']>;
  videoData?: Maybe<Documentation_PageVideoData>;
};

export type Documentation_AddChangeRequestItemInput = {
  changeRequestId: Scalars['Int']['input'];
  contentMd?: InputMaybe<Scalars['String']['input']>;
  operation: Documentation_ItemOperation;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  parentPageId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  videoData?: InputMaybe<Documentation_VideoDataInput>;
};

export type Documentation_AdminPageListItem = {
  __typename?: 'Documentation_AdminPageListItem';
  activeCrStatus?: Maybe<Documentation_ChangeRequestStatus>;
  metadata: Array<Documentation_PageMetadata>;
  page: Documentation_Page;
};

/**
 * Lean tenant-wide admin-page row used by the link picker dialog and the
 * broken-link decoration in the editor. Distinct from `Documentation_AdminPageListItem`
 * (which carries per-row management context like activeCrStatus + metadata) so
 * the picker / classifier don't pay for fields they don't render.
 */
export type Documentation_AdminPageSummary = {
  __typename?: 'Documentation_AdminPageSummary';
  entityType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  publishedVersionId?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  spaceId: Scalars['Int']['output'];
  spaceName: Scalars['String']['output'];
  spaceSlug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Documentation_CancelChangeRequestsInput = {
  ids: Array<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Documentation_ChangeRequest = {
  __typename?: 'Documentation_ChangeRequest';
  cancellationReason?: Maybe<Scalars['String']['output']>;
  createdByUserId?: Maybe<Scalars['Long']['output']>;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  releaseTag?: Maybe<Scalars['String']['output']>;
  source: Documentation_ChangeRequestSource;
  status: Documentation_ChangeRequestStatus;
  title: Scalars['String']['output'];
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type Documentation_ChangeRequestDiff = {
  __typename?: 'Documentation_ChangeRequestDiff';
  currentContent?: Maybe<Scalars['String']['output']>;
  currentPublishedVersionId?: Maybe<Scalars['Int']['output']>;
  currentVideoData?: Maybe<Documentation_PageVideoData>;
  itemId: Scalars['Int']['output'];
  operation: Scalars['String']['output'];
  pageId?: Maybe<Scalars['Int']['output']>;
  proposedContent?: Maybe<Scalars['String']['output']>;
  proposedVideoData?: Maybe<Documentation_PageVideoData>;
};

export type Documentation_ChangeRequestFilter = {
  releaseTag?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Documentation_ChangeRequestSource>;
  status?: InputMaybe<Documentation_ChangeRequestStatus>;
};

export type Documentation_ChangeRequestItem = {
  __typename?: 'Documentation_ChangeRequestItem';
  basePublishedVersionId?: Maybe<Scalars['Int']['output']>;
  changeRequestId: Scalars['Int']['output'];
  contentMd?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  operation: Documentation_ItemOperation;
  pageId?: Maybe<Scalars['Int']['output']>;
  parentPageId?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  spaceId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userTypes?: Maybe<Array<Scalars['String']['output']>>;
};

export enum Documentation_ChangeRequestSource {
  GitSync = 'git_sync',
  Ui = 'ui'
}

export enum Documentation_ChangeRequestStatus {
  Approved = 'approved',
  Cancelled = 'cancelled',
  Draft = 'draft',
  InReview = 'in_review',
  Merged = 'merged',
  Rejected = 'rejected',
  Unchanged = 'unchanged'
}

export type Documentation_CreateChangeRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  item?: InputMaybe<Documentation_NewChangeRequestItemInput>;
  releaseTag?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type Documentation_CreatePageInput = {
  entityType?: InputMaybe<Scalars['String']['input']>;
  metadataChanges?: InputMaybe<Array<Documentation_MetadataEntryInput>>;
  parentPageId?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  spaceId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  userTypes: Array<Scalars['String']['input']>;
  videoData?: InputMaybe<Documentation_VideoDataInput>;
};

export type Documentation_CreateSpaceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type Documentation_ExportResult = {
  __typename?: 'Documentation_ExportResult';
  markdown?: Maybe<Scalars['String']['output']>;
};

export enum Documentation_ItemOperation {
  Add = 'add',
  Delete = 'delete',
  Modify = 'modify'
}

export type Documentation_MetadataEntryInput = {
  key: Documentation_PageMetadataKey;
  values: Array<Scalars['String']['input']>;
};

export type Documentation_MetadataFilterInput = {
  key: Documentation_PageMetadataKey;
  values: Array<Scalars['String']['input']>;
};

export type Documentation_MovePageInput = {
  newParentPageId?: InputMaybe<Scalars['Int']['input']>;
  newSortOrder?: InputMaybe<Scalars['Int']['input']>;
  newSpaceId?: InputMaybe<Scalars['Int']['input']>;
  pageId: Scalars['Int']['input'];
};

export type Documentation_NewChangeRequestItemInput = {
  contentMd?: InputMaybe<Scalars['String']['input']>;
  operation: Documentation_ItemOperation;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  parentPageId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  videoData?: InputMaybe<Documentation_VideoDataInput>;
};

export type Documentation_Page = {
  __typename?: 'Documentation_Page';
  /**
   * Counts of broken / pending internal links found in `contentMd` after
   * server-side normalisation. Zero on tree-fetch responses (where contentMd
   * is null). Used by the reader's top-of-page alert; the inline decoration
   * is baked into `contentMd` itself as `<a data-link-state="...">` HTML so
   * the FE doesn't need to classify links client-side.
   */
  brokenLinkCount: Scalars['Int']['output'];
  contentMd?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  parentPageId?: Maybe<Scalars['Int']['output']>;
  pendingLinkCount: Scalars['Int']['output'];
  publishedVersionId?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  spaceId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  userTypes: Array<Scalars['String']['output']>;
  videoData?: Maybe<Documentation_PageVideoData>;
};

export type Documentation_PageDetail = {
  __typename?: 'Documentation_PageDetail';
  activeChangeRequest?: Maybe<Documentation_ActiveChangeRequestForPage>;
  metadata: Array<Documentation_PageMetadata>;
  page?: Maybe<Documentation_Page>;
};

export type Documentation_PageFilter = {
  metadataFilters?: InputMaybe<Array<Documentation_MetadataFilterInput>>;
  spaceId: Scalars['Int']['input'];
};

export type Documentation_PageMetadata = {
  __typename?: 'Documentation_PageMetadata';
  blockId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  key: Documentation_PageMetadataKey;
  pageId: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type Documentation_PageMetadataItemInput = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  key: Documentation_PageMetadataKey;
  pageId: Scalars['Int']['input'];
  values: Array<Scalars['String']['input']>;
};

export enum Documentation_PageMetadataKey {
  AssociatedUrl = 'ASSOCIATED_URL',
  DocumentType = 'DOCUMENT_TYPE',
  PermissionSet = 'PERMISSION_SET',
  Platform = 'PLATFORM',
  Quality = 'QUALITY',
  RelatedDocs = 'RELATED_DOCS',
  SchoolType = 'SCHOOL_TYPE',
  TenantTypes = 'TENANT_TYPES',
  Unknown = 'UNKNOWN',
  UserType = 'USER_TYPE'
}

export type Documentation_PageVersion = {
  __typename?: 'Documentation_PageVersion';
  changeRequestId?: Maybe<Scalars['Int']['output']>;
  contentMd?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  pageId: Scalars['Int']['output'];
  plainText?: Maybe<Scalars['String']['output']>;
  status: Documentation_VersionStatus;
  versionNumber: Scalars['Int']['output'];
};

export type Documentation_PageVideoData = {
  __typename?: 'Documentation_PageVideoData';
  /**
   * Stored as `width:height` (e.g. `16:9`) — industry convention. CSS
   * `aspect-ratio` needs `width / height`; convert at the rendering boundary
   * (web: `utils/video-format.ts#toCssAspectRatio`).
   */
  aspectRatio?: Maybe<Scalars['String']['output']>;
  durationSec?: Maybe<Scalars['Int']['output']>;
  embedUrl: Scalars['String']['output'];
  provider: Documentation_VideoProvider;
  sourceUrl: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type Documentation_PermissionInfo = {
  __typename?: 'Documentation_PermissionInfo';
  contact: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  staff: Scalars['Boolean']['output'];
  student: Scalars['Boolean']['output'];
};

export type Documentation_PromotionResult = {
  __typename?: 'Documentation_PromotionResult';
  conflictingItemIds: Array<Scalars['Int']['output']>;
  promotedCrIds: Array<Scalars['Int']['output']>;
  promotedItemIds: Array<Scalars['Int']['output']>;
};

export type Documentation_QuickMergeChangeRequestInput = {
  id: Scalars['Int']['input'];
  items?: InputMaybe<Array<Documentation_QuickPublishItemInput>>;
};

/**
 * Publish many markdown pages into a SINGLE change request (one push run = one CR).
 * title/source/releaseTag are batch-level; each item reuses the per-page input shape
 * (its own source/releaseTag are ignored).
 */
export type Documentation_QuickPublishBatchFromMarkdownInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  items: Array<Documentation_QuickPublishFromMarkdownInput>;
  releaseTag?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Documentation_ChangeRequestSource>;
  title: Scalars['String']['input'];
};

/**
 * Result of a batch markdown publish: the single CR created (null if nothing changed),
 * plus the page slugs grouped by outcome.
 */
export type Documentation_QuickPublishBatchResult = {
  __typename?: 'Documentation_QuickPublishBatchResult';
  added: Array<Scalars['String']['output']>;
  crId?: Maybe<Scalars['Int']['output']>;
  failed: Array<Scalars['String']['output']>;
  modified: Array<Scalars['String']['output']>;
  unchanged: Array<Scalars['String']['output']>;
};

export type Documentation_QuickPublishFromMarkdownInput = {
  contentMd: Scalars['String']['input'];
  entityType?: InputMaybe<Scalars['String']['input']>;
  metadataChanges?: InputMaybe<Array<Documentation_MetadataEntryInput>>;
  parentPageId?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  releaseTag?: InputMaybe<Scalars['String']['input']>;
  routes?: InputMaybe<Array<Scalars['String']['input']>>;
  slug: Scalars['String']['input'];
  source?: InputMaybe<Documentation_ChangeRequestSource>;
  spaceId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  userTypes: Array<Scalars['String']['input']>;
  videoData?: InputMaybe<Documentation_VideoDataInput>;
};

export type Documentation_QuickPublishInput = {
  items: Array<Documentation_QuickPublishItemInput>;
  title: Scalars['String']['input'];
};

export type Documentation_QuickPublishItemInput = {
  contentMd?: InputMaybe<Scalars['String']['input']>;
  operation: Documentation_ItemOperation;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  parentPageId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Documentation_RefreshVideoDataInput = {
  pageId: Scalars['Int']['input'];
};

export type Documentation_RejectChangeRequestsInput = {
  ids: Array<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Documentation_RelatedPage = {
  __typename?: 'Documentation_RelatedPage';
  ancestorTitles: Array<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  pageId: Scalars['Int']['output'];
  pageSlug: Scalars['String']['output'];
  spaceId: Scalars['Int']['output'];
  spaceName: Scalars['String']['output'];
  spaceSlug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Documentation_RelatedPagesFilter = {
  includeUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
  routePattern?: InputMaybe<Scalars['String']['input']>;
};

export type Documentation_ReleaseTag = {
  __typename?: 'Documentation_ReleaseTag';
  approvedCount: Scalars['Int']['output'];
  draftCount: Scalars['Int']['output'];
  inReviewCount: Scalars['Int']['output'];
  mergedCount: Scalars['Int']['output'];
  releaseTag: Scalars['String']['output'];
};

export type Documentation_RemoveChangeRequestItemInput = {
  changeRequestId: Scalars['Int']['input'];
  pageId: Scalars['Int']['input'];
};

export type Documentation_ReorderSpacesInput = {
  spaceIds: Array<Scalars['Int']['input']>;
};

export type Documentation_ReplacePageVideoUrlInput = {
  pageId: Scalars['Int']['input'];
  sourceUrl: Scalars['String']['input'];
};

export type Documentation_RestoreVersionInput = {
  pageId: Scalars['Int']['input'];
  versionId: Scalars['Int']['input'];
};

export type Documentation_SearchFilter = {
  metadataFilters?: InputMaybe<Array<Documentation_MetadataFilterInput>>;
  query: Scalars['String']['input'];
};

export type Documentation_SearchResult = {
  __typename?: 'Documentation_SearchResult';
  ancestorTitles: Array<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  pageId: Scalars['Int']['output'];
  pageSlug: Scalars['String']['output'];
  rank: Scalars['Float']['output'];
  snippet: Scalars['String']['output'];
  spaceName: Scalars['String']['output'];
  spaceSlug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Documentation_SetPageMetadataInput = {
  items: Array<Documentation_PageMetadataItemInput>;
};

export type Documentation_SinglePageFilter = {
  pageId?: InputMaybe<Scalars['Int']['input']>;
  pageSlug?: InputMaybe<Scalars['String']['input']>;
  spaceSlug?: InputMaybe<Scalars['String']['input']>;
};

export type Documentation_Space = {
  __typename?: 'Documentation_Space';
  articleCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  videoCount: Scalars['Int']['output'];
};

export type Documentation_UpdateChangeRequestReleaseTagInput = {
  id: Scalars['Int']['input'];
  releaseTag?: InputMaybe<Scalars['String']['input']>;
};

export type Documentation_UpdatePageInput = {
  metadataChanges?: InputMaybe<Array<Documentation_MetadataEntryInput>>;
  pageId: Scalars['Int']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Documentation_UpdateSpaceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export enum Documentation_VersionStatus {
  Archived = 'archived',
  Published = 'published'
}

export type Documentation_VideoDataInput = {
  sourceUrl: Scalars['String']['input'];
};

export enum Documentation_VideoProvider {
  Loom = 'LOOM',
  Other = 'OTHER',
  Vimeo = 'VIMEO',
  Youtube = 'YOUTUBE'
}

export type Dtab_CellValue = {
  __typename?: 'Dtab_CellValue';
  columnId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isLatest: Scalars['Boolean']['output'];
  /** Optional resolved link if it's a linked column */
  linkedRows?: Maybe<Array<Dtab_Row>>;
  rowId: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type Dtab_Chart = {
  groupByLink: Scalars['Boolean']['input'];
  groupings?: InputMaybe<Array<Dtab_ChartGrouping>>;
  id: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  metrics: Array<Dtab_ChartMetric>;
  sortColumn?: InputMaybe<Dtab_SortColumn>;
  sortType?: InputMaybe<Dtab_SortType>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Charts_ChartType;
};

export type Dtab_ChartGrouping = {
  columnId: Scalars['String']['input'];
  customRecordFormat?: InputMaybe<Dtab_CustomRecordFormat>;
  operation?: InputMaybe<Dtab_Operation>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type Dtab_ChartMetric = {
  aggregationFunction: AggregationFunction;
  columnId: Scalars['String']['input'];
};

export type Dtab_ChartTableFilter = {
  chartIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tableFilter: Dtab_TableFilter;
};

export type Dtab_ColumnGroup = {
  __typename?: 'Dtab_ColumnGroup';
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type Dtab_CreateChart = {
  groupByLink?: InputMaybe<Scalars['Boolean']['input']>;
  groupings?: InputMaybe<Array<Dtab_CreateChartGrouping>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  metrics: Array<Dtab_CreateChartMetric>;
  sortColumn?: InputMaybe<Dtab_SortColumn>;
  sortType?: InputMaybe<Dtab_SortType>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Charts_ChartType;
};

export type Dtab_CreateChartGrouping = {
  columnId: Scalars['String']['input'];
  customRecordFormat?: InputMaybe<Dtab_CustomRecordFormat>;
  operation?: InputMaybe<Dtab_Operation>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type Dtab_CreateChartMetric = {
  aggregationFunction: AggregationFunction;
  columnId: Scalars['String']['input'];
};

export type Dtab_CreateColumn = {
  columnGroup?: InputMaybe<Dtab_CreateColumnGroup>;
  columnId?: InputMaybe<Scalars['String']['input']>;
  csvColumn?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  selectInfo?: InputMaybe<FormsFd_UpsertFormDefinitionFieldSelect>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  type: Form_FormFieldItemType;
};

export type Dtab_CreateColumnGroup = {
  header?: InputMaybe<Scalars['String']['input']>;
  idx?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type Dtab_CreateExtensionPointInput = {
  area: Dtab_ExtensionArea;
  table: Dtab_CreateTable;
  tenantConfigs: Array<Dtab_CreateTenantExtensionPointConfigInput>;
  type: Dtab_ExtensionAreaType;
};

export type Dtab_CreateRootDetails = {
  visibleToTenants: Array<Dtab_CreateRootDetailsTenant>;
};

export type Dtab_CreateRootDetailsTenant = {
  canEditTableDefinition: Scalars['Boolean']['input'];
  canRead: Scalars['Boolean']['input'];
  canWriteRows: Scalars['Boolean']['input'];
  tenant: Scalars['Int']['input'];
};

export type Dtab_CreateTable = {
  allowPartialRowCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  charts?: InputMaybe<Array<Dtab_CreateChart>>;
  columnGroups?: InputMaybe<Array<Dtab_CreateColumnGroup>>;
  columns: Array<Dtab_CreateColumn>;
  description?: InputMaybe<Scalars['String']['input']>;
  isReusableTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  rootDetails?: InputMaybe<Dtab_CreateRootDetails>;
  tableType?: InputMaybe<Dtab_TableType>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  tyroDefinedTableId?: InputMaybe<Scalars['String']['input']>;
  validationRules?: InputMaybe<Dtab_TableValidationRulesInput>;
};

export type Dtab_CreateTenantExtensionPointConfigInput = {
  canEditTableDefinition: Scalars['Boolean']['input'];
  canView: Scalars['Boolean']['input'];
  canWrite: Scalars['Boolean']['input'];
  disabled: Scalars['Boolean']['input'];
  tenant: Scalars['Int']['input'];
};

export type Dtab_CustomExtensionPoint = {
  __typename?: 'Dtab_CustomExtensionPoint';
  data: Dtab_Row;
  referencedId: Scalars['String']['output'];
};

export type Dtab_CustomExtensionPointFilter = {
  area: Dtab_ExtensionArea;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Dtab_ExtensionAreaType>>;
};

/**
 * One link per (requested entity, registered extension point). `data` is the
 * entity's submitted row when present, or null when the entity has not yet
 * submitted — in which case the link acts as a metadata-only placeholder
 * advertising the extension point (area, type, table schema) to the client.
 */
export type Dtab_CustomExtensionPointLink = {
  __typename?: 'Dtab_CustomExtensionPointLink';
  area: Dtab_ExtensionArea;
  data?: Maybe<Dtab_Row>;
  referencedId: Scalars['String']['output'];
  table: Dtab_Table;
  type: Dtab_ExtensionAreaType;
};

export type Dtab_CustomExtensionPointLinkFilter = {
  types: Array<Dtab_ExtensionAreaType>;
};

export type Dtab_CustomExtensionPointLinkList = {
  __typename?: 'Dtab_CustomExtensionPointLinkList';
  result: Array<Dtab_CustomExtensionPointLink>;
};


export type Dtab_CustomExtensionPointLinkListResultArgs = {
  custExtFilter?: InputMaybe<Dtab_CustomExtensionPointLinkFilter>;
};

export type Dtab_CustomExtensionPoints = {
  __typename?: 'Dtab_CustomExtensionPoints';
  table: Dtab_Table;
  type?: Maybe<Dtab_ExtensionAreaType>;
};

export enum Dtab_CustomRecordFormat {
  DateToMonthYear = 'DATE_TO_MONTH_YEAR'
}

export type Dtab_DeleteExtensionPointInput = {
  deleteAllData?: InputMaybe<Scalars['Boolean']['input']>;
  extensionPointId: Scalars['Int']['input'];
};

export type Dtab_DeleteRows = {
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  rowIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tableId: FormsFd_DefinitionIdInput;
};

export type Dtab_DeleteTable = {
  id: FormsFd_DefinitionIdInput;
};

export type Dtab_DeleteTag = {
  ids: Array<Scalars['Int']['input']>;
};

export enum Dtab_ExtensionArea {
  Student = 'STUDENT'
}

export enum Dtab_ExtensionAreaType {
  StudentEnrollment = 'STUDENT_ENROLLMENT'
}

export enum Dtab_ExtensionPointAdminDisabledType {
  Enabled = 'ENABLED',
  SystemDefinedDisabled = 'SYSTEM_DEFINED_DISABLED',
  UserDefinedDisabled = 'USER_DEFINED_DISABLED'
}

export type Dtab_ExtensionPointAdminFilter = {
  area?: InputMaybe<Dtab_ExtensionArea>;
  enabled?: InputMaybe<Array<Dtab_ExtensionPointAdminDisabledType>>;
  extensionPointIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Array<Dtab_ExtensionAreaType>>;
};

export type Dtab_ExtensionPointConfig = {
  __typename?: 'Dtab_ExtensionPointConfig';
  area: Dtab_ExtensionArea;
  canEditTableDefinition?: Maybe<Scalars['Boolean']['output']>;
  canView?: Maybe<Scalars['Boolean']['output']>;
  canWrite?: Maybe<Scalars['Boolean']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  extensionPointId: Scalars['Int']['output'];
  isSystemDefined: Scalars['Boolean']['output'];
  table: Dtab_Table;
  tenantConfigs?: Maybe<Array<Dtab_TenantExtensionPointConfig>>;
  type: Dtab_ExtensionAreaType;
};

export type Dtab_MetricDefinition = {
  metric: Scalars['String']['input'];
  metricAggregate: AggregationFunction;
};

export type Dtab_NoteFilter = {
  page?: InputMaybe<Page>;
  tagTypes?: InputMaybe<Array<Dtab_TagType>>;
};

export type Dtab_Operation = {
  type: Dtab_OperationType;
};

export enum Dtab_OperationType {
  TruncateMonth = 'TRUNCATE_MONTH'
}

export type Dtab_RegisterExtensionPointInput = {
  extensionPointId: Scalars['Int']['input'];
};

export type Dtab_Row = {
  __typename?: 'Dtab_Row';
  cells: Array<Dtab_CellValue>;
  completionStatus: RequestStatus;
  confirmationStatus: Forms_ConfirmationStatus;
  header: Dtab_RowHeader;
  pbac: Pbac_ResourceResult;
  rowId: Dtab_RowId;
};

export type Dtab_RowFilter = {
  columnId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Dtab_RowHeader = {
  rowId: Dtab_RowId;
  type: Dtab_RowHeaderType;
};

export enum Dtab_RowHeaderType {
  FormInfoRequest = 'FORM_INFO_REQUEST',
  FormStandard = 'FORM_STANDARD'
}

export type Dtab_RowHeader_FormInfoRequest = Dtab_RowHeader & {
  __typename?: 'Dtab_RowHeader_FormInfoRequest';
  aboutParty: Person;
  aboutPartyId: Scalars['Long']['output'];
  responderParty?: Maybe<Person>;
  responderPartyId?: Maybe<Scalars['Long']['output']>;
  rowId: Dtab_RowId;
  type: Dtab_RowHeaderType;
};

export type Dtab_RowHeader_FormSubmission = Dtab_RowHeader & {
  __typename?: 'Dtab_RowHeader_FormSubmission';
  createdBy?: Maybe<AuditPerson>;
  createdByPartyId?: Maybe<Scalars['Long']['output']>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  entity?: Maybe<Person>;
  entityPartyId?: Maybe<Scalars['Long']['output']>;
  entityType: DyRel_EntityType;
  headerFields: Array<Dtab_RowHeader_FormSubmissionItem>;
  id: Scalars['String']['output'];
  lastUpdatedBy?: Maybe<AuditPerson>;
  lastUpdatedByPartyId?: Maybe<Scalars['Long']['output']>;
  lastUpdatedByUserId?: Maybe<Scalars['Int']['output']>;
  rowId: Dtab_RowId;
  type: Dtab_RowHeaderType;
};

export type Dtab_RowHeader_FormSubmissionItem = {
  __typename?: 'Dtab_RowHeader_FormSubmissionItem';
  label: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  type: Form_FormFieldItemType;
  value?: Maybe<Scalars['String']['output']>;
};

export type Dtab_RowId = {
  __typename?: 'Dtab_RowId';
  rowId: Scalars['String']['output'];
  tableId: Scalars['Int']['output'];
};

/** Optional: returned when querying a snapshot at a given time */
export type Dtab_RowSnapshot = {
  __typename?: 'Dtab_RowSnapshot';
  cells: Array<Dtab_CellValue>;
  rowId: Scalars['String']['output'];
};

export enum Dtab_SortColumn {
  GroupingColumn_1 = 'GROUPING_COLUMN_1',
  GroupingColumn_2 = 'GROUPING_COLUMN_2',
  Value = 'VALUE'
}

export enum Dtab_SortType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Dtab_Table = {
  __typename?: 'Dtab_Table';
  columnGroups: Array<Dtab_ColumnGroup>;
  columns: Array<FormsFd_FormDefinitionField>;
  displayOptions?: Maybe<Dtab_TableDisplayOptions>;
  id: FormsFd_DefinitionId;
  name: Scalars['String']['output'];
  pbac: Pbac_ResourceResult;
  rows: Array<Dtab_Row>;
  tags: Array<Dtab_Tag>;
  tagsIds: Array<Scalars['Int']['output']>;
  tyroDefinedTableId?: Maybe<Scalars['String']['output']>;
  validationRules: Dtab_TableValidationRules;
};

export type Dtab_TableDefinitionFilter = {
  ids: Array<FormsFd_DefinitionIdInput>;
  tableType?: InputMaybe<Dtab_TableType>;
  /** Dtab_TyroDefinedTable */
  tyroDefinedTableId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Dtab_TableDisplayOptions = {
  __typename?: 'Dtab_TableDisplayOptions';
  displayCompletedOnRow: Scalars['Boolean']['output'];
  displayConfirmedOnRow: Scalars['Boolean']['output'];
};

export type Dtab_TableFilter = {
  id?: InputMaybe<FormsFd_DefinitionIdInput>;
  linksRequired?: InputMaybe<Scalars['Boolean']['input']>;
  rowFiltersOR: Array<Dtab_RowFilter>;
  rowLinkFilters?: InputMaybe<Array<InputMaybe<DyRel_RelationFilter>>>;
  /** Dtab_TyroDefinedTable */
  tyroDefinedTableId?: InputMaybe<Scalars['String']['input']>;
};

export enum Dtab_TableType {
  CustomExtensionPoint = 'CUSTOM_EXTENSION_POINT',
  TyroCms = 'TYRO_CMS',
  UserFacingStandard = 'USER_FACING_STANDARD'
}

export type Dtab_TableValidationRules = {
  __typename?: 'Dtab_TableValidationRules';
  /** what is allowed to be linked to the form. empty is all */
  allowedDyRelEntityTypes: Array<DyRel_EntityType>;
  /** for example a student can only have one Cat4Entry */
  canOnlyContainOneEntryPerDyRelEntity: Scalars['Boolean']['output'];
};

export type Dtab_TableValidationRulesInput = {
  /** what is allowed to be linked to the form. empty is all */
  allowedDyRelEntityTypes: Array<DyRel_EntityType>;
  /** for example a student can only have one Cat4Entry */
  canOnlyContainOneEntryPerDyRelEntity: Scalars['Boolean']['input'];
};

export type Dtab_Tag = {
  __typename?: 'Dtab_Tag';
  colour: Colour;
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  disabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
  pbac: Pbac_ResourceResult;
  refId?: Maybe<Scalars['String']['output']>;
  systemTag: Scalars['Boolean']['output'];
  tenantCanEdit: Scalars['Boolean']['output'];
  type?: Maybe<Dtab_TagType>;
  uniqueName?: Maybe<Scalars['String']['output']>;
};

export type Dtab_TagFilter = {
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tagTypes?: InputMaybe<Array<InputMaybe<Dtab_TagType>>>;
};

export enum Dtab_TagType {
  AdmissionsAdminTable = 'ADMISSIONS_ADMIN_TABLE',
  AdmissionsUserForm = 'ADMISSIONS_USER_FORM',
  CustomExtensionPoint = 'CUSTOM_EXTENSION_POINT',
  Safeguarding = 'SAFEGUARDING',
  SaPermissionSlip = 'SA_PERMISSION_SLIP',
  StandardisedTest = 'STANDARDISED_TEST',
  StudentData = 'STUDENT_DATA',
  TtOnCallRequest = 'TT_ON_CALL_REQUEST',
  UserDefinedForm = 'USER_DEFINED_FORM'
}

export type Dtab_TenantExtensionPointConfig = {
  __typename?: 'Dtab_TenantExtensionPointConfig';
  canEditTableDefinition: Scalars['Boolean']['output'];
  canView: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
  disabled: Scalars['Boolean']['output'];
  extensionPointId: Scalars['Int']['output'];
  tenant: Scalars['Int']['output'];
};

export enum Dtab_TyroDefinedTable {
  Cat_4 = 'CAT_4',
  DiscontinuedStudy = 'DISCONTINUED_STUDY',
  ExamProvisionsRace = 'EXAM_PROVISIONS_RACE',
  FetEnrolmentData = 'FET_ENROLMENT_DATA',
  HomeSchoolCommunityLiaison = 'HOME_SCHOOL_COMMUNITY_LIAISON',
  VswareStage1Import = 'VSWARE_STAGE1_IMPORT',
  VswareStage2Import = 'VSWARE_STAGE2_IMPORT'
}

export type Dtab_UnregisterExtensionPointInput = {
  extensionPointId: Scalars['Int']['input'];
};

export type Dtab_UpdateTable = {
  id: FormsFd_DefinitionIdInput;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Dtab_UpdateTenantExtensionPointConfigInput = {
  canEditTableDefinition: Scalars['Boolean']['input'];
  canView: Scalars['Boolean']['input'];
  canWrite: Scalars['Boolean']['input'];
  disabled: Scalars['Boolean']['input'];
  extensionPointId: Scalars['Int']['input'];
  tenant: Scalars['Int']['input'];
};

export type Dtab_UpsertRow = {
  cells: Array<Forms_SubmitFormFieldInput>;
  links?: InputMaybe<Array<DyRel_EntityInput>>;
  rowId?: InputMaybe<Scalars['String']['input']>;
};

export enum Dtab_UpsertRowValidationType {
  SkipValidationPersistOnly = 'SKIP_VALIDATION_PERSIST_ONLY',
  ValidateAndPersist = 'VALIDATE_AND_PERSIST',
  ValidateOnly = 'VALIDATE_ONLY'
}

export type Dtab_UpsertTag = {
  colour?: InputMaybe<Colour>;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  groupTagType: Dtab_TagType;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Array<InputMaybe<TranslationInput>>;
};

export type DyRel_CreateLink = {
  fromEntityId: Scalars['String']['input'];
  fromEntityType: DyRel_EntityType;
  toEntityId: Scalars['String']['input'];
  toEntityType: DyRel_EntityType;
};

export type DyRel_Entity = {
  __typename?: 'DyRel_Entity';
  id: Scalars['String']['output'];
  type: DyRel_EntityType;
};

export type DyRel_EntityInput = {
  entityId: Scalars['String']['input'];
  entityType: DyRel_EntityType;
};

export enum DyRel_EntityType {
  Doc = 'DOC',
  Form = 'FORM',
  Note = 'NOTE',
  Party = 'PARTY',
  SchoolActivity = 'SCHOOL_ACTIVITY',
  Student = 'STUDENT',
  Substitution = 'SUBSTITUTION',
  SupportPlan = 'SUPPORT_PLAN',
  Timetable = 'TIMETABLE'
}

export type DyRel_Link = {
  __typename?: 'DyRel_Link';
  fromEntityId: Scalars['String']['output'];
  fromEntityType: DyRel_EntityType;
  toEntityId: Scalars['String']['output'];
  toEntityType: DyRel_EntityType;
};

export type DyRel_RelationFilter = {
  id: Scalars['String']['input'];
  type: DyRel_EntityType;
};

export type DyRel_RelationFilters = {
  /** lookup all links related to an entity. to */
  lookups: Array<DyRel_RelationFilter>;
};

export type EmailAddress = {
  __typename?: 'EmailAddress';
  active?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailId?: Maybe<Scalars['Int']['output']>;
  partyId: Scalars['Long']['output'];
  primaryEmail?: Maybe<Scalars['Boolean']['output']>;
};

export type EnrollmentHistory = {
  __typename?: 'EnrollmentHistory';
  academicNamespace: Scalars['String']['output'];
  academicNamespaceId: Scalars['Int']['output'];
  classGroupId: Scalars['Long']['output'];
  classGroupName: Scalars['String']['output'];
  studentPartyId: Scalars['Long']['output'];
};

export type EnrollmentIre_AutoAssignBlockMembershipInput = {
  assignmentType?: InputMaybe<EnrollmentIre_AutoAssignBlockMembershipType>;
  blockId: Scalars['String']['input'];
};

export enum EnrollmentIre_AutoAssignBlockMembershipType {
  ByGender = 'BY_GENDER'
}

export type EnrollmentIre_AutoAssignCoreMembershipInput = {
  assignmentType?: InputMaybe<EnrollmentIre_AutoAssignCoreMembershipType>;
  yearGroupEnrollmentId: Scalars['Long']['input'];
};

export enum EnrollmentIre_AutoAssignCoreMembershipType {
  ByGender = 'BY_GENDER'
}

/** ###  ire enrollment */
export type EnrollmentIre_BlockEnrollmentFilter = {
  blockId: Scalars['String']['input'];
};

/**
 * Within a block switch a student to a new subject group.
 * For ADD Type
 * Student will be added to chosen subject group and removed from the current subject group(within block) unless the subject group is set as allow duplicates
 * For REMOVE Type
 * Student will be remove from the subject group. They will then appear as unassigned(for this block). No further action taken
 */
export type EnrollmentIre_BlockMembershipChange = {
  studentId: Scalars['Long']['input'];
  subjectGroupId: Scalars['Long']['input'];
  type?: InputMaybe<EnrollmentIre_MembershipChangeEnum>;
};

export type EnrollmentIre_BlockMembershipStudent = {
  __typename?: 'EnrollmentIre_BlockMembershipStudent';
  classGroupName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  isDuplicate: Scalars['Boolean']['output'];
  partyId: Scalars['Long']['output'];
  person: Person;
};

export type EnrollmentIre_BlockMembershipSubjectGroup = {
  __typename?: 'EnrollmentIre_BlockMembershipSubjectGroup';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partyId: Scalars['Long']['output'];
  staff: Array<Person>;
  students: Array<EnrollmentIre_BlockMembershipStudent>;
  subjects: Array<Subject>;
};

export type EnrollmentIre_BlockMemberships = {
  __typename?: 'EnrollmentIre_BlockMemberships';
  block: CoreBlock;
  blockId: Scalars['String']['output'];
  groups: Array<EnrollmentIre_BlockMembershipsDetails>;
  isRotation: Scalars['Boolean']['output'];
};

export type EnrollmentIre_BlockMembershipsDetails = {
  __typename?: 'EnrollmentIre_BlockMembershipsDetails';
  rotationIteration: Scalars['Int']['output'];
  subjectGroups: Array<EnrollmentIre_BlockMembershipSubjectGroup>;
  unenrolledStudents: Array<EnrollmentIre_BlockMembershipStudent>;
};

export type EnrollmentIre_ChangeProgrammeStage = {
  programmeStageId: Scalars['Int']['input'];
  studentPartyId: Scalars['Long']['input'];
};

export type EnrollmentIre_ChangeProgrammeStages = {
  changes: Array<EnrollmentIre_ChangeProgrammeStage>;
  removeFromClasses?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnrollmentIre_CoreEnrollmentFilter = {
  yearGroupEnrollmentId: Scalars['Long']['input'];
};

export type EnrollmentIre_CoreMembershipChange = {
  classGroupId: Scalars['Long']['input'];
  studentId: Scalars['Long']['input'];
  type?: InputMaybe<EnrollmentIre_MembershipChangeEnum>;
};

export type EnrollmentIre_CoreMemberships = {
  __typename?: 'EnrollmentIre_CoreMemberships';
  classGroupIds: Array<Scalars['Long']['output']>;
  classGroups: Array<GeneralGroup>;
  unenrolledStudentIds: Array<Scalars['Long']['output']>;
  unenrolledStudents: Array<Student>;
  yearGroupEnrollment?: Maybe<YearGroupEnrollment>;
};

export type EnrollmentIre_CreateStudent = {
  programmeStageId: Scalars['Int']['input'];
  student: CreateStudentInput;
};

export enum EnrollmentIre_MembershipChangeEnum {
  Add = 'ADD',
  Remove = 'REMOVE'
}

/** reset core membership to match class group */
export type EnrollmentIre_ResetCoreMembership = {
  classGroupIds: Array<Scalars['Long']['input']>;
  groupTagIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type EnrollmentIre_UpsertBlockMembership = {
  blockId: Scalars['String']['input'];
  membershipChange: Array<EnrollmentIre_BlockMembershipChange>;
};

/**
 * For ADD Type
 * Student will be added to chosen class group and add to linked core subject groups for that class. They will be removed from the current Class Group and associated core Subject Groups. Duplicates are not allows
 * For REMOVE Type
 * Student will be removed from the current Class Group and associated core Subject Groups. They will then appear as unassigned (for any class group)
 */
export type EnrollmentIre_UpsertCoreMembership = {
  membershipChange: Array<EnrollmentIre_CoreMembershipChange>;
  /** default false if set to true, students will be removed from blocks which arent associated with class group */
  removeInvalidBlocks?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * @deprecated(reason: "This was used in the old implementation. It is no longer used.")
   * todo handle graphql deprecated annotation internally
   */
  yearGroupEnrollmentId: Scalars['Long']['input'];
};

export type EnrolmentHistoryFilter = {
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type EventAttendance = {
  __typename?: 'EventAttendance';
  adminSubmitted: Scalars['Boolean']['output'];
  attendanceCode: AttendanceCode;
  attendanceCodeId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Person;
  createdByPartyId: Scalars['Long']['output'];
  date: Scalars['Date']['output'];
  eventId: Scalars['Int']['output'];
  groupAttendanceTaken?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  isSignInOut?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  personPartyId: Scalars['Long']['output'];
  previousLessonAttendanceCode?: Maybe<AttendanceCode>;
  previousLessonAttendanceCodeId?: Maybe<Scalars['Int']['output']>;
  subjectGroupId?: Maybe<Scalars['Long']['output']>;
  time?: Maybe<Scalars['Time']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy: Person;
  updatedByPartyId: Scalars['Long']['output'];
};

export type EventAttendanceFilter = {
  adminSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  attendanceCodesIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eventIds?: InputMaybe<Array<AttendanceEventId>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includePreviousLesson?: InputMaybe<Scalars['Boolean']['input']>;
  personPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type EventAttendanceReport = {
  __typename?: 'EventAttendanceReport';
  attendances: Array<EventAttendanceReportPerson>;
  periods: Array<EventAttendanceReportPeriod>;
};

export type EventAttendanceReportEntry = {
  __typename?: 'EventAttendanceReportEntry';
  attendanceCode?: Maybe<AttendanceCode>;
  attendanceCodeId?: Maybe<Scalars['Int']['output']>;
  time: Scalars['Time']['output'];
};

export type EventAttendanceReportFilter = {
  classGroupId: Scalars['Long']['input'];
  date: Scalars['Date']['input'];
};

export type EventAttendanceReportPeriod = {
  __typename?: 'EventAttendanceReportPeriod';
  time: Scalars['Time']['output'];
};

export type EventAttendanceReportPerson = {
  __typename?: 'EventAttendanceReportPerson';
  attendances: Array<EventAttendanceReportEntry>;
  classGroup: GeneralGroup;
  classGroupId: Scalars['Long']['output'];
  percentage: Scalars['Int']['output'];
  possible: Scalars['Int']['output'];
  present: Scalars['Int']['output'];
  student: Person;
  studentPartyId: Scalars['Long']['output'];
};

export enum EventType {
  Behaviour = 'BEHAVIOUR',
  Doc = 'DOC',
  Form = 'FORM',
  Note = 'NOTE'
}

export type ExampleObjectExtension = {
  __typename?: 'ExampleObjectExtension';
  value?: Maybe<Scalars['String']['output']>;
};

export enum ExcludeAction {
  Exclude = 'EXCLUDE',
  Undo = 'UNDO'
}

export type ExcludedPerson = {
  __typename?: 'ExcludedPerson';
  /** deep linked */
  excludedBy: Person;
  excludedByPartyId: Scalars['Long']['output'];
  excludedOn: Scalars['DateTime']['output'];
  /** deep linked */
  excludedPerson: Person;
  excludedPersonId: ExcludedPersonId;
};

export type ExcludedPersonId = {
  __typename?: 'ExcludedPersonId';
  excludedPartyId: Scalars['Long']['output'];
  feeId: Scalars['Int']['output'];
};

export type ExpandedParties = {
  __typename?: 'ExpandedParties';
  partyId?: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
};

export type ExpandedPartiesFilter = {
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type Export_PtmoFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export enum ExternalSystemEntityType {
  Contact = 'CONTACT',
  Group = 'GROUP',
  Room = 'ROOM',
  Staff = 'STAFF',
  Student = 'STUDENT'
}

export type ExternalSystemInfo = {
  /** Used if external system has one to one mapping */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Used if external system has many entities that we are mapping to one */
  externalIdArray?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalSystemEntityType?: InputMaybe<ExternalSystemEntityType>;
  externalSystemProvider?: InputMaybe<ExternalSystemProvider>;
};

export enum ExternalSystemProvider {
  Facility = 'FACILITY',
  Vsware = 'VSWARE'
}

export enum ExtraFieldType {
  CommentBank = 'COMMENT_BANK',
  FreeForm = 'FREE_FORM',
  GradeSet = 'GRADE_SET',
  Select = 'SELECT'
}

export type FailedNotification = {
  __typename?: 'FailedNotification';
  featureId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  notificationType: NotificationType;
  recipientIds: Array<Scalars['Long']['output']>;
  recipients: Array<FailedNotificationRecipient>;
  scheduledNotificationId?: Maybe<Scalars['Long']['output']>;
  /** deep linked */
  sender: Person;
  senderPartyId: Scalars['Long']['output'];
  sentOn: Scalars['DateTime']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type FailedNotificationFilter = {
  failedNotificationIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type FailedNotificationRecipient = {
  __typename?: 'FailedNotificationRecipient';
  id: Scalars['Long']['output'];
  metaData?: Maybe<NotificationMetaData>;
  recipientPartyId: Scalars['Long']['output'];
  userType: FailedNotificationUserType;
};

export type FailedNotificationResendInput = {
  failedNotificationId: Scalars['Long']['input'];
};

export enum FailedNotificationUserType {
  Contact = 'CONTACT',
  Staff = 'STAFF',
  Student = 'STUDENT'
}

export type FailedSms = {
  __typename?: 'FailedSms';
  id: Scalars['Long']['output'];
  recipientIds: Array<Scalars['Long']['output']>;
  recipients: Array<FailedSmsRecipient>;
  /** deep linked */
  sender: Person;
  senderPartyId: Scalars['Long']['output'];
  sentOn: Scalars['DateTime']['output'];
  text: Scalars['String']['output'];
};

export type FailedSmsFilter = {
  failedSmsIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type FailedSmsRecipient = {
  __typename?: 'FailedSmsRecipient';
  id: Scalars['Long']['output'];
  recipientPartyId: Scalars['Long']['output'];
  recipientType?: Maybe<SmsRecipientType>;
};

export type FailedSmsResendInput = {
  failedSmsIds: Array<Scalars['Long']['input']>;
};

export enum Feature {
  Admissions = 'ADMISSIONS',
  AdvancedPermissions = 'ADVANCED_PERMISSIONS',
  Ana = 'ANA',
  Assessment = 'ASSESSMENT',
  Attendance = 'ATTENDANCE',
  Calendar = 'CALENDAR',
  Communications = 'COMMUNICATIONS',
  Documentation = 'DOCUMENTATION',
  Documents = 'DOCUMENTS',
  Drives = 'DRIVES',
  Fees = 'FEES',
  Folders = 'FOLDERS',
  Forms = 'FORMS',
  GeneralAdmin = 'GENERAL_ADMIN',
  Groups = 'GROUPS',
  Notes = 'NOTES',
  Options = 'OPTIONS',
  People = 'PEOPLE',
  PrintingAndExporting = 'PRINTING_AND_EXPORTING',
  SchoolActivity = 'SCHOOL_ACTIVITY',
  Sds = 'SDS',
  Search = 'SEARCH',
  Settings = 'SETTINGS',
  StaffWorkManagement = 'STAFF_WORK_MANAGEMENT',
  StudentTimeline = 'STUDENT_TIMELINE',
  Substitution = 'SUBSTITUTION',
  Templating = 'TEMPLATING',
  Timetable = 'TIMETABLE',
  TimetableConstruction = 'TIMETABLE_CONSTRUCTION',
  Users = 'USERS',
  Wellbeing = 'WELLBEING'
}

export type Fee = {
  __typename?: 'Fee';
  absorbFees: Scalars['Boolean']['output'];
  academicNamespaceId: Scalars['Int']['output'];
  accountingCode?: Maybe<AccountingCode>;
  accountingCodeId?: Maybe<Scalars['Int']['output']>;
  allowPartialPayments: Scalars['Boolean']['output'];
  amount: Scalars['Float']['output'];
  /** deep linked */
  assignedToParties?: Maybe<Array<Party>>;
  assignedToPartyIds?: Maybe<Array<Scalars['Long']['output']>>;
  audCreatedByPartyId: Scalars['Long']['output'];
  categories?: Maybe<Array<Category>>;
  createdBy: Person;
  debtorIds?: Maybe<Array<Scalars['Int']['output']>>;
  debtors?: Maybe<Array<Debtor>>;
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<Discount>>;
  due: Scalars['Float']['output'];
  dueDate: Scalars['Date']['output'];
  excludedPartyIds: Array<Maybe<Scalars['Long']['output']>>;
  exclusions: Array<ExcludedPerson>;
  feeStatus: FeeStatus;
  feeType: FeeType;
  id?: Maybe<Scalars['Int']['output']>;
  individualDiscountIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** deep linked */
  individualDiscounts?: Maybe<Array<IndividualDiscount>>;
  installments?: Maybe<Array<FeeInstallment>>;
  name: Scalars['String']['output'];
  paid: Scalars['Float']['output'];
  paymentPlan: Scalars['Boolean']['output'];
  paymentPlanInterval?: Maybe<PaymentPlanInterval>;
  paymentPlanIntervalCount?: Maybe<Scalars['Long']['output']>;
  published: Scalars['Boolean']['output'];
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
  writtenOff: Scalars['Float']['output'];
};

export type FeeExclusion = {
  __typename?: 'FeeExclusion';
  success: Success;
  validations: Array<Scalars['String']['output']>;
};

export type FeeExclusionInput = {
  action: ExcludeAction;
  feeId: Scalars['Int']['input'];
  partyIds: Array<Scalars['Long']['input']>;
};

export type FeeExclusionsFilter = {
  feeIds: Array<Scalars['Int']['input']>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type FeeFilter = {
  assignedToPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeeIdStudent = {
  __typename?: 'FeeIdStudent';
  feeId: Scalars['Int']['output'];
  studentPartyId: Scalars['Long']['output'];
};

export type FeeInstallment = {
  __typename?: 'FeeInstallment';
  amount: Scalars['Float']['output'];
  feeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  installment: Scalars['Int']['output'];
  serviceChargePercentage: Scalars['Float']['output'];
  serviceCharges: Scalars['Float']['output'];
  stripePriceId: Scalars['String']['output'];
};

export type FeeInstallmentFilter = {
  feeIds: Array<Scalars['Int']['input']>;
};

export type FeeMigrationInput = {
  feeId: Scalars['Int']['input'];
};

export enum FeeStatus {
  Complete = 'COMPLETE',
  Outstanding = 'OUTSTANDING',
  Overdue = 'OVERDUE'
}

export enum FeeType {
  Mandatory = 'MANDATORY',
  Voluntary = 'VOLUNTARY'
}

export type FileMoveRequest = {
  destinationFeature: FileTransferFeature;
  id: Scalars['Long']['input'];
  sourceFeature: FileTransferFeature;
};

export enum FileTransferFeature {
  AenDoc = 'AEN_DOC',
  AssessmentTemplate = 'ASSESSMENT_TEMPLATE',
  BulkPersonalDrive = 'BULK_PERSONAL_DRIVE',
  BulkStudentDocs = 'BULK_STUDENT_DOCS',
  DocumentationImage = 'DOCUMENTATION_IMAGE',
  FolderFiles = 'FOLDER_FILES',
  MailAttachment = 'MAIL_ATTACHMENT',
  NoticeboardPhoto = 'NOTICEBOARD_PHOTO',
  ParentalAbsenceRequest = 'PARENTAL_ABSENCE_REQUEST',
  Riu = 'RIU',
  StaffAbsenceRequest = 'STAFF_ABSENCE_REQUEST',
  StaffDocs = 'STAFF_DOCS',
  StaffPhotos = 'STAFF_PHOTOS',
  StudentDocs = 'STUDENT_DOCS',
  StudentPhotos = 'STUDENT_PHOTOS',
  Temporary = 'TEMPORARY',
  TenantPhoto = 'TENANT_PHOTO'
}

export type FileTransferFilter = {
  download?: InputMaybe<Scalars['Boolean']['input']>;
  feature?: InputMaybe<FileTransferFeature>;
  id?: InputMaybe<Scalars['Long']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export enum FileTransferRiuType {
  Documentation = 'DOCUMENTATION',
  Mail = 'MAIL',
  Noticeboard = 'NOTICEBOARD',
  Templates = 'TEMPLATES'
}

export type FileTransferResponse = {
  __typename?: 'FileTransferResponse';
  contentType?: Maybe<Scalars['String']['output']>;
  feature: FileTransferFeature;
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  referenceId: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  uploader?: Maybe<Person>;
  uploaderPartyId?: Maybe<Scalars['Long']['output']>;
};

export type FilterOptions = {
  columnFilters?: InputMaybe<Array<InputMaybe<ColumnFilter>>>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

/** set either times OR recurrence OR atTimesOfEvents */
export type FindFreeResourcesFilter = {
  allRooms?: InputMaybe<Scalars['Boolean']['input']>;
  atTimesOfEvents?: InputMaybe<Array<CalendarEventIdInput>>;
  /** Optionally search for in particular calendars. If not specified, all calendars will be searched. */
  calendarIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  cancellationStatus?: InputMaybe<Calendar_CancellationStatusFilter>;
  /** excludes events based on whether a school day or not. Default value false */
  disableDayTypeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Check against recurrence rules whether the resources are free or not. Times is set OR recurrence is set. */
  recurrence?: InputMaybe<FindFreeResourcesRecurrence>;
  resources: CalendarResourceFilter;
  /** Check against these timeslots whether the resources are free or not. Times is set OR recurrence is set. */
  times?: InputMaybe<Array<InputMaybe<FindFreeResourcesTime>>>;
};

export type FindFreeResourcesRecurrence = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endTime: Scalars['Time']['input'];
  fromDate: Scalars['Date']['input'];
  occurrences?: InputMaybe<Scalars['Int']['input']>;
  recurrence: RecurrenceEnum;
  startTime: Scalars['Time']['input'];
};

export type FindFreeResourcesTime = {
  endTime: Scalars['Time']['input'];
  fromDate: Scalars['Date']['input'];
  startTime: Scalars['Time']['input'];
  toDate: Scalars['Date']['input'];
};

/**
 * Query input for the residual-access preview rendered before an admin
 * removes a party from a folder's ACL.
 */
export type Folders_AclRemovalPreviewFilter = {
  entityType: Pbac_EntityType;
  folderId: Scalars['Long']['input'];
  removingPartyId: Scalars['Long']['input'];
};

/**
 * A null folderId means the item lives at the root of the surface
 * (SchoolDrive/MyDrive root, etc).
 */
export type Folders_AddItemInput = {
  entityId: Scalars['String']['input'];
  entityType: Folders_ItemType;
  folderId?: InputMaybe<Scalars['Long']['input']>;
};

/** A null folderId creates the quick link at the root of the surface. */
export type Folders_AddQuickLinkInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['Long']['input']>;
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type Folders_ArchiveFolderInput = {
  id: Scalars['Long']['input'];
};

/**
 * Shared across all surfaces (SchoolDrive, MyDrive, and future module surfaces).
 * No namespace/context fields — the surface wrapper binds them server-side.
 */
export type Folders_CreateFolderInput = {
  colour?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['Long']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Used only by the primitive `folders_createFolder` mutation (admin/debug).
 * Adds namespace + optional context so folders can be created in any tree.
 */
export type Folders_CreatePrimitiveFolderInput = {
  colour?: InputMaybe<Scalars['String']['input']>;
  contextEntityId?: InputMaybe<Scalars['String']['input']>;
  contextEntityType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['Long']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type Folders_DeleteFolderInput = {
  id: Scalars['Long']['input'];
};

export type Folders_DeleteQuickLinkInput = {
  id: Scalars['Long']['input'];
};

export type Folders_DriveAclRemovalPreviewInput = {
  filter: Folders_AclRemovalPreviewFilter;
  surface: Folders_DriveSurface;
};

export type Folders_DriveAddItemInput = {
  input: Folders_AddItemInput;
  surface: Folders_DriveSurface;
};

export type Folders_DriveAddQuickLinkInput = {
  input: Folders_AddQuickLinkInput;
  surface: Folders_DriveSurface;
};

export type Folders_DriveArchiveFolderInput = {
  input: Folders_ArchiveFolderInput;
  surface: Folders_DriveSurface;
};

export type Folders_DriveCreateFolderInput = {
  input: Folders_CreateFolderInput;
  surface: Folders_DriveSurface;
};

export type Folders_DriveDeleteFolderInput = {
  input: Folders_DeleteFolderInput;
  surface: Folders_DriveSurface;
};

export type Folders_DriveDeleteQuickLinkInput = {
  input: Folders_DeleteQuickLinkInput;
  surface: Folders_DriveSurface;
};

export type Folders_DriveFolderAclInput = {
  folderId: Scalars['Long']['input'];
  surface: Folders_DriveSurface;
};

export type Folders_DriveFolderGrantsInput = {
  filter: Folders_FolderGrantsFilter;
  surface: Folders_DriveSurface;
};

export type Folders_DriveItemsInput = {
  filter: Folders_ItemsFilter;
  surface: Folders_DriveSurface;
};

export type Folders_DriveRemoveItemInput = {
  input: Folders_RemoveItemInput;
  surface: Folders_DriveSurface;
};

export type Folders_DriveRestoreFolderInput = {
  input: Folders_RestoreFolderInput;
  surface: Folders_DriveSurface;
};

export type Folders_DriveSetFolderTypeInput = {
  input: Folders_SetFolderTypeInput;
  surface: Folders_DriveSurface;
};

/**
 * Identifies a drive-family surface on a unified `drive_*` operation. The
 * server dispatches to the correct permission gate, namespace, and context
 * binding based on this value. Non-drive folder surfaces (reports,
 * support_plan) get their own operations rather than being squeezed onto
 * this enum.
 */
export enum Folders_DriveSurface {
  /**
   * Per-user drive (namespace = `mydrive`, context_entity_type = `party`,
   * context_entity_id = the caller's party id). Gated by `api:my_drive:*`
   * permissions plus an ownership override that lets users always manage
   * their own drive.
   */
  Personal = 'PERSONAL',
  /**
   * Shared school-wide drive (namespace = `schooldrive`, no context). Gated
   * by `api:school_drive:*` permissions.
   */
  School = 'SCHOOL',
  /**
   * Shared staff-only drive (namespace = `staffdrive`, no context). Gated
   * by `api:staff_drive:*` permissions AND a profile-type check — only
   * `TEACHER` and `ADMIN` profiles can access, even if a permission is
   * mis-granted to another profile type. Useful for staff-internal
   * content (policies, HR documents, committee files) that mustn't
   * surface to students / contacts.
   */
  Staff = 'STAFF'
}

export type Folders_DriveTreeInput = {
  filter: Folders_TreeFilter;
  surface: Folders_DriveSurface;
};

export type Folders_DriveUpdateFolderAclInput = {
  input: Folders_UpdateFolderAclInput;
  surface: Folders_DriveSurface;
};

export type Folders_DriveUpdateFolderInput = {
  input: Folders_UpdateFolderInput;
  surface: Folders_DriveSurface;
};

export type Folders_DriveUpdateQuickLinkInput = {
  input: Folders_UpdateQuickLinkInput;
  surface: Folders_DriveSurface;
};

/**
 * A folder is a node in a hierarchical tree. A tree is identified by `namespace`
 * plus optional `contextEntityType` + `contextEntityId`. Surfaces (SchoolDrive,
 * MyDrive, …) bind these columns; the raw primitive API exposes them directly.
 */
export type Folders_Folder = {
  __typename?: 'Folders_Folder';
  /**
   * Present only when `type` is `SHARED`. Null on `UI_ONLY` folders, even
   * if they carry stale ACL rows from a previous SHARED period — the UI
   * should treat null as "no access-control grants flow from this folder."
   */
  acl?: Maybe<Folders_FolderAcl>;
  children: Array<Folders_Folder>;
  colour?: Maybe<Scalars['String']['output']>;
  contextEntityId?: Maybe<Scalars['String']['output']>;
  contextEntityType?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Person>;
  createdByPartyId?: Maybe<Scalars['Long']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  itemCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  parentFolderId?: Maybe<Scalars['Long']['output']>;
  quickLinks: Array<Folders_FolderQuickLink>;
  sortOrder: Scalars['Int']['output'];
  status: Folders_Status;
  /**
   * Access-control mode. Defaults to `UI_ONLY`; a folder becomes `SHARED`
   * via `setFolderType` and gains an ACL.
   */
  type: Folders_FolderType;
};

/**
 * The list of parties (individuals or groups) that receive additive read
 * access to everything under a SHARED folder. The server resolves each
 * party's display name from the directory; the UI renders a list with
 * add/remove affordances.
 */
export type Folders_FolderAcl = {
  __typename?: 'Folders_FolderAcl';
  subjects: Array<Folders_FolderAclSubject>;
};

/**
 * One ACL entry. {@code partyId} can be an individual or a subject-group
 * (resolved via `pbac_staff_groups_view`); `isGroup` tells the UI which
 * icon to render.
 */
export type Folders_FolderAclSubject = {
  __typename?: 'Folders_FolderAclSubject';
  isGroup: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  partyId: Scalars['Long']['output'];
};

/**
 * A single path by which a user's access to an item derives from a folder ACL.
 * One item can have multiple paths when it sits inside more than one SHARED
 * ancestor, or when multiple SHARED ancestors are stacked above it.
 *
 * The UI uses these to render an "access via Smith case file" chip next to
 * items so admins can reason about how a user got here and what removing
 * them would cost.
 */
export type Folders_FolderGrantPath = {
  __typename?: 'Folders_FolderGrantPath';
  /** Id of the SHARED ancestor folder whose ACL grants the access. */
  ancestorFolderId: Scalars['Long']['output'];
  /** Display name of that ancestor folder. */
  ancestorFolderName: Scalars['String']['output'];
};

/**
 * One entity's grant-provenance entry. Returned in batches so the UI can
 * render chips for every visible row in a folder listing in one query.
 */
export type Folders_FolderGrantPathEntry = {
  __typename?: 'Folders_FolderGrantPathEntry';
  entityId: Scalars['String']['output'];
  entityType: Folders_ItemType;
  paths: Array<Folders_FolderGrantPath>;
};

/**
 * Query input for the grant-provenance ("access via X folder") chip.
 * Returns the current user's folder-derived grants for each requested item.
 */
export type Folders_FolderGrantsFilter = {
  entityIds: Array<Scalars['String']['input']>;
  entityType: Pbac_EntityType;
};

/**
 * A resolved view of an item placed in a folder — combines link metadata with
 * provider-resolved fields (title, previewUrl, creator). `available=false` when
 * the source entity has been deleted and the provider cannot resolve it.
 */
export type Folders_FolderItem = {
  __typename?: 'Folders_FolderItem';
  addedAt?: Maybe<Scalars['DateTime']['output']>;
  addedBy?: Maybe<Person>;
  addedByPartyId?: Maybe<Scalars['Long']['output']>;
  available: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Person>;
  createdByPartyId?: Maybe<Scalars['Long']['output']>;
  entityId: Scalars['String']['output'];
  entityType: Folders_ItemType;
  folderCount: Scalars['Int']['output'];
  /**
   * Per-item PBAC flags. Populated for items that carry a resource-level
   * policy in their source module (e.g. folder-docs with an explicit policy,
   * notes with a secured tag). Null for unsecured items. Surfaced so the UI
   * can render lock icons / 'secured' chips without a second lookup.
   */
  pbac?: Maybe<Pbac_ResourceResult>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * A placement of a source entity inside a folder. Same entity can appear in
 * multiple folders via multiple link rows.
 */
export type Folders_FolderItemLink = {
  __typename?: 'Folders_FolderItemLink';
  entityId: Scalars['String']['output'];
  entityType: Folders_ItemType;
  /**
   * Null when the item lives at the root of the surface rather than inside a
   * folder.
   */
  folderId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
};

/**
 * A quick link owned by the folders module — has a title and URL and lives
 * within a folder. No standalone bookmarks.
 */
export type Folders_FolderQuickLink = {
  __typename?: 'Folders_FolderQuickLink';
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Null when the quick link lives at the root of the surface rather than
   * inside a folder.
   */
  folderId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  isGlobal: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * Access-control mode of a folder.
 *
 * `UI_ONLY` (default): the folder is just a grouping — it has no ACL and
 * grants no access to the items it contains. Permissions live on the
 * entities as usual.
 *
 * `SHARED`: the folder carries an ACL (subjects on
 * `pbac_secured_entity` / `pbac_staff_party_policy` keyed by folder id).
 * ACL members receive *additive* read access to every descendant item.
 * Grants flow transitively through intermediate folders regardless of
 * their type.
 *
 * Access is always a union, never a mutation — folder ACLs only ever
 * grant. Entity-level denies still win. See
 * docs/features/folders/specs/folders.md.
 */
export enum Folders_FolderType {
  Shared = 'SHARED',
  UiOnly = 'UI_ONLY'
}

/**
 * The kind of entity a folder references. Registered providers resolve entityId
 * values of a matching entityType into human-readable metadata.
 */
export enum Folders_ItemType {
  File = 'FILE',
  Note = 'NOTE',
  QuickLink = 'QUICK_LINK'
}

/**
 * Shared across all surfaces' items query. Identifies a folder by id and
 * supports offset/limit pagination. A null folderId returns items that
 * sit at the root of the surface.
 */
export type Folders_ItemsFilter = {
  folderId?: InputMaybe<Scalars['Long']['input']>;
  pagination?: InputMaybe<Folders_Pagination>;
};

export type Folders_Pagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Used only by the primitive `folders_tree` query (admin/debug). Callers must
 * supply the namespace directly.
 */
export type Folders_PrimitiveTreeFilter = {
  contextEntityId?: InputMaybe<Scalars['String']['input']>;
  contextEntityType?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  namespace: Scalars['String']['input'];
};

/** A null folderId targets the item at the root of the surface. */
export type Folders_RemoveItemInput = {
  entityId: Scalars['String']['input'];
  entityType: Folders_ItemType;
  folderId?: InputMaybe<Scalars['Long']['input']>;
};

/**
 * Per-item result of a residual-access preview. Returned for every item
 * in the folder's subtree, regardless of whether the removal affects it.
 */
export type Folders_ResidualAccessItem = {
  __typename?: 'Folders_ResidualAccessItem';
  entityId: Scalars['String']['output'];
  entityType: Folders_ItemType;
  status: Folders_ResidualAccessStatus;
};

/**
 * Summary of what happens to a user's access when they're removed from a
 * specific folder's ACL. Used by the manage-access UI to surface
 * "Sarah will lose access to 14 of 17 items" before the admin confirms.
 *
 * `totalItemsInSubtree` counts items whose folder-membership would be
 * affected (items inside the folder or any descendant). `items` carries
 * the per-item breakdown so the UI can list which specific docs would
 * disappear.
 */
export type Folders_ResidualAccessPreview = {
  __typename?: 'Folders_ResidualAccessPreview';
  items: Array<Folders_ResidualAccessItem>;
  itemsLost: Scalars['Int']['output'];
  itemsRetained: Scalars['Int']['output'];
  totalItemsInSubtree: Scalars['Int']['output'];
};

/**
 * The residual-access state of a single item when a specific ACL subject
 * is (hypothetically) removed from a folder's ACL.
 *
 * Retained means the user would still see the item via another path
 * (direct PBAC, creator default, tag, another SHARED ancestor, or
 * default-open when the item carries no PBAC). Lost means the folder
 * ACL was the user's only grant path.
 */
export enum Folders_ResidualAccessStatus {
  Lost = 'LOST',
  Retained = 'RETAINED'
}

export type Folders_RestoreFolderInput = {
  id: Scalars['Long']['input'];
};

/**
 * Flip a folder between UI_ONLY and SHARED. Setting to UI_ONLY keeps the
 * ACL rows (they become dormant); setting to SHARED reactivates them.
 */
export type Folders_SetFolderTypeInput = {
  folderId: Scalars['Long']['input'];
  type: Folders_FolderType;
};

export enum Folders_Status {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

/**
 * Shared surface filter — reused by every surface's tree query. No namespace or
 * context fields; the surface wrapper binds them server-side.
 */
export type Folders_TreeFilter = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Add/remove parties (individuals or subject-groups) on a folder's ACL.
 * Empty arrays are legal.
 */
export type Folders_UpdateFolderAclInput = {
  addSubjectPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  folderId: Scalars['Long']['input'];
  removeSubjectPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Folders_UpdateFolderInput = {
  colour?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type Folders_UpdateQuickLinkInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FormAdmin_InformationRequestConfigMeta = {
  type: FormAdmin_InformationRequestConfigMetaType;
};

export enum FormAdmin_InformationRequestConfigMetaType {
  TtOnCallRequest = 'TT_ON_CALL_REQUEST'
}

export enum FormFd_SystemTag {
  SaPermissionSlip = 'SA_PERMISSION_SLIP',
  TtOnCallRequest = 'TT_ON_CALL_REQUEST'
}

export type FormRequestStatus = {
  __typename?: 'FormRequestStatus';
  id: Scalars['String']['output'];
  personPartyId: Scalars['Long']['output'];
  requestType: InfoRequestType;
  status: RequestStatus;
};

export type FormRequestStatusInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  personPartyId?: InputMaybe<Scalars['Long']['input']>;
  status?: InputMaybe<RequestStatus>;
  type?: InputMaybe<InfoRequestType>;
};

export enum FormType {
  InfoRequest = 'INFO_REQUEST',
  SingleSubmission = 'SINGLE_SUBMISSION'
}

export enum Form_FormFieldItemType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Datetime = 'DATETIME',
  FormConfirmation = 'FORM_CONFIRMATION',
  Input = 'INPUT',
  Inputnumber = 'INPUTNUMBER',
  Multiselect = 'MULTISELECT',
  Radio = 'RADIO',
  Select = 'SELECT',
  TableLink = 'TABLE_LINK',
  Textarea = 'TEXTAREA',
  Time = 'TIME',
  Variable = 'VARIABLE'
}

export type Form_FormResponseInfo = {
  __typename?: 'Form_FormResponseInfo';
  description?: Maybe<Scalars['String']['output']>;
  id: Forms_FormId;
  infoRequestInfo?: Maybe<Form_FormResponseInfoRequestInfo>;
  links: Array<DyRel_Entity>;
  singleSubmissionInfo?: Maybe<Form_FormResponseSingleSubmissionInfo>;
  tagIds: Array<Scalars['Int']['output']>;
  tags?: Maybe<Array<Dtab_Tag>>;
  title: Scalars['String']['output'];
  type: FormType;
  updatedBy: AuditPerson;
  updatedByPartyId: Scalars['Long']['output'];
  updatedByUserId: Scalars['Int']['output'];
  updatedOn: Scalars['DateTime']['output'];
};

export type Form_FormResponseInfoRequestInfo = {
  __typename?: 'Form_FormResponseInfoRequestInfo';
  currentlyVisibleForResponders: Scalars['Boolean']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  hide: Scalars['Boolean']['output'];
  id: FormsAdmin_InformationRequestDefinitionId;
  isConfirmable: Scalars['Boolean']['output'];
  metaConfig?: Maybe<FormAdmin_InformationRequestConfigMeta>;
  metaConfigType?: Maybe<FormAdmin_InformationRequestConfigMetaType>;
  publishDate?: Maybe<Scalars['DateTime']['output']>;
  responseCompleteCount: Scalars['Int']['output'];
  responseConfirmationCount: Scalars['Int']['output'];
  responseCount: Scalars['Int']['output'];
  responseExpected: Scalars['Int']['output'];
  responseRejectedCount: Scalars['Int']['output'];
};

export type Form_FormResponseSingleSubmissionInfo = {
  __typename?: 'Form_FormResponseSingleSubmissionInfo';
  confirmationStatus: Forms_ConfirmationStatus;
  status: RequestStatus;
  submissionCount: Scalars['Int']['output'];
};

export enum Form_SelectEntityType {
  Party = 'PARTY',
  PartyGroup = 'PARTY_GROUP',
  Staff = 'STAFF',
  String = 'STRING',
  Student = 'STUDENT',
  Subject = 'SUBJECT',
  SubjectGroup = 'SUBJECT_GROUP'
}

export type FormsAdminInformationRequestFilter = {
  ids: Array<FormsFd_DefinitionIdInput>;
};

export type FormsAdminTagsFilter = {
  ids: Array<InputMaybe<Scalars['Int']['input']>>;
  isSystemTag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormsAdmin_FormDefinitionViewFilter = {
  id: FormsFd_DefinitionIdInput;
};

export type FormsAdmin_FormDefinitionsFilter = {
  ids: Array<FormsFd_DefinitionIdInput>;
  isReusableTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** defaultValue false */
  loadVariableFieldsWithAllOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormsAdmin_InformationRequestDefinition = {
  __typename?: 'FormsAdmin_InformationRequestDefinition';
  currentlyVisibleForResponders: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  formId: FormsFd_DefinitionId;
  hide?: Maybe<Scalars['Boolean']['output']>;
  id: FormsAdmin_InformationRequestDefinitionId;
  /** who are you gathering information on */
  informationRequestType: Forms_InformationRequestResponderType;
  isConfirmable: Scalars['Boolean']['output'];
  links: Array<DyRel_Entity>;
  metaConfig?: Maybe<FormAdmin_InformationRequestConfigMeta>;
  metaConfigType?: Maybe<FormAdmin_InformationRequestConfigMetaType>;
  name: Scalars['String']['output'];
  publishDate?: Maybe<Scalars['DateTime']['output']>;
  requestAboutParties?: Maybe<Array<Person>>;
  requestAboutPartyIds?: Maybe<Array<Scalars['Long']['output']>>;
  responderStaffRoles: Array<StaffGroupMembershipRoles>;
  respondersFillOutIndividually: Scalars['Boolean']['output'];
  responseIds: Array<Maybe<Forms_FormId>>;
  stats: Forms_InformationRequestDefinitionStats;
  tags: Array<Dtab_Tag>;
  tagsIds: Array<Scalars['Int']['output']>;
};

export type FormsAdmin_InformationRequestDefinitionDeleteInput = {
  id: Scalars['Int']['input'];
  onlyDeleteSubmissionsForParties: Array<Scalars['Long']['input']>;
  provider: Scalars['String']['input'];
};

export type FormsAdmin_InformationRequestDefinitionId = {
  __typename?: 'FormsAdmin_InformationRequestDefinitionId';
  id?: Maybe<Scalars['Int']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
};

export type FormsAdmin_InformationRequestDefinitionIdInput = {
  id: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
};

export type FormsAdmin_InformationRequestFilter = {
  ids: Array<FormsAdmin_InformationRequestDefinitionIdInput>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FormsAdmin_InformationRequestTableFilter = {
  id: FormsAdmin_InformationRequestDefinitionIdInput;
};

export type FormsAdmin_UpdateInformationRequest = {
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FormsAdmin_InformationRequestDefinitionIdInput>;
};

export type FormsAdmin_UpsertInformationRequest = {
  /** input for CONTACTS_OF_STUDENTS type */
  contactsOfStudent?: InputMaybe<FormsAdmin_UpsertInformationRequest_ContactsOfStudent>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['DateTime']['input'];
  form: FormsAdmin_UpsertInformationRequestForDetails;
  /** default true. whereher to hide the info request, default false */
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FormsAdmin_InformationRequestDefinitionIdInput>;
  links?: InputMaybe<Array<DyRel_EntityInput>>;
  name: Scalars['String']['input'];
  /** when the form is available to be filled out */
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** what type of responder is the information request for */
  responderType: Forms_InformationRequestResponderType;
  /** input for TEACHERS_OF_STUDENTS type */
  staff?: InputMaybe<FormsAdmin_UpsertInformationRequest_Staff>;
  /** input for STUDENT type */
  student?: InputMaybe<FormsAdmin_UpsertInformationRequest_Student>;
  /** input for STAFF type */
  teachersOfStudent?: InputMaybe<FormsAdmin_UpsertInformationRequest_TeachersOfStudents>;
};

export type FormsAdmin_UpsertInformationRequestForDetails = {
  createForm?: InputMaybe<FormsFd_UpsertFormDefinition>;
  useFormId?: InputMaybe<FormsFd_DefinitionIdInput>;
};

export type FormsAdmin_UpsertInformationRequestUsingMetaConfig = {
  __typename?: 'FormsAdmin_UpsertInformationRequestUsingMetaConfig';
  /**
   * input should be of type FormAdmin_InformationRequestConfigMeta
   * interfaces are not allowed to be used in input in Graphql
   */
  config?: Maybe<FormAdmin_InformationRequestConfigMeta>;
  id?: Maybe<FormsAdmin_InformationRequestDefinitionId>;
};

export type FormsAdmin_UpsertInformationRequestUsingMetaConfigObj = {
  /**
   * input should be of type FormAdmin_InformationRequestConfigMeta
   * interfaces are not allowed to be used in input in Graphql
   * FormsAdmin_UpsertInformationRequestUsingMetaConfig is the object as an output graphql type
   */
  config?: InputMaybe<Scalars['Object']['input']>;
  id?: InputMaybe<FormsAdmin_InformationRequestDefinitionIdInput>;
};

export type FormsAdmin_UpsertInformationRequest_ContactsOfStudent = {
  requestAboutParties: Array<Scalars['Long']['input']>;
};

export type FormsAdmin_UpsertInformationRequest_Staff = {
  requestAboutParties: Array<Scalars['Long']['input']>;
};

export type FormsAdmin_UpsertInformationRequest_Student = {
  requestAboutParties: Array<Scalars['Long']['input']>;
};

export type FormsAdmin_UpsertInformationRequest_TeachersOfStudents = {
  requestAboutParties: Array<Scalars['Long']['input']>;
  responderStaffRoles: Array<Forms_InfoRequestStaffRole>;
};

export type FormsFd_DefinitionId = {
  __typename?: 'FormsFd_DefinitionId';
  id?: Maybe<Scalars['Int']['output']>;
  provider: Scalars['String']['output'];
};

export type FormsFd_DefinitionIdInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  provider: Scalars['String']['input'];
};

export type FormsFd_DisableFormDefinition = {
  disabled: Scalars['Boolean']['input'];
  ids: Array<FormsFd_DefinitionIdInput>;
};

export type FormsFd_FormDefinition = {
  __typename?: 'FormsFd_FormDefinition';
  allowPartialCompletion: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** form is no longer visible for new use */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  fields: Array<FormsFd_FormDefinitionFieldGroup>;
  id: FormsFd_DefinitionId;
  /** form is viewable as tempalte or is for one case only */
  isReusableTemplate?: Maybe<Scalars['Boolean']['output']>;
  pbac: Pbac_ResourceResult;
  tableSyncInfo: Array<FormsFd_FormDefinitionTableSyncInfo>;
  tags: Array<Dtab_Tag>;
  tagsIds: Array<Scalars['Int']['output']>;
  /** form is viewable as tempalte or is for one case only */
  tenantCanEdit: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
};

export type FormsFd_FormDefinitionField = {
  __typename?: 'FormsFd_FormDefinitionField';
  csvColumn?: Maybe<Scalars['String']['output']>;
  /** custom reference that can be used for lookup afterwards. */
  customRef?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['Int']['output'];
  id: FormsFd_FormDefinitionFieldId;
  isMandatoryOnFormDefinition?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  rowHeaderIndex?: Maybe<Scalars['Int']['output']>;
  selectInfo?: Maybe<FormsFd_FormDefinitionFieldSelect>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  type: Form_FormFieldItemType;
  variableFieldMeta?: Maybe<FormsFd_VariableField>;
};

export type FormsFd_FormDefinitionFieldGroup = {
  __typename?: 'FormsFd_FormDefinitionFieldGroup';
  fields: Array<FormsFd_FormDefinitionField>;
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type FormsFd_FormDefinitionFieldId = {
  __typename?: 'FormsFd_FormDefinitionFieldId';
  fieldId: Scalars['String']['output'];
  formId: Scalars['Int']['output'];
};

export type FormsFd_FormDefinitionFieldSelect = {
  __typename?: 'FormsFd_FormDefinitionFieldSelect';
  options?: Maybe<Array<FormsFd_FormDefinitionFieldSelectOptions>>;
};

export type FormsFd_FormDefinitionFieldSelectOptions = {
  __typename?: 'FormsFd_FormDefinitionFieldSelectOptions';
  id?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type FormsFd_FormDefinitionTableSyncInfo = {
  __typename?: 'FormsFd_FormDefinitionTableSyncInfo';
  tableId: Scalars['Int']['output'];
};

export type FormsFd_SetAsDynamicTableSynced = {
  /** default value true */
  autoAddFormFieldsAsColumns?: InputMaybe<Scalars['Boolean']['input']>;
  formId: FormsFd_DefinitionIdInput;
  tableInfo: Dtab_CreateTable;
};

export type FormsFd_UpsertFormDefinition = {
  /** gridWidth: FormsFd_FormFieldGridWidth! */
  allowPartialCompletion: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /** form is no longer visible for new use */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  fields: Array<FormsFd_UpsertFormDefinitionFieldGroup>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** form is viewable as tempalte or is for one case only */
  isReusableTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds: Array<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type FormsFd_UpsertFormDefinitionField = {
  /** custom reference tha can be used for lookup afterwards. */
  customRef?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  fieldGroupIdx?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<FormsFd_UpsertFormDefinitionFieldId>;
  isMandatoryOnFormDefinition?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  selectInfo?: InputMaybe<FormsFd_UpsertFormDefinitionFieldSelect>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  type: Form_FormFieldItemType;
  /** FormsFd_VariableField */
  variableFieldMeta?: InputMaybe<Scalars['Object']['input']>;
};

export type FormsFd_UpsertFormDefinitionFieldGroup = {
  fields: Array<FormsFd_UpsertFormDefinitionField>;
  header?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type FormsFd_UpsertFormDefinitionFieldId = {
  fieldId: Scalars['String']['input'];
  formId?: InputMaybe<Scalars['Int']['input']>;
};

export type FormsFd_UpsertFormDefinitionFieldSelect = {
  options?: InputMaybe<Array<FormsFd_UpsertFormDefinitionFieldSelectOptions>>;
};

export type FormsFd_UpsertFormDefinitionFieldSelectOptions = {
  id?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type FormsFd_VariableField = {
  type?: Maybe<FormsFd_VariableFieldType>;
};

export enum FormsFd_VariableFieldType {
  MyFreeTtPeriods = 'MyFreeTtPeriods',
  RandomNumber = 'RandomNumber'
}

export type FormsFd_VariableField_MyFreeTtPeriods = FormsFd_VariableField & {
  __typename?: 'FormsFd_VariableField_MyFreeTTPeriods';
  timetableId: Scalars['Int']['output'];
  type?: Maybe<FormsFd_VariableFieldType>;
};

export type FormsFd_VariableField_RandomNumber = FormsFd_VariableField & {
  __typename?: 'FormsFd_VariableField_RandomNumber';
  type?: Maybe<FormsFd_VariableFieldType>;
};

export enum Forms_ConfirmationStatus {
  Confirm = 'CONFIRM',
  NotApplicable = 'NOT_APPLICABLE',
  NotSubmitted = 'NOT_SUBMITTED',
  Reject = 'REJECT'
}

export type Forms_FormField = Forms_FormFieldItem | Forms_FormFieldSubGroup;

export type Forms_FormFieldGridWidth = {
  __typename?: 'Forms_FormFieldGridWidth';
  lg?: Maybe<Scalars['Int']['output']>;
  md?: Maybe<Scalars['Int']['output']>;
  sm?: Maybe<Scalars['Int']['output']>;
  xl?: Maybe<Scalars['Int']['output']>;
  xs?: Maybe<Scalars['Int']['output']>;
};

export type Forms_FormFieldGroup = {
  __typename?: 'Forms_FormFieldGroup';
  fields: Array<Forms_FormField>;
  header: Scalars['String']['output'];
};

export type Forms_FormFieldItem = {
  __typename?: 'Forms_FormFieldItem';
  /** custom reference tha can be used for lookup afterwards. */
  customRef?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  fieldGroupIdx: Scalars['Int']['output'];
  formFieldType: Forms_FormFieldType;
  gridWidth: Forms_FormFieldGridWidth;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<Forms_FormFieldSelectOptions>;
  optionsType?: Maybe<Form_SelectEntityType>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: Form_FormFieldItemType;
  variableFieldMeta?: Maybe<FormsFd_VariableField>;
};

export type Forms_FormFieldSelectOptions = {
  __typename?: 'Forms_FormFieldSelectOptions';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Forms_FormFieldSubGroup = {
  __typename?: 'Forms_FormFieldSubGroup';
  fields: Array<Forms_FormFieldItem>;
  formFieldType: Forms_FormFieldType;
  gridWidth: Forms_FormFieldGridWidth;
  header: Scalars['String']['output'];
};

export enum Forms_FormFieldType {
  Item = 'ITEM',
  Subgroup = 'SUBGROUP'
}

export type Forms_FormId = {
  __typename?: 'Forms_FormId';
  /** todo refactor to submission id. The is the id its submitted under */
  forPartyId?: Maybe<Scalars['String']['output']>;
  /** todo refactor to provider id. This will be the form id */
  objectId?: Maybe<Scalars['Long']['output']>;
  provider: Scalars['String']['output'];
};

export type Forms_FormIdInput = {
  forPartyId?: InputMaybe<Scalars['String']['input']>;
  /** depricated */
  name?: InputMaybe<Scalars['String']['input']>;
  objectId: Scalars['Long']['input'];
  optionalResponderId?: InputMaybe<Scalars['Long']['input']>;
  provider: Scalars['String']['input'];
};

/** rename to Forms_InformationRequestListing */
export type Forms_FormListing = {
  __typename?: 'Forms_FormListing';
  completionDate?: Maybe<Scalars['DateTime']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  forPartyId: Scalars['Long']['output'];
  forPerson: Person;
  id: Forms_FormId;
  isComplete?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  status: RequestStatus;
};

export type Forms_FormView = {
  __typename?: 'Forms_FormView';
  allowPartialCompletion: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  fields: Array<Forms_FormFieldGroup>;
  gridWidth: Forms_FormFieldGridWidth;
  id: Forms_FormId;
  readOnly: Scalars['Boolean']['output'];
  status: RequestStatus;
  title?: Maybe<Scalars['String']['output']>;
};

export enum Forms_InfoRequestStaffRole {
  Teacher = 'TEACHER',
  Tutor = 'TUTOR',
  Yearhead = 'YEARHEAD'
}

export type Forms_InformationRequestDefinitionStats = {
  __typename?: 'Forms_InformationRequestDefinitionStats';
  responseCompleteCount: Scalars['Int']['output'];
  responseConfirmationCount: Scalars['Int']['output'];
  responseCount: Scalars['Int']['output'];
  responseExpected: Scalars['Int']['output'];
  responseRejectedCount: Scalars['Int']['output'];
};

export type Forms_InformationRequestListFormFilter = {
  /** ids of the people which information is requestedFrom */
  targetPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export enum Forms_InformationRequestResponderType {
  ContactsOfStudents = 'CONTACTS_OF_STUDENTS',
  Staff = 'STAFF',
  Students = 'STUDENTS',
  TeachersOfStudents = 'TEACHERS_OF_STUDENTS'
}

export type Forms_InformationRequestResponseTable = {
  __typename?: 'Forms_InformationRequestResponseTable';
  form: FormsFd_FormDefinition;
  headers: Array<Forms_InformationRequestResponseTableHeader>;
  id: FormsAdmin_InformationRequestDefinitionId;
  informationRequest: FormsAdmin_InformationRequestDefinition;
  rows: Array<Forms_InformationRequestResponseTableRow>;
};

export type Forms_InformationRequestResponseTableColumn = {
  __typename?: 'Forms_InformationRequestResponseTableColumn';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Forms_InformationRequestResponseTableHeader = {
  __typename?: 'Forms_InformationRequestResponseTableHeader';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: Form_FormFieldItemType;
};

export type Forms_InformationRequestResponseTableRow = {
  __typename?: 'Forms_InformationRequestResponseTableRow';
  aboutParty: Person;
  aboutPartyId: Scalars['Long']['output'];
  columns: Array<Forms_InformationRequestResponseTableColumn>;
  completionStatus: RequestStatus;
  confirmationStatus: Forms_ConfirmationStatus;
  responderParty?: Maybe<Person>;
  responderPartyId?: Maybe<Scalars['Long']['output']>;
};

export type Forms_InformationRequestViewFormFilter = {
  id: Forms_FormIdInput;
};

export type Forms_SearchSubmissionFilter = {
  ids?: InputMaybe<Array<Forms_FormIdInput>>;
  includesSystemTags?: InputMaybe<Array<FormFd_SystemTag>>;
  links?: InputMaybe<Array<DyRel_RelationFilter>>;
};

export type Forms_StatusFilter = {
  id?: InputMaybe<Scalars['String']['input']>;
  personPartyId?: InputMaybe<Scalars['Long']['input']>;
  requestType?: InputMaybe<InfoRequestType>;
};

export type Forms_SubmitFormFieldInput = {
  fieldId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Object']['input']>;
};

export type Forms_SubmitFormFieldInputs = {
  rows: Array<Dtab_UpsertRow>;
  tableId?: InputMaybe<FormsFd_DefinitionIdInput>;
  tyroDefinedTableId?: InputMaybe<Scalars['String']['input']>;
  validationMethod?: InputMaybe<Dtab_UpsertRowValidationType>;
};

export type Forms_SubmitFormInput = {
  about?: InputMaybe<DyRel_EntityInput>;
  fields: Array<Forms_SubmitFormFieldInput>;
  formId: Forms_FormIdInput;
  validateOnly: Scalars['Boolean']['input'];
};

export type Forms_SubmitFormResponse = {
  __typename?: 'Forms_SubmitFormResponse';
  globalId: Scalars['Int']['output'];
  id: Forms_FormId;
  status?: Maybe<Forms_SubmitFormResponseStatus>;
  success: Scalars['Boolean']['output'];
  validations?: Maybe<Forms_SubmitFormValidationError>;
};

export type Forms_SubmitFormResponseStatus = {
  __typename?: 'Forms_SubmitFormResponseStatus';
  completionStatus: RequestStatus;
  confirmationStatus: Forms_ConfirmationStatus;
};

export type Forms_SubmitFormValidationError = {
  __typename?: 'Forms_SubmitFormValidationError';
  fieldErrors?: Maybe<Scalars['Object']['output']>;
  globalErrors: Array<Scalars['String']['output']>;
};

export type Forms_UpsertRowResponse = {
  __typename?: 'Forms_UpsertRowResponse';
  rowIdentifier: Forms_UpsertRowsId;
  success: Scalars['Boolean']['output'];
  topLevelErrors: Array<Scalars['String']['output']>;
};

export type Forms_UpsertRowsId = {
  __typename?: 'Forms_UpsertRowsId';
  rowId?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
};

export type Forms_UpsertRowsResponse = {
  __typename?: 'Forms_UpsertRowsResponse';
  rowDetails: Array<Forms_UpsertRowResponse>;
  success: Forms_UpsertRowsSuccess;
};

export enum Forms_UpsertRowsSuccess {
  All = 'ALL',
  None = 'NONE',
  Partial = 'PARTIAL'
}

export type Forms_ViewSubmissionFilter = {
  id: Forms_FormIdInput;
};

export type FreeCalendarResources = {
  __typename?: 'FreeCalendarResources';
  clashingParties: Array<ClashingParty>;
  clashingRooms: Array<ClashingRooms>;
  freeParties: Array<Party>;
  freePartyIds: Array<Scalars['Long']['output']>;
  freeRoomIds: Array<Scalars['Int']['output']>;
  freeRooms: Array<Room>;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GeneralGroup = Party & PartyGroup & {
  __typename?: 'GeneralGroup';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  blocks: Array<CoreBlock>;
  classGroupInfo?: Maybe<ClassGroupInfo>;
  code?: Maybe<Scalars['String']['output']>;
  /** deep linked */
  contactMembers?: Maybe<Group>;
  /** deep linked */
  contacts: Array<Person>;
  generalGroupType: GeneralGroupType;
  groupTagIds: Array<Scalars['Int']['output']>;
  groupTags: Array<GroupTag>;
  includeInTimetable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  partyId: Scalars['Long']['output'];
  programmeStages: Array<ProgrammeStage>;
  /** deep linked */
  relatedSubjectGroups: Array<SubjectGroup>;
  source?: Maybe<Core_PartySource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  /** deep linked */
  staff: Array<Person>;
  /** deep linked */
  staffMembers?: Maybe<Group>;
  /** deep linked */
  studentMembers?: Maybe<Group>;
  /** deep linked */
  students: Array<Student>;
  /** deep linked */
  tutors: Array<Person>;
  /** deep linked */
  yearGroupLeads: Array<Person>;
  /** deep linked */
  yearGroups: Array<YearGroupEnrollment>;
};

export type GeneralGroupFilter = {
  excludeSources?: InputMaybe<Array<Core_PartySource>>;
  excludeTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  groupTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  groupTypes?: InputMaybe<Array<InputMaybe<GeneralGroupType>>>;
  isIncludeInTimetabling?: InputMaybe<Scalars['Boolean']['input']>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export enum GeneralGroupType {
  ClassGroup = 'CLASS_GROUP',
  CustomGroup = 'CUSTOM_GROUP',
  DynamicGroup = 'DYNAMIC_GROUP',
  GeneralGroup = 'GENERAL_GROUP',
  StaticGroup = 'STATIC_GROUP'
}

export type GlobalUser = {
  __typename?: 'GlobalUser';
  activeProfileId?: Maybe<Scalars['Int']['output']>;
  defaultProfileId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emulatedGlobalUserId?: Maybe<Scalars['Int']['output']>;
  /** Integer id, String email, String name, Integer defaultProfileId, List<Profile> profiles */
  id: Scalars['Int']['output'];
  isEmulatingAsTyroUser?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profiles: Array<Profile>;
};

export type GlobalUserFilter = {
  userIds: Array<Scalars['Int']['input']>;
};

export type Grade = {
  __typename?: 'Grade';
  active: Scalars['Boolean']['output'];
  end: Scalars['Int']['output'];
  externalSystemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
  passFailThreshold?: Maybe<Scalars['Int']['output']>;
  start: Scalars['Int']['output'];
  studyLevels?: Maybe<Array<Maybe<GradeSetStudyLevel>>>;
};

export type GradeFilter = {
  gradeSetId?: InputMaybe<Scalars['Long']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  programmeShortName?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['Int']['input']>;
  studyLevel?: InputMaybe<StudyLevel>;
};

export type GradeSet = {
  __typename?: 'GradeSet';
  active: Scalars['Boolean']['output'];
  customGradeSet: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  externalSystemId?: Maybe<Scalars['String']['output']>;
  grades?: Maybe<Array<Grade>>;
  id: Scalars['Long']['output'];
  isCba: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
  passFailThreshold?: Maybe<Scalars['Int']['output']>;
  type: Assessment_GradeSetType;
  years?: Maybe<Array<Scalars['Int']['output']>>;
};

export type GradeSetFilter = {
  ids: Array<Scalars['Long']['input']>;
};

export enum GradeSetStudyLevel {
  Common = 'COMMON',
  Foundation = 'FOUNDATION',
  Higher = 'HIGHER',
  NotApplicable = 'NOT_APPLICABLE',
  Ordinary = 'ORDINARY'
}

export enum GradeType {
  Both = 'BOTH',
  GradeSet = 'GRADE_SET',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

export type Group = {
  __typename?: 'Group';
  groupPartyId: Scalars['Long']['output'];
  memberCount: Scalars['Int']['output'];
  memberIds: Array<Scalars['Long']['output']>;
  /** deep linked */
  members: Array<GroupMembership>;
};

export type GroupMembership = {
  __typename?: 'GroupMembership';
  fromDate?: Maybe<Scalars['Date']['output']>;
  partyId: Scalars['Long']['output'];
  /** deep linked */
  person?: Maybe<Person>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  toDate?: Maybe<Scalars['Date']['output']>;
};

export type GroupProgrammeStage = {
  __typename?: 'GroupProgrammeStage';
  programmeId?: Maybe<Scalars['Int']['output']>;
  programmeStage?: Maybe<ProgrammeStage>;
  programmeStageId?: Maybe<Scalars['Int']['output']>;
};

export type GroupTag = {
  __typename?: 'GroupTag';
  colour: Colour;
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  /**
   * True when the linked programme (refId for PROGRAMME tags) or programme stage
   * (refId for PROGRAMME_STAGE tags) is discontinued for the current school in the
   * current academic namespace. False for tag types that don't track discontinuation.
   */
  discontinued: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
  refId?: Maybe<Scalars['String']['output']>;
  systemTag: Scalars['Boolean']['output'];
  type?: Maybe<GroupTagType>;
  uniqueName?: Maybe<Scalars['String']['output']>;
};

export enum GroupTagType {
  AdmissionsGrouping = 'ADMISSIONS_GROUPING',
  Duty = 'DUTY',
  HouseGrouping = 'HOUSE_GROUPING',
  Meeting = 'MEETING',
  MeetingGrouping = 'MEETING_GROUPING',
  Misc = 'MISC',
  OnCall = 'ON_CALL',
  Programme = 'PROGRAMME',
  ProgrammeStage = 'PROGRAMME_STAGE',
  SchoolActivity = 'SCHOOL_ACTIVITY',
  Support = 'SUPPORT',
  SupportGrouping = 'SUPPORT_GROUPING',
  YearGroup = 'YEAR_GROUP'
}

export enum HighlightStatus {
  Pending = 'PENDING',
  Resolved = 'RESOLVED',
  Reviewing = 'REVIEWING'
}

export type ImportCanonical_AcademicYear = {
  __typename?: 'ImportCanonical_AcademicYear';
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ImportCanonical_AcademicYearPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_AcademicYearPage';
  data: Array<ImportCanonical_AcademicYear>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_Assessment = {
  __typename?: 'ImportCanonical_Assessment';
  academicYear?: Maybe<Scalars['Int']['output']>;
  academicYearId?: Maybe<Scalars['Int']['output']>;
  assessmentCommentBankId?: Maybe<Scalars['Int']['output']>;
  assessmentCommentType?: Maybe<Scalars['String']['output']>;
  assessmentGradeSetIds?: Maybe<Scalars['JSON']['output']>;
  assessmentType?: Maybe<Scalars['String']['output']>;
  assessmentYears?: Maybe<Scalars['JSON']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  captureGrade?: Maybe<Scalars['Boolean']['output']>;
  captureHouseMasterComment?: Maybe<Scalars['Boolean']['output']>;
  capturePrincipalComment?: Maybe<Scalars['Boolean']['output']>;
  captureTarget?: Maybe<Scalars['Boolean']['output']>;
  captureTutorComment?: Maybe<Scalars['Boolean']['output']>;
  captureYearHeadComment?: Maybe<Scalars['Boolean']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  gradeType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  maxCommentLength?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  passFailThreshold?: Maybe<Scalars['Int']['output']>;
  publish?: Maybe<Scalars['Boolean']['output']>;
  publishLearner?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type ImportCanonical_AssessmentExtraField = {
  __typename?: 'ImportCanonical_AssessmentExtraField';
  assessmentId?: Maybe<Scalars['Long']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  capture?: Maybe<Scalars['Boolean']['output']>;
  commentBankId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gradeSetId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  options?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ImportCanonical_ExtraFieldType>;
};

export type ImportCanonical_AssessmentExtraFieldPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_AssessmentExtraFieldPage';
  data: Array<ImportCanonical_AssessmentExtraField>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_AssessmentPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_AssessmentPage';
  data: Array<ImportCanonical_Assessment>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_AssessmentResult = {
  __typename?: 'ImportCanonical_AssessmentResult';
  absent?: Maybe<Scalars['Boolean']['output']>;
  actualGradeId?: Maybe<Scalars['Int']['output']>;
  actualResult?: Maybe<Scalars['Int']['output']>;
  assessmentId?: Maybe<Scalars['Long']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['Long']['output']>;
  commenterId?: Maybe<Scalars['Long']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  learnerDeptId?: Maybe<Scalars['Long']['output']>;
  learnerId?: Maybe<Scalars['Long']['output']>;
  learnerUserInfoId?: Maybe<Scalars['Long']['output']>;
  studyLevel?: Maybe<Scalars['String']['output']>;
  targetGradeId?: Maybe<Scalars['Int']['output']>;
  targetResult?: Maybe<Scalars['Int']['output']>;
  teacherComment?: Maybe<Scalars['String']['output']>;
  teachingGroupId?: Maybe<Scalars['Long']['output']>;
};

export type ImportCanonical_AssessmentResultExtraField = {
  __typename?: 'ImportCanonical_AssessmentResultExtraField';
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  commentBankCommentId?: Maybe<Scalars['Int']['output']>;
  extrafieldid?: Maybe<Scalars['Long']['output']>;
  extrafieldname?: Maybe<Scalars['String']['output']>;
  gradeSetGradeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  resultId?: Maybe<Scalars['Long']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_AssessmentResultExtraFieldPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_AssessmentResultExtraFieldPage';
  data: Array<ImportCanonical_AssessmentResultExtraField>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_AssessmentResultPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_AssessmentResultPage';
  data: Array<ImportCanonical_AssessmentResult>;
  totalCount: Scalars['Int']['output'];
};

export enum ImportCanonical_AssessmentTopLevelCommentType {
  Principal = 'PRINCIPAL',
  Tutor = 'TUTOR',
  YeahHead = 'YEAH_HEAD'
}

export type ImportCanonical_AssessmentTopLevelComments = {
  __typename?: 'ImportCanonical_AssessmentTopLevelComments';
  assessmentId?: Maybe<Scalars['Long']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commenterId?: Maybe<Scalars['Long']['output']>;
  learnerId?: Maybe<Scalars['Long']['output']>;
  type?: Maybe<ImportCanonical_AssessmentTopLevelCommentType>;
};

export type ImportCanonical_AssessmentTopLevelCommentsPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_AssessmentTopLevelCommentsPage';
  data: Array<ImportCanonical_AssessmentTopLevelComments>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_AttendanceCode = {
  __typename?: 'ImportCanonical_AttendanceCode';
  active?: Maybe<Scalars['Boolean']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  lessonCodeType?: Maybe<ImportCanonical_AttendanceCodeType>;
  sessionCodeType?: Maybe<ImportCanonical_AttendanceCodeType>;
  tuslaCode?: Maybe<Scalars['String']['output']>;
  visibleForContact?: Maybe<Scalars['Boolean']['output']>;
  visibleForTeacher?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportCanonical_AttendanceCodePage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_AttendanceCodePage';
  data: Array<ImportCanonical_AttendanceCode>;
  totalCount: Scalars['Int']['output'];
};

export enum ImportCanonical_AttendanceCodeType {
  ExplainedAbsence = 'EXPLAINED_ABSENCE',
  Late = 'LATE',
  NotTaken = 'NOT_TAKEN',
  Present = 'PRESENT',
  UnexplainedAbsence = 'UNEXPLAINED_ABSENCE'
}

export type ImportCanonical_Behaviour = {
  __typename?: 'ImportCanonical_Behaviour';
  actionTakenNotes?: Maybe<Scalars['String']['output']>;
  behaviourDescription?: Maybe<Scalars['String']['output']>;
  behaviourId?: Maybe<Scalars['String']['output']>;
  behaviourName?: Maybe<Scalars['String']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  creatorname?: Maybe<Scalars['String']['output']>;
  incidentDate?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  positiveOrNegative?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  teachingGroupId?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_BehaviourPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_BehaviourPage';
  data: Array<ImportCanonical_Behaviour>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_BlockClassGroupLink = {
  __typename?: 'ImportCanonical_BlockClassGroupLink';
  academicYear?: Maybe<Scalars['Int']['output']>;
  blockId?: Maybe<Scalars['String']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  classGroupId?: Maybe<Scalars['String']['output']>;
  classGroupName?: Maybe<Scalars['String']['output']>;
  subjectGroupNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type ImportCanonical_BlockClassGroupLinkPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_BlockClassGroupLinkPage';
  data: Array<ImportCanonical_BlockClassGroupLink>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_BlockSubjectGroup = {
  __typename?: 'ImportCanonical_BlockSubjectGroup';
  academicYear?: Maybe<Scalars['Int']['output']>;
  blockId?: Maybe<Scalars['String']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  subjectGroupId?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_BlockSubjectGroupPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_BlockSubjectGroupPage';
  data: Array<ImportCanonical_BlockSubjectGroup>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_Calendar = {
  __typename?: 'ImportCanonical_Calendar';
  academicYear?: Maybe<Scalars['Int']['output']>;
  amBellTime?: Maybe<Scalars['Time']['output']>;
  attendanceRequired?: Maybe<Scalars['Boolean']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  isSchoolDay?: Maybe<Scalars['Boolean']['output']>;
  noSchoolReason?: Maybe<Scalars['String']['output']>;
  pmBellTime?: Maybe<Scalars['Time']['output']>;
  statutoryAttendanceRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportCanonical_CalendarPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_CalendarPage';
  data: Array<ImportCanonical_Calendar>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_CanonicalImportMeta = {
  __typename?: 'ImportCanonical_CanonicalImportMeta';
  created?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  importType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ImportCanonical_CanonicalImportStatus>;
  stepCompleted?: Maybe<Scalars['BigDecimal']['output']>;
  tenant?: Maybe<Scalars['Int']['output']>;
  updatingUser?: Maybe<Scalars['Int']['output']>;
};

export type ImportCanonical_CanonicalImportMetaPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_CanonicalImportMetaPage';
  data: Array<ImportCanonical_CanonicalImportMeta>;
  totalCount: Scalars['Int']['output'];
};

export enum ImportCanonical_CanonicalImportStatus {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export type ImportCanonical_ClassGroupMembers = {
  __typename?: 'ImportCanonical_ClassGroupMembers';
  academicYear?: Maybe<Scalars['Int']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  classGroupId?: Maybe<Scalars['String']['output']>;
  className?: Maybe<Scalars['String']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_ClassGroupMembersPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_ClassGroupMembersPage';
  data: Array<ImportCanonical_ClassGroupMembers>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_ClassGroupStaff = {
  __typename?: 'ImportCanonical_ClassGroupStaff';
  academicYear?: Maybe<Scalars['Int']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  classGroupId?: Maybe<Scalars['String']['output']>;
  className?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  staffFullName?: Maybe<Scalars['String']['output']>;
  staffId?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_ClassGroupStaffPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_ClassGroupStaffPage';
  data: Array<ImportCanonical_ClassGroupStaff>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_ClassGroups = {
  __typename?: 'ImportCanonical_ClassGroups';
  academicYear?: Maybe<Scalars['Int']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  classGroupId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  programmeStage?: Maybe<Scalars['Int']['output']>;
  yearGroup?: Maybe<Scalars['Int']['output']>;
};

export type ImportCanonical_ClassGroupsPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_ClassGroupsPage';
  data: Array<ImportCanonical_ClassGroups>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_CommentBank = {
  __typename?: 'ImportCanonical_CommentBank';
  active?: Maybe<Scalars['Boolean']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inUse?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_CommentBankPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_CommentBankPage';
  data: Array<ImportCanonical_CommentBank>;
  totalCount: Scalars['Int']['output'];
};

export enum ImportCanonical_ExtraFieldType {
  CommentBank = 'COMMENT_BANK',
  GradeSet = 'GRADE_SET',
  Select = 'SELECT',
  Text = 'TEXT'
}

export type ImportCanonical_Filter = {
  importId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<FilterOptions>;
};

export type ImportCanonical_GlobalUserExternalSystemRel = {
  __typename?: 'ImportCanonical_GlobalUserExternalSystemRel';
  externalSystemEntityType?: Maybe<Scalars['String']['output']>;
  externalSystemId?: Maybe<Scalars['String']['output']>;
  globalUserId?: Maybe<Scalars['Int']['output']>;
  oldPartyId?: Maybe<Scalars['Long']['output']>;
  tenant?: Maybe<Scalars['Int']['output']>;
};

export type ImportCanonical_GlobalUserExternalSystemRelPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_GlobalUserExternalSystemRelPage';
  data: Array<ImportCanonical_GlobalUserExternalSystemRel>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_GradeSet = {
  __typename?: 'ImportCanonical_GradeSet';
  active?: Maybe<Scalars['Boolean']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  grades?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCba?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  passFailThreshold?: Maybe<Scalars['Int']['output']>;
};

export type ImportCanonical_GradeSetPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_GradeSetPage';
  data: Array<ImportCanonical_GradeSet>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_ImportErrorLog = {
  __typename?: 'ImportCanonical_ImportErrorLog';
  canonicalImportMetaId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityType: Scalars['String']['output'];
  errorType: ImportCanonical_ImportErrorType;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  stackTrace?: Maybe<Scalars['String']['output']>;
  step: Scalars['String']['output'];
  tenantId: Scalars['Int']['output'];
};

export type ImportCanonical_ImportErrorLogFilter = {
  canonicalImportMetaId: Scalars['String']['input'];
};

export type ImportCanonical_ImportErrorLogPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_ImportErrorLogPage';
  data: Array<ImportCanonical_ImportErrorLog>;
  totalCount: Scalars['Int']['output'];
};

export enum ImportCanonical_ImportErrorType {
  Exception = 'EXCEPTION',
  Skipped = 'SKIPPED'
}

export type ImportCanonical_MedicalCondition = {
  __typename?: 'ImportCanonical_MedicalCondition';
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  creatorname?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_MedicalConditionPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_MedicalConditionPage';
  data: Array<ImportCanonical_MedicalCondition>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_MedicalContact = {
  __typename?: 'ImportCanonical_MedicalContact';
  address?: Maybe<Scalars['String']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_MedicalContactPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_MedicalContactPage';
  data: Array<ImportCanonical_MedicalContact>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_Notes = {
  __typename?: 'ImportCanonical_Notes';
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  lastEditedByName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  teachingGroupId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_NotesPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_NotesPage';
  data: Array<ImportCanonical_Notes>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_PageResponse = {
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_PermissionGroupMembershipExternalSystemRel = {
  __typename?: 'ImportCanonical_PermissionGroupMembershipExternalSystemRel';
  externalSystemEntityType?: Maybe<Scalars['String']['output']>;
  externalSystemId?: Maybe<Scalars['String']['output']>;
  globalUserId?: Maybe<Scalars['Int']['output']>;
  oldPartyId?: Maybe<Scalars['Long']['output']>;
  permissionGroupId?: Maybe<Scalars['Int']['output']>;
  tenant?: Maybe<Scalars['Int']['output']>;
};

export type ImportCanonical_PermissionGroupMembershipExternalSystemRelPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_PermissionGroupMembershipExternalSystemRelPage';
  data: Array<ImportCanonical_PermissionGroupMembershipExternalSystemRel>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_Room = {
  __typename?: 'ImportCanonical_Room';
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includeInTimetable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pool?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_RoomPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_RoomPage';
  data: Array<ImportCanonical_Room>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_RotationSubjectGroup = {
  __typename?: 'ImportCanonical_RotationSubjectGroup';
  academicYear?: Maybe<Scalars['Int']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  blockName?: Maybe<Scalars['String']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  rotationIdx?: Maybe<Scalars['Int']['output']>;
  subjectGroupId?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_RotationSubjectGroupPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_RotationSubjectGroupPage';
  data: Array<ImportCanonical_RotationSubjectGroup>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_RunSanityCheckInput = {
  tenantId: Scalars['Int']['input'];
};

export type ImportCanonical_RunSanityCheckResult = {
  __typename?: 'ImportCanonical_RunSanityCheckResult';
  executionId: Scalars['String']['output'];
};

export type ImportCanonical_SanityCheckIssueGroup = {
  __typename?: 'ImportCanonical_SanityCheckIssueGroup';
  checkName: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  exampleIssue: Scalars['String']['output'];
  severity: ImportCanonical_SanityCheckSeverity;
  tenantIds: Array<Scalars['Int']['output']>;
};

export type ImportCanonical_SanityCheckIssueGroupPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_SanityCheckIssueGroupPage';
  data: Array<ImportCanonical_SanityCheckIssueGroup>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_SanityCheckResult = {
  __typename?: 'ImportCanonical_SanityCheckResult';
  academicYear?: Maybe<Scalars['String']['output']>;
  checkName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityType: Scalars['String']['output'];
  executionId: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  internalId?: Maybe<Scalars['Long']['output']>;
  issue: Scalars['String']['output'];
  severity: ImportCanonical_SanityCheckSeverity;
  suggestedResolution?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['Int']['output'];
};

export type ImportCanonical_SanityCheckResultFilter = {
  tenantId: Scalars['Int']['input'];
};

export type ImportCanonical_SanityCheckResultPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_SanityCheckResultPage';
  data: Array<ImportCanonical_SanityCheckResult>;
  totalCount: Scalars['Int']['output'];
};

export enum ImportCanonical_SanityCheckSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type ImportCanonical_SanityCheckSummary = {
  __typename?: 'ImportCanonical_SanityCheckSummary';
  errorCount: Scalars['Int']['output'];
  infoCount: Scalars['Int']['output'];
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  successCount: Scalars['Int']['output'];
  tenantId: Scalars['Int']['output'];
  warningCount: Scalars['Int']['output'];
};

export type ImportCanonical_SanityCheckSummaryPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_SanityCheckSummaryPage';
  data: Array<ImportCanonical_SanityCheckSummary>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_SchoolInfo = {
  __typename?: 'ImportCanonical_SchoolInfo';
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rollNumber?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_SchoolInfoPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_SchoolInfoPage';
  data: Array<ImportCanonical_SchoolInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_StaffAbsenceType = {
  __typename?: 'ImportCanonical_StaffAbsenceType';
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['Date']['output']>;
  customValue_1?: Maybe<Scalars['String']['output']>;
  customValue_2?: Maybe<Scalars['String']['output']>;
  customValue_3?: Maybe<Scalars['String']['output']>;
  customValue_4?: Maybe<Scalars['String']['output']>;
  customValue_5?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dfeDescription?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  enumCode?: Maybe<Scalars['String']['output']>;
  enumId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  modifiedOn?: Maybe<Scalars['Date']['output']>;
  naturalId?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['Long']['output']>;
  tenant?: Maybe<Scalars['Int']['output']>;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_StaffAbsenceTypePage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_StaffAbsenceTypePage';
  data: Array<ImportCanonical_StaffAbsenceType>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_Student = {
  __typename?: 'ImportCanonical_Student';
  borderIndicator?: Maybe<Scalars['Boolean']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dateOfEntry?: Maybe<Scalars['String']['output']>;
  dateOfExit?: Maybe<Scalars['String']['output']>;
  departmentNumber?: Maybe<Scalars['String']['output']>;
  examEntrant?: Maybe<Scalars['Boolean']['output']>;
  examNumber?: Maybe<Scalars['String']['output']>;
  examRepeat?: Maybe<Scalars['Boolean']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  irishExemption?: Maybe<Scalars['String']['output']>;
  irishExemptionDate?: Maybe<Scalars['Date']['output']>;
  languageSupportApplicant?: Maybe<Scalars['Boolean']['output']>;
  lcvp?: Maybe<Scalars['Boolean']['output']>;
  leftEarly?: Maybe<Scalars['Boolean']['output']>;
  lockerNumber?: Maybe<Scalars['String']['output']>;
  medicalCard?: Maybe<Scalars['Boolean']['output']>;
  mothersMaidenName?: Maybe<Scalars['String']['output']>;
  newEntrant?: Maybe<Scalars['Boolean']['output']>;
  ppsNumber?: Maybe<Scalars['String']['output']>;
  preferredFirstName?: Maybe<Scalars['String']['output']>;
  previousSchoolRollNumber?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
  repeatExemptionDate?: Maybe<Scalars['Boolean']['output']>;
  repeatingYear?: Maybe<Scalars['Boolean']['output']>;
  studentEmail?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  studentMobileNumber?: Maybe<Scalars['String']['output']>;
  travellerHeritage?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportCanonical_StudentAddresses = {
  __typename?: 'ImportCanonical_StudentAddresses';
  addressline1?: Maybe<Scalars['String']['output']>;
  addressline2?: Maybe<Scalars['String']['output']>;
  addressline3?: Maybe<Scalars['String']['output']>;
  addressline4?: Maybe<Scalars['String']['output']>;
  addressline5?: Maybe<Scalars['String']['output']>;
  arrangements?: Maybe<Scalars['String']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  detailsOfGuardianship_2cCustodyAnd_2forAccessOrders_2farrangeme?: Maybe<Scalars['Boolean']['output']>;
  postalTitle?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_StudentAddressesPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_StudentAddressesPage';
  data: Array<ImportCanonical_StudentAddresses>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_StudentContactStudentLink = {
  __typename?: 'ImportCanonical_StudentContactStudentLink';
  accountActive?: Maybe<Scalars['Boolean']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  includeInSms?: Maybe<Scalars['Boolean']['output']>;
  legalGuardian?: Maybe<Scalars['Boolean']['output']>;
  pickupRights?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['BigDecimal']['output']>;
  relationshipSubType?: Maybe<Scalars['String']['output']>;
  relationshipToStudent?: Maybe<ImportCanonical_Vs2StudentContactType>;
  requiresInterpreter?: Maybe<Scalars['Boolean']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_StudentContactStudentLinkPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_StudentContactStudentLinkPage';
  data: Array<ImportCanonical_StudentContactStudentLink>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_StudentContacts = {
  __typename?: 'ImportCanonical_StudentContacts';
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  contactAddressLine_1?: Maybe<Scalars['String']['output']>;
  contactAddressLine_2?: Maybe<Scalars['String']['output']>;
  contactAddressLine_3?: Maybe<Scalars['String']['output']>;
  contactAddressLine_4?: Maybe<Scalars['String']['output']>;
  contactCountry?: Maybe<Scalars['String']['output']>;
  contactCounty?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactGender?: Maybe<Scalars['String']['output']>;
  contactHomePhone?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  contactMobile?: Maybe<Scalars['String']['output']>;
  contactOccupation?: Maybe<Scalars['String']['output']>;
  contactPostcode?: Maybe<Scalars['String']['output']>;
  contactTitle?: Maybe<Scalars['String']['output']>;
  contactWorkPhone?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_StudentContactsPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_StudentContactsPage';
  data: Array<ImportCanonical_StudentContacts>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_StudentMedical = {
  __typename?: 'ImportCanonical_StudentMedical';
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  medialFlag?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  wearsGlasses?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_StudentMedicalPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_StudentMedicalPage';
  data: Array<ImportCanonical_StudentMedical>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_StudentPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_StudentPage';
  data: Array<ImportCanonical_Student>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_StudentSiblings = {
  __typename?: 'ImportCanonical_StudentSiblings';
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  studentIdA?: Maybe<Scalars['String']['output']>;
  studentIdB?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_StudentSiblingsPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_StudentSiblingsPage';
  data: Array<ImportCanonical_StudentSiblings>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_SubjectGroupMemberships = {
  __typename?: 'ImportCanonical_SubjectGroupMemberships';
  academicYear?: Maybe<Scalars['Int']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  subjectGroupId?: Maybe<Scalars['String']['output']>;
  subjectGroupName?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_SubjectGroupMembershipsPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_SubjectGroupMembershipsPage';
  data: Array<ImportCanonical_SubjectGroupMemberships>;
  totalCount: Scalars['Int']['output'];
};

export enum ImportCanonical_SubjectGroupStudentMembershipType {
  Block = 'BLOCK',
  Core = 'CORE',
  SocialWorker = 'SOCIAL_WORKER',
  StepFather = 'STEP_FATHER',
  StepMother = 'STEP_MOTHER'
}

export enum ImportCanonical_SubjectGroupTeacherType {
  Additional = 'ADDITIONAL',
  Teacher = 'TEACHER'
}

export type ImportCanonical_SubjectGroups = {
  __typename?: 'ImportCanonical_SubjectGroups';
  academicYear?: Maybe<Scalars['Int']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  blockId?: Maybe<Scalars['String']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  classGroupId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['Int']['output']>;
  courseYear?: Maybe<Scalars['Int']['output']>;
  subjectCode?: Maybe<Scalars['String']['output']>;
  subjectGroupId?: Maybe<Scalars['String']['output']>;
  subjectGroupName?: Maybe<Scalars['String']['output']>;
  subjectGroupStudentMembershipType?: Maybe<ImportCanonical_SubjectGroupStudentMembershipType>;
  yearGroup?: Maybe<Scalars['Int']['output']>;
};

export type ImportCanonical_SubjectGroupsPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_SubjectGroupsPage';
  data: Array<ImportCanonical_SubjectGroups>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_SubjectGroupsTeacher = {
  __typename?: 'ImportCanonical_SubjectGroupsTeacher';
  academicYear?: Maybe<Scalars['Int']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  subjectGroupId?: Maybe<Scalars['String']['output']>;
  teacherFullName?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ImportCanonical_SubjectGroupTeacherType>;
};

export type ImportCanonical_SubjectGroupsTeacherPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_SubjectGroupsTeacherPage';
  data: Array<ImportCanonical_SubjectGroupsTeacher>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_Teacher = {
  __typename?: 'ImportCanonical_Teacher';
  addressLine_1?: Maybe<Scalars['String']['output']>;
  addressLine_2?: Maybe<Scalars['String']['output']>;
  addressLine_3?: Maybe<Scalars['String']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  carColour?: Maybe<Scalars['String']['output']>;
  carMake?: Maybe<Scalars['String']['output']>;
  carRegistrationNumber?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dateOfEntry?: Maybe<Scalars['Date']['output']>;
  displayCode?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasLeftSchool?: Maybe<Scalars['Boolean']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  includeInTimetabling?: Maybe<Scalars['Boolean']['output']>;
  jobSharer?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  nextOfKin?: Maybe<Scalars['String']['output']>;
  nextOfKinsPhoneNumber?: Maybe<Scalars['String']['output']>;
  parkingSpot?: Maybe<Scalars['String']['output']>;
  payrollNumber?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  ppsNumber?: Maybe<Scalars['String']['output']>;
  qualification_1?: Maybe<Scalars['String']['output']>;
  qualification_2?: Maybe<Scalars['String']['output']>;
  qualification_3?: Maybe<Scalars['String']['output']>;
  qualification_4?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
  teacherCouncilNumber?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  teachingPost?: Maybe<Scalars['String']['output']>;
  userInfoId?: Maybe<Scalars['Long']['output']>;
  workPhone?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_TeacherPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_TeacherPage';
  data: Array<ImportCanonical_Teacher>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_Timetable = {
  __typename?: 'ImportCanonical_Timetable';
  academicYear?: Maybe<Scalars['Int']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['Time']['output']>;
  gridIdx?: Maybe<Scalars['Int']['output']>;
  periodIdx?: Maybe<Scalars['Int']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
  teacherFullName?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  teachingGroupId?: Maybe<Scalars['String']['output']>;
  teachingGroupName?: Maybe<Scalars['String']['output']>;
};

export type ImportCanonical_TimetablePage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_TimetablePage';
  data: Array<ImportCanonical_Timetable>;
  totalCount: Scalars['Int']['output'];
};

export type ImportCanonical_TimetablePeriod = {
  __typename?: 'ImportCanonical_TimetablePeriod';
  academicYear?: Maybe<Scalars['Int']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  dayIdx?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['Time']['output']>;
  gridIdx?: Maybe<Scalars['Int']['output']>;
  isBreak?: Maybe<Scalars['Boolean']['output']>;
  periodIdx?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
};

export type ImportCanonical_TimetablePeriodPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_TimetablePeriodPage';
  data: Array<ImportCanonical_TimetablePeriod>;
  totalCount: Scalars['Int']['output'];
};

export enum ImportCanonical_Vs2StudentContactType {
  Aunty = 'AUNTY',
  FamilyFriend = 'FAMILY_FRIEND',
  Father = 'FATHER',
  FosterFather = 'FOSTER_FATHER',
  FosterMother = 'FOSTER_MOTHER',
  GrandFather = 'GRAND_FATHER',
  GrandMother = 'GRAND_MOTHER',
  Mother = 'MOTHER',
  Neighbour = 'NEIGHBOUR',
  Other = 'OTHER',
  Sibling = 'SIBLING',
  SocialWorker = 'SOCIAL_WORKER',
  StepFather = 'STEP_FATHER',
  StepMother = 'STEP_MOTHER',
  Uncle = 'UNCLE'
}

export type ImportCanonical_YearGroupInfo = {
  __typename?: 'ImportCanonical_YearGroupInfo';
  academicYear?: Maybe<Scalars['Int']['output']>;
  canonicalImportMetaId?: Maybe<Scalars['String']['output']>;
  yearGroup?: Maybe<Scalars['Int']['output']>;
  yearHeadIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type ImportCanonical_YearGroupInfoPage = ImportCanonical_PageResponse & {
  __typename?: 'ImportCanonical_YearGroupInfoPage';
  data: Array<ImportCanonical_YearGroupInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportSubjectInput = {
  colour?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Array<InputMaybe<TranslationInput>>;
  nationalCode: Scalars['String']['input'];
  region: Scalars['Int']['input'];
  shortCode: Array<InputMaybe<TranslationInput>>;
  subjectSource?: InputMaybe<SubjectSource>;
};

export type ImportVsware2_AcademicYear = {
  __typename?: 'ImportVsware2_AcademicYear';
  enddate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  startdate?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

export type ImportVsware2_AcademicYearPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_AcademicYearPage';
  data: Array<ImportVsware2_AcademicYear>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_AssessmentCommentBank = {
  __typename?: 'ImportVsware2_AssessmentCommentBank';
  commentBankDescription?: Maybe<Scalars['String']['output']>;
  commentBankId?: Maybe<Scalars['Int']['output']>;
  commentBankName?: Maybe<Scalars['String']['output']>;
  commentBankStatus?: Maybe<Scalars['Boolean']['output']>;
  commentRow?: Maybe<Scalars['String']['output']>;
  commentRowId?: Maybe<Scalars['Int']['output']>;
  commentRowStatus?: Maybe<Scalars['Boolean']['output']>;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_AssessmentCommentBankPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_AssessmentCommentBankPage';
  data: Array<ImportVsware2_AssessmentCommentBank>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_AssessmentCommentInfo = {
  __typename?: 'ImportVsware2_AssessmentCommentInfo';
  comment?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_AssessmentCommentInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_AssessmentCommentInfoPage';
  data: Array<ImportVsware2_AssessmentCommentInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_AssessmentGradeSet = {
  __typename?: 'ImportVsware2_AssessmentGradeSet';
  gradeDescription?: Maybe<Scalars['String']['output']>;
  gradeEndMark?: Maybe<Scalars['Int']['output']>;
  gradeOrder?: Maybe<Scalars['Int']['output']>;
  gradeSetActive?: Maybe<Scalars['Boolean']['output']>;
  gradeSetCba?: Maybe<Scalars['Boolean']['output']>;
  gradeSetCreatedOn?: Maybe<Scalars['DateTime']['output']>;
  gradeSetDefault?: Maybe<Scalars['Boolean']['output']>;
  gradeSetDescription?: Maybe<Scalars['String']['output']>;
  gradeSetName?: Maybe<Scalars['String']['output']>;
  gradeSetPpodCba?: Maybe<Scalars['Boolean']['output']>;
  gradeStartMark?: Maybe<Scalars['Int']['output']>;
  gradeValue?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  masterYearLevelId?: Maybe<Scalars['String']['output']>;
  passThreshold?: Maybe<Scalars['Int']['output']>;
  studyLevel?: Maybe<Scalars['String']['output']>;
  studyLevelDescription?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_AssessmentGradeSetPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_AssessmentGradeSetPage';
  data: Array<ImportVsware2_AssessmentGradeSet>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_AssessmentResult = {
  __typename?: 'ImportVsware2_AssessmentResult';
  absent?: Maybe<Scalars['Boolean']['output']>;
  examAcademicYear?: Maybe<Scalars['Int']['output']>;
  examId?: Maybe<Scalars['Int']['output']>;
  examName?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  resultCommentId?: Maybe<Scalars['String']['output']>;
  resultGrade?: Maybe<Scalars['String']['output']>;
  resultNote?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
  studyLevelCode?: Maybe<Scalars['String']['output']>;
  studyLevelDescription?: Maybe<Scalars['String']['output']>;
  targetResult?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teachingGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_AssessmentResultExtraFieldInfo = {
  __typename?: 'ImportVsware2_AssessmentResultExtraFieldInfo';
  commentRowId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  examId?: Maybe<Scalars['Int']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  learnerId?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teachinggroupId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_AssessmentResultExtraFieldInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_AssessmentResultExtraFieldInfoPage';
  data: Array<ImportVsware2_AssessmentResultExtraFieldInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_AssessmentResultInfo = {
  __typename?: 'ImportVsware2_AssessmentResultInfo';
  absent?: Maybe<Scalars['Boolean']['output']>;
  examAcademicYear?: Maybe<Scalars['Int']['output']>;
  examId?: Maybe<Scalars['Int']['output']>;
  examName?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  resultCommentId?: Maybe<Scalars['String']['output']>;
  resultGrade?: Maybe<Scalars['String']['output']>;
  resultNote?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
  studyLevelCode?: Maybe<Scalars['String']['output']>;
  studyLevelDescription?: Maybe<Scalars['String']['output']>;
  targetResult?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teachingGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_AssessmentResultInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_AssessmentResultInfoPage';
  data: Array<ImportVsware2_AssessmentResultInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_AssessmentResultPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_AssessmentResultPage';
  data: Array<ImportVsware2_AssessmentResult>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_AssessmentStudentCommentInfo = {
  __typename?: 'ImportVsware2_AssessmentStudentCommentInfo';
  commenterType?: Maybe<Scalars['String']['output']>;
  examComment?: Maybe<Scalars['String']['output']>;
  examId?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_AssessmentStudentCommentInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_AssessmentStudentCommentInfoPage';
  data: Array<ImportVsware2_AssessmentStudentCommentInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_AttendanceCode = {
  __typename?: 'ImportVsware2_AttendanceCode';
  attendanceCode?: Maybe<Scalars['String']['output']>;
  attendanceType?: Maybe<Scalars['String']['output']>;
  availableToParents?: Maybe<Scalars['Boolean']['output']>;
  availableToTeachers?: Maybe<Scalars['Boolean']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  statutoryCode?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_AttendanceCodePage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_AttendanceCodePage';
  data: Array<ImportVsware2_AttendanceCode>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_BellTime = {
  __typename?: 'ImportVsware2_BellTime';
  academicYear?: Maybe<Scalars['Long']['output']>;
  bellTime?: Maybe<Scalars['String']['output']>;
  bellTimeCode?: Maybe<Scalars['String']['output']>;
  bellTimeName?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  weekDay?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_BellTimePage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_BellTimePage';
  data: Array<ImportVsware2_BellTime>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_DeleteSchoolIdentifierInput = {
  vsIdentifier: Scalars['Int']['input'];
};

export type ImportVsware2_DutyRoster = {
  __typename?: 'ImportVsware2_DutyRoster';
  dayInCycle?: Maybe<Scalars['Int']['output']>;
  finishTime?: Maybe<Scalars['String']['output']>;
  gridId?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  periodCode?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teacherName?: Maybe<Scalars['String']['output']>;
  timetablePeriodId?: Maybe<Scalars['Long']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_DutyRosterPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_DutyRosterPage';
  data: Array<ImportVsware2_DutyRoster>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_EnumInfo = {
  __typename?: 'ImportVsware2_EnumInfo';
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  enumName?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_EnumInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_EnumInfoPage';
  data: Array<ImportVsware2_EnumInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_ExamInfo = {
  __typename?: 'ImportVsware2_ExamInfo';
  academicYearId?: Maybe<Scalars['Int']['output']>;
  captureGrade?: Maybe<Scalars['Boolean']['output']>;
  captureHouseMasterComment?: Maybe<Scalars['Boolean']['output']>;
  capturePrincipalComment?: Maybe<Scalars['Boolean']['output']>;
  captureTarget?: Maybe<Scalars['Boolean']['output']>;
  captureTutorComment?: Maybe<Scalars['Boolean']['output']>;
  captureYearHeadComment?: Maybe<Scalars['Boolean']['output']>;
  commentBankId?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  examDescription?: Maybe<Scalars['String']['output']>;
  examId?: Maybe<Scalars['String']['output']>;
  examName?: Maybe<Scalars['String']['output']>;
  examType?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  maxCommentLength?: Maybe<Scalars['Int']['output']>;
  passFailThreshold?: Maybe<Scalars['Int']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  studyLevel?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_ExamInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_ExamInfoPage';
  data: Array<ImportVsware2_ExamInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_ExamTeachingGroups = {
  __typename?: 'ImportVsware2_ExamTeachingGroups';
  examId?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  teachingGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_ExamTeachingGroupsPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_ExamTeachingGroupsPage';
  data: Array<ImportVsware2_ExamTeachingGroups>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_ExamYears = {
  __typename?: 'ImportVsware2_ExamYears';
  courseid?: Maybe<Scalars['Int']['output']>;
  courseyear?: Maybe<Scalars['Int']['output']>;
  examId?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  yearLevel?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_ExamYearsPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_ExamYearsPage';
  data: Array<ImportVsware2_ExamYears>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_FeeGroupInfo = {
  __typename?: 'ImportVsware2_FeeGroupInfo';
  feeId?: Maybe<Scalars['Float']['output']>;
  groupIdentifier?: Maybe<Scalars['String']['output']>;
  groupType?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_FeeGroupInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_FeeGroupInfoPage';
  data: Array<ImportVsware2_FeeGroupInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_FeeInfo = {
  __typename?: 'ImportVsware2_FeeInfo';
  discountAvailable?: Maybe<Scalars['String']['output']>;
  feeAmount?: Maybe<Scalars['Float']['output']>;
  feeDueBy?: Maybe<Scalars['Date']['output']>;
  feeId?: Maybe<Scalars['Float']['output']>;
  feeName?: Maybe<Scalars['String']['output']>;
  feePaidOn?: Maybe<Scalars['Date']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  methodOfPayment?: Maybe<Scalars['String']['output']>;
  paymentAdditionalInformation?: Maybe<Scalars['String']['output']>;
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  paymentReference?: Maybe<Scalars['String']['output']>;
  receiptNumber?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
};

export type ImportVsware2_FeeInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_FeeInfoPage';
  data: Array<ImportVsware2_FeeInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_FeeListInfo = {
  __typename?: 'ImportVsware2_FeeListInfo';
  amount?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  dueBy?: Maybe<Scalars['Date']['output']>;
  feeId?: Maybe<Scalars['Float']['output']>;
  feeName?: Maybe<Scalars['String']['output']>;
  feeType?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportVsware2_FeeListInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_FeeListInfoPage';
  data: Array<ImportVsware2_FeeListInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_Filter = {
  importId?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<FilterOptions>;
};

export type ImportVsware2_FreeformMembership = {
  __typename?: 'ImportVsware2_FreeformMembership';
  freeformGroupName?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_FreeformMembershipPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_FreeformMembershipPage';
  data: Array<ImportVsware2_FreeformMembership>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_ImportMeta = {
  __typename?: 'ImportVsware2_ImportMeta';
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startedOn?: Maybe<Scalars['DateTime']['output']>;
  stepCompleted?: Maybe<Scalars['Int']['output']>;
  tenant?: Maybe<Scalars['Int']['output']>;
  updatingUser?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_ImportMetaPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_ImportMetaPage';
  data: Array<ImportVsware2_ImportMeta>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_LongTermLeaveSubstitutionInfo = {
  __typename?: 'ImportVsware2_LongTermLeaveSubstitutionInfo';
  academicYearId?: Maybe<Scalars['Int']['output']>;
  dayNumber?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  mainTeacher?: Maybe<Scalars['String']['output']>;
  periodNumber?: Maybe<Scalars['Int']['output']>;
  subTeacherId?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teachingGroup?: Maybe<Scalars['String']['output']>;
  teachingGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_LongTermLeaveSubstitutionInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_LongTermLeaveSubstitutionInfoPage';
  data: Array<ImportVsware2_LongTermLeaveSubstitutionInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_NonClassContactHours = {
  __typename?: 'ImportVsware2_NonClassContactHours';
  activityCode?: Maybe<Scalars['String']['output']>;
  activityDescription?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['String']['output']>;
  dayOfTheWeek?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  minutes?: Maybe<Scalars['Int']['output']>;
  teacherFullName?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_NonClassContactHoursPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_NonClassContactHoursPage';
  data: Array<ImportVsware2_NonClassContactHours>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_OnCallRoster = {
  __typename?: 'ImportVsware2_OnCallRoster';
  dayInCycle?: Maybe<Scalars['Int']['output']>;
  finishTime?: Maybe<Scalars['String']['output']>;
  gridId?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  periodCode?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teacherName?: Maybe<Scalars['String']['output']>;
  timetablePeriodId?: Maybe<Scalars['Long']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_OnCallRosterPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_OnCallRosterPage';
  data: Array<ImportVsware2_OnCallRoster>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_PageResponse = {
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_RelationshipInfo = {
  __typename?: 'ImportVsware2_RelationshipInfo';
  allowPushCommunication?: Maybe<Scalars['Boolean']['output']>;
  allowSmsCommunication?: Maybe<Scalars['Boolean']['output']>;
  allowVsmailCommunication?: Maybe<Scalars['Boolean']['output']>;
  contactAddressLine_1?: Maybe<Scalars['String']['output']>;
  contactAddressLine_2?: Maybe<Scalars['String']['output']>;
  contactAddressLine_3?: Maybe<Scalars['String']['output']>;
  contactAddressLine_4?: Maybe<Scalars['String']['output']>;
  contactCountry?: Maybe<Scalars['String']['output']>;
  contactCounty?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFamilyName?: Maybe<Scalars['String']['output']>;
  contactGender?: Maybe<Scalars['String']['output']>;
  contactGivenName?: Maybe<Scalars['String']['output']>;
  contactHomePhone?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['Float']['output']>;
  contactMobile?: Maybe<Scalars['String']['output']>;
  contactOccupation?: Maybe<Scalars['String']['output']>;
  contactPostcode?: Maybe<Scalars['String']['output']>;
  contactTitle?: Maybe<Scalars['String']['output']>;
  contactWorkPhone?: Maybe<Scalars['String']['output']>;
  enableAccessToVsware?: Maybe<Scalars['Boolean']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  parentOfGuardian?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  relationshipToStudent?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
};

export type ImportVsware2_RelationshipInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_RelationshipInfoPage';
  data: Array<ImportVsware2_RelationshipInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_RoomsInfo = {
  __typename?: 'ImportVsware2_RoomsInfo';
  importMetaId?: Maybe<Scalars['Int']['output']>;
  roomActive?: Maybe<Scalars['String']['output']>;
  roomCapacity?: Maybe<Scalars['Int']['output']>;
  roomDescription?: Maybe<Scalars['String']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomIncludeInTimetabling?: Maybe<Scalars['Boolean']['output']>;
  roomName?: Maybe<Scalars['String']['output']>;
  roomPool?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_RoomsInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_RoomsInfoPage';
  data: Array<ImportVsware2_RoomsInfo>;
  totalCount: Scalars['Int']['output'];
};

/** Operator-managed lookup binding a VSware school id to a Tyro tenant. */
export type ImportVsware2_SchoolIdentifier = {
  __typename?: 'ImportVsware2_SchoolIdentifier';
  name: Scalars['String']['output'];
  tenant: Scalars['Int']['output'];
  vsIdentifier: Scalars['Int']['output'];
};

export type ImportVsware2_SchoolInfo = {
  __typename?: 'ImportVsware2_SchoolInfo';
  boardOfManagementChairperson?: Maybe<Scalars['String']['output']>;
  boardOfManagementChairpersonPhone?: Maybe<Scalars['String']['output']>;
  coOpSchool_1?: Maybe<Scalars['String']['output']>;
  coOpSchool_2?: Maybe<Scalars['String']['output']>;
  countryCallingCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fiveDayBoarding?: Maybe<Scalars['Boolean']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  irishClassification?: Maybe<Scalars['String']['output']>;
  localAuthority?: Maybe<Scalars['String']['output']>;
  localAuthorityCode?: Maybe<Scalars['String']['output']>;
  octoberReturnsContactPerson?: Maybe<Scalars['String']['output']>;
  octoberReturnsContactPersonEmail?: Maybe<Scalars['String']['output']>;
  octoberReturnsContactPersonFax?: Maybe<Scalars['String']['output']>;
  octoberReturnsContactPersonPhone?: Maybe<Scalars['String']['output']>;
  ownerAddressLine_1?: Maybe<Scalars['String']['output']>;
  ownerAddressLine_2?: Maybe<Scalars['String']['output']>;
  ownerAddressLine_3?: Maybe<Scalars['String']['output']>;
  ownerAddressLine_4?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  parentsAssociation?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rollNumber?: Maybe<Scalars['String']['output']>;
  schoolAddressLine_1?: Maybe<Scalars['String']['output']>;
  schoolAddressLine_2?: Maybe<Scalars['String']['output']>;
  schoolAddressLine_3?: Maybe<Scalars['String']['output']>;
  schoolAddressLine_4?: Maybe<Scalars['String']['output']>;
  schoolGender?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  schoolWebsite?: Maybe<Scalars['String']['output']>;
  sevenDayBoarding?: Maybe<Scalars['Boolean']['output']>;
  studentCouncil?: Maybe<Scalars['Boolean']['output']>;
  trusteeAAddressLine_1?: Maybe<Scalars['String']['output']>;
  trusteeAAddressLine_2?: Maybe<Scalars['String']['output']>;
  trusteeAAddressLine_3?: Maybe<Scalars['String']['output']>;
  trusteeAAddressLine_4?: Maybe<Scalars['String']['output']>;
  trusteeAName?: Maybe<Scalars['String']['output']>;
  trusteeBAddressLine_1?: Maybe<Scalars['String']['output']>;
  trusteeBAddressLine_2?: Maybe<Scalars['String']['output']>;
  trusteeBAddressLine_3?: Maybe<Scalars['String']['output']>;
  trusteeBAddressLine_4?: Maybe<Scalars['String']['output']>;
  trusteeBName?: Maybe<Scalars['String']['output']>;
  trusteeCAddressLine_1?: Maybe<Scalars['String']['output']>;
  trusteeCAddressLine_2?: Maybe<Scalars['String']['output']>;
  trusteeCAddressLine_3?: Maybe<Scalars['String']['output']>;
  trusteeCAddressLine_4?: Maybe<Scalars['String']['output']>;
  trusteeCName?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_SchoolInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_SchoolInfoPage';
  data: Array<ImportVsware2_SchoolInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_Sibling = {
  __typename?: 'ImportVsware2_Sibling';
  contactAddressLine_1?: Maybe<Scalars['String']['output']>;
  contactAddressLine_2?: Maybe<Scalars['String']['output']>;
  contactAddressLine_3?: Maybe<Scalars['String']['output']>;
  contactAddressLine_4?: Maybe<Scalars['String']['output']>;
  contactCountry?: Maybe<Scalars['String']['output']>;
  contactCounty?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactGender?: Maybe<Scalars['String']['output']>;
  contactHomePhone?: Maybe<Scalars['String']['output']>;
  contactMobile?: Maybe<Scalars['String']['output']>;
  contactOccupation?: Maybe<Scalars['String']['output']>;
  contactPostcode?: Maybe<Scalars['String']['output']>;
  contactTitle?: Maybe<Scalars['String']['output']>;
  contactWorkPhone?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  parentOfGuardian?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  relationshipToStudent?: Maybe<Scalars['String']['output']>;
  siblingName?: Maybe<Scalars['String']['output']>;
  siblingStudentId?: Maybe<Scalars['Int']['output']>;
  siblingUserInfoId?: Maybe<Scalars['Int']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
  studentUserInfoId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_SiblingPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_SiblingPage';
  data: Array<ImportVsware2_Sibling>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_SmsNotification = {
  __typename?: 'ImportVsware2_SmsNotification';
  body?: Maybe<Scalars['String']['output']>;
  dateSent?: Maybe<Scalars['DateTime']['output']>;
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  messageReference?: Maybe<Scalars['String']['output']>;
  receiptTimestamp?: Maybe<Scalars['DateTime']['output']>;
  sentTo?: Maybe<Scalars['String']['output']>;
  sentToMobileNumber?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_SmsNotificationPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_SmsNotificationPage';
  data: Array<ImportVsware2_SmsNotification>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_StatutoryAttendance = {
  __typename?: 'ImportVsware2_StatutoryAttendance';
  attendanceCode?: Maybe<Scalars['String']['output']>;
  attendanceDate?: Maybe<Scalars['Date']['output']>;
  attendanceNote?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  session?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_StatutoryAttendancePage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_StatutoryAttendancePage';
  data: Array<ImportVsware2_StatutoryAttendance>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_Student = {
  __typename?: 'ImportVsware2_Student';
  borderIndicator?: Maybe<Scalars['Boolean']['output']>;
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dateOfEntry?: Maybe<Scalars['String']['output']>;
  departmentPupilId?: Maybe<Scalars['String']['output']>;
  examEntrant?: Maybe<Scalars['Boolean']['output']>;
  examNumber?: Maybe<Scalars['String']['output']>;
  examRepeat?: Maybe<Scalars['Boolean']['output']>;
  exitDate?: Maybe<Scalars['Date']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  irishExemption?: Maybe<Scalars['String']['output']>;
  irishExemptionDate?: Maybe<Scalars['Date']['output']>;
  languageSupportApplicant?: Maybe<Scalars['Boolean']['output']>;
  lcvp?: Maybe<Scalars['Boolean']['output']>;
  leavingReason?: Maybe<Scalars['String']['output']>;
  leftEarly?: Maybe<Scalars['Boolean']['output']>;
  leftSchool?: Maybe<Scalars['Boolean']['output']>;
  lockerNumber?: Maybe<Scalars['String']['output']>;
  medicalCard?: Maybe<Scalars['Boolean']['output']>;
  mothersMaidenName?: Maybe<Scalars['String']['output']>;
  newEntrant?: Maybe<Scalars['Boolean']['output']>;
  ppsNumber?: Maybe<Scalars['String']['output']>;
  preferredFirstName?: Maybe<Scalars['String']['output']>;
  previousSchoolRollNumber?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
  repeatExemptionDate?: Maybe<Scalars['Boolean']['output']>;
  repeatingYear?: Maybe<Scalars['Boolean']['output']>;
  studentEmail?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
  studentMobileNumber?: Maybe<Scalars['String']['output']>;
  travellerHeritage?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportVsware2_StudentBehaviour = {
  __typename?: 'ImportVsware2_StudentBehaviour';
  actionTakenNote?: Maybe<Scalars['String']['output']>;
  behaviorName?: Maybe<Scalars['String']['output']>;
  behaviourNote?: Maybe<Scalars['String']['output']>;
  behaviourPoints?: Maybe<Scalars['Int']['output']>;
  behaviourType?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['Long']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  incidentDate?: Maybe<Scalars['DateTime']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
  teachingGroupId?: Maybe<Scalars['Long']['output']>;
  teachingGroupName?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_StudentBehaviourPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_StudentBehaviourPage';
  data: Array<ImportVsware2_StudentBehaviour>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_StudentClasses = {
  __typename?: 'ImportVsware2_StudentClasses';
  academicYear?: Maybe<Scalars['Float']['output']>;
  className?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['Int']['output']>;
  courseYear?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
  tutorId?: Maybe<Scalars['Long']['output']>;
  tutorName?: Maybe<Scalars['String']['output']>;
  yearHeadId?: Maybe<Scalars['Long']['output']>;
  yearHeadName?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_StudentClassesPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_StudentClassesPage';
  data: Array<ImportVsware2_StudentClasses>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_StudentContactInfo = {
  __typename?: 'ImportVsware2_StudentContactInfo';
  addressLine_1?: Maybe<Scalars['String']['output']>;
  addressLine_2?: Maybe<Scalars['String']['output']>;
  addressLine_3?: Maybe<Scalars['String']['output']>;
  addressLine_4?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  guardianshipDetails?: Maybe<Scalars['String']['output']>;
  householdNumber?: Maybe<Scalars['String']['output']>;
  householdSms?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  postalTitle?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
};

export type ImportVsware2_StudentContactInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_StudentContactInfoPage';
  data: Array<ImportVsware2_StudentContactInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_StudentExclusion = {
  __typename?: 'ImportVsware2_StudentExclusion';
  exclusionEndDate?: Maybe<Scalars['String']['output']>;
  exclusionNote?: Maybe<Scalars['String']['output']>;
  exclusionReason?: Maybe<Scalars['String']['output']>;
  exclusionStartDate?: Maybe<Scalars['String']['output']>;
  exclusionType?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_StudentExclusionPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_StudentExclusionPage';
  data: Array<ImportVsware2_StudentExclusion>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_StudentMedicalInfo = {
  __typename?: 'ImportVsware2_StudentMedicalInfo';
  doctorDetailsAddress?: Maybe<Scalars['String']['output']>;
  doctorDetailsPhone?: Maybe<Scalars['String']['output']>;
  doctorsName?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  medicalDescription?: Maybe<Scalars['String']['output']>;
  medicalNote?: Maybe<Scalars['String']['output']>;
  medicalNoteCreationDate?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_StudentMedicalInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_StudentMedicalInfoPage';
  data: Array<ImportVsware2_StudentMedicalInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_StudentNote = {
  __typename?: 'ImportVsware2_StudentNote';
  importMetaId?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteCreatorFullName?: Maybe<Scalars['String']['output']>;
  noteCreatorId?: Maybe<Scalars['Int']['output']>;
  noteDate?: Maybe<Scalars['DateTime']['output']>;
  noteTitle?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_StudentNotePage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_StudentNotePage';
  data: Array<ImportVsware2_StudentNote>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_StudentOptionsClassList = {
  __typename?: 'ImportVsware2_StudentOptionsClassList';
  blockIdx?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  poolIdx?: Maybe<Scalars['Int']['output']>;
  solutionName?: Maybe<Scalars['String']['output']>;
  studentGroupName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  subjectName?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_StudentOptionsClassListPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_StudentOptionsClassListPage';
  data: Array<ImportVsware2_StudentOptionsClassList>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_StudentOptionsPreference = {
  __typename?: 'ImportVsware2_StudentOptionsPreference';
  importMetaId?: Maybe<Scalars['Int']['output']>;
  learnerId?: Maybe<Scalars['Int']['output']>;
  preferenceOrder?: Maybe<Scalars['Int']['output']>;
  studentGroupName?: Maybe<Scalars['String']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subjectCode?: Maybe<Scalars['String']['output']>;
  subjectSetName?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_StudentOptionsPreferencePage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_StudentOptionsPreferencePage';
  data: Array<ImportVsware2_StudentOptionsPreference>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_StudentOptionsSolution = {
  __typename?: 'ImportVsware2_StudentOptionsSolution';
  importMetaId?: Maybe<Scalars['Int']['output']>;
  solutionName?: Maybe<Scalars['String']['output']>;
  studentGroupName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
  subjects?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_StudentOptionsSolutionPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_StudentOptionsSolutionPage';
  data: Array<ImportVsware2_StudentOptionsSolution>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_StudentPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_StudentPage';
  data: Array<ImportVsware2_Student>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_StudentSenInfo = {
  __typename?: 'ImportVsware2_StudentSenInfo';
  importMetaId?: Maybe<Scalars['Int']['output']>;
  senContact?: Maybe<Scalars['String']['output']>;
  senEndDate?: Maybe<Scalars['String']['output']>;
  senNote?: Maybe<Scalars['String']['output']>;
  senProvision?: Maybe<Scalars['String']['output']>;
  senStartDate?: Maybe<Scalars['String']['output']>;
  senType?: Maybe<Scalars['String']['output']>;
  senTypeNote?: Maybe<Scalars['String']['output']>;
  snaSupport?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_StudentSenInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_StudentSenInfoPage';
  data: Array<ImportVsware2_StudentSenInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_Subject = {
  __typename?: 'ImportVsware2_Subject';
  deleted?: Maybe<Scalars['Boolean']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationalCode?: Maybe<Scalars['String']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['Float']['output']>;
};

export type ImportVsware2_SubjectPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_SubjectPage';
  data: Array<ImportVsware2_Subject>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_SubstitutionAbsenceInfo = {
  __typename?: 'ImportVsware2_SubstitutionAbsenceInfo';
  absenceCategory?: Maybe<Scalars['String']['output']>;
  absenceNote?: Maybe<Scalars['String']['output']>;
  absenceReason?: Maybe<Scalars['String']['output']>;
  absenceType?: Maybe<Scalars['String']['output']>;
  academicYearId?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  endPeriod?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  startPeriod?: Maybe<Scalars['String']['output']>;
  substitutionAbsenceId?: Maybe<Scalars['Long']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_SubstitutionAbsenceInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_SubstitutionAbsenceInfoPage';
  data: Array<ImportVsware2_SubstitutionAbsenceInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_SubstitutionInfo = {
  __typename?: 'ImportVsware2_SubstitutionInfo';
  absenceId?: Maybe<Scalars['Long']['output']>;
  coverNote?: Maybe<Scalars['String']['output']>;
  coverReason?: Maybe<Scalars['String']['output']>;
  coverType?: Maybe<Scalars['String']['output']>;
  coveredTeacherFullName?: Maybe<Scalars['String']['output']>;
  coveredTeacherId?: Maybe<Scalars['Int']['output']>;
  coveringTeacherFullName?: Maybe<Scalars['String']['output']>;
  coveringTeacherId?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  periodEndTime?: Maybe<Scalars['String']['output']>;
  periodStartTime?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  substitutionCoverDate?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_SubstitutionInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_SubstitutionInfoPage';
  data: Array<ImportVsware2_SubstitutionInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_Teacher = {
  __typename?: 'ImportVsware2_Teacher';
  addressLine_1?: Maybe<Scalars['String']['output']>;
  addressLine_2?: Maybe<Scalars['String']['output']>;
  addressLine_3?: Maybe<Scalars['String']['output']>;
  addressLine_4?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  carColour?: Maybe<Scalars['String']['output']>;
  carMake?: Maybe<Scalars['String']['output']>;
  carRegistrationNumber?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dateOfEntry?: Maybe<Scalars['Date']['output']>;
  displayCode?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasLeftSchool?: Maybe<Scalars['Boolean']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  includeInTimetabling?: Maybe<Scalars['Boolean']['output']>;
  jobSharer?: Maybe<Scalars['Boolean']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  nextOfKin?: Maybe<Scalars['String']['output']>;
  nextOfKinsPhoneNumber?: Maybe<Scalars['String']['output']>;
  parkingSpot?: Maybe<Scalars['String']['output']>;
  payrollNumber?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  ppsNumber?: Maybe<Scalars['String']['output']>;
  qualification_1?: Maybe<Scalars['String']['output']>;
  qualification_2?: Maybe<Scalars['String']['output']>;
  qualification_3?: Maybe<Scalars['String']['output']>;
  qualification_4?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
  teacherCouncilNumber?: Maybe<Scalars['String']['output']>;
  teacherFamilyName?: Maybe<Scalars['String']['output']>;
  teacherGivenName?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teachingPost?: Maybe<Scalars['String']['output']>;
  tutor?: Maybe<Scalars['String']['output']>;
  workPhone?: Maybe<Scalars['String']['output']>;
  yearHead?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_TeacherFreeformGroup = {
  __typename?: 'ImportVsware2_TeacherFreeformGroup';
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_TeacherFreeformGroupMembership = {
  __typename?: 'ImportVsware2_TeacherFreeformGroupMembership';
  groupName?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_TeacherFreeformGroupMembershipPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_TeacherFreeformGroupMembershipPage';
  data: Array<ImportVsware2_TeacherFreeformGroupMembership>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_TeacherFreeformGroupPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_TeacherFreeformGroupPage';
  data: Array<ImportVsware2_TeacherFreeformGroup>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_TeacherPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_TeacherPage';
  data: Array<ImportVsware2_Teacher>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_TeachingGroupAttendance = {
  __typename?: 'ImportVsware2_TeachingGroupAttendance';
  attendanceCode?: Maybe<Scalars['String']['output']>;
  attendanceDate?: Maybe<Scalars['Date']['output']>;
  attendanceNote?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
  teachingGroupId?: Maybe<Scalars['Int']['output']>;
  teachingGroupName?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_TeachingGroupAttendancePage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_TeachingGroupAttendancePage';
  data: Array<ImportVsware2_TeachingGroupAttendance>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_TeachingGroupInfo = {
  __typename?: 'ImportVsware2_TeachingGroupInfo';
  blockName?: Maybe<Scalars['String']['output']>;
  classGroup?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['Int']['output']>;
  courseYear?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  studyLevel?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teachingGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_TeachingGroupInfoPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_TeachingGroupInfoPage';
  data: Array<ImportVsware2_TeachingGroupInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_TeachingGroupMembership = {
  __typename?: 'ImportVsware2_TeachingGroupMembership';
  academicYear?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
  teachingGroupId?: Maybe<Scalars['Int']['output']>;
  teachingGroupName?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware2_TeachingGroupMembershipPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_TeachingGroupMembershipPage';
  data: Array<ImportVsware2_TeachingGroupMembership>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_Timetable = {
  __typename?: 'ImportVsware2_Timetable';
  academicYear?: Maybe<Scalars['Int']['output']>;
  academicYearName?: Maybe<Scalars['String']['output']>;
  day?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  gridId?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  periodCode?: Maybe<Scalars['String']['output']>;
  periodId?: Maybe<Scalars['Long']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  skipped?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  teacherFullName?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teachingGroup?: Maybe<Scalars['String']['output']>;
  teachingGroupId?: Maybe<Scalars['Long']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware2_TimetablePage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_TimetablePage';
  data: Array<ImportVsware2_Timetable>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_UnexplainedAbsenceNotification = {
  __typename?: 'ImportVsware2_UnexplainedAbsenceNotification';
  importMetaId?: Maybe<Scalars['Int']['output']>;
  learnerId?: Maybe<Scalars['Float']['output']>;
  receiverName?: Maybe<Scalars['String']['output']>;
  sentOn?: Maybe<Scalars['DateTime']['output']>;
  session?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  viewedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type ImportVsware2_UnexplainedAbsenceNotificationPage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_UnexplainedAbsenceNotificationPage';
  data: Array<ImportVsware2_UnexplainedAbsenceNotification>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware2_UpsertSchoolIdentifierInput = {
  name: Scalars['String']['input'];
  tenant: Scalars['Int']['input'];
  vsIdentifier: Scalars['Int']['input'];
};

export type ImportVsware2_VsmailMessage = {
  __typename?: 'ImportVsware2_VsmailMessage';
  attachments?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  messageId?: Maybe<Scalars['Float']['output']>;
  originatedFrom?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Scalars['String']['output']>;
  sentOn?: Maybe<Scalars['DateTime']['output']>;
  startMessageId?: Maybe<Scalars['Float']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  threadid?: Maybe<Scalars['Float']['output']>;
};

export type ImportVsware2_VsmailMessagePage = ImportVsware2_PageResponse & {
  __typename?: 'ImportVsware2_VsmailMessagePage';
  data: Array<ImportVsware2_VsmailMessage>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_AcademicYear = {
  __typename?: 'ImportVsware_AcademicYear';
  id?: Maybe<Scalars['Float']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

export type ImportVsware_AcademicYearPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_AcademicYearPage';
  data: Array<ImportVsware_AcademicYear>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_AssessmentCommentBank = {
  __typename?: 'ImportVsware_AssessmentCommentBank';
  commentBankDescription?: Maybe<Scalars['String']['output']>;
  commentBankId?: Maybe<Scalars['Long']['output']>;
  commentBankName?: Maybe<Scalars['String']['output']>;
  commentBankStatus?: Maybe<Scalars['Boolean']['output']>;
  commentRow?: Maybe<Scalars['String']['output']>;
  commentRowId?: Maybe<Scalars['Long']['output']>;
  commentRowStatus?: Maybe<Scalars['Boolean']['output']>;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware_AssessmentCommentBankPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_AssessmentCommentBankPage';
  data: Array<ImportVsware_AssessmentCommentBank>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_AssessmentCommentInfo = {
  __typename?: 'ImportVsware_AssessmentCommentInfo';
  comment?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware_AssessmentCommentInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_AssessmentCommentInfoPage';
  data: Array<ImportVsware_AssessmentCommentInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_AssessmentGradeSet = {
  __typename?: 'ImportVsware_AssessmentGradeSet';
  gradeDescription?: Maybe<Scalars['String']['output']>;
  gradeEndMark?: Maybe<Scalars['Int']['output']>;
  gradeOrder?: Maybe<Scalars['Int']['output']>;
  gradeSetActive?: Maybe<Scalars['Boolean']['output']>;
  gradeSetCba?: Maybe<Scalars['Boolean']['output']>;
  gradeSetCreatedOn?: Maybe<Scalars['DateTime']['output']>;
  gradeSetDefault?: Maybe<Scalars['Boolean']['output']>;
  gradeSetDescription?: Maybe<Scalars['String']['output']>;
  gradeSetName?: Maybe<Scalars['String']['output']>;
  gradeSetPpodCba?: Maybe<Scalars['Boolean']['output']>;
  gradeStartMark?: Maybe<Scalars['Int']['output']>;
  gradeValue?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  masterYearLevelId?: Maybe<Scalars['String']['output']>;
  passThreshold?: Maybe<Scalars['Int']['output']>;
  studyLevel?: Maybe<Scalars['String']['output']>;
  studyLevelDescription?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_AssessmentGradeSetPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_AssessmentGradeSetPage';
  data: Array<ImportVsware_AssessmentGradeSet>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_AssessmentResult = {
  __typename?: 'ImportVsware_AssessmentResult';
  examAcademicYear?: Maybe<Scalars['Float']['output']>;
  examComment?: Maybe<Scalars['String']['output']>;
  examName?: Maybe<Scalars['String']['output']>;
  extrafield_1?: Maybe<Scalars['String']['output']>;
  extrafield_1Description?: Maybe<Scalars['String']['output']>;
  extrafield_2?: Maybe<Scalars['String']['output']>;
  extrafield_2Description?: Maybe<Scalars['String']['output']>;
  extrafield_3?: Maybe<Scalars['String']['output']>;
  extrafield_3Description?: Maybe<Scalars['String']['output']>;
  extrafield_4?: Maybe<Scalars['Boolean']['output']>;
  extrafield_4Description?: Maybe<Scalars['String']['output']>;
  extrafield_5?: Maybe<Scalars['Boolean']['output']>;
  extrafield_5Description?: Maybe<Scalars['String']['output']>;
  extrafield_6?: Maybe<Scalars['Boolean']['output']>;
  extrafield_6Description?: Maybe<Scalars['String']['output']>;
  extrafield_7?: Maybe<Scalars['Boolean']['output']>;
  extrafield_7Description?: Maybe<Scalars['String']['output']>;
  extrafield_8?: Maybe<Scalars['Boolean']['output']>;
  extrafield_8Description?: Maybe<Scalars['String']['output']>;
  extrafield_9?: Maybe<Scalars['Boolean']['output']>;
  extrafield_9Description?: Maybe<Scalars['String']['output']>;
  extrafield_10?: Maybe<Scalars['Boolean']['output']>;
  extrafield_10Description?: Maybe<Scalars['Boolean']['output']>;
  extrafield_11?: Maybe<Scalars['Boolean']['output']>;
  extrafield_11Description?: Maybe<Scalars['Boolean']['output']>;
  extrafield_12?: Maybe<Scalars['Boolean']['output']>;
  extrafield_12Description?: Maybe<Scalars['Boolean']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['Float']['output']>;
  resultNote?: Maybe<Scalars['String']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
  subjectName?: Maybe<Scalars['String']['output']>;
  teachersName?: Maybe<Scalars['String']['output']>;
  teachingGroup?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_AssessmentResultExtraFieldInfo = {
  __typename?: 'ImportVsware_AssessmentResultExtraFieldInfo';
  description?: Maybe<Scalars['String']['output']>;
  examId?: Maybe<Scalars['Int']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  learnerId?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teachinggroupId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_AssessmentResultExtraFieldInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_AssessmentResultExtraFieldInfoPage';
  data: Array<ImportVsware_AssessmentResultExtraFieldInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_AssessmentResultInfo = {
  __typename?: 'ImportVsware_AssessmentResultInfo';
  commentId?: Maybe<Scalars['String']['output']>;
  examAcademicYear?: Maybe<Scalars['Int']['output']>;
  examId?: Maybe<Scalars['Int']['output']>;
  examName?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  resultCommentId?: Maybe<Scalars['Long']['output']>;
  resultGrade?: Maybe<Scalars['String']['output']>;
  resultNote?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
  studyLevelCode?: Maybe<Scalars['String']['output']>;
  studyLevelDescription?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teachingGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware_AssessmentResultInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_AssessmentResultInfoPage';
  data: Array<ImportVsware_AssessmentResultInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_AssessmentResultPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_AssessmentResultPage';
  data: Array<ImportVsware_AssessmentResult>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_AssessmentStudentCommentInfo = {
  __typename?: 'ImportVsware_AssessmentStudentCommentInfo';
  commenterType?: Maybe<Scalars['String']['output']>;
  examComment?: Maybe<Scalars['String']['output']>;
  examId?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware_AssessmentStudentCommentInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_AssessmentStudentCommentInfoPage';
  data: Array<ImportVsware_AssessmentStudentCommentInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_AttendanceCode = {
  __typename?: 'ImportVsware_AttendanceCode';
  attendanceCode?: Maybe<Scalars['String']['output']>;
  attendanceType?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_AttendanceCodePage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_AttendanceCodePage';
  data: Array<ImportVsware_AttendanceCode>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_BellTime = {
  __typename?: 'ImportVsware_BellTime';
  academicYear?: Maybe<Scalars['Long']['output']>;
  bellTime?: Maybe<Scalars['String']['output']>;
  bellTimeCode?: Maybe<Scalars['String']['output']>;
  bellTimeName?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  weekDay?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_BellTimePage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_BellTimePage';
  data: Array<ImportVsware_BellTime>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_ExamInfo = {
  __typename?: 'ImportVsware_ExamInfo';
  academicYearId?: Maybe<Scalars['Int']['output']>;
  commentBankId?: Maybe<Scalars['Long']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  examDescription?: Maybe<Scalars['String']['output']>;
  examId?: Maybe<Scalars['String']['output']>;
  examName?: Maybe<Scalars['String']['output']>;
  examType?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  schoolYear?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  studyLevel?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_ExamInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_ExamInfoPage';
  data: Array<ImportVsware_ExamInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_FeeInfo = {
  __typename?: 'ImportVsware_FeeInfo';
  discountAvailable?: Maybe<Scalars['Boolean']['output']>;
  feeAmount?: Maybe<Scalars['Float']['output']>;
  feeDueBy?: Maybe<Scalars['Date']['output']>;
  feeId?: Maybe<Scalars['Float']['output']>;
  feeName?: Maybe<Scalars['String']['output']>;
  feePaidOn?: Maybe<Scalars['Date']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  methodOfPayment?: Maybe<Scalars['String']['output']>;
  paymentAdditionalInformation?: Maybe<Scalars['String']['output']>;
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  paymentReference?: Maybe<Scalars['String']['output']>;
  receiptNumber?: Maybe<Scalars['Float']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_FeeInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_FeeInfoPage';
  data: Array<ImportVsware_FeeInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_Filter = {
  importId?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<FilterOptions>;
};

export type ImportVsware_FreeformMembership = {
  __typename?: 'ImportVsware_FreeformMembership';
  freeformGroupName?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
};

export type ImportVsware_FreeformMembershipPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_FreeformMembershipPage';
  data: Array<ImportVsware_FreeformMembership>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_ImportMeta = {
  __typename?: 'ImportVsware_ImportMeta';
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startedOn?: Maybe<Scalars['DateTime']['output']>;
  stepCompleted?: Maybe<Scalars['Int']['output']>;
  tenant?: Maybe<Scalars['Int']['output']>;
  updatingUser?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware_ImportMetaPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_ImportMetaPage';
  data: Array<ImportVsware_ImportMeta>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_IndividualStudentCustomField = {
  __typename?: 'ImportVsware_IndividualStudentCustomField';
  customFieldId?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  learnerId?: Maybe<Scalars['Long']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_IndividualStudentCustomFieldPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_IndividualStudentCustomFieldPage';
  data: Array<ImportVsware_IndividualStudentCustomField>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_NonClassContactHours = {
  __typename?: 'ImportVsware_NonClassContactHours';
  activityCode?: Maybe<Scalars['String']['output']>;
  activityDescription?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['String']['output']>;
  dayOfTheWeek?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  minutes?: Maybe<Scalars['Int']['output']>;
  teacherFullName?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Long']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_NonClassContactHoursPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_NonClassContactHoursPage';
  data: Array<ImportVsware_NonClassContactHours>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_PageResponse = {
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_Qualification = {
  __typename?: 'ImportVsware_Qualification';
  collegename?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['Boolean']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  qualificationClassOfDegree?: Maybe<Scalars['String']['output']>;
  qualificationDescription?: Maybe<Scalars['Boolean']['output']>;
  qualificationName?: Maybe<Scalars['String']['output']>;
  qualificationType?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  subjectCodeType?: Maybe<Scalars['String']['output']>;
  teacherFullName?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_QualificationPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_QualificationPage';
  data: Array<ImportVsware_Qualification>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_RelationshipInfo = {
  __typename?: 'ImportVsware_RelationshipInfo';
  contactAddressLine_1?: Maybe<Scalars['String']['output']>;
  contactAddressLine_2?: Maybe<Scalars['String']['output']>;
  contactAddressLine_3?: Maybe<Scalars['String']['output']>;
  contactAddressLine_4?: Maybe<Scalars['String']['output']>;
  contactCountry?: Maybe<Scalars['String']['output']>;
  contactCounty?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactGender?: Maybe<Scalars['String']['output']>;
  contactHomePhone?: Maybe<Scalars['String']['output']>;
  contactMobile?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactOccupation?: Maybe<Scalars['String']['output']>;
  contactPostcode?: Maybe<Scalars['String']['output']>;
  contactTitle?: Maybe<Scalars['String']['output']>;
  contactWorkPhone?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  parentOfGuardian?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  relationshipToStudent?: Maybe<Scalars['String']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
};

export type ImportVsware_RelationshipInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_RelationshipInfoPage';
  data: Array<ImportVsware_RelationshipInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_RoomBooking = {
  __typename?: 'ImportVsware_RoomBooking';
  bookedBy?: Maybe<Scalars['Float']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  roomBookedFrom?: Maybe<Scalars['String']['output']>;
  roomBookedTo?: Maybe<Scalars['String']['output']>;
  roomBookingDate?: Maybe<Scalars['Date']['output']>;
  roomName?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_RoomBookingPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_RoomBookingPage';
  data: Array<ImportVsware_RoomBooking>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_RoomsInfo = {
  __typename?: 'ImportVsware_RoomsInfo';
  importMetaId?: Maybe<Scalars['Int']['output']>;
  roomActive?: Maybe<Scalars['String']['output']>;
  roomCapacity?: Maybe<Scalars['Int']['output']>;
  roomDescription?: Maybe<Scalars['String']['output']>;
  roomId?: Maybe<Scalars['Int']['output']>;
  roomName?: Maybe<Scalars['String']['output']>;
  roomPool?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_RoomsInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_RoomsInfoPage';
  data: Array<ImportVsware_RoomsInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_SchoolInfo = {
  __typename?: 'ImportVsware_SchoolInfo';
  boardOfManagementChairperson?: Maybe<Scalars['String']['output']>;
  boardOfManagementChairpersonPhone?: Maybe<Scalars['String']['output']>;
  coOpSchool_1?: Maybe<Scalars['String']['output']>;
  coOpSchool_2?: Maybe<Scalars['String']['output']>;
  countryCallingCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fiveDayBoarding?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  irishClassification?: Maybe<Scalars['Int']['output']>;
  localAuthority?: Maybe<Scalars['String']['output']>;
  localAuthorityCode?: Maybe<Scalars['Int']['output']>;
  localauthoritycode_2?: Maybe<Scalars['String']['output']>;
  octoberReturnsContactPerson?: Maybe<Scalars['String']['output']>;
  octoberReturnsContactPersonEmail?: Maybe<Scalars['String']['output']>;
  octoberReturnsContactPersonFax?: Maybe<Scalars['String']['output']>;
  octoberReturnsContactPersonPhone?: Maybe<Scalars['String']['output']>;
  ownerAddressLine_1?: Maybe<Scalars['String']['output']>;
  ownerAddressLine_2?: Maybe<Scalars['String']['output']>;
  ownerAddressLine_3?: Maybe<Scalars['String']['output']>;
  ownerAddressLine_4?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  parentsAssociation?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['Int']['output']>;
  rollNumber?: Maybe<Scalars['String']['output']>;
  schoolAddressLine_1?: Maybe<Scalars['String']['output']>;
  schoolAddressLine_2?: Maybe<Scalars['String']['output']>;
  schoolAddressLine_3?: Maybe<Scalars['String']['output']>;
  schoolAddressLine_4?: Maybe<Scalars['String']['output']>;
  schoolGender?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  schoolWebsite?: Maybe<Scalars['String']['output']>;
  sevenDayBoarding?: Maybe<Scalars['String']['output']>;
  studentCouncil?: Maybe<Scalars['String']['output']>;
  trusteeAAddressLine_1?: Maybe<Scalars['String']['output']>;
  trusteeAAddressLine_2?: Maybe<Scalars['String']['output']>;
  trusteeAAddressLine_3?: Maybe<Scalars['String']['output']>;
  trusteeAAddressLine_4?: Maybe<Scalars['String']['output']>;
  trusteeAName?: Maybe<Scalars['String']['output']>;
  trusteeBAddressLine_1?: Maybe<Scalars['String']['output']>;
  trusteeBAddressLine_2?: Maybe<Scalars['String']['output']>;
  trusteeBAddressLine_3?: Maybe<Scalars['String']['output']>;
  trusteeBAddressLine_4?: Maybe<Scalars['String']['output']>;
  trusteeBName?: Maybe<Scalars['String']['output']>;
  trusteeCAddressLine_1?: Maybe<Scalars['String']['output']>;
  trusteeCAddressLine_2?: Maybe<Scalars['String']['output']>;
  trusteeCAddressLine_3?: Maybe<Scalars['String']['output']>;
  trusteeCAddressLine_4?: Maybe<Scalars['String']['output']>;
  trusteeCName?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_SchoolInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_SchoolInfoPage';
  data: Array<ImportVsware_SchoolInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_Sibling = {
  __typename?: 'ImportVsware_Sibling';
  contactAddressLine_1?: Maybe<Scalars['String']['output']>;
  contactAddressLine_2?: Maybe<Scalars['String']['output']>;
  contactAddressLine_3?: Maybe<Scalars['String']['output']>;
  contactAddressLine_4?: Maybe<Scalars['String']['output']>;
  contactCountry?: Maybe<Scalars['String']['output']>;
  contactCounty?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactGender?: Maybe<Scalars['String']['output']>;
  contactHomePhone?: Maybe<Scalars['String']['output']>;
  contactMobile?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactOccupation?: Maybe<Scalars['String']['output']>;
  contactPostcode?: Maybe<Scalars['String']['output']>;
  contactTitle?: Maybe<Scalars['String']['output']>;
  contactWorkPhone?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  parentOfGuardian?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  relationshipToStudent?: Maybe<Scalars['String']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
  userInfoId?: Maybe<Scalars['Int']['output']>;
  userInfoId_2?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware_SiblingPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_SiblingPage';
  data: Array<ImportVsware_Sibling>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_StatutoryAttendance = {
  __typename?: 'ImportVsware_StatutoryAttendance';
  attendanceCode?: Maybe<Scalars['String']['output']>;
  attendanceDate?: Maybe<Scalars['Date']['output']>;
  attendanceNote?: Maybe<Scalars['Boolean']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  session?: Maybe<Scalars['String']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware_StatutoryAttendancePage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_StatutoryAttendancePage';
  data: Array<ImportVsware_StatutoryAttendance>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_Student = {
  __typename?: 'ImportVsware_Student';
  borderIndicator?: Maybe<Scalars['Boolean']['output']>;
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dateOfEntry?: Maybe<Scalars['String']['output']>;
  departmentPupilId?: Maybe<Scalars['String']['output']>;
  examEntrant?: Maybe<Scalars['Boolean']['output']>;
  examNumber?: Maybe<Scalars['String']['output']>;
  examRepeat?: Maybe<Scalars['Boolean']['output']>;
  exitDate?: Maybe<Scalars['Date']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  irishExemption?: Maybe<Scalars['String']['output']>;
  irishExemptionDate?: Maybe<Scalars['Date']['output']>;
  languageSupportApplicant?: Maybe<Scalars['Boolean']['output']>;
  lcvp?: Maybe<Scalars['Boolean']['output']>;
  leavingReason?: Maybe<Scalars['String']['output']>;
  leftEarly?: Maybe<Scalars['Boolean']['output']>;
  leftSchool?: Maybe<Scalars['Boolean']['output']>;
  lockerNumber?: Maybe<Scalars['String']['output']>;
  medicalCard?: Maybe<Scalars['Boolean']['output']>;
  mothersMaidenName?: Maybe<Scalars['String']['output']>;
  newEntrant?: Maybe<Scalars['Boolean']['output']>;
  ppsNumber?: Maybe<Scalars['String']['output']>;
  preferredFirstName?: Maybe<Scalars['String']['output']>;
  previousSchoolRollNumber?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
  repeatExemptionDate?: Maybe<Scalars['Boolean']['output']>;
  repeatingYear?: Maybe<Scalars['Boolean']['output']>;
  studentEmail?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
  studentMobileNumber?: Maybe<Scalars['Float']['output']>;
  travellerHeritage?: Maybe<Scalars['Boolean']['output']>;
};

export type ImportVsware_StudentBehaviour = {
  __typename?: 'ImportVsware_StudentBehaviour';
  actionTakenNote?: Maybe<Scalars['Boolean']['output']>;
  behaviorName?: Maybe<Scalars['String']['output']>;
  behaviourNote?: Maybe<Scalars['String']['output']>;
  behaviourPoints?: Maybe<Scalars['Int']['output']>;
  behaviourType?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['Long']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  incidentDate?: Maybe<Scalars['DateTime']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
  teachingGroupId?: Maybe<Scalars['Long']['output']>;
  teachingGroupName?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_StudentBehaviourPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_StudentBehaviourPage';
  data: Array<ImportVsware_StudentBehaviour>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_StudentClasses = {
  __typename?: 'ImportVsware_StudentClasses';
  academicYear?: Maybe<Scalars['Float']['output']>;
  className?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['Int']['output']>;
  courseYear?: Maybe<Scalars['Int']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  tutorId?: Maybe<Scalars['Long']['output']>;
  tutorName?: Maybe<Scalars['String']['output']>;
  yearHeadId?: Maybe<Scalars['Long']['output']>;
  yearHeadName?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_StudentClassesPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_StudentClassesPage';
  data: Array<ImportVsware_StudentClasses>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_StudentContactInfo = {
  __typename?: 'ImportVsware_StudentContactInfo';
  addressLine_1?: Maybe<Scalars['String']['output']>;
  addressLine_2?: Maybe<Scalars['String']['output']>;
  addressLine_3?: Maybe<Scalars['String']['output']>;
  addressLine_4?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  guardianshipDetails?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  postalTitle?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_StudentContactInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_StudentContactInfoPage';
  data: Array<ImportVsware_StudentContactInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_StudentCustomField = {
  __typename?: 'ImportVsware_StudentCustomField';
  category?: Maybe<Scalars['String']['output']>;
  customFieldId?: Maybe<Scalars['Long']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_StudentCustomFieldPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_StudentCustomFieldPage';
  data: Array<ImportVsware_StudentCustomField>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_StudentExclusion = {
  __typename?: 'ImportVsware_StudentExclusion';
  exclusionEndDate?: Maybe<Scalars['String']['output']>;
  exclusionNote?: Maybe<Scalars['String']['output']>;
  exclusionReason?: Maybe<Scalars['String']['output']>;
  exclusionStartDate?: Maybe<Scalars['String']['output']>;
  exclusionType?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
};

export type ImportVsware_StudentExclusionPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_StudentExclusionPage';
  data: Array<ImportVsware_StudentExclusion>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_StudentMedicalInfo = {
  __typename?: 'ImportVsware_StudentMedicalInfo';
  creationDate?: Maybe<Scalars['String']['output']>;
  doctorsName?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  medicalDescription?: Maybe<Scalars['String']['output']>;
  medicalNote?: Maybe<Scalars['String']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
};

export type ImportVsware_StudentMedicalInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_StudentMedicalInfoPage';
  data: Array<ImportVsware_StudentMedicalInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_StudentNote = {
  __typename?: 'ImportVsware_StudentNote';
  importMetaId?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteCreatorFullName?: Maybe<Scalars['String']['output']>;
  noteCreatorId?: Maybe<Scalars['Int']['output']>;
  noteDate?: Maybe<Scalars['String']['output']>;
  noteTitle?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware_StudentNotePage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_StudentNotePage';
  data: Array<ImportVsware_StudentNote>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_StudentPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_StudentPage';
  data: Array<ImportVsware_Student>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_StudentSenInfo = {
  __typename?: 'ImportVsware_StudentSenInfo';
  importMetaId?: Maybe<Scalars['Int']['output']>;
  senContact?: Maybe<Scalars['String']['output']>;
  senEndDate?: Maybe<Scalars['String']['output']>;
  senNote?: Maybe<Scalars['String']['output']>;
  senProvision?: Maybe<Scalars['String']['output']>;
  senStartDate?: Maybe<Scalars['String']['output']>;
  senType?: Maybe<Scalars['String']['output']>;
  senTypeNote?: Maybe<Scalars['String']['output']>;
  snaSupport?: Maybe<Scalars['String']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_StudentSenInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_StudentSenInfoPage';
  data: Array<ImportVsware_StudentSenInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_SubstitutionAbsenceInfo = {
  __typename?: 'ImportVsware_SubstitutionAbsenceInfo';
  absenceCategory?: Maybe<Scalars['String']['output']>;
  absenceNote?: Maybe<Scalars['String']['output']>;
  absenceReason?: Maybe<Scalars['String']['output']>;
  absenceType?: Maybe<Scalars['String']['output']>;
  academicYearId?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  endPeriod?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  startPeriod?: Maybe<Scalars['String']['output']>;
  substitutionAbsenceId?: Maybe<Scalars['Long']['output']>;
  teacherId?: Maybe<Scalars['Long']['output']>;
};

export type ImportVsware_SubstitutionAbsenceInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_SubstitutionAbsenceInfoPage';
  data: Array<ImportVsware_SubstitutionAbsenceInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_SubstitutionInfo = {
  __typename?: 'ImportVsware_SubstitutionInfo';
  absenceId?: Maybe<Scalars['Long']['output']>;
  coverNote?: Maybe<Scalars['String']['output']>;
  coverReason?: Maybe<Scalars['Boolean']['output']>;
  coverType?: Maybe<Scalars['String']['output']>;
  coveredTeacherFullName?: Maybe<Scalars['String']['output']>;
  coveredTeacherId?: Maybe<Scalars['Float']['output']>;
  coveringTeacherFullName?: Maybe<Scalars['String']['output']>;
  coveringTeacherId?: Maybe<Scalars['Float']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  periodEndTime?: Maybe<Scalars['String']['output']>;
  periodStartTime?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  substitutionCoverDate?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_SubstitutionInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_SubstitutionInfoPage';
  data: Array<ImportVsware_SubstitutionInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_Teacher = {
  __typename?: 'ImportVsware_Teacher';
  addressLine_1?: Maybe<Scalars['String']['output']>;
  addressLine_2?: Maybe<Scalars['String']['output']>;
  addressLine_3?: Maybe<Scalars['String']['output']>;
  addressLine_4?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  carColour?: Maybe<Scalars['String']['output']>;
  carMake?: Maybe<Scalars['String']['output']>;
  carRegistrationNumber?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dateOfEntry?: Maybe<Scalars['Date']['output']>;
  displayCode?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasLeftSchool?: Maybe<Scalars['Boolean']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  includeInTimetabling?: Maybe<Scalars['Boolean']['output']>;
  jobSharer?: Maybe<Scalars['Boolean']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  nextOfKin?: Maybe<Scalars['String']['output']>;
  nextOfKinsPhoneNumber?: Maybe<Scalars['String']['output']>;
  parkingSpot?: Maybe<Scalars['String']['output']>;
  payrollNumber?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  ppsNumber?: Maybe<Scalars['String']['output']>;
  qualification_1?: Maybe<Scalars['String']['output']>;
  qualification_2?: Maybe<Scalars['String']['output']>;
  qualification_3?: Maybe<Scalars['String']['output']>;
  qualification_4?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
  teacherCouncilNumber?: Maybe<Scalars['String']['output']>;
  teacherFullName?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Float']['output']>;
  teachingPost?: Maybe<Scalars['String']['output']>;
  tutor?: Maybe<Scalars['String']['output']>;
  workPhone?: Maybe<Scalars['String']['output']>;
  yearHead?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_TeacherPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_TeacherPage';
  data: Array<ImportVsware_Teacher>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_TeachingGroupAttendance = {
  __typename?: 'ImportVsware_TeachingGroupAttendance';
  attendanceCode?: Maybe<Scalars['String']['output']>;
  attendanceDate?: Maybe<Scalars['Date']['output']>;
  attendanceNote?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['Float']['output']>;
  teachingGroupId?: Maybe<Scalars['Long']['output']>;
  teachingGroupName?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware_TeachingGroupAttendancePage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_TeachingGroupAttendancePage';
  data: Array<ImportVsware_TeachingGroupAttendance>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_TeachingGroupInfo = {
  __typename?: 'ImportVsware_TeachingGroupInfo';
  blockName?: Maybe<Scalars['String']['output']>;
  classGroup?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['Int']['output']>;
  courseYear?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  studyLevel?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  teachingGroupId?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware_TeachingGroupInfoPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_TeachingGroupInfoPage';
  data: Array<ImportVsware_TeachingGroupInfo>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_TeachingGroupMembership = {
  __typename?: 'ImportVsware_TeachingGroupMembership';
  academicYear?: Maybe<Scalars['Float']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  studentFullName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  teachingGroupId?: Maybe<Scalars['Int']['output']>;
  teachingGroupName?: Maybe<Scalars['String']['output']>;
};

export type ImportVsware_TeachingGroupMembershipPage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_TeachingGroupMembershipPage';
  data: Array<ImportVsware_TeachingGroupMembership>;
  totalCount: Scalars['Int']['output'];
};

export type ImportVsware_Timetable = {
  __typename?: 'ImportVsware_Timetable';
  academicYear?: Maybe<Scalars['String']['output']>;
  academicYearName?: Maybe<Scalars['String']['output']>;
  day?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  importMetaId?: Maybe<Scalars['Int']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  teacherFullName?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Float']['output']>;
  teachingGroup?: Maybe<Scalars['String']['output']>;
  teachingGroupId?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ImportVsware_TimetablePage = ImportVsware_PageResponse & {
  __typename?: 'ImportVsware_TimetablePage';
  data: Array<ImportVsware_Timetable>;
  totalCount: Scalars['Int']['output'];
};

export type IndividualDiscount = {
  __typename?: 'IndividualDiscount';
  adHocAmount?: Maybe<Scalars['Float']['output']>;
  /** deep linked */
  discount: Discount;
  discountId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** deep linked */
  person: Person;
  personPartyId: Scalars['Long']['output'];
};

export type IndividualDiscountFilter = {
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type IndividualDiscountInput = {
  action: BulkAction;
  adhocAmount?: InputMaybe<Scalars['Float']['input']>;
  discountId: Scalars['Int']['input'];
  feeId: Scalars['Int']['input'];
  studentPartyId: Scalars['Long']['input'];
};

export type IndividualEventFilter = {
  filterConditionsIncludeAugments?: InputMaybe<Scalars['Boolean']['input']>;
  filterConditionsIncludeExclusions?: InputMaybe<Scalars['Boolean']['input']>;
  orConditions?: InputMaybe<Array<Calendar_DatetimeFilterCondition>>;
};

export enum InfoRequestType {
  Options = 'OPTIONS'
}

export type InputAddress = {
  active: Scalars['Boolean']['input'];
  addressId?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  line4?: InputMaybe<Scalars['String']['input']>;
  line5?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  primaryAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputEmailAddress = {
  active: Scalars['Boolean']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailId?: InputMaybe<Scalars['Int']['input']>;
  primaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputNextOfKin = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InputPhoneNumber = {
  active: Scalars['Boolean']['input'];
  areaCode?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  phoneNumberId?: InputMaybe<Scalars['Int']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputStaffEmergencyContact = {
  additionalNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  primaryNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum InstallmentStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export type InstantPaymentInput = {
  amount: Scalars['Float']['input'];
  feeId: Scalars['Int']['input'];
  feesAbsorbed?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  serviceCharges?: InputMaybe<Scalars['Float']['input']>;
  studentPartyId: Scalars['Long']['input'];
};

export type InviteUser = {
  email: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  globalUserId?: InputMaybe<Scalars['Int']['input']>;
  invitedEmail?: InputMaybe<Scalars['String']['input']>;
  personPartyId: Scalars['Long']['input'];
  profileId: Scalars['Int']['input'];
  resend: Scalars['Boolean']['input'];
  surname: Scalars['String']['input'];
  userType: UserType;
};

export type InviteUsersResponse = {
  __typename?: 'InviteUsersResponse';
  userAccesses: Array<UserAccess>;
  validations?: Maybe<Array<Maybe<UserAccessValidation>>>;
};

export type InviteVerificationInput = {
  code: Scalars['String']['input'];
  existingPartyId: Scalars['Long']['input'];
  existingProfileId: Scalars['Int']['input'];
  globalUserId: Scalars['Int']['input'];
  newPartyId: Scalars['Long']['input'];
  newProfileId: Scalars['Int']['input'];
};

export type InvoiceResponse = {
  __typename?: 'InvoiceResponse';
  amount: Scalars['Float']['output'];
  dueOn: Scalars['DateTime']['output'];
  invoiceNumber: Scalars['String']['output'];
  xeroInvoiceId: Scalars['String']['output'];
};

export enum Iterator {
  Closest = 'CLOSEST',
  Next = 'NEXT',
  Previous = 'PREVIOUS'
}

export type Label = {
  __typename?: 'Label';
  colour?: Maybe<Colour>;
  custom?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  personPartyId: Scalars['Long']['output'];
  type: LabelType;
};

export type LabelFilter = {
  id?: InputMaybe<Scalars['Long']['input']>;
  personPartyId?: InputMaybe<Scalars['Long']['input']>;
};

export type LabelInput = {
  colour?: InputMaybe<Colour>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
};

export enum LabelSizeType {
  '1x7' = '_1x7',
  '1x8' = '_1x8',
  '2x7' = '_2x7',
  '2x8' = '_2x8',
  '3x7' = '_3x7',
  '3x8' = '_3x8',
  '4x7' = '_4x7',
  '4x8' = '_4x8'
}

export enum LabelType {
  Archive = 'Archive',
  Custom = 'Custom',
  Inbox = 'Inbox',
  Outbox = 'Outbox'
}

export type Layout_Config = {
  __typename?: 'Layout_Config';
  configKey: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  lockedWidgets?: Maybe<Array<Scalars['String']['output']>>;
  userId?: Maybe<Scalars['Long']['output']>;
  widgets: Scalars['Object']['output'];
};

export type Layout_ConfigFilter = {
  configKey: Scalars['String']['input'];
};

export type Layout_ConfigsFilter = {
  configKeyPrefix?: InputMaybe<Scalars['String']['input']>;
};

export type Layout_DeleteConfigInput = {
  configKey: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Long']['input']>;
};

export type Layout_UpsertConfigInput = {
  configKey: Scalars['String']['input'];
  lockedWidgets?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['Long']['input']>;
  widgets: Scalars['Object']['input'];
};

export type ListString = {
  __typename?: 'ListString';
  values: Array<Scalars['String']['output']>;
};

export type Locale = {
  __typename?: 'Locale';
  id: Scalars['Int']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LoginAudit = {
  __typename?: 'LoginAudit';
  globalUserId: Scalars['Int']['output'];
  ipAddress: Scalars['String']['output'];
  loggedInTime: Scalars['DateTime']['output'];
  partyId: Scalars['Long']['output'];
  person: Person;
};

export type LoginAuditFilter = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mail = {
  __typename?: 'Mail';
  hasAttachments: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  labels: Array<Label>;
  lastThreadMessage: Scalars['DateTime']['output'];
  lastThreadMessageBody: Scalars['String']['output'];
  lastThreadMessageId: Scalars['Long']['output'];
  read: Scalars['Boolean']['output'];
  resolvedRecipients: Array<ResolvedRecipient>;
  scheduleFor?: Maybe<Scalars['DateTime']['output']>;
  senders: Array<MailSender>;
  subject: Scalars['String']['output'];
  threadId: Scalars['Long']['output'];
};

export type MailFilter = {
  labelId?: InputMaybe<Scalars['Long']['input']>;
  pagination: Pagination;
  rulesEngineMail?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  schedulerPartyId?: InputMaybe<Scalars['Long']['input']>;
  schoolMail: Scalars['Boolean']['input'];
  threadIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type MailReadInput = {
  schoolMail: Scalars['Boolean']['input'];
  threadMessageId: Scalars['Long']['input'];
};

export type MailSearchFilter = {
  from?: InputMaybe<Scalars['Date']['input']>;
  pagination: Pagination;
  recipientPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  schoolMail: Scalars['Boolean']['input'];
  senderPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type MailSender = {
  __typename?: 'MailSender';
  sender: Person;
  senderName: Scalars['String']['output'];
  senderPartyId: Scalars['Long']['output'];
};

export type MailStarredInput = {
  mailId: Scalars['Long']['input'];
  starred: Scalars['Boolean']['input'];
  threadId: Scalars['Long']['input'];
  threadMessageId: Scalars['Long']['input'];
};

export type MailThread = {
  __typename?: 'MailThread';
  attachmentIds?: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  attachments: Array<Attachment>;
  body?: Maybe<Scalars['String']['output']>;
  canReply: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  labels: Array<Label>;
  latestMessage?: Maybe<Scalars['DateTime']['output']>;
  readOn?: Maybe<Scalars['DateTime']['output']>;
  recipients: Array<Recipient>;
  resolvedRecipients: Array<ResolvedRecipient>;
  scheduleFor?: Maybe<Scalars['DateTime']['output']>;
  sender: Person;
  senderPartyId: Scalars['Long']['output'];
  sentOn: Scalars['DateTime']['output'];
  starred?: Maybe<Scalars['Boolean']['output']>;
  subject: Scalars['String']['output'];
  threadId?: Maybe<Scalars['Long']['output']>;
  threadMessageId?: Maybe<Scalars['Long']['output']>;
};

export type MailThreadFilter = {
  mailId?: InputMaybe<Scalars['Long']['input']>;
  rulesEngineMail?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  schoolMail: Scalars['Boolean']['input'];
  threadId?: InputMaybe<Scalars['Long']['input']>;
  threadMessageId?: InputMaybe<Scalars['Long']['input']>;
};

export type MakePaymentInput = {
  bankTransferReference?: InputMaybe<Scalars['String']['input']>;
  instantPayments?: InputMaybe<Array<InstantPaymentInput>>;
  onBehalfOfEmail?: InputMaybe<Scalars['String']['input']>;
  onBehalfOfPartyId?: InputMaybe<Scalars['Long']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethod;
  paymentStatus: PaymentStatus;
  recurringPayments?: InputMaybe<Array<RecurringPaymentInput>>;
  saveCard?: InputMaybe<Scalars['Boolean']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
};

export enum MemberType {
  Admin = 'ADMIN',
  Contact = 'CONTACT',
  External = 'EXTERNAL',
  Staff = 'STAFF',
  Student = 'STUDENT',
  ThirdParty = 'THIRD_PARTY'
}

export type MergeDuplicateProfilesInput = {
  mergeFromPartyId: Scalars['Long']['input'];
  mergeIntoPartyId: Scalars['Long']['input'];
};

export type MergeUserProfiles = {
  mergeIntoPartyId: Scalars['Long']['input'];
  partyIdsToMerge: Array<Scalars['Long']['input']>;
};

export type MoveFileTransferInput = {
  moves: Array<FileMoveRequest>;
};

export type Mutation = {
  __typename?: 'Mutation';
  admin__refreshTenantSearch: Success;
  admin__resetTenantCache: Success;
  asd?: Maybe<Scalars['String']['output']>;
  assessment_archiveClassAssessment: Success;
  assessment_archiveStateCbaAssessment: Success;
  assessment_archiveTermAssessment: Success;
  assessment_deleteStateCbaAssessment: Success;
  assessment_publish: Success;
  assessment_publishPPODResults?: Maybe<Array<AssessmentResult>>;
  assessment_publishStateCba: Success;
  assessment_saveAssessmentComments?: Maybe<Array<AssessmentComment>>;
  assessment_saveAssessmentResults?: Maybe<Array<AssessmentResult>>;
  assessment_saveClassAssessment?: Maybe<Assessment>;
  assessment_saveCommentBank?: Maybe<Array<Maybe<CommentBank>>>;
  assessment_saveGradeSet?: Maybe<GradeSet>;
  assessment_saveStateCbaAssessment?: Maybe<Assessment>;
  assessment_saveTermAssessment?: Maybe<Assessment>;
  assessment_setOpenForResultEntry?: Maybe<Assessment>;
  assessment_studentAssessmentExclusion: Success;
  assessment_unarchiveClassAssessment: Success;
  assessment_unarchiveStateCbaAssessment: Success;
  assessment_unarchiveTermAssessment: Success;
  assessment_updateGradeSet?: Maybe<Array<Maybe<GradeSet>>>;
  assessment_updateStudentSubjectGroup: Success;
  assessment_verifyPPODResults?: Maybe<PpodVerificationReport>;
  attendance_deleteSignInOut?: Maybe<Success>;
  attendance_mergeAttendanceCodes: Success;
  attendance_rollBackAndSaveNewBulkAttendance?: Maybe<Success>;
  attendance_rollBackBulkAttendance?: Maybe<Success>;
  attendance_saveAttendanceCode: Array<AttendanceCode>;
  attendance_saveBulkAttendance?: Maybe<Success>;
  attendance_saveEventAttendance: Array<EventAttendance>;
  attendance_saveParentalAttendanceRequest: Array<ParentalAttendanceRequest>;
  attendance_saveSchoolActivityEventAttendance: Success;
  attendance_saveSignInOut: Array<SignInOut>;
  attendance_saveStudentSessionAttendance: Array<StudentSessionAttendance>;
  attendance_saveThirdPartyEventAttendance?: Maybe<Success>;
  attendance_saveThirdPartySessionAttendance?: Maybe<Success>;
  attendance_undoParentalAttendanceRequest?: Maybe<Success>;
  attendance_updateParentalAttendanceRequest: Array<ParentalAttendanceRequest>;
  attendance_withdrawParentalAttendanceRequest?: Maybe<Success>;
  calendar_cloneEvent?: Maybe<Success>;
  calendar_createCalendar?: Maybe<Calendar>;
  calendar_createCalendarEvents: Calendar_UpdateEventResult;
  calendar_createSchoolDayTypeInput?: Maybe<Success>;
  calendar_deleteCalendarEvents?: Maybe<Success>;
  calendar_deleteEventCancellations?: Maybe<Success>;
  calendar_deleteFollowers?: Maybe<Success>;
  calendar_editCalendarEvents: Calendar_UpdateEventResult;
  calendar_ical_schoolCalendarConfigure?: Maybe<Success>;
  calendar_manuallyCancelEvents?: Maybe<Success>;
  calendar_updateCalendarBellTimes?: Maybe<Success>;
  calendar_updateCalendarDayTimes?: Maybe<Success>;
  calendar_updateCalendarDays?: Maybe<Success>;
  calendar_upsertBellTime?: Maybe<Success>;
  calendar_upsertEventTag: Success;
  calendar_upsertFollower?: Maybe<Calendar_FollowUpsertResult>;
  catalogue_createSubject?: Maybe<Subject>;
  catalogue_deleteGroupTag?: Maybe<CatalogueSuccess>;
  catalogue_deletePeopleTag?: Maybe<CatalogueSuccess>;
  catalogue_deleteSubject?: Maybe<CatalogueSuccess>;
  catalogue_importProgrammeData?: Maybe<Catalogue_ImportProgrammeDataResult>;
  catalogue_systemSettingsUpdate: Array<Catalogue_SystemSettingsUpdateResult>;
  catalogue_updateSubjects?: Maybe<CatalogueSuccess>;
  catalogue_upsertGroupTag?: Maybe<CatalogueSuccess>;
  catalogue_upsertPeopleTag?: Maybe<CatalogueSuccess>;
  catalogue_upsertProgramme?: Maybe<CatalogueSuccess>;
  catalogue_upsertProgrammeStage?: Maybe<CatalogueSuccess>;
  catalogue_upsertProgrammeStageSubjects?: Maybe<CatalogueSuccess>;
  catalogue_upsertProgrammeStages?: Maybe<CatalogueSuccess>;
  communications_acknowledgeNotice: Success;
  communications_archiveMail: Success;
  communications_archiveNotice: Success;
  communications_assignLabel?: Maybe<Mail>;
  communications_deleteNotice: Success;
  communications_deleteScheduledMail: Success;
  communications_deleteScheduledSms: Success;
  /** social media endpoints */
  communications_disconnectPlatform: Success;
  communications_noticeboardConfigure: Success;
  /** xero on endpoints */
  communications_purchaseAddOn: Success;
  communications_read?: Maybe<Scalars['String']['output']>;
  communications_readNotification?: Maybe<Success>;
  communications_recallMail?: Maybe<Success>;
  /** notifications endpoints */
  communications_registerDevice?: Maybe<DeviceRegistration>;
  communications_resendNotification: Success;
  communications_resendSms: Success;
  communications_retrySocialPost: Success;
  communications_saveLabel?: Maybe<Label>;
  /** noticeboard endpoints */
  communications_saveNotice: Array<Notice>;
  communications_saveNotificationSchoolSettings: Array<SchoolNotificationSetting>;
  communications_saveNotificationTemplate?: Maybe<NotificationTemplate>;
  /** mail endpoints */
  communications_sendMail?: Maybe<Mail>;
  /** sms endpoints */
  communications_sendSms?: Maybe<Scalars['String']['output']>;
  communications_smsTopUp: Success;
  communications_starred?: Maybe<Scalars['String']['output']>;
  composite_deleteStudents: Success;
  composite_switchProfile: GlobalUser;
  composite_upsertTenantSettings: Success;
  core_archiveStudentContacts: Success;
  core_copyGroups: Success;
  core_deleteBuildings: Success;
  core_deleteCampuses: Success;
  core_deleteCustomFields: Success;
  core_deleteGroups: Success;
  core_discontinueInAcademicNamespace: Success;
  core_enableBlockRotations?: Maybe<Success>;
  core_enrolInAcademicNamespace: Success;
  core_linkSiblingsAndContacts: Success;
  core_modifyBlocks: Success;
  core_modifyGroupMemberships: Success;
  core_modifySubjectGroupMembershipType: Success;
  core_reinstateStaff: Success;
  core_reinstateStudent: Success;
  core_rollOverEntity: Success;
  core_rotateBlockStudents: Success;
  core_setActiveActiveAcademicNamespace?: Maybe<AcademicNamespace>;
  core_switchSubjectGroupType: Success;
  core_updateClassGroups?: Maybe<Success>;
  core_updateProgrammeStageEnrollments?: Maybe<Success>;
  core_updateStaff: Success;
  core_updateStaffAvailability: Success;
  core_updateStudentContactRelationships?: Maybe<Success>;
  core_updateStudentContacts: Success;
  core_updateStudentSubjectGroup: Success;
  core_updateStudents?: Maybe<Success>;
  core_updateSubjectGroups?: Maybe<Success>;
  core_updateYearGroupEnrollments?: Maybe<Success>;
  core_upsertAcademicNamespace?: Maybe<AcademicNamespace>;
  core_upsertBuildings: Array<Building>;
  core_upsertCampusTravelTimes: Array<CampusTravelTime>;
  core_upsertCampuses: Array<Campus>;
  core_upsertCustomFields: Success;
  core_upsertCustomGroupDefinition: Success;
  core_upsertRoomPools: Array<RoomPool>;
  core_upsertRooms: Array<Room>;
  core_upsertStaff?: Maybe<Array<Maybe<Staff>>>;
  core_upsertStudentContact: StudentContact;
  delete_file_transfer?: Maybe<Success>;
  documentation_admin_addChangeRequestItem: Documentation_ChangeRequestItem;
  documentation_admin_approveChangeRequests: Array<Documentation_ChangeRequest>;
  documentation_admin_cancelChangeRequests: Array<Documentation_ChangeRequest>;
  documentation_admin_createChangeRequest: Documentation_ChangeRequest;
  documentation_admin_createPage: Documentation_Page;
  documentation_admin_createSpace: Documentation_Space;
  documentation_admin_deletePages?: Maybe<Success>;
  documentation_admin_deleteSpace?: Maybe<Success>;
  documentation_admin_movePage?: Maybe<Success>;
  documentation_admin_promoteRelease: Documentation_PromotionResult;
  documentation_admin_quickMergeChangeRequest: Documentation_ChangeRequest;
  documentation_admin_quickPublish: Documentation_ChangeRequest;
  documentation_admin_quickPublishBatchFromMarkdown: Documentation_QuickPublishBatchResult;
  documentation_admin_quickPublishFromMarkdown: Documentation_ChangeRequest;
  documentation_admin_refreshVideoData: Documentation_PageVideoData;
  documentation_admin_rejectChangeRequests: Array<Documentation_ChangeRequest>;
  documentation_admin_removeChangeRequestItem?: Maybe<Success>;
  documentation_admin_reorderSpaces?: Maybe<Success>;
  documentation_admin_replacePageVideoUrl: Documentation_PageVideoData;
  documentation_admin_restoreVersion: Scalars['Int']['output'];
  documentation_admin_revertChangeRequestToDraft: Documentation_ChangeRequest;
  documentation_admin_setPageMetadata?: Maybe<Success>;
  documentation_admin_submitChangeRequests: Array<Documentation_ChangeRequest>;
  documentation_admin_updateChangeRequestReleaseTag: Documentation_ChangeRequest;
  documentation_admin_updatePage: Documentation_Page;
  documentation_admin_updateSpace: Documentation_Space;
  drive_addItem: Folders_FolderItemLink;
  drive_addQuickLink: Folders_FolderQuickLink;
  drive_archiveFolder: Folders_Folder;
  drive_createFolder: Folders_Folder;
  drive_deleteFolder: Success;
  drive_deleteQuickLink: Success;
  drive_removeItem: Success;
  drive_restoreFolder: Folders_Folder;
  /**
   * Flip a folder between UI_ONLY and SHARED. Surface access rules match
   * `drive_updateFolderAcl`.
   */
  drive_setFolderType: Folders_Folder;
  drive_updateFolder: Folders_Folder;
  /**
   * Add and/or remove ACL subjects in a single call. Each change writes an
   * audit row.
   */
  drive_updateFolderAcl: Folders_FolderAcl;
  drive_updateQuickLink: Folders_FolderQuickLink;
  eire_deleteNonClassContactHours?: Maybe<Success>;
  eire_rollOverNonClassContactHours?: Maybe<Success>;
  eire_updateNonClassContactHours?: Maybe<Success>;
  eire_upsertNonClassContactHours?: Maybe<Success>;
  enrollment_ire_autoAssignBlocks: Success;
  enrollment_ire_autoAssignCore: Success;
  enrollment_ire_changeProgrammeStage: Success;
  enrollment_ire_createStudent?: Maybe<Student>;
  enrollment_ire_upsertBlockMemberships: EnrollmentIre_BlockMemberships;
  enrollment_ire_upsertCoreMemberships: EnrollmentIre_CoreMemberships;
  fees_bulkApplyIndividualDiscounts: Success;
  fees_createPayment: CreatePaymentResponse;
  fees_createSetupIntent: CreatePaymentResponse;
  fees_deleteCard: Success;
  fees_deleteDiscount: Success;
  fees_deleteFee: Success;
  fees_excludeFromFee: FeeExclusion;
  fees_migrateFee: Success;
  fees_publish: Success;
  fees_refund: Success;
  fees_saveAccountingCode: AccountingCode;
  fees_saveCategory: Category;
  fees_saveDiscount: Discount;
  fees_saveFee: Fee;
  fees_simulateBankTransfer: Success;
  fees_stripeSignUp: StripeAccount;
  fees_updatePaymentPlanCard: Success;
  fees_writeOffStudentsFee: Success;
  /** Extension point management (school admins: scoped to own tenant; Tyro: cross-tenant) */
  formsAdmin_createExtensionPoint: Scalars['Int']['output'];
  formsAdmin_deleteExtensionPoint?: Maybe<Success>;
  formsAdmin_deleteFormDefinition?: Maybe<Success>;
  formsAdmin_disableFormDefinitions: Array<Maybe<FormsFd_DefinitionId>>;
  /** School admin: register/unregister system-defined extension points */
  formsAdmin_registerExtensionPoint: Dtab_TenantExtensionPointConfig;
  formsAdmin_unregisterExtensionPoint?: Maybe<Success>;
  /** Tyro-only: cross-tenant config management */
  formsAdmin_updateTenantExtensionPointConfig: Dtab_TenantExtensionPointConfig;
  formsAdmin_upsertFormDefinitions: FormsFd_FormDefinition;
  formsAdmin_upsertInformationRequest: FormsAdmin_InformationRequestDefinition;
  formsAdmin_upsertInformationRequestUsingMetaConfig: FormsAdmin_InformationRequestDefinitionId;
  formsAdmin_upsertTags: Array<Dtab_Tag>;
  forms_deleteFormSubmission: Success;
  forms_submitInformationRequestForms: Forms_SubmitFormResponse;
  forms_upsertRows: Forms_UpsertRowsResponse;
  importCanonical_runSanityCheck: ImportCanonical_RunSanityCheckResult;
  importVsware2_deleteSchoolIdentifier?: Maybe<Success>;
  importVsware2_upsertSchoolIdentifier?: Maybe<Success>;
  layout_deleteConfig: Scalars['Boolean']['output'];
  layout_upsertConfig: Layout_Config;
  move_file_transfer?: Maybe<Success>;
  notes_deleteBehaviourCategory?: Maybe<Success>;
  notes_deleteBehaviourNote?: Maybe<Success>;
  notes_deleteBehaviourTag?: Maybe<Success>;
  notes_deleteNote?: Maybe<Success>;
  notes_resetBehaviourPoints?: Maybe<Success>;
  notes_upsertBehaviourCategory?: Maybe<Success>;
  notes_upsertBehaviourTags: Array<Notes_Tag>;
  notes_upsertNotes: Array<Notes_Note>;
  notes_upsertNotesTags: Array<Notes_Tag>;
  notesv2_upsertNote: Array<Scalars['Int']['output']>;
  optionsSol_fillInOptions: Success;
  optionsSol_modifySolutionSettings: Success;
  optionsSol_solve: Options_Solve;
  optionsSol_upsertSubjectGroupMemberships: Success;
  options_clone: Success;
  options_delete: Success;
  options_publish: Success;
  options_saveOptions: Options_Option;
  options_saveStudentPreferences: Success;
  pbac_upsertFromOverview: Pbac_UpsertResourcePolicyResult;
  pbac_upsertResourcePolicy: Pbac_UpsertResourcePolicyResult;
  ppod_savePPODCredentials: PpodCredentials;
  reporting_exportReport: Reporting_ExportReportResult;
  rot_addBlockRotations?: Maybe<Success>;
  rot_deleteRotation?: Maybe<Success>;
  rot_removeBlockRotationDate?: Maybe<Success>;
  rules_deleteTriggeredLog: Rules_Success;
  rules_revertTriggeredActions: Rules_Success;
  rules_runRule: Rules_Success;
  rules_testRule?: Maybe<Rules_RuleTestResult>;
  rules_updateCustomRule: Rules_Success;
  rules_upsertCustomRule: Rules_Success;
  sa_addRemoveStaff?: Maybe<Success>;
  sa_addRemoveStudents?: Maybe<Success>;
  sa_approveActivity?: Maybe<Success>;
  sa_deleteActivity?: Maybe<Success>;
  sa_refresh?: Maybe<Success>;
  sa_upsertActivity?: Maybe<Success>;
  sa_upsertActivityRequest?: Maybe<Success>;
  sa_upsertAttendanceCodeSettings: Success;
  sa_upsertPublish?: Maybe<Success>;
  scheduling_cancelJob: Success;
  scheduling_retryFailedJob: Scheduling_SubmitJobResult;
  scheduling_submitOneTimeJob: Scheduling_SubmitJobResult;
  scheduling_submitPollingJob: Scheduling_SubmitJobResult;
  scheduling_triggerCronNow: Scheduling_SubmitJobResult;
  scheduling_updateCronJobs: Success;
  sds_deleteSDSSettings: Success;
  sds_updateSDSSettings: Success;
  swm_applySubstitutions: Success;
  swm_changeAbsenceRequestStatus: Array<Swm_StaffAbsenceRequest>;
  swm_deleteAbsence: Success;
  swm_deleteSubstitutions: Success;
  swm_sendCoverNotifications: Success;
  swm_upsertAbsence: Swm_UpsertStaffAbsencesResponse;
  swm_upsertAbsenceRequest: Swm_StaffAbsenceRequest;
  swm_upsertAbsenceType: Array<Swm_StaffAbsenceType>;
  tasks_cancelTask: Success;
  templating_deleteLabelTemplates: Success;
  templating_deleteSavedVariableTemplates: Success;
  templating_deleteTemplates: Success;
  templating_saveTemplate: Success;
  templating_upsertLabelTemplate: Templating_LabelTemplate;
  templating_upsertSavedVariableTemplate: Success;
  timeline_deleteHighlight: Success;
  timeline_deleteHighlightComment: Success;
  timeline_saveHighlight: Timeline_Highlight;
  timeline_saveHighlightComment: Timeline_HighlightComment;
  tt_addLesson: Success;
  tt_addPeriodToEnd: Success;
  tt_addPeriodToStart: Success;
  tt_attachClassGroupsToTimetable: Tt_AttachClassGroupsResult;
  tt_cloneTimetable: TtTimetable;
  tt_createCheckpoint: Success;
  tt_createTimetable: TtTimetable;
  tt_deleteBlock: Success;
  tt_deleteClassGroup: Success;
  tt_deleteTimetableGroup: Success;
  tt_deleteTimetables: Success;
  tt_editLessonInstance: Array<TtIndividualViewLesson>;
  tt_importGroupsFromCore: Success;
  tt_infoReqRunsolver: Success;
  tt_migrateGrid: Success;
  tt_onCallSetBlank: Success;
  tt_publish: Tt_PublishResult;
  tt_publishConstruction: Tt_PublishConstructionResult;
  tt_refreshGrid: Success;
  tt_removeLesson: Success;
  tt_removeLessonBulk: Success;
  tt_reset: Success;
  tt_resetDefaultTimetableGroupName: Success;
  tt_setTimetableGroupRolloverSources: Success;
  tt_splitPeriod: Success;
  tt_swap: Success;
  tt_updateClassGroup: Success;
  tt_updateLessons: Success;
  tt_updateRoomAssignments: Success;
  tt_updateTeacher: Success;
  tt_updateTimetableGroup: Success;
  tt_upsertBlock: Success;
  tt_upsertClassGroup: Success;
  tt_upsertCoScheduleChains: Success;
  tt_upsertGrids: Success;
  tt_upsertTimetableGroup: Success;
  ttoptions_importOptions: Success;
  ttsolve_cancelSolve: Success;
  ttsolve_classDataAddSubject: Success;
  ttsolve_classDataDeleteCoreSubjects: Success;
  ttsolve_classDataDropOnBlock: Success;
  ttsolve_classDataSetSpreadOnBlock: Success;
  ttsolve_classDataSetSpreadOnCoreSubjects: Success;
  ttsolve_clearRooms: Success;
  ttsolve_clearTimeslots: Success;
  ttsolve_deleteCatalogueOverride: Success;
  ttsolve_deleteRestriction: Success;
  ttsolve_deleteSolverServer: Success;
  ttsolve_importSubjectCompetenciesFromCore: Success;
  ttsolve_solve: Success;
  ttsolve_solverSwappedTeacherAcceptReject: Success;
  ttsolve_stackGroups: Success;
  ttsolve_updateConfigurations: Success;
  ttsolve_updateDefaultSolverConfiguration: Success;
  ttsolve_updateSubjectCompetencies: Success;
  /** Tyro-admin only (gated in the service via @TyroSecured). */
  ttsolve_upsertCatalogueOverride: Success;
  ttsolve_upsertRestriction: Success;
  ttsolve_upsertSolverServer: Success;
  tyrone_refreshDocumentationIndex: Success;
  users_accountReset?: Maybe<Success>;
  users_admin__addUserToTenant: Users_AdminPerson;
  users_admin__clearPreAuthCache: Success;
  users_admin__createEmptyTenant: Tenant;
  users_admin__deleteDefaultPermission: Success;
  users_admin__saveDefaultPermission: Users_DefaultPermission;
  users_admin__updateTenants: Success;
  users_blockUser: Success;
  users_configure2fa?: Maybe<Success>;
  users_createProfileForGlobalUser?: Maybe<Profile>;
  users_deactivateProfiles?: Maybe<Success>;
  users_deletePermissionGroup: Success;
  users_deleteThirdPartyAccount?: Maybe<Success>;
  users_inviteUsers?: Maybe<InviteUsersResponse>;
  users_logout?: Maybe<Success>;
  users_mergeDuplicateUserProfiles?: Maybe<Success>;
  users_mergeUserProfiles?: Maybe<Success>;
  users_provisionMicrosoftEntraIds?: Maybe<Success>;
  users_provisionThirdPartyAccount?: Maybe<Users_ThirdPartyProvisionResponse>;
  users_resetPasswordBySms?: Maybe<SuccessFailure>;
  users_savePermissionGroup?: Maybe<PermissionGroup>;
  users_setDefaultProfile?: Maybe<Success>;
  users_toggleDeleteMicrosoftEntraUserInput?: Maybe<Success>;
  users_updatePermissionSet: Success;
  users_validateUserProfile?: Maybe<Success>;
  wellbeing_deleteStudentAen: Success;
  wellbeing_deleteStudentMedicalCondition: StudentMedical;
  wellbeing_deleteStudentMedicalContact: StudentMedical;
  wellbeing_savePriorityStudent?: Maybe<PriorityStudent>;
  wellbeing_saveStudentSupportFile?: Maybe<StudentSupportFile>;
  wellbeing_saveStudentSupportPlan?: Maybe<StudentSupportPlan>;
  wellbeing_saveStudentSupportPlanReview?: Maybe<StudentSupportPlanReview>;
  wellbeing_upsertStudentAen: Success;
  wellbeing_upsertStudentMedicalCondition: StudentMedical;
  wellbeing_upsertStudentMedicalContact: StudentMedical;
};


export type MutationAdmin__RefreshTenantSearchArgs = {
  input: Search_RefreshTenantSearchInput;
};


export type MutationAdmin__ResetTenantCacheArgs = {
  input?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAssessment_ArchiveClassAssessmentArgs = {
  input: Scalars['Long']['input'];
};


export type MutationAssessment_ArchiveStateCbaAssessmentArgs = {
  input: Scalars['Long']['input'];
};


export type MutationAssessment_ArchiveTermAssessmentArgs = {
  input: Scalars['Long']['input'];
};


export type MutationAssessment_DeleteStateCbaAssessmentArgs = {
  input: Scalars['Long']['input'];
};


export type MutationAssessment_PublishArgs = {
  input?: InputMaybe<PublishAssessmentInput>;
};


export type MutationAssessment_PublishPpodResultsArgs = {
  input?: InputMaybe<PpodPublishResultsInput>;
};


export type MutationAssessment_PublishStateCbaArgs = {
  input?: InputMaybe<PublishAssessmentInput>;
};


export type MutationAssessment_SaveAssessmentCommentsArgs = {
  input?: InputMaybe<Array<InputMaybe<SaveAssessmentCommentInput>>>;
};


export type MutationAssessment_SaveAssessmentResultsArgs = {
  input?: InputMaybe<Array<InputMaybe<SaveAssessmentResultInput>>>;
};


export type MutationAssessment_SaveClassAssessmentArgs = {
  input?: InputMaybe<SaveClassAssessmentInput>;
};


export type MutationAssessment_SaveCommentBankArgs = {
  input?: InputMaybe<Array<InputMaybe<SaveCommentBankInput>>>;
};


export type MutationAssessment_SaveGradeSetArgs = {
  input?: InputMaybe<SaveGradeSetInput>;
};


export type MutationAssessment_SaveStateCbaAssessmentArgs = {
  input?: InputMaybe<SaveStateCbaAssessmentInput>;
};


export type MutationAssessment_SaveTermAssessmentArgs = {
  input?: InputMaybe<SaveTermAssessmentInput>;
};


export type MutationAssessment_SetOpenForResultEntryArgs = {
  input?: InputMaybe<SetOpenForResultEntryInput>;
};


export type MutationAssessment_StudentAssessmentExclusionArgs = {
  input?: InputMaybe<Array<InputMaybe<StudentAssessmentExclusionInput>>>;
};


export type MutationAssessment_UnarchiveClassAssessmentArgs = {
  input: Scalars['Long']['input'];
};


export type MutationAssessment_UnarchiveStateCbaAssessmentArgs = {
  input: Scalars['Long']['input'];
};


export type MutationAssessment_UnarchiveTermAssessmentArgs = {
  input: Scalars['Long']['input'];
};


export type MutationAssessment_UpdateGradeSetArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateGradeSetInput>>>;
};


export type MutationAssessment_UpdateStudentSubjectGroupArgs = {
  input: Array<UpsertStudentSubjectGroup>;
};


export type MutationAssessment_VerifyPpodResultsArgs = {
  input?: InputMaybe<PpodPublishResultsInput>;
};


export type MutationAttendance_DeleteSignInOutArgs = {
  input?: InputMaybe<Attendance_SignInOutDeleteInput>;
};


export type MutationAttendance_MergeAttendanceCodesArgs = {
  input: Attendance_MergeAttendanceCodeInput;
};


export type MutationAttendance_RollBackAndSaveNewBulkAttendanceArgs = {
  input?: InputMaybe<Attendance_RollBackAndSaveBulkAttendanceInput>;
};


export type MutationAttendance_RollBackBulkAttendanceArgs = {
  input?: InputMaybe<Attendance_RollBackBulkAttendanceInput>;
};


export type MutationAttendance_SaveAttendanceCodeArgs = {
  input?: InputMaybe<Array<InputMaybe<SaveAttendanceCodeInput>>>;
};


export type MutationAttendance_SaveBulkAttendanceArgs = {
  input?: InputMaybe<Attendance_SaveBulkAttendanceInput>;
};


export type MutationAttendance_SaveEventAttendanceArgs = {
  input?: InputMaybe<Array<InputMaybe<SaveEventAttendanceInput>>>;
};


export type MutationAttendance_SaveParentalAttendanceRequestArgs = {
  input?: InputMaybe<Array<InputMaybe<SaveParentalAttendanceRequest>>>;
};


export type MutationAttendance_SaveSchoolActivityEventAttendanceArgs = {
  input: Array<SaveSchoolActivityAttendanceInput>;
};


export type MutationAttendance_SaveSignInOutArgs = {
  input?: InputMaybe<Array<InputMaybe<Attendance_SignInOutInput>>>;
};


export type MutationAttendance_SaveStudentSessionAttendanceArgs = {
  input?: InputMaybe<SaveStudentSessionAttendanceInput>;
};


export type MutationAttendance_SaveThirdPartyEventAttendanceArgs = {
  input?: InputMaybe<Array<InputMaybe<ThirdPartyEventAttendanceInput>>>;
};


export type MutationAttendance_SaveThirdPartySessionAttendanceArgs = {
  input?: InputMaybe<Array<InputMaybe<ThirdPartySessionAttendanceInput>>>;
};


export type MutationAttendance_UndoParentalAttendanceRequestArgs = {
  input?: InputMaybe<Attendance_RollbackParentalAttendanceInput>;
};


export type MutationAttendance_UpdateParentalAttendanceRequestArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateParentalAttendanceRequest>>>;
};


export type MutationAttendance_WithdrawParentalAttendanceRequestArgs = {
  input?: InputMaybe<WithdrawParentalAttendanceRequest>;
};


export type MutationCalendar_CloneEventArgs = {
  input: Calendar_CloneEvent;
};


export type MutationCalendar_CreateCalendarArgs = {
  input?: InputMaybe<CreateCalendarInput>;
};


export type MutationCalendar_CreateCalendarEventsArgs = {
  input?: InputMaybe<CreateCalendarEventsInput>;
};


export type MutationCalendar_CreateSchoolDayTypeInputArgs = {
  input?: InputMaybe<Calendar_CreateSchoolDayTypeInput>;
};


export type MutationCalendar_DeleteCalendarEventsArgs = {
  input: Calendar_DeleteEvent;
};


export type MutationCalendar_DeleteEventCancellationsArgs = {
  input: Calendar_DeleteEventCancellationInput;
};


export type MutationCalendar_DeleteFollowersArgs = {
  input: Calendar_FollowDelete;
};


export type MutationCalendar_EditCalendarEventsArgs = {
  input: Calendar_EditEvents;
};


export type MutationCalendar_Ical_SchoolCalendarConfigureArgs = {
  input: Calendar_Ical_SchoolCalendarConfigure;
};


export type MutationCalendar_ManuallyCancelEventsArgs = {
  input: Calendar_ManuallyCancelEventInput;
};


export type MutationCalendar_UpdateCalendarBellTimesArgs = {
  input?: InputMaybe<Calendar_UpdateCalendarBellTimesInput>;
};


export type MutationCalendar_UpdateCalendarDayTimesArgs = {
  input?: InputMaybe<Calendar_UpdateCalendarDayTimesInput>;
};


export type MutationCalendar_UpdateCalendarDaysArgs = {
  input?: InputMaybe<Calendar_UpdateDays>;
};


export type MutationCalendar_UpsertBellTimeArgs = {
  input?: InputMaybe<Calendar_CreateBellTimeInput>;
};


export type MutationCalendar_UpsertEventTagArgs = {
  input?: InputMaybe<Calendar_UpsertEventTag>;
};


export type MutationCalendar_UpsertFollowerArgs = {
  input: Calendar_FollowUpsert;
};


export type MutationCatalogue_CreateSubjectArgs = {
  input?: InputMaybe<CreateSubjectInput>;
};


export type MutationCatalogue_DeleteGroupTagArgs = {
  input: Catalogue_DeleteGroupTag;
};


export type MutationCatalogue_DeletePeopleTagArgs = {
  input: Catalogue_DeletePeopleTag;
};


export type MutationCatalogue_DeleteSubjectArgs = {
  input?: InputMaybe<DeleteSubjectInput>;
};


export type MutationCatalogue_ImportProgrammeDataArgs = {
  input: Catalogue_ImportProgrammeData;
};


export type MutationCatalogue_SystemSettingsUpdateArgs = {
  input: Catalogue_SystemSettingsUpdates;
};


export type MutationCatalogue_UpdateSubjectsArgs = {
  input: Array<UpdateSubject>;
};


export type MutationCatalogue_UpsertGroupTagArgs = {
  input: Array<Catalogue_UpsertGroupTag>;
};


export type MutationCatalogue_UpsertPeopleTagArgs = {
  input: Array<Catalogue_UpsertPeopleTag>;
};


export type MutationCatalogue_UpsertProgrammeArgs = {
  input: Array<Catalogue_UpsertProgramme>;
};


export type MutationCatalogue_UpsertProgrammeStageArgs = {
  input: Array<Catalogue_UpsertProgrammeStage>;
};


export type MutationCatalogue_UpsertProgrammeStageSubjectsArgs = {
  input: Array<Catalogue_UpsertProgrammeStageSubjects>;
};


export type MutationCatalogue_UpsertProgrammeStagesArgs = {
  input: Array<Catalogue_UpsertProgrammeStages>;
};


export type MutationCommunications_AcknowledgeNoticeArgs = {
  input?: InputMaybe<NoticeAction>;
};


export type MutationCommunications_ArchiveMailArgs = {
  input?: InputMaybe<ArchiveMailInput>;
};


export type MutationCommunications_ArchiveNoticeArgs = {
  input?: InputMaybe<NoticeAction>;
};


export type MutationCommunications_AssignLabelArgs = {
  input?: InputMaybe<AssignLabelInput>;
};


export type MutationCommunications_DeleteNoticeArgs = {
  input: NoticeAction;
};


export type MutationCommunications_DeleteScheduledMailArgs = {
  input: DeleteScheduledMailInput;
};


export type MutationCommunications_DeleteScheduledSmsArgs = {
  input: DeleteScheduledSmsInput;
};


export type MutationCommunications_DisconnectPlatformArgs = {
  input?: InputMaybe<DisconnectPlatformInput>;
};


export type MutationCommunications_NoticeboardConfigureArgs = {
  input: Communications_NoticeboardConfigInput;
};


export type MutationCommunications_PurchaseAddOnArgs = {
  input?: InputMaybe<PurchaseAddOnInput>;
};


export type MutationCommunications_ReadArgs = {
  input?: InputMaybe<MailReadInput>;
};


export type MutationCommunications_ReadNotificationArgs = {
  input?: InputMaybe<NotificationReadInput>;
};


export type MutationCommunications_RecallMailArgs = {
  input?: InputMaybe<RecallMailInput>;
};


export type MutationCommunications_RegisterDeviceArgs = {
  input?: InputMaybe<RegisterDeviceInput>;
};


export type MutationCommunications_ResendNotificationArgs = {
  input?: InputMaybe<FailedNotificationResendInput>;
};


export type MutationCommunications_ResendSmsArgs = {
  input?: InputMaybe<FailedSmsResendInput>;
};


export type MutationCommunications_RetrySocialPostArgs = {
  input: RetrySocialPostInput;
};


export type MutationCommunications_SaveLabelArgs = {
  input?: InputMaybe<LabelInput>;
};


export type MutationCommunications_SaveNoticeArgs = {
  input: Array<SaveNoticeInput>;
};


export type MutationCommunications_SaveNotificationSchoolSettingsArgs = {
  input: Array<SchoolNotificationSettingInput>;
};


export type MutationCommunications_SaveNotificationTemplateArgs = {
  input?: InputMaybe<SaveNotificationTemplateInput>;
};


export type MutationCommunications_SendMailArgs = {
  input?: InputMaybe<SendMailInput>;
};


export type MutationCommunications_SendSmsArgs = {
  input?: InputMaybe<SendSmsInput>;
};


export type MutationCommunications_SmsTopUpArgs = {
  input?: InputMaybe<SmsTopUpInput>;
};


export type MutationCommunications_StarredArgs = {
  input?: InputMaybe<MailStarredInput>;
};


export type MutationComposite_DeleteStudentsArgs = {
  input: DeleteStudentsInput;
};


export type MutationComposite_SwitchProfileArgs = {
  input: SwitchProfileInput;
};


export type MutationComposite_UpsertTenantSettingsArgs = {
  input: UpsertTenantSettingsInput;
};


export type MutationCore_ArchiveStudentContactsArgs = {
  input: ArchiveStudentContactInput;
};


export type MutationCore_CopyGroupsArgs = {
  input: Array<InputMaybe<Core_CopyGroups>>;
};


export type MutationCore_DeleteBuildingsArgs = {
  input: Array<Scalars['Int']['input']>;
};


export type MutationCore_DeleteCampusesArgs = {
  input: Array<Scalars['Int']['input']>;
};


export type MutationCore_DeleteCustomFieldsArgs = {
  input: Core_DeleteCustomFields;
};


export type MutationCore_DeleteGroupsArgs = {
  input: Core_DeleteGroupInput;
};


export type MutationCore_DiscontinueInAcademicNamespaceArgs = {
  input: Core_DiscontinueAcademicNamespaceInput;
};


export type MutationCore_EnableBlockRotationsArgs = {
  input?: InputMaybe<Core_EnableBlockRotationInput>;
};


export type MutationCore_EnrolInAcademicNamespaceArgs = {
  input: Core_EnrolInAcademicNamespaceInput;
};


export type MutationCore_LinkSiblingsAndContactsArgs = {
  input: Core_LinkSiblingsAndContacts;
};


export type MutationCore_ModifyBlocksArgs = {
  input: Core_ModifyBlocks;
};


export type MutationCore_ModifyGroupMembershipsArgs = {
  input: Core_ModifyMemberships;
};


export type MutationCore_ModifySubjectGroupMembershipTypeArgs = {
  input: Array<InputMaybe<Core_ModifySubjectGroupMembershipType>>;
};


export type MutationCore_ReinstateStaffArgs = {
  input: Core_ReinstateMemberInput;
};


export type MutationCore_ReinstateStudentArgs = {
  input: Core_ReinstateMemberInput;
};


export type MutationCore_RollOverEntityArgs = {
  input: Core_RolloverEntity;
};


export type MutationCore_RotateBlockStudentsArgs = {
  input: Core_RotateBlockStudentsInput;
};


export type MutationCore_SetActiveActiveAcademicNamespaceArgs = {
  input?: InputMaybe<SetActiveAcademicNamespace>;
};


export type MutationCore_SwitchSubjectGroupTypeArgs = {
  input: Core_SwitchSubjectGroupType;
};


export type MutationCore_UpdateClassGroupsArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateClassGroupGroupInput>>>;
};


export type MutationCore_UpdateProgrammeStageEnrollmentsArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateProgrammeStageEnrollmentInput>>>;
};


export type MutationCore_UpdateStaffArgs = {
  input: Array<UpdateStaffInput>;
};


export type MutationCore_UpdateStaffAvailabilityArgs = {
  input: Core_UpdateStaffAvailabilityInput;
};


export type MutationCore_UpdateStudentContactRelationshipsArgs = {
  input?: InputMaybe<Array<InputMaybe<Core_UpdateStudentContactRelationshipInput>>>;
};


export type MutationCore_UpdateStudentContactsArgs = {
  input: Array<UpdateStudentContactInput>;
};


export type MutationCore_UpdateStudentSubjectGroupArgs = {
  input: Array<InputMaybe<Core_UpdateStudentSubjectGroupInput>>;
};


export type MutationCore_UpdateStudentsArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateStudentInput>>>;
};


export type MutationCore_UpdateSubjectGroupsArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateSubjectGroupInput>>>;
};


export type MutationCore_UpdateYearGroupEnrollmentsArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateYearGroupEnrollmentInput>>>;
};


export type MutationCore_UpsertAcademicNamespaceArgs = {
  input?: InputMaybe<SaveAcademicNamespaceInput>;
};


export type MutationCore_UpsertBuildingsArgs = {
  input: Array<UpsertBuildingInput>;
};


export type MutationCore_UpsertCampusTravelTimesArgs = {
  input: Array<UpsertCampusTravelTimeInput>;
};


export type MutationCore_UpsertCampusesArgs = {
  input: Array<UpsertCampusInput>;
};


export type MutationCore_UpsertCustomFieldsArgs = {
  input: Array<Core_UpsertCustomFields>;
};


export type MutationCore_UpsertCustomGroupDefinitionArgs = {
  input: Core_UpsertCustomGroupDefinition;
};


export type MutationCore_UpsertRoomPoolsArgs = {
  input?: InputMaybe<Array<InputMaybe<UpsertRoomPool>>>;
};


export type MutationCore_UpsertRoomsArgs = {
  input?: InputMaybe<Array<InputMaybe<UpsertRoomInput>>>;
};


export type MutationCore_UpsertStaffArgs = {
  input?: InputMaybe<Array<InputMaybe<UpsertStaffInput>>>;
};


export type MutationCore_UpsertStudentContactArgs = {
  input: UpsertStudentContactInput;
};


export type MutationDelete_File_TransferArgs = {
  input: DeleteFileTransferInput;
};


export type MutationDocumentation_Admin_AddChangeRequestItemArgs = {
  input: Documentation_AddChangeRequestItemInput;
};


export type MutationDocumentation_Admin_ApproveChangeRequestsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDocumentation_Admin_CancelChangeRequestsArgs = {
  input: Documentation_CancelChangeRequestsInput;
};


export type MutationDocumentation_Admin_CreateChangeRequestArgs = {
  input: Documentation_CreateChangeRequestInput;
};


export type MutationDocumentation_Admin_CreatePageArgs = {
  input: Documentation_CreatePageInput;
};


export type MutationDocumentation_Admin_CreateSpaceArgs = {
  input: Documentation_CreateSpaceInput;
};


export type MutationDocumentation_Admin_DeletePagesArgs = {
  pageIds: Array<Scalars['Int']['input']>;
};


export type MutationDocumentation_Admin_DeleteSpaceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDocumentation_Admin_MovePageArgs = {
  input: Documentation_MovePageInput;
};


export type MutationDocumentation_Admin_PromoteReleaseArgs = {
  releaseTag: Scalars['String']['input'];
};


export type MutationDocumentation_Admin_QuickMergeChangeRequestArgs = {
  input: Documentation_QuickMergeChangeRequestInput;
};


export type MutationDocumentation_Admin_QuickPublishArgs = {
  input: Documentation_QuickPublishInput;
};


export type MutationDocumentation_Admin_QuickPublishBatchFromMarkdownArgs = {
  input: Documentation_QuickPublishBatchFromMarkdownInput;
};


export type MutationDocumentation_Admin_QuickPublishFromMarkdownArgs = {
  input: Documentation_QuickPublishFromMarkdownInput;
};


export type MutationDocumentation_Admin_RefreshVideoDataArgs = {
  input: Documentation_RefreshVideoDataInput;
};


export type MutationDocumentation_Admin_RejectChangeRequestsArgs = {
  input: Documentation_RejectChangeRequestsInput;
};


export type MutationDocumentation_Admin_RemoveChangeRequestItemArgs = {
  input: Documentation_RemoveChangeRequestItemInput;
};


export type MutationDocumentation_Admin_ReorderSpacesArgs = {
  input: Documentation_ReorderSpacesInput;
};


export type MutationDocumentation_Admin_ReplacePageVideoUrlArgs = {
  input: Documentation_ReplacePageVideoUrlInput;
};


export type MutationDocumentation_Admin_RestoreVersionArgs = {
  input: Documentation_RestoreVersionInput;
};


export type MutationDocumentation_Admin_RevertChangeRequestToDraftArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDocumentation_Admin_SetPageMetadataArgs = {
  input: Documentation_SetPageMetadataInput;
};


export type MutationDocumentation_Admin_SubmitChangeRequestsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDocumentation_Admin_UpdateChangeRequestReleaseTagArgs = {
  input: Documentation_UpdateChangeRequestReleaseTagInput;
};


export type MutationDocumentation_Admin_UpdatePageArgs = {
  input: Documentation_UpdatePageInput;
};


export type MutationDocumentation_Admin_UpdateSpaceArgs = {
  input: Documentation_UpdateSpaceInput;
};


export type MutationDrive_AddItemArgs = {
  input: Folders_DriveAddItemInput;
};


export type MutationDrive_AddQuickLinkArgs = {
  input: Folders_DriveAddQuickLinkInput;
};


export type MutationDrive_ArchiveFolderArgs = {
  input: Folders_DriveArchiveFolderInput;
};


export type MutationDrive_CreateFolderArgs = {
  input: Folders_DriveCreateFolderInput;
};


export type MutationDrive_DeleteFolderArgs = {
  input: Folders_DriveDeleteFolderInput;
};


export type MutationDrive_DeleteQuickLinkArgs = {
  input: Folders_DriveDeleteQuickLinkInput;
};


export type MutationDrive_RemoveItemArgs = {
  input: Folders_DriveRemoveItemInput;
};


export type MutationDrive_RestoreFolderArgs = {
  input: Folders_DriveRestoreFolderInput;
};


export type MutationDrive_SetFolderTypeArgs = {
  input: Folders_DriveSetFolderTypeInput;
};


export type MutationDrive_UpdateFolderArgs = {
  input: Folders_DriveUpdateFolderInput;
};


export type MutationDrive_UpdateFolderAclArgs = {
  input: Folders_DriveUpdateFolderAclInput;
};


export type MutationDrive_UpdateQuickLinkArgs = {
  input: Folders_DriveUpdateQuickLinkInput;
};


export type MutationEire_DeleteNonClassContactHoursArgs = {
  input?: InputMaybe<DeleteNonClassContactHoursInput>;
};


export type MutationEire_RollOverNonClassContactHoursArgs = {
  input?: InputMaybe<RollOverNonClassContactHoursInput>;
};


export type MutationEire_UpdateNonClassContactHoursArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateNonClassContactHoursInput>>>;
};


export type MutationEire_UpsertNonClassContactHoursArgs = {
  input?: InputMaybe<Array<InputMaybe<SaveNonClassContactHoursInput>>>;
};


export type MutationEnrollment_Ire_AutoAssignBlocksArgs = {
  input: EnrollmentIre_AutoAssignBlockMembershipInput;
};


export type MutationEnrollment_Ire_AutoAssignCoreArgs = {
  input: EnrollmentIre_AutoAssignCoreMembershipInput;
};


export type MutationEnrollment_Ire_ChangeProgrammeStageArgs = {
  input: EnrollmentIre_ChangeProgrammeStages;
};


export type MutationEnrollment_Ire_CreateStudentArgs = {
  input?: InputMaybe<EnrollmentIre_CreateStudent>;
};


export type MutationEnrollment_Ire_UpsertBlockMembershipsArgs = {
  input: EnrollmentIre_UpsertBlockMembership;
};


export type MutationEnrollment_Ire_UpsertCoreMembershipsArgs = {
  input: EnrollmentIre_UpsertCoreMembership;
};


export type MutationFees_BulkApplyIndividualDiscountsArgs = {
  input?: InputMaybe<Array<InputMaybe<IndividualDiscountInput>>>;
};


export type MutationFees_CreatePaymentArgs = {
  input?: InputMaybe<MakePaymentInput>;
};


export type MutationFees_CreateSetupIntentArgs = {
  input?: InputMaybe<OnBehalfOfInput>;
};


export type MutationFees_DeleteCardArgs = {
  input?: InputMaybe<DeleteCardInput>;
};


export type MutationFees_DeleteDiscountArgs = {
  input?: InputMaybe<DeleteDiscountInput>;
};


export type MutationFees_DeleteFeeArgs = {
  input?: InputMaybe<DeleteFeeInput>;
};


export type MutationFees_ExcludeFromFeeArgs = {
  input?: InputMaybe<FeeExclusionInput>;
};


export type MutationFees_MigrateFeeArgs = {
  input?: InputMaybe<FeeMigrationInput>;
};


export type MutationFees_PublishArgs = {
  input?: InputMaybe<PublishInput>;
};


export type MutationFees_RefundArgs = {
  input?: InputMaybe<RefundInput>;
};


export type MutationFees_SaveAccountingCodeArgs = {
  input?: InputMaybe<SaveAccountCodeInput>;
};


export type MutationFees_SaveCategoryArgs = {
  input?: InputMaybe<SaveCategoryInput>;
};


export type MutationFees_SaveDiscountArgs = {
  input?: InputMaybe<SaveDiscountInput>;
};


export type MutationFees_SaveFeeArgs = {
  input?: InputMaybe<SaveFeeInput>;
};


export type MutationFees_SimulateBankTransferArgs = {
  input?: InputMaybe<SimulateBankTransferInput>;
};


export type MutationFees_UpdatePaymentPlanCardArgs = {
  input?: InputMaybe<UpdateSubscriptionCardInput>;
};


export type MutationFees_WriteOffStudentsFeeArgs = {
  input?: InputMaybe<Array<InputMaybe<WriteOffInput>>>;
};


export type MutationFormsAdmin_CreateExtensionPointArgs = {
  input: Dtab_CreateExtensionPointInput;
};


export type MutationFormsAdmin_DeleteExtensionPointArgs = {
  input: Dtab_DeleteExtensionPointInput;
};


export type MutationFormsAdmin_DeleteFormDefinitionArgs = {
  input: FormsAdmin_FormDefinitionsFilter;
};


export type MutationFormsAdmin_DisableFormDefinitionsArgs = {
  input: FormsFd_DisableFormDefinition;
};


export type MutationFormsAdmin_RegisterExtensionPointArgs = {
  input: Dtab_RegisterExtensionPointInput;
};


export type MutationFormsAdmin_UnregisterExtensionPointArgs = {
  input: Dtab_UnregisterExtensionPointInput;
};


export type MutationFormsAdmin_UpdateTenantExtensionPointConfigArgs = {
  input: Dtab_UpdateTenantExtensionPointConfigInput;
};


export type MutationFormsAdmin_UpsertFormDefinitionsArgs = {
  input: FormsFd_UpsertFormDefinition;
};


export type MutationFormsAdmin_UpsertInformationRequestArgs = {
  input: FormsAdmin_UpsertInformationRequest;
};


export type MutationFormsAdmin_UpsertInformationRequestUsingMetaConfigArgs = {
  input: FormsAdmin_UpsertInformationRequestUsingMetaConfigObj;
};


export type MutationFormsAdmin_UpsertTagsArgs = {
  input?: InputMaybe<Array<InputMaybe<Dtab_UpsertTag>>>;
};


export type MutationForms_DeleteFormSubmissionArgs = {
  input: Forms_FormIdInput;
};


export type MutationForms_SubmitInformationRequestFormsArgs = {
  input: Forms_SubmitFormInput;
};


export type MutationForms_UpsertRowsArgs = {
  input?: InputMaybe<Forms_SubmitFormFieldInputs>;
};


export type MutationImportCanonical_RunSanityCheckArgs = {
  input: ImportCanonical_RunSanityCheckInput;
};


export type MutationImportVsware2_DeleteSchoolIdentifierArgs = {
  input: ImportVsware2_DeleteSchoolIdentifierInput;
};


export type MutationImportVsware2_UpsertSchoolIdentifierArgs = {
  input: ImportVsware2_UpsertSchoolIdentifierInput;
};


export type MutationLayout_DeleteConfigArgs = {
  input: Layout_DeleteConfigInput;
};


export type MutationLayout_UpsertConfigArgs = {
  input: Layout_UpsertConfigInput;
};


export type MutationMove_File_TransferArgs = {
  input: MoveFileTransferInput;
};


export type MutationNotes_DeleteBehaviourCategoryArgs = {
  input?: InputMaybe<Notes_BehaviourCategoryInput>;
};


export type MutationNotes_DeleteBehaviourNoteArgs = {
  input?: InputMaybe<Notes_DeleteBehaviourNote>;
};


export type MutationNotes_DeleteBehaviourTagArgs = {
  input?: InputMaybe<Notes_DeleteBehaviourTagInput>;
};


export type MutationNotes_DeleteNoteArgs = {
  input?: InputMaybe<Notes_DeleteNotes>;
};


export type MutationNotes_ResetBehaviourPointsArgs = {
  input?: InputMaybe<Notes_BehaviourResetPoints>;
};


export type MutationNotes_UpsertBehaviourCategoryArgs = {
  input?: InputMaybe<Notes_BehaviourCategoryInput>;
};


export type MutationNotes_UpsertBehaviourTagsArgs = {
  input?: InputMaybe<Array<InputMaybe<Notes_UpsertBehaviourTagInput>>>;
};


export type MutationNotes_UpsertNotesArgs = {
  input?: InputMaybe<Array<InputMaybe<Notes_UpsertNote>>>;
};


export type MutationNotes_UpsertNotesTagsArgs = {
  input?: InputMaybe<Array<InputMaybe<Notes_UpsertNotesTagInput>>>;
};


export type MutationNotesv2_UpsertNoteArgs = {
  filter: Notesv2_UpsertNotes;
};


export type MutationOptionsSol_FillInOptionsArgs = {
  input: Options_OptionIdFilter;
};


export type MutationOptionsSol_ModifySolutionSettingsArgs = {
  input: OptionsSol_ModifySolutionSettings;
};


export type MutationOptionsSol_SolveArgs = {
  input: OptionsSol_Solve;
};


export type MutationOptionsSol_UpsertSubjectGroupMembershipsArgs = {
  input: OptionsSol_UpsertSubjectGroupMembership;
};


export type MutationOptions_CloneArgs = {
  input?: InputMaybe<Options_Clone>;
};


export type MutationOptions_DeleteArgs = {
  input?: InputMaybe<DeleteOption>;
};


export type MutationOptions_PublishArgs = {
  input?: InputMaybe<Options_OptionsPublish>;
};


export type MutationOptions_SaveOptionsArgs = {
  input?: InputMaybe<Options_SaveOptions>;
};


export type MutationOptions_SaveStudentPreferencesArgs = {
  input?: InputMaybe<Array<InputMaybe<Options_SaveStudentPreference>>>;
};


export type MutationPbac_UpsertFromOverviewArgs = {
  input: Pbac_UpsertFromOverview;
};


export type MutationPbac_UpsertResourcePolicyArgs = {
  input: Pbac_UpsertResourcePolicy;
};


export type MutationPpod_SavePpodCredentialsArgs = {
  input?: InputMaybe<SavePpodCredentials>;
};


export type MutationReporting_ExportReportArgs = {
  filter: Reporting_ExportReportInput;
};


export type MutationRot_AddBlockRotationsArgs = {
  input?: InputMaybe<Rot_AddRotation>;
};


export type MutationRot_DeleteRotationArgs = {
  input?: InputMaybe<Rot_DeleteRotation>;
};


export type MutationRot_RemoveBlockRotationDateArgs = {
  input?: InputMaybe<Rot_RemoveRotationDate>;
};


export type MutationRules_DeleteTriggeredLogArgs = {
  input: Rules_DeleteTriggeredLog;
};


export type MutationRules_RevertTriggeredActionsArgs = {
  input: Rules_RevertTriggeredActions;
};


export type MutationRules_RunRuleArgs = {
  input: Rules_RunRulesNow;
};


export type MutationRules_TestRuleArgs = {
  input: Rules_CustomRuleInput;
};


export type MutationRules_UpdateCustomRuleArgs = {
  input: Array<Rules_CustomRuleUpdateInput>;
};


export type MutationRules_UpsertCustomRuleArgs = {
  input: Rules_CustomRuleInput;
};


export type MutationSa_AddRemoveStaffArgs = {
  input: Sa_AddRemoveStaff;
};


export type MutationSa_AddRemoveStudentsArgs = {
  input: Sa_AddRemoveStudents;
};


export type MutationSa_ApproveActivityArgs = {
  input?: InputMaybe<Sa_ApproveInput>;
};


export type MutationSa_DeleteActivityArgs = {
  input: Sa_SchoolActivityDelete;
};


export type MutationSa_RefreshArgs = {
  input: Sa_RefreshInput;
};


export type MutationSa_UpsertActivityArgs = {
  input?: InputMaybe<Sa_SchoolActivityInput>;
};


export type MutationSa_UpsertActivityRequestArgs = {
  input?: InputMaybe<Sa_SchoolActivityRequestInput>;
};


export type MutationSa_UpsertAttendanceCodeSettingsArgs = {
  input: Array<InputMaybe<Sa_SaveAttendanceCodeInput>>;
};


export type MutationSa_UpsertPublishArgs = {
  input?: InputMaybe<Sa_PublishInput>;
};


export type MutationScheduling_CancelJobArgs = {
  input: Scheduling_CancelJobInput;
};


export type MutationScheduling_RetryFailedJobArgs = {
  input: Scheduling_RetryFailedJobInput;
};


export type MutationScheduling_SubmitOneTimeJobArgs = {
  input: Scheduling_SubmitOneTimeJobInput;
};


export type MutationScheduling_SubmitPollingJobArgs = {
  input: Scheduling_SubmitPollingJobInput;
};


export type MutationScheduling_TriggerCronNowArgs = {
  input: Scheduling_TriggerCronNowInput;
};


export type MutationScheduling_UpdateCronJobsArgs = {
  input: Scheduling_UpdateCronJobsInput;
};


export type MutationSds_UpdateSdsSettingsArgs = {
  input: Sds_UpdateSettingsInput;
};


export type MutationSwm_ApplySubstitutionsArgs = {
  input?: InputMaybe<Swm_InsertSubstitution>;
};


export type MutationSwm_ChangeAbsenceRequestStatusArgs = {
  input?: InputMaybe<Swm_ChangeStaffAbsenceRequestStatus>;
};


export type MutationSwm_DeleteAbsenceArgs = {
  input: Swm_DeleteStaffAbsence;
};


export type MutationSwm_DeleteSubstitutionsArgs = {
  input?: InputMaybe<Swm_DeleteSubstitution>;
};


export type MutationSwm_SendCoverNotificationsArgs = {
  input?: InputMaybe<Swm_SendNotifications>;
};


export type MutationSwm_UpsertAbsenceArgs = {
  input: Swm_UpsertStaffAbsences;
};


export type MutationSwm_UpsertAbsenceRequestArgs = {
  input?: InputMaybe<Swm_UpsertStaffAbsenceRequest>;
};


export type MutationSwm_UpsertAbsenceTypeArgs = {
  input?: InputMaybe<Array<InputMaybe<Swm_UpsertStaffAbsenceType>>>;
};


export type MutationTasks_CancelTaskArgs = {
  input: Tasks_CancelTaskInput;
};


export type MutationTemplating_DeleteLabelTemplatesArgs = {
  input?: InputMaybe<Templating_DeleteLabelTemplateInput>;
};


export type MutationTemplating_DeleteSavedVariableTemplatesArgs = {
  input?: InputMaybe<Templating_DeleteSavedVariableTemplateInput>;
};


export type MutationTemplating_DeleteTemplatesArgs = {
  input?: InputMaybe<Templating_DeleteTemplateInput>;
};


export type MutationTemplating_SaveTemplateArgs = {
  input?: InputMaybe<Templating_SaveTemplateInput>;
};


export type MutationTemplating_UpsertLabelTemplateArgs = {
  input?: InputMaybe<Templating_UpsertLabelTemplateInput>;
};


export type MutationTemplating_UpsertSavedVariableTemplateArgs = {
  input?: InputMaybe<Templating_UpsertSavedVariableTemplateInput>;
};


export type MutationTimeline_DeleteHighlightArgs = {
  input?: InputMaybe<Timeline_RemoveHighlight>;
};


export type MutationTimeline_DeleteHighlightCommentArgs = {
  input?: InputMaybe<Timeline_RemoveComment>;
};


export type MutationTimeline_SaveHighlightArgs = {
  input?: InputMaybe<Timeline_SaveHighlight>;
};


export type MutationTimeline_SaveHighlightCommentArgs = {
  input?: InputMaybe<Timeline_SaveHighlightComment>;
};


export type MutationTt_AddLessonArgs = {
  input?: InputMaybe<Tt_AddLessonInput>;
};


export type MutationTt_AddPeriodToEndArgs = {
  input: Tt_AddPeriodsToEnd;
};


export type MutationTt_AddPeriodToStartArgs = {
  input: Tt_AddPeriodsToStart;
};


export type MutationTt_AttachClassGroupsToTimetableArgs = {
  input: Tt_AttachClassGroupsToTimetableInput;
};


export type MutationTt_CloneTimetableArgs = {
  input: TtCloneTimetableInput;
};


export type MutationTt_CreateCheckpointArgs = {
  input: Tt_CreateCheckpoint;
};


export type MutationTt_CreateTimetableArgs = {
  input: Tt_CreateTimetableInput;
};


export type MutationTt_DeleteBlockArgs = {
  input: Tt_DeleteBlocks;
};


export type MutationTt_DeleteClassGroupArgs = {
  input: Tt_DeleteClassGroups;
};


export type MutationTt_DeleteTimetableGroupArgs = {
  input: Tt_DeleteTimetableGroups;
};


export type MutationTt_DeleteTimetablesArgs = {
  input: Tt_DeleteTimetables;
};


export type MutationTt_EditLessonInstanceArgs = {
  input: TtEditLessonPeriodInstanceWrapper;
};


export type MutationTt_ImportGroupsFromCoreArgs = {
  input: Tt_ImportGroupsFromCore;
};


export type MutationTt_InfoReqRunsolverArgs = {
  input: TtRunOnCallSolverParams;
};


export type MutationTt_MigrateGridArgs = {
  input: Tt_MigrateGrid;
};


export type MutationTt_OnCallSetBlankArgs = {
  input: TtTimetableFilter;
};


export type MutationTt_PublishArgs = {
  input: TtPublishTimetableInput;
};


export type MutationTt_PublishConstructionArgs = {
  input: TtPublishConstructionInput;
};


export type MutationTt_RemoveLessonArgs = {
  input?: InputMaybe<Array<Tt_RemoveLessonInput>>;
};


export type MutationTt_RemoveLessonBulkArgs = {
  input: Tt_RemoveLessonBulk;
};


export type MutationTt_ResetArgs = {
  input: Tt_Reset;
};


export type MutationTt_ResetDefaultTimetableGroupNameArgs = {
  input?: InputMaybe<Tt_ResetTimetableGroupNamesToDefault>;
};


export type MutationTt_SetTimetableGroupRolloverSourcesArgs = {
  input: Tt_SetTimetableGroupRolloverSourcesInput;
};


export type MutationTt_SplitPeriodArgs = {
  input: Tt_SplitPeriods;
};


export type MutationTt_SwapArgs = {
  input: TtSwapsInput;
};


export type MutationTt_UpdateClassGroupArgs = {
  input: Tt_UpdateClassGroupInput;
};


export type MutationTt_UpdateLessonsArgs = {
  input?: InputMaybe<Tt_UpdateLessons>;
};


export type MutationTt_UpdateRoomAssignmentsArgs = {
  input: Tt_UpdateRoomAssignments;
};


export type MutationTt_UpdateTeacherArgs = {
  input: Tt_UpdateTeacherAssignments;
};


export type MutationTt_UpdateTimetableGroupArgs = {
  input: Tt_UpdateTimetableGroupInput;
};


export type MutationTt_UpsertBlockArgs = {
  input?: InputMaybe<Tt_UpsertBlock>;
};


export type MutationTt_UpsertClassGroupArgs = {
  input?: InputMaybe<Tt_UpsertClassGroup>;
};


export type MutationTt_UpsertCoScheduleChainsArgs = {
  input: Tt_UpsertCoScheduleChainsInput;
};


export type MutationTt_UpsertGridsArgs = {
  input: TtUpsertGrids;
};


export type MutationTt_UpsertTimetableGroupArgs = {
  input?: InputMaybe<Tt_UpsertTimetableGroup>;
};


export type MutationTtoptions_ImportOptionsArgs = {
  input: TtStudentOptions_Import;
};


export type MutationTtsolve_CancelSolveArgs = {
  input: TtSolve_CancelSolveInput;
};


export type MutationTtsolve_ClassDataAddSubjectArgs = {
  input: TtSolve_ClassDataAddSubject;
};


export type MutationTtsolve_ClassDataDeleteCoreSubjectsArgs = {
  input: TtSolve_ClassDataDeleteCoreSubject;
};


export type MutationTtsolve_ClassDataDropOnBlockArgs = {
  input: TtSolve_ClassDataDropOnBlock;
};


export type MutationTtsolve_ClassDataSetSpreadOnBlockArgs = {
  input: TtSolve_ClassDataSetSpreadOnBlock;
};


export type MutationTtsolve_ClassDataSetSpreadOnCoreSubjectsArgs = {
  input: TtSolve_ClassDataSetSpreadOnCoreSubject;
};


export type MutationTtsolve_ClearRoomsArgs = {
  input?: InputMaybe<TtSolve_ClearRooms>;
};


export type MutationTtsolve_ClearTimeslotsArgs = {
  input?: InputMaybe<TtSolve_ClearTimeslots>;
};


export type MutationTtsolve_DeleteCatalogueOverrideArgs = {
  input: TtSolve_DeleteCatalogueOverride;
};


export type MutationTtsolve_DeleteRestrictionArgs = {
  input: TtSolve_DeleteRestrictions;
};


export type MutationTtsolve_DeleteSolverServerArgs = {
  input: TtSolve_DeleteSolverServerInput;
};


export type MutationTtsolve_ImportSubjectCompetenciesFromCoreArgs = {
  input: Tt_ImportSubjectCompetenciesFromCore;
};


export type MutationTtsolve_SolveArgs = {
  input?: InputMaybe<TtSolve_RunSolverParams>;
};


export type MutationTtsolve_SolverSwappedTeacherAcceptRejectArgs = {
  input: TtSolve_SolverSwappedTeachersAccept;
};


export type MutationTtsolve_StackGroupsArgs = {
  input: TtSolve_StackGroups;
};


export type MutationTtsolve_UpdateConfigurationsArgs = {
  input: TtSolve_UpdateConfigurations;
};


export type MutationTtsolve_UpdateDefaultSolverConfigurationArgs = {
  input: TtSolve_SolverConfiguration;
};


export type MutationTtsolve_UpdateSubjectCompetenciesArgs = {
  input: TtSolve_UpdateSubjectCompetenciesInput;
};


export type MutationTtsolve_UpsertCatalogueOverrideArgs = {
  input: TtSolve_UpsertCatalogueOverride;
};


export type MutationTtsolve_UpsertRestrictionArgs = {
  input: TtSolve_UpsertRestrictions;
};


export type MutationTtsolve_UpsertSolverServerArgs = {
  input: TtSolve_UpsertSolverServerInput;
};


export type MutationUsers_AccountResetArgs = {
  input?: InputMaybe<Array<InputMaybe<AccountReset>>>;
};


export type MutationUsers_Admin__AddUserToTenantArgs = {
  input: Users_Admin_AddUserToTenantInput;
};


export type MutationUsers_Admin__ClearPreAuthCacheArgs = {
  emails: Array<Scalars['String']['input']>;
};


export type MutationUsers_Admin__CreateEmptyTenantArgs = {
  input: Users_CreateEmptyTenantInput;
};


export type MutationUsers_Admin__DeleteDefaultPermissionArgs = {
  input: Users_DeleteDefaultPermission;
};


export type MutationUsers_Admin__SaveDefaultPermissionArgs = {
  input: Users_SaveDefaultPermission;
};


export type MutationUsers_Admin__UpdateTenantsArgs = {
  input: Users_UpdateTenantsInput;
};


export type MutationUsers_BlockUserArgs = {
  input: AccountAction;
};


export type MutationUsers_Configure2faArgs = {
  input?: InputMaybe<Configure2faInput>;
};


export type MutationUsers_CreateProfileForGlobalUserArgs = {
  input?: InputMaybe<CreateProfileForGlobalUserInput>;
};


export type MutationUsers_DeactivateProfilesArgs = {
  input?: InputMaybe<DeactivateProfiles>;
};


export type MutationUsers_DeletePermissionGroupArgs = {
  input?: InputMaybe<Users_DeletePermissionGroup>;
};


export type MutationUsers_DeleteThirdPartyAccountArgs = {
  input?: InputMaybe<Users_DeleteThirdPartyAccountInput>;
};


export type MutationUsers_InviteUsersArgs = {
  input?: InputMaybe<Array<InputMaybe<InviteUser>>>;
};


export type MutationUsers_MergeDuplicateUserProfilesArgs = {
  input?: InputMaybe<MergeDuplicateProfilesInput>;
};


export type MutationUsers_MergeUserProfilesArgs = {
  input?: InputMaybe<MergeUserProfiles>;
};


export type MutationUsers_ProvisionMicrosoftEntraIdsArgs = {
  input?: InputMaybe<Users_ProvisionMicroSoftEntraIdsInput>;
};


export type MutationUsers_ProvisionThirdPartyAccountArgs = {
  input?: InputMaybe<Users_ProvisionThirdPartyInput>;
};


export type MutationUsers_ResetPasswordBySmsArgs = {
  input: Users_ResetPassword;
};


export type MutationUsers_SavePermissionGroupArgs = {
  input?: InputMaybe<SavePermissionGroup>;
};


export type MutationUsers_SetDefaultProfileArgs = {
  input?: InputMaybe<DefaultProfileInput>;
};


export type MutationUsers_ToggleDeleteMicrosoftEntraUserInputArgs = {
  input?: InputMaybe<Users_ToggleDeleteMicrosoftEntraUserInput>;
};


export type MutationUsers_UpdatePermissionSetArgs = {
  input: Array<UpdatePermissionSet>;
};


export type MutationUsers_ValidateUserProfileArgs = {
  input?: InputMaybe<ValidateUserProfile>;
};


export type MutationWellbeing_DeleteStudentAenArgs = {
  input: Wellbeing_DeleteStudentAenInput;
};


export type MutationWellbeing_DeleteStudentMedicalConditionArgs = {
  input: DeleteStudentMedicalConditionInput;
};


export type MutationWellbeing_DeleteStudentMedicalContactArgs = {
  input: DeleteStudentMedicalContactInput;
};


export type MutationWellbeing_SavePriorityStudentArgs = {
  input?: InputMaybe<SavePriorityStudentInput>;
};


export type MutationWellbeing_SaveStudentSupportFileArgs = {
  input?: InputMaybe<SaveStudentSupportFileInput>;
};


export type MutationWellbeing_SaveStudentSupportPlanArgs = {
  input?: InputMaybe<SaveStudentSupportPlanInput>;
};


export type MutationWellbeing_SaveStudentSupportPlanReviewArgs = {
  input?: InputMaybe<SaveStudentSupportPlanReviewInput>;
};


export type MutationWellbeing_UpsertStudentAenArgs = {
  input: Wellbeing_UpsertStudentAenInput;
};


export type MutationWellbeing_UpsertStudentMedicalConditionArgs = {
  input: UpsertStudentMedicalConditionInput;
};


export type MutationWellbeing_UpsertStudentMedicalContactArgs = {
  input: UpsertStudentMedicalContactInput;
};

export type MyLabelsFilter = {
  personPartyId: Scalars['Long']['input'];
};

export enum Ncch_Programme {
  Jcsp = 'JCSP',
  JuniorCycle = 'JUNIOR_CYCLE',
  Lcvp = 'LCVP',
  LeavingCertificate = 'LEAVING_CERTIFICATE',
  LeavingCertificateApplied = 'LEAVING_CERTIFICATE_APPLIED',
  TransitionYear = 'TRANSITION_YEAR',
  Vpt2 = 'VPT2',
  Vtos = 'VTOS'
}

export enum NameFormat {
  FirstnameInitialsLastname = 'FIRSTNAME_INITIALS_LASTNAME',
  FirstnameLastname = 'FIRSTNAME_LASTNAME',
  LastnameFirstname = 'LASTNAME_FIRSTNAME',
  LastnameFirstnameInitials = 'LASTNAME_FIRSTNAME_INITIALS'
}

export type NextOfKin = {
  __typename?: 'NextOfKin';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type NonClassContactHours = {
  __typename?: 'NonClassContactHours';
  academicNameSpaceId: Scalars['Int']['output'];
  activity: Activity;
  dayOfTheWeek: Day;
  description?: Maybe<Scalars['String']['output']>;
  hours: Scalars['Int']['output'];
  minutes: Scalars['Int']['output'];
  nonClassContactHoursId: Scalars['Int']['output'];
  programme?: Maybe<Ncch_Programme>;
  staff?: Maybe<Staff>;
  staffPartyId: Scalars['Long']['output'];
};

export type NonClassContactHoursFilter = {
  academicNameSpaceId?: InputMaybe<Scalars['Int']['input']>;
  nonClassContactHourIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  staffPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Notes_BehaviourCategory = {
  __typename?: 'Notes_BehaviourCategory';
  behaviourCategoryId: Scalars['Int']['output'];
  behaviourType: Notes_BehaviourType;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tagIds: Array<Scalars['Long']['output']>;
  tags: Array<Notes_Tag>;
};

export type Notes_BehaviourCategoryFilter = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type?: InputMaybe<Notes_BehaviourType>;
};

export type Notes_BehaviourCategoryInput = {
  behaviourType: Notes_BehaviourType;
  colour: Colour;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type Notes_BehaviourFilter = {
  associatedPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  behaviourType?: InputMaybe<Notes_BehaviourType>;
  noteIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type Notes_BehaviourResetPoints = {
  partyIds: Array<Scalars['Long']['input']>;
  resetFromDate: Scalars['Date']['input'];
  resetTo: Scalars['Int']['input'];
};

export type Notes_BehaviourTagUsage = {
  __typename?: 'Notes_BehaviourTagUsage';
  linkedBehaviourCount: Scalars['Int']['output'];
  tagId: Scalars['Long']['output'];
};

export type Notes_BehaviourTagUsageFilter = {
  tagId: Scalars['Long']['input'];
};

export enum Notes_BehaviourType {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type Notes_DeleteBehaviourNote = {
  noteId: Scalars['Long']['input'];
  referencedPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Notes_DeleteBehaviourTagInput = {
  migrateToTagId?: InputMaybe<Scalars['Long']['input']>;
  tagId: Scalars['Long']['input'];
};

export type Notes_DeleteNotes = {
  noteIds: Array<Scalars['Long']['input']>;
};

export type Notes_Note = {
  __typename?: 'Notes_Note';
  associatedGroups?: Maybe<Array<Maybe<PartyGroup>>>;
  associatedPartiesIds?: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  associatedPeople?: Maybe<Array<Maybe<Person>>>;
  createdBy: Scalars['Long']['output'];
  createdByPerson?: Maybe<Person>;
  createdOn: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['Long']['output']>;
  incidentDate?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  pbac: Pbac_ResourceResult;
  priorityEndDate?: Maybe<Scalars['Date']['output']>;
  priorityNote?: Maybe<Scalars['Boolean']['output']>;
  priorityStartDate?: Maybe<Scalars['Date']['output']>;
  referencedParties: Array<Person>;
  referencedPartiesIds: Array<Scalars['Long']['output']>;
  tags: Array<Notes_Tag>;
  tagsIds: Array<Scalars['Long']['output']>;
};

export type Notes_NotesFilter = {
  associatedPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  noteIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  noteType?: InputMaybe<Notes_TagCategory>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  priority?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Notes_PriorityFilter = {
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type Notes_StudentBehaviour = {
  __typename?: 'Notes_StudentBehaviour';
  associatedParties: Array<Maybe<Party>>;
  associatedPartyIds?: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  category: Scalars['String']['output'];
  details: Scalars['String']['output'];
  incidentDate: Scalars['DateTime']['output'];
  noteId: Scalars['Long']['output'];
  points?: Maybe<Scalars['Int']['output']>;
  referencedParties: Array<Person>;
  referencedPartiesIds: Array<Scalars['Long']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  tags?: Maybe<Array<Maybe<Notes_Tag>>>;
  takenBy: Person;
  takenByPartyId: Scalars['Long']['output'];
};

export type Notes_StudentBehaviourCategory = {
  __typename?: 'Notes_StudentBehaviourCategory';
  behaviourCategoryId: Scalars['Int']['output'];
  behaviourType: Notes_BehaviourType;
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Notes_StudentBehaviourOverview = {
  __typename?: 'Notes_StudentBehaviourOverview';
  behaviours?: Maybe<Array<Notes_StudentBehaviour>>;
  categories: Array<Notes_StudentBehaviourCategory>;
  pointsTotal: Scalars['Int']['output'];
};

export type Notes_Tag = {
  __typename?: 'Notes_Tag';
  availableToContacts?: Maybe<Scalars['Boolean']['output']>;
  availableToStaff?: Maybe<Scalars['Boolean']['output']>;
  availableToStudents?: Maybe<Scalars['Boolean']['output']>;
  behaviourCategory?: Maybe<Notes_BehaviourCategory>;
  behaviourType?: Maybe<Notes_BehaviourType>;
  category: Notes_TagCategory;
  colour: Colour;
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
  pbac?: Maybe<Pbac_ResourceResult>;
  points?: Maybe<Scalars['Int']['output']>;
  tag_l1?: Maybe<Scalars['String']['output']>;
  tag_l2?: Maybe<Scalars['String']['output']>;
  tag_l3?: Maybe<Scalars['String']['output']>;
};

export enum Notes_TagCategory {
  Behaviour = 'BEHAVIOUR',
  Misc = 'MISC',
  Note = 'NOTE'
}

export type Notes_TagFilter = {
  categories?: InputMaybe<Array<InputMaybe<Notes_TagCategory>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type Notes_UpsertBehaviourTagInput = {
  availableToContacts?: InputMaybe<Scalars['Boolean']['input']>;
  availableToStaff?: InputMaybe<Scalars['Boolean']['input']>;
  availableToStudents?: InputMaybe<Scalars['Boolean']['input']>;
  behaviourType?: InputMaybe<Notes_BehaviourType>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  points?: InputMaybe<Scalars['Int']['input']>;
  tag_l2: Scalars['String']['input'];
  tag_l3?: InputMaybe<Scalars['String']['input']>;
};

export type Notes_UpsertNote = {
  applyToPresentStudents?: InputMaybe<Scalars['Boolean']['input']>;
  associatedParties?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  createdBy?: InputMaybe<Scalars['Long']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  incidentDate?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  priorityEndDate?: InputMaybe<Scalars['Date']['input']>;
  priorityNote?: InputMaybe<Scalars['Boolean']['input']>;
  priorityStartDate?: InputMaybe<Scalars['Date']['input']>;
  referencedParties: Array<Scalars['Long']['input']>;
  tags: Array<Scalars['Long']['input']>;
};

export type Notes_UpsertNotesTagInput = {
  colour: Colour;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  tag_l1: Scalars['String']['input'];
  tag_l2?: InputMaybe<Scalars['String']['input']>;
  tag_l3?: InputMaybe<Scalars['String']['input']>;
};

export type Notesv2_DeleteNote = {
  deleteByFilter: Notesv2_NoteFilter;
  ids: Array<Scalars['Int']['input']>;
};

export type Notesv2_DeleteNoteTag = {
  ids: Array<Scalars['Int']['input']>;
};

export type Notesv2_Note = {
  __typename?: 'Notesv2_Note';
  createdBy?: Maybe<AuditPerson>;
  createdByPartyId?: Maybe<Scalars['Long']['output']>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['DateTime']['output'];
  dyRels: Array<DyRel_Link>;
  fromDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  readOn?: Maybe<Scalars['DateTime']['output']>;
  tagIds: Array<Scalars['Int']['output']>;
  tags: Array<Notesv2_Tag>;
  toDate?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<AuditPerson>;
  updatedByPartyId?: Maybe<Scalars['Long']['output']>;
  updatedByUserId?: Maybe<Scalars['Int']['output']>;
  updatedOn: Scalars['DateTime']['output'];
};

export type Notesv2_NoteFilter = {
  dyRel?: InputMaybe<Array<DyRel_RelationFilter>>;
  noteIds: Array<Scalars['Int']['input']>;
  page?: InputMaybe<Page>;
  tagTypes?: InputMaybe<Array<Notesv2_TagType>>;
};

export type Notesv2_ReadNotes = {
  __typename?: 'Notesv2_ReadNotes';
  notes: Array<Notesv2_Note>;
  read: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Notesv2_Tag = {
  __typename?: 'Notesv2_Tag';
  colour: Colour;
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
  refId?: Maybe<Scalars['String']['output']>;
  systemTag: Scalars['Boolean']['output'];
  type?: Maybe<Notesv2_TagType>;
  uniqueName?: Maybe<Scalars['String']['output']>;
};

export type Notesv2_TagFilter = {
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tagTypes?: InputMaybe<Array<InputMaybe<Notesv2_TagType>>>;
};

export enum Notesv2_TagType {
  Student = 'STUDENT',
  SubstitutionNote = 'SUBSTITUTION_NOTE'
}

export type Notesv2_UpsertNote = {
  dyRels?: InputMaybe<Array<DyRel_RelationFilter>>;
  folderId?: InputMaybe<Scalars['Long']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Notesv2_UpsertNoteTag = {
  colour?: InputMaybe<Colour>;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  groupTagType: Notesv2_TagType;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Array<InputMaybe<TranslationInput>>;
};

export type Notesv2_UpsertNotes = {
  notes: Array<Notesv2_UpsertNote>;
};

export type Notice = {
  __typename?: 'Notice';
  allContacts: Scalars['Boolean']['output'];
  allStaff: Scalars['Boolean']['output'];
  allStudents: Scalars['Boolean']['output'];
  archived: Scalars['Boolean']['output'];
  /** deep linked */
  archivedBy?: Maybe<Person>;
  archivedByPartyId?: Maybe<Scalars['Long']['output']>;
  archivedOn?: Maybe<Scalars['DateTime']['output']>;
  /** deep linked */
  assignedToParties: Array<NoticeAssignee>;
  assignedToPartyIds: Array<NoticeAssigneeId>;
  id?: Maybe<Scalars['Long']['output']>;
  imageUrls: Array<Scalars['String']['output']>;
  images: Array<NoticeImage>;
  notice: Scalars['String']['output'];
  pinned: Scalars['Boolean']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  publicNotice: Scalars['Boolean']['output'];
  recipientPartyIds: Array<Scalars['Long']['output']>;
  /** deep linked */
  recipients: Array<NoticeRecipient>;
  /** deep linked */
  socialPosts: Array<SocialPost>;
  title: Scalars['String']['output'];
  validFrom?: Maybe<Scalars['Date']['output']>;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export type NoticeAction = {
  enable: Scalars['Boolean']['input'];
  noticeId: Scalars['Long']['input'];
};

export type NoticeAssignee = {
  __typename?: 'NoticeAssignee';
  contact?: Maybe<Scalars['Boolean']['output']>;
  id: NoticeAssigneeId;
  party: Party;
  staff?: Maybe<Scalars['Boolean']['output']>;
  student?: Maybe<Scalars['Boolean']['output']>;
};

export type NoticeAssigneeFilter = {
  noticeIds: Array<InputMaybe<Scalars['Long']['input']>>;
};

export type NoticeAssigneeId = {
  __typename?: 'NoticeAssigneeId';
  noticeId: Scalars['Long']['output'];
  partyId: Scalars['Long']['output'];
};

export type NoticeImage = {
  __typename?: 'NoticeImage';
  id: Scalars['Long']['output'];
  isCover: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type NoticeRecipient = {
  __typename?: 'NoticeRecipient';
  acknowledged: Scalars['Boolean']['output'];
  acknowledgedOn?: Maybe<Scalars['DateTime']['output']>;
  id: NoticeRecipientId;
};

export type NoticeRecipientFilter = {
  noticeIds: Array<InputMaybe<Scalars['Long']['input']>>;
  recipientPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type NoticeRecipientId = {
  __typename?: 'NoticeRecipientId';
  noticeId: Scalars['Long']['output'];
  partyId: Scalars['Long']['output'];
};

export type NoticeboardFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTo?: InputMaybe<Array<Scalars['Long']['input']>>;
  drafts?: InputMaybe<Scalars['Boolean']['input']>;
  noticeIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  publicNotice?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validUntil?: InputMaybe<Scalars['Date']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  featureId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  notificationType: NotificationType;
  recipientIds: Array<Scalars['Long']['output']>;
  recipients: Array<NotificationRecipient>;
  /** deep linked */
  sender: Person;
  senderPartyId: Scalars['Long']['output'];
  sentOn: Scalars['DateTime']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NotificationError = {
  __typename?: 'NotificationError';
  error?: Maybe<Scalars['String']['output']>;
  personPartyId?: Maybe<Scalars['Long']['output']>;
};

export type NotificationFilter = {
  globalUserId: Scalars['Int']['input'];
};

export type NotificationMetaData = {
  __typename?: 'NotificationMetaData';
  assessmentId?: Maybe<Scalars['Long']['output']>;
  eventStartTime?: Maybe<Scalars['DateTime']['output']>;
  feeId?: Maybe<Scalars['Int']['output']>;
  formId?: Maybe<Scalars['Int']['output']>;
  highlightCommentId?: Maybe<Scalars['Long']['output']>;
  highlightId?: Maybe<Scalars['Long']['output']>;
  mailId?: Maybe<Scalars['Long']['output']>;
  notificationId?: Maybe<Scalars['Long']['output']>;
  notificationType: NotificationType;
  optionId?: Maybe<Scalars['Int']['output']>;
  partyId?: Maybe<Scalars['Long']['output']>;
  schoolActivityId?: Maybe<Scalars['Int']['output']>;
  staffAbsenceRequestId?: Maybe<Scalars['Long']['output']>;
  studentPartyId?: Maybe<Scalars['Long']['output']>;
  substitutionDate?: Maybe<Scalars['Date']['output']>;
  threadMessageId?: Maybe<Scalars['Long']['output']>;
};

export type NotificationMetaDataInput = {
  assessmentId?: InputMaybe<Scalars['Long']['input']>;
  eventStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  feeId?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['Int']['input']>;
  highlightCommentId?: InputMaybe<Scalars['Long']['input']>;
  highlightId?: InputMaybe<Scalars['Long']['input']>;
  mailId?: InputMaybe<Scalars['Long']['input']>;
  notificationId: Scalars['Long']['input'];
  notificationType: NotificationType;
  optionId?: InputMaybe<Scalars['Int']['input']>;
  partyId?: InputMaybe<Scalars['Long']['input']>;
  schoolActivityId?: InputMaybe<Scalars['Int']['input']>;
  staffAbsenceRequestId?: InputMaybe<Scalars['Long']['input']>;
  studentPartyId?: InputMaybe<Scalars['Long']['input']>;
  substitutionDate?: InputMaybe<Scalars['Date']['input']>;
  threadMessageId?: InputMaybe<Scalars['Long']['input']>;
};

export type NotificationReadInput = {
  notificationIds: Array<Scalars['Long']['input']>;
};

export type NotificationRecipient = {
  __typename?: 'NotificationRecipient';
  devices: Array<RecipientDevice>;
  id: Scalars['Long']['output'];
  metaData?: Maybe<NotificationMetaData>;
  readOn?: Maybe<Scalars['DateTime']['output']>;
  recipientGlobalUserId: Scalars['Int']['output'];
  recipientPartyId: Scalars['Long']['output'];
  status: NotificationStatus;
};

export type NotificationSentResponse = {
  __typename?: 'NotificationSentResponse';
  errors?: Maybe<Array<Maybe<NotificationError>>>;
  numNotificationsSent?: Maybe<Scalars['Int']['output']>;
};

export enum NotificationStatus {
  Abandoned = 'Abandoned',
  Canceled = 'Canceled',
  Completed = 'Completed',
  Enqueued = 'Enqueued',
  NoTargetFound = 'NoTargetFound',
  Processing = 'Processing',
  Scheduled = 'Scheduled',
  Unknown = 'Unknown'
}

export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NotificationTemplateFilter = {
  id?: InputMaybe<Scalars['Long']['input']>;
};

export enum NotificationType {
  Absence = 'ABSENCE',
  Assessment = 'ASSESSMENT',
  Fee = 'FEE',
  FeePaymentFailed = 'FEE_PAYMENT_FAILED',
  FeePaymentUpcoming = 'FEE_PAYMENT_UPCOMING',
  Highlight = 'HIGHLIGHT',
  Individual = 'INDIVIDUAL',
  InfoRequest = 'INFO_REQUEST',
  Mail = 'MAIL',
  OneOff = 'ONE_OFF',
  SchoolActivityCreated = 'SCHOOL_ACTIVITY_CREATED',
  SchoolActivityUpdated = 'SCHOOL_ACTIVITY_UPDATED',
  SignInOutRequest = 'SIGN_IN_OUT_REQUEST',
  StaffAbsenceRequest = 'STAFF_ABSENCE_REQUEST',
  Substitution = 'SUBSTITUTION',
  Timetable = 'TIMETABLE',
  Wellbeing = 'WELLBEING'
}

export enum NotificationUserType {
  Contact = 'CONTACT',
  Staff = 'STAFF',
  Student = 'STUDENT'
}

export type NotificationsUnreadCount = {
  __typename?: 'NotificationsUnreadCount';
  count: Scalars['Int']['output'];
};

export type OnBehalfOfInput = {
  onBehalfOf?: InputMaybe<Scalars['String']['input']>;
  partyId?: InputMaybe<Scalars['Long']['input']>;
};

export type OptionsSol_Block = {
  __typename?: 'OptionsSol_Block';
  blockIdx: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  subjectGroups: Array<OptionsSol_SubjectGroup>;
};

export type OptionsSol_ModifySolutionSettings = {
  minSubjectsPerBlock?: InputMaybe<Scalars['Int']['input']>;
  optionId: Scalars['Int']['input'];
  subjectGroups?: InputMaybe<Array<OptionsSol_ModifySubjectGroup>>;
  subjects?: InputMaybe<Array<OptionsSol_ModifySubjectSettings>>;
};

export type OptionsSol_ModifySubjectGroup = {
  blockIdx: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pinBlock: Scalars['Boolean']['input'];
};

export type OptionsSol_ModifySubjectSettings = {
  maxPerBlock?: InputMaybe<Scalars['Int']['input']>;
  maxSize: Scalars['Int']['input'];
  numberOfClasses: Scalars['Int']['input'];
  poolIdx: Scalars['Int']['input'];
  subjectId: Scalars['Int']['input'];
};

export type OptionsSol_Solve = {
  operation: OptionsSol_SolverOperation;
  optionId: Scalars['Int']['input'];
};

export enum OptionsSol_SolverOperation {
  Start = 'START',
  Stop = 'STOP'
}

export type OptionsSol_StudentAssignment = {
  __typename?: 'OptionsSol_StudentAssignment';
  missedPreferences: Scalars['Int']['output'];
  student?: Maybe<Person>;
  studentId: Scalars['Long']['output'];
  /** deep linked */
  subjectGroupsAssigned: Array<OptionsSol_StudentAssignmentSubjectGroup>;
};

export type OptionsSol_StudentAssignmentSubjectGroup = {
  __typename?: 'OptionsSol_StudentAssignmentSubjectGroup';
  preferenceNumber?: Maybe<Scalars['Int']['output']>;
  studentId?: Maybe<Scalars['Long']['output']>;
  subjectSetIdx?: Maybe<Scalars['Int']['output']>;
  teachingGroup?: Maybe<OptionsSol_SubjectGroup>;
};

export type OptionsSol_StudentAssignments = {
  __typename?: 'OptionsSol_StudentAssignments';
  students: OptionsSol_StudentAssignment;
  subjectSets: Options_OptionSubjectSet;
};

export type OptionsSol_Subject = {
  __typename?: 'OptionsSol_Subject';
  maxSize: Scalars['Int']['output'];
  preferencesGotten: Scalars['Int']['output'];
  preferencesTotal: Scalars['Int']['output'];
  /** deep linked */
  subject: Subject;
  subjectId: Scalars['Int']['output'];
  teachingGroups: Array<OptionsSol_SubjectGroup>;
};

export type OptionsSol_SubjectGroup = {
  __typename?: 'OptionsSol_SubjectGroup';
  blockIdx: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numStudents: Scalars['Int']['output'];
  pinned: Scalars['Boolean']['output'];
  poolIdx: Scalars['Int']['output'];
  subject: Subject;
  subjectId: Scalars['String']['output'];
};

export type OptionsSol_SubjectGroupMembershipChange = {
  studentPartyId: Scalars['Long']['input'];
  subjectGroupId: Scalars['Int']['input'];
  type: Options_MembershipChangeEnum;
};

export type OptionsSol_SubjectSetBlock = {
  __typename?: 'OptionsSol_SubjectSetBlock';
  blocks: Array<OptionsSol_Block>;
  subjectSet: Options_OptionSubjectSet;
};

export type OptionsSol_SubjectSetBlocks = {
  __typename?: 'OptionsSol_SubjectSetBlocks';
  subjectSet: Array<Maybe<OptionsSol_SubjectSetBlock>>;
};

export type OptionsSol_UpsertSubjectGroupMembership = {
  membershipChange: Array<OptionsSol_SubjectGroupMembershipChange>;
  optionId: Scalars['Int']['input'];
};

export type Options_AvailableGroups = {
  __typename?: 'Options_AvailableGroups';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  students: Array<Student>;
};

export type Options_AvailableGroupsFilter = {
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Options_Block = {
  __typename?: 'Options_Block';
  blockIdx: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subjectGroups: Array<Options_SubjectGroup>;
};

export type Options_Clm = {
  __typename?: 'Options_CLM';
  blockIdx: Scalars['Int']['output'];
  subjectGroups: Array<Options_SubjectGroupMembership>;
};

export type Options_Choice = {
  __typename?: 'Options_Choice';
  blockIdx?: Maybe<Scalars['Int']['output']>;
  choiceIdx: Scalars['Int']['output'];
  subject?: Maybe<Subject>;
  subjectGroupId?: Maybe<Scalars['Int']['output']>;
  subjectGroupName?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['Int']['output']>;
};

export type Options_ChoiceId = {
  __typename?: 'Options_ChoiceId';
  preferenceIdx: Scalars['Int']['output'];
  subjectSetIdx: Scalars['Int']['output'];
};

export type Options_ClmFilter = {
  blockIdx: Scalars['Int']['input'];
  optionId: Scalars['Int']['input'];
};

export type Options_Clone = {
  name?: InputMaybe<Scalars['String']['input']>;
  optionId: Scalars['Int']['input'];
  tyroOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Options_InfoRequestFilter = {
  studentPartyIds: Array<Scalars['Long']['input']>;
};

export type Options_InfoRequestId = {
  __typename?: 'Options_InfoRequestId';
  optionId: Scalars['Int']['output'];
  studentPartyId: Scalars['Long']['output'];
};

export type Options_InfoRequestOption = {
  __typename?: 'Options_InfoRequestOption';
  dueBy: Scalars['Date']['output'];
  id: Options_InfoRequestId;
  optionName: Scalars['String']['output'];
  /** deep linked */
  requestFor: Person;
};

export enum Options_MembershipChangeEnum {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type Options_Option = {
  __typename?: 'Options_Option';
  academicNamespaceId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentsDescription?: Maybe<Scalars['String']['output']>;
  parentsDueByDate?: Maybe<Scalars['Date']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  publishedToParents: Scalars['Boolean']['output'];
  publishedToParentsOn?: Maybe<Scalars['DateTime']['output']>;
  studentCount: Scalars['Int']['output'];
  studentPartyIds?: Maybe<Array<Scalars['Long']['output']>>;
  studentPreferencesCompleteCount: Scalars['Int']['output'];
  /** deep linked */
  students?: Maybe<Array<Student>>;
  subjectSetIds?: Maybe<Array<Options_OptionsId>>;
  /** deep linked */
  subjectSets: Array<Options_OptionSubjectSet>;
  validations?: Maybe<Array<Scalars['String']['output']>>;
  /** deep linked */
  yearGroup: YearGroup;
  yearGroupId: Scalars['Int']['output'];
};

export type Options_OptionFilter = {
  academicNameSpaceId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Options_OptionIdFilter = {
  optionId: Scalars['Int']['input'];
};

export type Options_OptionSubjectSet = {
  __typename?: 'Options_OptionSubjectSet';
  canChoose: Scalars['Int']['output'];
  id: Options_OptionsId;
  mustGet: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  poolIdx?: Maybe<Scalars['Int']['output']>;
  subjectIds: Array<Scalars['Int']['output']>;
  /** deep linked */
  subjects: Array<Subject>;
};

export type Options_OptionsId = {
  __typename?: 'Options_OptionsId';
  idx: Scalars['Int']['output'];
  optionId: Scalars['Int']['output'];
};

export type Options_OptionsPublish = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueByDate?: InputMaybe<Scalars['Date']['input']>;
  optionId: Scalars['Int']['input'];
  publish: Scalars['Boolean']['input'];
};

export type Options_ParentalPreferencesFilter = {
  optionId: Scalars['Int']['input'];
  studentPartyId: Scalars['Long']['input'];
};

export type Options_PreferenceId = {
  __typename?: 'Options_PreferenceId';
  optionId: Scalars['Int']['output'];
  studentPartyId: Scalars['Long']['output'];
};

export type Options_PreferencesFilter = {
  optionId: Scalars['Int']['input'];
  studentPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Options_SaveOptions = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
  studentPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  subjectSets: Array<Options_SaveSubjectSet>;
  validate: Scalars['Boolean']['input'];
  yearGroupId: Scalars['Int']['input'];
};

export type Options_SaveStudentPreference = {
  optionId: Scalars['Int']['input'];
  preferenceIdx: Scalars['Int']['input'];
  studentPartyId: Scalars['Long']['input'];
  subjectId?: InputMaybe<Scalars['Int']['input']>;
  subjectSetIdx: Scalars['Int']['input'];
};

export type Options_SaveSubjectSet = {
  canChoose: Scalars['Int']['input'];
  idx?: InputMaybe<Scalars['Int']['input']>;
  mustGet: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  poolIdx?: InputMaybe<Scalars['Int']['input']>;
  subjectIds: Array<Scalars['Int']['input']>;
};

export type Options_Solution = {
  __typename?: 'Options_Solution';
  minSubjectsPerBlock?: Maybe<Scalars['Int']['output']>;
  optionId: Scalars['Int']['output'];
  pools: Array<Options_SolutionPool>;
  solverStatus: SolutionStatus;
};

export type Options_SolutionPool = {
  __typename?: 'Options_SolutionPool';
  blocks: Array<Options_Block>;
  poolIdx: Scalars['Int']['output'];
  subjectSets: Array<Options_SolutionSubjectSet>;
  subjects: Array<Options_SolutionSubject>;
};

export type Options_SolutionStudentSubjects = {
  __typename?: 'Options_SolutionStudentSubjects';
  student: Person;
  studentPartyId: Scalars['Long']['output'];
  subjectIds: Array<Scalars['Int']['output']>;
  subjects: Array<Subject>;
};

export type Options_SolutionSubject = {
  __typename?: 'Options_SolutionSubject';
  maxPerBlock?: Maybe<Scalars['Int']['output']>;
  maxSize: Scalars['Int']['output'];
  missed: Scalars['Int']['output'];
  numClasses: Scalars['Int']['output'];
  numPreferences: Scalars['Int']['output'];
  poolIdx: Scalars['Int']['output'];
  subject: Subject;
  subjectId: Scalars['Int']['output'];
};

export type Options_SolutionSubjectId = {
  __typename?: 'Options_SolutionSubjectId';
  optionId: Scalars['Int']['output'];
  subjectSetIdx: Scalars['Int']['output'];
};

export type Options_SolutionSubjectSet = {
  __typename?: 'Options_SolutionSubjectSet';
  canChoose: Scalars['Int']['output'];
  id: Options_OptionsId;
  mustGet: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  poolIdx?: Maybe<Scalars['Int']['output']>;
  studentChoices: Array<Options_StudentChoices>;
  subjects: Array<Options_SolutionSubjectSetSubject>;
};

export type Options_SolutionSubjectSetSubject = {
  __typename?: 'Options_SolutionSubjectSetSubject';
  id: Options_OptionsId;
  subject: Subject;
  subjectId: Scalars['Int']['output'];
};

export type Options_Solve = {
  __typename?: 'Options_Solve';
  problemId?: Maybe<Scalars['String']['output']>;
};

export type Options_SolverInput = {
  __typename?: 'Options_SolverInput';
  input: Scalars['Object']['output'];
};

export type Options_StudentChoice = {
  __typename?: 'Options_StudentChoice';
  adminSelectedSubjectId?: Maybe<Scalars['Int']['output']>;
  id: Options_ChoiceId;
  studentSelectedSubjectId: Scalars['Int']['output'];
  /** deep linked */
  subject: Subject;
  subjectId: Scalars['Int']['output'];
};

export type Options_StudentChoices = {
  __typename?: 'Options_StudentChoices';
  reservedUsed: Scalars['Int']['output'];
  studentPartyId: Scalars['Long']['output'];
  subjectSetChoices: Array<Options_Choice>;
  subjectsAllocated: Scalars['Int']['output'];
};

export type Options_StudentPreference = {
  __typename?: 'Options_StudentPreference';
  choices: Array<Options_StudentChoice>;
  id: Options_PreferenceId;
  /** deep linked */
  student: Person;
};

export type Options_StudentPreferenceRaw = {
  __typename?: 'Options_StudentPreferenceRaw';
  adminSelectedSubjectId?: Maybe<Scalars['Int']['output']>;
  optionId: Scalars['Int']['output'];
  preferenceIdx: Scalars['Int']['output'];
  studentPartyId: Scalars['Long']['output'];
  studentSelectedSubjectId?: Maybe<Scalars['Int']['output']>;
  subjectSetIdx: Scalars['Int']['output'];
};

export type Options_SubjectGroup = {
  __typename?: 'Options_SubjectGroup';
  blockIdx: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numStudents: Scalars['Int']['output'];
  pinned: Scalars['Boolean']['output'];
  poolIdx: Scalars['Int']['output'];
  subject: Subject;
  subjectId: Scalars['Int']['output'];
};

export type Options_SubjectGroupMembership = {
  __typename?: 'Options_SubjectGroupMembership';
  id: Scalars['Int']['output'];
  studentPartyIds: Array<Scalars['Long']['output']>;
  students: Array<Student>;
  subjectGroupName: Scalars['String']['output'];
};

export enum OrderingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrganizationTenantFilter = {
  tenant: Scalars['Int']['input'];
};

export enum OutputFormat {
  Docx = 'DOCX',
  Pdf = 'PDF'
}

export type OverallComments = {
  __typename?: 'OverallComments';
  principalCommentsEntered: Scalars['Int']['output'];
  students: Array<CommentStudent>;
  totalCommentsToEnter: Scalars['Int']['output'];
  tutorCommentsEntered: Scalars['Int']['output'];
  yearHeadCommentsEntered: Scalars['Int']['output'];
};

export type OverallCommentsFilter = {
  assessmentId: Scalars['Long']['input'];
  subjectGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  yearGroupId: Scalars['Int']['input'];
};

export type Owner = {
  __typename?: 'Owner';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  addressLine4?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  forename?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type PpodCredentials = {
  __typename?: 'PPODCredentials';
  lastSyncSuccessful: Scalars['Boolean']['output'];
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type PpodFilter = {
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type PpodPublishResultsInput = {
  assessmentId: Scalars['Long']['input'];
  resultIds: Array<Scalars['Long']['input']>;
  subjectGroupIds: Array<Scalars['Long']['input']>;
};

export type PpodStudent = {
  address?: InputMaybe<InputAddress>;
  birthCertForename?: InputMaybe<Scalars['String']['input']>;
  birthCertSurname?: InputMaybe<Scalars['String']['input']>;
  boarding?: InputMaybe<Scalars['Boolean']['input']>;
  boardingDays?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  deceased?: InputMaybe<Scalars['Boolean']['input']>;
  deceasedDate?: InputMaybe<Scalars['Date']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  destinationRollNo?: InputMaybe<Scalars['String']['input']>;
  dpin?: InputMaybe<Scalars['Long']['input']>;
  enrolment?: InputMaybe<PpodStudentEnrolment>;
  examEntrant?: InputMaybe<Scalars['Boolean']['input']>;
  exemptions?: InputMaybe<Array<InputMaybe<PpodStudentExemption>>>;
  forename?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  leavingReason?: InputMaybe<Scalars['String']['input']>;
  leftEarly?: InputMaybe<Scalars['Boolean']['input']>;
  medicalCard?: InputMaybe<Scalars['Boolean']['input']>;
  mothersMaidenName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  ppsn?: InputMaybe<Scalars['String']['input']>;
  previousSchoolRollNum?: InputMaybe<Scalars['String']['input']>;
  previousSchoolType?: InputMaybe<Scalars['String']['input']>;
  shortTermPupil?: InputMaybe<Scalars['Boolean']['input']>;
  shortTermPupilNumWeeks?: InputMaybe<Scalars['Int']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  travellerStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PpodStudentEnrolment = {
  academicYear?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  enrolmentDate?: InputMaybe<Scalars['Date']['input']>;
  leftEarly?: InputMaybe<Scalars['Boolean']['input']>;
  programmeCode?: InputMaybe<Scalars['Int']['input']>;
  programmeYear?: InputMaybe<Scalars['Int']['input']>;
  repeatYear?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PpodStudentExemption = {
  academicYear?: InputMaybe<Scalars['Int']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exemption?: InputMaybe<Scalars['String']['input']>;
  exemptionId?: InputMaybe<Scalars['Long']['input']>;
  exemptionTypeCode?: InputMaybe<Scalars['Int']['input']>;
  grantor?: InputMaybe<Scalars['String']['input']>;
  programmeCode?: InputMaybe<Scalars['Int']['input']>;
  programmeYear?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  studentPartyId?: InputMaybe<Scalars['Long']['input']>;
};

export type PpodSyncEnrolment = {
  __typename?: 'PPODSyncEnrolment';
  academicYear: Scalars['Int']['output'];
  boarding?: Maybe<Scalars['Boolean']['output']>;
  dpin: Scalars['Long']['output'];
  earlyLeaving?: Maybe<Scalars['Boolean']['output']>;
  earlyLeavingDate?: Maybe<Scalars['Date']['output']>;
  enrolmentDate?: Maybe<Scalars['Date']['output']>;
  enrolmentId: Scalars['Long']['output'];
  forename?: Maybe<Scalars['String']['output']>;
  leavingReason?: Maybe<Scalars['String']['output']>;
  newEntrant?: Maybe<Scalars['Boolean']['output']>;
  programme: Scalars['String']['output'];
  programmeYear: Scalars['Int']['output'];
  repeat?: Maybe<Scalars['Boolean']['output']>;
  rollClass?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type PpodSyncExemption = {
  __typename?: 'PPODSyncExemption';
  comments?: Maybe<Scalars['String']['output']>;
  dpin: Scalars['Long']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  exemption: Scalars['String']['output'];
  exemptionId: Scalars['Long']['output'];
  exemptionTypeCode: Scalars['Int']['output'];
  forename?: Maybe<Scalars['String']['output']>;
  grantor?: Maybe<Scalars['String']['output']>;
  programmeCode: Scalars['Int']['output'];
  programmeYear?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type PpodSyncShortCourse = {
  __typename?: 'PPODSyncShortCourse';
  academicYear: Scalars['Int']['output'];
  dpin: Scalars['Long']['output'];
  enrolmentId: Scalars['Long']['output'];
  forename?: Maybe<Scalars['String']['output']>;
  shortCourse?: Maybe<Scalars['String']['output']>;
  shortCourseCode: Scalars['Long']['output'];
  shortCourseLevelCode: Scalars['Int']['output'];
  shortCourseMediumCode: Scalars['Int']['output'];
  surname?: Maybe<Scalars['String']['output']>;
};

export type PpodSyncStudent = {
  __typename?: 'PPODSyncStudent';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address4?: Maybe<Scalars['String']['output']>;
  birthCertChecked?: Maybe<Scalars['Boolean']['output']>;
  birthCertForename?: Maybe<Scalars['String']['output']>;
  birthCertSurname?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  deceased?: Maybe<Scalars['Boolean']['output']>;
  deceasedDate?: Maybe<Scalars['Date']['output']>;
  dpin: Scalars['Long']['output'];
  eircode?: Maybe<Scalars['String']['output']>;
  forename?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  mothersMaidenName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  ppsn?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type PpodSyncSubject = {
  __typename?: 'PPODSyncSubject';
  abInitio?: Maybe<Scalars['Boolean']['output']>;
  academicYear: Scalars['Int']['output'];
  classGroupId?: Maybe<Scalars['String']['output']>;
  dpin: Scalars['Long']['output'];
  enrolmentId: Scalars['Long']['output'];
  forename?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subjectCode: Scalars['Long']['output'];
  subjectLevelCode: Scalars['Int']['output'];
  subjectMediumCode: Scalars['Int']['output'];
  surname?: Maybe<Scalars['String']['output']>;
};

export type PpodVerificationReport = {
  __typename?: 'PPODVerificationReport';
  matchCount: Scalars['Int']['output'];
  mismatchCount: Scalars['Int']['output'];
  notFoundOnPpodCount: Scalars['Int']['output'];
  notPublishedCount: Scalars['Int']['output'];
  results: Array<PpodVerificationResult>;
  unexpectedOnPpodCount: Scalars['Int']['output'];
};

export type PpodVerificationResult = {
  __typename?: 'PPODVerificationResult';
  assessmentResultId: Scalars['Long']['output'];
  lastPublishedGrade?: Maybe<Scalars['String']['output']>;
  nationalCode?: Maybe<Scalars['Int']['output']>;
  ppodGrade?: Maybe<Scalars['String']['output']>;
  status: PpodVerificationStatus;
  studentPartyId: Scalars['Long']['output'];
};

export enum PpodVerificationStatus {
  Match = 'MATCH',
  Mismatch = 'MISMATCH',
  NotFoundOnPpod = 'NOT_FOUND_ON_PPOD',
  NotPublished = 'NOT_PUBLISHED',
  UnexpectedOnPpod = 'UNEXPECTED_ON_PPOD'
}

export type Page = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export enum PageOrientation {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT'
}

export type Pagination = {
  lastId?: InputMaybe<Scalars['Long']['input']>;
  lastMessage?: InputMaybe<Scalars['DateTime']['input']>;
  limit: Scalars['Int']['input'];
};

export type ParentalAttendanceCountFilter = {
  studentPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type ParentalAttendanceRequest = {
  __typename?: 'ParentalAttendanceRequest';
  adminNote?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<Person>;
  approvedByPartyId?: Maybe<Scalars['Long']['output']>;
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  attendanceCode: AttendanceCode;
  attendanceCodeId: Scalars['Int']['output'];
  attendanceNote?: Maybe<Scalars['String']['output']>;
  classGroup?: Maybe<GeneralGroup>;
  contact?: Maybe<StudentContact>;
  contactPartyId?: Maybe<Scalars['Long']['output']>;
  createdOn: Scalars['DateTime']['output'];
  from: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  parentNote: Scalars['String']['output'];
  requestType: ParentalAttendanceRequestType;
  status: ParentalAttendanceRequestStatus;
  student: Person;
  /** temp adding duplication here so mobile doesn't break */
  studentNew: Student;
  studentPartyId: Scalars['Long']['output'];
  submittedBy: Person;
  submittedByPartyId: Scalars['Long']['output'];
  to: Scalars['DateTime']['output'];
};

export type ParentalAttendanceRequestFilter = {
  contactPartyId?: InputMaybe<Scalars['Long']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  status?: InputMaybe<ParentalAttendanceRequestStatus>;
  studentPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export enum ParentalAttendanceRequestStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING',
  Reverted = 'REVERTED'
}

export enum ParentalAttendanceRequestType {
  MultiDay = 'MULTI_DAY',
  PartialDay = 'PARTIAL_DAY',
  SingleDay = 'SINGLE_DAY'
}

export type Party = {
  partyId: Scalars['Long']['output'];
};

export type PartyCalendar = ResourceCalendar & {
  __typename?: 'PartyCalendar';
  events: Array<CalendarEvent>;
  gridsIds: Array<Scalars['Int']['output']>;
  partyInfo?: Maybe<Party>;
  resourceId: Scalars['Long']['output'];
  type: CalendarResourceTypeEnum;
};

export type PartyFilter = {
  filterPartyTypes?: InputMaybe<Array<InputMaybe<PartyType>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nameFuzzySearch?: InputMaybe<Scalars['String']['input']>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type PartyGroup = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  groupTagIds: Array<Scalars['Int']['output']>;
  groupTags: Array<GroupTag>;
  includeInTimetable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  partyId: Scalars['Long']['output'];
  source?: Maybe<Core_PartySource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  studentMembers?: Maybe<Group>;
};

export enum PartyGroupType {
  ClassGroup = 'CLASS_GROUP',
  CustomGroup = 'CUSTOM_GROUP',
  GeneralGroup = 'GENERAL_GROUP',
  ProgrammeStage = 'PROGRAMME_STAGE',
  SubjectGroup = 'SUBJECT_GROUP',
  SupportGroup = 'SUPPORT_GROUP',
  YearGroup = 'YEAR_GROUP'
}

export type PartyPerson = {
  person: Person;
};

export enum PartyPersonType {
  Contact = 'CONTACT',
  Staff = 'STAFF',
  Student = 'STUDENT'
}

export enum PartyType {
  ClassGroup = 'CLASS_GROUP',
  Contact = 'CONTACT',
  CustomGroup = 'CUSTOM_GROUP',
  GeneralGroup = 'GENERAL_GROUP',
  ProgrammeStage = 'PROGRAMME_STAGE',
  Staff = 'STAFF',
  Student = 'STUDENT',
  SubjectGroup = 'SUBJECT_GROUP',
  YearGroup = 'YEAR_GROUP'
}

export type PartyTypeFilter = {
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float']['output'];
  cardType: Scalars['String']['output'];
  fee: Fee;
  feesAbsorbed: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  installment?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  payee: Person;
  payeePartyId: Scalars['Long']['output'];
  paymentIntentId: Scalars['String']['output'];
  paymentMethod: PaymentMethod;
  paymentStatus: PaymentStatus;
  refunds: Array<Refund>;
  serviceFeesAmount: Scalars['Float']['output'];
  sourceTransferId?: Maybe<Scalars['String']['output']>;
  student?: Maybe<Student>;
  studentPartyId: Scalars['Long']['output'];
  transactionDate: Scalars['DateTime']['output'];
};

export type PaymentFilter = {
  feeId?: InputMaybe<Scalars['Int']['input']>;
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  payeePartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  studentPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export enum PaymentMethod {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH',
  Cheque = 'CHEQUE',
  StripeBankTransfer = 'STRIPE_BANK_TRANSFER',
  Terminal = 'TERMINAL'
}

export type PaymentPlan = {
  __typename?: 'PaymentPlan';
  absorbFees: Scalars['Boolean']['output'];
  cardUsed: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  installments: Array<PaymentPlanInstallment>;
  payee: Person;
  payeePartyId: Scalars['Long']['output'];
  status: PaymentPlanStatus;
};

export type PaymentPlanFilter = {
  paymentPlanIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type PaymentPlanId = {
  __typename?: 'PaymentPlanId';
  feeId: Scalars['Int']['output'];
  studentPartyId: Scalars['Long']['output'];
};

export type PaymentPlanInstallment = {
  __typename?: 'PaymentPlanInstallment';
  absorbFees: Scalars['Boolean']['output'];
  amount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  installment: Scalars['Int']['output'];
  installmentDate: Scalars['Date']['output'];
  paymentPlanId: Scalars['Int']['output'];
  serviceCharges: Scalars['Float']['output'];
  status: InstallmentStatus;
};

export type PaymentPlanInstallments = {
  __typename?: 'PaymentPlanInstallments';
  id: PaymentPlanId;
  installments: Array<PaymentPlanInstallment>;
};

export type PaymentPlanInstallmentsFilter = {
  paymentPlanIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export enum PaymentPlanInterval {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum PaymentPlanStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Paid = 'PAID',
  Refunded = 'REFUNDED'
}

export enum PaymentStatus {
  AwaitingBankTransfer = 'AWAITING_BANK_TRANSFER',
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Failed = 'FAILED',
  PartiallyFunded = 'PARTIALLY_FUNDED',
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED'
}

export enum PayoutStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  InTransit = 'IN_TRANSIT',
  Paid = 'PAID',
  Updated = 'UPDATED'
}

export type Pbac_AreaMetaData = {
  __typename?: 'Pbac_AreaMetaData';
  entityType: Pbac_EntityType;
  groupLevel: Pbac_AreaMetaData_GroupLevel;
  resourceLevel: Pbac_AreaMetaData_ResourceLevel;
};

export type Pbac_AreaMetaData_GroupLevel = {
  __typename?: 'Pbac_AreaMetaData_GroupLevel';
  supportsPolicyUpdates: Scalars['Boolean']['output'];
};

export type Pbac_AreaMetaData_ResourceLevel = {
  __typename?: 'Pbac_AreaMetaData_ResourceLevel';
  supportsPolicyUpdates: Scalars['Boolean']['output'];
};

export enum Pbac_EntityType {
  /**
   * A folder itself when it carries an access-control list (folder
   * type = SHARED). PBAC policies attached to a FOLDER grant additive
   * read access to every entity placed inside the folder — see
   * FolderPbacPartial for the union branch that materialises this.
   */
  Folder = 'FOLDER',
  FolderFile = 'FOLDER_FILE',
  Form = 'FORM',
  Notev2 = 'NOTEV2',
  StudentNote = 'STUDENT_NOTE',
  Timetable = 'TIMETABLE'
}

export enum Pbac_Level {
  Group = 'GROUP',
  Resource = 'RESOURCE'
}

export enum Pbac_OperationType {
  ChangePbac = 'CHANGE_PBAC',
  Delete = 'DELETE',
  Read = 'READ',
  Write = 'WRITE'
}

export type Pbac_ResolvedAuth = {
  __typename?: 'Pbac_ResolvedAuth';
  isPbacSecured: Scalars['Boolean']['output'];
  rows: Array<Pbac_ResolvedAuthRow>;
};

export type Pbac_ResolvedAuthFilter = {
  entity: Pbac_ResourcePolicyByEntityFilter;
  /** default true */
  expandGroup?: InputMaybe<Scalars['Boolean']['input']>;
  lookupLevel: Pbac_Level;
};

export type Pbac_ResolvedAuthOtherParties = {
  __typename?: 'Pbac_ResolvedAuthOtherParties';
  party: Party;
  partyId: Scalars['Long']['output'];
};

export type Pbac_ResolvedAuthRow = {
  __typename?: 'Pbac_ResolvedAuthRow';
  canChangeAuth: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canRead: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parties?: Maybe<Array<Maybe<Pbac_ResolvedAuthOtherParties>>>;
  randomIdentifier: Scalars['String']['output'];
  source: Pbac_ResolvedAuthRowSource;
};

export enum Pbac_ResolvedAuthRowSource {
  FromCreatorPolicy = 'FROM_CREATOR_POLICY',
  FromDirectStaffPolicy = 'FROM_DIRECT_STAFF_POLICY',
  FromGroupStaffPolicy = 'FROM_GROUP_STAFF_POLICY',
  FromOtherPolicy = 'FROM_OTHER_POLICY',
  FromPermissionGroup = 'FROM_PERMISSION_GROUP',
  IsSuperUser = 'IS_SUPER_USER'
}

export type Pbac_Resource = {
  __typename?: 'Pbac_Resource';
  activeUserCanChangeAuth: Scalars['Boolean']['output'];
  entityId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Pbac_EntityType;
  overview?: Maybe<Pbac_ResourceOverview>;
  pbacPolicyId: Scalars['Int']['output'];
  policies: Array<Pbac_ResourcePolicy>;
};

export type Pbac_ResourceOverview = {
  __typename?: 'Pbac_ResourceOverview';
  rows: Array<Pbac_ResourceOverviewRow>;
};

export enum Pbac_ResourceOverviewEditEnum {
  CanOverride = 'CAN_OVERRIDE',
  Editable = 'EDITABLE',
  ReadOnly = 'READ_ONLY'
}

export type Pbac_ResourceOverviewRow = {
  __typename?: 'Pbac_ResourceOverviewRow';
  canChangeAuth: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canRead: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
  editStatus: Pbac_ResourceOverviewEditEnum;
  hintMessage?: Maybe<Scalars['String']['output']>;
  party: Party;
  partyId: Scalars['Long']['output'];
};

export type Pbac_ResourcePolicy = {
  __typename?: 'Pbac_ResourcePolicy';
  entityType: Pbac_EntityType;
  name: Scalars['String']['output'];
  parties: Array<Pbac_ResourcePolicyParty>;
  policyLevel: Pbac_Level;
  policyType: PolicyType;
};

export type Pbac_ResourcePolicyByEntityFilter = {
  entityId: Scalars['String']['input'];
  entityType: Pbac_EntityType;
};

export type Pbac_ResourcePolicyFilter = {
  entities: Array<Pbac_ResourcePolicyByEntityFilter>;
  lookupLevel: Pbac_Level;
  pbacIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Pbac_ResourcePolicyParty = {
  __typename?: 'Pbac_ResourcePolicyParty';
  canChangeAuth: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canRead: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
  party: Party;
  partyId: Scalars['Long']['output'];
};

export type Pbac_ResourceResult = {
  __typename?: 'Pbac_ResourceResult';
  canChangePbac: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canRead: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
  isSecured: Scalars['Boolean']['output'];
};

export type Pbac_SearchForParties = {
  entityId: Array<Scalars['String']['input']>;
  entityType: Pbac_EntityType;
  lookupLevel: Pbac_Level;
};

export type Pbac_SearchResult = {
  __typename?: 'Pbac_SearchResult';
  canChangeAuth: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canRead: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
  party: Party;
  partyId: Scalars['Long']['output'];
};

export type Pbac_UpsertCreatorResourcePolicy = {
  canChangeAuth: Scalars['Boolean']['input'];
  canDelete: Scalars['Boolean']['input'];
  canRead: Scalars['Boolean']['input'];
  canWrite: Scalars['Boolean']['input'];
};

export type Pbac_UpsertFromOverview = {
  entityId: Scalars['String']['input'];
  entityType: Pbac_EntityType;
  level: Pbac_Level;
  policy_staff: Array<Pbac_UpsertStaffResourcePolicy>;
};

export type Pbac_UpsertResourcePolicy = {
  entityId: Scalars['String']['input'];
  entityType: Pbac_EntityType;
  level: Pbac_Level;
  pbacId?: InputMaybe<Scalars['Int']['input']>;
  policy_creator?: InputMaybe<Pbac_UpsertCreatorResourcePolicy>;
  policy_staff: Array<Pbac_UpsertStaffResourcePolicy>;
};

export enum Pbac_UpsertResourcePolicyResulErrorTypeEnum {
  DonestHavePermission = 'DONEST_HAVE_PERMISSION',
  InvalidPartyType = 'INVALID_PARTY_TYPE'
}

export type Pbac_UpsertResourcePolicyResult = {
  __typename?: 'Pbac_UpsertResourcePolicyResult';
  errors?: Maybe<Array<Pbac_UpsertResourcePolicyResultError>>;
  policyId?: Maybe<Scalars['Int']['output']>;
  success: Pbac_UpsertResourcePolicyResultEnum;
};

export enum Pbac_UpsertResourcePolicyResultEnum {
  Failure = 'FAILURE',
  PartialSuccess = 'PARTIAL_SUCCESS',
  Success = 'SUCCESS'
}

export type Pbac_UpsertResourcePolicyResultError = {
  __typename?: 'Pbac_UpsertResourcePolicyResultError';
  errorType: Pbac_UpsertResourcePolicyResulErrorTypeEnum;
  message: Scalars['String']['output'];
  parties?: Maybe<Party>;
  partyIds: Array<Scalars['Long']['output']>;
};

export type Pbac_UpsertStaffResourcePolicy = {
  canChangeAuth: Scalars['Boolean']['input'];
  canDelete: Scalars['Boolean']['input'];
  canRead: Scalars['Boolean']['input'];
  canWrite: Scalars['Boolean']['input'];
  partyIds: Array<Scalars['Long']['input']>;
};

export type PeopleAddedToGroupInput = {
  addedFrom?: InputMaybe<Scalars['Date']['input']>;
  groupId: Scalars['Long']['input'];
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type PeopleTag = {
  __typename?: 'PeopleTag';
  colour: Colour;
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
  refId?: Maybe<Scalars['String']['output']>;
  systemTag: Scalars['Boolean']['output'];
  type?: Maybe<PeopleTagType>;
  uniqueName?: Maybe<Scalars['String']['output']>;
};

export enum PeopleTagType {
  Role = 'ROLE'
}

export type Permission = {
  __typename?: 'Permission';
  description: Scalars['String']['output'];
  descriptionTextId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
};

export type PermissionForGroup = {
  permission?: InputMaybe<Scalars['String']['input']>;
  permissionType?: InputMaybe<PermissionType>;
};

export type PermissionGroup = {
  __typename?: 'PermissionGroup';
  custom?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  memberPartyIds: Array<Scalars['Long']['output']>;
  memberType: MemberType;
  name: Scalars['String']['output'];
  nameTextId?: Maybe<Scalars['Int']['output']>;
  permissionSets: Array<PermissionGroupPermissionSet>;
};

export type PermissionGroupFilter = {
  custom?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type PermissionGroupPermissionSet = {
  __typename?: 'PermissionGroupPermissionSet';
  feature?: Maybe<Feature>;
  id: Scalars['String']['output'];
  permissionType?: Maybe<PermissionType>;
  toggle?: Maybe<Scalars['Boolean']['output']>;
};

export type PermissionSet = {
  __typename?: 'PermissionSet';
  contact: Scalars['Boolean']['output'];
  context?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  descriptionTextId: Scalars['Int']['output'];
  feature?: Maybe<Feature>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
  permissionType?: Maybe<PermissionType>;
  permissions?: Maybe<Array<Permission>>;
  staff: Scalars['Boolean']['output'];
  student: Scalars['Boolean']['output'];
  toggle?: Maybe<Scalars['Boolean']['output']>;
  visibleToSchools: Scalars['Boolean']['output'];
};

export type PermissionSetFilter = {
  contact?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  staff?: InputMaybe<Scalars['Boolean']['input']>;
  student?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PermissionType {
  All = 'ALL',
  GroupAdmin = 'GROUP_ADMIN',
  MemberOfGroup = 'MEMBER_OF_GROUP',
  Self = 'SELF'
}

export type PermissionsFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Person = {
  __typename?: 'Person';
  archived?: Maybe<Scalars['Boolean']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Core_PartyCustomField>>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  partyId: Scalars['Long']['output'];
  title?: Maybe<PersonalTitle>;
  type?: Maybe<PartyPersonType>;
};

export type PersonFilter = {
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  profilePartyType?: InputMaybe<PartyPersonType>;
};

export type PersonStatus = {
  __typename?: 'PersonStatus';
  activeMedical?: Maybe<Scalars['Boolean']['output']>;
  activeSupportPlan?: Maybe<Scalars['Boolean']['output']>;
  currentLocation?: Maybe<CurrentLocation>;
  partyId: Scalars['Long']['output'];
  priorityStudent?: Maybe<Scalars['Boolean']['output']>;
  sessionAttendance?: Maybe<Array<Maybe<SessionAttendanceStatus>>>;
};

export type PersonStatusFilter = {
  partyId?: InputMaybe<Scalars['Long']['input']>;
};

export type PersonalInformation = {
  __typename?: 'PersonalInformation';
  addresses?: Maybe<Array<Maybe<Address>>>;
  birthCertFirstName?: Maybe<Scalars['String']['output']>;
  birthCertLastName?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  emails?: Maybe<Array<Maybe<EmailAddress>>>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  ire?: Maybe<PersonalInformationIre>;
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  mothersMaidenName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  nextOfKin?: Maybe<NextOfKin>;
  partyId?: Maybe<Scalars['Long']['output']>;
  partyPersonType?: Maybe<PartyPersonType>;
  personalInformationId?: Maybe<Scalars['Int']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumber>>>;
  preferredFirstName?: Maybe<Scalars['String']['output']>;
  preferredLastName?: Maybe<Scalars['String']['output']>;
  primaryAddress?: Maybe<Address>;
  primaryEmail?: Maybe<EmailAddress>;
  primaryPhoneNumber?: Maybe<PhoneNumber>;
};

export type PersonalInformationFilter = {
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type PersonalInformationInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  ire?: InputMaybe<PersonalInformationIreInput>;
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalInformationIre = {
  __typename?: 'PersonalInformationIre';
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  ppsNumber?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
};

export type PersonalInformationIreInput = {
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  ppsNumber?: InputMaybe<Scalars['String']['input']>;
  religion?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalTitle = {
  __typename?: 'PersonalTitle';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  active?: Maybe<Scalars['Boolean']['output']>;
  areaCode?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  partyId: Scalars['Long']['output'];
  phoneNumberId?: Maybe<Scalars['Int']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
};

export enum PolicyType {
  Creator = 'CREATOR',
  Staff = 'STAFF'
}

export type PreviousEventAttendance = {
  __typename?: 'PreviousEventAttendance';
  attendanceCode: AttendanceCode;
  attendanceCodeId: Scalars['Int']['output'];
  eventId: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  personPartyId: Scalars['Long']['output'];
};

export type PreviousEventAttendanceFilter = {
  eventIds?: InputMaybe<Array<AttendanceEventId>>;
};

export type PrimarySchoolIre = {
  __typename?: 'PrimarySchoolIre';
  rollNumber: Scalars['String']['output'];
  schoolName: Scalars['String']['output'];
};

export type PrimarySchoolIreFilter = {
  rollNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum PrintType {
  /** prints per context type (i.e. Staff, Student, etc...) */
  PagedPerEntity = 'PAGED_PER_ENTITY',
  /** Prints all html on single page */
  SinglePage = 'SINGLE_PAGE'
}

export type Print_AssessmentOptions = {
  academicNameSpaceId?: InputMaybe<Scalars['Int']['input']>;
  assessmentId: Scalars['Long']['input'];
  classGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  docxFileTransferId?: InputMaybe<Scalars['Long']['input']>;
  includeAbsenceCount: Scalars['Boolean']['input'];
  includeCAOPoints: Scalars['Boolean']['input'];
  includeExtraFields: Scalars['Boolean']['input'];
  includeGrade: Scalars['Boolean']['input'];
  includeLateCount: Scalars['Boolean']['input'];
  includeLevel: Scalars['Boolean']['input'];
  includePrincipalComment: Scalars['Boolean']['input'];
  includeResult: Scalars['Boolean']['input'];
  includeTeacherComment: Scalars['Boolean']['input'];
  includeTutorComment: Scalars['Boolean']['input'];
  includeYearHeadComment: Scalars['Boolean']['input'];
  orientation: PageOrientation;
  printColour: Scalars['Boolean']['input'];
  studentIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  yearGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Print_Clm = {
  blocks?: InputMaybe<Array<Print_Clm_Block>>;
  format: ClmPrintFormat;
  type: ClmPrintType;
  yearGroupEnrollmentId?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Print_Clm_Block = {
  blockId: Scalars['String']['input'];
  rotationIteration?: InputMaybe<Scalars['Int']['input']>;
};

export type Print_FeeOptions = {
  feeId?: InputMaybe<Scalars['Int']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  studentId?: InputMaybe<Scalars['Long']['input']>;
  type: ReceiptType;
};

export type Print_GroupMembers = {
  groupIds: Array<Scalars['Long']['input']>;
  options: Print_GroupMembersOptions;
};

export enum Print_GroupMembersOptions {
  Csv = 'CSV',
  Print = 'PRINT'
}

export type Print_OptionsMail = {
  canReply?: InputMaybe<Scalars['Boolean']['input']>;
  contacts?: InputMaybe<Scalars['Boolean']['input']>;
  optionId: Scalars['Int']['input'];
  students?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Print_PersonsGroupMemberships = {
  groupTypes: Array<PartyGroupType>;
  options: Print_GroupMembersOptions;
  personIds: Array<Scalars['Long']['input']>;
};

export type Print_StudentOptionsMembers = {
  options: Print_GroupMembersOptions;
  optionsIds: Scalars['Int']['input'];
};

export type Print_SubjectOptions = {
  format: SubjectOptionsPrintFormat;
  optionId: Scalars['Int']['input'];
  orientation: PageOrientation;
  printColour: Scalars['Boolean']['input'];
};

export enum Print_TimetableLayout {
  Combined = 'COMBINED',
  CombinedDayPeriodYAxis = 'COMBINED_DAY_PERIOD_Y_AXIS',
  DaysOnXAxis = 'DAYS_ON_X_AXIS',
  PeriodsOnXAxis = 'PERIODS_ON_X_AXIS'
}

export type Print_TimetableOptions = {
  calendarEventTypes?: InputMaybe<Array<CalendarEventType>>;
  /** collapse block-group lessons shared across multiple classes to a single occurrence */
  condenseSharedLessons?: InputMaybe<Scalars['Boolean']['input']>;
  /** scale each timetable down so it fits on a single A4 page when printing */
  fitToPage?: InputMaybe<Scalars['Boolean']['input']>;
  fontSize?: InputMaybe<Scalars['Int']['input']>;
  groupTagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** default true */
  hideSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  individualStudents: Scalars['Boolean']['input'];
  /** invert what is displayed to show free spots */
  invert?: InputMaybe<Scalars['Boolean']['input']>;
  layout: Print_TimetableLayout;
  /** page orientation when printing; defaults to landscape */
  orientation?: InputMaybe<PageOrientation>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  periodDisplayInCell: Print_TimetablePeriodDisplayInCell;
  periodDisplayOnAxis: Print_TimetablePeriodDisplayOnAxis;
  printWeekOf?: InputMaybe<Scalars['Date']['input']>;
  printWithColour: Scalars['Boolean']['input'];
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rootSourceType?: InputMaybe<Print_TimetableRootSourceType>;
  showGroupNames: Scalars['Boolean']['input'];
  showRooms: Scalars['Boolean']['input'];
  subjectFormat: Print_TimetableSubjectFormat;
  teacherDisplayOption: Print_TimetableStaffFormat;
  timetableId?: InputMaybe<Scalars['Int']['input']>;
  ttClassGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  ttGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export enum Print_TimetablePeriodDisplayInCell {
  Hide = 'HIDE',
  PeriodNumber = 'PERIOD_NUMBER',
  Time = 'TIME'
}

export enum Print_TimetablePeriodDisplayOnAxis {
  Hide = 'HIDE',
  PeriodNumber = 'PERIOD_NUMBER',
  Time = 'TIME'
}

export enum Print_TimetableRootSourceType {
  ClassGroup = 'CLASS_GROUP',
  Room = 'ROOM',
  Staff = 'STAFF',
  Student = 'STUDENT',
  Year = 'YEAR'
}

export enum Print_TimetableStaffFormat {
  DisplayCode = 'DISPLAY_CODE',
  Full = 'FULL',
  Hide = 'HIDE'
}

export enum Print_TimetableSubjectFormat {
  Code = 'CODE',
  Full = 'FULL',
  Short = 'SHORT'
}

export type PriorityStudent = {
  __typename?: 'PriorityStudent';
  from?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  studentPartyId?: Maybe<Scalars['Long']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type PriorityStudentFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  studentPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type Profile = {
  __typename?: 'Profile';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Blocked>;
  contactInfo?: Maybe<ProfileContactInfo>;
  globalUserId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  microsoftEntraId?: Maybe<Scalars['String']['output']>;
  nickName?: Maybe<Scalars['String']['output']>;
  partyId?: Maybe<Scalars['Long']['output']>;
  permissionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  permissions?: Maybe<Array<Permission>>;
  profileType?: Maybe<ProfileType>;
  profileTypeId?: Maybe<Scalars['Int']['output']>;
  subTenants?: Maybe<Array<Scalars['Int']['output']>>;
  tenant: Tenant;
  tenantId?: Maybe<Scalars['Int']['output']>;
};

export type ProfileContactInfo = {
  __typename?: 'ProfileContactInfo';
  hasAccessToStudents: Array<Scalars['Long']['output']>;
};

export type ProfileFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  partyPersonIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type ProfileType = {
  __typename?: 'ProfileType';
  description: Scalars['String']['output'];
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId?: Maybe<Scalars['Int']['output']>;
  userType: UserType;
};

export type ProfileTypeFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Programme = {
  __typename?: 'Programme';
  awardingBody?: Maybe<AwardingBody>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  discontinued: Scalars['Boolean']['output'];
  editable: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId?: Maybe<Scalars['Int']['output']>;
  nationalCode?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  shortNameTextId?: Maybe<Scalars['Int']['output']>;
  stageIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** deep linked */
  stages?: Maybe<Array<ProgrammeStage>>;
};

export type ProgrammeFilter = {
  academicNamespaceId?: InputMaybe<Scalars['Int']['input']>;
  /** Exclude programmes the school has discontinued for the given academicNamespaceId. Defaults to true. */
  excludeDiscontinued?: InputMaybe<Scalars['Boolean']['input']>;
  programmeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ProgrammeStage = {
  __typename?: 'ProgrammeStage';
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  discontinued: Scalars['Boolean']['output'];
  editable: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId?: Maybe<Scalars['Int']['output']>;
  nationalCode: Scalars['String']['output'];
  programme?: Maybe<Programme>;
  programmeId: Scalars['Int']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  shortNameTextId?: Maybe<Scalars['Int']['output']>;
  subjectIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** deep linked */
  subjects?: Maybe<Array<Maybe<Subject>>>;
  yearGroupId: Scalars['Int']['output'];
};

export type ProgrammeStageEnrollment = Party & PartyGroup & {
  __typename?: 'ProgrammeStageEnrollment';
  academicNamespaceId: Scalars['Int']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  groupTagIds: Array<Scalars['Int']['output']>;
  groupTags: Array<GroupTag>;
  includeInTimetable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  partyId: Scalars['Long']['output'];
  programmeId: Scalars['Int']['output'];
  programmeStage?: Maybe<ProgrammeStage>;
  programmeStageEnrollmentPartyId: Scalars['Long']['output'];
  programmeStageId: Scalars['Int']['output'];
  programmeStageLeads: Array<Person>;
  source?: Maybe<Core_PartySource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  studentMembers?: Maybe<Group>;
  students: Array<Student>;
};

export type ProgrammeStageEnrollmentFilter = {
  programmeStageEnrollmentPartyId?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type ProgrammeStageFilter = {
  academicNamespaceId?: InputMaybe<Scalars['Int']['input']>;
  /** Exclude programme stages the school has discontinued for the given academicNamespaceId. Defaults to true. */
  excludeDiscontinued?: InputMaybe<Scalars['Boolean']['input']>;
  programmeStageIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type PublishAssessmentInput = {
  assessmentId: Scalars['Long']['input'];
  publish: Scalars['Boolean']['input'];
  publishFrom?: InputMaybe<Scalars['Date']['input']>;
  subjectGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type PublishInput = {
  feeId: Scalars['Int']['input'];
  publish: Scalars['Boolean']['input'];
};

export type PurchaseAddOnInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<XeroProduct>;
  purchaseOrder?: InputMaybe<Scalars['String']['input']>;
};

export type PushNotificationRecipient = {
  metadata: NotificationMetaDataInput;
  recipientPartyId: Scalars['Long']['input'];
  userType: NotificationUserType;
};

export type Query = {
  __typename?: 'Query';
  admin__party_people?: Maybe<Array<Person>>;
  admin__tenants?: Maybe<Array<Tenant>>;
  asd?: Maybe<Scalars['String']['output']>;
  assessment_assessment?: Maybe<Array<Assessment>>;
  assessment_assessmentComment?: Maybe<Array<AssessmentComment>>;
  assessment_assessmentResult?: Maybe<Array<AssessmentResult>>;
  assessment_assessmentSubjectGroups?: Maybe<Array<AssessmentSubjectGroup>>;
  assessment_calculateGrade: CalculatedGrade;
  assessment_commentBank?: Maybe<Array<CommentBank>>;
  assessment_dashboardAssessment?: Maybe<Array<DashboardAssessment>>;
  assessment_gradeSet?: Maybe<Array<GradeSet>>;
  assessment_grades: Array<Grade>;
  assessment_overallComments?: Maybe<OverallComments>;
  assessment_studentResult: Array<AssessmentResult>;
  attendance_attendanceCodes: Array<AttendanceCode>;
  attendance_bulkAttendanceActions: Array<Attendance_BulkAttendanceAction>;
  attendance_calendarAttendance: CalendarAttendance;
  attendance_eventAttendance: Array<EventAttendance>;
  attendance_eventAttendanceReport: EventAttendanceReport;
  attendance_parentalAttendanceRequests: Array<ParentalAttendanceRequest>;
  attendance_parentalRequestCount?: Maybe<Attendance_ParentalRequestCounter>;
  attendance_rollBookAttendance: Array<Attendance_StudentRollBook>;
  attendance_sessionAttendanceList: Array<SessionAttendanceList>;
  attendance_signInOutReport: Array<SignInOut>;
  attendance_studentRollBookAttendance: Attendance_StudentRollBookAttendance;
  attendance_studentSessionAttendance: Array<StudentSessionAttendance>;
  calendar_bellTimes: Array<Calendar_BellTime>;
  calendar_calendar: Array<Calendar>;
  calendar_calendarDayBellTimes: Array<CalendarDayBellTime>;
  calendar_calendarEvents?: Maybe<ResourceCalendarWrapper>;
  calendar_calendarEventsForEdit: Array<CalendarEventRawSimple>;
  /** depricated */
  calendar_calendarEventsIterator?: Maybe<CalendarEvent>;
  calendar_calendarEventsIterator_v2?: Maybe<Calendar_EventIteratorResult>;
  calendar_cancellationRecommendations: Calendar_CancellationRecommendationsResult;
  calendar_dayInfo: Array<CalendarDayInfo>;
  calendar_eventTags: Array<Calendar_EventTag>;
  /** Checks whether the searched for calendar resources are free or not at particular times */
  calendar_findFreeResources: FreeCalendarResources;
  calendar_findNextFreeSlot: Calendar_NextFreeSlot;
  calendar_grids: Array<CalendarGrid>;
  calendar_ical_schoolCalendar?: Maybe<Calendar_Ical_SchoolCalendar>;
  calendar_viewFollows: Array<Calendar_Follow>;
  catalogue_groupTags: Array<GroupTag>;
  catalogue_peopleTags: Array<PeopleTag>;
  catalogue_personalTitles: Array<PersonalTitle>;
  catalogue_programmeStages: Array<ProgrammeStage>;
  catalogue_programmes: Array<Programme>;
  catalogue_staffCapacities: Array<StaffCapacity>;
  catalogue_staffPosts: Array<StaffPost>;
  catalogue_subjects: Array<Subject>;
  catalogue_systemSettingsValues: Dyn_SystemSettings;
  catalogue_systemSettingsView: Array<Catalogue_SystemSettings>;
  catalogue_years: Array<YearGroup>;
  /** sms endpoints */
  communications_currentBalance?: Maybe<SmsCurrentBalance>;
  communications_failedNotifications: Array<FailedNotification>;
  communications_failedSms: Array<FailedSms>;
  communications_label: Array<Label>;
  /** mail endpoints */
  communications_mail: Array<Mail>;
  communications_mailReadReceipt: Array<ReadRecipient>;
  communications_mailSearch: Array<Mail>;
  communications_mailThread: Array<MailThread>;
  /** noticeboard endpoints */
  communications_noticeboard: Array<Notice>;
  communications_noticeboardConfig?: Maybe<Communications_NoticeboardConfig>;
  communications_notificationCount?: Maybe<NotificationsUnreadCount>;
  communications_notificationSchoolSettings: Array<SchoolNotificationSetting>;
  communications_notificationTemplates: Array<NotificationTemplate>;
  communications_notifications: Array<Notification>;
  communications_parties: Array<Search>;
  communications_recipients: Array<Search>;
  /** notifications endpoints */
  communications_registeredDevices: Array<DeviceRegistration>;
  communications_scheduledNotifications: Array<ScheduledNotification>;
  communications_scheduledSms: Array<ScheduledSms>;
  communications_sms: Array<Sms>;
  communications_smsCost?: Maybe<SmsCost>;
  /** social media endpoints */
  communications_socialIntegration: SocialIntegration;
  communications_unreadCount: Array<UnreadCount>;
  composite_cmsConfig?: Maybe<Cms_Config>;
  composite_extractStudentData: TemporaryDownload;
  composite_permissionGroups: Array<Maybe<PermissionGroup>>;
  composite_personStatus: PersonStatus;
  composite_tenantSettings: Composite_TenantSettings;
  core_academicNamespaces?: Maybe<Array<AcademicNamespace>>;
  core_blocks: Array<CoreBlock>;
  core_buildings: Array<Building>;
  core_campusTravelTimes: Array<CampusTravelTime>;
  core_campuses: Array<Campus>;
  core_customFields: Array<Core_CustomField>;
  core_customGroupDefinition: Core_CustomGroupDefinition;
  core_customGroupFieldOptions: Core_CustomGroupFieldOptions;
  core_parties: Array<Party>;
  core_people: Array<Person>;
  core_programmeStageEnrollments: Array<ProgrammeStageEnrollment>;
  core_roomPools?: Maybe<Array<RoomPool>>;
  core_rooms?: Maybe<Array<Room>>;
  core_staff: Array<Staff>;
  core_staffAvailability: Array<Core_StaffAvailability>;
  core_studentContacts?: Maybe<Array<StudentContact>>;
  core_students: Array<Student>;
  core_subjectGroupStudents: Array<StudentSubjectGroup>;
  core_yearGroupEnrollments: Array<YearGroupEnrollment>;
  documentation_admin_activeChangeRequestForPage?: Maybe<Documentation_ActiveChangeRequestForPage>;
  documentation_admin_allPages: Array<Documentation_AdminPageSummary>;
  documentation_admin_changeRequest?: Maybe<Documentation_ChangeRequest>;
  documentation_admin_changeRequestDiff: Array<Documentation_ChangeRequestDiff>;
  documentation_admin_changeRequests: Array<Documentation_ChangeRequest>;
  documentation_admin_conflictingChangeRequests: Array<Documentation_ChangeRequest>;
  documentation_admin_exportPage?: Maybe<Documentation_ExportResult>;
  documentation_admin_exportSpace?: Maybe<Documentation_ExportResult>;
  documentation_admin_pageDetail?: Maybe<Documentation_PageDetail>;
  documentation_admin_pageVersionContent?: Maybe<Documentation_PageVersion>;
  documentation_admin_pageVersions: Array<Documentation_PageVersion>;
  documentation_admin_pages: Array<Documentation_AdminPageListItem>;
  documentation_admin_permissions: Array<Documentation_PermissionInfo>;
  documentation_admin_releaseTags: Array<Documentation_ReleaseTag>;
  documentation_user_page?: Maybe<Documentation_Page>;
  documentation_user_pageMetadata: Array<Documentation_PageMetadata>;
  documentation_user_pages: Array<Documentation_Page>;
  documentation_user_relatedPages: Array<Documentation_RelatedPage>;
  documentation_user_search: Array<Documentation_SearchResult>;
  documentation_user_space?: Maybe<Documentation_Space>;
  documentation_user_spaces: Array<Documentation_Space>;
  /**
   * ACL attached to a single SHARED folder. Returns null for UI_ONLY
   * folders (or SHARED folders with no subjects). Access depends on
   * surface: SchoolDrive folder creator or `school_drive:manage_acl`;
   * MyDrive folder owner or admin with `my_drive:manage_acl`.
   */
  drive_folderAcl?: Maybe<Folders_FolderAcl>;
  /**
   * Current user's folder-derived read grants for each requested item —
   * drives the "access via X folder" chip. No permission gate; only
   * reveals the caller's own access paths.
   */
  drive_folderGrantsForCurrentUser: Array<Folders_FolderGrantPathEntry>;
  /**
   * Items placed inside a drive folder (or at the surface root when
   * `folderId` is null).
   */
  drive_items: Array<Folders_FolderItem>;
  /**
   * Preview the effect of removing a party from a folder's ACL. Surface
   * access rules match `drive_folderAcl`.
   */
  drive_previewAclSubjectRemoval: Folders_ResidualAccessPreview;
  /**
   * Folder tree for the given drive surface. Requires the surface's read
   * permission (`api:school_drive:read:folders` /
   * `api:my_drive:read:folders`); MyDrive implicitly scopes to the caller's
   * own tree.
   */
  drive_tree: Array<Folders_Folder>;
  eire_nonClassContactHours?: Maybe<Array<Maybe<NonClassContactHours>>>;
  enrollment_ire_blockMemberships: EnrollmentIre_BlockMemberships;
  enrollment_ire_coreMemberships: EnrollmentIre_CoreMemberships;
  export_ptm: TemporaryDownload;
  export_ptm2: Scheduling_SubmitJobResult;
  fees_accountingCodes: Array<AccountingCode>;
  fees_cardPaymentPlans: Array<CardPaymentPlan>;
  fees_categories: Array<Category>;
  fees_discountAssignees: Array<DiscountAssignee>;
  fees_discounts: Array<Discount>;
  fees_fees: Array<Fee>;
  fees_paymentPlanInstallments: Array<PaymentPlanInstallments>;
  fees_payments: Array<Payment>;
  fees_savedCards: Array<SavedCard>;
  fees_serviceCharges: ServiceCharge;
  fees_stripeAccount: StripeAccount;
  fees_stripeCustomerInfo: StripeCustomerInfo;
  fees_studentFees: Array<StudentFee>;
  file_transfer_list?: Maybe<Array<FileTransferResponse>>;
  formsAdmin_blankForm: Forms_FormView;
  formsAdmin_extensionPoints: Array<Dtab_ExtensionPointConfig>;
  formsAdmin_formDefinitions: Array<FormsFd_FormDefinition>;
  formsAdmin_informationRequest: Array<FormsAdmin_InformationRequestDefinition>;
  formsAdmin_informationRequestTableView?: Maybe<Forms_InformationRequestResponseTable>;
  formsAdmin_tags: Array<Dtab_Tag>;
  forms_charts: Array<Charts_Chart>;
  forms_listInformationRequestForms: Array<Forms_FormListing>;
  forms_searchFormsSubmissions: Array<Form_FormResponseInfo>;
  forms_table: Dtab_Table;
  forms_tableLookup: Array<Dtab_Table>;
  forms_viewInformationRequestForms: Forms_FormView;
  forms_viewSubmission?: Maybe<Forms_FormView>;
  generalGroups?: Maybe<Array<GeneralGroup>>;
  importCanonical_academicYears: ImportCanonical_AcademicYearPage;
  importCanonical_assessmentExtraFields: ImportCanonical_AssessmentExtraFieldPage;
  importCanonical_assessmentResultExtraFields: ImportCanonical_AssessmentResultExtraFieldPage;
  importCanonical_assessmentResults: ImportCanonical_AssessmentResultPage;
  importCanonical_assessmentTopLevelComments: ImportCanonical_AssessmentTopLevelCommentsPage;
  importCanonical_assessments: ImportCanonical_AssessmentPage;
  importCanonical_attendanceCodes: ImportCanonical_AttendanceCodePage;
  importCanonical_behaviour: ImportCanonical_BehaviourPage;
  importCanonical_blockClassGroupLinks: ImportCanonical_BlockClassGroupLinkPage;
  importCanonical_blockSubjectGroups: ImportCanonical_BlockSubjectGroupPage;
  importCanonical_calendar: ImportCanonical_CalendarPage;
  importCanonical_classGroupMembers: ImportCanonical_ClassGroupMembersPage;
  importCanonical_classGroupStaff: ImportCanonical_ClassGroupStaffPage;
  importCanonical_classGroups: ImportCanonical_ClassGroupsPage;
  importCanonical_commentBanks: ImportCanonical_CommentBankPage;
  importCanonical_globalUserExternalSystemRelations: ImportCanonical_GlobalUserExternalSystemRelPage;
  importCanonical_gradeSets: ImportCanonical_GradeSetPage;
  importCanonical_importErrorLogs: ImportCanonical_ImportErrorLogPage;
  importCanonical_imports: ImportCanonical_CanonicalImportMetaPage;
  importCanonical_medicalConditions: ImportCanonical_MedicalConditionPage;
  importCanonical_medicalContacts: ImportCanonical_MedicalContactPage;
  importCanonical_notes: ImportCanonical_NotesPage;
  importCanonical_permissionGroupMembershipExternalSystemRelations: ImportCanonical_PermissionGroupMembershipExternalSystemRelPage;
  importCanonical_rooms: ImportCanonical_RoomPage;
  importCanonical_rotationSubjectGroups: ImportCanonical_RotationSubjectGroupPage;
  importCanonical_sanityCheckIssueGroups: ImportCanonical_SanityCheckIssueGroupPage;
  importCanonical_sanityCheckResults: ImportCanonical_SanityCheckResultPage;
  importCanonical_sanityCheckSummary: ImportCanonical_SanityCheckSummaryPage;
  importCanonical_schoolInfo: ImportCanonical_SchoolInfoPage;
  importCanonical_staffAbsenceTypes: ImportCanonical_StaffAbsenceTypePage;
  importCanonical_studentAddresses: ImportCanonical_StudentAddressesPage;
  importCanonical_studentContactStudentLinks: ImportCanonical_StudentContactStudentLinkPage;
  importCanonical_studentContacts: ImportCanonical_StudentContactsPage;
  importCanonical_studentMedical: ImportCanonical_StudentMedicalPage;
  importCanonical_studentSiblings: ImportCanonical_StudentSiblingsPage;
  importCanonical_students: ImportCanonical_StudentPage;
  importCanonical_subjectGroupMemberships: ImportCanonical_SubjectGroupMembershipsPage;
  importCanonical_subjectGroups: ImportCanonical_SubjectGroupsPage;
  importCanonical_subjectGroupsTeachers: ImportCanonical_SubjectGroupsTeacherPage;
  importCanonical_teachers: ImportCanonical_TeacherPage;
  importCanonical_timetable: ImportCanonical_TimetablePage;
  importCanonical_timetablePeriods: ImportCanonical_TimetablePeriodPage;
  importCanonical_yearGroupInfo: ImportCanonical_YearGroupInfoPage;
  importVsware2_academicYears: ImportVsware2_AcademicYearPage;
  importVsware2_assessmentCommentBank: ImportVsware2_AssessmentCommentBankPage;
  importVsware2_assessmentCommentInfo: ImportVsware2_AssessmentCommentInfoPage;
  importVsware2_assessmentGradeSets: ImportVsware2_AssessmentGradeSetPage;
  importVsware2_assessmentResultExtraFieldInfo: ImportVsware2_AssessmentResultExtraFieldInfoPage;
  importVsware2_assessmentResultInfo: ImportVsware2_AssessmentResultInfoPage;
  importVsware2_assessmentResults: ImportVsware2_AssessmentResultPage;
  importVsware2_assessmentStudentCommentInfo: ImportVsware2_AssessmentStudentCommentInfoPage;
  importVsware2_attendanceCodes: ImportVsware2_AttendanceCodePage;
  importVsware2_bellTimes: ImportVsware2_BellTimePage;
  importVsware2_dutyRoster: ImportVsware2_DutyRosterPage;
  importVsware2_enumInfo: ImportVsware2_EnumInfoPage;
  importVsware2_examInfo: ImportVsware2_ExamInfoPage;
  importVsware2_examTeachingGroups: ImportVsware2_ExamTeachingGroupsPage;
  importVsware2_examYears: ImportVsware2_ExamYearsPage;
  importVsware2_feeGroupInfo: ImportVsware2_FeeGroupInfoPage;
  importVsware2_feeInfo: ImportVsware2_FeeInfoPage;
  importVsware2_feeListInfo: ImportVsware2_FeeListInfoPage;
  importVsware2_freeformMembership: ImportVsware2_FreeformMembershipPage;
  importVsware2_imports: ImportVsware2_ImportMetaPage;
  importVsware2_longTermLeaveSubstitutionInfo: ImportVsware2_LongTermLeaveSubstitutionInfoPage;
  importVsware2_nonClassContactHours: ImportVsware2_NonClassContactHoursPage;
  importVsware2_onCallRoster: ImportVsware2_OnCallRosterPage;
  importVsware2_relationshipInfo: ImportVsware2_RelationshipInfoPage;
  importVsware2_roomsInfo: ImportVsware2_RoomsInfoPage;
  importVsware2_schoolIdentifiers: Array<ImportVsware2_SchoolIdentifier>;
  importVsware2_schoolInfo: ImportVsware2_SchoolInfoPage;
  importVsware2_siblings: ImportVsware2_SiblingPage;
  importVsware2_smsNotifications: ImportVsware2_SmsNotificationPage;
  importVsware2_statutoryAttendance: ImportVsware2_StatutoryAttendancePage;
  importVsware2_studentBehaviour: ImportVsware2_StudentBehaviourPage;
  importVsware2_studentClasses: ImportVsware2_StudentClassesPage;
  importVsware2_studentContactInfo: ImportVsware2_StudentContactInfoPage;
  importVsware2_studentExclusions: ImportVsware2_StudentExclusionPage;
  importVsware2_studentMedicalInfo: ImportVsware2_StudentMedicalInfoPage;
  importVsware2_studentNotes: ImportVsware2_StudentNotePage;
  importVsware2_studentOptionsClassLists: ImportVsware2_StudentOptionsClassListPage;
  importVsware2_studentOptionsPreferences: ImportVsware2_StudentOptionsPreferencePage;
  importVsware2_studentOptionsSolutions: ImportVsware2_StudentOptionsSolutionPage;
  importVsware2_studentSenInfo: ImportVsware2_StudentSenInfoPage;
  importVsware2_students: ImportVsware2_StudentPage;
  importVsware2_subjects: ImportVsware2_SubjectPage;
  importVsware2_substitutionAbsenceInfo: ImportVsware2_SubstitutionAbsenceInfoPage;
  importVsware2_substitutionInfo: ImportVsware2_SubstitutionInfoPage;
  importVsware2_teacherFreeformGroupMemberships: ImportVsware2_TeacherFreeformGroupMembershipPage;
  importVsware2_teacherFreeformGroups: ImportVsware2_TeacherFreeformGroupPage;
  importVsware2_teachers: ImportVsware2_TeacherPage;
  importVsware2_teachingGroupAttendance: ImportVsware2_TeachingGroupAttendancePage;
  importVsware2_teachingGroupMemberships: ImportVsware2_TeachingGroupMembershipPage;
  importVsware2_teachingGroupsInfo: ImportVsware2_TeachingGroupInfoPage;
  importVsware2_timetable: ImportVsware2_TimetablePage;
  importVsware2_unexplainedAbsenceNotifications: ImportVsware2_UnexplainedAbsenceNotificationPage;
  importVsware2_vsmailMessages: ImportVsware2_VsmailMessagePage;
  importVsware_academicYears: ImportVsware_AcademicYearPage;
  importVsware_assessmentCommentBank: ImportVsware_AssessmentCommentBankPage;
  importVsware_assessmentCommentInfo: ImportVsware_AssessmentCommentInfoPage;
  importVsware_assessmentGradeSets: ImportVsware_AssessmentGradeSetPage;
  importVsware_assessmentResultExtraFieldInfo: ImportVsware_AssessmentResultExtraFieldInfoPage;
  importVsware_assessmentResultInfo: ImportVsware_AssessmentResultInfoPage;
  importVsware_assessmentResults: ImportVsware_AssessmentResultPage;
  importVsware_assessmentStudentCommentInfo: ImportVsware_AssessmentStudentCommentInfoPage;
  importVsware_attendanceCodes: ImportVsware_AttendanceCodePage;
  importVsware_bellTimes: ImportVsware_BellTimePage;
  importVsware_examInfo: ImportVsware_ExamInfoPage;
  importVsware_feeInfo: ImportVsware_FeeInfoPage;
  importVsware_freeformMembership: ImportVsware_FreeformMembershipPage;
  importVsware_imports: ImportVsware_ImportMetaPage;
  importVsware_individualStudentCustomField: ImportVsware_IndividualStudentCustomFieldPage;
  importVsware_nonClassContactHours: ImportVsware_NonClassContactHoursPage;
  importVsware_qualifications: ImportVsware_QualificationPage;
  importVsware_relationshipInfo: ImportVsware_RelationshipInfoPage;
  importVsware_roomBooking: ImportVsware_RoomBookingPage;
  importVsware_roomsInfo: ImportVsware_RoomsInfoPage;
  importVsware_schoolInfo: ImportVsware_SchoolInfoPage;
  importVsware_siblings: ImportVsware_SiblingPage;
  importVsware_statutoryAttendance: ImportVsware_StatutoryAttendancePage;
  importVsware_studentBehaviour: ImportVsware_StudentBehaviourPage;
  importVsware_studentClasses: ImportVsware_StudentClassesPage;
  importVsware_studentContactInfo: ImportVsware_StudentContactInfoPage;
  importVsware_studentCustomField: ImportVsware_StudentCustomFieldPage;
  importVsware_studentExclusions: ImportVsware_StudentExclusionPage;
  importVsware_studentMedicalInfo: ImportVsware_StudentMedicalInfoPage;
  importVsware_studentNotes: ImportVsware_StudentNotePage;
  importVsware_studentSenInfo: ImportVsware_StudentSenInfoPage;
  importVsware_students: ImportVsware_StudentPage;
  importVsware_substitutionAbsenceInfo: ImportVsware_SubstitutionAbsenceInfoPage;
  importVsware_substitutionInfo: ImportVsware_SubstitutionInfoPage;
  importVsware_teachers: ImportVsware_TeacherPage;
  importVsware_teachingGroupAttendance: ImportVsware_TeachingGroupAttendancePage;
  importVsware_teachingGroupMemberships: ImportVsware_TeachingGroupMembershipPage;
  importVsware_teachingGroupsInfo: ImportVsware_TeachingGroupInfoPage;
  importVsware_timetable: ImportVsware_TimetablePage;
  layout_getConfig?: Maybe<Layout_Config>;
  layout_getConfigs: Array<Layout_Config>;
  myAuthDetails?: Maybe<GlobalUser>;
  notes_behaviour?: Maybe<Notes_StudentBehaviourOverview>;
  notes_behaviourCategories: Array<Notes_BehaviourCategory>;
  notes_behaviourTagUsage?: Maybe<Notes_BehaviourTagUsage>;
  notes_notes: Array<Notes_Note>;
  notes_tags: Array<Notes_Tag>;
  notesv2_notes: Notesv2_ReadNotes;
  optionsSol_blocks: OptionsSol_SubjectSetBlocks;
  optionsSol_studentAssignment: Array<OptionsSol_StudentAssignments>;
  optionsSol_subjectStats: Array<OptionsSol_Subject>;
  options_availableEnrollmentGroups: Array<Options_AvailableGroups>;
  options_clm: Options_Clm;
  options_currentBest: Options_Solution;
  options_options: Array<Options_Option>;
  options_preferences: Array<Options_StudentPreference>;
  options_solutions: Options_Solution;
  options_solverInput: Options_SolverInput;
  pbac_areaMetaData: Array<Pbac_AreaMetaData>;
  pbac_permittedParties: Array<Pbac_SearchResult>;
  pbac_viewResolvedAuth: Pbac_ResolvedAuth;
  pbac_viewResourcePolicy: Array<Pbac_Resource>;
  pbac_viewResourcePolicyAndResolved: Array<Pbac_Resource>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  ppod_PPODCredentials?: Maybe<PpodCredentials>;
  ppod_enrolments: Array<PpodSyncEnrolment>;
  ppod_exemptions: Array<PpodSyncExemption>;
  ppod_shortCourses: Array<PpodSyncShortCourse>;
  ppod_students: Array<PpodSyncStudent>;
  ppod_subjects: Array<PpodSyncSubject>;
  ppod_syncRequests: Array<SyncRequest>;
  print_assessment: TemporaryDownload;
  print_assessmentTemplate: Scheduling_SubmitJobResult;
  print_clm: TemporaryDownload;
  print_fees: TemporaryDownload;
  print_fireDrill: TemporaryDownload;
  print_groupMembers: TemporaryDownload;
  print_letterTemplate: Scheduling_SubmitJobResult;
  print_optionsGroupMembers: TemporaryDownload;
  print_optionsMail: Success;
  print_personsGroupMemberships: TemporaryDownload;
  print_printTimetable: TemporaryDownload;
  print_subjectOptions: TemporaryDownload;
  print_substitution: TemporaryDownload;
  profileTypes?: Maybe<Array<Maybe<ProfileType>>>;
  profiles?: Maybe<Array<Maybe<ProfileType>>>;
  reporting_analyseReport: Reporting_AnalyseResult;
  reporting_reports: Array<Reporting_ReportInfoTopLevel>;
  reporting_runQuery: Reporting_QueryResult;
  reporting_runReport?: Maybe<Reporting_TableReport>;
  reporting_runReportExpand?: Maybe<Reporting_TableReport>;
  reporting_runReportPaginated?: Maybe<Reporting_PaginatedReportResult>;
  rules_actionTypesMetadata: Array<Rules_ActionMetaData>;
  rules_ruleTypesMetadata: Array<Rules_RuleMetaData>;
  rules_rules: Array<Rules_RuleView>;
  rules_viewTriggered: Array<Rules_TriggeredView>;
  rules_viewTriggeredActions: Array<Rules_TriggeredActionView>;
  sa_activities: Array<Maybe<Sa_SchoolActivity>>;
  sa_attendanceCodeSettings: Array<Maybe<Sa_AttendanceCode>>;
  sa_classAway: Array<Maybe<Sa_ClassAway>>;
  sa_lessonsNeedingCover: Array<Maybe<Sa_LessonNeedingCover>>;
  scheduling_cronJobs: Array<Scheduling_CronJobDefinition>;
  scheduling_jobExecution?: Maybe<Scheduling_JobExecution>;
  scheduling_jobHandlers: Array<Scheduling_JobHandlerDefinition>;
  scheduling_jobHistory: Array<Scheduling_JobExecution>;
  scheduling_jobLogEntries: Array<Scheduling_JobLogEntry>;
  scheduling_taskResults: Array<Scheduling_TaskResult>;
  sds_csv_download: Sds_CsvDownload;
  sds_settings: Sds_Settings;
  search_search: Array<Search>;
  stutime_timeline: Array<Wellbeing_StudentAen>;
  subjectGroups?: Maybe<Array<SubjectGroup>>;
  swm_absenceRequests: Array<Swm_StaffAbsenceRequest>;
  swm_absenceTypes: Array<Swm_StaffAbsenceType>;
  swm_absences: Array<Swm_StaffAbsence>;
  swm_countAbsenceRequests: Swm_StaffAbsenceRequestCounterResult;
  swm_dcsCodes: Array<Swm_DcsCode>;
  /** note will return all events that require substitution */
  swm_eventsForSubstitutions: Array<Swm_CalendarSubstitution>;
  /** note will only return timetabled lessons that occur on the grid */
  swm_eventsForSubstitutionsByStaffByPeriod: Swm_StaffSubstitutionEventByDay;
  swm_substitutionLookup: Swm_SubstitutionLookup;
  swm_substitutionTypes: Array<Swm_SubstitutionType>;
  swm_substitutions: Array<Swm_Substitution>;
  tasks_taskExecution?: Maybe<Tasks_TaskExecution>;
  tasks_tasks: Array<Tasks_TaskExecution>;
  templating_getDemoLabelTemplate: Templating_DemoLabelTemplate;
  templating_getLabelTemplates: Array<Templating_LabelTemplate>;
  templating_getSavedVariableTemplates: Array<Templating_SavedVariableTemplate>;
  templating_getTemplateDownloadUrl: Templating_ResolvedTemplate;
  templating_getTemplates: Array<Templating_Template>;
  templating_getVariables: Array<Templating_Variable>;
  templating_resolveDataTemplate: Templating_ResolvedTemplate;
  templating_resolveLabelTemplate: Templating_ResolvedTemplate;
  templating_resolveTemplate: Templating_ResolvedTemplate;
  timeline_studentHighlights: Array<Timeline_Highlight>;
  timeline_studentTimeline?: Maybe<Timeline_Timeline>;
  tt_addLessonOptions: Tt_AddLessonOptions;
  tt_blocks: Array<Tt_Block>;
  tt_classGroupRolloverView: Tt_ClassGroupRolloverView;
  tt_classGroups: Array<Tt_ClassGroup>;
  tt_coScheduleChains: Array<Tt_CoScheduleChain>;
  tt_diff?: Maybe<Tt_Diff>;
  tt_editLessonOptions: Array<Tt_EditLessonOptions>;
  tt_grids: Array<TtGrid>;
  tt_groupTagsUsed: Array<Search>;
  tt_groups: Array<Tt_Groups>;
  tt_individualLessons: Array<TtIndividualViewLesson>;
  tt_liveTimetableClassGroups: Array<Tt_ClassGroup>;
  tt_lookupCoreGroupsNotInTimetable: Array<PartyGroup>;
  tt_resourceTimetableView: TtResourceTimetableView;
  tt_rolloverAutoMatch: Tt_RolloverAutoMatch;
  tt_rolloverProgrammeStages: Array<Tt_RolloverProgrammeStage>;
  tt_roomAssignments: Tt_RoomAssignments;
  tt_search: Array<Search>;
  tt_subjectGroupRolloverView: Tt_SubjectGroupRolloverView;
  tt_swapRoomOptions: TtSwapRoomOptions;
  tt_swapTeacherOptions: TtSwapTeacherOptions;
  tt_swapTimeslotOptions: TtSwapTimeslotOptions;
  tt_teacherAssignments: Tt_TeacherAssignments;
  tt_timetable: TtTimetable;
  tt_timetables: Array<TtTimetable>;
  ttoptions_availableOptionsForImport: Array<TtOptions_AvailableOption>;
  ttsolve_cascadeGraph: TtSolve_CascadeGraph;
  ttsolve_classDataView: TtSolve_ClassData;
  ttsolve_competenciesMeta: TtSolve_CompetenciesMeta;
  ttsolve_configuration: TtSolve_Configuration;
  ttsolve_constraintCellLessons: TtSolve_ConstraintCellLessons;
  ttsolve_constraintEdges: TtSolve_ConstraintEdges;
  ttsolve_defaultSolverConfiguration: TtSolve_DefaultSolverConfiguration;
  ttsolve_explainSpreadConflict: TtSolve_SpreadConflictExplanation;
  ttsolve_getSolverInput: TtSolve_SolverInput;
  ttsolve_groupViolationSummary: TtSolve_GroupViolationSummary;
  ttsolve_hotspotLessons: TtSolve_HotspotLessons;
  ttsolve_resourceSlackReport: TtSolve_ResourceSlackReport;
  ttsolve_restrictions: TtSolve_Restrictions;
  ttsolve_restrictionsMeta: TtSolve_RestrictionsMeta;
  ttsolve_scheduleLessonOptions: TtSolve_ScheduleLessonOptions;
  ttsolve_scheduleView: TtSolve_ScheduleView;
  ttsolve_solveRuns: Array<TtSolve_SolveRunSummary>;
  /** No input: tenant + Tyro/school view are derived from the security context. */
  ttsolve_solverCatalog: TtSolve_SolverCatalog;
  ttsolve_solverReconcile: Array<TtSolve_SolverReconcileRow>;
  ttsolve_solverServerHealth: Array<TtSolve_SolverServerHealth>;
  ttsolve_solverServers: Array<TtSolve_SolverServer>;
  ttsolve_solverStateOverview: Array<TtSolve_SolverStateOverview>;
  ttsolve_solverSwappedTeachers: Array<TtSolve_SolverSwappedTeachers>;
  ttsolve_status: TtSolve_SolverStatus;
  ttsolve_subjectCompetencies: TtSolve_SubjectCompetencies;
  ttsolve_subjectCompetenciesCondensed: TtSolve_SubjectCompetenciesCondensed;
  ttsolve_teacherLoadBreakdown: TtSolve_TeacherLoadBreakdown;
  ttsolve_teacherViolationSummary: TtSolve_TeacherViolationSummary;
  ttsolve_topBrokenConstraints: TtSolve_TopBrokenConstraints;
  ttvalidation_validate: TtValidation_Validations;
  tyrone_conversationHistory?: Maybe<Tyrone_ConversationHistory>;
  tyrone_conversationUsage?: Maybe<Tyrone_ConversationUsage>;
  tyrone_generateReportLayout: Tyrone_GenerateReportLayoutResult;
  tyrone_myConversations: Array<Tyrone_Conversation>;
  tyrone_prompt: Tyrone_PromptResult;
  users_admin__defaultPermissions: Array<Users_DefaultPermission>;
  users_admin__party_people?: Maybe<Array<Users_AdminPerson>>;
  users_admin__permissionGroupsForTenant: Array<Users_Admin_PermissionGroupOption>;
  users_admin__user_lookup: Array<Users_AdminPersonalInfo>;
  users_loginAudit: Array<LoginAudit>;
  users_organizationTenant?: Maybe<Tenant>;
  users_permissionGroups?: Maybe<Array<Maybe<PermissionGroup>>>;
  users_permissionSets?: Maybe<Array<Maybe<PermissionSet>>>;
  users_schoolInfo?: Maybe<SchoolInfo>;
  users_subTenants: Array<Tenant>;
  users_thirdParties: Array<Users_ThirdParty>;
  users_userAccess: Array<UserAccess>;
  users_userPermissions: Array<Users_UserPermission>;
  wellbeing_activeMedical?: Maybe<Array<Maybe<Active>>>;
  wellbeing_activeSupportPlan?: Maybe<Array<Maybe<Active>>>;
  wellbeing_priorityStudent?: Maybe<Array<Maybe<PriorityStudent>>>;
  wellbeing_studentAen: Array<Wellbeing_StudentAen>;
  wellbeing_studentMedical?: Maybe<StudentMedical>;
  wellbeing_studentMedicalConditionLookup?: Maybe<ListString>;
  wellbeing_studentSupportFile?: Maybe<Array<Maybe<StudentSupportFile>>>;
  wellbeing_studentSupportPlan?: Maybe<Array<Maybe<StudentSupportPlan>>>;
  wellbeing_studentSupportPlanReview?: Maybe<Array<Maybe<StudentSupportPlanReview>>>;
};


export type QueryAdmin__Party_PeopleArgs = {
  tenant: Scalars['Int']['input'];
};


export type QueryAdmin__TenantsArgs = {
  filter?: InputMaybe<TenantsFilter>;
};


export type QueryAssessment_AssessmentArgs = {
  filter?: InputMaybe<AssessmentFilter>;
};


export type QueryAssessment_AssessmentCommentArgs = {
  filter?: InputMaybe<AssessmentCommentFilter>;
};


export type QueryAssessment_AssessmentResultArgs = {
  filter?: InputMaybe<AssessmentResultFilter>;
};


export type QueryAssessment_AssessmentSubjectGroupsArgs = {
  filter?: InputMaybe<AssessmentSubjectGroupsFilter>;
};


export type QueryAssessment_CalculateGradeArgs = {
  filter?: InputMaybe<CalculateGradeFilter>;
};


export type QueryAssessment_CommentBankArgs = {
  filter?: InputMaybe<CommentBankFilter>;
};


export type QueryAssessment_DashboardAssessmentArgs = {
  filter?: InputMaybe<DashboardAssessmentFilter>;
};


export type QueryAssessment_GradeSetArgs = {
  filter?: InputMaybe<GradeSetFilter>;
};


export type QueryAssessment_GradesArgs = {
  filter?: InputMaybe<GradeFilter>;
};


export type QueryAssessment_OverallCommentsArgs = {
  filter?: InputMaybe<OverallCommentsFilter>;
};


export type QueryAssessment_StudentResultArgs = {
  filter?: InputMaybe<StudentResultFilter>;
};


export type QueryAttendance_AttendanceCodesArgs = {
  filter?: InputMaybe<AttendanceCodeFilter>;
};


export type QueryAttendance_BulkAttendanceActionsArgs = {
  filter?: InputMaybe<Attendance_BulkAttendanceActionFilter>;
};


export type QueryAttendance_CalendarAttendanceArgs = {
  filter?: InputMaybe<CalendarAttendanceFilter>;
};


export type QueryAttendance_EventAttendanceArgs = {
  filter?: InputMaybe<EventAttendanceFilter>;
};


export type QueryAttendance_EventAttendanceReportArgs = {
  filter?: InputMaybe<EventAttendanceReportFilter>;
};


export type QueryAttendance_ParentalAttendanceRequestsArgs = {
  filter?: InputMaybe<ParentalAttendanceRequestFilter>;
};


export type QueryAttendance_ParentalRequestCountArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttendance_RollBookAttendanceArgs = {
  filter?: InputMaybe<Attendance_RollBookFilter>;
};


export type QueryAttendance_SessionAttendanceListArgs = {
  filter?: InputMaybe<SessionAttendanceListFilter>;
};


export type QueryAttendance_SignInOutReportArgs = {
  filter?: InputMaybe<Attendance_SignInOutReportFilter>;
};


export type QueryAttendance_StudentRollBookAttendanceArgs = {
  filter?: InputMaybe<Attendance_StudentRollBookFilter>;
};


export type QueryAttendance_StudentSessionAttendanceArgs = {
  filter?: InputMaybe<StudentSessionAttendanceFilter>;
};


export type QueryCalendar_BellTimesArgs = {
  filter?: InputMaybe<BellTimeFilter>;
};


export type QueryCalendar_CalendarArgs = {
  filter?: InputMaybe<CalendarFilter>;
};


export type QueryCalendar_CalendarDayBellTimesArgs = {
  filter?: InputMaybe<CalendarDayBellTimeFilter>;
};


export type QueryCalendar_CalendarEventsArgs = {
  filter?: InputMaybe<CalendarEventFilter>;
};


export type QueryCalendar_CalendarEventsForEditArgs = {
  filter?: InputMaybe<CalendarEventRawFilter>;
};


export type QueryCalendar_CalendarEventsIteratorArgs = {
  filter?: InputMaybe<CalendarEventIteratorFilter>;
};


export type QueryCalendar_CalendarEventsIterator_V2Args = {
  filter?: InputMaybe<CalendarEventIteratorFilter>;
};


export type QueryCalendar_CancellationRecommendationsArgs = {
  filter: Calendar_CancellationRecommendationFilter;
};


export type QueryCalendar_DayInfoArgs = {
  filter?: InputMaybe<CalendarDayInfoFilter>;
};


export type QueryCalendar_EventTagsArgs = {
  filter?: InputMaybe<Calendar_EventTagFilter>;
};


export type QueryCalendar_FindFreeResourcesArgs = {
  filter?: InputMaybe<FindFreeResourcesFilter>;
};


export type QueryCalendar_FindNextFreeSlotArgs = {
  filter?: InputMaybe<Calendar_NextFreeSlotFilter>;
};


export type QueryCalendar_GridsArgs = {
  filter?: InputMaybe<CalendarGridFilter>;
};


export type QueryCalendar_ViewFollowsArgs = {
  filter?: InputMaybe<Calender_FollowFilter>;
};


export type QueryCatalogue_GroupTagsArgs = {
  filter: Catalogue_GroupTagFilter;
};


export type QueryCatalogue_PeopleTagsArgs = {
  filter: Catalogue_PeopleTagFilter;
};


export type QueryCatalogue_ProgrammeStagesArgs = {
  filter?: InputMaybe<ProgrammeStageFilter>;
};


export type QueryCatalogue_ProgrammesArgs = {
  filter?: InputMaybe<ProgrammeFilter>;
};


export type QueryCatalogue_SubjectsArgs = {
  filter?: InputMaybe<SubjectFilter>;
};


export type QueryCatalogue_SystemSettingsValuesArgs = {
  filter: Catalogue_SystemSettingsFilter;
};


export type QueryCatalogue_SystemSettingsViewArgs = {
  filter: Catalogue_SystemSettingsFilter;
};


export type QueryCatalogue_YearsArgs = {
  filter?: InputMaybe<YearGroupFilter>;
};


export type QueryCommunications_FailedNotificationsArgs = {
  filter?: InputMaybe<FailedNotificationFilter>;
};


export type QueryCommunications_FailedSmsArgs = {
  filter?: InputMaybe<FailedSmsFilter>;
};


export type QueryCommunications_LabelArgs = {
  filter?: InputMaybe<LabelFilter>;
};


export type QueryCommunications_MailArgs = {
  filter?: InputMaybe<MailFilter>;
};


export type QueryCommunications_MailReadReceiptArgs = {
  filter?: InputMaybe<ReadReceiptFilter>;
};


export type QueryCommunications_MailSearchArgs = {
  filter?: InputMaybe<MailSearchFilter>;
};


export type QueryCommunications_MailThreadArgs = {
  filter?: InputMaybe<MailThreadFilter>;
};


export type QueryCommunications_NoticeboardArgs = {
  filter?: InputMaybe<NoticeboardFilter>;
};


export type QueryCommunications_NotificationSchoolSettingsArgs = {
  filter?: InputMaybe<SchoolNotificationSettingFilter>;
};


export type QueryCommunications_NotificationTemplatesArgs = {
  filter?: InputMaybe<NotificationTemplateFilter>;
};


export type QueryCommunications_NotificationsArgs = {
  filter?: InputMaybe<NotificationFilter>;
};


export type QueryCommunications_PartiesArgs = {
  filter?: InputMaybe<RecipientFilter>;
};


export type QueryCommunications_RecipientsArgs = {
  filter?: InputMaybe<RecipientFilter>;
};


export type QueryCommunications_RegisteredDevicesArgs = {
  filter?: InputMaybe<DeviceRegistrationFilter>;
};


export type QueryCommunications_ScheduledNotificationsArgs = {
  filter?: InputMaybe<ScheduledNotificationFilter>;
};


export type QueryCommunications_ScheduledSmsArgs = {
  filter?: InputMaybe<ScheduledSmsFilter>;
};


export type QueryCommunications_SmsArgs = {
  filter?: InputMaybe<SmsFilter>;
};


export type QueryCommunications_SmsCostArgs = {
  filter?: InputMaybe<SmsCostFilter>;
};


export type QueryCommunications_SocialIntegrationArgs = {
  filter?: InputMaybe<SocialMediaFilter>;
};


export type QueryCommunications_UnreadCountArgs = {
  filter?: InputMaybe<UnreadCountFilter>;
};


export type QueryComposite_ExtractStudentDataArgs = {
  input: DataExtraction_ExtractInput;
};


export type QueryComposite_PermissionGroupsArgs = {
  filter?: InputMaybe<PermissionGroupFilter>;
};


export type QueryComposite_PersonStatusArgs = {
  filter?: InputMaybe<PersonStatusFilter>;
};


export type QueryCore_AcademicNamespacesArgs = {
  filter?: InputMaybe<AcademicNamespaceFilter>;
};


export type QueryCore_BlocksArgs = {
  filter?: InputMaybe<BlockFilter>;
};


export type QueryCore_BuildingsArgs = {
  filter?: InputMaybe<BuildingFilter>;
};


export type QueryCore_CampusTravelTimesArgs = {
  filter?: InputMaybe<CampusTravelTimeFilter>;
};


export type QueryCore_CampusesArgs = {
  filter?: InputMaybe<CampusFilter>;
};


export type QueryCore_CustomFieldsArgs = {
  filter?: InputMaybe<Core_CustomFieldFilter>;
};


export type QueryCore_CustomGroupDefinitionArgs = {
  filter: Core_CustomGroupDefinitionFilter;
};


export type QueryCore_PartiesArgs = {
  filter?: InputMaybe<PartyFilter>;
};


export type QueryCore_PeopleArgs = {
  filter: Core_PeopleFilter;
};


export type QueryCore_ProgrammeStageEnrollmentsArgs = {
  filter?: InputMaybe<ProgrammeStageEnrollmentFilter>;
};


export type QueryCore_RoomPoolsArgs = {
  filter?: InputMaybe<RoomPoolFilter>;
};


export type QueryCore_RoomsArgs = {
  filter?: InputMaybe<RoomFilter>;
};


export type QueryCore_StaffArgs = {
  filter?: InputMaybe<StaffFilter>;
};


export type QueryCore_StaffAvailabilityArgs = {
  filter: Core_StaffAvailabilityFilter;
};


export type QueryCore_StudentContactsArgs = {
  filter?: InputMaybe<StudentContactFilter>;
};


export type QueryCore_StudentsArgs = {
  filter?: InputMaybe<StudentFilter>;
};


export type QueryCore_SubjectGroupStudentsArgs = {
  filter?: InputMaybe<SubjectGroupStudentFilter>;
};


export type QueryCore_YearGroupEnrollmentsArgs = {
  filter?: InputMaybe<YearGroupEnrollmentFilter>;
};


export type QueryDocumentation_Admin_ActiveChangeRequestForPageArgs = {
  pageId: Scalars['Int']['input'];
};


export type QueryDocumentation_Admin_ChangeRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDocumentation_Admin_ChangeRequestDiffArgs = {
  changeRequestId: Scalars['Int']['input'];
};


export type QueryDocumentation_Admin_ChangeRequestsArgs = {
  filter?: InputMaybe<Documentation_ChangeRequestFilter>;
};


export type QueryDocumentation_Admin_ConflictingChangeRequestsArgs = {
  changeRequestId: Scalars['Int']['input'];
};


export type QueryDocumentation_Admin_ExportPageArgs = {
  pageId: Scalars['Int']['input'];
};


export type QueryDocumentation_Admin_ExportSpaceArgs = {
  spaceSlug: Scalars['String']['input'];
};


export type QueryDocumentation_Admin_PageDetailArgs = {
  filter: Documentation_SinglePageFilter;
};


export type QueryDocumentation_Admin_PageVersionContentArgs = {
  versionId: Scalars['Int']['input'];
};


export type QueryDocumentation_Admin_PageVersionsArgs = {
  pageId: Scalars['Int']['input'];
};


export type QueryDocumentation_Admin_PagesArgs = {
  filter: Documentation_PageFilter;
};


export type QueryDocumentation_User_PageArgs = {
  filter: Documentation_SinglePageFilter;
};


export type QueryDocumentation_User_PageMetadataArgs = {
  pageIds: Array<Scalars['Int']['input']>;
};


export type QueryDocumentation_User_PagesArgs = {
  filter: Documentation_PageFilter;
};


export type QueryDocumentation_User_RelatedPagesArgs = {
  filter?: InputMaybe<Documentation_RelatedPagesFilter>;
};


export type QueryDocumentation_User_SearchArgs = {
  filter: Documentation_SearchFilter;
};


export type QueryDocumentation_User_SpaceArgs = {
  slug: Scalars['String']['input'];
};


export type QueryDrive_FolderAclArgs = {
  input: Folders_DriveFolderAclInput;
};


export type QueryDrive_FolderGrantsForCurrentUserArgs = {
  input: Folders_DriveFolderGrantsInput;
};


export type QueryDrive_ItemsArgs = {
  input: Folders_DriveItemsInput;
};


export type QueryDrive_PreviewAclSubjectRemovalArgs = {
  input: Folders_DriveAclRemovalPreviewInput;
};


export type QueryDrive_TreeArgs = {
  input: Folders_DriveTreeInput;
};


export type QueryEire_NonClassContactHoursArgs = {
  filter?: InputMaybe<NonClassContactHoursFilter>;
};


export type QueryEnrollment_Ire_BlockMembershipsArgs = {
  filter: EnrollmentIre_BlockEnrollmentFilter;
};


export type QueryEnrollment_Ire_CoreMembershipsArgs = {
  filter: EnrollmentIre_CoreEnrollmentFilter;
};


export type QueryExport_PtmArgs = {
  filter: Export_PtmoFilter;
};


export type QueryExport_Ptm2Args = {
  filter: Export_PtmoFilter;
};


export type QueryFees_AccountingCodesArgs = {
  filter?: InputMaybe<AccountingCodeFilter>;
};


export type QueryFees_CardPaymentPlansArgs = {
  filter?: InputMaybe<CardPaymentPlanFilter>;
};


export type QueryFees_CategoriesArgs = {
  filter?: InputMaybe<CategoryFilter>;
};


export type QueryFees_DiscountAssigneesArgs = {
  filter?: InputMaybe<DiscountAssigneeFilter>;
};


export type QueryFees_DiscountsArgs = {
  filter?: InputMaybe<DiscountFilter>;
};


export type QueryFees_FeesArgs = {
  filter?: InputMaybe<FeeFilter>;
};


export type QueryFees_PaymentPlanInstallmentsArgs = {
  filter?: InputMaybe<CalculatePaymentPlanFilter>;
};


export type QueryFees_PaymentsArgs = {
  filter?: InputMaybe<PaymentFilter>;
};


export type QueryFees_ServiceChargesArgs = {
  filter?: InputMaybe<ChargesFilter>;
};


export type QueryFees_StripeCustomerInfoArgs = {
  filter?: InputMaybe<OnBehalfOfInput>;
};


export type QueryFees_StudentFeesArgs = {
  filter?: InputMaybe<StudentFeeFilter>;
};


export type QueryFile_Transfer_ListArgs = {
  filter?: InputMaybe<FileTransferFilter>;
};


export type QueryFormsAdmin_BlankFormArgs = {
  filter?: InputMaybe<FormsAdmin_FormDefinitionViewFilter>;
};


export type QueryFormsAdmin_ExtensionPointsArgs = {
  filter?: InputMaybe<Dtab_ExtensionPointAdminFilter>;
};


export type QueryFormsAdmin_FormDefinitionsArgs = {
  filter?: InputMaybe<FormsAdmin_FormDefinitionsFilter>;
};


export type QueryFormsAdmin_InformationRequestArgs = {
  filter?: InputMaybe<FormsAdmin_InformationRequestFilter>;
};


export type QueryFormsAdmin_InformationRequestTableViewArgs = {
  filter: FormsAdmin_InformationRequestTableFilter;
};


export type QueryFormsAdmin_TagsArgs = {
  filter?: InputMaybe<FormsAdminTagsFilter>;
};


export type QueryForms_ChartsArgs = {
  input: Dtab_ChartTableFilter;
};


export type QueryForms_ListInformationRequestFormsArgs = {
  filter?: InputMaybe<Forms_InformationRequestListFormFilter>;
};


export type QueryForms_SearchFormsSubmissionsArgs = {
  filter: Forms_SearchSubmissionFilter;
};


export type QueryForms_TableArgs = {
  input: Dtab_TableFilter;
};


export type QueryForms_TableLookupArgs = {
  input: Dtab_TableDefinitionFilter;
};


export type QueryForms_ViewInformationRequestFormsArgs = {
  filter?: InputMaybe<Forms_InformationRequestViewFormFilter>;
};


export type QueryForms_ViewSubmissionArgs = {
  filter: Forms_ViewSubmissionFilter;
};


export type QueryGeneralGroupsArgs = {
  filter?: InputMaybe<GeneralGroupFilter>;
};


export type QueryImportCanonical_AcademicYearsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_AssessmentExtraFieldsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_AssessmentResultExtraFieldsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_AssessmentResultsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_AssessmentTopLevelCommentsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_AssessmentsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_AttendanceCodesArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_BehaviourArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_BlockClassGroupLinksArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_BlockSubjectGroupsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_CalendarArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_ClassGroupMembersArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_ClassGroupStaffArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_ClassGroupsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_CommentBanksArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_GlobalUserExternalSystemRelationsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_GradeSetsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_ImportErrorLogsArgs = {
  filter: ImportCanonical_ImportErrorLogFilter;
};


export type QueryImportCanonical_ImportsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_MedicalConditionsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_MedicalContactsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_NotesArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_PermissionGroupMembershipExternalSystemRelationsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_RoomsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_RotationSubjectGroupsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_SanityCheckResultsArgs = {
  filter: ImportCanonical_SanityCheckResultFilter;
};


export type QueryImportCanonical_SchoolInfoArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_StaffAbsenceTypesArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_StudentAddressesArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_StudentContactStudentLinksArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_StudentContactsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_StudentMedicalArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_StudentSiblingsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_StudentsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_SubjectGroupMembershipsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_SubjectGroupsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_SubjectGroupsTeachersArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_TeachersArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_TimetableArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_TimetablePeriodsArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportCanonical_YearGroupInfoArgs = {
  filter?: InputMaybe<ImportCanonical_Filter>;
};


export type QueryImportVsware2_AcademicYearsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_AssessmentCommentBankArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_AssessmentCommentInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_AssessmentGradeSetsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_AssessmentResultExtraFieldInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_AssessmentResultInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_AssessmentResultsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_AssessmentStudentCommentInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_AttendanceCodesArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_BellTimesArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_DutyRosterArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_EnumInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_ExamInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_ExamTeachingGroupsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_ExamYearsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_FeeGroupInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_FeeInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_FeeListInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_FreeformMembershipArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_ImportsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_LongTermLeaveSubstitutionInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_NonClassContactHoursArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_OnCallRosterArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_RelationshipInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_RoomsInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_SchoolIdentifiersArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_SchoolInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_SiblingsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_SmsNotificationsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_StatutoryAttendanceArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_StudentBehaviourArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_StudentClassesArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_StudentContactInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_StudentExclusionsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_StudentMedicalInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_StudentNotesArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_StudentOptionsClassListsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_StudentOptionsPreferencesArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_StudentOptionsSolutionsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_StudentSenInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_StudentsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_SubjectsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_SubstitutionAbsenceInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_SubstitutionInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_TeacherFreeformGroupMembershipsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_TeacherFreeformGroupsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_TeachersArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_TeachingGroupAttendanceArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_TeachingGroupMembershipsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_TeachingGroupsInfoArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_TimetableArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_UnexplainedAbsenceNotificationsArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware2_VsmailMessagesArgs = {
  filter?: InputMaybe<ImportVsware2_Filter>;
};


export type QueryImportVsware_AcademicYearsArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_AssessmentCommentBankArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_AssessmentCommentInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_AssessmentGradeSetsArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_AssessmentResultExtraFieldInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_AssessmentResultInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_AssessmentResultsArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_AssessmentStudentCommentInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_AttendanceCodesArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_BellTimesArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_ExamInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_FeeInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_FreeformMembershipArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_ImportsArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_IndividualStudentCustomFieldArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_NonClassContactHoursArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_QualificationsArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_RelationshipInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_RoomBookingArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_RoomsInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_SchoolInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_SiblingsArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_StatutoryAttendanceArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_StudentBehaviourArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_StudentClassesArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_StudentContactInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_StudentCustomFieldArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_StudentExclusionsArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_StudentMedicalInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_StudentNotesArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_StudentSenInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_StudentsArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_SubstitutionAbsenceInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_SubstitutionInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_TeachersArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_TeachingGroupAttendanceArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_TeachingGroupMembershipsArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_TeachingGroupsInfoArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryImportVsware_TimetableArgs = {
  filter?: InputMaybe<ImportVsware_Filter>;
};


export type QueryLayout_GetConfigArgs = {
  filter: Layout_ConfigFilter;
};


export type QueryLayout_GetConfigsArgs = {
  filter: Layout_ConfigsFilter;
};


export type QueryNotes_BehaviourArgs = {
  filter?: InputMaybe<Notes_BehaviourFilter>;
};


export type QueryNotes_BehaviourCategoriesArgs = {
  filter?: InputMaybe<Notes_BehaviourCategoryFilter>;
};


export type QueryNotes_BehaviourTagUsageArgs = {
  filter?: InputMaybe<Notes_BehaviourTagUsageFilter>;
};


export type QueryNotes_NotesArgs = {
  filter?: InputMaybe<Notes_NotesFilter>;
};


export type QueryNotes_TagsArgs = {
  filter?: InputMaybe<Notes_TagFilter>;
};


export type QueryNotesv2_NotesArgs = {
  filter: Notesv2_NoteFilter;
};


export type QueryOptionsSol_BlocksArgs = {
  filter?: InputMaybe<Options_OptionFilter>;
};


export type QueryOptionsSol_StudentAssignmentArgs = {
  filter?: InputMaybe<Options_OptionFilter>;
};


export type QueryOptionsSol_SubjectStatsArgs = {
  filter?: InputMaybe<Options_OptionFilter>;
};


export type QueryOptions_AvailableEnrollmentGroupsArgs = {
  filter?: InputMaybe<Options_AvailableGroupsFilter>;
};


export type QueryOptions_ClmArgs = {
  filter?: InputMaybe<Options_ClmFilter>;
};


export type QueryOptions_CurrentBestArgs = {
  filter?: InputMaybe<Options_OptionIdFilter>;
};


export type QueryOptions_OptionsArgs = {
  filter?: InputMaybe<Options_OptionFilter>;
};


export type QueryOptions_PreferencesArgs = {
  filter?: InputMaybe<Options_PreferencesFilter>;
};


export type QueryOptions_SolutionsArgs = {
  filter?: InputMaybe<Options_OptionIdFilter>;
};


export type QueryOptions_SolverInputArgs = {
  filter?: InputMaybe<Options_OptionIdFilter>;
};


export type QueryPbac_PermittedPartiesArgs = {
  filter: Pbac_SearchForParties;
};


export type QueryPbac_ViewResolvedAuthArgs = {
  filter: Pbac_ResolvedAuthFilter;
};


export type QueryPbac_ViewResourcePolicyArgs = {
  filter: Pbac_ResourcePolicyFilter;
};


export type QueryPbac_ViewResourcePolicyAndResolvedArgs = {
  filter: Pbac_ResourcePolicyFilter;
};


export type QueryPpod_SyncRequestsArgs = {
  filter?: InputMaybe<SyncRequestsFilter>;
};


export type QueryPrint_AssessmentArgs = {
  filter: Print_AssessmentOptions;
};


export type QueryPrint_AssessmentTemplateArgs = {
  filter: Templating_ResolveTemplateInput;
};


export type QueryPrint_ClmArgs = {
  filter: Print_Clm;
};


export type QueryPrint_FeesArgs = {
  filter: Print_FeeOptions;
};


export type QueryPrint_GroupMembersArgs = {
  filter: Print_GroupMembers;
};


export type QueryPrint_LetterTemplateArgs = {
  filter: Templating_ResolveTemplateInput;
};


export type QueryPrint_OptionsGroupMembersArgs = {
  filter: Print_StudentOptionsMembers;
};


export type QueryPrint_OptionsMailArgs = {
  filter: Print_OptionsMail;
};


export type QueryPrint_PersonsGroupMembershipsArgs = {
  filter: Print_PersonsGroupMemberships;
};


export type QueryPrint_PrintTimetableArgs = {
  filter?: InputMaybe<Print_TimetableOptions>;
};


export type QueryPrint_SubjectOptionsArgs = {
  filter: Print_SubjectOptions;
};


export type QueryPrint_SubstitutionArgs = {
  filter?: InputMaybe<Swm_EventsForSubstitutionFilter>;
};


export type QueryProfileTypesArgs = {
  filter?: InputMaybe<ProfileTypeFilter>;
};


export type QueryProfilesArgs = {
  filter?: InputMaybe<ProfileFilter>;
};


export type QueryReporting_AnalyseReportArgs = {
  input: Reporting_AnalyseInput;
};


export type QueryReporting_RunQueryArgs = {
  filter?: InputMaybe<Reporting_ReportFilter>;
};


export type QueryReporting_RunReportArgs = {
  filter?: InputMaybe<Reporting_ReportFilter>;
};


export type QueryReporting_RunReportExpandArgs = {
  filter?: InputMaybe<Reporting_ReportFilterExpand>;
};


export type QueryReporting_RunReportPaginatedArgs = {
  filter?: InputMaybe<Reporting_PaginatedReportFilter>;
};


export type QueryRules_RulesArgs = {
  filter: Rules_RulesViewFilter;
};


export type QueryRules_ViewTriggeredArgs = {
  input: Rules_TriggeredViewFilter;
};


export type QueryRules_ViewTriggeredActionsArgs = {
  filter: Rules_TriggeredActionFilter;
};


export type QuerySa_ActivitiesArgs = {
  filter: Sa_SchoolActivityFilter;
};


export type QuerySa_AttendanceCodeSettingsArgs = {
  filter: Sa_AttendanceCodeFilter;
};


export type QuerySa_ClassAwayArgs = {
  filter: Sa_ClassAwayFilter;
};


export type QuerySa_LessonsNeedingCoverArgs = {
  filter: Sa_LessonsNeedingCoverFilter;
};


export type QueryScheduling_JobExecutionArgs = {
  filter: Scheduling_JobExecutionFilter;
};


export type QueryScheduling_JobHistoryArgs = {
  filter?: InputMaybe<Scheduling_JobHistoryFilter>;
};


export type QueryScheduling_JobLogEntriesArgs = {
  filter: Scheduling_JobLogEntriesFilter;
};


export type QueryScheduling_TaskResultsArgs = {
  filter: Scheduling_TaskResultsFilter;
};


export type QuerySearch_SearchArgs = {
  filter?: InputMaybe<SearchFilter>;
};


export type QueryStutime_TimelineArgs = {
  filter: StudentAenFilter;
};


export type QuerySubjectGroupsArgs = {
  filter?: InputMaybe<SubjectGroupFilter>;
};


export type QuerySwm_AbsenceRequestsArgs = {
  filter?: InputMaybe<Swm_StaffAbsenceRequestFilter>;
};


export type QuerySwm_AbsenceTypesArgs = {
  filter?: InputMaybe<Swm_StaffAbsenceTypeFilter>;
};


export type QuerySwm_AbsencesArgs = {
  filter?: InputMaybe<Swm_StaffAbsenceFilter>;
};


export type QuerySwm_CountAbsenceRequestsArgs = {
  filter?: InputMaybe<Swm_StaffAbsenceRequestCounterFilter>;
};


export type QuerySwm_DcsCodesArgs = {
  filter?: InputMaybe<Swm_DcsCodeFilter>;
};


export type QuerySwm_EventsForSubstitutionsArgs = {
  filter?: InputMaybe<Swm_EventsForSubstitutionFilter>;
};


export type QuerySwm_EventsForSubstitutionsByStaffByPeriodArgs = {
  filter?: InputMaybe<Swm_EventsForSubstitutionFilter>;
};


export type QuerySwm_SubstitutionLookupArgs = {
  filter?: InputMaybe<Swm_SubstitutionLookupFilter>;
};


export type QuerySwm_SubstitutionTypesArgs = {
  filter?: InputMaybe<Swm_StaffSubstitutionTypeFilter>;
};


export type QuerySwm_SubstitutionsArgs = {
  filter?: InputMaybe<Swm_SubstitutionsFilter>;
};


export type QueryTasks_TaskExecutionArgs = {
  filter: Tasks_TaskExecutionFilter;
};


export type QueryTasks_TasksArgs = {
  filter?: InputMaybe<Tasks_MyTasksFilter>;
};


export type QueryTemplating_GetDemoLabelTemplateArgs = {
  filter?: InputMaybe<Templating_DemoLabelTemplateInput>;
};


export type QueryTemplating_GetLabelTemplatesArgs = {
  filter?: InputMaybe<Templating_LabelTemplateFilter>;
};


export type QueryTemplating_GetSavedVariableTemplatesArgs = {
  filter?: InputMaybe<Templating_SavedVariableTemplateFilter>;
};


export type QueryTemplating_GetTemplateDownloadUrlArgs = {
  templateId?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryTemplating_GetTemplatesArgs = {
  filter?: InputMaybe<Templating_TemplateFilter>;
};


export type QueryTemplating_GetVariablesArgs = {
  filter?: InputMaybe<Templating_VariablesFilter>;
};


export type QueryTemplating_ResolveDataTemplateArgs = {
  filter?: InputMaybe<Templating_ResolveDataTemplateInput>;
};


export type QueryTemplating_ResolveLabelTemplateArgs = {
  filter?: InputMaybe<Templating_ResolveLabelTemplateInput>;
};


export type QueryTemplating_ResolveTemplateArgs = {
  filter?: InputMaybe<Templating_ResolveTemplateInput>;
};


export type QueryTimeline_StudentHighlightsArgs = {
  filter: Timeline_HighlightFilter;
};


export type QueryTimeline_StudentTimelineArgs = {
  filter: Timeline_TimelineFilter;
};


export type QueryTt_AddLessonOptionsArgs = {
  filter?: InputMaybe<Tt_AddLessonFilter>;
};


export type QueryTt_BlocksArgs = {
  filter: Tt_BlockFilter;
};


export type QueryTt_ClassGroupRolloverViewArgs = {
  filter: Tt_ClassGroupRolloverViewFilter;
};


export type QueryTt_ClassGroupsArgs = {
  filter: Tt_ClassGroupsFilter;
};


export type QueryTt_CoScheduleChainsArgs = {
  filter: Tt_CoScheduleChainsFilter;
};


export type QueryTt_DiffArgs = {
  filter?: InputMaybe<Tt_DiffFilter>;
};


export type QueryTt_EditLessonOptionsArgs = {
  filter?: InputMaybe<Tt_EditLessonFilter>;
};


export type QueryTt_GridsArgs = {
  filter: TtGridFilter;
};


export type QueryTt_GroupTagsUsedArgs = {
  filter: Tt_SearchFilter;
};


export type QueryTt_GroupsArgs = {
  filter: Tt_GroupsFilter;
};


export type QueryTt_IndividualLessonsArgs = {
  filter?: InputMaybe<TtIndividualViewLessonFilter>;
};


export type QueryTt_LiveTimetableClassGroupsArgs = {
  filter: Tt_LiveTimetableClassGroupsFilter;
};


export type QueryTt_LookupCoreGroupsNotInTimetableArgs = {
  filter?: InputMaybe<TtTimetableFilter>;
};


export type QueryTt_ResourceTimetableViewArgs = {
  filter: TtResourceTimetableViewFilter;
};


export type QueryTt_RolloverAutoMatchArgs = {
  filter: Tt_RolloverAutoMatchFilter;
};


export type QueryTt_RolloverProgrammeStagesArgs = {
  filter: Tt_RolloverProgrammeStagesFilter;
};


export type QueryTt_RoomAssignmentsArgs = {
  filter: Tt_RoomAssignmentFilter;
};


export type QueryTt_SearchArgs = {
  filter: Tt_SearchFilter;
};


export type QueryTt_SubjectGroupRolloverViewArgs = {
  filter: Tt_SubjectGroupRolloverViewFilter;
};


export type QueryTt_SwapRoomOptionsArgs = {
  filter?: InputMaybe<TtSwapRoomFilter>;
};


export type QueryTt_SwapTeacherOptionsArgs = {
  filter?: InputMaybe<TtSwapTeacherFilter>;
};


export type QueryTt_SwapTimeslotOptionsArgs = {
  filter?: InputMaybe<TtSwapTimeslotFilter>;
};


export type QueryTt_TeacherAssignmentsArgs = {
  filter: Tt_TeacherAssignmentFilter;
};


export type QueryTt_TimetableArgs = {
  filter?: InputMaybe<TtTimetableFilter>;
};


export type QueryTt_TimetablesArgs = {
  filter?: InputMaybe<TtTimetableListFilter>;
};


export type QueryTtoptions_AvailableOptionsForImportArgs = {
  filter: TtTimetableFilter;
};


export type QueryTtsolve_CascadeGraphArgs = {
  filter: TtSolve_CascadeGraphFilter;
};


export type QueryTtsolve_ClassDataViewArgs = {
  filter: TtSolve_ClassDataFilter;
};


export type QueryTtsolve_ConfigurationArgs = {
  filter: TtSolve_SolveParams;
};


export type QueryTtsolve_ConstraintCellLessonsArgs = {
  filter: TtSolve_ConstraintCellLessonsFilter;
};


export type QueryTtsolve_ConstraintEdgesArgs = {
  filter: TtSolve_ConstraintEdgesFilter;
};


export type QueryTtsolve_ExplainSpreadConflictArgs = {
  filter: TtSolve_SpreadConflictFilter;
};


export type QueryTtsolve_GetSolverInputArgs = {
  filter: TtSolve_SolveParams;
};


export type QueryTtsolve_GroupViolationSummaryArgs = {
  filter: TtSolve_GroupViolationSummaryFilter;
};


export type QueryTtsolve_HotspotLessonsArgs = {
  filter: TtSolve_HotspotLessonsFilter;
};


export type QueryTtsolve_ResourceSlackReportArgs = {
  filter: TtSolve_SolveParams;
};


export type QueryTtsolve_RestrictionsArgs = {
  filter: TtSolve_RestrictionParams;
};


export type QueryTtsolve_RestrictionsMetaArgs = {
  filter: TtSolve_RestrictionParams;
};


export type QueryTtsolve_ScheduleLessonOptionsArgs = {
  filter: TtSolver_ScheduleLessonFilter;
};


export type QueryTtsolve_ScheduleViewArgs = {
  filter: TtSolver_ScheduleFilter;
};


export type QueryTtsolve_SolveRunsArgs = {
  filter: TtSolve_SolveRunsFilter;
};


export type QueryTtsolve_SolverServersArgs = {
  filter: TtSolve_SolverServersFilter;
};


export type QueryTtsolve_SolverSwappedTeachersArgs = {
  filter: TtTimetableFilter;
};


export type QueryTtsolve_StatusArgs = {
  filter?: InputMaybe<TtSolve_SolveParams>;
};


export type QueryTtsolve_SubjectCompetenciesArgs = {
  filter: TtSolve_SubjectCompetenciesFilter;
};


export type QueryTtsolve_SubjectCompetenciesCondensedArgs = {
  filter: TtSolve_SubjectCompetenciesFilter;
};


export type QueryTtsolve_TeacherLoadBreakdownArgs = {
  filter: TtSolve_TeacherLoadFilter;
};


export type QueryTtsolve_TeacherViolationSummaryArgs = {
  filter: TtSolve_TeacherViolationSummaryFilter;
};


export type QueryTtsolve_TopBrokenConstraintsArgs = {
  filter: TtSolve_TopBrokenConstraintsFilter;
};


export type QueryTtvalidation_ValidateArgs = {
  filter: TtValidation_Filter;
};


export type QueryTyrone_ConversationHistoryArgs = {
  conversationId: Scalars['String']['input'];
};


export type QueryTyrone_ConversationUsageArgs = {
  conversationId: Scalars['String']['input'];
};


export type QueryTyrone_GenerateReportLayoutArgs = {
  filter: Tyrone_GenerateReportLayoutInput;
};


export type QueryTyrone_PromptArgs = {
  filter?: InputMaybe<Tyrone_Prompt>;
};


export type QueryUsers_Admin__Party_PeopleArgs = {
  tenant: Scalars['Int']['input'];
};


export type QueryUsers_Admin__PermissionGroupsForTenantArgs = {
  tenant: Scalars['Int']['input'];
};


export type QueryUsers_Admin__User_LookupArgs = {
  filter?: InputMaybe<AdminLookupFilter>;
};


export type QueryUsers_LoginAuditArgs = {
  filter?: InputMaybe<LoginAuditFilter>;
};


export type QueryUsers_OrganizationTenantArgs = {
  filter?: InputMaybe<OrganizationTenantFilter>;
};


export type QueryUsers_PermissionGroupsArgs = {
  filter?: InputMaybe<PermissionGroupFilter>;
};


export type QueryUsers_PermissionSetsArgs = {
  filter?: InputMaybe<PermissionSetFilter>;
};


export type QueryUsers_SubTenantsArgs = {
  filter?: InputMaybe<SubTenantsFilter>;
};


export type QueryUsers_UserAccessArgs = {
  filter?: InputMaybe<UserAccessFilter>;
};


export type QueryUsers_UserPermissionsArgs = {
  partyPersonId: Scalars['Long']['input'];
};


export type QueryWellbeing_ActiveMedicalArgs = {
  filter?: InputMaybe<ActiveFilter>;
};


export type QueryWellbeing_ActiveSupportPlanArgs = {
  filter?: InputMaybe<ActiveFilter>;
};


export type QueryWellbeing_PriorityStudentArgs = {
  filter?: InputMaybe<PriorityStudentFilter>;
};


export type QueryWellbeing_StudentAenArgs = {
  filter: StudentAenFilter;
};


export type QueryWellbeing_StudentMedicalArgs = {
  filter?: InputMaybe<StudentMedicalFilter>;
};


export type QueryWellbeing_StudentSupportFileArgs = {
  filter?: InputMaybe<StudentSupportFileFilter>;
};


export type QueryWellbeing_StudentSupportPlanArgs = {
  filter?: InputMaybe<StudentSupportPlanFilter>;
};


export type QueryWellbeing_StudentSupportPlanReviewArgs = {
  filter?: InputMaybe<StudentSupportPlanReviewFilter>;
};

export type QueryBuilderField = {
  __typename?: 'QueryBuilderField';
  defaultValue?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  operators: Array<QueryBuilderOperator>;
  selectOptions: Array<QueryBuilderOptions>;
  valueEditorType: QueryBuilderValueTypeEditor;
};

export type QueryBuilderOperator = {
  __typename?: 'QueryBuilderOperator';
  allowsMultiple: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QueryBuilderOptions = {
  __typename?: 'QueryBuilderOptions';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum QueryBuilderValueTypeEditor {
  Autocomplete = 'autocomplete',
  Checkbox = 'checkbox',
  Date = 'date',
  Datetime = 'datetime',
  Multiselect = 'multiselect',
  Radio = 'radio',
  Select = 'select',
  SwitchToggle = 'switch_toggle',
  Text = 'text',
  Textarea = 'textarea',
  Time = 'time'
}

export type ReadReceiptFilter = {
  mailId: Scalars['Long']['input'];
  rulesEngineMail?: InputMaybe<Scalars['Boolean']['input']>;
  schoolMail: Scalars['Boolean']['input'];
};

export type ReadRecipient = {
  __typename?: 'ReadRecipient';
  id: Scalars['Long']['output'];
  readOn?: Maybe<Scalars['DateTime']['output']>;
  recipient: Person;
  recipientPartyId: Scalars['Long']['output'];
  recipientType: RecipientType;
  threadMessageId: Scalars['Long']['output'];
};

export type RecallMailInput = {
  rootMailId: Scalars['Long']['input'];
};

export enum ReceiptType {
  Statement = 'STATEMENT',
  Transaction = 'TRANSACTION'
}

export type Recipient = {
  __typename?: 'Recipient';
  id: Scalars['Long']['output'];
  recipient: Person;
  recipientPartyId: Scalars['Long']['output'];
  recipientType: RecipientType;
  resolvedRecipientId?: Maybe<Scalars['Long']['output']>;
  searchType: SearchType;
};

export type RecipientDevice = {
  __typename?: 'RecipientDevice';
  id?: Maybe<RecipientDeviceId>;
  status: NotificationStatus;
};

export type RecipientDeviceFilter = {
  recipientIds: Array<Scalars['Long']['input']>;
};

export type RecipientDeviceId = {
  __typename?: 'RecipientDeviceId';
  deviceId: Scalars['String']['output'];
  recipientId: Scalars['Long']['output'];
};

export type RecipientFilter = {
  partyIds: Array<Scalars['Long']['input']>;
  recipientType: Array<RecipientSearchType>;
};

export type RecipientInput = {
  recipientPartyId: Scalars['Long']['input'];
  recipientPartyType: SmsRecipientType;
};

export enum RecipientSearchType {
  ClassGroupTutors = 'CLASS_GROUP_TUTORS',
  ClassGroupYearHeads = 'CLASS_GROUP_YEAR_HEADS',
  Contact = 'CONTACT',
  ContactsOfStudent = 'CONTACTS_OF_STUDENT',
  GeneralGroupContact = 'GENERAL_GROUP_CONTACT',
  GeneralGroupStaff = 'GENERAL_GROUP_STAFF',
  GeneralGroupStudent = 'GENERAL_GROUP_STUDENT',
  Staff = 'STAFF',
  Student = 'STUDENT',
  StudentContacts = 'STUDENT_CONTACTS',
  StudentTeachers = 'STUDENT_TEACHERS',
  SubjectGroupContact = 'SUBJECT_GROUP_CONTACT',
  SubjectGroupStaff = 'SUBJECT_GROUP_STAFF',
  SubjectGroupStudent = 'SUBJECT_GROUP_STUDENT',
  SubjectGroupTutors = 'SUBJECT_GROUP_TUTORS',
  SubjectGroupYearHeads = 'SUBJECT_GROUP_YEAR_HEADS',
  YearGroupContact = 'YEAR_GROUP_CONTACT',
  YearGroupStaff = 'YEAR_GROUP_STAFF',
  YearGroupStudent = 'YEAR_GROUP_STUDENT'
}

export enum RecipientType {
  Bcc = 'BCC',
  Cc = 'CC',
  To = 'TO'
}

export enum RecurrenceEnum {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  NoRecurrence = 'NO_RECURRENCE',
  Weekly = 'WEEKLY'
}

export type RecurringPaymentInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  feeId: Scalars['Int']['input'];
  feesAbsorbed?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  serviceCharges?: InputMaybe<Scalars['Float']['input']>;
  studentPartyId: Scalars['Long']['input'];
};

export type Refund = {
  __typename?: 'Refund';
  amount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  refundDate: Scalars['DateTime']['output'];
  refundStatus: RefundStatus;
  refundType: RefundType;
};

export type RefundInput = {
  feeId: Scalars['Int']['input'];
  studentPartyId: Scalars['Long']['input'];
  transactions: Array<TransactionInput>;
};

export enum RefundStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  RequiresAction = 'REQUIRES_ACTION',
  Succeeded = 'SUCCEEDED'
}

export enum RefundType {
  Full = 'FULL',
  Partial = 'PARTIAL'
}

export type RegisterDeviceInput = {
  deviceId: Scalars['String']['input'];
  deviceMake: Scalars['String']['input'];
  deviceType: DeviceType;
  osVersion: Scalars['String']['input'];
};

export enum ReportLink {
  StudentAttendanceScreen = 'STUDENT_ATTENDANCE_SCREEN'
}

export type Reporting_AggregatableFieldInfo = {
  __typename?: 'Reporting_AggregatableFieldInfo';
  fieldId: Scalars['String']['output'];
  label: Scalars['String']['output'];
  supportedAggregations: Array<Reporting_AggregationType>;
};

export enum Reporting_AggregationType {
  Avg = 'avg',
  Count = 'count',
  CountDistinct = 'count_distinct',
  Max = 'max',
  Min = 'min',
  Percent = 'percent',
  Sum = 'sum'
}

export type Reporting_AnalyseInput = {
  chartType?: InputMaybe<Reporting_AnalyticsChartType>;
  customMetric?: InputMaybe<Reporting_CustomMetricInput>;
  filters?: InputMaybe<Array<InputMaybe<Reporting_TableFilterInput>>>;
  groupings?: InputMaybe<Array<Reporting_GroupingInput>>;
  metricId?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
};

export type Reporting_AnalyseResult = {
  __typename?: 'Reporting_AnalyseResult';
  chart?: Maybe<Reporting_AnalyticsChartResponse>;
  debug?: Maybe<Reporting_TableReportDebug>;
  reportMeta: Reporting_AnalyticsMeta;
  rows?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
};

export type Reporting_AnalyticsChartDataPoint = {
  __typename?: 'Reporting_AnalyticsChartDataPoint';
  label?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['Object']['output']>;
  x: Scalars['Object']['output'];
  y: Scalars['Float']['output'];
  z?: Maybe<Scalars['Float']['output']>;
};

export type Reporting_AnalyticsChartMetadata = {
  __typename?: 'Reporting_AnalyticsChartMetadata';
  currency?: Maybe<Scalars['String']['output']>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  stacked?: Maybe<Scalars['Boolean']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  xAxisLabel?: Maybe<Scalars['String']['output']>;
  yAxisLabel?: Maybe<Scalars['String']['output']>;
};

export type Reporting_AnalyticsChartResponse = {
  __typename?: 'Reporting_AnalyticsChartResponse';
  metadata?: Maybe<Reporting_AnalyticsChartMetadata>;
  series: Array<Reporting_AnalyticsChartSeries>;
  type: Reporting_AnalyticsChartType;
  validTypes: Array<Reporting_AnalyticsChartType>;
};

export type Reporting_AnalyticsChartSeries = {
  __typename?: 'Reporting_AnalyticsChartSeries';
  color?: Maybe<Scalars['String']['output']>;
  data: Array<Reporting_AnalyticsChartDataPoint>;
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export enum Reporting_AnalyticsChartType {
  Area = 'AREA',
  Bar = 'BAR',
  Donut = 'DONUT',
  Line = 'LINE',
  Scatter = 'SCATTER',
  StackedBar = 'STACKED_BAR',
  Treemap = 'TREEMAP'
}

export type Reporting_AnalyticsColorEntry = {
  __typename?: 'Reporting_AnalyticsColorEntry';
  color: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type Reporting_AnalyticsMeta = {
  __typename?: 'Reporting_AnalyticsMeta';
  aggregatableFields: Array<Reporting_AggregatableFieldInfo>;
  description?: Maybe<Scalars['String']['output']>;
  domains: Array<Scalars['String']['output']>;
  groupableFields: Array<Reporting_GroupableFieldInfo>;
  metrics: Array<Reporting_AnalyticsMetricInfo>;
};

export type Reporting_AnalyticsMetricInfo = {
  __typename?: 'Reporting_AnalyticsMetricInfo';
  colorMapping?: Maybe<Array<Reporting_AnalyticsColorEntry>>;
  compatibleGroupings?: Maybe<Array<Scalars['String']['output']>>;
  defaultChartType?: Maybe<Reporting_AnalyticsChartType>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idealFor?: Maybe<Array<Scalars['String']['output']>>;
  label: Scalars['String']['output'];
  requiresGrouping: Scalars['Boolean']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type Reporting_CellNumberFormat = {
  __typename?: 'Reporting_CellNumberFormat';
  maximumFractionDigits?: Maybe<Scalars['Int']['output']>;
  style?: Maybe<Reporting_CellNumberFormatStyle>;
};

export enum Reporting_CellNumberFormatStyle {
  Currency = 'currency',
  Decimal = 'decimal',
  Percent = 'percent',
  Unit = 'unit'
}

export type Reporting_Chart = {
  __typename?: 'Reporting_Chart';
  categories: Array<Scalars['String']['output']>;
  colours: Array<Scalars['String']['output']>;
  debug?: Maybe<Reporting_TableReportDebug>;
  series: Array<Reporting_ChartSeries>;
  type: Reporting_ChartType;
};

export type Reporting_ChartSeries = {
  __typename?: 'Reporting_ChartSeries';
  colour?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  series: Array<Scalars['Int']['output']>;
  sortOrder: Scalars['Int']['output'];
};

export enum Reporting_ChartType {
  Bar = 'bar',
  Donut = 'donut',
  Line = 'line',
  Treemap = 'treemap'
}

export type Reporting_Colour = {
  __typename?: 'Reporting_Colour';
  colour: Scalars['String']['output'];
  shade: Scalars['Int']['output'];
};

export type Reporting_CustomMetricInput = {
  aggregation: Reporting_AggregationType;
  fieldId: Scalars['String']['input'];
};

export type Reporting_DeleteReportActionRel = {
  reportId: Scalars['String']['input'];
  tenant: Scalars['Int']['input'];
};

export type Reporting_ExportReportInput = {
  filters?: InputMaybe<Array<InputMaybe<Reporting_TableFilterInput>>>;
  reportId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Reporting_ExportReportResult = {
  __typename?: 'Reporting_ExportReportResult';
  executionId: Scalars['String']['output'];
};

export type Reporting_GroupBy = {
  __typename?: 'Reporting_GroupBy';
  defaultValue: Scalars['String']['output'];
  values: Array<Reporting_GroupByValue>;
};

export type Reporting_GroupByValue = {
  __typename?: 'Reporting_GroupByValue';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Reporting_GroupableFieldInfo = {
  __typename?: 'Reporting_GroupableFieldInfo';
  availableBuckets?: Maybe<Array<Reporting_TimeBucket>>;
  fieldId: Scalars['String']['output'];
  isDateField: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export type Reporting_GroupingInput = {
  fieldId: Scalars['String']['input'];
  timeBucket?: InputMaybe<Reporting_TimeBucket>;
};

export enum Reporting_InteractiveCrosstab {
  Grouping = 'GROUPING',
  Metric = 'METRIC',
  None = 'NONE',
  TimeGrouping = 'TIME_GROUPING'
}

export enum Reporting_MetaChipSize {
  Medium = 'medium',
  Small = 'small'
}

export enum Reporting_MetaChipVariant {
  Filled = 'filled',
  Outlined = 'outlined',
  Soft = 'soft'
}

export type Reporting_PaginatedReportFilter = {
  filters?: InputMaybe<Array<InputMaybe<Reporting_TableFilterInput>>>;
  groupKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportId: Scalars['String']['input'];
  rowGroupCols?: InputMaybe<Array<InputMaybe<Reporting_RowGroupCol>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Reporting_Sort>>>;
};

export type Reporting_PaginatedReportResult = {
  __typename?: 'Reporting_PaginatedReportResult';
  data?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  debug?: Maybe<Reporting_TableReportDebug>;
};

export enum Reporting_Pinned {
  Left = 'left',
  Right = 'right'
}

export type Reporting_QueryResult = Reporting_Segment & {
  __typename?: 'Reporting_QueryResult';
  actions?: Maybe<Reporting_ReportActionRel>;
  charts: Array<Reporting_Chart>;
  debug?: Maybe<Reporting_TableReportDebug>;
  filters: Array<Reporting_TableFilter>;
  groupBy?: Maybe<Reporting_GroupBy>;
  id: Scalars['String']['output'];
  info: Reporting_ReportInfo;
  innerReports: Array<Reporting_ReportInfo>;
  metrics?: Maybe<Reporting_TableMetric>;
  table?: Maybe<Reporting_QueryResultTable>;
  timeGroupBy?: Maybe<Reporting_TimeGroupBy>;
};

export type Reporting_QueryResultTable = {
  __typename?: 'Reporting_QueryResultTable';
  data?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  fields: Array<Reporting_TableReportField>;
  links?: Maybe<Array<Maybe<Reporting_TableReportLink>>>;
  tableDisplayOptions: Reporting_TableDisplayOptions;
};

export enum Reporting_ReportAction {
  SendMail = 'SEND_MAIL',
  SendSms = 'SEND_SMS'
}

export enum Reporting_ReportActionField {
  Avatar = 'AVATAR'
}

export type Reporting_ReportActionFilter = {
  reportId: Scalars['String']['input'];
};

export type Reporting_ReportActionMapping = {
  __typename?: 'Reporting_ReportActionMapping';
  field: Reporting_ReportActionField;
  fieldId: Scalars['String']['output'];
};

export type Reporting_ReportActionRel = {
  __typename?: 'Reporting_ReportActionRel';
  actions?: Maybe<Array<Reporting_ReportAction>>;
  id: Scalars['Long']['output'];
  mappings?: Maybe<Array<Reporting_ReportActionMapping>>;
  reportId: Scalars['String']['output'];
  tenant: Scalars['Int']['output'];
};

export type Reporting_ReportCellMeta = {
  __typename?: 'Reporting_ReportCellMeta';
  avatarSize?: Maybe<Scalars['Int']['output']>;
  chipSize?: Maybe<Reporting_MetaChipSize>;
  chipVariant?: Maybe<Reporting_MetaChipVariant>;
  currency?: Maybe<Scalars['String']['output']>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  enableLink?: Maybe<Scalars['Boolean']['output']>;
  numberFormat?: Maybe<Reporting_CellNumberFormat>;
  showAvatar?: Maybe<Scalars['Boolean']['output']>;
};

export enum Reporting_ReportCellType {
  Boolean = 'BOOLEAN',
  Chip = 'CHIP',
  CountryCode = 'COUNTRY_CODE',
  Currency = 'CURRENCY',
  Date = 'DATE',
  HourMinutes = 'HOUR_MINUTES',
  Icon = 'ICON',
  Number = 'NUMBER',
  PartyGroup = 'PARTY_GROUP',
  Person = 'PERSON',
  PhoneNumber = 'PHONE_NUMBER',
  Raw = 'RAW'
}

export type Reporting_ReportFilter = {
  chartType?: InputMaybe<Reporting_ChartType>;
  crosstab?: InputMaybe<Reporting_InteractiveCrosstab>;
  filters?: InputMaybe<Array<InputMaybe<Reporting_TableFilterInput>>>;
  groupings?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  outputType?: InputMaybe<Reporting_ReportOutputType>;
  reportId: Scalars['String']['input'];
  /** list of fields ids to be returned in report. Returns default if null */
  showFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<Reporting_Sort>>>;
  timeGrouping?: InputMaybe<Scalars['String']['input']>;
};

export type Reporting_ReportFilterExpand = {
  filter: Reporting_ReportFilter;
  id: Scalars['Object']['input'];
};

export type Reporting_ReportInfo = {
  __typename?: 'Reporting_ReportInfo';
  analyticsEnabled?: Maybe<Scalars['Boolean']['output']>;
  defaultMetricId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isInteractive?: Maybe<Scalars['Boolean']['output']>;
  isServerSide?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** has aggregated rows which can be expanded to show individual rows */
  supportsExpandRow: Scalars['Boolean']['output'];
  /** flag to say whether its released */
  visibleToSchools: Scalars['Boolean']['output'];
};

export type Reporting_ReportInfoTopLevel = {
  __typename?: 'Reporting_ReportInfoTopLevel';
  info: Reporting_ReportInfo;
  reports: Array<Reporting_ReportInfo>;
};

export enum Reporting_ReportOutputType {
  Chart = 'CHART',
  Table = 'TABLE'
}

export type Reporting_RowGroupCol = {
  field: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type Reporting_Segment = {
  debug?: Maybe<Reporting_TableReportDebug>;
  id: Scalars['String']['output'];
};

export enum Reporting_SegmentType {
  Table = 'Table',
  ThreeDimensionChart = 'ThreeDimensionChart',
  TwoDimensionChart = 'TwoDimensionChart'
}

export type Reporting_Sort = {
  direction: Reporting_SortDirection;
  field: Scalars['String']['input'];
};

export enum Reporting_SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Reporting_StatusPanel = {
  __typename?: 'Reporting_StatusPanel';
  statusPanel: Scalars['String']['output'];
  statusPanelParams: Reporting_StatusPanelParams;
};

export type Reporting_StatusPanelColumn = {
  __typename?: 'Reporting_StatusPanelColumn';
  aggregationTypes: Array<Reporting_AggregationType>;
  id: Scalars['String']['output'];
  onSelectOnly: Scalars['Boolean']['output'];
};

export type Reporting_StatusPanelParams = {
  __typename?: 'Reporting_StatusPanelParams';
  columns: Array<Reporting_StatusPanelColumn>;
};

export type Reporting_TableDisplayOptions = {
  __typename?: 'Reporting_TableDisplayOptions';
  gridOptions?: Maybe<Scalars['Object']['output']>;
  tableContainerSx?: Maybe<Scalars['Object']['output']>;
};

export enum Reporting_TableFieldType {
  Datetime = 'DATETIME',
  Int = 'INT',
  String = 'STRING'
}

export type Reporting_TableFilter = {
  __typename?: 'Reporting_TableFilter';
  defaultValue?: Maybe<Scalars['Object']['output']>;
  id: Scalars['String']['output'];
  inputType: Reporting_TableFilterType;
  label: Scalars['String']['output'];
  maxValue?: Maybe<Scalars['Object']['output']>;
  minValue?: Maybe<Scalars['Object']['output']>;
  required: Scalars['Boolean']['output'];
  values?: Maybe<Array<Maybe<Reporting_TableFilterValues>>>;
};

export type Reporting_TableFilterInput = {
  filterId: Scalars['String']['input'];
  filterValue?: InputMaybe<Scalars['Object']['input']>;
};

export enum Reporting_TableFilterType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Input = 'INPUT',
  InputNumber = 'INPUT_NUMBER',
  MultiSelect = 'MULTI_SELECT',
  Select = 'SELECT'
}

export type Reporting_TableFilterValues = {
  __typename?: 'Reporting_TableFilterValues';
  colour?: Maybe<Reporting_Colour>;
  id?: Maybe<Scalars['Object']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Reporting_TableMetric = {
  __typename?: 'Reporting_TableMetric';
  defaultValue: Scalars['String']['output'];
  values: Array<Reporting_TableMetricValue>;
};

export type Reporting_TableMetricValue = {
  __typename?: 'Reporting_TableMetricValue';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Reporting_TableReport = Reporting_Segment & {
  __typename?: 'Reporting_TableReport';
  actions?: Maybe<Reporting_ReportActionRel>;
  data?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  debug?: Maybe<Reporting_TableReportDebug>;
  fields: Array<Reporting_TableReportField>;
  filters: Array<Reporting_TableFilter>;
  groupBy?: Maybe<Reporting_GroupBy>;
  id: Scalars['String']['output'];
  info: Reporting_ReportInfo;
  innerReports: Array<Reporting_ReportInfo>;
  links?: Maybe<Array<Maybe<Reporting_TableReportLink>>>;
  metrics?: Maybe<Reporting_TableMetric>;
  statusPanels?: Maybe<Array<Maybe<Reporting_StatusPanel>>>;
  tableDisplayOptions: Reporting_TableDisplayOptions;
  timeGroupBy?: Maybe<Reporting_TimeGroupBy>;
};

export type Reporting_TableReportDataColumn = {
  __typename?: 'Reporting_TableReportDataColumn';
  link?: Maybe<Reporting_TableReportDataColumnLink>;
  value?: Maybe<Scalars['Object']['output']>;
};

export type Reporting_TableReportDataColumnLink = {
  __typename?: 'Reporting_TableReportDataColumnLink';
  externalUrl?: Maybe<Scalars['String']['output']>;
  profileTab?: Maybe<Scalars['String']['output']>;
  queryParams?: Maybe<Scalars['Object']['output']>;
  report?: Maybe<Scalars['String']['output']>;
  reportTab?: Maybe<Scalars['String']['output']>;
};

export type Reporting_TableReportDebug = {
  __typename?: 'Reporting_TableReportDebug';
  sql?: Maybe<Scalars['String']['output']>;
};

export type Reporting_TableReportField = {
  __typename?: 'Reporting_TableReportField';
  cellType?: Maybe<Reporting_ReportCellType>;
  checkExpandedRows: Scalars['Boolean']['output'];
  hideMenu: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  maxWidth?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Reporting_ReportCellMeta>;
  minWidth?: Maybe<Scalars['Int']['output']>;
  pinned?: Maybe<Reporting_Pinned>;
  rowGroup?: Maybe<Scalars['Boolean']['output']>;
  searchable?: Maybe<Scalars['Boolean']['output']>;
  sortable: Scalars['Boolean']['output'];
  type: Reporting_TableFieldType;
  visibleByDefault: Scalars['Boolean']['output'];
};

export type Reporting_TableReportFieldAggregation = {
  __typename?: 'Reporting_TableReportFieldAggregation';
  labels: Array<Reporting_TableReportFieldAggregationLabel>;
  showTypes: Array<Reporting_AggregationType>;
  valuePrefix?: Maybe<Scalars['String']['output']>;
};

export type Reporting_TableReportFieldAggregationLabel = {
  __typename?: 'Reporting_TableReportFieldAggregationLabel';
  aggregation: Reporting_AggregationType;
  selected: Scalars['String']['output'];
  total: Scalars['String']['output'];
};

export type Reporting_TableReportLink = {
  __typename?: 'Reporting_TableReportLink';
  linkId?: Maybe<Scalars['Object']['output']>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  linkType?: Maybe<ReportLink>;
};

export type Reporting_ThreeDimensionChartOptions = {
  __typename?: 'Reporting_ThreeDimensionChartOptions';
  colors: Array<Scalars['String']['output']>;
};

export enum Reporting_TimeBucket {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Reporting_TimeGroupBy = {
  __typename?: 'Reporting_TimeGroupBy';
  defaultValue: Scalars['String']['output'];
  values: Array<Reporting_TimeGroupByValues>;
};

export type Reporting_TimeGroupByValues = {
  __typename?: 'Reporting_TimeGroupByValues';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Reporting_TwoDimensionChartOptions = {
  __typename?: 'Reporting_TwoDimensionChartOptions';
  colors: Array<Scalars['String']['output']>;
  labels: Array<Scalars['String']['output']>;
};

export type Reporting_UpsertReportActionMapping = {
  field: Reporting_ReportActionField;
  fieldId: Scalars['String']['input'];
};

export type Reporting_UpsertReportActionRel = {
  actions?: InputMaybe<Array<Reporting_ReportAction>>;
  mappings?: InputMaybe<Array<Reporting_UpsertReportActionMapping>>;
  reportId: Scalars['String']['input'];
  tenant: Scalars['Int']['input'];
};

export enum RequestStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  PartiallyComplete = 'PARTIALLY_COMPLETE'
}

export type ResolvedRecipient = {
  __typename?: 'ResolvedRecipient';
  id: Scalars['Long']['output'];
  person?: Maybe<Person>;
  recipientPartyId: Scalars['Long']['output'];
  recipientType: RecipientType;
  resolvedName: Scalars['String']['output'];
  searchType: SearchType;
};

export type ResourceCalendar = {
  events: Array<CalendarEvent>;
  gridsIds: Array<Scalars['Int']['output']>;
  resourceId: Scalars['Long']['output'];
  type: CalendarResourceTypeEnum;
};

export type ResourceCalendarWrapper = {
  __typename?: 'ResourceCalendarWrapper';
  otherEvents: Array<CalendarEvent>;
  resources: Array<ResourceCalendar>;
};

export type ResultExtraField = {
  __typename?: 'ResultExtraField';
  assessmentExtraFieldId: Scalars['Long']['output'];
  assessmentResultId: Scalars['Long']['output'];
  commentBankCommentId?: Maybe<Scalars['Long']['output']>;
  extraFieldType: ExtraFieldType;
  gradeNameTextId?: Maybe<Scalars['Int']['output']>;
  gradeSetGradeId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  result?: Maybe<Scalars['String']['output']>;
};

export type RetrySocialPostInput = {
  socialPostId: Scalars['Long']['input'];
};

export type RollOverNonClassContactHoursInput = {
  nonClassContactHoursIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  staffPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export enum RolloverEntityType {
  BellTime = 'BELL_TIME',
  ClassGroups = 'CLASS_GROUPS',
  CustomGroups = 'CUSTOM_GROUPS',
  Programmes = 'PROGRAMMES',
  Staff = 'STAFF',
  Students = 'STUDENTS',
  SubjectGroups = 'SUBJECT_GROUPS'
}

export type Room = {
  __typename?: 'Room';
  building?: Maybe<Building>;
  buildingId?: Maybe<Scalars['Int']['output']>;
  campus?: Maybe<Campus>;
  campusId?: Maybe<Scalars['Int']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  externalSystemId?: Maybe<Scalars['String']['output']>;
  includeInTimetable: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pools: Array<RoomPool>;
  roomId: Scalars['Int']['output'];
  roomPoolIds: Array<Scalars['Int']['output']>;
};

export type RoomCalendar = ResourceCalendar & {
  __typename?: 'RoomCalendar';
  events: Array<CalendarEvent>;
  gridsIds: Array<Scalars['Int']['output']>;
  resourceId: Scalars['Long']['output'];
  room?: Maybe<Room>;
  type: CalendarResourceTypeEnum;
};

export type RoomFilter = {
  buildingIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIncludeInTimetabling?: InputMaybe<Scalars['Boolean']['input']>;
  roomIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type RoomPool = {
  __typename?: 'RoomPool';
  colour: Colour;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isGeneral: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roomIds: Array<Scalars['Int']['output']>;
  rooms: Array<Room>;
};

export type RoomPoolFilter = {
  /** default false */
  excludeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Rot_AddRotation = {
  blockId: Scalars['String']['input'];
  newRotationStartDate: Scalars['Date']['input'];
};

export type Rot_DeleteRotation = {
  blockId: Scalars['String']['input'];
};

export type Rot_RemoveRotationDate = {
  blockId: Scalars['String']['input'];
};

export type Rule_TriggerConfigInput = {
  maxAllowed?: InputMaybe<Scalars['Int']['input']>;
  trigger: Scalars['Object']['input'];
  triggerIdx: Scalars['Int']['input'];
  triggerType: Rules_TriggerType;
};

export enum Rules_AboutType {
  Student = 'STUDENT'
}

export type Rules_Action = {
  type: Rules_ActionType;
};

export type Rules_ActionEmpty = Rules_Action & {
  __typename?: 'Rules_ActionEmpty';
  type: Rules_ActionType;
};

export type Rules_ActionInput = {
  /** should be one of Rules_Action */
  action: Scalars['Object']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  ruleActionId?: InputMaybe<Scalars['Int']['input']>;
  triggerIdx: Scalars['Int']['input'];
  type: Rules_ActionType;
};

export type Rules_ActionMail = Rules_Action & {
  __typename?: 'Rules_ActionMail';
  assignees?: Maybe<Rules_ActionToParty>;
  body: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  type: Rules_ActionType;
};

export type Rules_ActionMetaData = {
  __typename?: 'Rules_ActionMetaData';
  actionType: Rules_ActionType;
  canRevert: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  inputObject: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Rules_ActionSms = Rules_Action & {
  __typename?: 'Rules_ActionSms';
  assignees?: Maybe<Rules_ActionToParty>;
  message: Scalars['String']['output'];
  type: Rules_ActionType;
};

export type Rules_ActionToParty = {
  __typename?: 'Rules_ActionToParty';
  parties: Array<Party>;
  partyIds: Array<Scalars['Long']['output']>;
  toContacts: Scalars['Boolean']['output'];
  toStaffRoles: Array<Rules_ActionToPartyType>;
};

export enum Rules_ActionToPartyType {
  Teacher = 'TEACHER',
  Tutor = 'TUTOR',
  YearGroupLead = 'YEAR_GROUP_LEAD'
}

export enum Rules_ActionType {
  Log = 'LOG',
  SendForm = 'SEND_FORM',
  SendMail = 'SEND_MAIL',
  SendSms = 'SEND_SMS',
  StudentTimetableHighlight = 'STUDENT_TIMETABLE_HIGHLIGHT'
}

export type Rules_ActionView = {
  __typename?: 'Rules_ActionView';
  action: Rules_Action;
  errorRawData?: Maybe<Scalars['Object']['output']>;
  hasError: Scalars['Boolean']['output'];
  ruleActionId?: Maybe<Scalars['Int']['output']>;
  triggerIdx: Scalars['Int']['output'];
  type: Rules_ActionType;
};

export type Rules_Action_CreateHighlight = Rules_Action & {
  __typename?: 'Rules_Action_CreateHighlight';
  assignees?: Maybe<Rules_ActionToParty>;
  highlight?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Rules_ActionType;
};

export type Rules_Action_Log = Rules_Action & {
  __typename?: 'Rules_Action_Log';
  type: Rules_ActionType;
};

export type Rules_Action_SendFormRequest = Rules_Action & {
  __typename?: 'Rules_Action_SendFormRequest';
  formDefinitionId?: Maybe<FormsFd_DefinitionId>;
  formType: Rules_Action_SendFormRequest_Type;
  numberDaysTillDue: Scalars['Int']['output'];
  requestName: Scalars['String']['output'];
  teacherOfStaff?: Maybe<Rules_Action_SendFormRequestTeacherOfStaff>;
  type: Rules_ActionType;
};

export type Rules_Action_SendFormRequestTeacherOfStaff = {
  __typename?: 'Rules_Action_SendFormRequestTeacherOfStaff';
  roles?: Maybe<Array<Forms_InfoRequestStaffRole>>;
};

export enum Rules_Action_SendFormRequest_Type {
  ContactsOfStudents = 'CONTACTS_OF_STUDENTS',
  Students = 'STUDENTS',
  TeachersOfStudents = 'TEACHERS_OF_STUDENTS'
}

export enum Rules_AggregateResultOperators {
  Eq = 'EQ',
  Ge = 'GE',
  Gt = 'GT',
  Le = 'LE',
  Lt = 'LT',
  Ne = 'NE'
}

export enum Rules_AggregateType {
  Avg = 'AVG',
  Count = 'COUNT',
  Sum = 'SUM'
}

export type Rules_Criteria = {
  ruleType: Rules_RuleType;
};

export enum Rules_CriteriaType {
  Assessment = 'ASSESSMENT',
  Behaviour = 'BEHAVIOUR',
  IndividualBellTimeAttendance = 'INDIVIDUAL_BELL_TIME_ATTENDANCE',
  SessionAttendance = 'SESSION_ATTENDANCE'
}

export type Rules_Criteria_AggregateMatch2 = Rules_Criteria & {
  __typename?: 'Rules_Criteria_AggregateMatch2';
  criteriaType: Rules_CriteriaType;
  filterCondition?: Maybe<Scalars['String']['output']>;
  ruleType: Rules_RuleType;
  timeframe: Rules_TimeFrame;
};

export type Rules_Criteria_AggregateMatch2_Trigger = Rules_Trigger & {
  __typename?: 'Rules_Criteria_AggregateMatch2_Trigger';
  field?: Maybe<Scalars['String']['output']>;
  operator: Rules_AggregateResultOperators;
  triggerType: Rules_TriggerType;
  type: Rules_AggregateType;
  value: Scalars['Int']['output'];
};

export type Rules_CustomRuleInput = {
  actions?: InputMaybe<Array<Rules_ActionInput>>;
  criteria: Scalars['Object']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  excludePartyIds: Array<Scalars['Long']['input']>;
  maxTriggersAllowed?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  partyIds: Array<Scalars['Long']['input']>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
  ruleType: Rules_RuleType;
  schedule: Rules_ScheduleInput;
  triggers: Array<Rule_TriggerConfigInput>;
};

export type Rules_CustomRuleUpdateInput = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  ruleId?: InputMaybe<Scalars['Int']['input']>;
};

export type Rules_DeleteTriggeredLog = {
  ruleIds: Array<Scalars['Int']['input']>;
  ruleTriggeredIds: Array<Scalars['Int']['input']>;
  tryAndRollBackActions?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Rules_LogicalOperator {
  And = 'AND',
  Or = 'OR'
}

export type Rules_RevertTriggeredActions = {
  alsoDeleteTriggeredAction?: InputMaybe<Scalars['Boolean']['input']>;
  ruleTriggeredActionIds: Array<Scalars['Long']['input']>;
  ruleTriggeredIds: Array<Scalars['Int']['input']>;
};

export type Rules_RuleMetaData = {
  about: Rules_AboutType;
  criteriaType: Rules_CriteriaType;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ruleType: Rules_RuleType;
};

export type Rules_RuleMetaData_AggregateMatch = Rules_RuleMetaData & {
  __typename?: 'Rules_RuleMetaData_AggregateMatch';
  about: Rules_AboutType;
  /** count == 5 */
  aggregateFields: Array<Rules_RuleMetaData_AggregateMatch_AggregateMeta>;
  /** date = year to date */
  allowedTimeFrames: Array<Rules_TimeFrameType>;
  criteriaType: Rules_CriteriaType;
  description?: Maybe<Scalars['String']['output']>;
  /** filter for attendance code === 'PRESENT' */
  filterFields: Array<QueryBuilderField>;
  name: Scalars['String']['output'];
  ruleType: Rules_RuleType;
};

export type Rules_RuleMetaData_AggregateMatchInput = {
  filters?: InputMaybe<Scalars['String']['input']>;
};

export type Rules_RuleMetaData_AggregateMatch_AggregateMeta = {
  __typename?: 'Rules_RuleMetaData_AggregateMatch_AggregateMeta';
  aggType: Rules_AggregateType;
  possibleFields: Array<Rules_RuleMetaData_AggregateMatch_AggregateMetaField>;
};

export type Rules_RuleMetaData_AggregateMatch_AggregateMetaField = {
  __typename?: 'Rules_RuleMetaData_AggregateMatch_AggregateMetaField';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Rules_RuleTestResult = {
  __typename?: 'Rules_RuleTestResult';
  actionsToBeRan: Array<Rules_RuleTestResultActionsToBeRan>;
  triggered: Array<Rules_TriggeredView>;
};

export type Rules_RuleTestResultActionsToBeRan = {
  __typename?: 'Rules_RuleTestResultActionsToBeRan';
  count: Scalars['Int']['output'];
  type: Rules_ActionType;
};

export enum Rules_RuleType {
  AggregateMatch_2 = 'AGGREGATE_MATCH_2'
}

export type Rules_RuleView = {
  __typename?: 'Rules_RuleView';
  actionTakenCount: Scalars['Int']['output'];
  actions: Array<Rules_ActionView>;
  createdOn: Scalars['DateTime']['output'];
  criteria: Rules_Criteria;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  excludeParties: Array<Party>;
  excludePartyIds: Array<Scalars['Long']['output']>;
  lastRanAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunSuccess?: Maybe<Scalars['Boolean']['output']>;
  maxTriggersAllowed?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  parties: Array<Party>;
  partyIds: Array<Scalars['Long']['output']>;
  ruleId: Scalars['Int']['output'];
  ruleTriggeredCount: Scalars['Int']['output'];
  ruleType: Rules_RuleType;
  schedule: Rules_Schedule;
  triggers: Array<Rules_TriggerView>;
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type Rules_RulesViewFilter = {
  ruleIds: Array<Scalars['Int']['input']>;
};

export type Rules_RunRulesNow = {
  ruleId: Scalars['Int']['input'];
};

export type Rules_Schedule = {
  type: Rules_ScheduleType;
};

export type Rules_ScheduleInput = {
  /** should be one of Rules_Schedule */
  schedule: Scalars['Object']['input'];
  type: Rules_ScheduleType;
};

export enum Rules_ScheduleType {
  Auto = 'AUTO',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type Rules_ScheduleTypeAuto = Rules_Schedule & {
  __typename?: 'Rules_ScheduleTypeAuto';
  type: Rules_ScheduleType;
};

export type Rules_ScheduleTypeDaily = Rules_Schedule & {
  __typename?: 'Rules_ScheduleTypeDaily';
  time: Scalars['Time']['output'];
  type: Rules_ScheduleType;
};

export type Rules_ScheduleWeekly = Rules_Schedule & {
  __typename?: 'Rules_ScheduleWeekly';
  isoDayOfWeek: Scalars['Int']['output'];
  time: Scalars['Time']['output'];
  type: Rules_ScheduleType;
};

export type Rules_Success = {
  __typename?: 'Rules_Success';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Rules_TimeFrame = {
  type: Rules_TimeFrameType;
};

export enum Rules_TimeFrameType {
  BetweenDates = 'BETWEEN_DATES',
  CurrentWeek = 'CURRENT_WEEK',
  FromDate = 'FROM_DATE',
  RollingXWeeks = 'ROLLING_X_WEEKS',
  SevenDayCycle = 'SEVEN_DAY_CYCLE',
  Today = 'TODAY',
  YearToDate = 'YEAR_TO_DATE'
}

export type Rules_TimeFrame_BetweenDates = Rules_TimeFrame & {
  __typename?: 'Rules_TimeFrame_BetweenDates';
  from: Scalars['Date']['output'];
  to: Scalars['Date']['output'];
  type: Rules_TimeFrameType;
};

export type Rules_TimeFrame_CurrentWeek = Rules_TimeFrame & {
  __typename?: 'Rules_TimeFrame_CurrentWeek';
  type: Rules_TimeFrameType;
};

export type Rules_TimeFrame_FromDate = Rules_TimeFrame & {
  __typename?: 'Rules_TimeFrame_FromDate';
  from: Scalars['Date']['output'];
  type: Rules_TimeFrameType;
};

export type Rules_TimeFrame_PreviousOrSameDay = Rules_TimeFrame & {
  __typename?: 'Rules_TimeFrame_PreviousOrSameDay';
  isoDayOfWeek: Scalars['Int']['output'];
  type: Rules_TimeFrameType;
};

export type Rules_TimeFrame_Rolling = Rules_TimeFrame & {
  __typename?: 'Rules_TimeFrame_Rolling';
  type: Rules_TimeFrameType;
  weeks: Scalars['Int']['output'];
};

export type Rules_TimeFrame_Today = Rules_TimeFrame & {
  __typename?: 'Rules_TimeFrame_Today';
  type: Rules_TimeFrameType;
};

export type Rules_TimeFrame_YearToDate = Rules_TimeFrame & {
  __typename?: 'Rules_TimeFrame_YearToDate';
  type: Rules_TimeFrameType;
};

export type Rules_Trigger = {
  triggerType: Rules_TriggerType;
};

export enum Rules_TriggerType {
  AggregateMatch = 'AGGREGATE_MATCH'
}

export type Rules_TriggerView = {
  __typename?: 'Rules_TriggerView';
  maxAllowed?: Maybe<Scalars['Int']['output']>;
  trigger: Rules_Trigger;
  triggerIdx: Scalars['Int']['output'];
};

export type Rules_TriggeredActionFilter = {
  page?: InputMaybe<Page>;
  ruleIds: Array<Scalars['Int']['input']>;
  ruleTriggeredIds: Array<Scalars['Int']['input']>;
};

export enum Rules_TriggeredActionStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Reverted = 'REVERTED',
  Success = 'SUCCESS'
}

export type Rules_TriggeredActionView = {
  __typename?: 'Rules_TriggeredActionView';
  createdOn: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  meta: Rules_ActionMetaData;
  ruleTriggeredActionId: Scalars['Long']['output'];
  ruleTriggeredId: Scalars['Int']['output'];
  status: Rules_TriggeredActionStatus;
  successId?: Maybe<Scalars['String']['output']>;
  updateOn?: Maybe<Scalars['DateTime']['output']>;
};

export type Rules_TriggeredContext = {
  type: Rules_TriggeredContextType;
};

export enum Rules_TriggeredContextType {
  Student = 'STUDENT'
}

export type Rules_TriggeredContext_Student = Rules_TriggeredContext & {
  __typename?: 'Rules_TriggeredContext_Student';
  contextId: Scalars['String']['output'];
  criteriaType: Rules_CriteriaType;
  datetime: Scalars['DateTime']['output'];
  timelineType?: Maybe<Scalars['String']['output']>;
  type: Rules_TriggeredContextType;
};

export type Rules_TriggeredView = {
  __typename?: 'Rules_TriggeredView';
  actionsTaken: Array<Rules_TriggeredActionView>;
  context: Array<Rules_TriggeredContext>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Int']['output'];
  party?: Maybe<Party>;
  ruleId: Scalars['Int']['output'];
  ruleTriggerIdx: Scalars['Int']['output'];
  ruleType: Rules_RuleType;
  triggeredOn?: Maybe<Scalars['DateTime']['output']>;
};

export type Rules_TriggeredViewFilter = {
  page?: InputMaybe<Page>;
  ruleIds: Array<Scalars['Int']['input']>;
};

export enum Sa_Status {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type Sds_CsvDownload = {
  __typename?: 'SDS_CsvDownload';
  url: Scalars['String']['output'];
};

export type Sds_Settings = {
  __typename?: 'SDS_Settings';
  includeAcademicYear: Scalars['Boolean']['output'];
  includeClassGroups: Scalars['Boolean']['output'];
  includeNextYearsFirstYears: Scalars['Boolean']['output'];
  includeYearGroups: Scalars['Boolean']['output'];
  prefix: Scalars['String']['output'];
};

export type Sds_UpdateSettingsInput = {
  includeAcademicYear: Scalars['Boolean']['input'];
  includeClassGroups: Scalars['Boolean']['input'];
  includeNextYearsFirstYears: Scalars['Boolean']['input'];
  includeYearGroups: Scalars['Boolean']['input'];
  prefix: Scalars['String']['input'];
};

export enum Swm_AlsoApplyToEventContext {
  CombinedPeriod = 'COMBINED_PERIOD',
  Double = 'DOUBLE'
}

export type Swm_CalendarSubstitution = {
  __typename?: 'SWM_CalendarSubstitution';
  absenceId?: Maybe<Scalars['Int']['output']>;
  coverTeacherDuplicatedAtSameTime?: Maybe<Array<Swm_CalendarSubstitution>>;
  event: CalendarEvent;
  ignored?: Maybe<Scalars['Boolean']['output']>;
  ignoredNote?: Maybe<Scalars['String']['output']>;
  key: Swm_CalendarSubstitutionKey;
  linkedEvents: Array<Swm_LinkedEvents>;
  requireSubstitutionReason?: Maybe<Swm_RequireSubstitutionDetails>;
  staffPartyId: Scalars['Long']['output'];
  substitution?: Maybe<Swm_Substitution>;
};

export type Swm_CalendarSubstitutionKey = {
  __typename?: 'SWM_CalendarSubstitutionKey';
  absentStaffId: Scalars['Long']['output'];
  date: Scalars['Date']['output'];
  eventId: Scalars['Int']['output'];
};

export type Swm_CalendarSubstitutionPeriod = {
  __typename?: 'SWM_CalendarSubstitutionPeriod';
  eventSubstitutions: Array<Swm_CalendarSubstitution>;
};

export type Swm_ChangeStaffAbsenceRequestStatus = {
  rejectionText?: InputMaybe<Scalars['String']['input']>;
  staffAbsenceRequestIds: Array<Scalars['Long']['input']>;
  status: Swm_StaffAbsenceRequestStatusEnum;
};

export type Swm_DcsCode = {
  __typename?: 'SWM_DcsCode';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type Swm_DcsCodeFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Swm_DeleteStaffAbsence = {
  /** filter only these staffIds */
  onlyForStaffIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  staffAbsenceIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type Swm_DeleteSubstitution = {
  deleteByEventDateAndStaff?: InputMaybe<Array<Swm_DeleteSubstitutionByEventDateAndStaff>>;
  substitutionIds: Array<Scalars['Int']['input']>;
};

export type Swm_DeleteSubstitutionByEventDateAndStaff = {
  date: Scalars['Date']['input'];
  eventId: Scalars['Int']['input'];
  originalStaffId: Scalars['Long']['input'];
};

export enum Swm_EventForSubstitutionIncludeTypes {
  All = 'ALL',
  HasCover = 'HAS_COVER',
  Ignored = 'IGNORED',
  NeedsCover = 'NEEDS_COVER'
}

export type Swm_EventsForSubstitutionFilter = {
  /** excludes events based on whether a school day or not. Default value false */
  disableDayTypeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** default [NEEDS_COVER, HAS_COVER] */
  eventsForSubstitutionMode?: InputMaybe<Array<Swm_EventForSubstitutionIncludeTypes>>;
  fromDate: Scalars['Date']['input'];
  staffPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  toDate: Scalars['Date']['input'];
};

export type Swm_EventsForSubstitutionStaff = {
  __typename?: 'SWM_EventsForSubstitutionStaff';
  staff: Staff;
  substitutionEventsByDay: Array<Swm_EventsForSubstitutionStaffByDay>;
};

export type Swm_EventsForSubstitutionStaffByDay = {
  __typename?: 'SWM_EventsForSubstitutionStaffByDay';
  date?: Maybe<Scalars['Date']['output']>;
  dayInfo: CalendarDayInfo;
  requireSubstitutionReason?: Maybe<Swm_RequireSubstitutionDetails>;
  staffPartyId: Scalars['Long']['output'];
  substitutionEventsByPeriod: Array<Swm_CalendarSubstitutionPeriod>;
};

export type Swm_InsertSubstitution = {
  events: Array<Swm_UpsertSubstitutionEvent>;
  ignoreEvents: Array<Swm_UpsertSubstitutionIgnoreEvent>;
};

export type Swm_LinkedEvents = {
  __typename?: 'SWM_LinkedEvents';
  context: Swm_AlsoApplyToEventContext;
  event: CalendarEvent;
};

export type Swm_RequireSubstitutionDetails = {
  __typename?: 'SWM_RequireSubstitutionDetails';
  note?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type Swm_SendNotificationEvent = {
  eventIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  substituteStaffId: Scalars['Long']['input'];
};

export type Swm_SendNotifications = {
  date: Scalars['Date']['input'];
  events?: InputMaybe<Array<Swm_SendNotificationEvent>>;
};

export type Swm_StaffAbsence = {
  __typename?: 'SWM_StaffAbsence';
  absenceId: Scalars['Int']['output'];
  absenceReasonText?: Maybe<Scalars['String']['output']>;
  absenceType: Swm_StaffAbsenceType;
  absenceTypeId: Scalars['Int']['output'];
  dates: Array<Swm_StaffAbsenceDate>;
  fromAbsenceRequestId?: Maybe<Scalars['Int']['output']>;
  isLongTermLeave: Scalars['Boolean']['output'];
  longTermLeaveGroups: Array<Swm_StaffAbsenceLongTermLeaveGroup>;
  longTermLeaveGroupsApplied?: Maybe<Scalars['Int']['output']>;
  longTermLeaveGroupsRequired?: Maybe<Scalars['Int']['output']>;
  staff?: Maybe<Person>;
  staffPartyId: Scalars['Long']['output'];
  substitutionRequired?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * either  continuousStartDate AND continuousEndDate are set
 * OR individualDates is set
 */
export type Swm_StaffAbsenceDate = {
  __typename?: 'SWM_StaffAbsenceDate';
  continuousEndDate?: Maybe<Scalars['Date']['output']>;
  continuousStartDate?: Maybe<Scalars['Date']['output']>;
  individualDates?: Maybe<Array<Scalars['Date']['output']>>;
  leavesAt?: Maybe<Scalars['Time']['output']>;
  /** if is a partial absence wither leavesAt or  returnsAt must be set */
  partialAbsence: Scalars['Boolean']['output'];
  returnsAt?: Maybe<Scalars['Time']['output']>;
};

export type Swm_StaffAbsenceFilter = {
  fromAbsenceRequestIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isLongTermLeave?: InputMaybe<Scalars['Boolean']['input']>;
  staffAbsenceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  staffPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Swm_StaffAbsenceLongTermLeaveGroup = {
  __typename?: 'SWM_StaffAbsenceLongTermLeaveGroup';
  coveringStaff?: Maybe<Staff>;
  coveringStaffId?: Maybe<Scalars['Long']['output']>;
  group: PartyGroup;
  groupId: Scalars['Long']['output'];
};

export type Swm_StaffAbsenceRequest = {
  __typename?: 'SWM_StaffAbsenceRequest';
  absenceNoteText?: Maybe<Scalars['String']['output']>;
  absenceType?: Maybe<Swm_StaffAbsenceType>;
  absenceTypeId: Scalars['Int']['output'];
  absentStaffPartyId: Scalars['Long']['output'];
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  completedBy?: Maybe<Staff>;
  completedByPartyId?: Maybe<Scalars['Long']['output']>;
  createdAbsence?: Maybe<Swm_StaffAbsence>;
  createdAbsenceId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dates: Array<Swm_StaffAbsenceDate>;
  rejectionReasonText?: Maybe<Scalars['String']['output']>;
  staff?: Maybe<Staff>;
  staffAbsenceRequestId: Scalars['Long']['output'];
  status?: Maybe<Swm_StaffAbsenceRequestStatusEnum>;
};

export type Swm_StaffAbsenceRequestCounterFilter = {
  status: Swm_StaffAbsenceRequestStatusEnum;
};

export type Swm_StaffAbsenceRequestCounterResult = {
  __typename?: 'SWM_StaffAbsenceRequestCounterResult';
  count: Scalars['Int']['output'];
  status: Swm_StaffAbsenceRequestStatusEnum;
};

export type Swm_StaffAbsenceRequestFilter = {
  staffPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  staffRequestIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  status?: InputMaybe<Array<Swm_StaffAbsenceRequestStatusEnum>>;
};

export enum Swm_StaffAbsenceRequestStatusEnum {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type Swm_StaffAbsenceType = {
  __typename?: 'SWM_StaffAbsenceType';
  absenceTypeId: Scalars['Int']['output'];
  availableForRequests: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  dcsCode?: Maybe<Scalars['String']['output']>;
  dcsCodeId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nameTextId?: Maybe<Scalars['Int']['output']>;
};

export type Swm_StaffAbsenceTypeFilter = {
  absenceTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  availableForRequests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Swm_StaffSubstitutionEventByDay = {
  __typename?: 'SWM_StaffSubstitutionEventByDay';
  eventsByStaff: Array<Swm_EventsForSubstitutionStaff>;
};

export type Swm_StaffSubstitutionTypeFilter = {
  substitutionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Swm_Substitution = {
  __typename?: 'SWM_Substitution';
  absenceId?: Maybe<Scalars['Int']['output']>;
  /** deep linked */
  event?: Maybe<CalendarEvent>;
  eventDate: Scalars['Date']['output'];
  eventId: Scalars['Int']['output'];
  ignored?: Maybe<Scalars['Boolean']['output']>;
  ignoredNote?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  originalStaff: Person;
  originalStaffPartyId: Scalars['Long']['output'];
  substituteRoom?: Maybe<Room>;
  substituteRoomId?: Maybe<Scalars['Int']['output']>;
  substituteStaff: Person;
  substituteStaffId: Scalars['Long']['output'];
  substitutionId?: Maybe<Scalars['Int']['output']>;
  substitutionType: Swm_SubstitutionType;
  substitutionTypeId: Scalars['Int']['output'];
};

export type Swm_SubstitutionLookup = {
  __typename?: 'SWM_SubstitutionLookup';
  clashingRooms: Array<ClashingRooms>;
  freeRooms: Array<Room>;
  staff: Array<Swm_SubstitutionLookupStaff>;
};

/** either times or substitutionEvents must be set */
export type Swm_SubstitutionLookupFilter = {
  staffPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  substitutionEventIds?: InputMaybe<Array<CalendarEventIdInput>>;
  times?: InputMaybe<Array<FindFreeResourcesTime>>;
};

export type Swm_SubstitutionLookupRoom = {
  __typename?: 'SWM_SubstitutionLookupRoom';
  available: Scalars['Boolean']['output'];
  clashingEvents?: Maybe<Array<Scalars['String']['output']>>;
  room: Room;
  roomId: Scalars['Int']['output'];
};

export type Swm_SubstitutionLookupStaff = {
  __typename?: 'SWM_SubstitutionLookupStaff';
  available: Scalars['Boolean']['output'];
  clashingEvents?: Maybe<Array<Scalars['String']['output']>>;
  staff: Staff;
  staffPartyId: Scalars['Long']['output'];
  substitutionStats: Swm_SubstitutionSummaryForWeek;
};

export type Swm_SubstitutionSummary = {
  __typename?: 'SWM_SubstitutionSummary';
  substitutionCountThisWeek: Scalars['Int']['output'];
  substitutionCountThisYear: Scalars['Int']['output'];
  substitutionTimeThisWeekMinutes: Scalars['Int']['output'];
  substitutionTimeThisYearMinutes: Scalars['Int']['output'];
};

export type Swm_SubstitutionSummaryFilter = {
  date: Scalars['Date']['input'];
  staffPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Swm_SubstitutionSummaryForWeek = {
  __typename?: 'SWM_SubstitutionSummaryForWeek';
  casualWeekCount: Scalars['Int']['output'];
  casualWeekMinutes: Scalars['Int']['output'];
  emer35WeekCount: Scalars['Int']['output'];
  emer35WeekMinutes: Scalars['Int']['output'];
  emer35YearCount: Scalars['Int']['output'];
  emer35YearMinutes: Scalars['Int']['output'];
  sandsWeekCount: Scalars['Int']['output'];
  sandsWeekMinutes: Scalars['Int']['output'];
  sandsYearCount: Scalars['Int']['output'];
  sandsYearMinutes: Scalars['Int']['output'];
  totalWeekCount: Scalars['Int']['output'];
  totalWeekMinutes: Scalars['Int']['output'];
  totalYearCount: Scalars['Int']['output'];
  totalYearMinutes: Scalars['Int']['output'];
  windfallWeekCount: Scalars['Int']['output'];
  windfallWeekMinutes: Scalars['Int']['output'];
  windfallYearCount: Scalars['Int']['output'];
  windfallYearMinutes: Scalars['Int']['output'];
};

export type Swm_SubstitutionTime = {
  __typename?: 'SWM_SubstitutionTime';
  endTime: Scalars['Time']['output'];
  isoDayOfWeek: Scalars['Int']['output'];
  startTime: Scalars['Time']['output'];
};

export type Swm_SubstitutionType = {
  __typename?: 'SWM_SubstitutionType';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
  substitutionTypeId: Scalars['Int']['output'];
};

export type Swm_SubstitutionsFilter = {
  byAbsenceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  fromDate: Scalars['Date']['input'];
  staffPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  toDate: Scalars['Date']['input'];
};

export type Swm_UpsertStaffAbsence = {
  absenceReasonText?: InputMaybe<Scalars['String']['input']>;
  absenceTypeId: Scalars['Int']['input'];
  dates: Array<Swm_UpsertStaffAbsenceDate>;
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
  fromAbsenceRequestId?: InputMaybe<Scalars['Int']['input']>;
  /** default false */
  isLongTermLeave?: InputMaybe<Scalars['Boolean']['input']>;
  /** can only be set if isLongTermLeave is true */
  longTermLeaveGroups?: InputMaybe<Array<Swm_UpsertStaffAbsenceLongTermLeaveGroupInput>>;
  staffAbsenceId?: InputMaybe<Scalars['Int']['input']>;
  staffPartyIds: Array<Scalars['Long']['input']>;
  substitutionRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * either  continuousStartDate AND continuousEndDate are set
 * OR individualDates is set
 */
export type Swm_UpsertStaffAbsenceDate = {
  continuousEndDate?: InputMaybe<Scalars['Date']['input']>;
  continuousStartDate?: InputMaybe<Scalars['Date']['input']>;
  individualDates?: InputMaybe<Array<Scalars['Date']['input']>>;
  leavesAt?: InputMaybe<Scalars['Time']['input']>;
  /** if is a partial absence wither leavesAt or  returnsAt must be set */
  partialAbsence: Scalars['Boolean']['input'];
  returnsAt?: InputMaybe<Scalars['Time']['input']>;
};

export type Swm_UpsertStaffAbsenceLongTermLeaveGroupInput = {
  coveringStaffId?: InputMaybe<Scalars['Long']['input']>;
  groupId: Scalars['Long']['input'];
};

export type Swm_UpsertStaffAbsenceRequest = {
  absenceNoteText?: InputMaybe<Scalars['String']['input']>;
  absenceTypeId: Scalars['Int']['input'];
  absentStaffPartyId: Scalars['Long']['input'];
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  dates: Array<Swm_UpsertStaffAbsenceDate>;
  rejectionReasonText?: InputMaybe<Scalars['String']['input']>;
  staffAbsenceRequestId?: InputMaybe<Scalars['Long']['input']>;
};

export type Swm_UpsertStaffAbsenceResponse = {
  __typename?: 'SWM_UpsertStaffAbsenceResponse';
  wasApplied: Scalars['Boolean']['output'];
};

export type Swm_UpsertStaffAbsenceType = {
  absenceTypeId?: InputMaybe<Scalars['Int']['input']>;
  availableForRequests: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  dcsCodeId?: InputMaybe<Scalars['Int']['input']>;
  description: Array<InputMaybe<TranslationInput>>;
  name: Array<InputMaybe<TranslationInput>>;
};

export type Swm_UpsertStaffAbsences = {
  absences: Array<Swm_UpsertStaffAbsence>;
  existingAbsenceChecksAction?: InputMaybe<Swm_UpsertStaffAbsencesProceedWithExistingValidationChecks>;
  /** bypasses checks to see if absent staff has events to notifiy user about such as substitution */
  ignorePreValidationExistingEventChecks: Scalars['Boolean']['input'];
};

export type Swm_UpsertStaffAbsencesProceedWithExistingValidationChecks = {
  /** delete all substitutions for the period of staff absence */
  deleteSubstitutions: Scalars['Boolean']['input'];
  /** proceed with creating staff absence */
  proceed: Scalars['Boolean']['input'];
};

export type Swm_UpsertStaffAbsencesResponse = {
  __typename?: 'SWM_UpsertStaffAbsencesResponse';
  absenceIds: Array<Scalars['Int']['output']>;
  substitutionsPresent: Array<CalendarEvent>;
  wasApplied: Scalars['Boolean']['output'];
  wrongYear?: Maybe<Scalars['Boolean']['output']>;
};

export type Swm_UpsertStaffSubstitutionType = {
  code: Scalars['String']['input'];
  description: Array<InputMaybe<TranslationInput>>;
  name: Array<InputMaybe<TranslationInput>>;
  substitutionTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type Swm_UpsertSubstitutionEvent = {
  absenceId?: InputMaybe<Scalars['Int']['input']>;
  alsoApplySubstitutionsForEvent?: InputMaybe<Array<Scalars['Int']['input']>>;
  date: Scalars['Date']['input'];
  eventId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  originalStaffId: Scalars['Long']['input'];
  substituteRoomId?: InputMaybe<Scalars['Int']['input']>;
  substituteStaffId: Scalars['Long']['input'];
  /** if set then substitution will be deleted and recreated ad */
  substitutionId?: InputMaybe<Scalars['Int']['input']>;
  substitutionTypeId: Scalars['Int']['input'];
};

export type Swm_UpsertSubstitutionIgnoreEvent = {
  date: Scalars['Date']['input'];
  eventId: Scalars['Int']['input'];
  ignoreNote?: InputMaybe<Scalars['String']['input']>;
  originalStaffId: Scalars['Long']['input'];
};

export enum Sa_AddRemove {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type Sa_AddRemoveStaff = {
  schoolActivityId: Scalars['Int']['input'];
  staff: Array<Sa_AddRemoveStaffMember>;
};

export type Sa_AddRemoveStaffMember = {
  action: Sa_AddRemove;
  attending: Scalars['Boolean']['input'];
  organiser: Scalars['Boolean']['input'];
  staff: Scalars['Long']['input'];
};

export type Sa_AddRemoveStudent = {
  action: Sa_AddRemove;
  studentId: Scalars['Long']['input'];
};

export type Sa_AddRemoveStudents = {
  schoolActivityId: Scalars['Int']['input'];
  students: Array<Sa_AddRemoveStudent>;
};

export type Sa_ApproveInput = {
  approvalNote?: InputMaybe<Scalars['String']['input']>;
  publicContactCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  publicStaffCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  publicStudentCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  /** default: DO_NOTHING */
  publishOptions?: InputMaybe<Sa_ApproveInputPublishOptions>;
  schoolActivityId: Array<InputMaybe<Scalars['Int']['input']>>;
  staffAbsenceTypeId?: InputMaybe<Scalars['Int']['input']>;
  status: Sa_Status;
};

export enum Sa_ApproveInputPublishOptions {
  DoNothing = 'DO_NOTHING',
  /** upon approval publish, upun rejection unpiblish */
  PublishUnpublish = 'PUBLISH_UNPUBLISH'
}

export type Sa_AttendanceCode = {
  __typename?: 'Sa_AttendanceCode';
  attendanceCode: AttendanceCode;
  attendanceCodeId: Scalars['Int']['output'];
  attendanceCodeType: AttendanceCodeType;
};

export type Sa_AttendanceCodeFilter = {
  attendanceCodeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum Sa_CancelationStatus {
  All = 'ALL',
  Canceled = 'CANCELED',
  NotCanceled = 'NOT_CANCELED'
}

export type Sa_ClassAway = {
  __typename?: 'Sa_ClassAway';
  affectedAttendees: Array<Maybe<Party>>;
  cancelled: Scalars['Boolean']['output'];
  event: CalendarEvent;
  freeStaff: Array<Maybe<Person>>;
  freeStaffPartyIds: Array<Maybe<Scalars['Long']['output']>>;
  staffAreFreed: Scalars['Boolean']['output'];
  studentsAttendingActivityTotal: Scalars['Int']['output'];
  studentsInGroupTotal: Scalars['Int']['output'];
};

export type Sa_ClassAwayFilter = {
  cancelationStatus?: InputMaybe<Sa_CancelationStatus>;
  schoolActivityId: Scalars['Int']['input'];
};

export type Sa_LessonNeedingCover = {
  __typename?: 'Sa_LessonNeedingCover';
  affectedAttendees: Array<Maybe<Party>>;
  awayStaff: Array<Maybe<Person>>;
  awayStaffPartyIds: Array<Maybe<Scalars['Long']['output']>>;
  event: CalendarEvent;
  studentsAttendingActivityTotal: Scalars['Int']['output'];
  studentsInGroupTotal: Scalars['Int']['output'];
};

export type Sa_LessonsNeedingCoverFilter = {
  schoolActivityId: Scalars['Int']['input'];
};

export type Sa_PublishInput = {
  schoolActivityId: Scalars['Int']['input'];
  setAsPublished: Scalars['Boolean']['input'];
};

export type Sa_RefreshInput = {
  refreshAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  refreshCancelledLessons?: InputMaybe<Scalars['Boolean']['input']>;
  refreshPublicCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  schoolActivityId: Scalars['Int']['input'];
};

export type Sa_SaveAttendanceCodeInput = {
  attendanceCodeId: Scalars['Int']['input'];
  attendanceCodeType: AttendanceCodeType;
};

export type Sa_SchoolActivity = {
  __typename?: 'Sa_SchoolActivity';
  approval: Sa_SchoolActivityApproval;
  createdBy: AuditPerson;
  createdByPartyId: Scalars['Long']['output'];
  createdByUserId: Scalars['Int']['output'];
  createdOn: Scalars['DateTime']['output'];
  customGroup?: Maybe<GeneralGroup>;
  customGroupId?: Maybe<Scalars['Long']['output']>;
  dates: Array<Sa_SchoolActivityDate>;
  eventIds: Array<Scalars['Int']['output']>;
  lastPublished?: Maybe<Scalars['DateTime']['output']>;
  location: Sa_SchoolActivityLocation;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  publicContactCalendar: Scalars['Boolean']['output'];
  publicStaffCalendar: Scalars['Boolean']['output'];
  publicStudentCalendar: Scalars['Boolean']['output'];
  published: Scalars['Boolean']['output'];
  schoolActivityId: Scalars['Int']['output'];
  staffAbsenceIds: Array<Scalars['Int']['output']>;
  staffAbsenceTypeId?: Maybe<Scalars['Int']['output']>;
  tripPurpose?: Maybe<Scalars['String']['output']>;
};

export type Sa_SchoolActivityApproval = {
  __typename?: 'Sa_SchoolActivityApproval';
  approvalDate?: Maybe<Scalars['DateTime']['output']>;
  approvalNote?: Maybe<Scalars['String']['output']>;
  approvedByParty?: Maybe<Person>;
  approvedByPartyId?: Maybe<Scalars['Long']['output']>;
  status: Sa_Status;
};

export type Sa_SchoolActivityDate = {
  __typename?: 'Sa_SchoolActivityDate';
  date: Scalars['Date']['output'];
  endTime?: Maybe<Scalars['Time']['output']>;
  partial: Scalars['Boolean']['output'];
  startTime?: Maybe<Scalars['Time']['output']>;
};

export type Sa_SchoolActivityDateInput = {
  dates: Array<Scalars['Date']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  partial: Scalars['Boolean']['input'];
  startTime?: InputMaybe<Scalars['Time']['input']>;
};

export type Sa_SchoolActivityDelete = {
  schoolActivityId: Scalars['Int']['input'];
};

export type Sa_SchoolActivityFilter = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  schoolActivityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Sa_SchoolActivityInput = {
  dates: Array<Sa_SchoolActivityDateInput>;
  group: Sa_SchoolActivityInputGroup;
  location: Sa_SchoolActivityLocationInput;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  schoolActivityId?: InputMaybe<Scalars['Int']['input']>;
  staffAbsenceType?: InputMaybe<Scalars['Int']['input']>;
  tripPurpose?: InputMaybe<Scalars['String']['input']>;
};

export type Sa_SchoolActivityInputCreateGroup = {
  organiserIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  staffIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  studentIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Sa_SchoolActivityInputGroup = {
  createCustomGroup?: InputMaybe<Sa_SchoolActivityInputCreateGroup>;
  customGroupId?: InputMaybe<Scalars['Long']['input']>;
};

export type Sa_SchoolActivityLocation = {
  __typename?: 'Sa_SchoolActivityLocation';
  inSchoolGrounds: Scalars['Boolean']['output'];
  locationDetails?: Maybe<Scalars['String']['output']>;
  roomIds: Array<Scalars['Int']['output']>;
  rooms: Array<Room>;
};

export type Sa_SchoolActivityLocationInput = {
  inSchoolGrounds: Scalars['Boolean']['input'];
  locationDetails?: InputMaybe<Scalars['String']['input']>;
  roomIds: Array<Scalars['Int']['input']>;
};

export type Sa_SchoolActivityRequestInput = {
  groupPartyId?: InputMaybe<Scalars['Long']['input']>;
  location: Sa_SchoolActivityLocationInput;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  tripPurpose?: InputMaybe<Scalars['String']['input']>;
};

export type SaveAcademicNamespaceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  type?: InputMaybe<AcademicNamespaceType>;
  year: Scalars['Int']['input'];
};

export type SaveAccountCodeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveAssessmentCommentInput = {
  assessmentId: Scalars['Long']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  commentBankCommentId?: InputMaybe<Scalars['Long']['input']>;
  commenterPartyId?: InputMaybe<Scalars['Long']['input']>;
  commenterUserType: CommenterUserType;
  id?: InputMaybe<Scalars['Long']['input']>;
  studentPartyId: Scalars['Long']['input'];
  subjectGroupPartyId?: InputMaybe<Scalars['Long']['input']>;
};

export type SaveAssessmentResultInput = {
  absent?: InputMaybe<Scalars['Boolean']['input']>;
  assessmentId: Scalars['Long']['input'];
  extraFields?: InputMaybe<Array<SaveResultExtraFieldInput>>;
  gradeId?: InputMaybe<Scalars['Long']['input']>;
  gradeResult?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  result?: InputMaybe<Scalars['Int']['input']>;
  studentPartyId: Scalars['Long']['input'];
  studentStudyLevel?: InputMaybe<StudyLevel>;
  subjectGroupId: Scalars['Long']['input'];
  targetGradeId?: InputMaybe<Scalars['Long']['input']>;
  targetGradeResult?: InputMaybe<Scalars['String']['input']>;
  targetResult?: InputMaybe<Scalars['Int']['input']>;
  teacherComment?: InputMaybe<SaveAssessmentCommentInput>;
};

export type SaveAttendanceCodeInput = {
  code?: InputMaybe<TuslaCode>;
  codeType?: InputMaybe<AttendanceCodeType>;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Array<InputMaybe<TranslationInput>>;
  sessionCodeType?: InputMaybe<AttendanceCodeType>;
  visibleForContact?: InputMaybe<Scalars['Boolean']['input']>;
  visibleForTeacher?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveCategoryInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type SaveChairPerson = {
  chairPersonId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  forename?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type SaveClassAssessmentInput = {
  allowLearnerPrint?: InputMaybe<Scalars['Boolean']['input']>;
  captureTarget: Scalars['Boolean']['input'];
  commentBankId?: InputMaybe<Scalars['Long']['input']>;
  commentLength?: InputMaybe<Scalars['Int']['input']>;
  commentType: CommentType;
  description?: InputMaybe<Scalars['String']['input']>;
  docxFileTransferId?: InputMaybe<Scalars['Long']['input']>;
  endDate: Scalars['Date']['input'];
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
  extraFields?: InputMaybe<Array<InputMaybe<SaveExtraFieldInput>>>;
  gradeSetIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  gradeType: GradeType;
  id?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  passFailThreshold?: InputMaybe<Scalars['Int']['input']>;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
  publishLearner?: InputMaybe<Scalars['Boolean']['input']>;
  showType: GradeType;
  startDate: Scalars['Date']['input'];
  subjectGroupIds: Array<Scalars['Long']['input']>;
};

export type SaveCommentBankInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  comments: Array<SaveCommentInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
};

export type SaveCommentInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
};

export type SaveDiscountInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  siblingDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type SaveEventAttendanceInput = {
  adminSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  attendanceCodeId?: InputMaybe<Scalars['Int']['input']>;
  attendanceOverride?: InputMaybe<Attendance_OverrideAttendance>;
  bulkAttendanceId?: InputMaybe<Scalars['Long']['input']>;
  date: Scalars['Date']['input'];
  eventId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Long']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parentalAttendanceRequestId?: InputMaybe<Scalars['Long']['input']>;
  personPartyId: Scalars['Long']['input'];
  setGroupAttendanceAsTaken?: InputMaybe<Scalars['Boolean']['input']>;
  signInOutId?: InputMaybe<Scalars['Long']['input']>;
  sourceInfo?: InputMaybe<Scalars['String']['input']>;
  subjectGroupId?: InputMaybe<Scalars['Long']['input']>;
};

export type SaveExtraFieldInput = {
  commentBankId?: InputMaybe<Scalars['Long']['input']>;
  commentLength?: InputMaybe<Scalars['Int']['input']>;
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
  extraFieldType: ExtraFieldType;
  gradeSetId?: InputMaybe<Scalars['Long']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  selectOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SaveFeeInput = {
  absorbFees: Scalars['Boolean']['input'];
  accountingCodeId?: InputMaybe<Scalars['Int']['input']>;
  allowPartialPayments: Scalars['Boolean']['input'];
  amount: Scalars['Float']['input'];
  assignedToPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dueDate: Scalars['Date']['input'];
  feeType: FeeType;
  id?: InputMaybe<Scalars['Int']['input']>;
  individualDiscounts?: InputMaybe<Array<InputMaybe<SaveIndividualDiscountInput>>>;
  installments?: InputMaybe<Array<SaveFeeInstallmentInput>>;
  name: Scalars['String']['input'];
  paymentPlan: Scalars['Boolean']['input'];
  paymentPlanInterval?: InputMaybe<PaymentPlanInterval>;
  paymentPlanIntervalCount?: InputMaybe<Scalars['Long']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
};

export type SaveFeeInstallmentInput = {
  amount: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  installment: Scalars['Int']['input'];
  serviceChargePercentage?: InputMaybe<Scalars['Float']['input']>;
  serviceCharges?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
};

export type SaveGradeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  end: Scalars['Int']['input'];
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name: Array<TranslationInput>;
  passFailThreshold?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['Int']['input'];
  studyLevels?: InputMaybe<Array<InputMaybe<GradeSetStudyLevel>>>;
};

export type SaveGradeSetInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  customGradeSet?: InputMaybe<Scalars['Boolean']['input']>;
  description: Array<TranslationInput>;
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
  grades: Array<SaveGradeInput>;
  id?: InputMaybe<Scalars['Long']['input']>;
  isCba?: InputMaybe<Scalars['Boolean']['input']>;
  name: Array<TranslationInput>;
  passFailThreshold?: InputMaybe<Scalars['Int']['input']>;
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SaveIndividualDiscountInput = {
  adhocAmount?: InputMaybe<Scalars['Float']['input']>;
  discountId: Scalars['Int']['input'];
  partyId: Scalars['Long']['input'];
};

export type SaveNonClassContactHoursInput = {
  activity: Activity;
  dayOfTheWeek: Day;
  description?: InputMaybe<Scalars['String']['input']>;
  hours: Scalars['Int']['input'];
  minutes: Scalars['Int']['input'];
  nonClassContactHoursId?: InputMaybe<Scalars['Int']['input']>;
  programme?: InputMaybe<Ncch_Programme>;
  staffPartyId: Scalars['Long']['input'];
};

export type SaveNoticeAssigneeInput = {
  contact?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Long']['input'];
  staff?: InputMaybe<Scalars['Boolean']['input']>;
  student?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveNoticeImage = {
  id?: InputMaybe<Scalars['Long']['input']>;
  isCover: Scalars['Boolean']['input'];
  url: Scalars['String']['input'];
};

export type SaveNoticeInput = {
  allContacts?: InputMaybe<Scalars['Boolean']['input']>;
  allStaff?: InputMaybe<Scalars['Boolean']['input']>;
  allStudents?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  images?: InputMaybe<Array<SaveNoticeImage>>;
  notice: Scalars['String']['input'];
  noticeAssignees: Array<SaveNoticeAssigneeInput>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  platforms?: InputMaybe<Array<InputMaybe<SocialPlatform>>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  publicNotice?: InputMaybe<Scalars['Boolean']['input']>;
  repostToSocial?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validUntil?: InputMaybe<Scalars['Date']['input']>;
};

export type SaveNotificationTemplateInput = {
  id?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type SaveOwner = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  addressLine4?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  forename?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type SavePpodCredentials = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SavePpodSchoolInfo = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  boardOfManagement?: InputMaybe<Scalars['Boolean']['input']>;
  boardingFeeFiveDay?: InputMaybe<Scalars['BigDecimal']['input']>;
  boardingFeeSixOrSevenDay?: InputMaybe<Scalars['BigDecimal']['input']>;
  chairPeople?: InputMaybe<Array<InputMaybe<SaveChairPerson>>>;
  coOperatingSchoolRollNo1?: InputMaybe<Scalars['String']['input']>;
  coOperatingSchoolRollNo2?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  irishClassification?: InputMaybe<Scalars['String']['input']>;
  localAuthority?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  octoberReturnsContact?: InputMaybe<Scalars['String']['input']>;
  octoberReturnsEmail?: InputMaybe<Scalars['String']['input']>;
  octoberReturnsFaxNo?: InputMaybe<Scalars['String']['input']>;
  octoberReturnsPhoneNo?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<InputMaybe<SaveOwner>>>;
  parentAssociation?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  principal?: InputMaybe<Scalars['String']['input']>;
  rollNo?: InputMaybe<Scalars['String']['input']>;
  schoolGender?: InputMaybe<Scalars['String']['input']>;
  studentCouncil?: InputMaybe<Scalars['Boolean']['input']>;
  trustees?: InputMaybe<Array<InputMaybe<SaveTrustee>>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type SaveParentalAttendanceRequest = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  attachmentUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  attendanceCodeId: Scalars['Int']['input'];
  attendanceNote?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Long']['input']>;
  parentNote: Scalars['String']['input'];
  requestType: ParentalAttendanceRequestType;
  status: ParentalAttendanceRequestStatus;
  studentPartyId: Scalars['Long']['input'];
  to: Scalars['DateTime']['input'];
};

export type SavePermissionGroup = {
  description: Array<InputMaybe<TranslationInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  memberPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  memberType: MemberType;
  name: Array<InputMaybe<TranslationInput>>;
  permissionSets?: InputMaybe<Array<SavePermissionGroupSet>>;
};

export type SavePermissionGroupSet = {
  id: Scalars['String']['input'];
  permissionType?: InputMaybe<PermissionType>;
  toggle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SavePriorityStudentInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  studentPartyId?: InputMaybe<Scalars['Long']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SaveResultExtraFieldInput = {
  assessmentExtraFieldId: Scalars['Long']['input'];
  commentBankCommentId?: InputMaybe<Scalars['Long']['input']>;
  gradeSetGradeId?: InputMaybe<Scalars['Long']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
};

export type SaveSchoolActivityAttendanceInput = {
  date: Scalars['Date']['input'];
  eventId: Scalars['Int']['input'];
  schoolActivity: Scalars['String']['input'];
  schoolActivityAttendanceCodeId: Scalars['Int']['input'];
  schoolActivityId: Scalars['Int']['input'];
  studentAttendance: Array<SaveSchoolActivityStudentAttendanceInput>;
};

export type SaveSchoolActivityStudentAttendanceInput = {
  attendanceCodeId: Scalars['Int']['input'];
  attendanceOverride?: InputMaybe<Attendance_OverrideAttendance>;
  note?: InputMaybe<Scalars['String']['input']>;
  personPartyId: Scalars['Long']['input'];
};

export type SaveSolution = {
  name: Scalars['String']['input'];
  optionId: Scalars['Int']['input'];
};

export type SaveStateCbaAssessmentInput = {
  allowLearnerPrint?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  docxFileTransferId?: InputMaybe<Scalars['Long']['input']>;
  endDate: Scalars['Date']['input'];
  extraFields?: InputMaybe<Array<InputMaybe<SaveExtraFieldInput>>>;
  id?: InputMaybe<Scalars['Long']['input']>;
  startDate: Scalars['Date']['input'];
  stateCbaType?: InputMaybe<StateCbaType>;
  subjectGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  yearId: Scalars['Int']['input'];
};

export type SaveStudentSessionAttendanceInput = {
  adminSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  applyCodes?: InputMaybe<SessionAttendanceFlag>;
  attendanceOverride?: InputMaybe<Attendance_OverrideAttendance>;
  attendances: Array<SessionAttendanceInput>;
  bulkAttendanceId?: InputMaybe<Scalars['Long']['input']>;
  overwriteExistingEventAttendance?: InputMaybe<Scalars['Boolean']['input']>;
  parentalAttendanceRequestId?: InputMaybe<Scalars['Long']['input']>;
  signInOutId?: InputMaybe<Scalars['Long']['input']>;
};

export type SaveStudentSupportFileInput = {
  actionsNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  actionsNeededComments?: InputMaybe<Scalars['String']['input']>;
  actionsNeededDate?: InputMaybe<Scalars['Date']['input']>;
  basicNeedsChecklist?: InputMaybe<Scalars['Boolean']['input']>;
  basicNeedsChecklistComments?: InputMaybe<Scalars['String']['input']>;
  basicNeedsChecklistDate?: InputMaybe<Scalars['Date']['input']>;
  classroomWorkDifferentiated?: InputMaybe<Scalars['Boolean']['input']>;
  classroomWorkDifferentiatedComments?: InputMaybe<Scalars['String']['input']>;
  classroomWorkDifferentiatedDate?: InputMaybe<Scalars['Date']['input']>;
  dateClosed: Scalars['Date']['input'];
  dateOpened: Scalars['Date']['input'];
  guardiansConsulted?: InputMaybe<Scalars['Boolean']['input']>;
  guardiansConsultedComments?: InputMaybe<Scalars['String']['input']>;
  guardiansConsultedDate?: InputMaybe<Scalars['Date']['input']>;
  hearing?: InputMaybe<Scalars['Boolean']['input']>;
  hearingComments?: InputMaybe<Scalars['String']['input']>;
  hearingDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  learningEnvironmentAdapted?: InputMaybe<Scalars['Boolean']['input']>;
  learningEnvironmentAdaptedComments?: InputMaybe<Scalars['String']['input']>;
  learningEnvironmentAdaptedDate?: InputMaybe<Scalars['Date']['input']>;
  learningScreening?: InputMaybe<Scalars['Boolean']['input']>;
  learningScreeningComments?: InputMaybe<Scalars['String']['input']>;
  learningScreeningDate?: InputMaybe<Scalars['Date']['input']>;
  medical?: InputMaybe<Scalars['Boolean']['input']>;
  medicalComments?: InputMaybe<Scalars['String']['input']>;
  medicalDate?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  observationOfLearning?: InputMaybe<Scalars['Boolean']['input']>;
  observationOfLearningComments?: InputMaybe<Scalars['String']['input']>;
  observationOfLearningDate?: InputMaybe<Scalars['Date']['input']>;
  otherInterventions?: InputMaybe<Scalars['Boolean']['input']>;
  otherInterventionsComments?: InputMaybe<Scalars['String']['input']>;
  otherInterventionsDate?: InputMaybe<Scalars['Date']['input']>;
  outsideProfessionals?: InputMaybe<Scalars['Boolean']['input']>;
  outsideProfessionalsComments?: InputMaybe<Scalars['String']['input']>;
  outsideProfessionalsDate?: InputMaybe<Scalars['Date']['input']>;
  previousSchoolInfo?: InputMaybe<Scalars['Boolean']['input']>;
  previousSchoolInfoComments?: InputMaybe<Scalars['String']['input']>;
  previousSchoolInfoDate?: InputMaybe<Scalars['Date']['input']>;
  pupilInterview?: InputMaybe<Scalars['Boolean']['input']>;
  pupilInterviewComments?: InputMaybe<Scalars['String']['input']>;
  pupilInterviewDate?: InputMaybe<Scalars['Date']['input']>;
  schoolEnvironmentAdapted?: InputMaybe<Scalars['Boolean']['input']>;
  schoolEnvironmentAdaptedComments?: InputMaybe<Scalars['String']['input']>;
  schoolEnvironmentAdaptedDate?: InputMaybe<Scalars['Date']['input']>;
  studentPartyId: Scalars['Long']['input'];
  subjects?: InputMaybe<Array<InputMaybe<SaveStudentSupportFileSubjectInput>>>;
  vision?: InputMaybe<Scalars['Boolean']['input']>;
  visionComments?: InputMaybe<Scalars['String']['input']>;
  visionDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SaveStudentSupportFileSubjectInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  subjectId: Scalars['Int']['input'];
};

export type SaveStudentSupportPlanInput = {
  endDate: Scalars['Date']['input'];
  guardiansSignatureObtained?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  planType: StudentSupportPlanType;
  possibleConcerns?: InputMaybe<Scalars['String']['input']>;
  priorityConcerns?: InputMaybe<Scalars['String']['input']>;
  resourcesNeeded?: InputMaybe<Scalars['String']['input']>;
  review?: InputMaybe<SaveStudentSupportPlanReviewInput>;
  staff?: InputMaybe<Array<InputMaybe<SaveStudentSupportPlanStaffInput>>>;
  staffSignatureObtained?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['Date']['input'];
  strategies?: InputMaybe<Scalars['String']['input']>;
  strengthsAndInterests?: InputMaybe<Scalars['String']['input']>;
  studentSupportFileId: Scalars['Int']['input'];
  targets?: InputMaybe<Array<InputMaybe<SaveStudentSupportPlanTargetInput>>>;
};

export type SaveStudentSupportPlanReviewAttendeeInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  personPartyId: Scalars['Long']['input'];
};

export type SaveStudentSupportPlanReviewInput = {
  attendees?: InputMaybe<Array<InputMaybe<SaveStudentSupportPlanReviewAttendeeInput>>>;
  date: Scalars['Date']['input'];
  guardiansComments: Scalars['String']['input'];
  guardiansSignatureObtained?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  originalConcernsChanges: Scalars['String']['input'];
  recommendedActions: Scalars['String']['input'];
  staffSignatureObtained?: InputMaybe<Scalars['Boolean']['input']>;
  studentSupportPlanId: Scalars['Int']['input'];
  studentsComments: Scalars['String']['input'];
  studentsNeedsChanges: Scalars['String']['input'];
  successfulAreas: Scalars['String']['input'];
};

export type SaveStudentSupportPlanStaffInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  lead?: InputMaybe<Scalars['Boolean']['input']>;
  staffPartyId: Scalars['Long']['input'];
};

export type SaveStudentSupportPlanTargetInput = {
  comments: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  status: TargetStatus;
  target: Scalars['String']['input'];
};

export type SaveTermAssessmentInput = {
  allowLearnerPrint?: InputMaybe<Scalars['Boolean']['input']>;
  assessmentType: AssessmentType;
  captureHouseMasterComment?: InputMaybe<Scalars['Boolean']['input']>;
  capturePrincipalComment?: InputMaybe<Scalars['Boolean']['input']>;
  captureTarget: Scalars['Boolean']['input'];
  captureTutorComment?: InputMaybe<Scalars['Boolean']['input']>;
  captureYearHeadComment?: InputMaybe<Scalars['Boolean']['input']>;
  commentBankId?: InputMaybe<Scalars['Long']['input']>;
  commentLength?: InputMaybe<Scalars['Int']['input']>;
  commentType: CommentType;
  createdBy?: InputMaybe<Scalars['Long']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  docxFileTransferId?: InputMaybe<Scalars['Long']['input']>;
  endDate: Scalars['Date']['input'];
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
  extraFields?: InputMaybe<Array<InputMaybe<SaveExtraFieldInput>>>;
  gradeSetIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  gradeType: GradeType;
  housemasterCommentBankId?: InputMaybe<Scalars['Long']['input']>;
  housemasterCommentLength?: InputMaybe<Scalars['Int']['input']>;
  housemasterCommentType?: InputMaybe<CommentType>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  passFailThreshold?: InputMaybe<Scalars['Int']['input']>;
  principalCommentBankId?: InputMaybe<Scalars['Long']['input']>;
  principalCommentLength?: InputMaybe<Scalars['Int']['input']>;
  principalCommentType?: InputMaybe<CommentType>;
  programmeStages?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publish?: InputMaybe<Scalars['Boolean']['input']>;
  publishLearner?: InputMaybe<Scalars['Boolean']['input']>;
  showType: GradeType;
  startDate: Scalars['Date']['input'];
  tutorCommentBankId?: InputMaybe<Scalars['Long']['input']>;
  tutorCommentLength?: InputMaybe<Scalars['Int']['input']>;
  tutorCommentType?: InputMaybe<CommentType>;
  yearHeadCommentBankId?: InputMaybe<Scalars['Long']['input']>;
  yearHeadCommentLength?: InputMaybe<Scalars['Int']['input']>;
  yearHeadCommentType?: InputMaybe<CommentType>;
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SaveTrustee = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  addressLine4?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  forename?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  trusteeId?: InputMaybe<Scalars['Int']['input']>;
};

export type SavedCard = {
  __typename?: 'SavedCard';
  brand: Scalars['String']['output'];
  expiry: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type ScheduledMail = {
  __typename?: 'ScheduledMail';
  academicNamespaceId?: Maybe<Scalars['Int']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  body: Scalars['String']['output'];
  canReply: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  recipients: Array<Maybe<Recipient>>;
  resolvedRecipients?: Maybe<Array<ResolvedRecipient>>;
  scheduleFor: Scalars['DateTime']['output'];
  schoolMail: Scalars['Boolean']['output'];
  senderName: Scalars['String']['output'];
  senderPartyId: Scalars['Long']['output'];
  subject: Scalars['String']['output'];
  tenant: Scalars['Int']['output'];
  threadId?: Maybe<Scalars['Long']['output']>;
  threadMessageId?: Maybe<Scalars['Long']['output']>;
};

export type ScheduledNotification = {
  __typename?: 'ScheduledNotification';
  featureId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  notificationType: NotificationType;
  scheduledRecipientIds: Array<Scalars['Long']['output']>;
  scheduledRecipients: Array<ScheduledNotificationRecipient>;
  scheduledStatus: ScheduledStatus;
  sendAt: Scalars['DateTime']['output'];
  /** deep linked */
  sender: Person;
  senderPartyId: Scalars['Long']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ScheduledNotificationFilter = {
  scheduledNotificationId: Scalars['Long']['input'];
};

export type ScheduledNotificationRecipient = {
  __typename?: 'ScheduledNotificationRecipient';
  id: Scalars['Long']['output'];
  metaData?: Maybe<NotificationMetaData>;
  recipient: Person;
  recipientPartyId: Scalars['Long']['output'];
  scheduledNotificationId: Scalars['Long']['output'];
};

export type ScheduledNotificationRecipientFilter = {
  scheduledNotificationIds: Array<InputMaybe<Scalars['Long']['input']>>;
};

export type ScheduledSms = {
  __typename?: 'ScheduledSms';
  academicNamespaceId: Scalars['Int']['output'];
  body: Scalars['String']['output'];
  canReply: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  recipientIds: Array<Scalars['Long']['output']>;
  recipients: Array<ScheduledSmsRecipient>;
  scheduledStatus: ScheduledStatus;
  sendAt: Scalars['DateTime']['output'];
  sender: Person;
  senderPartyId: Scalars['Long']['output'];
  tenant: Scalars['Int']['output'];
  totalCost: Scalars['Float']['output'];
  totalRecipients: Scalars['Int']['output'];
};

export type ScheduledSmsFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type ScheduledSmsRecipient = {
  __typename?: 'ScheduledSmsRecipient';
  id: Scalars['Long']['output'];
  party: Party;
  recipientPartyId: Scalars['Long']['output'];
  recipientPhoneNumber?: Maybe<Scalars['String']['output']>;
  scheduledSmsId: Scalars['Long']['output'];
  smsRecipientType: SmsRecipientType;
};

export type ScheduledSmsRecipientFilter = {
  scheduledSmsIds: Array<Scalars['Long']['input']>;
};

export enum ScheduledStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT'
}

export type Scheduling_CancelJobInput = {
  executionId: Scalars['String']['input'];
};

export type Scheduling_CronJobDefinition = {
  __typename?: 'Scheduling_CronJobDefinition';
  cronExpression: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  handlerName: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  maxConcurrent?: Maybe<Scalars['Int']['output']>;
  systemTask: Scalars['Boolean']['output'];
};

export type Scheduling_JobExecution = {
  __typename?: 'Scheduling_JobExecution';
  academicNamespaceId?: Maybe<Scalars['Int']['output']>;
  durationMs?: Maybe<Scalars['Long']['output']>;
  exceptionClass?: Maybe<Scalars['String']['output']>;
  exceptionMessage?: Maybe<Scalars['String']['output']>;
  executionCount: Scalars['Int']['output'];
  executionId: Scalars['String']['output'];
  failCount: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  handlerName: Scalars['String']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  jobType: Scheduling_JobType;
  parameters?: Maybe<Scalars['Object']['output']>;
  retryOfExecutionId?: Maybe<Scalars['String']['output']>;
  stale: Scalars['Boolean']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scheduling_JobStatus;
  submittedAt: Scalars['DateTime']['output'];
  successCount: Scalars['Int']['output'];
  tenantId: Scalars['Int']['output'];
  triggeredBy?: Maybe<Scalars['Int']['output']>;
  workerNode?: Maybe<Scalars['String']['output']>;
};

export type Scheduling_JobExecutionFilter = {
  executionId: Scalars['String']['input'];
};

export type Scheduling_JobHandlerDefinition = {
  __typename?: 'Scheduling_JobHandlerDefinition';
  name: Scalars['String']['output'];
  parameters: Array<Scheduling_JobHandlerParameter>;
};

export type Scheduling_JobHandlerParameter = {
  __typename?: 'Scheduling_JobHandlerParameter';
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Scheduling_JobHistoryFilter = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  handlerName?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scheduling_JobType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  stale?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scheduling_JobStatus>;
  tenantId?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredBy?: InputMaybe<Scalars['Int']['input']>;
};

export type Scheduling_JobLogEntriesFilter = {
  executionId: Scalars['String']['input'];
};

export type Scheduling_JobLogEntry = {
  __typename?: 'Scheduling_JobLogEntry';
  level: Scheduling_JobLogLevel;
  message?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export enum Scheduling_JobLogLevel {
  Error = 'ERROR',
  Info = 'INFO',
  Warn = 'WARN'
}

export enum Scheduling_JobStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  PartialSuccess = 'PARTIAL_SUCCESS',
  Pending = 'PENDING',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export enum Scheduling_JobType {
  Cron = 'CRON',
  OneTime = 'ONE_TIME',
  Polling = 'POLLING'
}

export type Scheduling_JobValidationEntity = {
  __typename?: 'Scheduling_JobValidationEntity';
  entityType: Scheduling_JobValidationEntityType;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export enum Scheduling_JobValidationEntityType {
  Party = 'PARTY',
  Student = 'STUDENT'
}

export type Scheduling_JobValidationFailure = {
  __typename?: 'Scheduling_JobValidationFailure';
  affectedEntities: Array<Scheduling_JobValidationEntity>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  severity: Scheduling_JobValidationSeverity;
};

export enum Scheduling_JobValidationSeverity {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export type Scheduling_RetryFailedJobInput = {
  executionId: Scalars['String']['input'];
};

export type Scheduling_SubmitJobResult = {
  __typename?: 'Scheduling_SubmitJobResult';
  executionId: Scalars['String']['output'];
  hasValidationErrors: Scalars['Boolean']['output'];
  validationFailures: Array<Scheduling_JobValidationFailure>;
};

export type Scheduling_SubmitOneTimeJobInput = {
  academicNamespaceId?: InputMaybe<Scalars['Int']['input']>;
  executeAt?: InputMaybe<Scalars['DateTime']['input']>;
  handlerName: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['Object']['input']>;
  tenantId: Scalars['Int']['input'];
  triggeredByPartyId?: InputMaybe<Scalars['Int']['input']>;
};

export type Scheduling_SubmitPollingJobInput = {
  academicNamespaceId?: InputMaybe<Scalars['Int']['input']>;
  handlerName: Scalars['String']['input'];
  intervalSeconds: Scalars['Int']['input'];
  maxDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<Scalars['Object']['input']>;
  tenantId: Scalars['Int']['input'];
  triggeredByPartyId?: InputMaybe<Scalars['Int']['input']>;
};

export type Scheduling_TaskResult = {
  __typename?: 'Scheduling_TaskResult';
  payload: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scheduling_TaskResultType;
};

export enum Scheduling_TaskResultType {
  Link = 'LINK',
  Message = 'MESSAGE'
}

export type Scheduling_TaskResultsFilter = {
  executionId: Scalars['String']['input'];
};

export type Scheduling_TriggerCronNowInput = {
  jobId: Scalars['String']['input'];
};

export type Scheduling_UpdateCronJobRowInput = {
  cronExpression?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['String']['input'];
};

export type Scheduling_UpdateCronJobsInput = {
  updates: Array<Scheduling_UpdateCronJobRowInput>;
};

export type SchoolAddress = {
  __typename?: 'SchoolAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address4?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  localAuthority?: Maybe<Scalars['String']['output']>;
};

export type SchoolInfo = {
  __typename?: 'SchoolInfo';
  addresses?: Maybe<Array<Maybe<SchoolAddress>>>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  boardOfManagement?: Maybe<Scalars['Boolean']['output']>;
  boardingFeeFiveDay?: Maybe<Scalars['BigDecimal']['output']>;
  boardingFeeSixOrSevenDay?: Maybe<Scalars['BigDecimal']['output']>;
  chairPeople?: Maybe<Array<Maybe<ChairPerson>>>;
  coOperatingSchoolRollNo1?: Maybe<Scalars['String']['output']>;
  coOperatingSchoolRollNo2?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  irishClassification?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  octoberReturnsContact?: Maybe<Scalars['String']['output']>;
  octoberReturnsEmail?: Maybe<Scalars['String']['output']>;
  octoberReturnsFaxNo?: Maybe<Scalars['String']['output']>;
  octoberReturnsPhoneNo?: Maybe<Scalars['String']['output']>;
  owners?: Maybe<Array<Maybe<Owner>>>;
  parentAssociation?: Maybe<Scalars['Boolean']['output']>;
  phones?: Maybe<Array<Maybe<SchoolPhoneNo>>>;
  principal?: Maybe<Scalars['String']['output']>;
  rollNo?: Maybe<Scalars['String']['output']>;
  schoolGender?: Maybe<Scalars['String']['output']>;
  studentCouncil?: Maybe<Scalars['Boolean']['output']>;
  trustees?: Maybe<Array<Maybe<Trustee>>>;
  website?: Maybe<Scalars['String']['output']>;
};

export type SchoolInfoFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SchoolNotificationSetting = {
  __typename?: 'SchoolNotificationSetting';
  active: Scalars['Boolean']['output'];
  allowedFrom: Scalars['Time']['output'];
  allowedTo: Scalars['Time']['output'];
  globalUserId?: Maybe<Scalars['Int']['output']>;
  notificationType: NotificationType;
  settingUserType: NotificationUserType;
};

export type SchoolNotificationSettingFilter = {
  globalUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SchoolNotificationSettingInput = {
  active: Scalars['Boolean']['input'];
  allowedFrom?: InputMaybe<Scalars['Time']['input']>;
  allowedTo?: InputMaybe<Scalars['Time']['input']>;
  notificationType: NotificationType;
  userType: NotificationUserType;
};

export type SchoolPhoneNo = {
  __typename?: 'SchoolPhoneNo';
  phone?: Maybe<Scalars['String']['output']>;
};

export type Search = {
  __typename?: 'Search';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  meta: SearchMeta;
  partyId: Scalars['Long']['output'];
  text: Scalars['String']['output'];
  type: SearchType;
};

export type SearchFilter = {
  context?: InputMaybe<Array<InputMaybe<Context>>>;
  /** optional filter to include only certain types of results */
  includeSearchType?: InputMaybe<Array<SearchType>>;
  source?: InputMaybe<SearchSource>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SearchMeta = {
  __typename?: 'SearchMeta';
  groupType?: Maybe<GeneralGroupType>;
  studentPartyId?: Maybe<Scalars['Long']['output']>;
};

export enum SearchSource {
  Dropdown = 'DROPDOWN',
  TopLevel = 'TOP_LEVEL'
}

export enum SearchType {
  ClassGroupTutors = 'CLASS_GROUP_TUTORS',
  ClassGroupYearHeads = 'CLASS_GROUP_YEAR_HEADS',
  Contact = 'CONTACT',
  ContactsOfStudent = 'CONTACTS_OF_STUDENT',
  CustomGroup = 'CUSTOM_GROUP',
  GeneralGroup = 'GENERAL_GROUP',
  GeneralGroupContact = 'GENERAL_GROUP_CONTACT',
  GeneralGroupStaff = 'GENERAL_GROUP_STAFF',
  GeneralGroupStudent = 'GENERAL_GROUP_STUDENT',
  GroupTag = 'GROUP_TAG',
  ProgrammeStageEnrollment = 'PROGRAMME_STAGE_ENROLLMENT',
  Room = 'ROOM',
  Staff = 'STAFF',
  Student = 'STUDENT',
  SubjectGroup = 'SUBJECT_GROUP',
  SubjectGroupContact = 'SUBJECT_GROUP_CONTACT',
  SubjectGroupStaff = 'SUBJECT_GROUP_STAFF',
  SubjectGroupStudent = 'SUBJECT_GROUP_STUDENT',
  SubjectGroupTutors = 'SUBJECT_GROUP_TUTORS',
  SubjectGroupYearHeads = 'SUBJECT_GROUP_YEAR_HEADS',
  TeachersOfStudent = 'TEACHERS_OF_STUDENT',
  YearGroupContact = 'YEAR_GROUP_CONTACT',
  YearGroupEnrollment = 'YEAR_GROUP_ENROLLMENT',
  YearGroupStaff = 'YEAR_GROUP_STAFF',
  YearGroupStudent = 'YEAR_GROUP_STUDENT'
}

export type Search_RefreshTenantSearchInput = {
  allYears: Scalars['Boolean']['input'];
  tenantId: Scalars['Int']['input'];
};

export type SecurityRole = {
  __typename?: 'SecurityRole';
  description: Scalars['String']['output'];
  descriptionTextId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
  permissionKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
};

export type SecurityRoleFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SendMailInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  body: Scalars['String']['input'];
  canReply: Scalars['Boolean']['input'];
  readOn?: InputMaybe<Scalars['DateTime']['input']>;
  recipients: Array<InputMaybe<SendMailRecipientInput>>;
  rulesEngineMail?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleFor?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledMailId?: InputMaybe<Scalars['Long']['input']>;
  schedulerPartyId?: InputMaybe<Scalars['Long']['input']>;
  schoolMail: Scalars['Boolean']['input'];
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  subject: Scalars['String']['input'];
  threadId?: InputMaybe<Scalars['Long']['input']>;
  threadMessageId?: InputMaybe<Scalars['Long']['input']>;
};

export type SendMailRecipientInput = {
  recipientPartyId: Scalars['Long']['input'];
  recipientPartyType: SearchType;
  recipientType: RecipientType;
  resolvedName: Scalars['String']['input'];
};

export type SendPushNotificationInput = {
  cancelExistingScheduledNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  featureId?: InputMaybe<Scalars['Long']['input']>;
  notificationType: NotificationType;
  recipients: Array<PushNotificationRecipient>;
  scheduleNotificationFor?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledNotificationId?: InputMaybe<Scalars['Long']['input']>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type SendSmsInput = {
  canReply: Scalars['Boolean']['input'];
  failedSmsId?: InputMaybe<Scalars['Long']['input']>;
  mobileNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  recipients?: InputMaybe<Array<RecipientInput>>;
  scheduleFor?: InputMaybe<Scalars['DateTime']['input']>;
  text: Scalars['String']['input'];
};

export type ServiceCharge = {
  __typename?: 'ServiceCharge';
  amount: Scalars['Float']['output'];
  systemServiceCharge: Scalars['Float']['output'];
  systemVat: Scalars['Float']['output'];
  userServiceCharge: Scalars['Float']['output'];
  userVat: Scalars['Float']['output'];
};

export type Session = {
  __typename?: 'Session';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId?: Maybe<Scalars['Int']['output']>;
  time: Scalars['Time']['output'];
};

export enum SessionAttendanceFlag {
  AbsentCodesOnly = 'ABSENT_CODES_ONLY',
  AllCodes = 'ALL_CODES'
}

export type SessionAttendanceInput = {
  adminSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  attendanceCodeId?: InputMaybe<Scalars['Int']['input']>;
  attendanceOverride?: InputMaybe<Attendance_OverrideAttendance>;
  bellTimeId: Scalars['Int']['input'];
  date: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['Long']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parentalAttendanceRequestId?: InputMaybe<Scalars['Long']['input']>;
  studentPartyId: Scalars['Long']['input'];
};

export type SessionAttendanceList = {
  __typename?: 'SessionAttendanceList';
  attendanceCode: AttendanceCode;
  attendanceCodeId: Scalars['Int']['output'];
  bellTime: Calendar_BellTime;
  bellTimeId: Scalars['Int']['output'];
  classGroup?: Maybe<GeneralGroup>;
  date: Scalars['Date']['output'];
  id: Scalars['Long']['output'];
  note?: Maybe<Scalars['String']['output']>;
  student: Student;
  studentPartyId: Scalars['Long']['output'];
};

export type SessionAttendanceListFilter = {
  attendanceCodeIds: Array<Scalars['Int']['input']>;
  from: Scalars['Date']['input'];
  studentPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  to: Scalars['Date']['input'];
};

export type SessionAttendanceStatus = {
  __typename?: 'SessionAttendanceStatus';
  codeType: AttendanceCodeType;
  name?: Maybe<Scalars['String']['output']>;
  partyId: Scalars['Long']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type SetActiveAcademicNamespace = {
  academicNamespaceId: Scalars['Int']['input'];
};

export type SetOpenForResultEntryInput = {
  assessmentId: Scalars['Long']['input'];
  open: Scalars['Boolean']['input'];
};

export type Sibling = {
  __typename?: 'Sibling';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  studentPartyId: Scalars['Long']['output'];
};

export type SignInOut = {
  createdBy: Staff;
  createdByPartyId: Scalars['Long']['output'];
  dateTime: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  note?: Maybe<Scalars['String']['output']>;
  signInOutPersonType: Attendance_SignInOutPersonType;
  signInOutStatus: Attendance_SignInOutStatus;
  type: Attendance_SignInOutType;
};

export type SimulateBankTransferInput = {
  amount?: InputMaybe<Scalars['Long']['input']>;
  bankReferenceId?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['Int']['input']>;
};

export type Sms = {
  __typename?: 'Sms';
  body: Scalars['String']['output'];
  canReply: Scalars['Boolean']['output'];
  groupRecipientIds?: Maybe<Array<Scalars['Long']['output']>>;
  groupRecipients?: Maybe<Array<PartyGroup>>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  numRecipients: Scalars['Int']['output'];
  recipientIds?: Maybe<Array<Scalars['Long']['output']>>;
  recipientType: SearchType;
  recipients: Array<SmsRecipient>;
  /** deep linked */
  sender: Person;
  senderPartyId: Scalars['Long']['output'];
  sentOn: Scalars['DateTime']['output'];
  totalCost: Scalars['BigDecimal']['output'];
};

export type SmsCost = {
  __typename?: 'SmsCost';
  total?: Maybe<Scalars['BigDecimal']['output']>;
};

export type SmsCostFilter = {
  recipients: Array<RecipientInput>;
  text: Scalars['String']['input'];
};

export type SmsCurrentBalance = {
  __typename?: 'SmsCurrentBalance';
  currentBalance: Scalars['Float']['output'];
};

export type SmsFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type SmsGroupRecipient = {
  __typename?: 'SmsGroupRecipient';
  groupPartyId: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type SmsRecipient = {
  __typename?: 'SmsRecipient';
  deliveredOn?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<SmsRecipientId>;
  /** deep linked */
  recipient?: Maybe<Person>;
  recipientPartyId: Scalars['Long']['output'];
  recipientPhoneNumber: Scalars['String']['output'];
  smsStatus: SmsStatus;
};

export type SmsRecipientId = {
  __typename?: 'SmsRecipientId';
  recipientPartyId: Scalars['Long']['output'];
  smsId: Scalars['Long']['output'];
  tenant: Scalars['Int']['output'];
};

export enum SmsRecipientType {
  ClassGroupStaff = 'CLASS_GROUP_STAFF',
  Contact = 'CONTACT',
  ContactsOfStudent = 'CONTACTS_OF_STUDENT',
  GeneralGroupContact = 'GENERAL_GROUP_CONTACT',
  GeneralGroupStaff = 'GENERAL_GROUP_STAFF',
  GeneralGroupStudent = 'GENERAL_GROUP_STUDENT',
  Person = 'PERSON',
  Staff = 'STAFF',
  Student = 'STUDENT',
  StudentTeachers = 'STUDENT_TEACHERS',
  SubjectGroupContact = 'SUBJECT_GROUP_CONTACT',
  SubjectGroupStaff = 'SUBJECT_GROUP_STAFF',
  SubjectGroupStudent = 'SUBJECT_GROUP_STUDENT',
  YearGroupContact = 'YEAR_GROUP_CONTACT',
  YearGroupStaff = 'YEAR_GROUP_STAFF',
  YearGroupStudent = 'YEAR_GROUP_STUDENT'
}

export type SmsSentResponse = {
  __typename?: 'SmsSentResponse';
  numSmsSent: Scalars['Int']['output'];
  smsSentCost: Scalars['Float']['output'];
};

export enum SmsStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED',
  Success = 'SUCCESS'
}

export type SmsTopUpInput = {
  amount: Scalars['Int']['input'];
  purchaseOrder?: InputMaybe<Scalars['String']['input']>;
};

export type SocialCache = {
  globalUserId: Scalars['Int']['input'];
  oauthTokenSecret?: InputMaybe<Scalars['String']['input']>;
  partyId: Scalars['Long']['input'];
  platform: SocialPlatform;
  state: Scalars['String']['input'];
  tenant: Scalars['Int']['input'];
  verifier?: InputMaybe<Scalars['String']['input']>;
};

export type SocialIntegration = {
  __typename?: 'SocialIntegration';
  platform: SocialPlatform;
  uri: Scalars['String']['output'];
};

export type SocialMediaFilter = {
  platform?: InputMaybe<SocialPlatform>;
};

export enum SocialPlatform {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Twitter = 'TWITTER'
}

export type SocialPost = {
  __typename?: 'SocialPost';
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  maxRetries: Scalars['Int']['output'];
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  noticeId: Scalars['Long']['output'];
  platform: SocialPlatform;
  retryCount: Scalars['Int']['output'];
  socialPostId?: Maybe<Scalars['String']['output']>;
  status: SocialPostStatus;
};

export type SocialPostFilter = {
  noticeIds: Array<Scalars['Long']['input']>;
};

export type SocialPostInput = {
  imageUrls: Array<Scalars['String']['input']>;
  noticeId: Scalars['Long']['input'];
  platforms: Array<SocialPlatform>;
  text: Scalars['String']['input'];
};

export type SocialPostProcessing = {
  cache: SocialCache;
  code?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export enum SocialPostStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED',
  Success = 'SUCCESS'
}

export enum SolutionStatus {
  Error = 'ERROR',
  NotSolving = 'NOT_SOLVING',
  SolvingActive = 'SOLVING_ACTIVE',
  SolvingScheduled = 'SOLVING_SCHEDULED'
}

export enum SolverRunType {
  Rooms = 'ROOMS',
  Teachers = 'TEACHERS',
  Timetslots = 'TIMETSLOTS'
}

export type Sort = {
  direction: SortDirection;
  field: Scalars['String']['input'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Staff = Party & PartyPerson & {
  __typename?: 'Staff';
  availableForSubstitution: Scalars['Boolean']['output'];
  availableForSupportClasses: Scalars['Boolean']['output'];
  availableForTeaching: Scalars['Boolean']['output'];
  carRegistrationNumber?: Maybe<Scalars['String']['output']>;
  competencies?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** deep linked */
  competencySubjects: Array<Subject>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  displayCode?: Maybe<Scalars['String']['output']>;
  emergencyContact?: Maybe<StaffEmergencyContact>;
  employmentCapacity?: Maybe<StaffCapacity>;
  endDate?: Maybe<Scalars['Date']['output']>;
  /** deep linked */
  enrolledNamespaces: Array<AcademicNamespace>;
  extensions?: Maybe<StaffGraphqlExtension>;
  externalSystemId?: Maybe<Scalars['String']['output']>;
  jobSharing?: Maybe<Scalars['Boolean']['output']>;
  makeAndModel?: Maybe<Scalars['String']['output']>;
  noLongerStaffMember?: Maybe<Scalars['Boolean']['output']>;
  parking?: Maybe<Scalars['String']['output']>;
  partyId: Scalars['Long']['output'];
  payrollNumber?: Maybe<Scalars['String']['output']>;
  peopleTags: Array<PeopleTag>;
  peopleTagsIds: Array<Scalars['Int']['output']>;
  person: Person;
  personalInformation?: Maybe<PersonalInformation>;
  position?: Maybe<Scalars['String']['output']>;
  qualifications?: Maybe<Scalars['String']['output']>;
  sdsSyncTime?: Maybe<Scalars['DateTime']['output']>;
  staffIre?: Maybe<StaffIre>;
  startDate?: Maybe<Scalars['Date']['output']>;
  subjectGroups: Array<SubjectGroup>;
};


export type StaffSubjectGroupsArgs = {
  filter?: InputMaybe<SubjectGroupRelationshipFilter>;
};

export type StaffCapacity = {
  __typename?: 'StaffCapacity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
};

export type StaffEmergencyContact = {
  __typename?: 'StaffEmergencyContact';
  additionalNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  primaryNumber?: Maybe<Scalars['String']['output']>;
};

export type StaffFilter = {
  availableForSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  availableForTeaching?: InputMaybe<Scalars['Boolean']['input']>;
  noLongerStaffMember?: InputMaybe<Scalars['Boolean']['input']>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  peopleTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type StaffGraphqlExtension = {
  __typename?: 'StaffGraphqlExtension';
  doeNotUser?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<Notes_Note>>>;
  substitutionSummary?: Maybe<Swm_SubstitutionSummary>;
  /** Gives a summary of the timetable for a particular teacher */
  timetableSummary?: Maybe<Tt_TeacherTimetableSummary>;
};

export type StaffGroupMembershipInput = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  partyId: Scalars['Long']['input'];
  roles?: InputMaybe<Array<InputMaybe<StaffGroupMembershipRoles>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export enum StaffGroupMembershipRoles {
  GroupAdmin = 'GROUP_ADMIN',
  LongTermSubstitute = 'LONG_TERM_SUBSTITUTE',
  ShortTermSubstitute = 'SHORT_TERM_SUBSTITUTE',
  Support = 'SUPPORT',
  Teacher = 'TEACHER',
  Tutor = 'TUTOR',
  YearGroupLead = 'YEAR_GROUP_LEAD'
}

export type StaffIre = {
  __typename?: 'StaffIre';
  customFields?: Maybe<Array<Core_PartyCustomField>>;
  includeDtrReturns?: Maybe<Scalars['Boolean']['output']>;
  otherSchool1?: Maybe<Scalars['String']['output']>;
  otherSchool2?: Maybe<Scalars['String']['output']>;
  previousSchool1?: Maybe<Scalars['String']['output']>;
  previousSchool2?: Maybe<Scalars['String']['output']>;
  qualifications2?: Maybe<Scalars['String']['output']>;
  qualifications3?: Maybe<Scalars['String']['output']>;
  qualifications4?: Maybe<Scalars['String']['output']>;
  staffPost?: Maybe<StaffPost>;
  teacherCouncilNumber?: Maybe<Scalars['String']['output']>;
  teacherReferenceNumber?: Maybe<Scalars['String']['output']>;
};

export type StaffPost = {
  __typename?: 'StaffPost';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
};

export enum StaffProgrammeStageMembershipRoles {
  GroupAdmin = 'GROUP_ADMIN',
  ProgrammeLead = 'PROGRAMME_LEAD',
  Support = 'SUPPORT'
}

export enum StaffYearGroupMembershipRoles {
  GroupAdmin = 'GROUP_ADMIN',
  Support = 'SUPPORT',
  YearGroupLead = 'YEAR_GROUP_LEAD'
}

export enum StateCbaType {
  Cba_1 = 'CBA_1',
  Cba_2 = 'CBA_2',
  ShortCourse = 'SHORT_COURSE'
}

export type StripeAccount = {
  __typename?: 'StripeAccount';
  onboardingComplete: Scalars['Boolean']['output'];
  onboardingLink?: Maybe<Scalars['String']['output']>;
  signUpStarted: Scalars['Boolean']['output'];
};

export type StripeCustomerInfo = {
  __typename?: 'StripeCustomerInfo';
  customerId: Scalars['String']['output'];
  ephemeralKey: Scalars['String']['output'];
};

export type StuTime_Timeline = {
  __typename?: 'StuTime_Timeline';
  events: Array<StuTime_TimelineEvent>;
};

export type StuTime_TimelineEvent = {
  __typename?: 'StuTime_TimelineEvent';
  endDate?: Maybe<Scalars['Date']['output']>;
  endDatetime?: Maybe<Scalars['DateTime']['output']>;
  meta?: Maybe<Scalars['Object']['output']>;
  startDate: Scalars['Date']['output'];
  startDatetime: Scalars['DateTime']['output'];
  student: Student;
  studentId: Scalars['Long']['output'];
  timelineId?: Maybe<StuTime_TimelineEventId>;
};

export type StuTime_TimelineEventId = {
  __typename?: 'StuTime_TimelineEventId';
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<EventType>;
};

export type StuTime_TimelineFilter = {
  studentPartyIds: Array<InputMaybe<Scalars['Long']['input']>>;
};

export type Student = Party & PartyPerson & {
  __typename?: 'Student';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** deep linked */
  classGroup?: Maybe<GeneralGroup>;
  /** deep linked */
  contacts?: Maybe<Array<StudentContact>>;
  endDate?: Maybe<Scalars['Date']['output']>;
  /** deep linked */
  enrolmentHistory?: Maybe<Array<EnrollmentHistory>>;
  /** deep linked */
  exemptions?: Maybe<Array<StudentExemption>>;
  extensions?: Maybe<StudentGraphqlExtension>;
  externalSystemId?: Maybe<Scalars['String']['output']>;
  guardianshipNote?: Maybe<Scalars['String']['output']>;
  leftEarly?: Maybe<Scalars['Boolean']['output']>;
  partyId: Scalars['Long']['output'];
  /** deep linked */
  person: Person;
  /** deep linked */
  personalInformation?: Maybe<PersonalInformation>;
  programmeStages?: Maybe<Array<ProgrammeStage>>;
  sdsSyncTime?: Maybe<Scalars['DateTime']['output']>;
  siblings?: Maybe<Core_Siblings>;
  startDate?: Maybe<Scalars['Date']['output']>;
  studentIrePP?: Maybe<StudentIrePp>;
  subjectGroups: Array<SubjectGroup>;
  /** deep linked */
  tutors: Array<Person>;
  yearGroupLeads: Array<Person>;
  yearGroups: Array<YearGroupEnrollment>;
};

export type StudentAenFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  studentPartyIds: Array<InputMaybe<Scalars['Long']['input']>>;
};

export type StudentAssessmentExclusionInput = {
  assessmentId: Scalars['Long']['input'];
  excluded: Scalars['Boolean']['input'];
  studentPartyId: Scalars['Long']['input'];
  subjectGroupId: Scalars['Long']['input'];
};

export type StudentContact = Party & PartyPerson & {
  __typename?: 'StudentContact';
  archived?: Maybe<Scalars['Boolean']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  partyId: Scalars['Long']['output'];
  person: Person;
  /** deep linked */
  personalInformation?: Maybe<PersonalInformation>;
  postalTitle?: Maybe<Scalars['String']['output']>;
  relationships: Array<StudentContactRelationshipInfo>;
  requiresInterpreter?: Maybe<Scalars['Boolean']['output']>;
  spokenLanguages: Array<Scalars['String']['output']>;
};

export type StudentContactFilter = {
  allowAccessToStudentData?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  studentContactPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  studentPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type StudentContactRelationshipInfo = {
  __typename?: 'StudentContactRelationshipInfo';
  allowAccessToStudentData: Scalars['Boolean']['output'];
  allowedToContact: Scalars['Boolean']['output'];
  contactPartyId: Scalars['Long']['output'];
  includeInSms: Scalars['Boolean']['output'];
  includeInTemplating: Scalars['Boolean']['output'];
  /** include in in  app email */
  includeInTmail: Scalars['Boolean']['output'];
  legalGuardian: Scalars['Boolean']['output'];
  pickupRights: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  relationshipType: StudentContactType;
  student: Student;
  studentPartyId: Scalars['Long']['output'];
};

export enum StudentContactType {
  Agent = 'AGENT',
  Aunty = 'AUNTY',
  ChildMinder = 'CHILD_MINDER',
  EmergencyContact = 'EMERGENCY_CONTACT',
  FamilyFriend = 'FAMILY_FRIEND',
  Father = 'FATHER',
  FosterFather = 'FOSTER_FATHER',
  FosterMother = 'FOSTER_MOTHER',
  GrandFather = 'GRAND_FATHER',
  GrandMother = 'GRAND_MOTHER',
  Host = 'HOST',
  Mother = 'MOTHER',
  Neighbour = 'NEIGHBOUR',
  Other = 'OTHER',
  Parent = 'PARENT',
  Sibling = 'SIBLING',
  SocialWorker = 'SOCIAL_WORKER',
  StepFather = 'STEP_FATHER',
  StepMother = 'STEP_MOTHER',
  Uncle = 'UNCLE'
}

export type StudentExemption = {
  __typename?: 'StudentExemption';
  comments?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  exemption: Scalars['String']['output'];
  exemptionTypeCode: Scalars['Int']['output'];
  grantor: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type StudentFee = {
  __typename?: 'StudentFee';
  adHocAmount?: Maybe<Scalars['Float']['output']>;
  allowPartialPayments: Scalars['Boolean']['output'];
  amount: Scalars['Float']['output'];
  amountDiscounted: Scalars['Float']['output'];
  amountDue: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  amountWrittenOff: Scalars['Float']['output'];
  /** deep linked */
  classGroup: GeneralGroup;
  debtorId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountIds: Array<Scalars['Int']['output']>;
  discounts: Array<Discount>;
  dueDate: Scalars['Date']['output'];
  feeName: Scalars['String']['output'];
  feeStatus: FeeStatus;
  feeType: FeeType;
  id: FeeIdStudent;
  paymentPlan: Scalars['Boolean']['output'];
  paymentPlanIds?: Maybe<Array<Scalars['Int']['output']>>;
  paymentPlanInterval?: Maybe<PaymentPlanInterval>;
  paymentPlanIntervalCount?: Maybe<Scalars['Long']['output']>;
  paymentPlans?: Maybe<Array<PaymentPlan>>;
  person: Person;
  writeOffNote?: Maybe<Scalars['String']['output']>;
};

export type StudentFeeFilter = {
  /** fees that were assigned to any of these groups */
  assignedToGroupPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  contactPartyId?: InputMaybe<Scalars['Long']['input']>;
  feeId?: InputMaybe<Scalars['Int']['input']>;
  studentPartyId?: InputMaybe<Scalars['Long']['input']>;
  /** fees for every student who is a member of any of these groups */
  studentsInGroupPartyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type StudentFilter = {
  /** default false.Will only include students who are currently enrolled in a year group */
  currentlyEnrolled?: InputMaybe<Core_CurrentlyEnrolledOption>;
  examNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  externalSystemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** defaults to false */
  includeLeftEarly?: InputMaybe<Scalars['Boolean']['input']>;
  leftSchool?: InputMaybe<Scalars['Boolean']['input']>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type StudentGraphqlExtension = {
  __typename?: 'StudentGraphqlExtension';
  aen?: Maybe<Scalars['Boolean']['output']>;
  customExtensionPoint?: Maybe<Dtab_CustomExtensionPointLinkList>;
  doeNotUser?: Maybe<Scalars['String']['output']>;
  exampleExtension?: Maybe<Scalars['String']['output']>;
  medical?: Maybe<Scalars['Boolean']['output']>;
  objectExample?: Maybe<ExampleObjectExtension>;
  priority?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentIre = {
  __typename?: 'StudentIre';
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  pps?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
};

export type StudentIrePp = {
  __typename?: 'StudentIrePP';
  boardingDays?: Maybe<Scalars['String']['output']>;
  borderIndicator?: Maybe<Scalars['Boolean']['output']>;
  deceased?: Maybe<Scalars['Boolean']['output']>;
  deceasedDate?: Maybe<Scalars['Date']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  destinationRollNo?: Maybe<Scalars['String']['output']>;
  dpin?: Maybe<Scalars['Long']['output']>;
  examEntrant?: Maybe<Scalars['Boolean']['output']>;
  examNumber?: Maybe<Scalars['String']['output']>;
  languageSupportApplicant?: Maybe<Scalars['Boolean']['output']>;
  lockerNumber?: Maybe<Scalars['String']['output']>;
  medicalCard?: Maybe<Scalars['Boolean']['output']>;
  previousSchoolName?: Maybe<Scalars['String']['output']>;
  previousSchoolRollNumber?: Maybe<Scalars['String']['output']>;
  previousSchoolType?: Maybe<Scalars['String']['output']>;
  reasonForLeaving?: Maybe<StudentLeavingReason>;
  repeatYear?: Maybe<Scalars['Boolean']['output']>;
  shortTermPupil?: Maybe<Scalars['Boolean']['output']>;
  shortTermPupilNumWeeks?: Maybe<Scalars['Int']['output']>;
  travellerHeritage?: Maybe<Scalars['Boolean']['output']>;
};

export enum StudentLeavingReason {
  Another_2NdLevelSchoolInTheState = 'ANOTHER_2ND_LEVEL_SCHOOL_IN_THE_STATE',
  ApprenticeshipsAndFurtherTraining = 'APPRENTICESHIPS_AND_FURTHER_TRAINING',
  ApprenticeshipInvolvingSomeTraining = 'APPRENTICESHIP_INVOLVING_SOME_TRAINING',
  ANonRecognisedSecondLevelSchoolInTheState = 'A_NON_RECOGNISED_SECOND_LEVEL_SCHOOL_IN_THE_STATE',
  Deceased = 'DECEASED',
  EmigrationOtherThan_6And_7Above = 'EMIGRATION_OTHER_THAN_6_AND_7_ABOVE',
  Employment = 'EMPLOYMENT',
  Expulsion = 'EXPULSION',
  FullTimeVocationalTrainingInTheState = 'FULL_TIME_VOCATIONAL_TRAINING_IN_THE_STATE',
  FurtherEducationOutsideTheState = 'FURTHER_EDUCATION_OUTSIDE_THE_STATE',
  Other = 'OTHER',
  OutsideTheStateAndNotInFurtherEducation = 'OUTSIDE_THE_STATE_AND_NOT_IN_FURTHER_EDUCATION',
  ParentIsHomeSchooling = 'PARENT_IS_HOME_SCHOOLING',
  PursuingSeniorCycleInPrivateInstitution = 'PURSUING_SENIOR_CYCLE_IN_PRIVATE_INSTITUTION',
  RegisteredForHomeSchoolingSection_14 = 'REGISTERED_FOR_HOME_SCHOOLING_SECTION_14',
  SchoolNotNotifiedOrNotAwareOfReasonForLeaving = 'SCHOOL_NOT_NOTIFIED_OR_NOT_AWARE_OF_REASON_FOR_LEAVING',
  SpecialSchoolPrimarySchool = 'SPECIAL_SCHOOL_PRIMARY_SCHOOL',
  StudentHasLeftTheJurisdiction = 'STUDENT_HAS_LEFT_THE_JURISDICTION',
  ThirdLevelCollegeInTheState = 'THIRD_LEVEL_COLLEGE_IN_THE_STATE',
  YouthreachAlternativeEducationProvision = 'YOUTHREACH_ALTERNATIVE_EDUCATION_PROVISION',
  YouthreachCourse = 'YOUTHREACH_COURSE'
}

export type StudentMedical = {
  __typename?: 'StudentMedical';
  conditions: Array<StudentMedicalCondition>;
  medicalContacts: Array<StudentMedicalContact>;
  student?: Maybe<Student>;
  studentPartyId: Scalars['Long']['output'];
};

export type StudentMedicalCondition = {
  __typename?: 'StudentMedicalCondition';
  description?: Maybe<Scalars['String']['output']>;
  emergencyPlan?: Maybe<Scalars['String']['output']>;
  equipment: Array<StudentMedicalConditionEquipment>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type StudentMedicalConditionEquipment = {
  __typename?: 'StudentMedicalConditionEquipment';
  expiryDate?: Maybe<Scalars['Date']['output']>;
  firstResponders: Array<Staff>;
  firstRespondersIds: Array<Scalars['Long']['output']>;
  id: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
};

export type StudentMedicalContact = {
  __typename?: 'StudentMedicalContact';
  additionalPhone?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  personalTitle?: Maybe<Scalars['String']['output']>;
  personalTitleId?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
};

export type StudentMedicalFilter = {
  studentPartyId: Scalars['Long']['input'];
};

export type StudentResultFilter = {
  academicYearId?: InputMaybe<Scalars['Int']['input']>;
  assessmentId: Scalars['Long']['input'];
  filterOutEmptyResults?: InputMaybe<Scalars['Boolean']['input']>;
  studentPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  subjectGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type StudentSessionAttendance = {
  __typename?: 'StudentSessionAttendance';
  adminSubmitted: Scalars['Boolean']['output'];
  classGroup?: Maybe<GeneralGroup>;
  dateAttendance: Array<DateAttendance>;
  student: Student;
  studentPartyId: Scalars['Long']['output'];
};

export type StudentSessionAttendanceFilter = {
  from: Scalars['Date']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  to: Scalars['Date']['input'];
};

export type StudentSignInOut = SignInOut & {
  __typename?: 'StudentSignInOut';
  attendanceCode: AttendanceCode;
  attendanceCodeId: Scalars['Long']['output'];
  collectedBy?: Maybe<Scalars['String']['output']>;
  createdBy: Staff;
  createdByPartyId: Scalars['Long']['output'];
  dateTime: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  note?: Maybe<Scalars['String']['output']>;
  parentalAttendanceRequest?: Maybe<ParentalAttendanceRequest>;
  parentalRequestId?: Maybe<Scalars['Long']['output']>;
  signInOutPersonType: Attendance_SignInOutPersonType;
  signInOutStatus: Attendance_SignInOutStatus;
  student: Student;
  studentPartyId: Scalars['Long']['output'];
  type: Attendance_SignInOutType;
};

export type StudentSubjectGroup = {
  __typename?: 'StudentSubjectGroup';
  studentPartyIds: Array<Scalars['Long']['output']>;
  /** deep linked */
  students: Array<SubjectGroupStudent>;
  /** deep linked */
  subjectGroup?: Maybe<SubjectGroup>;
  subjectGroupId: Scalars['Long']['output'];
};

export type StudentSupportFile = {
  __typename?: 'StudentSupportFile';
  actionsNeeded?: Maybe<Scalars['Boolean']['output']>;
  actionsNeededComments?: Maybe<Scalars['String']['output']>;
  actionsNeededDate?: Maybe<Scalars['Date']['output']>;
  basicNeedsChecklist?: Maybe<Scalars['Boolean']['output']>;
  basicNeedsChecklistComments?: Maybe<Scalars['String']['output']>;
  basicNeedsChecklistDate?: Maybe<Scalars['Date']['output']>;
  classroomWorkDifferentiated?: Maybe<Scalars['Boolean']['output']>;
  classroomWorkDifferentiatedComments?: Maybe<Scalars['String']['output']>;
  classroomWorkDifferentiatedDate?: Maybe<Scalars['Date']['output']>;
  creatorPartyId: Scalars['Long']['output'];
  dateClosed: Scalars['Date']['output'];
  dateOpened: Scalars['Date']['output'];
  guardiansConsulted?: Maybe<Scalars['Boolean']['output']>;
  guardiansConsultedComments?: Maybe<Scalars['String']['output']>;
  guardiansConsultedDate?: Maybe<Scalars['Date']['output']>;
  hearing?: Maybe<Scalars['Boolean']['output']>;
  hearingComments?: Maybe<Scalars['String']['output']>;
  hearingDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  learningEnvironmentAdapted?: Maybe<Scalars['Boolean']['output']>;
  learningEnvironmentAdaptedComments?: Maybe<Scalars['String']['output']>;
  learningEnvironmentAdaptedDate?: Maybe<Scalars['Date']['output']>;
  learningScreening?: Maybe<Scalars['Boolean']['output']>;
  learningScreeningComments?: Maybe<Scalars['String']['output']>;
  learningScreeningDate?: Maybe<Scalars['Date']['output']>;
  medical?: Maybe<Scalars['Boolean']['output']>;
  medicalComments?: Maybe<Scalars['String']['output']>;
  medicalDate?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  observationOfLearning?: Maybe<Scalars['Boolean']['output']>;
  observationOfLearningComments?: Maybe<Scalars['String']['output']>;
  observationOfLearningDate?: Maybe<Scalars['Date']['output']>;
  otherInterventions?: Maybe<Scalars['Boolean']['output']>;
  otherInterventionsComments?: Maybe<Scalars['String']['output']>;
  otherInterventionsDate?: Maybe<Scalars['Date']['output']>;
  outsideProfessionals?: Maybe<Scalars['Boolean']['output']>;
  outsideProfessionalsComments?: Maybe<Scalars['String']['output']>;
  outsideProfessionalsDate?: Maybe<Scalars['Date']['output']>;
  previousSchoolInfo?: Maybe<Scalars['Boolean']['output']>;
  previousSchoolInfoComments?: Maybe<Scalars['String']['output']>;
  previousSchoolInfoDate?: Maybe<Scalars['Date']['output']>;
  pupilInterview?: Maybe<Scalars['Boolean']['output']>;
  pupilInterviewComments?: Maybe<Scalars['String']['output']>;
  pupilInterviewDate?: Maybe<Scalars['Date']['output']>;
  schoolEnvironmentAdapted?: Maybe<Scalars['Boolean']['output']>;
  schoolEnvironmentAdaptedComments?: Maybe<Scalars['String']['output']>;
  schoolEnvironmentAdaptedDate?: Maybe<Scalars['Date']['output']>;
  studentPartyId: Scalars['Long']['output'];
  subjects?: Maybe<Array<Maybe<StudentSupportFileSubject>>>;
  vision?: Maybe<Scalars['Boolean']['output']>;
  visionComments?: Maybe<Scalars['String']['output']>;
  visionDate?: Maybe<Scalars['Date']['output']>;
};

export type StudentSupportFileFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  studentPartyId?: InputMaybe<Scalars['Long']['input']>;
};

export type StudentSupportFileSubject = {
  __typename?: 'StudentSupportFileSubject';
  id: Scalars['Int']['output'];
  subjectId: Scalars['Int']['output'];
};

export type StudentSupportPlan = {
  __typename?: 'StudentSupportPlan';
  endDate: Scalars['Date']['output'];
  guardiansSignatureObtained?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  planType: StudentSupportPlanType;
  possibleConcerns?: Maybe<Scalars['String']['output']>;
  priorityConcerns?: Maybe<Scalars['String']['output']>;
  resourcesNeeded?: Maybe<Scalars['String']['output']>;
  staff?: Maybe<Array<Maybe<StudentSupportPlanStaff>>>;
  staffSignatureObtained?: Maybe<Scalars['Boolean']['output']>;
  startDate: Scalars['Date']['output'];
  strategies?: Maybe<Scalars['String']['output']>;
  strengthsAndInterests?: Maybe<Scalars['String']['output']>;
  studentSupportFileId: Scalars['Int']['output'];
  targets?: Maybe<Array<Maybe<StudentSupportPlanTarget>>>;
};

export type StudentSupportPlanFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  studentSupportFileId?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentSupportPlanReview = {
  __typename?: 'StudentSupportPlanReview';
  attendees?: Maybe<Array<Maybe<StudentSupportPlanReviewAttendee>>>;
  date: Scalars['Date']['output'];
  guardiansComments: Scalars['String']['output'];
  guardiansSignatureObtained?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  originalConcernsChanges: Scalars['String']['output'];
  recommendedActions: Scalars['String']['output'];
  staffSignatureObtained?: Maybe<Scalars['Boolean']['output']>;
  studentSupportPlanId: Scalars['Int']['output'];
  studentsComments: Scalars['String']['output'];
  studentsNeedsChanges: Scalars['String']['output'];
  successfulAreas: Scalars['String']['output'];
};

export type StudentSupportPlanReviewAttendee = {
  __typename?: 'StudentSupportPlanReviewAttendee';
  id: Scalars['Int']['output'];
  personPartyId: Scalars['Long']['output'];
  studentSupportPlanReviewId: Scalars['Int']['output'];
};

export type StudentSupportPlanReviewFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  studentSupportPlanId?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentSupportPlanStaff = {
  __typename?: 'StudentSupportPlanStaff';
  id: Scalars['Int']['output'];
  lead?: Maybe<Scalars['Boolean']['output']>;
  staffPartyId: Scalars['Long']['output'];
  studentSupportPlanId: Scalars['Int']['output'];
};

export type StudentSupportPlanTarget = {
  __typename?: 'StudentSupportPlanTarget';
  comments: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  status: TargetStatus;
  studentSupportPlanId: Scalars['Int']['output'];
  target: Scalars['String']['output'];
};

export enum StudentSupportPlanType {
  ClassRoom = 'CLASS_ROOM',
  School = 'SCHOOL',
  SchoolPlus = 'SCHOOL_PLUS'
}

export enum StudyLevel {
  Common = 'COMMON',
  Foundation = 'FOUNDATION',
  Higher = 'HIGHER',
  NotApplicable = 'NOT_APPLICABLE',
  Ordinary = 'ORDINARY'
}

export type SubTenantsFilter = {
  tenant: Scalars['Int']['input'];
};

export type Subject = {
  __typename?: 'Subject';
  active: Scalars['Boolean']['output'];
  colour?: Maybe<Colour>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  examinable: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  inUseHistorically: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameTextId?: Maybe<Scalars['Int']['output']>;
  nationalCode?: Maybe<Scalars['String']['output']>;
  shortCode: Scalars['String']['output'];
  shortCodeTextId?: Maybe<Scalars['Int']['output']>;
  subjectSource: SubjectSource;
};

export type SubjectFilter = {
  /** Only show subject which are currently in use. default HISTORIC */
  filterUsage?: InputMaybe<SubjectUsage>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SubjectGroup = Party & PartyGroup & {
  __typename?: 'SubjectGroup';
  academicNamespace?: Maybe<Scalars['Int']['output']>;
  /** name as stored in database */
  actualName: Scalars['String']['output'];
  alsoInAcademicNamespaces: Array<Scalars['Int']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  groupTagIds: Array<Scalars['Int']['output']>;
  groupTags: Array<GroupTag>;
  includeInTimetable?: Maybe<Scalars['Boolean']['output']>;
  irePP?: Maybe<SubjectGroupIrePp>;
  /** this will return the actual name or the subject depending on the user type. Contacts/Students -> Subject name eveeryone else -> actual name */
  name: Scalars['String']['output'];
  partyId: Scalars['Long']['output'];
  programmeStages: Array<ProgrammeStage>;
  sdsSyncTime?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<Core_PartySource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  staff: Array<Person>;
  /** deep linked */
  staffMembers?: Maybe<Group>;
  /** deep linked */
  studentMembers?: Maybe<Group>;
  studentMembershipType?: Maybe<SubjectGroupStudentMembershipType>;
  students: Array<Student>;
  subjectGroupType: SubjectGroupType;
  subjectIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** deep linked */
  subjects: Array<Subject>;
  yearGroups: Array<YearGroupEnrollment>;
};

export type SubjectGroupFilter = {
  groupTagIds: Array<Scalars['Int']['input']>;
  isIncludeInTimetabling?: InputMaybe<Scalars['Boolean']['input']>;
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  type?: InputMaybe<Array<SubjectGroupType>>;
};

export type SubjectGroupIrePp = {
  __typename?: 'SubjectGroupIrePP';
  examinable: Scalars['Boolean']['output'];
  level?: Maybe<StudyLevel>;
};

export type SubjectGroupMembershipTypeInput = {
  academicNamespaceId: Scalars['Int']['input'];
  blockId?: InputMaybe<Scalars['String']['input']>;
  classGroupId?: InputMaybe<Scalars['Long']['input']>;
  membershipType: SubjectGroupStudentMembershipTypeEnum;
};

export type SubjectGroupRelationshipFilter = {
  staffRoles?: InputMaybe<Array<StaffGroupMembershipRoles>>;
};

export type SubjectGroupStudent = {
  __typename?: 'SubjectGroupStudent';
  examinable: Scalars['Boolean']['output'];
  extensions?: Maybe<SubjectGroupStudentGraphqlExtension>;
  fromDate?: Maybe<Scalars['Date']['output']>;
  id: SubjectGroupStudentId;
  student: Student;
  studyLevel?: Maybe<StudyLevel>;
  toDate?: Maybe<Scalars['Date']['output']>;
};

export type SubjectGroupStudentFilter = {
  studentPartyIds: Array<Scalars['Long']['input']>;
  subjectGroupIds: Array<InputMaybe<Scalars['Long']['input']>>;
};

export type SubjectGroupStudentGraphqlExtension = {
  __typename?: 'SubjectGroupStudentGraphqlExtension';
  doNotUse?: Maybe<Scalars['String']['output']>;
  targets?: Maybe<Array<TargetGrade>>;
};

export type SubjectGroupStudentId = {
  __typename?: 'SubjectGroupStudentId';
  studentPartyId: Scalars['Long']['output'];
  subjectGroupId: Scalars['Long']['output'];
};

export type SubjectGroupStudentMembershipType = {
  __typename?: 'SubjectGroupStudentMembershipType';
  blockId?: Maybe<Scalars['String']['output']>;
  classGroupId?: Maybe<Scalars['Long']['output']>;
  classGroupName?: Maybe<Scalars['String']['output']>;
  type: SubjectGroupStudentMembershipTypeEnum;
};

export enum SubjectGroupStudentMembershipTypeEnum {
  Block = 'BLOCK',
  Core = 'CORE',
  Freeform = 'FREEFORM',
  Unknown = 'UNKNOWN'
}

export enum SubjectGroupType {
  SubjectGroup = 'SUBJECT_GROUP',
  SupportGroup = 'SUPPORT_GROUP'
}

export enum SubjectOptionsPrintFormat {
  Pdf = 'PDF',
  Word = 'WORD'
}

export enum SubjectSource {
  Custom = 'CUSTOM',
  National = 'NATIONAL'
}

export enum SubjectUsage {
  Active = 'ACTIVE',
  All = 'ALL',
  Historic = 'HISTORIC'
}

export type Success = {
  __typename?: 'Success';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SuccessFailure = {
  __typename?: 'SuccessFailure';
  error?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum SupportType {
  SupportForAll = 'SUPPORT_FOR_ALL',
  SupportForSome = 'SUPPORT_FOR_SOME',
  SupportPlus = 'SUPPORT_PLUS'
}

export type SwitchProfileInput = {
  globalUserId: Scalars['Int']['input'];
  partyId: Scalars['Long']['input'];
  requestedProfileId: Scalars['Int']['input'];
  tenant: Scalars['Int']['input'];
};

export type SyncRequest = {
  __typename?: 'SyncRequest';
  /** deep linked */
  createdBy: AuditPerson;
  createdByPartyId?: Maybe<Scalars['Long']['output']>;
  createdByUserId: Scalars['Int']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  requestedOn: Scalars['DateTime']['output'];
  /** deep linked */
  requester: Person;
  requesterPartyId: Scalars['Long']['output'];
  syncRequestStatus: SyncRequestStatus;
};

export enum SyncRequestStatus {
  Error = 'ERROR',
  Fail = 'FAIL',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type SyncRequestsFilter = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum SyncStatus {
  FailedSync = 'FAILED_SYNC',
  FullySynced = 'FULLY_SYNCED',
  NotSynced = 'NOT_SYNCED',
  PartiallySynced = 'PARTIALLY_SYNCED'
}

export type TtCloneTimetableInput = {
  /** defaults to true */
  cloneSourceTimetableAsReadOnlyReplica?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  timetableId: Scalars['Int']['input'];
  tyroOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TtCreate_TtUpsertLessons = {
  lessonIdx: Scalars['Int']['input'];
  periods?: InputMaybe<Array<TtUpsertLessonPeriod>>;
  sourceTimetableGroupId: Tt_SourceIdInput;
  spread: Scalars['Int']['input'];
  subjectGroupPartyId?: InputMaybe<Scalars['Long']['input']>;
};

export type TtEditLessonInstance = {
  id?: InputMaybe<TtEditLessonPeriodInstanceId>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  roomPoolId?: InputMaybe<Scalars['Int']['input']>;
  teachersPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  timeslot?: InputMaybe<TtEditLessonInstanceTimeslot>;
};

export type TtEditLessonInstanceTimeslot = {
  dayIdx: Scalars['Int']['input'];
  periodIdx: Scalars['Int']['input'];
};

export type TtEditLessonPeriodInstanceId = {
  lessonIdx: Scalars['Int']['input'];
  lessonInstanceIdx: Scalars['Int']['input'];
  timetableGroupId: Scalars['Long']['input'];
};

export type TtEditLessonPeriodInstanceWrapper = {
  allowClashes: Scalars['Boolean']['input'];
  lessonsInstances: Array<TtEditLessonInstance>;
  timetableId: Scalars['Int']['input'];
};

export type TtGrid = {
  __typename?: 'TTGrid';
  appliesToGroupTagIds: Array<Scalars['Int']['output']>;
  appliesToGroupTags: Array<GroupTag>;
  /** date grid is val from. null means the start of the calendar date */
  days: Array<TtGridDay>;
  description?: Maybe<Scalars['String']['output']>;
  idx: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  timetableId: Scalars['Int']['output'];
};

export type TtGridDay = {
  __typename?: 'TTGridDay';
  /** iso day of week. 1 monday .. 7 sunday */
  dayOfWeek: Scalars['Int']['output'];
  halfDayAfterPeriod: Scalars['Int']['output'];
  /** the distinct number and order for the days */
  idx: Scalars['Int']['output'];
  periods: Array<TtGridPeriod>;
};

export type TtGridFilter = {
  timetableId: Scalars['Int']['input'];
};

export type TtGridPeriod = {
  __typename?: 'TTGridPeriod';
  combined?: Maybe<TtGridPeriodCombined>;
  endTime: Scalars['Time']['output'];
  /** the distinct number and order for the periods */
  idx: Scalars['Int']['output'];
  lengthMinutes: Scalars['Int']['output'];
  meta: TtGridPeriodMeta;
  name: Scalars['String']['output'];
  /** periods are sequential with no gapes between them */
  startTime: Scalars['Time']['output'];
  type: TtGridPeriodType;
};

export type TtGridPeriodCombined = {
  __typename?: 'TTGridPeriodCombined';
  combinedWithIsPrimary: Scalars['Boolean']['output'];
  combinedWithPeriod?: Maybe<Scalars['Int']['output']>;
};

export type TtGridPeriodMeta = {
  __typename?: 'TTGridPeriodMeta';
  placementDisabled: Scalars['Boolean']['output'];
};

export enum TtGridPeriodType {
  Break = 'BREAK',
  Class = 'CLASS'
}

export enum TtGroupStudentMembershipTypeEnum {
  Block = 'BLOCK',
  Core = 'CORE',
  Freeform = 'FREEFORM',
  NoStudents = 'NO_STUDENTS'
}

/** View all lesson individually. i.e. a lesson with spread 2 will com back as 2 individual lessons */
export type TtIndividualViewLesson = {
  __typename?: 'TTIndividualViewLesson';
  /** the distinct number and order for the periods */
  id: TtIndividualViewLessonId;
  originalTeacherIds: Array<Scalars['Long']['output']>;
  partyGroup: PartyGroup;
  room?: Maybe<Room>;
  roomId?: Maybe<Scalars['Int']['output']>;
  roomPool?: Maybe<RoomPool>;
  roomPoolId?: Maybe<Scalars['Int']['output']>;
  roomState?: Maybe<Tt_FieldStatus>;
  schedulingStats?: Maybe<Tt_LessonSchedulingStats>;
  solverBlockGroup?: Maybe<Scalars['String']['output']>;
  spread: Scalars['Int']['output'];
  teacherIds: Array<Scalars['Long']['output']>;
  teacherState?: Maybe<Tt_FieldStatus>;
  teachers: Array<Staff>;
  timeslotId?: Maybe<TtTimeslotId>;
  timeslotInfo?: Maybe<TtTimeslotInfo>;
  timeslotState?: Maybe<Tt_FieldStatus>;
  timetableGroup: Tt_Groups;
};

export type TtIndividualViewLessonFilter = {
  groupTgs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lessonInstances?: InputMaybe<Array<TtEditLessonPeriodInstanceId>>;
  timeslots?: InputMaybe<Array<TtTimeslotIdInput>>;
  timetableGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  timetableId: Scalars['Int']['input'];
};

export type TtIndividualViewLessonId = {
  __typename?: 'TTIndividualViewLessonId';
  lessonIdx: Scalars['Int']['output'];
  lessonInstanceIdx: Scalars['Int']['output'];
  timetableGroupId: Scalars['Long']['output'];
};

export type TtPublishConstructionInput = {
  /** defaults to false. This will delete all existing timetable lessons in calendar and republish them */
  deleteAndFullRepublish?: InputMaybe<Scalars['Boolean']['input']>;
  /** used to publish specific lessons. Will only publish lessons that are in this list and not update the publish stats */
  publishType: TtPublishConstructionType;
  timetableId: Scalars['Int']['input'];
};

export enum TtPublishConstructionType {
  ClassGroupAndTimetableGroups = 'CLASS_GROUP_AND_TIMETABLE_GROUPS',
  ClassGroupOnly = 'CLASS_GROUP_ONLY',
  Full = 'FULL'
}

export type TtPublishDiff = {
  __typename?: 'TTPublishDiff';
  blockDiffs: Array<TtPublishDiffBlock>;
  classGroupDiffs: Array<TtPublishDiffClassGroup>;
  groupDiffs: Array<TtPublishDiffGroup>;
  lessonDiffs: Array<TtPublishDiffLesson>;
};

export type TtPublishDiffBlock = {
  __typename?: 'TTPublishDiffBlock';
  classGroupsChanged: Scalars['Boolean']['output'];
  nameChanged: Scalars['Boolean']['output'];
  newGroup: Tt_Block;
  oldGroup: Tt_Block;
  type: Tt_DiffType;
};

export type TtPublishDiffClassGroup = {
  __typename?: 'TTPublishDiffClassGroup';
  nameChanged: Scalars['Boolean']['output'];
  newGroup: Tt_ClassGroup;
  oldGroup: Tt_ClassGroup;
  type: Tt_DiffType;
};

export type TtPublishDiffGroup = {
  __typename?: 'TTPublishDiffGroup';
  blockIdChanged: Scalars['Boolean']['output'];
  classGroupIdChanged: Scalars['Boolean']['output'];
  groupTypeChanged: Scalars['Boolean']['output'];
  nameChanged: Scalars['Boolean']['output'];
  newGroup: Tt_Groups;
  oldGroup: Tt_Groups;
  studentMembershipTypeChanged: Scalars['Boolean']['output'];
  subjectChanged: Scalars['Boolean']['output'];
  tagsChanged: Scalars['Boolean']['output'];
  teachersChanged: Scalars['Boolean']['output'];
  type: Tt_DiffType;
};

export type TtPublishDiffLesson = {
  __typename?: 'TTPublishDiffLesson';
  newLesson: TtIndividualViewLesson;
  oldLesson: TtIndividualViewLesson;
  roomChanged: Scalars['Boolean']['output'];
  teachersChanged: Scalars['Boolean']['output'];
  timeslotChanged: Scalars['Boolean']['output'];
  type: Tt_DiffType;
};

export type TtPublishTimetableInput = {
  /** defaults to false. This will delete all existing timetable lessons in calendar and republish them */
  deleteAndFullRepublish?: InputMaybe<Scalars['Boolean']['input']>;
  /** date from which the timetable is valid. Defaults to tomorrow. Must not be today or before */
  effectiveFromDate?: InputMaybe<Scalars['Date']['input']>;
  /** used to publish specific lessons. Will only publish lessons that are in this list and not update the publish stats */
  republishLessonsInstances?: InputMaybe<Array<TtEditLessonPeriodInstanceId>>;
  timetableId: Scalars['Int']['input'];
};

export type TtResourceTimeslotView = {
  __typename?: 'TTResourceTimeslotView';
  lessons: Array<TtIndividualViewLesson>;
  timeslotIds?: Maybe<TtTimeslotId>;
  timeslots?: Maybe<TtTimeslotInfo>;
};

export type TtResourceTimetableSearchCriteria = {
  classGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  groupTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasNoRoom?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  roomIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  searchType: TtSearchType;
  staffIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  studentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subjectIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  timetableGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

/** View timetable resouces such as rooms , teachers and years */
export type TtResourceTimetableView = {
  __typename?: 'TTResourceTimetableView';
  timeslots: Array<TtResourceTimeslotView>;
};

export type TtResourceTimetableViewFilter = {
  criteria: TtResourceTimetableSearchCriteria;
  timetableId: Scalars['Int']['input'];
};

export enum TtSolve_Constraint {
  BlockBlockConflict = 'BLOCK_BLOCK_CONFLICT',
  BlockCoreConflict = 'BLOCK_CORE_CONFLICT',
  BlockGroupSameTimeConflict = 'BLOCK_GROUP_SAME_TIME_CONFLICT',
  ClassGroupConflict = 'CLASS_GROUP_CONFLICT',
  PinRoomPoolConflict = 'PIN_ROOM_POOL_CONFLICT',
  RoomConflict = 'ROOM_CONFLICT',
  RoomPoolConflict = 'ROOM_POOL_CONFLICT',
  SplittingDoublesConflict = 'SPLITTING_DOUBLES_CONFLICT',
  SpreadConflict = 'SPREAD_CONFLICT',
  SubjectGroupConflict = 'SUBJECT_GROUP_CONFLICT',
  SubjectGroupCoScheduleConflict = 'SUBJECT_GROUP_CO_SCHEDULE_CONFLICT',
  TeacherConflict = 'TEACHER_CONFLICT',
  TeacherWeeklyTime = 'TEACHER_WEEKLY_TIME'
}

export type TtSolve_SolverConfiguration = {
  globalConstraints: Array<TtSolve_ConfigurationConstraintInput>;
  minutesSpentlimit?: InputMaybe<Scalars['Int']['input']>;
  onlyRunForGroupTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** default 1 */
  parallelSolvers?: InputMaybe<Scalars['Int']['input']>;
  unimprovedMinutesSpentlimit?: InputMaybe<Scalars['Int']['input']>;
  useIncremental?: InputMaybe<Scalars['Boolean']['input']>;
  weightings?: InputMaybe<Array<TtSolve_WeightingInput>>;
};

export type TtSolve_WeightingInput = {
  id: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

export type TtSwapLessonsToSwap = {
  __typename?: 'TTSwapLessonsToSwap';
  lessons?: Maybe<Array<TtIndividualViewLesson>>;
};

export type TtSwapRoomFilter = {
  lessonToSwap: Array<TtEditLessonPeriodInstanceId>;
  timetableId: Scalars['Int']['input'];
};

export type TtSwapRoomOptions = {
  __typename?: 'TTSwapRoomOptions';
  rooms: Array<TtSwapRoomRoomInfo>;
  timeslots: Array<TtTimeslot>;
};

/** Lesson being held in room in the same order as the timeslots in TTSwapRoomView. If no lesson is held a null value is present */
export type TtSwapRoomRoomInfo = {
  __typename?: 'TTSwapRoomRoomInfo';
  lessonOnTimeslots: Array<TtSwapLessonsToSwap>;
  room: Room;
  roomId: Scalars['Int']['output'];
};

export type TtSwapRoomsInput = {
  swapFromLessonInstanceId: TtEditLessonPeriodInstanceId;
  swapToLessonInstanceId?: InputMaybe<TtEditLessonPeriodInstanceId>;
  /** timeslotId: TTTimeslotIdInput! @NotNull */
  swapToRoomId: Scalars['Int']['input'];
};

export type TtSwapTeacherFilter = {
  lessonToSwap: Array<TtEditLessonPeriodInstanceId>;
  timetableId: Scalars['Int']['input'];
};

export type TtSwapTeacherOptions = {
  __typename?: 'TTSwapTeacherOptions';
  teachers: Array<TtSwapTeacherTeacherInfo>;
  timeslots: Array<TtTimeslot>;
};

/** Lesson being held in room in the same order as the timeslots in TTSwapRoomView. If no lesson is held a null value is present */
export type TtSwapTeacherTeacherInfo = {
  __typename?: 'TTSwapTeacherTeacherInfo';
  lessonOnTimeslots: Array<TtSwapLessonsToSwap>;
  staffId: Scalars['Long']['output'];
  teacher: Staff;
};

export type TtSwapTeachersInput = {
  swapFromLessonInstanceId: TtEditLessonPeriodInstanceId;
  /** the staff id of the teacher on the source lesson. This is used in the case that the source lesson has multiple teachers */
  swapFromStaffId: Scalars['Long']['input'];
  swapToLessonInstanceId?: InputMaybe<TtEditLessonPeriodInstanceId>;
  /** this teacher will now become the new teacher of the source lesson */
  swapToStaffId: Scalars['Long']['input'];
};

export type TtSwapTimeslotFilter = {
  lessonToSwap: TtEditLessonPeriodInstanceId;
  timetableId: Scalars['Int']['input'];
};

/** Lesson being held in room in the same order as the timeslots in TTSwapRoomView. If no lesson is held a null value is present */
export type TtSwapTimeslotInfo = {
  __typename?: 'TTSwapTimeslotInfo';
  lesson: TtIndividualViewLesson;
  roomsClashes: Array<Tt_RoomClash>;
  teacherClashes: Array<Tt_TeacherClash>;
};

export type TtSwapTimeslotInput = {
  swapFromLessonInstanceId: TtEditLessonPeriodInstanceId;
  swapFromNewRoomId?: InputMaybe<Scalars['Int']['input']>;
  swapToLessonInstanceId: TtEditLessonPeriodInstanceId;
  swapToNewRoomId?: InputMaybe<Scalars['Int']['input']>;
};

export type TtSwapTimeslotOptions = {
  __typename?: 'TTSwapTimeslotOptions';
  lessons: Array<TtSwapTimeslotInfo>;
};

export type TtSwapsInput = {
  roomsSwaps?: InputMaybe<Array<TtSwapRoomsInput>>;
  teacherSwaps?: InputMaybe<Array<TtSwapTeachersInput>>;
  timeslotSwaps?: InputMaybe<Array<TtSwapTimeslotInput>>;
  timetableId: Scalars['Int']['input'];
};

export type TtTimeslot = {
  __typename?: 'TTTimeslot';
  id: TtTimeslotId;
  info: TtTimeslotInfo;
};

export type TtTimeslotId = {
  __typename?: 'TTTimeslotId';
  dayIdx: Scalars['Int']['output'];
  gridIdx: Scalars['Int']['output'];
  periodIdx: Scalars['Int']['output'];
};

export type TtTimeslotIdInput = {
  dayIdx: Scalars['Int']['input'];
  gridIdx: Scalars['Int']['input'];
  periodIdx: Scalars['Int']['input'];
};

export type TtTimeslotInfo = {
  __typename?: 'TTTimeslotInfo';
  combined?: Maybe<TtGridPeriodCombined>;
  dayOfWeek: Scalars['Int']['output'];
  endTime: Scalars['Time']['output'];
  meta: TtGridPeriodMeta;
  name: Scalars['String']['output'];
  periodType: TtGridPeriodType;
  startTime: Scalars['Time']['output'];
};

export type TtTimetable = {
  __typename?: 'TTTimetable';
  checkpointStatus?: Maybe<Tt_CheckpointStatus>;
  clonedAt?: Maybe<Scalars['DateTime']['output']>;
  clonedFromId?: Maybe<Scalars['Int']['output']>;
  clonedFromName?: Maybe<Scalars['Int']['output']>;
  constructionInfo: TtTimetableConstructionInfo;
  created: Scalars['DateTime']['output'];
  createdBy: AuditPerson;
  createdByPartyId: Scalars['Long']['output'];
  createdByUserId: Scalars['Int']['output'];
  /** deeplinked */
  liveStatus?: Maybe<Tt_LiveStatus>;
  liveTimetable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pbac: Pbac_ResourceResult;
  readOnly: Scalars['Boolean']['output'];
  readOnlyReplicaAtCreationId: Scalars['Int']['output'];
  timetableId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: AuditPerson;
  updatedByPartyId: Scalars['Long']['output'];
  updatedByUserId: Scalars['Int']['output'];
};

export type TtTimetableConstructionInfo = {
  __typename?: 'TTTimetableConstructionInfo';
  classGroupsPublished?: Maybe<Scalars['DateTime']['output']>;
  fullPublish?: Maybe<Scalars['DateTime']['output']>;
  timetableGroupsPublished?: Maybe<Scalars['DateTime']['output']>;
};

export type TtTimetableFilter = {
  /** the live timetable in timetable edit with unpublished changed */
  liveTimetable?: InputMaybe<Scalars['Boolean']['input']>;
  /** the last published version of the timetable */
  publishedTimetable?: InputMaybe<Scalars['Boolean']['input']>;
  timetableId?: InputMaybe<Scalars['Int']['input']>;
};

export type TtTimetableListFilter = {
  excludeLive?: InputMaybe<Scalars['Boolean']['input']>;
  excludeReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  timetableIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TtUpsertGrid = {
  appliesToGroupTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  days?: InputMaybe<Array<InputMaybe<TtUpsertGridDay>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  idx: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  timetableId: Scalars['Int']['input'];
  /** date grid is val from. null means the start of the calendar date */
  validFrom?: InputMaybe<Scalars['Date']['input']>;
};

export type TtUpsertGridDay = {
  /** iso day of week. 1 monday .. 7 sunday */
  dayOfWeek: Scalars['Int']['input'];
  halfDayAfterPeriod: Scalars['Int']['input'];
  /** the distinct number and order for the days */
  idx: Scalars['Int']['input'];
  periods: Array<TtUpsertGridPeriod>;
};

export type TtUpsertGridPeriod = {
  endTime: Scalars['Time']['input'];
  /** the distinct number and order for the periods */
  idx: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  /** periods are sequential with no gapes between them */
  startTime: Scalars['Time']['input'];
  type: TtGridPeriodType;
};

export type TtUpsertGrids = {
  grids: Array<TtUpsertGrid>;
  timetableId: Scalars['Int']['input'];
};

export type TtUpsertLessonPeriod = {
  dayIdx?: InputMaybe<Scalars['Int']['input']>;
  gridIdx: Scalars['Int']['input'];
  lessonPeriodIdx: Scalars['Int']['input'];
  periodIdx: Scalars['Int']['input'];
  roomId?: InputMaybe<Scalars['Int']['input']>;
  roomPoolId?: InputMaybe<Scalars['Int']['input']>;
  teachersPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Tt_AttachClassGroupPairInput = {
  classGroupPartyId: Scalars['Long']['input'];
  confirmOverwrite: Scalars['Boolean']['input'];
  ttClassGroupId: Scalars['Long']['input'];
};

export type Tt_AttachClassGroupResult = {
  __typename?: 'TT_AttachClassGroupResult';
  classGroupPartyId: Scalars['Long']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: Tt_AttachClassGroupStatus;
  ttClassGroupId: Scalars['Long']['output'];
};

export enum Tt_AttachClassGroupStatus {
  Conflict = 'CONFLICT',
  Error = 'ERROR',
  MemberBlock = 'MEMBER_BLOCK',
  NoMatch = 'NO_MATCH',
  Ok = 'OK'
}

export type Tt_AttachClassGroupsResult = {
  __typename?: 'TT_AttachClassGroupsResult';
  results: Array<Tt_AttachClassGroupResult>;
};

export type Tt_AttachClassGroupsToTimetableInput = {
  pairs: Array<Tt_AttachClassGroupPairInput>;
};

export type Tt_Block = {
  __typename?: 'TT_Block';
  blockId: Scalars['String']['output'];
  /** deep linked */
  classGroups: Array<Tt_ClassGroup>;
  groupTagIds: Array<Scalars['Int']['output']>;
  groupTags: Array<GroupTag>;
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  /** deep linked */
  timetableGroups: Array<Tt_Groups>;
  ttClassGroupIds: Array<Scalars['Long']['output']>;
  ttTimetableGroupsIds: Array<Scalars['Long']['output']>;
};

export type Tt_BlockFilter = {
  blockIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  classGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  groupTags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_CheckPointHistory = {
  __typename?: 'TT_CheckPointHistory';
  checkpointName: Scalars['String']['output'];
  checkpointTimetableId: Scalars['Int']['output'];
  createdOn: Scalars['DateTime']['output'];
};

export type Tt_CheckpointStatus = {
  __typename?: 'TT_CheckpointStatus';
  checkpointTimetableId: Scalars['Int']['output'];
  checkpoints: Array<Tt_CheckPointHistory>;
  lastCheckpointDate?: Maybe<Scalars['DateTime']['output']>;
  lessonChanges: Scalars['Int']['output'];
  timetableGroupChanges: Scalars['Int']['output'];
  totalChanges: Scalars['Int']['output'];
};

export type Tt_ClassGroup = {
  __typename?: 'TT_ClassGroup';
  code: Scalars['String']['output'];
  groupTagIds: Array<Scalars['Int']['output']>;
  groupTags: Array<GroupTag>;
  /** partyGroup: PartyGroup! */
  name: Scalars['String']['output'];
  partyId?: Maybe<Scalars['Long']['output']>;
  source?: Maybe<Tt_SourceId>;
  ttClassGroupId: Scalars['Long']['output'];
};

export type Tt_ClassGroupRolloverView = {
  __typename?: 'TT_ClassGroupRolloverView';
  currentClassGroups: Array<Tt_ClassGroup>;
  currentTimetableId: Scalars['Int']['output'];
  previousAcademicNamespaceId?: Maybe<Scalars['Int']['output']>;
  previousClassGroups: Array<Tt_ClassGroup>;
  previousTimetableId?: Maybe<Scalars['Int']['output']>;
};

export type Tt_ClassGroupRolloverViewFilter = {
  timetableId: Scalars['Int']['input'];
};

export type Tt_ClassGroupsFilter = {
  groupTags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timetableId: Scalars['Int']['input'];
  ttClassGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

/** A set of timetable groups that are co-scheduled together (timetabled in the same slot). Order is not meaningful. */
export type Tt_CoScheduleChain = {
  __typename?: 'TT_CoScheduleChain';
  chainId: Scalars['String']['output'];
  groups: Array<Tt_Groups>;
};

export type Tt_CoScheduleChainInput = {
  /** Group ids in co-schedule order, head to tail. Each group may appear in at most one chain. */
  timetableGroupIds: Array<Scalars['Long']['input']>;
};

export type Tt_CoScheduleChainsFilter = {
  timetableId: Scalars['Int']['input'];
};

export enum Tt_DeleteClassGroups_DeleteTimetableGroupMode {
  Delete = 'DELETE',
  DoNotDelete = 'DO_NOT_DELETE'
}

export type Tt_DeleteTimetables = {
  deleteReadOnlyBackUps?: InputMaybe<Scalars['Boolean']['input']>;
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
  timetableIds: Array<Scalars['Int']['input']>;
};

export type Tt_Diff = {
  __typename?: 'TT_Diff';
  blockDiffs: Array<TtPublishDiffBlock>;
  classGroupDiffs: Array<TtPublishDiffClassGroup>;
  compareToTimetableId: Scalars['Int']['output'];
  groupDiffs: Array<TtPublishDiffGroup>;
  lessonChanges: Scalars['Int']['output'];
  lessonDiffs: Array<TtPublishDiffLesson>;
  sourceTimetableId: Scalars['Int']['output'];
  timetableGroupChanges: Scalars['Int']['output'];
  totalChanges: Scalars['Int']['output'];
};

export enum Tt_DiffType {
  Deleted = 'DELETED',
  New = 'NEW',
  Updated = 'UPDATED'
}

export enum Tt_FieldStatus {
  Pinned = 'PINNED',
  SolverSet = 'SOLVER_SET',
  UserSet = 'USER_SET'
}

export type Tt_GroupTagsUsed = {
  text?: InputMaybe<Scalars['String']['input']>;
  timetableId: Scalars['Int']['input'];
};

export enum Tt_GroupType {
  CustomGroup = 'CUSTOM_GROUP',
  NonStudent = 'NON_STUDENT',
  SubjectGroup = 'SUBJECT_GROUP',
  SupportGroup = 'SUPPORT_GROUP'
}

export type Tt_Groups = {
  __typename?: 'TT_Groups';
  allowAutoTeacherSwaps: Scalars['Boolean']['output'];
  blockId?: Maybe<Scalars['String']['output']>;
  blockIdx?: Maybe<Scalars['Int']['output']>;
  classGroupId?: Maybe<Scalars['Long']['output']>;
  coScheduleTtGroup?: Maybe<Tt_Groups>;
  coScheduleTtGroupId?: Maybe<Scalars['Long']['output']>;
  groupTag: Array<GroupTag>;
  groupTagIds: Array<Scalars['Int']['output']>;
  groupType: Tt_GroupType;
  lessonCount: Scalars['Int']['output'];
  lessons: Array<TtIndividualViewLesson>;
  maxClassSize: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  partyGroup?: Maybe<PartyGroup>;
  partyId?: Maybe<Scalars['Long']['output']>;
  room?: Maybe<Room>;
  roomId?: Maybe<Scalars['Int']['output']>;
  roomPool?: Maybe<RoomPool>;
  roomPoolId?: Maybe<Scalars['Int']['output']>;
  roomState?: Maybe<Tt_FieldStatus>;
  source?: Maybe<Tt_SourceId>;
  spread: Array<Scalars['Int']['output']>;
  studentMembershipType: TtGroupStudentMembershipTypeEnum;
  subject?: Maybe<Subject>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  teacherState?: Maybe<Tt_FieldStatus>;
  teachers: Array<Staff>;
  teachersIds: Array<Scalars['Long']['output']>;
  timetableGroupId: Scalars['Long']['output'];
  totalLessonNoSpread?: Maybe<Scalars['Int']['output']>;
};

export type Tt_GroupsFilter = {
  groupTags: Array<Scalars['Int']['input']>;
  groupTypes?: InputMaybe<Array<Tt_GroupType>>;
  inBlockOrCore?: InputMaybe<Tt_GroupsFilter_InBlockOrCore>;
  membershipTypeFilter?: InputMaybe<Array<TtGroupStudentMembershipTypeEnum>>;
  timetableGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_GroupsFilter_InBlockOrCore = {
  blockIds?: InputMaybe<Array<Scalars['String']['input']>>;
  classGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Tt_GroupsRoom = {
  __typename?: 'TT_GroupsRoom';
  id: Scalars['Int']['output'];
  room?: Maybe<Room>;
  type?: Maybe<Tt_RoomOrPool>;
};

export type Tt_Groups_ClassData = {
  __typename?: 'TT_Groups_ClassData';
  groups: Array<Tt_Groups>;
  isStack: Scalars['Boolean']['output'];
};

export type Tt_LessonSchedulingStats = {
  __typename?: 'TT_LessonSchedulingStats';
  brokenAllConstraints?: Maybe<Scalars['Int']['output']>;
  brokenFeasibility?: Maybe<Scalars['Int']['output']>;
  brokenSpreadOnly?: Maybe<Scalars['Int']['output']>;
};

export type Tt_LiveStatus = {
  __typename?: 'TT_LiveStatus';
  lastPublishedDate?: Maybe<Scalars['DateTime']['output']>;
  lessonChanges: Scalars['Int']['output'];
  publishDiff?: Maybe<TtPublishDiff>;
  publishHistory: Array<Tt_Published>;
  timetableGroupChanges: Scalars['Int']['output'];
  timetableId: Scalars['Int']['output'];
  totalChanges: Scalars['Int']['output'];
};

export type Tt_LiveTimetableClassGroupsFilter = {
  classGroupPartyIds: Array<Scalars['Long']['input']>;
};

export type Tt_PublishChange = {
  __typename?: 'TT_PublishChange';
  changeType: Tt_DiffType;
  changedByName?: Maybe<Scalars['String']['output']>;
  changedByPartyId?: Maybe<Scalars['Long']['output']>;
  changedFields: Array<Tt_PublishFieldChange>;
  entityId: Scalars['String']['output'];
  entityType: Tt_PublishChangeEntityType;
  name: Scalars['String']['output'];
};

export enum Tt_PublishChangeEntityType {
  Block = 'BLOCK',
  ClassGroup = 'CLASS_GROUP',
  Group = 'GROUP',
  Lesson = 'LESSON'
}

export type Tt_PublishConstructionResult = {
  __typename?: 'TT_PublishConstructionResult';
  success: Scalars['Boolean']['output'];
};

export type Tt_PublishFieldChange = {
  __typename?: 'TT_PublishFieldChange';
  field: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type Tt_PublishResult = {
  __typename?: 'TT_PublishResult';
  lessonsUpdated: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  teachingGroupsUpdated: Scalars['Int']['output'];
};

export type Tt_Published = {
  __typename?: 'TT_Published';
  /** Who changed what in this publish, snapshotted at publish time (partial publish only). */
  changes: Array<Tt_PublishChange>;
  cloneId: Scalars['Int']['output'];
  datetime: Scalars['DateTime']['output'];
  lessonChanges: Scalars['Int']['output'];
  publishedByName?: Maybe<Scalars['String']['output']>;
  /** Who published, snapshotted at publish time (partial publish only). */
  publishedByPartyId?: Maybe<Scalars['Long']['output']>;
  readOnlyReplicaOfTimetableCreationBeforeChanges: Scalars['Int']['output'];
  timetableGroupChanges: Scalars['Int']['output'];
  timetableId: Scalars['Int']['output'];
};

export type Tt_Reset = {
  blocks?: InputMaybe<Array<Tt_ResetBlock>>;
  classGroups?: InputMaybe<Array<Tt_ResetClassGroup>>;
  groups?: InputMaybe<Array<Tt_ResetGroup>>;
  lessons?: InputMaybe<Array<Tt_ResetLesson>>;
  /** default to the read only at creation tt */
  resetAgainstTimetableId?: InputMaybe<Scalars['Int']['input']>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_ResetBlock = {
  blockId: Scalars['String']['input'];
};

export type Tt_ResetClassGroup = {
  ttClassGroupId: Scalars['Long']['input'];
};

export type Tt_ResetGroup = {
  timetableGroupPartyId: Scalars['Long']['input'];
};

export type Tt_ResetLesson = {
  lessonId: TtEditLessonPeriodInstanceId;
};

export type Tt_RolloverAutoMatch = {
  __typename?: 'TT_RolloverAutoMatch';
  classGroupMatches: Array<Tt_RolloverClassGroupMatch>;
  subjectGroupMatches: Array<Tt_RolloverGroupMatch>;
};

export type Tt_RolloverAutoMatchFilter = {
  timetableId: Scalars['Int']['input'];
};

export type Tt_RolloverClassGroupMatch = {
  __typename?: 'TT_RolloverClassGroupMatch';
  previousYearClassGroupPartyId: Scalars['Long']['output'];
  ttClassGroupId: Scalars['Long']['output'];
};

/**
 * Suggested previous-year rollover sources for the current timetable's groups, derived from
 * naming/programme-stage/teacher conventions. Powers the "auto-populate" action; only confident
 * matches are returned so the UI can stage them for review.
 */
export type Tt_RolloverGroupMatch = {
  __typename?: 'TT_RolloverGroupMatch';
  previousYearTimetableGroupPartyId: Scalars['Long']['output'];
  timetableGroupId: Scalars['Long']['output'];
};

/**
 * A programme-stage rollover transition (current-year stage -> next-year stage).
 * Only stages that actually roll over (RolloverUtils.rolloverProgStage) and are not
 * discontinued for the current school are returned. Drives the rollover table filter.
 */
export type Tt_RolloverProgrammeStage = {
  __typename?: 'TT_RolloverProgrammeStage';
  from: GroupTag;
  fromProgrammeStageTagId: Scalars['Int']['output'];
  to: GroupTag;
  toProgrammeStageTagId: Scalars['Int']['output'];
};

export type Tt_RolloverProgrammeStagesFilter = {
  timetableId: Scalars['Int']['input'];
};

export enum Tt_RolloverScheduleGroupType {
  Freeform = 'FREEFORM',
  NonTeaching = 'NON_TEACHING',
  PlcProgrammeStage = 'PLC_PROGRAMME_STAGE'
}

export type Tt_RoomClash = {
  __typename?: 'TT_RoomClash';
  lesson: TtIndividualViewLesson;
  room: Room;
  roomId: Scalars['Int']['output'];
};

export enum Tt_RoomOrPool {
  Pool = 'POOL',
  Room = 'ROOM'
}

export type Tt_SearchFilter = {
  text?: InputMaybe<Scalars['String']['input']>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_SetTimetableClassGroupRolloverSourceRow = {
  /** the previous-year TT_ClassGroup partyId to link as the rollover source; null clears the link */
  previousYearClassGroupPartyId?: InputMaybe<Scalars['Long']['input']>;
  ttClassGroupId: Scalars['Long']['input'];
};

export type Tt_SetTimetableGroupRolloverSourceRow = {
  /** the previous-year TT_Groups partyId to link as the rollover source; null clears the link */
  previousYearTimetableGroupPartyId?: InputMaybe<Scalars['Long']['input']>;
  timetableGroupId: Scalars['Long']['input'];
};

export type Tt_SetTimetableGroupRolloverSourcesInput = {
  classGroupUpdates?: InputMaybe<Array<Tt_SetTimetableClassGroupRolloverSourceRow>>;
  timetableId: Scalars['Int']['input'];
  updates?: InputMaybe<Array<Tt_SetTimetableGroupRolloverSourceRow>>;
};

export enum Tt_SolverStatus {
  Error = 'ERROR',
  NotSolving = 'NOT_SOLVING',
  SolvingActive = 'SOLVING_ACTIVE',
  SolvingScheduled = 'SOLVING_SCHEDULED'
}

export type Tt_SourceId = {
  __typename?: 'TT_SourceId';
  id: Scalars['String']['output'];
  source: Tt_DataSource;
};

export type Tt_SourceIdInput = {
  id: Scalars['String']['input'];
  source: Tt_DataSource;
};

export type Tt_SubjectGroupRolloverView = {
  __typename?: 'TT_SubjectGroupRolloverView';
  currentGroups: Array<Tt_Groups>;
  currentTimetableId: Scalars['Int']['output'];
  previousAcademicNamespaceId?: Maybe<Scalars['Int']['output']>;
  previousGroups: Array<Tt_Groups>;
  previousTimetableId?: Maybe<Scalars['Int']['output']>;
};

export type Tt_SubjectGroupRolloverViewFilter = {
  timetableId: Scalars['Int']['input'];
};

export type Tt_TeacherClash = {
  __typename?: 'TT_TeacherClash';
  lesson: TtIndividualViewLesson;
  teacher: Staff;
  teacherId: Scalars['Long']['output'];
};

export type Tt_TeacherTimetableSummary = {
  __typename?: 'TT_TeacherTimetableSummary';
  fulltimePeriods: Scalars['Int']['output'];
  staffId: Scalars['Long']['output'];
};

export type Tt_TeacherTimetableSummaryFilter = {
  staffIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  timetableFilter: TtTimetableFilter;
};

export type Tt_UpdateClassGroupInput = {
  timetableId: Scalars['Int']['input'];
  updates: Array<Tt_UpdateClassGroupRowInput>;
};

export type Tt_UpdateClassGroupRowInput = {
  groupTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  partyId?: InputMaybe<Scalars['Long']['input']>;
  ttClassGroupId: Scalars['Long']['input'];
};

export type Tt_UpdateTimetableGroupInput = {
  alsoUpdateLessonTeachers?: InputMaybe<Scalars['Boolean']['input']>;
  timetableId: Scalars['Int']['input'];
  updates: Array<Tt_UpdateTimetableGroupRowInput>;
};

export type Tt_UpdateTimetableGroupRowInput = {
  allowAutoTeacherSwaps?: InputMaybe<Scalars['Boolean']['input']>;
  blockId?: InputMaybe<Scalars['String']['input']>;
  classGroupId?: InputMaybe<Scalars['Long']['input']>;
  coScheduleTtGroupId?: InputMaybe<Scalars['Long']['input']>;
  groupTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  groupType?: InputMaybe<Tt_GroupType>;
  membershipType?: InputMaybe<TtGroupStudentMembershipTypeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  pinRoom?: InputMaybe<Scalars['Boolean']['input']>;
  pinTeachers?: InputMaybe<Scalars['Boolean']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  roomPoolId?: InputMaybe<Scalars['Int']['input']>;
  spread?: InputMaybe<Array<Scalars['Int']['input']>>;
  subjectId?: InputMaybe<Scalars['Int']['input']>;
  teachersPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  timetableGroupId: Scalars['Long']['input'];
};

/** Replaces the full set of co-schedule chains for a timetable. Any group not present in a chain has its co-schedule link cleared. */
export type Tt_UpsertCoScheduleChainsInput = {
  chains: Array<Tt_CoScheduleChainInput>;
  timetableId: Scalars['Int']['input'];
};

export type TargetGrade = {
  __typename?: 'TargetGrade';
  partyId: Scalars['Long']['output'];
  subjectId: Scalars['Int']['output'];
  targetGradeSetGrade?: Maybe<Grade>;
  targetGradeSetGradeId?: Maybe<Scalars['Long']['output']>;
  targetResult?: Maybe<Scalars['Int']['output']>;
};

export type TargetGradeFilter = {
  partyIds: Array<Scalars['Long']['input']>;
};

export enum TargetStatus {
  Achieved = 'ACHIEVED',
  InProgress = 'IN_PROGRESS',
  NotAchieved = 'NOT_ACHIEVED',
  NotApplicable = 'NOT_APPLICABLE'
}

export type Tasks_CancelTaskInput = {
  executionId: Scalars['String']['input'];
};

export type Tasks_MyTasksFilter = {
  executionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  handlerName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<Scheduling_JobStatus>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Tasks_TaskExecution = {
  __typename?: 'Tasks_TaskExecution';
  durationMs?: Maybe<Scalars['Long']['output']>;
  exceptionMessage?: Maybe<Scalars['String']['output']>;
  executionId: Scalars['String']['output'];
  failCount: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  handlerName: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scheduling_JobStatus;
  submittedAt: Scalars['DateTime']['output'];
  successCount: Scalars['Int']['output'];
  taskResults: Array<Scheduling_TaskResult>;
};

export type Tasks_TaskExecutionFilter = {
  executionId: Scalars['String']['input'];
};

export enum TemplateFormat {
  Docx = 'DOCX',
  Html = 'HTML'
}

export enum TemplateType {
  Csv = 'CSV',
  Label = 'LABEL',
  Pdf = 'PDF'
}

export enum TemplatingArea {
  Assessment = 'ASSESSMENT',
  Letter = 'LETTER',
  Mail = 'MAIL',
  Sms = 'SMS'
}

export enum TemplatingContextType {
  Assessment = 'ASSESSMENT',
  Contact = 'CONTACT',
  Person = 'PERSON',
  Sms = 'SMS',
  Staff = 'STAFF',
  Student = 'STUDENT'
}

export type Templating_DeleteLabelTemplateInput = {
  ids: Array<Scalars['Long']['input']>;
};

export type Templating_DeleteSavedVariableTemplateInput = {
  ids: Array<Scalars['Long']['input']>;
};

export type Templating_DeleteTemplateInput = {
  ids: Array<Scalars['Long']['input']>;
};

export type Templating_DemoLabelTemplate = {
  __typename?: 'Templating_DemoLabelTemplate';
  html?: Maybe<Scalars['String']['output']>;
};

export type Templating_DemoLabelTemplateInput = {
  fontSize?: InputMaybe<Scalars['Int']['input']>;
  labelType?: InputMaybe<LabelSizeType>;
  paddingBottom?: InputMaybe<Scalars['BigDecimal']['input']>;
  paddingColumn?: InputMaybe<Scalars['BigDecimal']['input']>;
  paddingLeft?: InputMaybe<Scalars['BigDecimal']['input']>;
  paddingRight?: InputMaybe<Scalars['BigDecimal']['input']>;
  paddingRow?: InputMaybe<Scalars['BigDecimal']['input']>;
  paddingTop?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type Templating_LabelTemplate = {
  __typename?: 'Templating_LabelTemplate';
  defaultTemplate?: Maybe<Scalars['Boolean']['output']>;
  fontSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Long']['output'];
  labelType?: Maybe<LabelSizeType>;
  name: Scalars['String']['output'];
  paddingBottom?: Maybe<Scalars['BigDecimal']['output']>;
  paddingColumn?: Maybe<Scalars['BigDecimal']['output']>;
  paddingLeft?: Maybe<Scalars['BigDecimal']['output']>;
  paddingRight?: Maybe<Scalars['BigDecimal']['output']>;
  paddingRow?: Maybe<Scalars['BigDecimal']['output']>;
  paddingTop?: Maybe<Scalars['BigDecimal']['output']>;
};

export type Templating_LabelTemplateFilter = {
  ids?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Templating_Page = {
  __typename?: 'Templating_Page';
  id: Scalars['Long']['output'];
  page: Scalars['String']['output'];
  secondaryId?: Maybe<Scalars['Long']['output']>;
};

export type Templating_PrintTemplate = {
  __typename?: 'Templating_PrintTemplate';
  page?: Maybe<Scalars['String']['output']>;
  pages?: Maybe<Array<Maybe<Templating_Page>>>;
  type?: Maybe<PrintType>;
};

export type Templating_ResolveDataTemplateInput = {
  area: TemplatingArea;
  context: TemplatingContextType;
  order?: InputMaybe<Array<Templating_ResolveTemplateOrderingInput>>;
  partyIds: Array<Scalars['Long']['input']>;
  templateType: TemplateType;
  variables: Array<Scalars['String']['input']>;
};

export type Templating_ResolveLabelTemplateInput = {
  area: TemplatingArea;
  context: TemplatingContextType;
  fontSize?: InputMaybe<Scalars['Int']['input']>;
  labelId?: InputMaybe<Scalars['Long']['input']>;
  order?: InputMaybe<Array<Templating_ResolveTemplateOrderingInput>>;
  partyIds: Array<Scalars['Long']['input']>;
  variables: Array<Scalars['String']['input']>;
};

export type Templating_ResolveTemplateInput = {
  area: TemplatingArea;
  assessmentId?: InputMaybe<Scalars['Long']['input']>;
  context: TemplatingContextType;
  docxFileTransferId?: InputMaybe<Scalars['Long']['input']>;
  format?: InputMaybe<TemplateFormat>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<Templating_ResolveTemplateOrderingInput>>;
  outputFormat?: InputMaybe<OutputFormat>;
  overrideValidations?: InputMaybe<Scalars['Boolean']['input']>;
  partyIds: Array<Scalars['Long']['input']>;
  printType?: InputMaybe<PrintType>;
  printUnique?: InputMaybe<Scalars['Boolean']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['Long']['input']>;
  useBaseTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  useSecondaryIds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Templating_ResolveTemplateOrderingInput = {
  direction: OrderingDirection;
  order: Scalars['Int']['input'];
  variable: Scalars['String']['input'];
};

export type Templating_ResolvedTemplate = {
  __typename?: 'Templating_ResolvedTemplate';
  html?: Maybe<Scalars['String']['output']>;
  temporaryUrl?: Maybe<Scalars['String']['output']>;
};

export type Templating_SaveTemplateInput = {
  area: TemplatingArea;
  context: TemplatingContextType;
  docxFileTransferId?: InputMaybe<Scalars['Long']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<TemplateFormat>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  template?: InputMaybe<Scalars['String']['input']>;
};

export type Templating_SavedVariableTemplate = {
  __typename?: 'Templating_SavedVariableTemplate';
  id: Scalars['Long']['output'];
  labelTemplate?: Maybe<Templating_LabelTemplate>;
  name: Scalars['String']['output'];
  templateType: TemplateType;
  variables: Array<Templating_Variable>;
};

export type Templating_SavedVariableTemplateFilter = {
  ids?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Templating_Template = {
  __typename?: 'Templating_Template';
  area: TemplatingArea;
  context: TemplatingContextType;
  createdBy?: Maybe<Staff>;
  createdByPartyId?: Maybe<Scalars['Long']['output']>;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  docxFileName?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<Scalars['Boolean']['output']>;
  format?: Maybe<TemplateFormat>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
};

export type Templating_TemplateFilter = {
  area?: InputMaybe<TemplatingArea>;
  context?: InputMaybe<TemplatingContextType>;
  ids?: InputMaybe<Array<Scalars['Long']['input']>>;
};

/** TODO - add range for padding and font size */
export type Templating_UpsertLabelTemplateInput = {
  fontSize: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Long']['input']>;
  labelType: LabelSizeType;
  name: Scalars['String']['input'];
  paddingBottom: Scalars['BigDecimal']['input'];
  paddingColumn: Scalars['BigDecimal']['input'];
  paddingLeft: Scalars['BigDecimal']['input'];
  paddingRight: Scalars['BigDecimal']['input'];
  paddingRow: Scalars['BigDecimal']['input'];
  paddingTop: Scalars['BigDecimal']['input'];
};

export type Templating_UpsertSavedVariableTemplateInput = {
  id?: InputMaybe<Scalars['Long']['input']>;
  labelId?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  templateType: TemplateType;
  variableIds: Array<Scalars['Long']['input']>;
};

export type Templating_Variable = {
  __typename?: 'Templating_Variable';
  category?: Maybe<Scalars['String']['output']>;
  context: TemplatingContextType;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  nested: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type Templating_VariablesFilter = {
  context?: InputMaybe<TemplatingContextType>;
  ids?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type TemporaryDownload = {
  __typename?: 'TemporaryDownload';
  html?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  description: Scalars['String']['output'];
  eircode?: Maybe<Scalars['String']['output']>;
  goLiveOn?: Maybe<Scalars['Date']['output']>;
  imgUrl?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['BigDecimal']['output']>;
  liveSchool: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['BigDecimal']['output']>;
  name: Scalars['String']['output'];
  organizationTenant?: Maybe<Scalars['String']['output']>;
  rollNo?: Maybe<Scalars['String']['output']>;
  subTenants?: Maybe<Array<Scalars['Int']['output']>>;
  tenant: Scalars['Int']['output'];
  tenantType: TenantType;
  type?: Maybe<Scalars['String']['output']>;
};

export type TenantSetting = {
  __typename?: 'TenantSetting';
  activeAcademicNamesapce: Scalars['Int']['output'];
  tenant: Scalars['Int']['output'];
};

export enum TenantType {
  Organization = 'ORGANIZATION',
  School = 'SCHOOL'
}

export type TenantsFilter = {
  tenantType?: InputMaybe<TenantType>;
  tenants?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ThirdPartyEventAttendanceInput = {
  adminSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  attendanceCodeId: Scalars['Int']['input'];
  date: Scalars['Date']['input'];
  eventId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  personPartyId: Scalars['Long']['input'];
};

export type ThirdPartySessionAttendanceInput = {
  adminSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  attendanceCodeId: Scalars['Int']['input'];
  bellTimeId: Scalars['Int']['input'];
  date: Scalars['Date']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  studentPartyId: Scalars['Long']['input'];
};

export enum ThirdPartyUserType {
  Anseo = 'ANSEO',
  Athena = 'ATHENA',
  Docs = 'DOCS',
  Interleaf = 'INTERLEAF',
  Schoolwise = 'SCHOOLWISE',
  Test = 'TEST',
  Uniqueschools = 'UNIQUESCHOOLS',
  Wonde = 'WONDE'
}

export type Time_SaveHighlightEvent = {
  eventId: Scalars['String']['input'];
  eventType: Timeline_EventType;
};

export type Timeline_EventMeta = {
  type?: Maybe<Timeline_EventType>;
};

export type Timeline_EventMeta_Absent = Timeline_EventMeta & {
  __typename?: 'Timeline_EventMeta_Absent';
  note?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Time']['output']>;
  type?: Maybe<Timeline_EventType>;
};

export type Timeline_EventMeta_Behaviour = Timeline_EventMeta & {
  __typename?: 'Timeline_EventMeta_Behaviour';
  behaviourType?: Maybe<Notes_BehaviourType>;
  colour?: Maybe<Colour>;
  tag?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Timeline_EventType>;
};

export type Timeline_EventMeta_Late = Timeline_EventMeta & {
  __typename?: 'Timeline_EventMeta_Late';
  note?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Time']['output']>;
  type?: Maybe<Timeline_EventType>;
};

export type Timeline_EventMeta_Note = Timeline_EventMeta & {
  __typename?: 'Timeline_EventMeta_Note';
  colour?: Maybe<Colour>;
  tag?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Timeline_EventType>;
};

export type Timeline_EventMeta_SignInOut = Timeline_EventMeta & {
  __typename?: 'Timeline_EventMeta_SignInOut';
  note?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Time']['output']>;
  type?: Maybe<Timeline_EventType>;
};

export type Timeline_EventMeta_StudentDocs = Timeline_EventMeta & {
  __typename?: 'Timeline_EventMeta_StudentDocs';
  link: Scalars['String']['output'];
  type?: Maybe<Timeline_EventType>;
};

export enum Timeline_EventType {
  Absent = 'ABSENT',
  BehaviourNegative = 'BEHAVIOUR_NEGATIVE',
  BehaviourNeutral = 'BEHAVIOUR_NEUTRAL',
  BehaviourPositive = 'BEHAVIOUR_POSITIVE',
  Doc = 'DOC',
  Form = 'FORM',
  Late = 'LATE',
  Note = 'NOTE',
  PriorityNote = 'PRIORITY_NOTE',
  SignInOut = 'SIGN_IN_OUT'
}

export type Timeline_Highlight = {
  __typename?: 'Timeline_Highlight';
  assignedToParties: Array<Party>;
  assignedToPartyIds: Array<Scalars['Long']['output']>;
  assignedToPartyPeople: Array<Person>;
  assignedToPartyPeopleIds: Array<Scalars['Long']['output']>;
  commentIds: Array<Scalars['Long']['output']>;
  comments: Array<Timeline_HighlightComment>;
  createdBy: Person;
  createdByPartyId: Scalars['Long']['output'];
  createdOn: Scalars['DateTime']['output'];
  eventIds: Array<Timeline_TimelineEventId>;
  events: Array<Timeline_TimelineEvent>;
  highlight: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  status: HighlightStatus;
  studentPartyId: Scalars['Long']['output'];
  title: Scalars['String']['output'];
};

export type Timeline_HighlightComment = {
  __typename?: 'Timeline_HighlightComment';
  comment: Scalars['String']['output'];
  commentId: Scalars['Long']['output'];
  commenter: Person;
  commenterPartyId: Scalars['Long']['output'];
  createdOn: Scalars['DateTime']['output'];
  likedByParties?: Maybe<Array<Person>>;
  likedByPartyIds?: Maybe<Array<Scalars['Long']['output']>>;
};

export type Timeline_HighlightCommentFilter = {
  commentIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  highlightIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type Timeline_HighlightFilter = {
  highlightId?: InputMaybe<Scalars['Long']['input']>;
  studentPartyIds: Array<InputMaybe<Scalars['Long']['input']>>;
};

export type Timeline_RemoveComment = {
  commentId: Scalars['Long']['input'];
};

export type Timeline_RemoveHighlight = {
  highlightIds: Array<Scalars['Long']['input']>;
};

export type Timeline_SaveHighlight = {
  assignedToPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  events?: InputMaybe<Array<Time_SaveHighlightEvent>>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  status?: InputMaybe<HighlightStatus>;
  studentPartyId: Scalars['Long']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Timeline_SaveHighlightComment = {
  comment: Scalars['String']['input'];
  commentId?: InputMaybe<Scalars['Long']['input']>;
  highlightId: Scalars['Long']['input'];
  likedByPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Timeline_Timeline = {
  __typename?: 'Timeline_Timeline';
  events: Array<Timeline_TimelineEvent>;
};

export type Timeline_TimelineEvent = {
  __typename?: 'Timeline_TimelineEvent';
  createdBy: Person;
  createdByPartyId: Scalars['Long']['output'];
  details?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  endDatetime?: Maybe<Scalars['DateTime']['output']>;
  headline: Scalars['String']['output'];
  /** implements Timeline_EventMeta but is set as object so fields dont have to be queries */
  meta?: Maybe<Timeline_EventMeta>;
  startDate: Scalars['Date']['output'];
  startDatetime: Scalars['DateTime']['output'];
  student: Student;
  studentId: Scalars['Long']['output'];
  timelineId?: Maybe<Timeline_TimelineEventId>;
};

export type Timeline_TimelineEventId = {
  __typename?: 'Timeline_TimelineEventId';
  entityId: Scalars['String']['output'];
  entityType: Timeline_EventType;
  studentPartyId: Scalars['Long']['output'];
};

export type Timeline_TimelineEventIdInput = {
  entityId: Scalars['String']['input'];
  entityType: Timeline_EventType;
};

export type Timeline_TimelineFilter = {
  eventIds?: InputMaybe<Array<InputMaybe<Timeline_TimelineEventIdInput>>>;
  eventTypes?: InputMaybe<Array<InputMaybe<Timeline_EventType>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  studentPartyIds: Array<InputMaybe<Scalars['Long']['input']>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Timetable_OnCallAssignerOptions = FormAdmin_InformationRequestConfigMeta & {
  __typename?: 'Timetable_OnCallAssignerOptions';
  /**
   * maxPeriodsTeacherCanGet: Int! @NotNull
   * requiredTeachersPerPeriod: Int! @NotNull
   */
  dueDate: Scalars['DateTime']['output'];
  excludeTeachers?: Maybe<Array<Scalars['Long']['output']>>;
  minPeriodsToBeSelected: Scalars['Int']['output'];
  periodsToChooseFrom: Scalars['Int']['output'];
  publishDate: Scalars['DateTime']['output'];
  timetableId: Scalars['Int']['output'];
  type: FormAdmin_InformationRequestConfigMetaType;
};

export type TransactionInput = {
  amount: Scalars['Float']['input'];
  paymentId: Scalars['Int']['input'];
};

export type TranslationInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Trustee = {
  __typename?: 'Trustee';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  addressLine4?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  forename?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  trusteeId?: Maybe<Scalars['Int']['output']>;
};

export type TtCreate_Block = {
  name: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
  sourceId: Tt_SourceIdInput;
};

export type TtCreate_BlockClassGroupLink = {
  blockSourceId: Tt_SourceIdInput;
  classGroupSourceIds: Array<Tt_SourceIdInput>;
};

export type TtCreate_ClassGroup = {
  code: Scalars['String']['input'];
  groupTagIds: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  partyId?: InputMaybe<Scalars['Long']['input']>;
  sourceId: Tt_SourceIdInput;
};

export type TtCreate_Rollover = {
  name: Scalars['String']['input'];
  rollover?: InputMaybe<Scalars['Boolean']['input']>;
  rolloverFreeform?: InputMaybe<Scalars['Boolean']['input']>;
  rolloverNonTeaching?: InputMaybe<Scalars['Boolean']['input']>;
  rolloverSupport?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleLessonsFor?: InputMaybe<Array<Tt_RolloverScheduleGroupType>>;
};

export type TtCreate_Timetable = {
  direct?: InputMaybe<TtCreate_TimetableDirect>;
  rollover?: InputMaybe<TtCreate_Rollover>;
};

export type TtCreate_TimetableDirect = {
  blocksIds: Array<TtCreate_Block>;
  classGroupBlockLinks?: InputMaybe<Array<TtCreate_BlockClassGroupLink>>;
  classGroups: Array<InputMaybe<TtCreate_ClassGroup>>;
  config?: InputMaybe<TtCreate_TimetableDirectConfig>;
  description?: InputMaybe<Scalars['String']['input']>;
  grids?: InputMaybe<Array<InputMaybe<TtUpsertGrid>>>;
  isLiveTimetable?: InputMaybe<Scalars['Boolean']['input']>;
  lessons?: InputMaybe<Array<TtCreate_TtUpsertLessons>>;
  name: Scalars['String']['input'];
  sourceId: Tt_SourceIdInput;
  subjectCompetencies?: InputMaybe<Array<TtSolve_UpdateSubjectGroupInput>>;
  subjectGroups?: InputMaybe<Array<TtCreate_TimetableGroups>>;
};

export type TtCreate_TimetableDirectConfig = {
  resetLessonUsingSpread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TtCreate_TimetableGroups = {
  blockIdxSourceId?: InputMaybe<Tt_SourceIdInput>;
  blockSourceIdId?: InputMaybe<Tt_SourceIdInput>;
  classGroupIdSourceId?: InputMaybe<Tt_SourceIdInput>;
  groupTagIds: Array<Scalars['Int']['input']>;
  groupType: Tt_GroupType;
  /**
   * Whats the student membership makeup of the group if
   * if CORE than the class group id must be provided
   * if BLOCK than the block id must be provided
   * if NO_STUDENTS than no class group or block id should be provided
   */
  membershipType: TtGroupStudentMembershipTypeEnum;
  name: Scalars['String']['input'];
  /** Can timetable different types of groups such as a subject group or a staff group for meetings */
  partyId?: InputMaybe<Scalars['Long']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  roomPoolId?: InputMaybe<Scalars['Int']['input']>;
  sourceId: Tt_SourceIdInput;
  /** set the spread. If lessons are also imported, this will take precedence */
  spread?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subjectId: Scalars['Int']['input'];
  teachersPartyIds: Array<Scalars['Long']['input']>;
  timetableName?: InputMaybe<Scalars['String']['input']>;
};

export type TtOptions_AvailableOption = {
  __typename?: 'TtOptions_AvailableOption';
  options: Options_Option;
  possibleGroupTagIds: Array<Scalars['Int']['output']>;
};

export type TtRunOnCallSolverParams = {
  maxPeriodsTeacherCanGet: Scalars['Int']['input'];
  requiredTeachersPerPeriod: Scalars['Int']['input'];
  teachersCanOnlyGetPeriodsTheySelected: Scalars['Boolean']['input'];
  timetableId: Scalars['Int']['input'];
};

export enum TtSearchType {
  And = 'And',
  Or = 'Or'
}

export enum TtSolveConstraintLowMediumHigh {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export enum TtSolveConstraintType {
  Hard = 'HARD',
  Soft = 'SOFT'
}

export enum TtSolveMorningAfternoonType {
  Afternoon = 'AFTERNOON',
  Any = 'ANY',
  Morning = 'MORNING'
}

export type TtSolve_AxisTotal = {
  __typename?: 'TtSolve_AxisTotal';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  total: Scalars['Long']['output'];
};

export type TtSolve_BrokenConstraintEntry = {
  __typename?: 'TtSolve_BrokenConstraintEntry';
  constraintName: Scalars['String']['output'];
  distinctLessonInstances: Scalars['Int']['output'];
  totalFrequency: Scalars['Long']['output'];
};

export type TtSolve_CancelSolveInput = {
  problemId: Scalars['String']['input'];
  serverId: Scalars['String']['input'];
};

export type TtSolve_CascadeEdge = {
  __typename?: 'TtSolve_CascadeEdge';
  frequency: Scalars['Long']['output'];
  sourceId: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
};

/**
 * Bipartite cascade graph: constraints on one side, subject groups
 * on the other, edges weighted by solver_stats frequencies. Real
 * data (from latest solve). Always top-N filtered to keep the graph
 * manageable; the filter values used are echoed in the response.
 */
export type TtSolve_CascadeGraph = {
  __typename?: 'TtSolve_CascadeGraph';
  dataNote: Scalars['String']['output'];
  edges: Array<TtSolve_CascadeEdge>;
  minEdgeFrequency: Scalars['Int']['output'];
  nodes: Array<TtSolve_CascadeNode>;
  topConstraintsRequested: Scalars['Int']['output'];
  topSubjectGroupsRequested: Scalars['Int']['output'];
};

export type TtSolve_CascadeGraphFilter = {
  minEdgeFrequency?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Right-column node kind: SUBJECT_GROUP (default), TEACHER, or
   * ROOM_POOL. Teacher / room edges are derived by attributing each
   * SG's violation count to every teacher / room pool the SG uses.
   */
  target?: InputMaybe<TtSolve_CascadeTarget>;
  timetableId: Scalars['Int']['input'];
  topConstraints?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Cap on the number of right-column nodes — name retained as
   * topSubjectGroups for backwards compat but applies to TEACHER /
   * ROOM_POOL targets equally.
   */
  topSubjectGroups?: InputMaybe<Scalars['Int']['input']>;
};

export type TtSolve_CascadeNode = {
  __typename?: 'TtSolve_CascadeNode';
  constraintName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: TtSolve_CascadeNodeKind;
  label: Scalars['String']['output'];
  roomPoolId?: Maybe<Scalars['Int']['output']>;
  staffPartyId?: Maybe<Scalars['Long']['output']>;
  timetableGroupId?: Maybe<Scalars['Long']['output']>;
  weight: Scalars['Long']['output'];
};

export enum TtSolve_CascadeNodeKind {
  Constraint = 'CONSTRAINT',
  RoomPool = 'ROOM_POOL',
  SubjectGroup = 'SUBJECT_GROUP',
  Teacher = 'TEACHER'
}

export enum TtSolve_CascadeTarget {
  Day = 'DAY',
  DayPeriod = 'DAY_PERIOD',
  Room = 'ROOM',
  RoomPool = 'ROOM_POOL',
  Subject = 'SUBJECT',
  SubjectGroup = 'SUBJECT_GROUP',
  Teacher = 'TEACHER'
}

export type TtSolve_CatalogAction = {
  __typename?: 'TtSolve_CatalogAction';
  appliesTo?: Maybe<Scalars['String']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  kind: TtSolve_CatalogActionKind;
  label?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<TtSolve_RestrictionRuleId>;
  weightingId?: Maybe<Scalars['String']['output']>;
};

export enum TtSolve_CatalogActionKind {
  FindLesson = 'FIND_LESSON',
  LowerWeighting = 'LOWER_WEIGHTING',
  None = 'NONE',
  PlaceLesson = 'PLACE_LESSON',
  RelaxRule = 'RELAX_RULE',
  SwapRoom = 'SWAP_ROOM',
  SwapTeacher = 'SWAP_TEACHER'
}

export enum TtSolve_CatalogCategory {
  Global = 'GLOBAL',
  Grid = 'GRID',
  Room = 'ROOM',
  Spread = 'SPREAD',
  SubjectGroup = 'SUBJECT_GROUP',
  Teacher = 'TEACHER'
}

export type TtSolve_CatalogConstraint = {
  __typename?: 'TtSolve_CatalogConstraint';
  actions: Array<TtSolve_CatalogAction>;
  category: TtSolve_CatalogCategory;
  description?: Maybe<Scalars['String']['output']>;
  drivesDifficulty: Scalars['Boolean']['output'];
  hardness: TtSolve_CatalogHardness;
  hidden: Scalars['Boolean']['output'];
  humanName?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  /** Curatable metadata: does breaking this make the timetable infeasible / stop the solve running. */
  makesInfeasible: Scalars['Boolean']['output'];
  /** Solver-owned, abstract "how to fix" levers (distinct from the Tyro product `actions` above). */
  resolutions: Array<TtSolve_ResolutionHint>;
  ruleId?: Maybe<TtSolve_RestrictionRuleId>;
  solverName: Scalars['String']['output'];
  stopsSolver: Scalars['Boolean']['output'];
  weightingId?: Maybe<Scalars['String']['output']>;
};

export enum TtSolve_CatalogHardness {
  Diamond = 'DIAMOND',
  Hard = 'HARD',
  Soft = 'SOFT'
}

export enum TtSolve_CatalogSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum TtSolve_CatalogTargetKind {
  Constraint = 'CONSTRAINT',
  Message = 'MESSAGE'
}

export type TtSolve_ClassData = {
  __typename?: 'TtSolve_ClassData';
  blocks: Array<TtSolve_ClassDataBlock>;
  classGroups: Array<TtSolve_ClassDataClassGroup>;
  core: Array<TtSolve_ClassDataCore>;
};

export type TtSolve_ClassDataAddSubject = {
  classGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  groupTags: Array<InputMaybe<Scalars['Int']['input']>>;
  spread?: InputMaybe<Array<Scalars['Int']['input']>>;
  subjectId: Scalars['Int']['input'];
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_ClassDataBlock = {
  __typename?: 'TtSolve_ClassDataBlock';
  block: Tt_Block;
  blockId: Scalars['String']['output'];
  coScheduleGroups: Array<Tt_Groups_ClassData>;
  spillOverTimetableGroups: Array<Tt_Groups_ClassData>;
  supportGroups: Array<Tt_Groups_ClassData>;
  timetableGroups: Array<TtSolve_ClassDataBlockGroupList>;
};

export type TtSolve_ClassDataBlockGroup = {
  __typename?: 'TtSolve_ClassDataBlockGroup';
  classGroupIsPresentInBlock: Scalars['Boolean']['output'];
  groups: Array<Tt_Groups>;
  isStack: Scalars['Boolean']['output'];
};

export type TtSolve_ClassDataBlockGroupList = {
  __typename?: 'TtSolve_ClassDataBlockGroupList';
  blockGroup: Array<TtSolve_ClassDataBlockGroup>;
  classGroupId: Scalars['Long']['output'];
};

export type TtSolve_ClassDataClassGroup = {
  __typename?: 'TtSolve_ClassDataClassGroup';
  classGroup: Tt_ClassGroup;
  uiBlockLessonCountOnColumn: Scalars['Int']['output'];
  uiCoreLessonCountOnColumn: Scalars['Int']['output'];
  uiTotalLessonCountOnColumn: Scalars['Int']['output'];
};

export type TtSolve_ClassDataCore = {
  __typename?: 'TtSolve_ClassDataCore';
  subject: Subject;
  subjectId: Scalars['Int']['output'];
  timetableGroups: Array<TtSolve_ClassDataCoreList>;
};

export type TtSolve_ClassDataCoreList = {
  __typename?: 'TtSolve_ClassDataCoreList';
  classGroupId: Scalars['Long']['output'];
  timetableGroups: Array<Tt_Groups>;
};

export type TtSolve_ClassDataDeleteCoreSubject = {
  groupTags: Array<InputMaybe<Scalars['Int']['input']>>;
  subjectId: Scalars['Int']['input'];
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_ClassDataDropOnBlock = {
  blockId: Scalars['String']['input'];
  classGroupId?: InputMaybe<Scalars['Long']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  timetableGroupId: Scalars['Long']['input'];
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_ClassDataFilter = {
  groupTags: Array<Scalars['Int']['input']>;
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_ClassDataSetSpreadOnBlock = {
  blockId: Scalars['String']['input'];
  spread: Array<Scalars['Int']['input']>;
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_ClassDataSetSpreadOnCoreSubject = {
  groupTags: Array<InputMaybe<Scalars['Int']['input']>>;
  spread: Array<Scalars['Int']['input']>;
  subjectId: Scalars['Int']['input'];
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_ClearRooms = {
  groupTagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** defaults to solver assigned */
  roomsFieldStatus?: InputMaybe<Array<Tt_FieldStatus>>;
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_ClearTimeslots = {
  /** default false */
  cleanPinnedTimeslots?: InputMaybe<Scalars['Boolean']['input']>;
  groupTagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_CompetenciesGroup = {
  __typename?: 'TtSolve_CompetenciesGroup';
  groupId: Scalars['Int']['output'];
  subjects: Array<TtSolve_CompetenciesGroupSubject>;
};

export type TtSolve_CompetenciesGroupCondensed = {
  __typename?: 'TtSolve_CompetenciesGroupCondensed';
  staff: Staff;
  staffId: Scalars['Long']['output'];
  subjectIds: Array<Scalars['Int']['output']>;
  subjects: Array<Subject>;
};

export type TtSolve_CompetenciesGroupSubject = {
  __typename?: 'TtSolve_CompetenciesGroupSubject';
  preference1Staff: Array<Staff>;
  preference1StaffIds: Array<Scalars['Long']['output']>;
  preference2Staff: Array<Staff>;
  preference2StaffIds: Array<Scalars['Long']['output']>;
  preference3Staff: Array<Staff>;
  preference3StaffIds: Array<Scalars['Long']['output']>;
  subject: Subject;
  subjectId: Scalars['Int']['output'];
};

export type TtSolve_CompetenciesMeta = {
  __typename?: 'TtSolve_CompetenciesMeta';
  groups: Array<TtSolve_CompetenciesMetaGroup>;
};

export type TtSolve_CompetenciesMetaGroup = {
  __typename?: 'TtSolve_CompetenciesMetaGroup';
  groupTagIds: Array<Scalars['Int']['output']>;
  groupTags: Array<GroupTag>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subSetIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type TtSolve_Configuration = {
  __typename?: 'TtSolve_Configuration';
  defaults: TtSolve_ConfigurationDefaults;
  user: TtSolve_ConfigurationUser;
};

export type TtSolve_ConfigurationConstraint = {
  __typename?: 'TtSolve_ConfigurationConstraint';
  id: Scalars['String']['output'];
  isAdvanced: Scalars['Boolean']['output'];
  isDiamond: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  weighting: Scalars['Int']['output'];
};

export type TtSolve_ConfigurationConstraintInput = {
  id: Scalars['String']['input'];
  isDiamond: Scalars['Boolean']['input'];
  weighting: Scalars['Int']['input'];
};

export type TtSolve_ConfigurationDefaults = {
  __typename?: 'TtSolve_ConfigurationDefaults';
  globalConstraints: Array<TtSolve_ConfigurationConstraint>;
  weightings: Array<TtSolve_ConfigurationWeighting>;
};

export type TtSolve_ConfigurationUser = {
  __typename?: 'TtSolve_ConfigurationUser';
  globalConstraints: Array<TtSolve_ConfigurationConstraint>;
  weightings: Array<TtSolve_ConfigurationWeighting>;
};

export type TtSolve_ConfigurationWeighting = {
  __typename?: 'TtSolve_ConfigurationWeighting';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  weighting: Scalars['Int']['output'];
};

export type TtSolve_ConstraintCellLesson = {
  __typename?: 'TtSolve_ConstraintCellLesson';
  frequency: Scalars['Long']['output'];
  lessonIdx: Scalars['Int']['output'];
  lessonInstanceIdx: Scalars['Int']['output'];
  subjectGroupName?: Maybe<Scalars['String']['output']>;
  timetableGroupId: Scalars['Long']['output'];
};

/**
 * Per-lesson rows backing a single (constraint, entity) heatmap cell.
 * frequency is the raw count from solver_stats for that lesson instance.
 */
export type TtSolve_ConstraintCellLessons = {
  __typename?: 'TtSolve_ConstraintCellLessons';
  dataNote: Scalars['String']['output'];
  distinctLessons: Scalars['Int']['output'];
  entries: Array<TtSolve_ConstraintCellLesson>;
  totalFrequency: Scalars['Long']['output'];
};

/**
 * Drill-down: per-lesson rows underlying a single (constraint, entity) cell
 * from the heatmap. entityId is the prefixed identifier returned by
 * ttsolve_constraintEdges (sg:<id> / t:<id> / rp:<id>).
 */
export type TtSolve_ConstraintCellLessonsFilter = {
  constraint: Scalars['String']['input'];
  entityAxis: TtSolve_CascadeTarget;
  entityId: Scalars['String']['input'];
  solveRunId?: InputMaybe<Scalars['Int']['input']>;
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_ConstraintEdge = {
  __typename?: 'TtSolve_ConstraintEdge';
  constraint: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  entityLabel: Scalars['String']['output'];
  weight: Scalars['Long']['output'];
};

/**
 * Normalised edge list for the Constraint Diagnostics explorer.
 * `weight` is the per-solve normalised severity from solver_stats
 * (0–99 within the solve), not a raw count.
 */
export type TtSolve_ConstraintEdges = {
  __typename?: 'TtSolve_ConstraintEdges';
  constraintTotals: Array<TtSolve_AxisTotal>;
  dataNote: Scalars['String']['output'];
  edges: Array<TtSolve_ConstraintEdge>;
  entityAxis: TtSolve_CascadeTarget;
  entityTotals: Array<TtSolve_AxisTotal>;
  minWeight: Scalars['Int']['output'];
  topConstraintsRequested: Scalars['Int']['output'];
  topEntitiesRequested: Scalars['Int']['output'];
};

/**
 * Edge-list query backing the Constraint Diagnostics explorer (heatmap +
 * sankey). Returns (constraint, entity, weight) triples plus marginal
 * totals so the frontend can pivot for the heatmap and filter for the
 * sankey without round-tripping. entityAxis picks the entity dimension;
 * teacherFanout only matters when entityAxis = TEACHER.
 */
export type TtSolve_ConstraintEdgesFilter = {
  entityAxis?: InputMaybe<TtSolve_CascadeTarget>;
  minWeight?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Optional: pin to a specific solve run (see TtSolve_SolveRunSummary).
   * Null / omitted means latest run for the timetable.
   */
  solveRunId?: InputMaybe<Scalars['Int']['input']>;
  teacherFanout?: InputMaybe<TtSolve_TeacherFanout>;
  timetableId: Scalars['Int']['input'];
  topConstraints?: InputMaybe<Scalars['Int']['input']>;
  topEntities?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The system-wide default solver configuration (the fallback applied when a
 * solve request doesn't override these). Managed by Tyro admins.
 */
export type TtSolve_DefaultSolverConfiguration = {
  __typename?: 'TtSolve_DefaultSolverConfiguration';
  globalConstraints?: Maybe<Array<TtSolve_ConfigurationConstraint>>;
  minutesSpentlimit?: Maybe<Scalars['Int']['output']>;
  parallelSolvers?: Maybe<Scalars['Int']['output']>;
  unimprovedMinutesSpentlimit?: Maybe<Scalars['Int']['output']>;
  useIncremental?: Maybe<Scalars['Boolean']['output']>;
  weightings?: Maybe<Array<TtSolve_ConfigurationWeighting>>;
};

export type TtSolve_DeleteCatalogueOverride = {
  targetKey: Scalars['String']['input'];
  targetKind: TtSolve_CatalogTargetKind;
};

export type TtSolve_DeleteRestrictions = {
  restrictionIds: Array<Scalars['Int']['input']>;
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_DeleteSolverServerInput = {
  ids: Array<Scalars['String']['input']>;
};

export type TtSolve_GroupTagStats = {
  __typename?: 'TtSolve_GroupTagStats';
  groupTagId: Scalars['Int']['output'];
  stats: TtSolve_Stats;
};

export type TtSolve_GroupViolationSummary = {
  __typename?: 'TtSolve_GroupViolationSummary';
  dataNote: Scalars['String']['output'];
  distinctConstraints: Scalars['Int']['output'];
  distinctLessonInstances: Scalars['Int']['output'];
  timetableGroupId: Scalars['Long']['output'];
  topConstraints: Array<TtSolve_BrokenConstraintEntry>;
  totalFrequency: Scalars['Long']['output'];
};

export type TtSolve_GroupViolationSummaryFilter = {
  timetableGroupId: Scalars['Long']['input'];
  timetableId: Scalars['Int']['input'];
  topK?: InputMaybe<Scalars['Int']['input']>;
};

export type TtSolve_HotspotLesson = {
  __typename?: 'TtSolve_HotspotLesson';
  distinctConstraints: Scalars['Int']['output'];
  lessonIdx?: Maybe<Scalars['Int']['output']>;
  lessonInstanceIdx?: Maybe<Scalars['Int']['output']>;
  subjectGroupName?: Maybe<Scalars['String']['output']>;
  timetableGroupId: Scalars['Long']['output'];
  totalFrequency: Scalars['Long']['output'];
};

export type TtSolve_HotspotLessons = {
  __typename?: 'TtSolve_HotspotLessons';
  dataNote: Scalars['String']['output'];
  entries: Array<TtSolve_HotspotLesson>;
  totalLessons: Scalars['Int']['output'];
};

export type TtSolve_HotspotLessonsFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  timetableId: Scalars['Int']['input'];
};

export enum TtSolve_Likelihood {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type TtSolve_MessageTemplate = {
  __typename?: 'TtSolve_MessageTemplate';
  constraintKey?: Maybe<Scalars['String']['output']>;
  defaultMessage: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  /**
   * Short curated label for grouping a message in the UI; null for messages that borrow their
   * owning constraint's name. Curatable/localisable like a constraint's humanName.
   */
  humanName?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  /** Curatable metadata: does this message make the timetable infeasible / stop the solve running. */
  makesInfeasible: Scalars['Boolean']['output'];
  resolutions: Array<TtSolve_ResolutionHint>;
  severity: TtSolve_CatalogSeverity;
  stopsSolver: Scalars['Boolean']['output'];
  /** Which kind of message this is; open taxonomy, UNKNOWN for values this build doesn't model. */
  type: TtSolve_MessageType;
  variables: Array<TtSolve_MessageVariable>;
};

export enum TtSolve_MessageType {
  ConstraintViolation = 'CONSTRAINT_VIOLATION',
  Feasibility = 'FEASIBILITY',
  InputValidation = 'INPUT_VALIDATION',
  Unknown = 'UNKNOWN'
}

export type TtSolve_MessageVariable = {
  __typename?: 'TtSolve_MessageVariable';
  name: Scalars['String']['output'];
  type: TtSolve_MessageVariableType;
};

export enum TtSolve_MessageVariableType {
  BaseClassId = 'BASE_CLASS_ID',
  BlockId = 'BLOCK_ID',
  Count = 'COUNT',
  LessonId = 'LESSON_ID',
  Number = 'NUMBER',
  RoomId = 'ROOM_ID',
  RoomPoolId = 'ROOM_POOL_ID',
  SubjectGroupId = 'SUBJECT_GROUP_ID',
  TeacherId = 'TEACHER_ID',
  Text = 'TEXT',
  TimeslotId = 'TIMESLOT_ID'
}

export enum TtSolve_Operation {
  Start = 'START',
  Stop = 'STOP'
}

export enum TtSolve_ResolutionAction {
  AddCapacity = 'ADD_CAPACITY',
  AdjustSpread = 'ADJUST_SPREAD',
  IncreaseAvailability = 'INCREASE_AVAILABILITY',
  LowerWeighting = 'LOWER_WEIGHTING',
  MoveLesson = 'MOVE_LESSON',
  ReassignRoom = 'REASSIGN_ROOM',
  ReassignTeacher = 'REASSIGN_TEACHER',
  ReduceLoad = 'REDUCE_LOAD',
  RelaxRule = 'RELAX_RULE',
  RemoveRule = 'REMOVE_RULE',
  ReviewData = 'REVIEW_DATA',
  Split = 'SPLIT'
}

/** Solver-owned, UI-agnostic resolution lever for a constraint/message. */
export type TtSolve_ResolutionHint = {
  __typename?: 'TtSolve_ResolutionHint';
  action: TtSolve_ResolutionAction;
  appliesTo?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  likelihood: TtSolve_Likelihood;
};

/**
 * Mirrors the solver's structured resource-slack `Report`. Scalars are nullable so
 * partial reports render; lists are non-null so the UI never gets a null list. Ids
 * are real Tyro ids: teacherId is a staff party id, subjectGroupId a TT_TIMETABLE_GROUP
 * id, baseClassId a class-group id, roomPoolId a room-pool id. blockId is solver-internal.
 */
export type TtSolve_ResourceSlackReport = {
  __typename?: 'TtSolve_ResourceSlackReport';
  blocks?: Maybe<TtSolve_SlackBlocks>;
  capacity?: Maybe<TtSolve_SlackCapacity>;
  coSchedule?: Maybe<TtSolve_SlackCoSchedule>;
  difficulty?: Maybe<TtSolve_SlackDifficulty>;
  /** Pre-solve feasibility screening — orthogonal to difficulty. */
  feasibility?: Maybe<TtSolve_SlackFeasibility>;
  /** Must-fix problems from the feasibility checker. */
  feasibilityErrors: Array<TtSolve_SlackInfeasibleMessage>;
  generatedAtEpochMs?: Maybe<Scalars['Long']['output']>;
  inputHash?: Maybe<Scalars['Int']['output']>;
  multiples?: Maybe<TtSolve_SlackMultiples>;
  pinning?: Maybe<TtSolve_SlackPinning>;
  restrictions?: Maybe<TtSolve_SlackRestrictions>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  shape?: Maybe<TtSolve_SlackShape>;
  spread?: Maybe<TtSolve_SlackSpread>;
};

export type TtSolve_Restriction = {
  __typename?: 'TtSolve_Restriction';
  arguments?: Maybe<Array<TtSolve_RestrictionArgumentField>>;
  createdBy: AuditPerson;
  createdByPartyId: Scalars['Long']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  hasError?: Maybe<Scalars['Boolean']['output']>;
  restrictionIdx: Scalars['Int']['output'];
  ruleId: TtSolve_RestrictionRuleId;
  solverArea: TtSolve_RestrictionSolverArea;
  type: TtSolve_RestrictionType;
  updatedBy: AuditPerson;
  updatedByPartyId: Scalars['Long']['output'];
};

export type TtSolve_RestrictionArgumentField = {
  __typename?: 'TtSolve_RestrictionArgumentField';
  rawValue?: Maybe<Scalars['Object']['output']>;
  type: TtSolve_RestrictionArgumentInputType;
  /** possible values if a dropdown list */
  value?: Maybe<Scalars['Object']['output']>;
};

export enum TtSolve_RestrictionArgumentFieldType {
  Number = 'NUMBER',
  Party = 'PARTY',
  Room = 'ROOM',
  SearchExpression = 'SEARCH_EXPRESSION',
  Timeslot = 'TIMESLOT'
}

export enum TtSolve_RestrictionArgumentInputType {
  HardSoft = 'HARD_SOFT',
  MorningAfternoon = 'MORNING_AFTERNOON',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  SearchExpression = 'SEARCH_EXPRESSION',
  Select = 'SELECT',
  Timeslot = 'TIMESLOT',
  TimeslotHardSoft = 'TIMESLOT_HARD_SOFT'
}

export type TtSolve_RestrictionArgumentMetaField = {
  __typename?: 'TtSolve_RestrictionArgumentMetaField';
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  /** possible values if a dropdown list */
  selectValues?: Maybe<Array<TtSolve_RestrictionDropdownValues>>;
  type: TtSolve_RestrictionArgumentInputType;
};

export type TtSolve_RestrictionDropdownValues = {
  __typename?: 'TtSolve_RestrictionDropdownValues';
  id?: Maybe<Scalars['Object']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TtSolve_RestrictionMeta = {
  __typename?: 'TtSolve_RestrictionMeta';
  arguments?: Maybe<Array<Maybe<TtSolve_RestrictionArgumentMetaField>>>;
  ruleId: TtSolve_RestrictionRuleId;
  solverArea: TtSolve_RestrictionSolverArea;
};

export type TtSolve_RestrictionParams = {
  solverAreas?: InputMaybe<Array<TtSolve_RestrictionSolverArea>>;
  timetableId: Scalars['Int']['input'];
};

export enum TtSolve_RestrictionRuleId {
  CombinedPeriod = 'combined_period',
  ConsecutiveDaysConflict = 'consecutive_days_conflict',
  RoomExcludedTimeslots = 'room_excluded_timeslots',
  RoomPoolHardConstraint = 'room_pool_hard_constraint',
  StudentBuildingGroup = 'student_building_group',
  StudentBuildingTravelTime = 'student_building_travel_time',
  StudentCampusGroup = 'student_campus_group',
  StudentCampusTravelTime = 'student_campus_travel_time',
  StudentMaxBuildingsPerDay = 'student_max_buildings_per_day',
  StudentMaxCampusesPerDay = 'student_max_campuses_per_day',
  SubjectGroupExcludedTimeslots = 'subject_group_excluded_timeslots',
  SubjectGroupNoDoubleOnTimeslots = 'subject_group_no_double_on_timeslots',
  SubjectGroupNumDaysOff = 'subject_group_num_days_off',
  SubjectGroupOnlyRunAtTimeslots = 'subject_group_only_run_at_timeslots',
  SubjectGroupRoomWeightings = 'subject_group_room_weightings',
  SubjectGroupSpreadWeightings = 'subject_group_spread_weightings',
  TeacherBuildingGroup = 'teacher_building_group',
  TeacherBuildingTravelTime = 'teacher_building_travel_time',
  TeacherCampusGroup = 'teacher_campus_group',
  TeacherCampusTravelTime = 'teacher_campus_travel_time',
  TeacherExcludedTimeslots = 'teacher_excluded_timeslots',
  TeacherLunchSplit = 'teacher_lunch_split',
  TeacherMaxBuildingsPerDay = 'teacher_max_buildings_per_day',
  TeacherMaxCampusesPerDay = 'teacher_max_campuses_per_day',
  TeacherMaxLessonsPerDay = 'teacher_max_lessons_per_day',
  TeacherNumDaysOff = 'teacher_num_days_off',
  TeacherNumHalfDays = 'teacher_num_half_days',
  TeacherPrefRoomId = 'teacher_pref_room_id',
  WeekBalanceConstraint = 'week_balance_constraint'
}

export enum TtSolve_RestrictionSolverArea {
  Rule = 'RULE',
  Weighting = 'WEIGHTING'
}

export enum TtSolve_RestrictionType {
  Grid = 'GRID',
  Room = 'ROOM',
  SubjectGroup = 'SUBJECT_GROUP',
  Teacher = 'TEACHER'
}

export type TtSolve_Restrictions = {
  __typename?: 'TtSolve_Restrictions';
  resctriction: Array<TtSolve_Restriction>;
};

export type TtSolve_RestrictionsMeta = {
  __typename?: 'TtSolve_RestrictionsMeta';
  restriction: Array<TtSolve_RestrictionMeta>;
};

export enum TtSolve_RoomSolverRunType {
  All = 'ALL',
  HomeRooms = 'HOME_ROOMS',
  RoomPools = 'ROOM_POOLS'
}

export type TtSolve_RunRoomSolverConfig = {
  runType: TtSolve_RoomSolverRunType;
};

export type TtSolve_RunRoomSolverRoomPoolParams = {
  roomPoolIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TtSolve_RunSolverParams = {
  configuration?: InputMaybe<TtSolve_SolverConfiguration>;
  /** depricated */
  groupTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  operation: TtSolve_Operation;
  roomConfig?: InputMaybe<TtSolve_RunRoomSolverConfig>;
  runType: SolverRunType;
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_ScheduleLessonOptions = {
  __typename?: 'TtSolve_ScheduleLessonOptions';
  timeslotValidations: Array<TtValidation_ValidationTimeslotMove>;
};

export type TtSolve_ScheduleView = {
  __typename?: 'TtSolve_ScheduleView';
  byGroupTag: Array<TtSolve_ScheduleViewGroupTag>;
};

export type TtSolve_ScheduleViewGroupTag = {
  __typename?: 'TtSolve_ScheduleViewGroupTag';
  groupTag: GroupTag;
  groupTagId: Scalars['Int']['output'];
  rows: Array<TtSolve_ScheduleViewGroupTagRow>;
  timeslots: Array<TtTimeslot>;
  timetableGroups: Array<Tt_Groups>;
};

export type TtSolve_ScheduleViewGroupTagRow = {
  __typename?: 'TtSolve_ScheduleViewGroupTagRow';
  allowMultiple: Scalars['Boolean']['output'];
  grid: Array<TtSolve_ScheduleViewGroupTagRowGrid>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type TtSolve_ScheduleViewGroupTagRowGrid = {
  __typename?: 'TtSolve_ScheduleViewGroupTagRowGrid';
  included: Scalars['Boolean']['output'];
  includedBlockId?: Maybe<Scalars['String']['output']>;
  lessonInstanceIds: Array<TtIndividualViewLessonId>;
  timeslotId: TtTimeslotId;
};

export type TtSolve_SlackBigBlock = {
  __typename?: 'TtSolve_SlackBigBlock';
  blockId?: Maybe<Scalars['Int']['output']>;
  cols?: Maybe<Scalars['Int']['output']>;
  lessons?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Scalars['Int']['output']>;
};

export type TtSolve_SlackBigBlockGroup = {
  __typename?: 'TtSolve_SlackBigBlockGroup';
  blockGroupId?: Maybe<Scalars['String']['output']>;
  blockId?: Maybe<Scalars['Int']['output']>;
  blockName?: Maybe<Scalars['String']['output']>;
  lessons?: Maybe<Scalars['Int']['output']>;
};

export type TtSolve_SlackBlocks = {
  __typename?: 'TtSolve_SlackBlocks';
  bigBlockGroups: Array<TtSolve_SlackBigBlockGroup>;
  bigBlocks: Array<TtSolve_SlackBigBlock>;
};

/** Over-subscribed resources (RED) plus the load-ratio maxes that drive difficulty. */
export type TtSolve_SlackCapacity = {
  __typename?: 'TtSolve_SlackCapacity';
  maxBaseClassLoad?: Maybe<Scalars['Float']['output']>;
  maxPoolGlobalLoad?: Maybe<Scalars['Float']['output']>;
  /** Max over rooms of fixedLessons / cycle-slots — how packed the busiest pre-assigned room is. */
  maxRoomLoad?: Maybe<Scalars['Float']['output']>;
  maxTeacherTimeslotLoad?: Maybe<Scalars['Float']['output']>;
  /** Drives feasibility (skips teachers with no configured limit); minutesPerCycle can still be misconfigured. */
  maxTeacherWeeklyTimeLoad?: Maybe<Scalars['Float']['output']>;
  overbookedBaseClasses: Array<TtSolve_SlackOverbookedBaseClass>;
  overbookedPools: Array<TtSolve_SlackOverbookedPool>;
  overbookedTeachersTimeslots: Array<TtSolve_SlackOverbookedTeacher>;
  overbookedTeachersWeeklyTime: Array<TtSolve_SlackOverbookedTeacher>;
  /** roomedLessons / totalLessons. */
  roomedFraction?: Maybe<Scalars['Float']['output']>;
  /** Lessons carrying a fixed room into the timeslot solve (each adds a room-conflict edge). */
  roomedLessons?: Maybe<Scalars['Int']['output']>;
  /** Breadth signal for the difficulty gradient — teachers with slot-load > 0.9. */
  teacherSlotOver09Count?: Maybe<Scalars['Int']['output']>;
};

export type TtSolve_SlackCoSchedule = {
  __typename?: 'TtSolve_SlackCoSchedule';
  chains?: Maybe<Scalars['Int']['output']>;
  chainsWithBlocks?: Maybe<Scalars['Int']['output']>;
};

export enum TtSolve_SlackDifficulty {
  Easy = 'EASY',
  Hard = 'HARD',
  Moderate = 'MODERATE'
}

/**
 * Pre-solve feasibility screening — orthogonal to difficulty. INFEASIBLE is a proven
 * over-subscription; NO_BLOCKERS_FOUND means screening found nothing (not a guarantee).
 */
export enum TtSolve_SlackFeasibility {
  Infeasible = 'INFEASIBLE',
  NeedsFixes = 'NEEDS_FIXES',
  NoBlockersFound = 'NO_BLOCKERS_FOUND'
}

export type TtSolve_SlackInfeasibleMessage = {
  __typename?: 'TtSolve_SlackInfeasibleMessage';
  /** catalogue join key (a feasibility_* message key); null when unmapped */
  code?: Maybe<Scalars['String']['output']>;
  constraintId?: Maybe<Scalars['String']['output']>;
  constraintName?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type TtSolve_SlackMultiples = {
  __typename?: 'TtSolve_SlackMultiples';
  inBlocks?: Maybe<Scalars['Int']['output']>;
  inMandatory?: Maybe<Scalars['Int']['output']>;
};

export type TtSolve_SlackOverbookedBaseClass = {
  __typename?: 'TtSolve_SlackOverbookedBaseClass';
  available?: Maybe<Scalars['Int']['output']>;
  baseClassId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  over?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Int']['output']>;
};

export type TtSolve_SlackOverbookedPool = {
  __typename?: 'TtSolve_SlackOverbookedPool';
  capacity?: Maybe<Scalars['Int']['output']>;
  demand?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  roomPoolId?: Maybe<Scalars['Int']['output']>;
};

export type TtSolve_SlackOverbookedTeacher = {
  __typename?: 'TtSolve_SlackOverbookedTeacher';
  available?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  required?: Maybe<Scalars['Float']['output']>;
  /** Staff party id — open ttsolve_teacherLoadBreakdown for this teacher. */
  teacherId?: Maybe<Scalars['Int']['output']>;
};

export type TtSolve_SlackPinning = {
  __typename?: 'TtSolve_SlackPinning';
  fraction?: Maybe<Scalars['Float']['output']>;
  lessons?: Maybe<Scalars['Int']['output']>;
};

export type TtSolve_SlackPressuredSpread = {
  __typename?: 'TtSolve_SlackPressuredSpread';
  /** Solver-internal block id; null when the spread is not in a block. */
  blockId?: Maybe<Scalars['Int']['output']>;
  daysAvail?: Maybe<Scalars['Float']['output']>;
  daysNeeded?: Maybe<Scalars['Int']['output']>;
  difficulty?: Maybe<Scalars['Float']['output']>;
  hardSpread?: Maybe<Scalars['Boolean']['output']>;
  inBlock?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  sgName?: Maybe<Scalars['String']['output']>;
  spread?: Maybe<Scalars['String']['output']>;
  /** TT_TIMETABLE_GROUP id — open the spread inspector for this subject group. */
  subjectGroupId?: Maybe<Scalars['Int']['output']>;
  tightness?: Maybe<Scalars['Float']['output']>;
};

export type TtSolve_SlackRestrictions = {
  __typename?: 'TtSolve_SlackRestrictions';
  topSubjectGroups: Array<TtSolve_SlackTopSubjectGroup>;
  topTeachers: Array<TtSolve_SlackTopTeacher>;
};

export type TtSolve_SlackShape = {
  __typename?: 'TtSolve_SlackShape';
  avgSlotsPerDay?: Maybe<Scalars['Float']['output']>;
  baseClasses?: Maybe<Scalars['Int']['output']>;
  blockLessons?: Maybe<Scalars['Int']['output']>;
  blockSgs?: Maybe<Scalars['Int']['output']>;
  blocks?: Maybe<Scalars['Int']['output']>;
  cycles?: Maybe<Scalars['Int']['output']>;
  dualGrid?: Maybe<Scalars['Boolean']['output']>;
  mandatoryLessons?: Maybe<Scalars['Int']['output']>;
  mandatoryOrMeetingSgs?: Maybe<Scalars['Int']['output']>;
  meetingSgs?: Maybe<Scalars['Int']['output']>;
  roomPools?: Maybe<Scalars['Int']['output']>;
  rooms?: Maybe<Scalars['Int']['output']>;
  stackedBlocks?: Maybe<Scalars['Int']['output']>;
  teachers?: Maybe<Scalars['Int']['output']>;
  totalDays?: Maybe<Scalars['Int']['output']>;
  totalLessons?: Maybe<Scalars['Int']['output']>;
  totalSlots?: Maybe<Scalars['Int']['output']>;
  twoWeek?: Maybe<Scalars['Boolean']['output']>;
};

/** Spread pressure: one merged list of pressured spreads + aggregates/buckets. */
export type TtSolve_SlackSpread = {
  __typename?: 'TtSolve_SlackSpread';
  comfortableCount?: Maybe<Scalars['Int']['output']>;
  infeasibleCount?: Maybe<Scalars['Int']['output']>;
  isHardAtLeastOnce?: Maybe<Scalars['Boolean']['output']>;
  maxDifficulty?: Maybe<Scalars['Float']['output']>;
  multiplePairCount?: Maybe<Scalars['Int']['output']>;
  /** Per-SG intensity (informational); label is driven by spreadStrain. */
  pressureIndex?: Maybe<Scalars['Float']['output']>;
  pressureLabel?: Maybe<TtSolve_SlackDifficulty>;
  pressuredSpreads: Array<TtSolve_SlackPressuredSpread>;
  snugCount?: Maybe<Scalars['Int']['output']>;
  /** Absolute spread pressure — best predictor of realized spread misses; drives pressureLabel. */
  spreadStrain?: Maybe<Scalars['Float']['output']>;
  totalDifficulty?: Maybe<Scalars['Float']['output']>;
  totalEvaluated?: Maybe<Scalars['Int']['output']>;
  zeroSlackCount?: Maybe<Scalars['Int']['output']>;
};

export type TtSolve_SlackTopSubjectGroup = {
  __typename?: 'TtSolve_SlackTopSubjectGroup';
  hardDaysOff?: Maybe<Scalars['Int']['output']>;
  hardExcludedSlots?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subjectGroupId?: Maybe<Scalars['Int']['output']>;
};

export type TtSolve_SlackTopTeacher = {
  __typename?: 'TtSolve_SlackTopTeacher';
  hardDaysOff?: Maybe<Scalars['Int']['output']>;
  hardExcludedSlots?: Maybe<Scalars['Int']['output']>;
  hardHalfDaysOff?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
};

export type TtSolve_SolveParams = {
  timetableId: Scalars['Int']['input'];
};

/**
 * Summary of a retained solve run for a timetable. solveRunId is an
 * incrementing integer per timetable (1, 2, 3...). isLatest marks the
 * newest run; useful for the explorer's Run selector.
 */
export type TtSolve_SolveRunSummary = {
  __typename?: 'TtSolve_SolveRunSummary';
  isLatest: Scalars['Boolean']['output'];
  rowCount: Scalars['Int']['output'];
  solveRunId: Scalars['Int']['output'];
};

export type TtSolve_SolveRunsFilter = {
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_SolverCatalog = {
  __typename?: 'TtSolve_SolverCatalog';
  constraints: Array<TtSolve_CatalogConstraint>;
  messages: Array<TtSolve_MessageTemplate>;
  version: Scalars['String']['output'];
};

export type TtSolve_SolverInput = {
  __typename?: 'TtSolve_SolverInput';
  input?: Maybe<Scalars['Object']['output']>;
};

/** A solve the server reports it is currently running (from getAllProblems). */
export type TtSolve_SolverProblem = {
  __typename?: 'TtSolve_SolverProblem';
  durationSec?: Maybe<Scalars['Int']['output']>;
  problemId?: Maybe<Scalars['String']['output']>;
  problemType?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * One reconciled solve: what the server reports running (getAllProblems) vs what
 * tt_solver_current_state believes, keyed by problemId. presence is
 * MATCHED (both), SOLVER_ONLY (running on the box, not active in our DB) or
 * DB_ONLY (we think active/reserved, the box isn't running it — a stale reservation).
 */
export type TtSolve_SolverReconcileRow = {
  __typename?: 'TtSolve_SolverReconcileRow';
  dbStatus?: Maybe<Scalars['String']['output']>;
  presence: Scalars['String']['output'];
  problemId?: Maybe<Scalars['String']['output']>;
  reachable?: Maybe<Scalars['Boolean']['output']>;
  reservedCpus?: Maybe<Scalars['Int']['output']>;
  serverId: Scalars['String']['output'];
  solverDurationSec?: Maybe<Scalars['Int']['output']>;
  solverScore?: Maybe<Scalars['String']['output']>;
  solverStatus?: Maybe<Scalars['String']['output']>;
  timetableId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A solver server in the load-balancing pool registry. reservedCpus/freeCpus are
 * live usage derived from in-flight solves (null when the server is disabled).
 */
export type TtSolve_SolverServer = {
  __typename?: 'TtSolve_SolverServer';
  cpus: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  freeCpus?: Maybe<Scalars['Int']['output']>;
  host: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permanent: Scalars['Boolean']['output'];
  port: Scalars['Int']['output'];
  protocol: Scalars['String']['output'];
  reservedCpus?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/**
 * Live reachability of a pool server (the backend probes each enabled server via
 * getAllProblems) plus the solves it reports running.
 */
export type TtSolve_SolverServerHealth = {
  __typename?: 'TtSolve_SolverServerHealth';
  activeProblems?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  latencyMs?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  problems?: Maybe<Array<TtSolve_SolverProblem>>;
  reachable: Scalars['Boolean']['output'];
};

export type TtSolve_SolverServersFilter = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A row of timetable.tt_solver_current_state — the live per-timetable solve
 * state, surfaced cross-tenant for the Tyro-admin overview.
 */
export type TtSolve_SolverStateOverview = {
  __typename?: 'TtSolve_SolverStateOverview';
  academicNamespaceId?: Maybe<Scalars['Int']['output']>;
  problemId?: Maybe<Scalars['String']['output']>;
  reservedCpus?: Maybe<Scalars['Int']['output']>;
  restartCount?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  solverServerId?: Maybe<Scalars['String']['output']>;
  solverType?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stopReason?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['Int']['output']>;
  timetableId: Scalars['Int']['output'];
  updatedOn?: Maybe<Scalars['String']['output']>;
};

export type TtSolve_SolverStatus = {
  __typename?: 'TtSolve_SolverStatus';
  groupTagStats: Array<TtSolve_GroupTagStats>;
  score?: Maybe<Scalars['String']['output']>;
  solverRunType: SolverRunType;
  solverStatus: Tt_SolverStatus;
  stats: TtSolve_Stats;
};

export type TtSolve_SolverSwappedTeacherAccept = {
  accept: Scalars['Boolean']['input'];
  timetableGroupId: Scalars['Long']['input'];
};

export type TtSolve_SolverSwappedTeachers = {
  __typename?: 'TtSolve_SolverSwappedTeachers';
  group?: Maybe<Tt_Groups>;
  originalTeacher: Staff;
  originalTeacherPartyId: Scalars['Long']['output'];
  swappedTeacher: Staff;
  swappedTeacherPartyId: Scalars['Long']['output'];
  timetableGroupId: Scalars['Long']['output'];
};

export type TtSolve_SolverSwappedTeachersAccept = {
  groups: Array<TtSolve_SolverSwappedTeacherAccept>;
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_SpreadConflictAssignedTeacher = {
  __typename?: 'TtSolve_SpreadConflictAssignedTeacher';
  name?: Maybe<Scalars['String']['output']>;
  staffPartyId: Scalars['Long']['output'];
};

/**
 * Structured-where-possible explanation for one tight-spread SG. See
 * diagnostics-solver-needs.md section 2.3 — this is the best-effort
 * version that today's data supports; per-slot blockers, exact
 * attribution, and counterfactuals all require solver-side additions.
 */
export type TtSolve_SpreadConflictExplanation = {
  __typename?: 'TtSolve_SpreadConflictExplanation';
  assignedTeachers: Array<TtSolve_SpreadConflictAssignedTeacher>;
  resolution: TtSolve_SpreadConflictResolution;
  subjectGroup?: Maybe<TtSolve_SpreadConflictSubjectGroup>;
  tightSpread?: Maybe<TtSolve_SpreadConflictTightSpread>;
  unknowns: Array<Scalars['String']['output']>;
};

export type TtSolve_SpreadConflictFilter = {
  subjectGroupName: Scalars['String']['input'];
  timetableId: Scalars['Int']['input'];
};

export enum TtSolve_SpreadConflictReasonKind {
  DayShortage = 'DAY_SHORTAGE',
  InBlock = 'IN_BLOCK',
  NoSlack = 'NO_SLACK',
  TeacherHardDaysOff = 'TEACHER_HARD_DAYS_OFF',
  Unrecognised = 'UNRECOGNISED'
}

export type TtSolve_SpreadConflictResolution = {
  __typename?: 'TtSolve_SpreadConflictResolution';
  matchedName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  resolved: Scalars['Boolean']['output'];
  timetableGroupId?: Maybe<Scalars['Long']['output']>;
};

export type TtSolve_SpreadConflictStructuredReason = {
  __typename?: 'TtSolve_SpreadConflictStructuredReason';
  detail?: Maybe<Scalars['String']['output']>;
  kind: TtSolve_SpreadConflictReasonKind;
  original: Scalars['String']['output'];
};

export type TtSolve_SpreadConflictSubjectGroup = {
  __typename?: 'TtSolve_SpreadConflictSubjectGroup';
  blockId?: Maybe<Scalars['String']['output']>;
  classGroupId?: Maybe<Scalars['Long']['output']>;
  lessonCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  spread: Array<Scalars['Int']['output']>;
  timetableGroupId?: Maybe<Scalars['Long']['output']>;
};

export type TtSolve_SpreadConflictTightSpread = {
  __typename?: 'TtSolve_SpreadConflictTightSpread';
  daysAvailable?: Maybe<Scalars['Int']['output']>;
  daysNeeded?: Maybe<Scalars['Int']['output']>;
  pattern: Array<Scalars['Int']['output']>;
  rawReasons: Array<Scalars['String']['output']>;
  structuredReasons: Array<TtSolve_SpreadConflictStructuredReason>;
};

export type TtSolve_StackGroups = {
  operation: TtSolve_StackOperation;
  timetableGroupIds: Array<InputMaybe<Scalars['Long']['input']>>;
  timetableId: Scalars['Int']['input'];
};

export enum TtSolve_StackOperation {
  Stack = 'STACK',
  Unstack = 'UNSTACK'
}

export type TtSolve_Stats = {
  __typename?: 'TtSolve_Stats';
  lessonsScheduled: Scalars['Int']['output'];
  lessonsTotal: Scalars['Int']['output'];
  lessonsWithRoom: Scalars['Int']['output'];
  lessonsWithTeacher: Scalars['Int']['output'];
  spreadsAchieved: Scalars['Int']['output'];
  spreadsExpected: Scalars['Int']['output'];
  spreadsMissed?: Maybe<Scalars['Int']['output']>;
};

export type TtSolve_SubjectCompetencies = {
  __typename?: 'TtSolve_SubjectCompetencies';
  groups: Array<TtSolve_CompetenciesGroup>;
};

export type TtSolve_SubjectCompetenciesCondensed = {
  __typename?: 'TtSolve_SubjectCompetenciesCondensed';
  staff: Array<TtSolve_CompetenciesGroupCondensed>;
};

export type TtSolve_SubjectCompetenciesFilter = {
  competencyGroupId?: InputMaybe<Scalars['Int']['input']>;
  timetableId: Scalars['Int']['input'];
};

/**
 * How a teacher constraint's weight is split when entityAxis = TEACHER
 * and a subject group has multiple teachers. SPLIT divides weight evenly
 * across teachers (conserves totals); DUPLICATE assigns full weight to
 * each (good for ranking, never for summing).
 */
export enum TtSolve_TeacherFanout {
  Duplicate = 'DUPLICATE',
  Split = 'SPLIT'
}

export type TtSolve_TeacherLoadBreakdown = {
  __typename?: 'TtSolve_TeacherLoadBreakdown';
  lessonGroups: Array<TtSolve_TeacherLoadContribution>;
  suggestions: Array<TtSolve_TeacherLoadSuggestion>;
  teacher: TtSolve_TeacherLoadInfo;
};

export type TtSolve_TeacherLoadContribution = {
  __typename?: 'TtSolve_TeacherLoadContribution';
  /**
   * Other teachers competent for the same subject who are not the focus
   * teacher. Empty when no peers are competent.
   */
  alternativeStaffPartyIds: Array<Scalars['Long']['output']>;
  blockName?: Maybe<Scalars['String']['output']>;
  lessonCount: Scalars['Int']['output'];
  minutesPerLesson: Scalars['Int']['output'];
  role: TtSolve_TeacherLoadRole;
  subjectGroupName: Scalars['String']['output'];
  subjectId?: Maybe<Scalars['Int']['output']>;
  subjectName?: Maybe<Scalars['String']['output']>;
  timetableGroupId: Scalars['Long']['output'];
  totalMinutes: Scalars['Int']['output'];
};

export type TtSolve_TeacherLoadFilter = {
  teacherStaffPartyId: Scalars['Long']['input'];
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_TeacherLoadInfo = {
  __typename?: 'TtSolve_TeacherLoadInfo';
  load: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  requiredMinutes: Scalars['Int']['output'];
  staffPartyId: Scalars['Long']['output'];
  weeklyAllowanceMinutes: Scalars['Int']['output'];
};

export enum TtSolve_TeacherLoadRole {
  Primary = 'PRIMARY',
  Shared = 'SHARED'
}

export type TtSolve_TeacherLoadSuggestion = {
  __typename?: 'TtSolve_TeacherLoadSuggestion';
  candidateCurrentLoad: Scalars['Float']['output'];
  candidateName: Scalars['String']['output'];
  candidateSpareMinutes: Scalars['Int']['output'];
  candidateStaffPartyId: Scalars['Long']['output'];
  /** 1 = pref1, 2 = pref2, 3 = pref3 from the subject competencies grid. */
  competencyPreference: Scalars['Int']['output'];
  /** How many lessons the candidate could absorb without exceeding load 1.0. */
  shiftableLessons: Scalars['Int']['output'];
  subjectGroupName: Scalars['String']['output'];
  timetableGroupId: Scalars['Long']['output'];
};

export type TtSolve_TeacherViolationSummary = {
  __typename?: 'TtSolve_TeacherViolationSummary';
  dataNote: Scalars['String']['output'];
  distinctConstraints: Scalars['Int']['output'];
  distinctLessonInstances: Scalars['Int']['output'];
  distinctSubjectGroups: Scalars['Int']['output'];
  staffPartyId: Scalars['Long']['output'];
  topConstraints: Array<TtSolve_BrokenConstraintEntry>;
  totalFrequency: Scalars['Long']['output'];
};

export type TtSolve_TeacherViolationSummaryFilter = {
  staffPartyId: Scalars['Long']['input'];
  timetableId: Scalars['Int']['input'];
  topK?: InputMaybe<Scalars['Int']['input']>;
};

export type TtSolve_TimeslotHardSoftInput = {
  hardSoft?: InputMaybe<TtSolveConstraintType>;
  timeslot?: InputMaybe<TtTimeslotIdInput>;
};

/**
 * Real (non-mock) solver-derived aggregates from timetable.solver_stats.
 * See diagnostics-solver-needs.md section 4a. Numbers span all retained
 * solver_stats rows for the timetable, which may include more than the
 * most recent solve — dataNote carries that warning verbatim.
 */
export type TtSolve_TopBrokenConstraints = {
  __typename?: 'TtSolve_TopBrokenConstraints';
  dataNote: Scalars['String']['output'];
  distinctConstraints: Scalars['Int']['output'];
  entries: Array<TtSolve_BrokenConstraintEntry>;
  totalViolations: Scalars['Long']['output'];
};

export type TtSolve_TopBrokenConstraintsFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_UpdateConfigurations = {
  timetableId: Scalars['Int']['input'];
  weightings?: InputMaybe<Array<InputMaybe<TtSolve_UpdateConfigurationsWeightings>>>;
};

export type TtSolve_UpdateConfigurationsWeightings = {
  id: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type TtSolve_UpdateSubjectCompetenciesInput = {
  groups: Array<TtSolve_UpdateSubjectGroupInput>;
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_UpdateSubjectCompetenciesSubject = {
  preference1Ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  preference2Ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  preference3Ids?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  subjectId: Scalars['Int']['input'];
};

export type TtSolve_UpdateSubjectGroupInput = {
  groupId: Scalars['Int']['input'];
  subjects: Array<InputMaybe<TtSolve_UpdateSubjectCompetenciesSubject>>;
};

export type TtSolve_UpsertCatalogueOverride = {
  description?: InputMaybe<Array<TranslationInput>>;
  disabledActions?: InputMaybe<Array<TtSolve_CatalogActionKind>>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Array<TranslationInput>>;
  label?: InputMaybe<Array<TranslationInput>>;
  makesInfeasible?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Array<TranslationInput>>;
  severity?: InputMaybe<TtSolve_CatalogSeverity>;
  /** Curatable metadata; null = leave the solver-derived default. */
  stopsSolver?: InputMaybe<Scalars['Boolean']['input']>;
  targetKey: Scalars['String']['input'];
  targetKind: TtSolve_CatalogTargetKind;
};

export type TtSolve_UpsertRestriction = {
  arguments?: InputMaybe<Array<InputMaybe<Scalars['Object']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  restrictionIdx?: InputMaybe<Scalars['Int']['input']>;
  ruleId: TtSolve_RestrictionRuleId;
};

export type TtSolve_UpsertRestrictions = {
  restriction: Array<TtSolve_UpsertRestriction>;
  timetableId: Scalars['Int']['input'];
};

export type TtSolve_UpsertSolverServerInput = {
  cpus: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  host: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  permanent: Scalars['Boolean']['input'];
  port: Scalars['Int']['input'];
  protocol: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type TtSolver_ScheduleFilter = {
  classGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  groupTagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timetableId: Scalars['Int']['input'];
};

export type TtSolver_ScheduleLessonFilter = {
  lessonInstanceId: TtEditLessonPeriodInstanceId;
  timetableId: Scalars['Int']['input'];
};

export type TtSolver_ScheduleOnPeriodOptionsFilter = {
  timeslotId?: InputMaybe<TtTimeslotIdInput>;
  timetableId: Scalars['Int']['input'];
};

export type TtStudentOptions_Import = {
  groupTagId: Scalars['Int']['input'];
  studentOptionsId: Scalars['Int']['input'];
  timetableId: Scalars['Int']['input'];
};

export enum TtValidation_Action {
  EditBlockSpread = 'EDIT_BLOCK_SPREAD',
  EditTimetableGroup = 'EDIT_TIMETABLE_GROUP',
  EditTimetableGroupLessons = 'EDIT_TIMETABLE_GROUP_LESSONS',
  None = 'NONE'
}

export enum TtValidation_FeasibilityLevel {
  Pin = 'PIN',
  Structure = 'STRUCTURE'
}

export type TtValidation_Filter = {
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  timetableId: Scalars['Int']['input'];
};

export enum TtValidation_Level {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export enum TtValidation_RuleId {
  ClashBlock = 'CLASH_BLOCK',
  ClashCore = 'CLASH_CORE',
  ClashRoom = 'CLASH_ROOM',
  ClashSelf = 'CLASH_SELF',
  ClashTeacher = 'CLASH_TEACHER',
  ClassGroupOverPeriods = 'CLASS_GROUP_OVER_PERIODS',
  ClassGroupUnderPeriods = 'CLASS_GROUP_UNDER_PERIODS'
}

export type TtValidation_Validation = {
  __typename?: 'TtValidation_Validation';
  actions: Array<Tt_Action>;
  associatedBlockIds: Array<Scalars['String']['output']>;
  /** class groups this relates to */
  associatedClassGroupIds: Array<Scalars['Long']['output']>;
  associatedRoomIds: Array<Scalars['Int']['output']>;
  associatedStaffIds: Array<Scalars['Long']['output']>;
  associatedTimetableGroupIds: Array<Scalars['Long']['output']>;
  /** the solver-catalogue constraint key this validation maps to (null when it doesn't resolve); lets the client join to the catalogue */
  catalogueKey?: Maybe<Scalars['String']['output']>;
  contextMessage?: Maybe<Scalars['String']['output']>;
  /** feasibility results only: whether the problem is a pin or a structural one (null otherwise) */
  feasibilityLevel?: Maybe<TtValidation_FeasibilityLevel>;
  id: Scalars['String']['output'];
  /** displayed when viewing all errors */
  rootMessage?: Maybe<Scalars['String']['output']>;
  /** catalogue metadata: this validation must be resolved before the solver can run */
  stopsSolver: Scalars['Boolean']['output'];
  /** not for now but thinking it would be nice if on particular error you could diectly click an action and bring up a modal */
  validationAction?: Maybe<TtValidation_Action>;
  validationLevel: TtValidation_Level;
  /** displayed when contextualy loolking at message */
  validationName: Scalars['String']['output'];
  validationRuleId: TtValidation_RuleId;
};

export type TtValidation_ValidationRootMove = {
  __typename?: 'TtValidation_ValidationRootMove';
  valid: ValidationMoveValidity;
  validations: Array<TtValidation_Validation>;
};

export type TtValidation_ValidationTimeslotMove = {
  __typename?: 'TtValidation_ValidationTimeslotMove';
  timeslotId: TtTimeslotId;
  valid: ValidationMoveValidity;
  validations: Array<TtValidation_Validation>;
};

export type TtValidation_Validations = {
  __typename?: 'TtValidation_Validations';
  /** Map lookup class id -> [Error message ids] */
  classGroupLookup?: Maybe<Scalars['Object']['output']>;
  /** Map lookup staff id -> [Error message ids] */
  staffLookup?: Maybe<Scalars['Object']['output']>;
  validations: Array<TtValidation_Validation>;
};

export type Tt_AcceptRejectSolverSwappedTeacher = Tt_Action & {
  __typename?: 'Tt_AcceptRejectSolverSwappedTeacher';
  label?: Maybe<Scalars['String']['output']>;
  type: Tt_Type;
};

export type Tt_Action = {
  label?: Maybe<Scalars['String']['output']>;
  type: Tt_Type;
};

export type Tt_AddLessonFilter = {
  timeslot: TtTimeslotIdInput;
  /**
   * todo optional filter to which is used to set the context from which you are ading a lesson. this should be party id
   * if 'Duty' is your context then it will return only duty groups. 6th year will return 6th year groups. A staff id will return all groups
   */
  timetableGroupIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_AddLessonInput = {
  dayIdx: Scalars['Int']['input'];
  gridIdx: Scalars['Int']['input'];
  periodIdx: Scalars['Int']['input'];
  roomId?: InputMaybe<Scalars['Int']['input']>;
  teachersPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  timetableGroupId: Scalars['Long']['input'];
  timetableId: Scalars['Int']['input'];
};

export type Tt_AddLessonOptions = {
  __typename?: 'Tt_AddLessonOptions';
  clashingGroups: Array<Tt_ClashingGroup>;
  clashingRooms: Array<Tt_ClashingRoom>;
  clashingStaff: Array<Tt_ClashingStaff>;
  freeRoomIds: Array<Scalars['Int']['output']>;
  freeRooms: Array<Room>;
  freeStaff: Array<Staff>;
  freeStaffIds: Array<Scalars['Long']['output']>;
  freeTimetableGroupIds: Array<Scalars['Long']['output']>;
  freeTimetableGroups: Array<Tt_Groups>;
};

export type Tt_AddPeriodToEnd = {
  dayIdx: Scalars['Int']['input'];
  endTime: Scalars['Time']['input'];
  gridIdx: Scalars['Int']['input'];
  type: TtGridPeriodType;
};

export type Tt_AddPeriodToStart = {
  dayIdx: Scalars['Int']['input'];
  gridIdx: Scalars['Int']['input'];
  startTime: Scalars['Time']['input'];
  type: TtGridPeriodType;
};

export type Tt_AddPeriodsToEnd = {
  periods: Array<Tt_AddPeriodToEnd>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_AddPeriodsToStart = {
  periods: Array<Tt_AddPeriodToStart>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_ClashingGroup = {
  __typename?: 'Tt_ClashingGroup';
  clashes: Array<TtIndividualViewLesson>;
  group: Tt_Groups;
};

export type Tt_ClashingRoom = {
  __typename?: 'Tt_ClashingRoom';
  clashes: Array<TtIndividualViewLesson>;
  room: Room;
};

export type Tt_ClashingStaff = {
  __typename?: 'Tt_ClashingStaff';
  clashes: Array<TtIndividualViewLesson>;
  staff: Staff;
};

export type Tt_CreateCheckpoint = {
  /** defaul to mainn TT name + datetime */
  name?: InputMaybe<Scalars['String']['input']>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_CreateTimetableInput = {
  fromRollover?: InputMaybe<Tt_CreateTimetableRolloverInput>;
  tyroOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Tt_CreateTimetableRolloverInput = {
  name: Scalars['String']['input'];
  rolloverFreeform?: InputMaybe<Scalars['Boolean']['input']>;
  rolloverNonTeaching?: InputMaybe<Scalars['Boolean']['input']>;
  rolloverSupport?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleLessonsFor?: InputMaybe<Array<Tt_RolloverScheduleGroupType>>;
};

export enum Tt_DataSource {
  Import = 'IMPORT',
  /** group which to same year within rollover. 1MatA -> 1MAtA */
  RolloverReplicated = 'ROLLOVER_REPLICATED',
  /** group which went to next year within rollover. 1MatA -> 2MAtA */
  RolloverRollover = 'ROLLOVER_ROLLOVER',
  StudentOptions = 'STUDENT_OPTIONS'
}

export type Tt_DeleteBlocks = {
  blockIds: Array<Scalars['String']['input']>;
  timetableGroupMode?: InputMaybe<Tt_DeleteBlocks_DeleteTimetableGroupMode>;
  timetableId: Scalars['Int']['input'];
};

export enum Tt_DeleteBlocks_DeleteTimetableGroupMode {
  Delete = 'DELETE',
  DoNotDelete = 'DO_NOT_DELETE'
}

export type Tt_DeleteClassGroups = {
  classGroupIds: Array<Scalars['Long']['input']>;
  timetableGroupMode?: InputMaybe<Tt_DeleteClassGroups_DeleteTimetableGroupMode>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_DeleteTimetableGroups = {
  timetableGroupIds: Array<Scalars['Long']['input']>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_DiffFilter = {
  /** true will return deep object by object comparison. false will return high level stats */
  deepDiff: Scalars['Boolean']['input'];
  diffBlocks: Scalars['Boolean']['input'];
  diffClassGroups: Scalars['Boolean']['input'];
  diffGroups: Scalars['Boolean']['input'];
  diffLessons: Scalars['Boolean']['input'];
  newTimetableId: Scalars['Int']['input'];
  oldTimetableId: Scalars['Int']['input'];
};

export type Tt_EditLessonFilter = {
  lessonInstance: Array<TtEditLessonPeriodInstanceId>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_EditLessonOptions = {
  __typename?: 'Tt_EditLessonOptions';
  clashingRooms: Array<Tt_ClashingRoom>;
  clashingStaff: Array<Tt_ClashingStaff>;
  freeRoomIds: Array<Scalars['Int']['output']>;
  freeRooms: Array<Room>;
  freeStaff: Array<Staff>;
  freeStaffIds: Array<Scalars['Long']['output']>;
  lessonId: TtIndividualViewLessonId;
};

export type Tt_ImportGroupsFromCore = {
  partyIds: Array<Scalars['Long']['input']>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_ImportSubjectCompetenciesFromCore = {
  academicNamespaceId: Scalars['Int']['input'];
  timetableId: Scalars['Int']['input'];
};

export type Tt_MigrateGrid = {
  fromGridIdx: Scalars['Int']['input'];
  timetableId: Scalars['Int']['input'];
  toGridIdx: Scalars['Int']['input'];
};

export type Tt_RemoveLessonBulk = {
  allWithMatchingGroupTagsIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_RemoveLessonInput = {
  lessonIdx: Scalars['Int']['input'];
  lessonInstanceIdx: Scalars['Int']['input'];
  timetableGroupId: Scalars['Long']['input'];
  timetableId: Scalars['Int']['input'];
};

export type Tt_ResetTimetableGroupNamesToDefault = {
  timetableGroupIds: Scalars['Int']['input'];
  timetableId: Scalars['Int']['input'];
};

export type Tt_RoomAssignment = {
  __typename?: 'Tt_RoomAssignment';
  currentLoadMinutes: Scalars['Int']['output'];
  currentLoadPeriods: Scalars['Int']['output'];
  freeform: Array<Tt_RoomAssignmentGroup>;
  lessonsAssigned: Scalars['Int']['output'];
  mainstream: Array<Tt_RoomAssignmentGroup>;
  maxLoadMinutes: Scalars['Int']['output'];
  maxLoadPeriods: Scalars['Int']['output'];
  nonTeaching: Array<Tt_RoomAssignmentGroup>;
  room: Room;
  roomId: Scalars['Int']['output'];
};

export type Tt_RoomAssignmentFilter = {
  timetableId: Scalars['Int']['input'];
};

export type Tt_RoomAssignmentGroup = {
  __typename?: 'Tt_RoomAssignmentGroup';
  group: Tt_Groups;
  isMultipleOTeachersOnLesson: Scalars['Boolean']['output'];
  lessonsAssigned: Scalars['Int']['output'];
  lessonsTotal: Scalars['Int']['output'];
  minutesTotal: Scalars['Int']['output'];
  splitIndicator: Scalars['Boolean']['output'];
};

export type Tt_RoomAssignmentUnassigned = {
  __typename?: 'Tt_RoomAssignmentUnassigned';
  currentLoadPeriods: Scalars['Int']['output'];
  freeform: Array<Tt_RoomAssignmentGroup>;
  lessonsAssigned: Scalars['Int']['output'];
  mainstream: Array<Tt_RoomAssignmentGroup>;
  maxLoadPeriods: Scalars['Int']['output'];
  nonTeaching: Array<Tt_RoomAssignmentGroup>;
};

export type Tt_RoomAssignments = {
  __typename?: 'Tt_RoomAssignments';
  assignments: Array<Tt_RoomAssignment>;
  solverStatus?: Maybe<TtSolve_SolverStatus>;
  stats: Tt_RoomAssignmentsStats;
  unassigned: Tt_RoomAssignmentUnassigned;
};

export type Tt_RoomAssignmentsStats = {
  __typename?: 'Tt_RoomAssignmentsStats';
  freeformCount: Scalars['Int']['output'];
  freeformRoomsAssignedCount: Scalars['Int']['output'];
  freeformRoomsUnassignedCount: Scalars['Int']['output'];
  mainstreamCount: Scalars['Int']['output'];
  mainstreamRoomsAssignedCount: Scalars['Int']['output'];
  mainstreamRoomsUnassignedCount: Scalars['Int']['output'];
  nonTeachingCount: Scalars['Int']['output'];
  nonTeachingRoomsAssignedCount: Scalars['Int']['output'];
  nonTeachingRoomsUnassignedCount: Scalars['Int']['output'];
  roomCountTotal: Scalars['Int']['output'];
  roomsFullyAllocatedCount: Scalars['Int']['output'];
  roomsOverAllocatedCount: Scalars['Int']['output'];
  roomsUnderAllocatedCount: Scalars['Int']['output'];
};

export type Tt_SplitPeriod = {
  dayIdx: Scalars['Int']['input'];
  gridIdx: Scalars['Int']['input'];
  periodIdx: Scalars['Int']['input'];
};

export type Tt_SplitPeriods = {
  splitPeriods: Array<Tt_SplitPeriod>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_SwapRoomAction = Tt_Action & {
  __typename?: 'Tt_SwapRoomAction';
  label?: Maybe<Scalars['String']['output']>;
  lessonIds: Array<TtIndividualViewLessonId>;
  teachingGroupId: Scalars['Long']['output'];
  type: Tt_Type;
};

export type Tt_SwapTeacherAction = Tt_Action & {
  __typename?: 'Tt_SwapTeacherAction';
  label?: Maybe<Scalars['String']['output']>;
  lessonIds: Array<TtIndividualViewLessonId>;
  teachingGroupId: Scalars['Long']['output'];
  type: Tt_Type;
};

export type Tt_TeacherAssignment = {
  __typename?: 'Tt_TeacherAssignment';
  currentLoadMinutes: Scalars['Int']['output'];
  freeform: Array<Tt_TeacherAssignmentGroup>;
  lessonsAssigned: Scalars['Int']['output'];
  mainstream: Array<Tt_TeacherAssignmentGroup>;
  maxLoadMinutes: Scalars['Int']['output'];
  nonTeaching: Array<Tt_TeacherAssignmentGroup>;
  staff: Staff;
  staffId: Scalars['Long']['output'];
};

export type Tt_TeacherAssignmentFilter = {
  groupTagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timetableId: Scalars['Int']['input'];
  weekIdx?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Tt_TeacherAssignmentGroup = {
  __typename?: 'Tt_TeacherAssignmentGroup';
  group: Tt_Groups;
  isMultipleOTeachersOnLesson: Scalars['Boolean']['output'];
  lessonsAssigned: Scalars['Int']['output'];
  lessonsTotal: Scalars['Int']['output'];
  minutesTotal: Scalars['Int']['output'];
  splitIndicator: Scalars['Boolean']['output'];
};

export type Tt_TeacherAssignmentUnassigned = {
  __typename?: 'Tt_TeacherAssignmentUnassigned';
  currentLoadMinutes: Scalars['Int']['output'];
  freeform: Array<Tt_TeacherAssignmentGroup>;
  lessonsAssigned: Scalars['Int']['output'];
  mainstream: Array<Tt_TeacherAssignmentGroup>;
  maxLoadMinutes: Scalars['Int']['output'];
  nonTeaching: Array<Tt_TeacherAssignmentGroup>;
};

export type Tt_TeacherAssignments = {
  __typename?: 'Tt_TeacherAssignments';
  assignments: Array<Tt_TeacherAssignment>;
  solverStatus?: Maybe<TtSolve_SolverStatus>;
  stats: Tt_TeacherAssignmentsStats;
  unassigned: Tt_TeacherAssignmentUnassigned;
};

export type Tt_TeacherAssignmentsStats = {
  __typename?: 'Tt_TeacherAssignmentsStats';
  freeformCount: Scalars['Int']['output'];
  freeformTeachersAssignedCount: Scalars['Int']['output'];
  freeformTeachersUnassignedCount: Scalars['Int']['output'];
  mainstreamCount: Scalars['Int']['output'];
  mainstreamTeachersAssignedCount: Scalars['Int']['output'];
  mainstreamTeachersUnassignedCount: Scalars['Int']['output'];
  teacherCountTotal: Scalars['Int']['output'];
  teachersFullyAllocatedCount: Scalars['Int']['output'];
  teachersOverAllocatedCount: Scalars['Int']['output'];
  teachersUnderAllocatedCount: Scalars['Int']['output'];
};

export enum Tt_Type {
  AcceptRejectSolverSwappedTeacher = 'ACCEPT_REJECT_SOLVER_SWAPPED_TEACHER',
  SwapRoom = 'SWAP_ROOM',
  SwapTeacher = 'SWAP_TEACHER'
}

export type Tt_UpdateLesson = {
  lessonInstanceId: TtEditLessonPeriodInstanceId;
  pinRoom?: InputMaybe<Scalars['Boolean']['input']>;
  pinTeachers?: InputMaybe<Scalars['Boolean']['input']>;
  pinTimeslot?: InputMaybe<Scalars['Boolean']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  roomPoolId?: InputMaybe<Scalars['Int']['input']>;
  teachersPartyIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  timeslot?: InputMaybe<TtTimeslotIdInput>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_UpdateLessons = {
  lessons: Array<Tt_UpdateLesson>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_UpdateRoomAssignment = {
  addToGroup?: InputMaybe<Array<Scalars['Long']['input']>>;
  pinToGroup?: InputMaybe<Array<Scalars['Long']['input']>>;
  poolIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  removeGroup?: InputMaybe<Array<Scalars['Long']['input']>>;
  staffId: Scalars['Long']['input'];
  unpinFromGroup?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Tt_UpdateRoomAssignments = {
  rooms: Array<Tt_UpdateRoomAssignment>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_UpdateTeacherAssignment = {
  addToGroup?: InputMaybe<Array<Scalars['Long']['input']>>;
  maxLoadMinutes?: InputMaybe<Scalars['Int']['input']>;
  pinToGroup?: InputMaybe<Array<Scalars['Long']['input']>>;
  removeGroup?: InputMaybe<Array<Scalars['Long']['input']>>;
  staffId: Scalars['Long']['input'];
  unpinFromGroup?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type Tt_UpdateTeacherAssignments = {
  teachers: Array<Tt_UpdateTeacherAssignment>;
  timetableId: Scalars['Int']['input'];
};

export type Tt_UpsertBlock = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  classGroupIds: Array<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
  timetableId: Scalars['Int']['input'];
};

export type Tt_UpsertClassGroup = {
  code: Scalars['String']['input'];
  groupTags: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  timetableId: Scalars['Int']['input'];
  ttClassGroupId?: InputMaybe<Scalars['Long']['input']>;
};

export type Tt_UpsertTimetableGroup = {
  allowAutoTeacherSwaps?: InputMaybe<Scalars['Boolean']['input']>;
  alsoUpdateLessonTeachers?: InputMaybe<Scalars['Boolean']['input']>;
  blockId?: InputMaybe<Scalars['String']['input']>;
  blockIdx?: InputMaybe<Scalars['Int']['input']>;
  classGroupId?: InputMaybe<Scalars['Long']['input']>;
  coScheduleTtGroupId?: InputMaybe<Scalars['Long']['input']>;
  groupTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  groupType: Tt_GroupType;
  maxClassSize?: InputMaybe<Scalars['Int']['input']>;
  membershipType: TtGroupStudentMembershipTypeEnum;
  name?: InputMaybe<Scalars['String']['input']>;
  partyId?: InputMaybe<Scalars['Long']['input']>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
  roomPoolId?: InputMaybe<Scalars['Int']['input']>;
  spread?: InputMaybe<Array<Scalars['Int']['input']>>;
  subjectIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  teachers?: InputMaybe<Array<Scalars['Long']['input']>>;
  timetableGroupId?: InputMaybe<Scalars['Long']['input']>;
  timetableId: Scalars['Int']['input'];
  totalLessonNoSpread?: InputMaybe<Scalars['Int']['input']>;
};

export type Tt_UpsertTimetableGroupRoom = {
  id: Scalars['Int']['input'];
  type: Tt_RoomOrPool;
};

export type Tt_UpsertTimetableGroups = {
  groups: Array<Tt_UpsertTimetableGroup>;
  timetableId: Scalars['Int']['input'];
};

export enum TuslaCode {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H'
}

export type Tyrone_Conversation = {
  __typename?: 'Tyrone_Conversation';
  createdOn: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  initialMessage: Scalars['String']['output'];
  partyId: Scalars['Long']['output'];
  updatedOn: Scalars['DateTime']['output'];
};

export type Tyrone_ConversationHistory = {
  __typename?: 'Tyrone_ConversationHistory';
  conversation: Tyrone_Conversation;
  messageCount: Scalars['Int']['output'];
  messages: Array<Tyrone_ConversationMessage>;
  totalCompletionTokens: Scalars['Int']['output'];
  totalCost: Scalars['Float']['output'];
  totalPromptTokens: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
};

export type Tyrone_ConversationMessage = {
  __typename?: 'Tyrone_ConversationMessage';
  completionTokens: Scalars['Int']['output'];
  conversationId: Scalars['String']['output'];
  createdOn: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  inputCost: Scalars['Float']['output'];
  outputCost: Scalars['Float']['output'];
  prompt: Scalars['String']['output'];
  promptTokens: Scalars['Int']['output'];
  requestNumber: Scalars['Int']['output'];
  response: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
  totalTokens: Scalars['Int']['output'];
};

export type Tyrone_ConversationUsage = {
  __typename?: 'Tyrone_ConversationUsage';
  conversationId: Scalars['String']['output'];
  requestCount: Scalars['Int']['output'];
  totalCompletionTokens: Scalars['Int']['output'];
  totalCost: Scalars['Float']['output'];
  totalPromptTokens: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
};

export type Tyrone_GenerateReportLayoutInput = {
  /**
   * Re-use across turns of the same plan-the-report conversation. Pass the
   * conversationId returned from the previous turn so the agent remembers
   * what's already been discussed. Omit / null on the first turn.
   */
  conversationId?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
};

export enum Tyrone_GenerateReportLayoutKind {
  Question = 'QUESTION',
  Widgets = 'WIDGETS'
}

/**
 * Result of one turn of report-layout planning. `kind` is QUESTION when the
 * agent is still gathering information (the chat message lives in `message`)
 * and WIDGETS when it has emitted a final JSON array of widgets in `widgets`.
 * The same `conversationId` is returned every turn — pass it back on the next
 * input so the agent remembers what's already been discussed. `droppedCount`
 * counts widgets the LLM emitted that referenced unknown reportIds, metrics,
 * or groupings and were filtered out server-side.
 */
export type Tyrone_GenerateReportLayoutResult = {
  __typename?: 'Tyrone_GenerateReportLayoutResult';
  conversationId: Scalars['String']['output'];
  /**
   * Filter ids the agent suggests surfacing in the dashboard's top filter
   * bar, JSON-encoded as a `{filterId: value | null}` map. Always present;
   * "{}" when the agent didn't propose any. The frontend merges these into
   * the report's saved dashboard filters on Apply.
   */
  dashboardFilters: Scalars['String']['output'];
  droppedCount: Scalars['Int']['output'];
  kind: Tyrone_GenerateReportLayoutKind;
  message?: Maybe<Scalars['String']['output']>;
  /**
   * Suggested follow-up replies the user can click as buttons. The agent
   * populates this when offering 2–4 mutually-exclusive options
   * ("which dashboard would you like — A, B, or C?"). Empty for
   * open-ended replies.
   */
  options: Array<Scalars['String']['output']>;
  reasoning?: Maybe<Scalars['String']['output']>;
  totalCost: Scalars['Float']['output'];
  totalTokens: Scalars['Int']['output'];
  widgets: Scalars['String']['output'];
};

export type Tyrone_Prompt = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional page-context hints. When the user is viewing a specific
   * construction timetable, the front-end fills this in so tools that
   * need a timetableId can default to it instead of asking.
   */
  pageTimetableId?: InputMaybe<Scalars['Int']['input']>;
  prompt: Scalars['String']['input'];
};

export type Tyrone_PromptResult = {
  __typename?: 'Tyrone_PromptResult';
  completionTokens: Scalars['Int']['output'];
  conversationId: Scalars['String']['output'];
  inputCost: Scalars['Float']['output'];
  outputCost: Scalars['Float']['output'];
  promptTokens: Scalars['Int']['output'];
  result: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
  totalTokens: Scalars['Int']['output'];
};

export type UnreadCount = {
  __typename?: 'UnreadCount';
  count: Scalars['Int']['output'];
  labelId: Scalars['Long']['output'];
  labelType: LabelType;
  personPartyId: Scalars['Long']['output'];
};

export type UnreadCountFilter = {
  personPartyId: Scalars['Long']['input'];
};

export type UpdateCalendarInput = {
  academicNameSpaceId: Scalars['Int']['input'];
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type UpdateClassGroupGroupInput = {
  classGroupPartyId: Scalars['Long']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tutors?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type UpdateGeneralGroupInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  generalGroupPartyId: Scalars['Long']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  teachers?: InputMaybe<Array<UpdateGeneralGroupTeachersInput>>;
};

export type UpdateGeneralGroupTeachersInput = {
  roles: Array<StaffGroupMembershipRoles>;
  staffPartyId: Scalars['Long']['input'];
};

export type UpdateGradeSetInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  id: Scalars['Long']['input'];
  isCba?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  passFailThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNonClassContactHoursInput = {
  activity?: InputMaybe<Activity>;
  dayOfTheWeek?: InputMaybe<Day>;
  description?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  minutes?: InputMaybe<Scalars['Int']['input']>;
  nonClassContactHoursId: Scalars['Int']['input'];
  programme?: InputMaybe<Ncch_Programme>;
  staffPartyId: Scalars['Long']['input'];
};

export type UpdateParentalAttendanceRequest = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  attendanceCodeId?: InputMaybe<Scalars['Int']['input']>;
  attendanceNote?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  parentNote?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePermissionSet = {
  context?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  visibleToSchools?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProgrammeStageEnrollmentInput = {
  programmeStageEnrollmentPartyId: Scalars['Long']['input'];
  yearGroupLead?: InputMaybe<Scalars['Long']['input']>;
};

export type UpdateStaffInput = {
  addresses?: InputMaybe<Array<InputMaybe<InputAddress>>>;
  availableForSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  availableForSupportClasses?: InputMaybe<Scalars['Boolean']['input']>;
  availableForTeaching?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  carRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  competencies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  customFields?: InputMaybe<Array<InputMaybe<Core_PartyCustomFieldInput>>>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  displayCode?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<InputMaybe<InputEmailAddress>>>;
  emergencyContact?: InputMaybe<InputStaffEmergencyContact>;
  employmentCapacity?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  includeDtrReturns?: InputMaybe<Scalars['Boolean']['input']>;
  jobSharing?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  makeAndModel?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  noLongerStaffMember?: InputMaybe<Scalars['Boolean']['input']>;
  otherSchool1?: InputMaybe<Scalars['String']['input']>;
  otherSchool2?: InputMaybe<Scalars['String']['input']>;
  parking?: InputMaybe<Scalars['String']['input']>;
  payrollNumber?: InputMaybe<Scalars['String']['input']>;
  peopleTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<InputPhoneNumber>>>;
  position?: InputMaybe<Scalars['String']['input']>;
  ppsNumber?: InputMaybe<Scalars['String']['input']>;
  previousSchool1?: InputMaybe<Scalars['String']['input']>;
  previousSchool2?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Scalars['String']['input']>;
  qualifications2?: InputMaybe<Scalars['String']['input']>;
  qualifications3?: InputMaybe<Scalars['String']['input']>;
  qualifications4?: InputMaybe<Scalars['String']['input']>;
  staffPartyId: Scalars['Long']['input'];
  staffPost?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  teacherCouncilNumber?: InputMaybe<Scalars['String']['input']>;
  teacherReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  titleId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStudentContactInput = {
  contactPartyId: Scalars['Long']['input'];
  customFields?: InputMaybe<Array<InputMaybe<Core_PartyCustomFieldInput>>>;
  postalTitle?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStudentInput = {
  /** non ppod handled */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  addressLine4?: InputMaybe<Scalars['String']['input']>;
  addressLine5?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  birthCertFirstName?: InputMaybe<Scalars['String']['input']>;
  birthCertSurname?: InputMaybe<Scalars['String']['input']>;
  boardingDays?: InputMaybe<Scalars['String']['input']>;
  borderIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<Core_PartyCustomFieldInput>>>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dateOfLeaving?: InputMaybe<Scalars['Date']['input']>;
  deceased?: InputMaybe<Scalars['Boolean']['input']>;
  deceasedDate?: InputMaybe<Scalars['Date']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  destinationRollNo?: InputMaybe<Scalars['String']['input']>;
  dpin?: InputMaybe<Scalars['Long']['input']>;
  examEntrant?: InputMaybe<Scalars['Boolean']['input']>;
  examNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  guardianshipNote?: InputMaybe<Scalars['String']['input']>;
  languageSupportApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leavingReason?: InputMaybe<StudentLeavingReason>;
  leftEarly?: InputMaybe<Scalars['Boolean']['input']>;
  lockerNumber?: InputMaybe<Scalars['String']['input']>;
  medicalCard?: InputMaybe<Scalars['Boolean']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mothersMaidenName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  pps?: InputMaybe<Scalars['String']['input']>;
  preferredFirstName?: InputMaybe<Scalars['String']['input']>;
  preferredLastName?: InputMaybe<Scalars['String']['input']>;
  previousSchoolRollNumber?: InputMaybe<Scalars['String']['input']>;
  previousSchoolType?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  religion?: InputMaybe<Scalars['String']['input']>;
  repeatYear?: InputMaybe<Scalars['Boolean']['input']>;
  shortTermPupil?: InputMaybe<Scalars['Boolean']['input']>;
  shortTermPupilNumWeeks?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  studentPartyId: Scalars['Long']['input'];
  travellerHeritage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSubject = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  colour?: InputMaybe<Colour>;
  description?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  examinable?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  shortCode?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  subjectId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSubjectGroupInput = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  classGroupId?: InputMaybe<Scalars['Long']['input']>;
  irePP?: InputMaybe<UpdateSubjectGroupIrePpInput>;
  membershipType?: InputMaybe<SubjectGroupStudentMembershipTypeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  subjectGroupPartyId: Scalars['Long']['input'];
  subjectGroupType?: InputMaybe<SubjectGroupType>;
  subjectIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  teachers?: InputMaybe<Array<UpdateSubjectGroupTeachersInput>>;
};

export type UpdateSubjectGroupIrePpInput = {
  examinable?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<StudyLevel>;
};

export type UpdateSubjectGroupTeachersInput = {
  roles: Array<StaffGroupMembershipRoles>;
  staffPartyId: Scalars['Long']['input'];
};

export type UpdateSubscriptionCardInput = {
  paymentMethodId: Scalars['String']['input'];
  paymentPlanIds: Array<Scalars['Int']['input']>;
};

export type UpdateYearGroupEnrollmentInput = {
  yearGroupEnrollmentPartyId: Scalars['Long']['input'];
  yearGroupLead?: InputMaybe<Scalars['Long']['input']>;
};

export type UpdatingBellTimeInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type UpsertBlockInput = {
  blockId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  generalGroupIds: Array<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
};

export type UpsertBuildingInput = {
  campusId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/** ## Creates or replaces grid on calendar */
export type UpsertCalendarGrid = {
  days?: InputMaybe<Array<InputMaybe<UpsertGridDay>>>;
  idx: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** date grid is val from. null means the start of the calendar date */
  validFrom?: InputMaybe<Scalars['Date']['input']>;
};

export type UpsertCampusInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type UpsertCampusTravelTimeInput = {
  fromCampusId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  minutes: Scalars['Int']['input'];
  toCampusId: Scalars['Int']['input'];
};

export type UpsertGridDay = {
  /** iso day of week. 1 monday .. 7 sunday */
  dayOfWeek: Scalars['Int']['input'];
  /** the distinct number and order for the days */
  idx: Scalars['Int']['input'];
  periods: Array<UpsertGridPeriod>;
};

export type UpsertGridPeriod = {
  endTime: Scalars['Time']['input'];
  followOnPeriodIdx?: InputMaybe<Scalars['Int']['input']>;
  /** the distinct number and order for the periods */
  idx: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** periods are sequential with no gapes between them */
  startTime: Scalars['Time']['input'];
  type: CalendarGridPeriodType;
};

export type UpsertRoomInput = {
  buildingId?: InputMaybe<Scalars['Int']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
  includeInTimetable?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  /** mandatory on create */
  name?: InputMaybe<Scalars['String']['input']>;
  pools?: InputMaybe<Array<Scalars['Int']['input']>>;
  roomId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertRoomPool = {
  colour: Colour;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  roomsIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type UpsertStaffInput = {
  addresses?: InputMaybe<Array<InputMaybe<InputAddress>>>;
  availableForSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  availableForSupportClasses?: InputMaybe<Scalars['Boolean']['input']>;
  availableForTeaching?: InputMaybe<Scalars['Boolean']['input']>;
  carRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  competencies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  customFields?: InputMaybe<Array<InputMaybe<Core_PartyCustomFieldInput>>>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  displayCode?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<InputMaybe<InputEmailAddress>>>;
  emergencyContact?: InputMaybe<InputStaffEmergencyContact>;
  employmentCapacity?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  externalSystemInfo?: InputMaybe<ExternalSystemInfo>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Long']['input']>;
  jobSharing?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  makeAndModel?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  nextOfKin?: InputMaybe<InputNextOfKin>;
  noLongerStaff?: InputMaybe<Scalars['Boolean']['input']>;
  parking?: InputMaybe<Scalars['String']['input']>;
  payrollNumber?: InputMaybe<Scalars['String']['input']>;
  personalInformationId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<InputPhoneNumber>>>;
  position?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Scalars['String']['input']>;
  staffIre?: InputMaybe<UpsertStaffIreInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  titleId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertStaffIreInput = {
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  includeDtrReturns?: InputMaybe<Scalars['Boolean']['input']>;
  otherSchool1?: InputMaybe<Scalars['String']['input']>;
  otherSchool2?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  pps?: InputMaybe<Scalars['String']['input']>;
  previousSchool1?: InputMaybe<Scalars['String']['input']>;
  previousSchool2?: InputMaybe<Scalars['String']['input']>;
  qualifications2?: InputMaybe<Scalars['String']['input']>;
  qualifications3?: InputMaybe<Scalars['String']['input']>;
  qualifications4?: InputMaybe<Scalars['String']['input']>;
  religion?: InputMaybe<Scalars['String']['input']>;
  staffPost?: InputMaybe<Scalars['Int']['input']>;
  teacherCouncilNumber?: InputMaybe<Scalars['String']['input']>;
  teacherReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertStudentContactInput = {
  addresses?: InputMaybe<Array<InputMaybe<InputAddress>>>;
  contactPartyId?: InputMaybe<Scalars['Long']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<Core_PartyCustomFieldInput>>>;
  emails?: InputMaybe<Array<InputMaybe<InputEmailAddress>>>;
  externalSystemInfo?: InputMaybe<ExternalSystemInfo>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  personal: PersonalInformationInput;
  phoneNumbers?: InputMaybe<Array<InputMaybe<InputPhoneNumber>>>;
  postalTitle?: InputMaybe<Scalars['String']['input']>;
  requiresInterpreter?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  studentRelationships: Array<InputMaybe<UpsertStudentContactRelationshipInfoInput>>;
  titleId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertStudentContactRelationshipInfoInput = {
  allowAccessToStudentData: Scalars['Boolean']['input'];
  allowedToContact: Scalars['Boolean']['input'];
  includeInSms: Scalars['Boolean']['input'];
  includeInTemplating: Scalars['Boolean']['input'];
  includeInTmail: Scalars['Boolean']['input'];
  legalGuardian: Scalars['Boolean']['input'];
  pickupRights: Scalars['Boolean']['input'];
  priority: Scalars['Int']['input'];
  relationshipType: StudentContactType;
  studentPartyId: Scalars['Long']['input'];
};

export type UpsertStudentMedicalConditionEquipmentInput = {
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  firstRespondersIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertStudentMedicalConditionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  emergencyPlan?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Array<UpsertStudentMedicalConditionEquipmentInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  studentPartyId: Scalars['Long']['input'];
};

export type UpsertStudentMedicalContactInput = {
  additionalPhone?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  personalTitleId?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  studentPartyId: Scalars['Long']['input'];
};

export type UpsertStudentSubjectGroup = {
  examinable?: InputMaybe<Scalars['Boolean']['input']>;
  partyId: Scalars['Long']['input'];
  studyLevel?: InputMaybe<StudyLevel>;
  subjectGroupId?: InputMaybe<Scalars['Long']['input']>;
  subjectId?: InputMaybe<Scalars['Int']['input']>;
  targetGradeId?: InputMaybe<Scalars['Long']['input']>;
  targetResult?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertTenantSettingsInput = {
  comregName?: InputMaybe<Scalars['String']['input']>;
  eircode?: InputMaybe<Scalars['String']['input']>;
  goLiveOn?: InputMaybe<Scalars['Date']['input']>;
  latitude?: InputMaybe<Scalars['BigDecimal']['input']>;
  longitude?: InputMaybe<Scalars['BigDecimal']['input']>;
  organizationTenant?: InputMaybe<Scalars['Int']['input']>;
  xeroId?: InputMaybe<Scalars['String']['input']>;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  blocked: Scalars['Boolean']['output'];
  contactInfo?: Maybe<Array<Maybe<UserAccess_Contact_Info>>>;
  contactStudents?: Maybe<Array<Maybe<Person>>>;
  globalUserId?: Maybe<Scalars['Int']['output']>;
  invitationId?: Maybe<Scalars['Long']['output']>;
  invitedEmail?: Maybe<Scalars['String']['output']>;
  invitedOn?: Maybe<Scalars['DateTime']['output']>;
  invitingPersonPartyId?: Maybe<Scalars['Long']['output']>;
  invitingPersonalInfo?: Maybe<PersonalInformation>;
  isMicrosoftEntraDeleted?: Maybe<Scalars['Boolean']['output']>;
  microsoftEntraId?: Maybe<Scalars['String']['output']>;
  mobileAppVersion?: Maybe<Scalars['String']['output']>;
  mobileLastLogin?: Maybe<Scalars['DateTime']['output']>;
  personPartyId: Scalars['Long']['output'];
  personalInfo: PersonalInformation;
  profileId: Scalars['Int']['output'];
  status?: Maybe<UserAccessStatus>;
  webLastLogin?: Maybe<Scalars['DateTime']['output']>;
  yearGroup?: Maybe<YearGroupEnrollment>;
  yearGroupContacts?: Maybe<Array<Maybe<YearGroupEnrollment>>>;
};

export type UserAccessFilter = {
  partyIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  userType: AccessUserType;
};

export enum UserAccessStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  InviteSent = 'INVITE_SENT'
}

export type UserAccessValidation = {
  __typename?: 'UserAccessValidation';
  associatedUsers: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UserAccess_Contact_Info = {
  __typename?: 'UserAccess_Contact_Info';
  classGroup?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  id: Scalars['String']['output'];
  permissionType?: Maybe<PermissionType>;
};

export enum UserType {
  Admin = 'ADMIN',
  Contact = 'CONTACT',
  External = 'EXTERNAL',
  Student = 'STUDENT',
  Teacher = 'TEACHER',
  ThirdParty = 'THIRD_PARTY',
  Tyro = 'TYRO'
}

export type Users_AdminPerson = {
  __typename?: 'Users_AdminPerson';
  account: Users_AdminPersonalInfo;
  otherAccounts: Array<Users_AdminPersonalInfo>;
};

export type Users_AdminPersonalInfo = {
  __typename?: 'Users_AdminPersonalInfo';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  globalUserId: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  partyId: Scalars['Long']['output'];
  primaryEmail?: Maybe<EmailAddress>;
  profileId: Scalars['Int']['output'];
  tenant: Scalars['Int']['output'];
  tenantName: Scalars['String']['output'];
  type?: Maybe<PartyPersonType>;
};

export type Users_Admin_AddUserToTenantInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  globalUserId?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  permissionGroupId?: InputMaybe<Scalars['Int']['input']>;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
  tenant: Scalars['Int']['input'];
};

export type Users_Admin_PermissionGroupOption = {
  __typename?: 'Users_Admin_PermissionGroupOption';
  custom?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  memberType?: Maybe<MemberType>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Users_CreateEmptyTenantInput = {
  academicYear: Scalars['Int']['input'];
  academicYearEndDate: Scalars['Date']['input'];
  academicYearStartDate: Scalars['Date']['input'];
  name: Scalars['String']['input'];
  rollNo?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['Int']['input'];
  tenantType?: InputMaybe<TenantType>;
};

export type Users_DefaultPermission = {
  __typename?: 'Users_DefaultPermission';
  group: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  permissionSetId: Scalars['String']['output'];
  permissionType?: Maybe<PermissionType>;
};

export type Users_DeleteDefaultPermission = {
  id: Scalars['Int']['input'];
};

export type Users_DeletePermissionGroup = {
  id: Scalars['Int']['input'];
};

export type Users_DeleteThirdPartyAccountInput = {
  userType?: InputMaybe<ThirdPartyUserType>;
};

export type Users_ProvisionMicroSoftEntraIdsInput = {
  collisionsPolicy: CollisionPolicy;
  /**
   * if domain and copy email is both populated, we should then we should append the domain to
   * the end and convert the email @ symbol to a HASH.
   * E.G. john_smith1#tryo.school@tyrotechnologies.onmicrosoft.com
   */
  copyEmail?: InputMaybe<Scalars['Boolean']['input']>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  nameFormat: NameFormat;
  override?: InputMaybe<Scalars['Boolean']['input']>;
  partyIds: Array<Scalars['Long']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
};

export type Users_ProvisionThirdPartyInput = {
  reprovision?: InputMaybe<Scalars['Boolean']['input']>;
  userType?: InputMaybe<ThirdPartyUserType>;
};

export type Users_ResetPassword = {
  partyIds: Array<Scalars['Long']['input']>;
};

export type Users_SaveDefaultPermission = {
  group: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  permissionSetId: Scalars['String']['input'];
  permissionType?: InputMaybe<PermissionType>;
};

export type Users_ThirdParty = {
  __typename?: 'Users_ThirdParty';
  createdBy: Person;
  createdByPartyId: Scalars['Long']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  type: ThirdPartyUserType;
};

export type Users_ThirdPartyProvisionResponse = {
  __typename?: 'Users_ThirdPartyProvisionResponse';
  secret?: Maybe<Scalars['String']['output']>;
};

export type Users_ToggleDeleteMicrosoftEntraUserInput = {
  delete: Scalars['Boolean']['input'];
  partyId: Scalars['Long']['input'];
};

export type Users_UpdateTenantRowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['Int']['input'];
};

export type Users_UpdateTenantsInput = {
  updates: Array<Users_UpdateTenantRowInput>;
};

export type Users_UserPermission = {
  __typename?: 'Users_UserPermission';
  description: Scalars['String']['output'];
  feature: Feature;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissionGroups: Array<Users_UserPermissionGroup>;
};

export type Users_UserPermissionGroup = {
  __typename?: 'Users_UserPermissionGroup';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ValidateUserProfile = {
  code: Scalars['String']['input'];
};

export enum ValidationMoveValidity {
  Allowed = 'ALLOWED',
  Disallowed = 'DISALLOWED',
  Warning = 'WARNING'
}

export type VisitorSignInOut = SignInOut & {
  __typename?: 'VisitorSignInOut';
  createdBy: Staff;
  createdByPartyId: Scalars['Long']['output'];
  dateTime: Scalars['DateTime']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  signInOutPersonType: Attendance_SignInOutPersonType;
  signInOutStatus: Attendance_SignInOutStatus;
  type: Attendance_SignInOutType;
  visitingStaff: Staff;
  visitingStaffPartyId: Scalars['Long']['output'];
};

export type Wellbeing_DeleteStudentAenInput = {
  id: Scalars['Int']['input'];
  studentPartyId: Scalars['Long']['input'];
};

export type Wellbeing_StudentAen = {
  __typename?: 'Wellbeing_StudentAen';
  entries: Array<Wellbeing_StudentAenEntry>;
  student?: Maybe<Student>;
  studentPartyId: Scalars['Long']['output'];
};

export type Wellbeing_StudentAenEntry = {
  __typename?: 'Wellbeing_StudentAenEntry';
  contact?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  provision?: Maybe<Scalars['String']['output']>;
  snaSupport?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  studentPartyId: Scalars['Long']['output'];
  supportType?: Maybe<SupportType>;
  type?: Maybe<Scalars['String']['output']>;
  typeNote?: Maybe<Scalars['String']['output']>;
};

export type Wellbeing_UpsertStudentAenInput = {
  contact?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  provision?: InputMaybe<Scalars['String']['input']>;
  snaSupport?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  studentPartyId: Scalars['Long']['input'];
  supportType?: InputMaybe<SupportType>;
  type?: InputMaybe<Scalars['String']['input']>;
  typeNote?: InputMaybe<Scalars['String']['input']>;
};

export type WithdrawParentalAttendanceRequest = {
  id: Scalars['Long']['input'];
};

export enum WriteOffAction {
  Undo = 'UNDO',
  WriteOff = 'WRITE_OFF'
}

export type WriteOffInput = {
  action: WriteOffAction;
  feeId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  partyIds: Array<Scalars['Long']['input']>;
};

export type XeroContact = {
  __typename?: 'XeroContact';
  currentMonthlySpend: Scalars['Float']['output'];
  xeroContactId: Scalars['String']['output'];
};

export enum XeroProduct {
  RulesEngine = 'RULES_ENGINE',
  Sms = 'SMS'
}

export type YearGroup = {
  __typename?: 'YearGroup';
  description?: Maybe<Scalars['String']['output']>;
  descriptionTextId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nameTextId: Scalars['Int']['output'];
  nationalCode: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  shortNameTextId: Scalars['Int']['output'];
  yearGroupId: Scalars['Int']['output'];
};

export type YearGroupEnrollment = Party & PartyGroup & {
  __typename?: 'YearGroupEnrollment';
  academicNamespaceId: Scalars['Int']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupTagIds: Array<Scalars['Int']['output']>;
  groupTags: Array<GroupTag>;
  includeInTimetable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nationalCode: Scalars['String']['output'];
  partyId: Scalars['Long']['output'];
  shortName: Scalars['String']['output'];
  source?: Maybe<Core_PartySource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  studentMembers: Group;
  students: Array<Student>;
  yearGroupEnrollmentPartyId: Scalars['Long']['output'];
  yearGroupId: Scalars['Int']['output'];
  yearGroupLeads: Array<Person>;
};

export type YearGroupEnrollmentFilter = {
  academicNamespaceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  yearGroupEnrollmentPartyId?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  yearGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type YearGroupFilter = {
  years?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Dyn_SystemSettings = {
  __typename?: 'dyn_SystemSettings';
  advancedPermissions_form_enabled?: Maybe<Scalars['Boolean']['output']>;
  advancedPermissions_notesVtwo_enabled?: Maybe<Scalars['Boolean']['output']>;
  advancedPermissions_studentNote_enabled?: Maybe<Scalars['Boolean']['output']>;
  advancedPermissions_timetable_enabled?: Maybe<Scalars['Boolean']['output']>;
  attendance_applySupportAttendance_attendanceCode?: Maybe<Scalars['Int']['output']>;
  attendance_applySupportAttendance_enabled?: Maybe<Scalars['Boolean']['output']>;
  attendance_applySupportAttendance_skipWhereStaffAbsent?: Maybe<Scalars['Boolean']['output']>;
  attendance_awol_defaultMode: Catalogue_FeatureFlag;
  attendance_awol_includeBells: Catalogue_FeatureFlag;
  attendance_awol_includeSchoolActivities: Catalogue_FeatureFlag;
  attendance_bellTimes_overlappingBellTimes?: Maybe<Scalars['Boolean']['output']>;
  attendance_overdue_numberOfDaysWidgetShows?: Maybe<Scalars['Int']['output']>;
  attendance_shareAttendanceNote_enabled?: Maybe<Scalars['Boolean']['output']>;
  attendance_signInOut_collectedBy: CollectedByMode;
  attendance_signInOut_defaultSignInAttendanceCode?: Maybe<Scalars['Int']['output']>;
  attendance_signInOut_defaultSignOutAttendanceCode?: Maybe<Scalars['Int']['output']>;
  attendance_signInOut_kioskSignIn?: Maybe<Scalars['Boolean']['output']>;
  attendance_signInOut_kioskSignOut?: Maybe<Scalars['Boolean']['output']>;
  attendance_signInOut_kioskSignOutNoAbsenceRequest?: Maybe<Scalars['Boolean']['output']>;
  attendance_signInOut_kioskSignOutThresholdLimit?: Maybe<Scalars['Int']['output']>;
  attendance_subjectGroupAttendance_customSubjectGroupAttendanceCodes: Array<Scalars['Int']['output']>;
  attendance_thresholds_lower?: Maybe<Scalars['Int']['output']>;
  attendance_thresholds_middle?: Maybe<Scalars['Int']['output']>;
  behaviour_contacts_hideDetails?: Maybe<Scalars['Boolean']['output']>;
  behaviour_quickActions_list?: Maybe<Scalars['Object']['output']>;
  calendar_events_showCancelledEventsToStaff?: Maybe<Scalars['Boolean']['output']>;
  calendar_events_showCancelledEventsToStudent?: Maybe<Scalars['Boolean']['output']>;
  calendar_events_staffAbsenceCancelEvent?: Maybe<Scalars['Boolean']['output']>;
  communications_email_emailReminder?: Maybe<Scalars['Boolean']['output']>;
  communications_push_cancelledEventsNotification?: Maybe<Scalars['Boolean']['output']>;
  communications_sms_smsReminder?: Maybe<Scalars['Boolean']['output']>;
  communications_sms_studentSms?: Maybe<Scalars['Boolean']['output']>;
  featureFlag_assessments_stateCba: Catalogue_FeatureFlag;
  featureFlag_attendance_sessionAttendance: Catalogue_FeatureFlag;
  featureFlag_forms_newFormsSection: Catalogue_FeatureFlag;
  featureFlag_rulesEngine_rulesEnginePlus: Catalogue_FeatureFlag;
  featureFlag_security_advancedPermissions: Catalogue_FeatureFlag;
  featureFlag_settings_peapod: Catalogue_FeatureFlag;
  featureFlag_studentOptions_fullFeature: Catalogue_FeatureFlag;
  featureFlag_userAccess_sds: Catalogue_FeatureFlag;
  fees_feeForm_hideAbsorbFees?: Maybe<Scalars['Boolean']['output']>;
  groupTags_groupsMenu_showHouse?: Maybe<Scalars['Boolean']['output']>;
  groupTags_groupsMenu_showProgrammeStages?: Maybe<Scalars['Boolean']['output']>;
  groupTags_groupsMenu_showYears?: Maybe<Scalars['Boolean']['output']>;
  groupTags_programmeStage_enabledStages: Array<Scalars['Int']['output']>;
  language_translation_enableSwitching?: Maybe<Scalars['Boolean']['output']>;
  language_translation_glossary?: Maybe<Scalars['Object']['output']>;
  layout_dashboard_customisationMode?: Maybe<Scalars['String']['output']>;
  noticeboard_display_alwaysShowPinned?: Maybe<Scalars['Boolean']['output']>;
  people_display_teacherDisplayNameType: Core_StaffNameDisplayType;
  ppod_publish_publishYear?: Maybe<Scalars['Int']['output']>;
  ppod_sync_createNextYearsFirstYearGroup?: Maybe<Scalars['Boolean']['output']>;
  rulesEngine_configuration_enabled?: Maybe<Scalars['Boolean']['output']>;
  schoolActivity_attendance_defaultAttendanceCode?: Maybe<Scalars['Int']['output']>;
  security_access_customGroupsInSecurityModel?: Maybe<Scalars['Boolean']['output']>;
  security_dataPrivacy_confirmBeforeShowingSensitiveData?: Maybe<Scalars['Boolean']['output']>;
  security_geoBlocking_geoLockUsers?: Maybe<Scalars['Boolean']['output']>;
  security_logout_inactiveTimeUntilLogoutMinutes?: Maybe<Scalars['Int']['output']>;
  security_summerMode_blockAccess?: Maybe<Scalars['Boolean']['output']>;
  security_summerMode_enableForUserTypes: Array<Scalars['String']['output']>;
  security_summerMode_enabled?: Maybe<Scalars['Boolean']['output']>;
  security_summerMode_excludeStaff: Array<Scalars['Int']['output']>;
  security_summerMode_hideGroups: Array<Scalars['Int']['output']>;
  security_summerMode_hideTimetable: Array<Scalars['Int']['output']>;
  security_twoFactorAuthentication_enableForUserTypes: Array<Scalars['String']['output']>;
  social_thirdParties_facebook?: Maybe<Scalars['Boolean']['output']>;
  social_thirdParties_instagram?: Maybe<Scalars['Boolean']['output']>;
  social_thirdParties_twitter?: Maybe<Scalars['Boolean']['output']>;
  subject_subject_subjectSets: Array<Scalars['Int']['output']>;
  substitution_alsoApplySuggestion_enableForCombinedPeriod?: Maybe<Scalars['Boolean']['output']>;
  substitution_display_showAbsenceReason?: Maybe<Scalars['Boolean']['output']>;
  substitution_display_showStaffNotNeedingCoverOnCoverScreen?: Maybe<Scalars['Boolean']['output']>;
  substitution_display_teacherDisplayNameType: Core_StaffNameDisplayType;
  timetable_construction_blockGroupNameFormat?: Maybe<Scalars['String']['output']>;
  timetable_construction_blockSupportGroupNameFormat?: Maybe<Scalars['String']['output']>;
  timetable_construction_coreGroupNameFormat?: Maybe<Scalars['String']['output']>;
  timetable_construction_defaultToTableViewInBlockCores?: Maybe<Scalars['Boolean']['output']>;
  timetable_construction_enableCampusRules?: Maybe<Scalars['Boolean']['output']>;
  timetable_construction_enableSettingSpreadOnLiveTimetable?: Maybe<Scalars['Boolean']['output']>;
  timetable_construction_treatSupportGroupingsAsClassGroupsForSolver?: Maybe<Scalars['Boolean']['output']>;
  timetable_construction_tutorialSubjects: Array<Scalars['Int']['output']>;
  timetable_twoWeekTimetable_enabled?: Maybe<Scalars['Boolean']['output']>;
  timetable_twoWeekTimetable_weekOneStartDate?: Maybe<Scalars['Date']['output']>;
};

export enum Sdsd {
  Term = 'TERM'
}

export type Calendar_ViewAnaConnectsQueryVariables = Exact<{
  filter?: InputMaybe<Calender_FollowFilter>;
}>;


export type Calendar_ViewAnaConnectsQuery = { __typename?: 'Query', calendar_viewFollows: Array<{ __typename?: 'Calendar_Follow', followId: number, fromDate?: string | null, toDate?: string | null, eventIds: Array<number>, followerParties: Array<{ __typename: 'GeneralGroup' } | { __typename: 'ProgrammeStageEnrollment' } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student' } | { __typename: 'StudentContact' } | { __typename: 'SubjectGroup' } | { __typename: 'YearGroupEnrollment' }>, followedParties: Array<{ __typename: 'GeneralGroup' } | { __typename: 'ProgrammeStageEnrollment' } | { __typename: 'Staff' } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact' } | { __typename: 'SubjectGroup' } | { __typename: 'YearGroupEnrollment' }>, events: Array<{ __typename?: 'CalendarEvent', eventId: number, startTime: string, endTime: string, colour?: Colour | null, name: string }>, createdBy: { __typename?: 'AuditPerson', person?: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null }, updatedBy: { __typename?: 'AuditPerson', person?: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null } }> };

export type Calendar_UpsertAnaConnectsMutationVariables = Exact<{
  input: Calendar_FollowUpsert;
}>;


export type Calendar_UpsertAnaConnectsMutation = { __typename?: 'Mutation', calendar_upsertFollower?: { __typename?: 'Calendar_FollowUpsertResult', success: boolean, clashes: Array<{ __typename?: 'Calendar_FollowClashError', followEventId: number, followEventName?: string | null, clashingEvents: Array<{ __typename?: 'Calendar_FollowClashDetails', eventName: string, startTime: string, clashingParties: Array<{ __typename?: 'GeneralGroup' } | { __typename?: 'ProgrammeStageEnrollment' } | { __typename?: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename?: 'Student' } | { __typename?: 'StudentContact' } | { __typename?: 'SubjectGroup' } | { __typename?: 'YearGroupEnrollment' }> }> }> } | null };

export type Calendar_DeleteAnaConnectsMutationVariables = Exact<{
  input: Calendar_FollowDelete;
}>;


export type Calendar_DeleteAnaConnectsMutation = { __typename?: 'Mutation', calendar_deleteFollowers?: { __typename?: 'Success', success?: boolean | null } | null };

export type Communications_NotificationsQueryVariables = Exact<{
  filter?: InputMaybe<NotificationFilter>;
}>;


export type Communications_NotificationsQuery = { __typename?: 'Query', communications_notifications: Array<{ __typename?: 'Notification', id: number, title: string, text: string, notificationType: NotificationType, sentOn: string, sender: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, recipients: Array<{ __typename?: 'NotificationRecipient', recipientPartyId: number, readOn?: string | null, status: NotificationStatus, metaData?: { __typename?: 'NotificationMetaData', partyId?: number | null, feeId?: number | null, mailId?: number | null, threadMessageId?: number | null, notificationType: NotificationType, optionId?: number | null, studentPartyId?: number | null, substitutionDate?: string | null, schoolActivityId?: number | null, assessmentId?: number | null, formId?: number | null, highlightId?: number | null, highlightCommentId?: number | null, eventStartTime?: string | null, staffAbsenceRequestId?: number | null } | null }> }> };

export type Communications_ReadNotificationMutationVariables = Exact<{
  input?: InputMaybe<NotificationReadInput>;
}>;


export type Communications_ReadNotificationMutation = { __typename?: 'Mutation', communications_readNotification?: { __typename?: 'Success', success?: boolean | null } | null };

export type Communications_NotificationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type Communications_NotificationCountQuery = { __typename?: 'Query', communications_notificationCount?: { __typename?: 'NotificationsUnreadCount', count: number } | null };

export type SearchQueryQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
}>;


export type SearchQueryQuery = { __typename?: 'Query', search_search: Array<{ __typename?: 'Search', partyId: number, type: SearchType, text: string, avatarUrl?: string | null, meta: { __typename?: 'SearchMeta', studentPartyId?: number | null } }> };

export type Composite_SwitchProfileMutationVariables = Exact<{
  input: SwitchProfileInput;
}>;


export type Composite_SwitchProfileMutation = { __typename?: 'Mutation', composite_switchProfile: { __typename?: 'GlobalUser', id: number } };

export type Users_SetDefaultProfileMutationVariables = Exact<{
  input: DefaultProfileInput;
}>;


export type Users_SetDefaultProfileMutation = { __typename?: 'Mutation', users_setDefaultProfile?: { __typename?: 'Success', success?: boolean | null } | null };

export type Tyrone_ConversationHistoryQueryVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type Tyrone_ConversationHistoryQuery = { __typename?: 'Query', tyrone_conversationHistory?: { __typename?: 'Tyrone_ConversationHistory', messages: Array<{ __typename?: 'Tyrone_ConversationMessage', id: number, conversationId: string, requestNumber: number, prompt: string, response: string }> } | null };

export type Tyrone_MyConversationsQueryVariables = Exact<{ [key: string]: never; }>;


export type Tyrone_MyConversationsQuery = { __typename?: 'Query', tyrone_myConversations: Array<{ __typename?: 'Tyrone_Conversation', id: string, partyId: number, initialMessage: string, createdOn: string, updatedOn: string }> };

export type Assessment_ArchiveClassAssessmentMutationVariables = Exact<{
  input: Scalars['Long']['input'];
}>;


export type Assessment_ArchiveClassAssessmentMutation = { __typename?: 'Mutation', assessment_archiveClassAssessment: { __typename?: 'Success', success?: boolean | null } };

export type Assessment_ArchiveStateCbaAssessmentMutationVariables = Exact<{
  input: Scalars['Long']['input'];
}>;


export type Assessment_ArchiveStateCbaAssessmentMutation = { __typename?: 'Mutation', assessment_archiveStateCbaAssessment: { __typename?: 'Success', success?: boolean | null } };

export type Assessment_ArchiveTermAssessmentMutationVariables = Exact<{
  input: Scalars['Long']['input'];
}>;


export type Assessment_ArchiveTermAssessmentMutation = { __typename?: 'Mutation', assessment_archiveTermAssessment: { __typename?: 'Success', success?: boolean | null } };

export type Assessment_AssessmentResultQueryVariables = Exact<{
  filter?: InputMaybe<AssessmentResultFilter>;
}>;


export type Assessment_AssessmentResultQuery = { __typename?: 'Query', assessment_assessmentResult?: Array<{ __typename?: 'AssessmentResult', id?: number | null, assessmentId?: number | null, studentPartyId: number, studentClassGroup: string, studentStudyLevel?: StudyLevel | null, result?: number | null, gradeId?: number | null, gradeResult?: string | null, targetResult?: number | null, targetGradeId?: number | null, targetGradeResult?: string | null, examinable: boolean, absent: boolean, ppodPublished?: boolean | null, ppodErrorMessage?: string | null, ppodResult?: string | null, student: { __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null }, studentProgramme?: { __typename?: 'Programme', shortName?: string | null } | null, subjectGroup: { __typename?: 'SubjectGroup', partyId: number, name: string, irePP?: { __typename?: 'SubjectGroupIrePP', examinable: boolean } | null }, teacherComment?: { __typename?: 'AssessmentComment', id: number, assessmentId: number, studentPartyId: number, comment?: string | null, commentBankCommentId?: number | null, commenterUserType: CommenterUserType, commenterPartyId: number, subjectGroupPartyId: number } | null, extraFields?: Array<{ __typename?: 'ResultExtraField', id: number, extraFieldType: ExtraFieldType, assessmentResultId: number, assessmentExtraFieldId: number, result?: string | null, gradeSetGradeId?: number | null, gradeNameTextId?: number | null, commentBankCommentId?: number | null }> | null }> | null };

export type Assessment_SaveAssessmentResultsMutationVariables = Exact<{
  input?: InputMaybe<Array<SaveAssessmentResultInput> | SaveAssessmentResultInput>;
}>;


export type Assessment_SaveAssessmentResultsMutation = { __typename?: 'Mutation', assessment_saveAssessmentResults?: Array<{ __typename?: 'AssessmentResult', id?: number | null }> | null };

export type AssessmentSubjectGroupsQueryVariables = Exact<{
  filter?: InputMaybe<AssessmentSubjectGroupsFilter>;
}>;


export type AssessmentSubjectGroupsQuery = { __typename?: 'Query', assessment_assessmentSubjectGroups?: Array<{ __typename?: 'AssessmentSubjectGroup', resultsTotal: number, resultsEntered: number, commentsEntered: number, commentsTotal: number, extraFieldResultsEntered: number, extraFieldResultsTotal: number, ppodSyncStatus?: SyncStatus | null, ppodErrorMessages?: Array<string> | null, published?: boolean | null, subjectGroup: { __typename?: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null, subjects: Array<{ __typename?: 'Subject', name: string, colour?: Colour | null, nationalCode?: string | null }>, staff: Array<{ __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }>, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', yearGroupId: number, name: string }> } }> | null };

export type AssessmentsListQueryVariables = Exact<{
  filter?: InputMaybe<AssessmentFilter>;
}>;


export type AssessmentsListQuery = { __typename?: 'Query', assessment_assessment?: Array<{ __typename?: 'Assessment', id: number, name: string, assessmentType: AssessmentType, stateCbaType?: StateCbaType | null, academicNamespaceId: number, publish: boolean, publishedFrom?: string | null, publishLearner: boolean, allowLearnerPrint: boolean, openForResultEntry: boolean, archived: boolean, docxFileTransferId?: number | null, startDate: string, endDate: string, canEnterOverallComments: boolean, ppodSyncedSubjectGroupCount?: number | null, ppodTotalSubjectGroupCount?: number | null, subjectGroups?: Array<{ __typename?: 'SubjectGroup', name: string, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', partyId: number, name: string }> }> | null, years?: Array<{ __typename?: 'YearGroup', yearGroupId: number, name: string }> | null, programmeStages?: Array<{ __typename?: 'ProgrammeStage', id: number, name: string, yearGroupId: number }> | null, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> | null };

export type AssessmentQueryVariables = Exact<{
  filter?: InputMaybe<AssessmentFilter>;
}>;


export type AssessmentQuery = { __typename?: 'Query', assessment_assessment?: Array<{ __typename?: 'Assessment', id: number, name: string, description?: string | null, assessmentType: AssessmentType, academicNamespaceId: number, publish: boolean, createdOn: string, gradeType: GradeType, showType: GradeType, passFailThreshold?: number | null, captureTarget: boolean, commentType: CommentType, commentLength?: number | null, publishLearner: boolean, allowLearnerPrint: boolean, openForResultEntry: boolean, docxFileTransferId?: number | null, stateCbaType?: StateCbaType | null, startDate: string, endDate: string, captureTutorComment: boolean, capturePrincipalComment: boolean, captureYearHeadComment: boolean, captureHouseMasterComment: boolean, tutorCommentType?: CommentType | null, tutorCommentLength?: number | null, yearHeadCommentType?: CommentType | null, yearHeadCommentLength?: number | null, principalCommentType?: CommentType | null, principalCommentLength?: number | null, housemasterCommentType?: CommentType | null, housemasterCommentLength?: number | null, years?: Array<{ __typename?: 'YearGroup', yearGroupId: number, name: string }> | null, programmeStages?: Array<{ __typename?: 'ProgrammeStage', id: number, name: string, yearGroupId: number, programme?: { __typename?: 'Programme', shortName?: string | null } | null }> | null, yearGroupEnrolments?: Array<{ __typename?: 'YearGroupEnrollment', partyId: number, yearGroupEnrollmentPartyId: number, yearGroupId: number, name: string }> | null, gradeSets?: Array<{ __typename?: 'GradeSet', id: number, name: string }> | null, commentBank?: { __typename?: 'AssessmentCommentBank', commentBankId: number, commentBankName?: string | null } | null, extraFields?: Array<{ __typename?: 'AssessmentExtraField', id: number, order?: number | null, name: string, assessmentId: number, extraFieldType: ExtraFieldType, gradeSetId?: number | null, commentBankId?: number | null, commentBankName?: string | null, selectOptions?: Array<string> | null, commentLength?: number | null, resultsEntered: boolean }> | null, createdBy: { __typename?: 'Person', partyId: number, type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, subjectGroups?: Array<{ __typename?: 'SubjectGroup', partyId: number, name: string, subjects: Array<{ __typename?: 'Subject', name: string, id: number, colour?: Colour | null }> }> | null, tutorCommentBank?: { __typename?: 'AssessmentCommentBank', commentBankId: number, commentBankName?: string | null } | null, yearHeadCommentBank?: { __typename?: 'AssessmentCommentBank', commentBankId: number, commentBankName?: string | null } | null, principalCommentBank?: { __typename?: 'AssessmentCommentBank', commentBankId: number, commentBankName?: string | null } | null, housemasterCommentBank?: { __typename?: 'AssessmentCommentBank', commentBankId: number, commentBankName?: string | null } | null }> | null };

export type CommentBankAssessmentQueryVariables = Exact<{
  filter?: InputMaybe<CommentBankFilter>;
}>;


export type CommentBankAssessmentQuery = { __typename?: 'Query', assessment_commentBank?: Array<{ __typename?: 'CommentBank', id: number, name: string }> | null };

export type CommentBanksWithCommentsQueryVariables = Exact<{
  filter?: InputMaybe<CommentBankFilter>;
}>;


export type CommentBanksWithCommentsQuery = { __typename?: 'Query', assessment_commentBank?: Array<{ __typename?: 'CommentBank', id: number, name: string, comments?: Array<{ __typename?: 'Comment', id: number, comment: string, active: boolean }> | null }> | null };

export type Assessment_GradesQueryVariables = Exact<{
  filter?: InputMaybe<GradeFilter>;
}>;


export type Assessment_GradesQuery = { __typename?: 'Query', assessment_grades: Array<{ __typename?: 'Grade', id: number, name: string, start: number, end: number, active: boolean, studyLevels?: Array<GradeSetStudyLevel | null> | null }> };

export type Assessment_GradeSetQueryVariables = Exact<{
  filter?: InputMaybe<GradeSetFilter>;
}>;


export type Assessment_GradeSetQuery = { __typename?: 'Query', assessment_gradeSet?: Array<{ __typename?: 'GradeSet', id: number, name: string, description?: string | null, active: boolean, customGradeSet: boolean, isCba: boolean, years?: Array<number> | null, type: Assessment_GradeSetType, grades?: Array<{ __typename?: 'Grade', id: number, name: string, nameTextId: number, start: number, end: number, active: boolean }> | null }> | null };

export type Assessment_SaveGradeSetMutationVariables = Exact<{
  input?: InputMaybe<SaveGradeSetInput>;
}>;


export type Assessment_SaveGradeSetMutation = { __typename?: 'Mutation', assessment_saveGradeSet?: { __typename?: 'GradeSet', id: number } | null };

export type Assessment_UpdateGradeSetMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<UpdateGradeSetInput>> | InputMaybe<UpdateGradeSetInput>>;
}>;


export type Assessment_UpdateGradeSetMutation = { __typename?: 'Mutation', assessment_updateGradeSet?: Array<{ __typename?: 'GradeSet', id: number } | null> | null };

export type InClassAssessmentsQueryVariables = Exact<{
  filter?: InputMaybe<AssessmentFilter>;
}>;


export type InClassAssessmentsQuery = { __typename?: 'Query', assessment_assessment?: Array<{ __typename?: 'Assessment', id: number, name: string, assessmentType: AssessmentType }> | null };

export type Assessment_SaveClassAssessmentMutationVariables = Exact<{
  input?: InputMaybe<SaveClassAssessmentInput>;
}>;


export type Assessment_SaveClassAssessmentMutation = { __typename?: 'Mutation', assessment_saveClassAssessment?: { __typename?: 'Assessment', id: number, academicNamespaceId: number, name: string, assessmentType: AssessmentType, startDate: string, endDate: string, captureTarget: boolean, commentType: CommentType, capturePrincipalComment: boolean, captureYearHeadComment: boolean, captureTutorComment: boolean, captureHouseMasterComment: boolean, publish: boolean, publishLearner: boolean, yearGroupIds?: Array<number> | null, canEnterOverallComments: boolean, createdOn: string, gradeSets?: Array<{ __typename?: 'GradeSet', id: number }> | null, years?: Array<{ __typename?: 'YearGroup', yearGroupId: number, nameTextId: number, shortNameTextId: number, nationalCode: string, name: string, shortName: string }> | null } | null };

export type Assessment_SetOpenForResultEntryMutationVariables = Exact<{
  input?: InputMaybe<SetOpenForResultEntryInput>;
}>;


export type Assessment_SetOpenForResultEntryMutation = { __typename?: 'Mutation', assessment_setOpenForResultEntry?: { __typename?: 'Assessment', id: number, openForResultEntry: boolean } | null };

export type Assessment_OverallCommentsQueryVariables = Exact<{
  filter?: InputMaybe<OverallCommentsFilter>;
}>;


export type Assessment_OverallCommentsQuery = { __typename?: 'Query', assessment_overallComments?: { __typename?: 'OverallComments', tutorCommentsEntered: number, yearHeadCommentsEntered: number, principalCommentsEntered: number, totalCommentsToEnter: number, students: Array<{ __typename?: 'CommentStudent', studentPartyId: number, commentStatus: CommentStatus, principalComment: boolean, yearHeadComment: boolean, tutorComment: boolean, student: { __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup?: { __typename?: 'GeneralGroup', partyId: number, name: string } | null, programmeStages?: Array<{ __typename?: 'ProgrammeStage', id: number, name: string, programme?: { __typename?: 'Programme', shortName?: string | null } | null }> | null, subjectGroups: Array<{ __typename?: 'SubjectGroup', partyId: number, name: string, subjects: Array<{ __typename?: 'Subject', id: number, name: string, colour?: Colour | null }>, staff: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }> }> } }> } | null };

export type Assessment_PublishStateCbaMutationVariables = Exact<{
  input?: InputMaybe<PublishAssessmentInput>;
}>;


export type Assessment_PublishStateCbaMutation = { __typename?: 'Mutation', assessment_publishStateCba: { __typename?: 'Success', success?: boolean | null } };

export type Assessment_PublishMutationVariables = Exact<{
  input?: InputMaybe<PublishAssessmentInput>;
}>;


export type Assessment_PublishMutation = { __typename?: 'Mutation', assessment_publish: { __typename?: 'Success', success?: boolean | null } };

export type SaveTermAssessmentMutationVariables = Exact<{
  input?: InputMaybe<SaveTermAssessmentInput>;
}>;


export type SaveTermAssessmentMutation = { __typename?: 'Mutation', assessment_saveTermAssessment?: { __typename?: 'Assessment', name: string, startDate: string, endDate: string, years?: Array<{ __typename?: 'YearGroup', name: string }> | null } | null };

export type Assessment_PublishPpodResultsMutationVariables = Exact<{
  input?: InputMaybe<PpodPublishResultsInput>;
}>;


export type Assessment_PublishPpodResultsMutation = { __typename?: 'Mutation', assessment_publishPPODResults?: Array<{ __typename?: 'AssessmentResult', id?: number | null, assessmentId?: number | null, studentPartyId: number }> | null };

export type Assessment_SaveStateCbaAssessmentMutationVariables = Exact<{
  input?: InputMaybe<SaveStateCbaAssessmentInput>;
}>;


export type Assessment_SaveStateCbaAssessmentMutation = { __typename?: 'Mutation', assessment_saveStateCbaAssessment?: { __typename?: 'Assessment', id: number, academicNamespaceId: number, name: string, assessmentType: AssessmentType, startDate: string, endDate: string, yearGroupIds?: Array<number> | null, years?: Array<{ __typename?: 'YearGroup', yearGroupId: number, name: string }> | null, extraFields?: Array<{ __typename?: 'AssessmentExtraField', id: number, order?: number | null, name: string, assessmentId: number, extraFieldType: ExtraFieldType, gradeSetId?: number | null, commentBankId?: number | null, commentBankName?: string | null, selectOptions?: Array<string> | null, commentLength?: number | null }> | null, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | null };

export type Assessment_VerifyPpodResultsMutationVariables = Exact<{
  input?: InputMaybe<PpodPublishResultsInput>;
}>;


export type Assessment_VerifyPpodResultsMutation = { __typename?: 'Mutation', assessment_verifyPPODResults?: { __typename?: 'PPODVerificationReport', matchCount: number, mismatchCount: number, notFoundOnPpodCount: number, unexpectedOnPpodCount: number, notPublishedCount: number, results: Array<{ __typename?: 'PPODVerificationResult', assessmentResultId: number, studentPartyId: number, nationalCode?: number | null, lastPublishedGrade?: string | null, ppodGrade?: string | null, status: PpodVerificationStatus }> } | null };

export type Assessment_StudentAssessmentExclusionMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<StudentAssessmentExclusionInput>> | InputMaybe<StudentAssessmentExclusionInput>>;
}>;


export type Assessment_StudentAssessmentExclusionMutation = { __typename?: 'Mutation', assessment_studentAssessmentExclusion: { __typename?: 'Success', success?: boolean | null } };

export type DashboardAssessmentQueryVariables = Exact<{
  filter?: InputMaybe<DashboardAssessmentFilter>;
}>;


export type DashboardAssessmentQuery = { __typename?: 'Query', assessment_dashboardAssessment?: Array<{ __typename?: 'DashboardAssessment', id: number, name: string, description?: string | null, assessmentType: AssessmentType, startDate: string, endDate: string, publishedFrom?: string | null, results?: Array<{ __typename?: 'DashboardAssessmentResult', id: number, subject: string, result?: number | null, grade?: string | null, studyLevel?: StudyLevel | null }> | null }> | null };

export type Assessment_AssessmentCommentQueryVariables = Exact<{
  filter?: InputMaybe<AssessmentCommentFilter>;
}>;


export type Assessment_AssessmentCommentQuery = { __typename?: 'Query', assessment_assessmentComment?: Array<{ __typename?: 'AssessmentComment', id: number, comment?: string | null, commentBankCommentId?: number | null, commenterUserType: CommenterUserType, commenterPartyId: number }> | null };

export type Assessment_SaveAssessmentCommentsMutationVariables = Exact<{
  input?: InputMaybe<Array<SaveAssessmentCommentInput> | SaveAssessmentCommentInput>;
}>;


export type Assessment_SaveAssessmentCommentsMutation = { __typename?: 'Mutation', assessment_saveAssessmentComments?: Array<{ __typename?: 'AssessmentComment', id: number }> | null };

export type Core_ProgrammeStageEnrollmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type Core_ProgrammeStageEnrollmentsQuery = { __typename?: 'Query', core_programmeStageEnrollments: Array<{ __typename?: 'ProgrammeStageEnrollment', name: string, programmeStageId: number, programmeStage?: { __typename?: 'ProgrammeStage', yearGroupId: number } | null }> };

export type Assessment_StudentResultQueryVariables = Exact<{
  filter?: InputMaybe<StudentResultFilter>;
}>;


export type Assessment_StudentResultQuery = { __typename?: 'Query', assessment_studentResult: Array<{ __typename?: 'AssessmentResult', id?: number | null, assessmentId?: number | null, studentPartyId: number, studentClassGroup: string, studentStudyLevel?: StudyLevel | null, result?: number | null, targetResult?: number | null, gradeResult?: string | null, gradeNameTextId?: number | null, targetGradeResult?: string | null, targetGradeNameTextId?: number | null, examinable: boolean, student: { __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null }, studentProgramme?: { __typename?: 'Programme', shortName?: string | null } | null, subjectGroup: { __typename?: 'SubjectGroup', partyId: number, name: string, staff: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }>, subjects: Array<{ __typename?: 'Subject', name: string, colour?: Colour | null, nationalCode?: string | null }> }, teacherComment?: { __typename?: 'AssessmentComment', id: number, assessmentId: number, studentPartyId: number, comment?: string | null, commentBankCommentId?: number | null, commenterUserType: CommenterUserType, commenterPartyId: number, subjectGroupPartyId: number } | null, extraFields?: Array<{ __typename?: 'ResultExtraField', id: number, extraFieldType: ExtraFieldType, assessmentResultId: number, assessmentExtraFieldId: number, result?: string | null, gradeSetGradeId?: number | null, gradeNameTextId?: number | null, commentBankCommentId?: number | null }> | null }> };

export type Assessment_UnarchiveClassAssessmentMutationVariables = Exact<{
  input: Scalars['Long']['input'];
}>;


export type Assessment_UnarchiveClassAssessmentMutation = { __typename?: 'Mutation', assessment_unarchiveClassAssessment: { __typename?: 'Success', success?: boolean | null } };

export type Assessment_UnarchiveStateCbaAssessmentMutationVariables = Exact<{
  input: Scalars['Long']['input'];
}>;


export type Assessment_UnarchiveStateCbaAssessmentMutation = { __typename?: 'Mutation', assessment_unarchiveStateCbaAssessment: { __typename?: 'Success', success?: boolean | null } };

export type Assessment_UnarchiveTermAssessmentMutationVariables = Exact<{
  input: Scalars['Long']['input'];
}>;


export type Assessment_UnarchiveTermAssessmentMutation = { __typename?: 'Mutation', assessment_unarchiveTermAssessment: { __typename?: 'Success', success?: boolean | null } };

export type Attendance_ParentalAttendanceRequestsQueryVariables = Exact<{
  filter?: InputMaybe<ParentalAttendanceRequestFilter>;
}>;


export type Attendance_ParentalAttendanceRequestsQuery = { __typename?: 'Query', attendance_parentalAttendanceRequests: Array<{ __typename?: 'ParentalAttendanceRequest', id: number, adminNote?: string | null, approvedByPartyId?: number | null, attendanceCodeId: number, contactPartyId?: number | null, from: string, parentNote: string, attendanceNote?: string | null, requestType: ParentalAttendanceRequestType, status: ParentalAttendanceRequestStatus, studentPartyId: number, to: string, createdOn: string, attachments?: Array<string> | null, attendanceCode: { __typename?: 'AttendanceCode', id: number, code?: TuslaCode | null, name: string, description?: string | null }, approvedBy?: { __typename?: 'Person', avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null, classGroup?: { __typename?: 'GeneralGroup', name: string, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', name: string }> } | null, contact?: { __typename?: 'StudentContact', person: { __typename?: 'Person', avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, relationships: Array<{ __typename?: 'StudentContactRelationshipInfo', relationshipType: StudentContactType, studentPartyId: number }> } | null, submittedBy: { __typename?: 'Person', avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, studentNew: { __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null } }> };

export type Attendance_ParentalRequestCountQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type Attendance_ParentalRequestCountQuery = { __typename?: 'Query', attendance_parentalRequestCount?: { __typename?: 'Attendance_ParentalRequestCounter', count: number } | null };

export type Attendance_SaveParentalAttendanceRequestMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<SaveParentalAttendanceRequest>> | InputMaybe<SaveParentalAttendanceRequest>>;
}>;


export type Attendance_SaveParentalAttendanceRequestMutation = { __typename?: 'Mutation', attendance_saveParentalAttendanceRequest: Array<{ __typename?: 'ParentalAttendanceRequest', id: number }> };

export type Attendance_UpdateParentalAttendanceRequestMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<UpdateParentalAttendanceRequest>> | InputMaybe<UpdateParentalAttendanceRequest>>;
}>;


export type Attendance_UpdateParentalAttendanceRequestMutation = { __typename?: 'Mutation', attendance_updateParentalAttendanceRequest: Array<{ __typename?: 'ParentalAttendanceRequest', id: number }> };

export type Attendance_WithdrawParentalAttendanceRequestMutationVariables = Exact<{
  input?: InputMaybe<WithdrawParentalAttendanceRequest>;
}>;


export type Attendance_WithdrawParentalAttendanceRequestMutation = { __typename?: 'Mutation', attendance_withdrawParentalAttendanceRequest?: { __typename?: 'Success', success?: boolean | null } | null };

export type Attendance_UndoParentalAttendanceRequestMutationVariables = Exact<{
  input?: InputMaybe<Attendance_RollbackParentalAttendanceInput>;
}>;


export type Attendance_UndoParentalAttendanceRequestMutation = { __typename?: 'Mutation', attendance_undoParentalAttendanceRequest?: { __typename?: 'Success', success?: boolean | null } | null };

export type Attendance_AttendanceCodesQueryVariables = Exact<{
  filter?: InputMaybe<AttendanceCodeFilter>;
}>;


export type Attendance_AttendanceCodesQuery = { __typename?: 'Query', attendance_attendanceCodes: Array<{ __typename?: 'AttendanceCode', id: number, name: string, description?: string | null, code?: TuslaCode | null, active: boolean, visibleForTeacher: boolean, visibleForContact: boolean, nameTextId?: number | null, codeType: AttendanceCodeType, sessionCodeType: AttendanceCodeType, custom: boolean }> };

export type Attendance_SaveAttendanceCodeMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<SaveAttendanceCodeInput>> | InputMaybe<SaveAttendanceCodeInput>>;
}>;


export type Attendance_SaveAttendanceCodeMutation = { __typename?: 'Mutation', attendance_saveAttendanceCode: Array<{ __typename?: 'AttendanceCode', id: number }> };

export type Attendance_SaveEventAttendanceMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<SaveEventAttendanceInput>> | InputMaybe<SaveEventAttendanceInput>>;
}>;


export type Attendance_SaveEventAttendanceMutation = { __typename?: 'Mutation', attendance_saveEventAttendance: Array<{ __typename?: 'EventAttendance', id: number, eventId: number, attendanceCodeId: number, personPartyId: number, date: string }> };

export type Attendance_BulkAttendanceActionsQueryVariables = Exact<{
  filter: Attendance_BulkAttendanceActionFilter;
}>;


export type Attendance_BulkAttendanceActionsQuery = { __typename?: 'Query', attendance_bulkAttendanceActions: Array<{ __typename?: 'Attendance_BulkAttendanceAction', id: number, attendanceForPartyIds: Array<number>, attendanceCodeId: number, startDate: string, endDate?: string | null, leavesAt: string, returnsAt?: string | null, partial: boolean, note?: string | null, createdOn: string, action?: Attendance_BulkAttendanceActionType | null, parties: Array<{ __typename: 'GeneralGroup', partyId: number, generalGroupType: GeneralGroupType, name: string, classGroupInfo?: { __typename: 'ClassGroupInfo' } | null } | { __typename: 'ProgrammeStageEnrollment', partyId: number, name: string } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', partyId: number, actualName: string, name: string, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', partyId: number, name: string } | null>, attendanceCode: { __typename?: 'AttendanceCode', id: number, name: string, description?: string | null, code?: TuslaCode | null, active: boolean, visibleForTeacher: boolean, visibleForContact: boolean, nameTextId?: number | null, descriptionTextId?: number | null, codeType: AttendanceCodeType, sessionCodeType: AttendanceCodeType, custom: boolean }, createdBy: { __typename?: 'AuditPerson', userId?: number | null, partyId?: number | null, person?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null } }> };

export type Attendance_SaveBulkAttendanceMutationVariables = Exact<{
  input?: InputMaybe<Attendance_SaveBulkAttendanceInput>;
}>;


export type Attendance_SaveBulkAttendanceMutation = { __typename?: 'Mutation', attendance_saveBulkAttendance?: { __typename?: 'Success', success?: boolean | null } | null };

export type BulkAttendanceSearchQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
}>;


export type BulkAttendanceSearchQuery = { __typename?: 'Query', search_search: Array<{ __typename?: 'Search', partyId: number, type: SearchType, text: string, avatarUrl?: string | null, meta: { __typename?: 'SearchMeta', studentPartyId?: number | null } }> };

export type Attendance_RollBackAndSaveNewBulkAttendanceMutationVariables = Exact<{
  input?: InputMaybe<Attendance_RollBackAndSaveBulkAttendanceInput>;
}>;


export type Attendance_RollBackAndSaveNewBulkAttendanceMutation = { __typename?: 'Mutation', attendance_rollBackAndSaveNewBulkAttendance?: { __typename?: 'Success', success?: boolean | null } | null };

export type Attendance_RollBackBulkAttendanceMutationVariables = Exact<{
  input?: InputMaybe<Attendance_RollBackBulkAttendanceInput>;
}>;


export type Attendance_RollBackBulkAttendanceMutation = { __typename?: 'Mutation', attendance_rollBackBulkAttendance?: { __typename?: 'Success', success?: boolean | null } | null };

export type Attendance_CalendarAttendanceQueryVariables = Exact<{
  filter?: InputMaybe<CalendarAttendanceFilter>;
}>;


export type Attendance_CalendarAttendanceQuery = { __typename?: 'Query', attendance_calendarAttendance: { __typename?: 'CalendarAttendance', totalPresent: number, totalLate: number, totalAbsent: number, totalUnexplained: number, totalNotTaken: number, totalPartial: number, attendances: Array<{ __typename?: 'CalendarAttendanceDay', date: string, status: CalendarCodeType, partiallyTaken: boolean }> } };

export type Calendar_CalendarDayBellTimesQueryVariables = Exact<{
  filter?: InputMaybe<CalendarDayBellTimeFilter>;
}>;


export type Calendar_CalendarDayBellTimesQuery = { __typename?: 'Query', calendar_calendarDayBellTimes: Array<{ __typename?: 'CalendarDayBellTime', date: string, bellTimeIds?: Array<number> | null, dayType: DayType, bellTimes?: Array<{ __typename?: 'Calendar_BellTime', id: number, time: string, name?: string | null }> | null }> };

export type Calendar_CalendarLessonTimesQueryVariables = Exact<{
  filter?: InputMaybe<CalendarEventFilter>;
}>;


export type Calendar_CalendarLessonTimesQuery = { __typename?: 'Query', calendar_calendarEvents?: { __typename?: 'ResourceCalendarWrapper', resources: Array<{ __typename?: 'PartyCalendar', events: Array<{ __typename?: 'CalendarEvent', name: string, eventId: number, startTime: string, endTime: string }> } | { __typename?: 'RoomCalendar', events: Array<{ __typename?: 'CalendarEvent', name: string, eventId: number, startTime: string, endTime: string }> }> } | null };

export type Calendar_CalendarInformationQueryVariables = Exact<{
  filter?: InputMaybe<CalendarEventFilter>;
}>;


export type Calendar_CalendarInformationQuery = { __typename?: 'Query', calendar_calendarEvents?: { __typename?: 'ResourceCalendarWrapper', resources: Array<{ __typename?: 'PartyCalendar', events: Array<{ __typename?: 'CalendarEvent', eventId: number, startTime: string, endTime: string, type: CalendarEventType, colour?: Colour | null, name: string, lessonInfo?: { __typename?: 'CalendarEventLessonRaw', subjectGroupId: number } | null, extensions?: { __typename?: 'CalendarEventExtension', eventAttendance?: Array<{ __typename?: 'EventAttendance', id: number, eventId: number, attendanceCodeId: number, personPartyId: number, date: string, note?: string | null, createdByPartyId: number, updatedAt?: string | null, updatedByPartyId: number, attendanceCode: { __typename?: 'AttendanceCode', name: string, codeType: AttendanceCodeType }, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, updatedBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | null> | null } | null }> } | { __typename?: 'RoomCalendar', events: Array<{ __typename?: 'CalendarEvent', eventId: number, startTime: string, endTime: string, type: CalendarEventType, colour?: Colour | null, name: string, lessonInfo?: { __typename?: 'CalendarEventLessonRaw', subjectGroupId: number } | null, extensions?: { __typename?: 'CalendarEventExtension', eventAttendance?: Array<{ __typename?: 'EventAttendance', id: number, eventId: number, attendanceCodeId: number, personPartyId: number, date: string, note?: string | null, createdByPartyId: number, updatedAt?: string | null, updatedByPartyId: number, attendanceCode: { __typename?: 'AttendanceCode', name: string, codeType: AttendanceCodeType }, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, updatedBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | null> | null } | null }> }> } | null };

export type StudentSessionAttendanceQueryVariables = Exact<{
  filter?: InputMaybe<StudentSessionAttendanceFilter>;
}>;


export type StudentSessionAttendanceQuery = { __typename?: 'Query', attendance_studentSessionAttendance: Array<{ __typename?: 'StudentSessionAttendance', studentPartyId: number, dateAttendance: Array<{ __typename?: 'DateAttendance', date: string, bellTimeAttendance: Array<{ __typename?: 'BellTimeAttendance', bellTimeId: number, note?: string | null, createdByPartyId: number, updatedAt: string, updatedByPartyId: number, bellTime: { __typename?: 'Calendar_BellTime', time: string, name?: string | null }, attendanceCode?: { __typename?: 'AttendanceCode', id: number, name: string, description?: string | null, code?: TuslaCode | null, codeType: AttendanceCodeType } | null, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, updatedBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }>, student: { __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }, classGroup?: { __typename?: 'GeneralGroup', name: string, staff: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }> } | null }> };

export type Attendance_MergeAttendanceCodesMutationVariables = Exact<{
  input: Attendance_MergeAttendanceCodeInput;
}>;


export type Attendance_MergeAttendanceCodesMutation = { __typename?: 'Mutation', attendance_mergeAttendanceCodes: { __typename?: 'Success', success?: boolean | null } };

export type Attendance_RollBookAttendanceQueryVariables = Exact<{
  filter?: InputMaybe<Attendance_RollBookFilter>;
}>;


export type Attendance_RollBookAttendanceQuery = { __typename?: 'Query', attendance_rollBookAttendance: Array<{ __typename?: 'Attendance_StudentRollBook', studentPartyId: number, student: { __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null, dateAttendance: Array<{ __typename?: 'Attendance_RollBookAttendance', date: string, eventAttendance: Array<{ __typename?: 'EventAttendance', eventId: number, date: string, time?: string | null, note?: string | null, attendanceCode: { __typename?: 'AttendanceCode', id: number, name: string, codeType: AttendanceCodeType } }> }> }> };

export type SaveStudentSessionAttendanceMutationVariables = Exact<{
  input?: InputMaybe<SaveStudentSessionAttendanceInput>;
}>;


export type SaveStudentSessionAttendanceMutation = { __typename?: 'Mutation', attendance_saveStudentSessionAttendance: Array<{ __typename?: 'StudentSessionAttendance', studentPartyId: number }> };

export type Attendance_SaveSchoolActivityEventAttendanceMutationVariables = Exact<{
  input: Array<SaveSchoolActivityAttendanceInput> | SaveSchoolActivityAttendanceInput;
}>;


export type Attendance_SaveSchoolActivityEventAttendanceMutation = { __typename?: 'Mutation', attendance_saveSchoolActivityEventAttendance: { __typename?: 'Success', success?: boolean | null } };

export type Attendance_SessionAttendanceReportQueryVariables = Exact<{
  filter?: InputMaybe<SessionAttendanceListFilter>;
}>;


export type Attendance_SessionAttendanceReportQuery = { __typename?: 'Query', attendance_sessionAttendanceList: Array<{ __typename?: 'SessionAttendanceList', id: number, studentPartyId: number, attendanceCodeId: number, date: string, note?: string | null, attendanceCode: { __typename?: 'AttendanceCode', id: number, code?: TuslaCode | null, name: string }, student: { __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', name: string }> }, bellTime: { __typename?: 'Calendar_BellTime', id: number, time: string, name?: string | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null }> };

export type Attendance_StudentSessionAttendanceQueryVariables = Exact<{
  filter?: InputMaybe<StudentSessionAttendanceFilter>;
}>;


export type Attendance_StudentSessionAttendanceQuery = { __typename?: 'Query', attendance_studentSessionAttendance: Array<{ __typename?: 'StudentSessionAttendance', studentPartyId: number, student: { __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null, dateAttendance: Array<{ __typename?: 'DateAttendance', date: string, bellTimeAttendance: Array<{ __typename?: 'BellTimeAttendance', bellTimeId: number, note?: string | null, attendanceCode?: { __typename?: 'AttendanceCode', id: number, name: string, codeType: AttendanceCodeType } | null }> }> }> };

export type Attendance_SaveStudentSessionAttendanceMutationVariables = Exact<{
  input?: InputMaybe<SaveStudentSessionAttendanceInput>;
}>;


export type Attendance_SaveStudentSessionAttendanceMutation = { __typename?: 'Mutation', attendance_saveStudentSessionAttendance: Array<{ __typename?: 'StudentSessionAttendance', studentPartyId: number }> };

export type SessionPartySearchQueryQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
}>;


export type SessionPartySearchQueryQuery = { __typename?: 'Query', search_search: Array<{ __typename?: 'Search', partyId: number, type: SearchType, text: string, avatarUrl?: string | null }> };

export type Attendance_SignInOutReportQueryVariables = Exact<{
  filter: Attendance_SignInOutReportFilter;
}>;


export type Attendance_SignInOutReportQuery = { __typename?: 'Query', attendance_signInOutReport: Array<{ __typename: 'StudentSignInOut', attendanceCodeId: number, collectedBy?: string | null, id: number, dateTime: string, note?: string | null, type: Attendance_SignInOutType, signInOutPersonType: Attendance_SignInOutPersonType, createdByPartyId: number, student: { __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null }, attendanceCode: { __typename?: 'AttendanceCode', id: number, name: string }, parentalAttendanceRequest?: { __typename?: 'ParentalAttendanceRequest', id: number, requestType: ParentalAttendanceRequestType, from: string, to: string, parentNote: string, contact?: { __typename?: 'StudentContact', person: { __typename?: 'Person', avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, relationships: Array<{ __typename?: 'StudentContactRelationshipInfo', relationshipType: StudentContactType, studentPartyId: number }> } | null, attendanceCode: { __typename?: 'AttendanceCode', id: number, code?: TuslaCode | null, name: string, description?: string | null } } | null, createdBy: { __typename?: 'Staff', partyId: number, person: { __typename?: 'Person', avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } } | { __typename: 'VisitorSignInOut', firstname?: string | null, lastname?: string | null, id: number, dateTime: string, note?: string | null, type: Attendance_SignInOutType, signInOutPersonType: Attendance_SignInOutPersonType, createdByPartyId: number, visitingStaff: { __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }, createdBy: { __typename?: 'Staff', partyId: number, person: { __typename?: 'Person', avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } }> };

export type Attendance_DeleteSignInOutMutationVariables = Exact<{
  input?: InputMaybe<Attendance_SignInOutDeleteInput>;
}>;


export type Attendance_DeleteSignInOutMutation = { __typename?: 'Mutation', attendance_deleteSignInOut?: { __typename?: 'Success', success?: boolean | null } | null };

export type Attendance_SaveSignInOutMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<Attendance_SignInOutInput>> | InputMaybe<Attendance_SignInOutInput>>;
}>;


export type Attendance_SaveSignInOutMutation = { __typename?: 'Mutation', attendance_saveSignInOut: Array<{ __typename?: 'StudentSignInOut', id: number, dateTime: string, note?: string | null, type: Attendance_SignInOutType, signInOutPersonType: Attendance_SignInOutPersonType, createdByPartyId: number, createdBy: { __typename?: 'Staff', person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } } | { __typename?: 'VisitorSignInOut', id: number, dateTime: string, note?: string | null, type: Attendance_SignInOutType, signInOutPersonType: Attendance_SignInOutPersonType, createdByPartyId: number, createdBy: { __typename?: 'Staff', person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } }> };

export type Attendance_StudentRollBookAttendanceQueryVariables = Exact<{
  filter?: InputMaybe<Attendance_StudentRollBookFilter>;
}>;


export type Attendance_StudentRollBookAttendanceQuery = { __typename?: 'Query', attendance_studentRollBookAttendance: { __typename?: 'Attendance_StudentRollBookAttendance', events: Array<{ __typename?: 'CalendarEvent', eventId: number, gridIdx?: number | null, startTime: string, endTime: string, name: string, colour?: Colour | null, attendees: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', partyId: number } | { __typename: 'ProgrammeStageEnrollment', partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number } | { __typename: 'StudentContact', partyId: number } | { __typename: 'SubjectGroup', partyId: number } | { __typename: 'YearGroupEnrollment', partyId: number } | null }>, rooms: Array<{ __typename?: 'Room', roomId: number, name: string }> }>, students: Array<{ __typename?: 'Attendance_RollBookStudent', student: { __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null, dateAttendance: Array<{ __typename?: 'Attendance_RollBookDateAttendance', date: string, periodAttendance: Array<{ __typename?: 'Attendance_PeriodAttendance', periodIdx: number, eventId: number, note?: string | null, attendanceCode?: { __typename?: 'AttendanceCode', id: number, name: string, codeType: AttendanceCodeType } | null }> }> }> } };

export type TableSessionAttendanceViewQueryVariables = Exact<{
  filter?: InputMaybe<StudentSessionAttendanceFilter>;
}>;


export type TableSessionAttendanceViewQuery = { __typename?: 'Query', attendance_studentSessionAttendance: Array<{ __typename?: 'StudentSessionAttendance', dateAttendance: Array<{ __typename?: 'DateAttendance', date: string, bellTimeAttendance: Array<{ __typename?: 'BellTimeAttendance', bellTimeId: number, note?: string | null, createdByPartyId: number, updatedByPartyId: number, bellTime: { __typename?: 'Calendar_BellTime', time: string, name?: string | null }, attendanceCode?: { __typename?: 'AttendanceCode', id: number, name: string, description?: string | null, code?: TuslaCode | null, codeType: AttendanceCodeType } | null, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, updatedBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }> }> };

export type Users_ValidateUserProfileMutationVariables = Exact<{
  input: ValidateUserProfile;
}>;


export type Users_ValidateUserProfileMutation = { __typename?: 'Mutation', users_validateUserProfile?: { __typename?: 'Success', success?: boolean | null } | null };

export type Calendar_FindFreeResourcesQueryVariables = Exact<{
  filter?: InputMaybe<FindFreeResourcesFilter>;
}>;


export type Calendar_FindFreeResourcesQuery = { __typename?: 'Query', calendar_findFreeResources: { __typename?: 'FreeCalendarResources', freeRooms: Array<{ __typename?: 'Room', roomId: number, name: string }>, clashingRooms: Array<{ __typename?: 'ClashingRooms', room: { __typename?: 'Room', roomId: number, name: string } }> } };

export type Calendar_CreateCalendarEventsMutationVariables = Exact<{
  input: CreateCalendarEventsInput;
}>;


export type Calendar_CreateCalendarEventsMutation = { __typename?: 'Mutation', calendar_createCalendarEvents: { __typename?: 'Calendar_UpdateEventResult', success: boolean, clashes?: Array<{ __typename?: 'Calendar_ClashError', eventId: number, event: string, startTime?: string | null, endTime?: string | null, clashingRooms: Array<{ __typename?: 'Room', roomId: number, name: string }>, clashingParties: Array<{ __typename: 'GeneralGroup' } | { __typename: 'ProgrammeStageEnrollment' } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student' } | { __typename: 'StudentContact' } | { __typename: 'SubjectGroup' } | { __typename: 'YearGroupEnrollment' }> } | null> | null } };

export type CalendarSearchQueryQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
}>;


export type CalendarSearchQueryQuery = { __typename?: 'Query', search_search: Array<{ __typename?: 'Search', partyId: number, type: SearchType, text: string, avatarUrl?: string | null }> };

export type Calendar_CancellationRecommendationsQueryVariables = Exact<{
  filter: Calendar_CancellationRecommendationFilter;
}>;


export type Calendar_CancellationRecommendationsQuery = { __typename?: 'Query', calendar_cancellationRecommendations: { __typename?: 'Calendar_CancellationRecommendationsResult', recommendations: Array<{ __typename?: 'Calendar_CancellationRecommendation', totalStudents: number, awayStudents: number, remainingStudents: number, event: { __typename?: 'CalendarEvent', name: string, colour?: Colour | null, eventId: number, calendarIds: Array<number | null>, startTime: string, endTime: string, type: CalendarEventType, allDayEvent: boolean, roomIds: Array<number>, calendarEventId: { __typename?: 'CalendarEventId', eventId: number, date?: string | null }, attendees: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', partyId: number } | { __typename: 'ProgrammeStageEnrollment', partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', partyId: number } | { __typename: 'YearGroupEnrollment', partyId: number } | null }>, lessonInfo?: { __typename?: 'CalendarEventLessonRaw', subjectGroupId: number, lessonId?: number | null } | null, rooms: Array<{ __typename?: 'Room', roomId: number, name: string, capacity?: number | null, description?: string | null, includeInTimetable: boolean, externalSystemId?: string | null, location?: string | null, disabled: boolean, pools: Array<{ __typename?: 'RoomPool', id: number, name: string, colour: Colour }> }> }, studentAwayReasons: Array<{ __typename?: 'Calendar_StudentAwayReason', id: number, name?: string | null }> }> } };

export type Calendar_ManuallyCancelEventsMutationVariables = Exact<{
  input: Calendar_ManuallyCancelEventInput;
}>;


export type Calendar_ManuallyCancelEventsMutation = { __typename?: 'Mutation', calendar_manuallyCancelEvents?: { __typename?: 'Success', success?: boolean | null } | null };

export type Calendar_DeleteEventCancellationsMutationVariables = Exact<{
  input: Calendar_DeleteEventCancellationInput;
}>;


export type Calendar_DeleteEventCancellationsMutation = { __typename?: 'Mutation', calendar_deleteEventCancellations?: { __typename?: 'Success', success?: boolean | null } | null };

export type Calendar_CloneEventMutationVariables = Exact<{
  input: Calendar_CloneEvent;
}>;


export type Calendar_CloneEventMutation = { __typename?: 'Mutation', calendar_cloneEvent?: { __typename?: 'Success', success?: boolean | null } | null };

export type Calendar_DeleteCalendarEventsMutationVariables = Exact<{
  input: Calendar_DeleteEvent;
}>;


export type Calendar_DeleteCalendarEventsMutation = { __typename?: 'Mutation', calendar_deleteCalendarEvents?: { __typename?: 'Success', success?: boolean | null } | null };

export type Calendar_EditCalendarEventsMutationVariables = Exact<{
  input: Calendar_EditEvents;
}>;


export type Calendar_EditCalendarEventsMutation = { __typename?: 'Mutation', calendar_editCalendarEvents: { __typename?: 'Calendar_UpdateEventResult', success: boolean, clashes?: Array<{ __typename?: 'Calendar_ClashError', eventId: number, event: string, startTime?: string | null, endTime?: string | null, clashingRooms: Array<{ __typename?: 'Room', roomId: number, name: string }>, clashingParties: Array<{ __typename: 'GeneralGroup' } | { __typename: 'ProgrammeStageEnrollment' } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student' } | { __typename: 'StudentContact' } | { __typename: 'SubjectGroup' } | { __typename: 'YearGroupEnrollment' }> } | null> | null } };

export type Calendar_Ical_SchoolCalendarQueryVariables = Exact<{ [key: string]: never; }>;


export type Calendar_Ical_SchoolCalendarQuery = { __typename?: 'Query', calendar_ical_schoolCalendar?: { __typename?: 'Calendar_Ical_SchoolCalendar', enabled: boolean, externalCalendarId?: string | null, externalCalendarLink?: string | null } | null };

export type Calendar_Ical_SchoolCalendarConfigureMutationVariables = Exact<{
  input: Calendar_Ical_SchoolCalendarConfigure;
}>;


export type Calendar_Ical_SchoolCalendarConfigureMutation = { __typename?: 'Mutation', calendar_ical_schoolCalendarConfigure?: { __typename?: 'Success', success?: boolean | null } | null };

export type Calendar_CalendarEventsForEditQueryVariables = Exact<{
  filter: CalendarEventRawFilter;
}>;


export type Calendar_CalendarEventsForEditQuery = { __typename?: 'Query', calendar_calendarEventsForEdit: Array<{ __typename?: 'CalendarEventRawSimple', eventId: number, calendarIds: Array<number>, type: CalendarEventType, editable: boolean, name: string, colour?: Colour | null, description?: string | null, source?: CalendarEventSource | null, sourceId?: string | null, publicStaffCalendar: boolean, publicContactCalendar: boolean, publicStudentCalendar: boolean, schedule: { __typename?: 'CalendarEventRawScheduleSimple', scheduleId: number, startTime: string, endTime: string, startDate: string, endDate?: string | null, recurrenceRule?: string | null, recurrenceEnum?: RecurrenceEnum | null, allDayEvent?: boolean | null, gridIdx?: number | null, dayIdx?: number | null, periodIdx?: number | null }, lessonInfo?: { __typename?: 'CalendarEventLessonRaw', lessonId?: number | null, subjectGroupId: number } | null, tags: Array<{ __typename?: 'CalendarTag', label: string, context: Calendar_TagContext }>, attendees: Array<{ __typename?: 'CalendarEventRawAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number } | null }>, rooms?: Array<{ __typename?: 'CalendarEventRawRoom', room?: { __typename?: 'Room', roomId: number, name: string } | null } | null> | null, createdBy: { __typename?: 'AuditPerson', userId?: number | null, partyId?: number | null, person?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null }, eventTags?: Array<{ __typename?: 'Calendar_EventTag', id: number, name: string }> | null }> };

export type Calendar_CalendarEventsQueryVariables = Exact<{
  filter: CalendarEventFilter;
}>;


export type Calendar_CalendarEventsQuery = { __typename?: 'Query', calendar_calendarEvents?: { __typename?: 'ResourceCalendarWrapper', otherEvents: Array<{ __typename?: 'CalendarEvent', name: string, eventId: number, calendarIds: Array<number | null>, startTime: string, endTime: string, type: CalendarEventType, colour?: Colour | null, description?: string | null, allDayEvent: boolean, editable: boolean, sourceId?: string | null, status: CalendarEventStatus, alsoShowForParties: Array<number>, cancellations: Array<{ __typename?: 'Calendar_EventCancelled', id: number, contextId: string, context: Calendar_CancellationContext, reason?: string | null, note?: string | null }>, lessonInfo?: { __typename?: 'CalendarEventLessonRaw', subjectGroupId: number, lessonId?: number | null } | null, exclusions: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType }>, attendees: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number } | null }>, rooms: Array<{ __typename?: 'Room', roomId: number, name: string }>, tags: Array<{ __typename?: 'CalendarTag', label: string, context: Calendar_TagContext }>, eventTags?: Array<{ __typename?: 'Calendar_EventTag', id: number, name: string }> | null, followInfo: Array<{ __typename?: 'CalendarEvent_FollowInfo', followId: number, followerParties: Array<{ __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number }>, followedParties: Array<{ __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number }> }> }>, resources: Array<{ __typename: 'PartyCalendar', resourceId: number, partyInfo?: { __typename: 'GeneralGroup', name: string, avatarUrl?: string | null } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null } | { __typename: 'Staff', person: { __typename?: 'Person', avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', person: { __typename?: 'Person', avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', person: { __typename?: 'Person', avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null } | null, events: Array<{ __typename?: 'CalendarEvent', name: string, eventId: number, calendarIds: Array<number | null>, startTime: string, endTime: string, type: CalendarEventType, colour?: Colour | null, description?: string | null, allDayEvent: boolean, editable: boolean, sourceId?: string | null, status: CalendarEventStatus, gridIdx?: number | null, periodIdx?: number | null, dayIdx?: number | null, alsoShowForParties: Array<number>, cancellations: Array<{ __typename?: 'Calendar_EventCancelled', id: number, contextId: string, context: Calendar_CancellationContext, reason?: string | null, note?: string | null }>, lessonInfo?: { __typename?: 'CalendarEventLessonRaw', subjectGroupId: number, lessonId?: number | null } | null, exclusions: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number } | null }>, attendees: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number } | null }>, rooms: Array<{ __typename?: 'Room', roomId: number, name: string }>, tags: Array<{ __typename?: 'CalendarTag', label: string, context: Calendar_TagContext }>, eventTags?: Array<{ __typename?: 'Calendar_EventTag', id: number, name: string }> | null, followInfo: Array<{ __typename?: 'CalendarEvent_FollowInfo', followId: number, followerParties: Array<{ __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number }>, followedParties: Array<{ __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number }> }> }> } | { __typename?: 'RoomCalendar', resourceId: number, room?: { __typename?: 'Room', name: string } | null, events: Array<{ __typename?: 'CalendarEvent', name: string, eventId: number, calendarIds: Array<number | null>, startTime: string, endTime: string, type: CalendarEventType, colour?: Colour | null, description?: string | null, allDayEvent: boolean, editable: boolean, sourceId?: string | null, status: CalendarEventStatus, gridIdx?: number | null, periodIdx?: number | null, dayIdx?: number | null, alsoShowForParties: Array<number>, cancellations: Array<{ __typename?: 'Calendar_EventCancelled', id: number, contextId: string, context: Calendar_CancellationContext, reason?: string | null, note?: string | null }>, lessonInfo?: { __typename?: 'CalendarEventLessonRaw', subjectGroupId: number, lessonId?: number | null } | null, exclusions: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number } | null }>, attendees: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number } | null }>, rooms: Array<{ __typename?: 'Room', roomId: number, name: string }>, tags: Array<{ __typename?: 'CalendarTag', label: string, context: Calendar_TagContext }>, eventTags?: Array<{ __typename?: 'Calendar_EventTag', id: number, name: string }> | null, followInfo: Array<{ __typename?: 'CalendarEvent_FollowInfo', followId: number, followerParties: Array<{ __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number }>, followedParties: Array<{ __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number }> }> }> }> } | null };

export type CalendarGridPeriodsQueryVariables = Exact<{
  filter?: InputMaybe<CalendarGridFilter>;
}>;


export type CalendarGridPeriodsQuery = { __typename?: 'Query', calendar_grids: Array<{ __typename?: 'CalendarGrid', gridIdx: number, name: string, days?: Array<{ __typename?: 'CalendarGridDay', isoDayOfWeek: number, dayIdx: number, startTime: string, endTime: string, periods: Array<{ __typename?: 'CalendarGridPeriod', gridIdx: number, periodIdx: number, name?: string | null, dayIdx: number, startTime: string, endTime: string, type: CalendarGridPeriodType }> } | null> | null }> };

export type Calendar_WidgetQueryVariables = Exact<{
  filter: CalendarEventFilter;
}>;


export type Calendar_WidgetQuery = { __typename?: 'Query', calendar_calendarEvents?: { __typename?: 'ResourceCalendarWrapper', otherEvents: Array<{ __typename?: 'CalendarEvent', name: string, eventId: number, startTime: string, endTime: string, type: CalendarEventType, colour?: Colour | null, allDayEvent: boolean, sourceId?: string | null, lessonInfo?: { __typename?: 'CalendarEventLessonRaw', subjectGroupId: number, lessonId?: number | null } | null, attendees: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number } | null }> }>, resources: Array<{ __typename?: 'PartyCalendar', resourceId: number, events: Array<{ __typename?: 'CalendarEvent', name: string, eventId: number, startTime: string, endTime: string, type: CalendarEventType, colour?: Colour | null, allDayEvent: boolean, sourceId?: string | null, lessonInfo?: { __typename?: 'CalendarEventLessonRaw', subjectGroupId: number, lessonId?: number | null } | null, attendees: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number } | null }> }> } | { __typename?: 'RoomCalendar', resourceId: number, events: Array<{ __typename?: 'CalendarEvent', name: string, eventId: number, startTime: string, endTime: string, type: CalendarEventType, colour?: Colour | null, allDayEvent: boolean, sourceId?: string | null, lessonInfo?: { __typename?: 'CalendarEventLessonRaw', subjectGroupId: number, lessonId?: number | null } | null, attendees: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number } | null }> }> }> } | null };

export type Calendar_EventTagsQueryVariables = Exact<{
  filter?: InputMaybe<Calendar_EventTagFilter>;
}>;


export type Calendar_EventTagsQuery = { __typename?: 'Query', calendar_eventTags: Array<{ __typename?: 'Calendar_EventTag', id: number, type: Calendar_EventTagType, systemTag: boolean, name: string, description?: string | null, colour?: Colour | null, refId?: string | null, icon?: string | null }> };

export type Calendar_UpsertEventTagMutationVariables = Exact<{
  input: Calendar_UpsertEventTag;
}>;


export type Calendar_UpsertEventTagMutation = { __typename?: 'Mutation', calendar_upsertEventTag: { __typename?: 'Success', success?: boolean | null } };

export type TimetableInfoQueryVariables = Exact<{
  filter?: InputMaybe<CalendarDayInfoFilter>;
}>;


export type TimetableInfoQuery = { __typename?: 'Query', calendar_dayInfo: Array<{ __typename?: 'CalendarDayInfo', date: string, startTime?: string | null, endTime?: string | null, dayType: DayType, gridPeriods: Array<{ __typename?: 'CalendarGridPeriodsInfo', gridIdx: number, periods: Array<{ __typename?: 'CalendarGridPeriodInfo', startTime: string, endTime: string, type: CalendarGridPeriodType, name?: string | null, periodIdx?: number | null }> }> }> };

export type Calendar_PartyTimetableQueryVariables = Exact<{
  filter: CalendarEventFilter;
}>;


export type Calendar_PartyTimetableQuery = { __typename?: 'Query', calendar_calendarEvents?: { __typename?: 'ResourceCalendarWrapper', resources: Array<{ __typename?: 'PartyCalendar', resourceId: number, gridsIds: Array<number>, events: Array<{ __typename?: 'CalendarEvent', eventId: number, sourceId?: string | null, name: string, startTime: string, endTime: string, type: CalendarEventType, colour?: Colour | null, status: CalendarEventStatus, cancellations: Array<{ __typename?: 'Calendar_EventCancelled', id: number, contextId: string, context: Calendar_CancellationContext, reason?: string | null, note?: string | null }>, attendees: Array<{ __typename?: 'CalendarEventAttendee', type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', partyId: number } | { __typename: 'ProgrammeStageEnrollment', partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number } | { __typename: 'StudentContact', partyId: number } | { __typename: 'SubjectGroup', name: string, actualName: string, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', partyId: number } | null }>, exclusions: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number } | null }>, rooms: Array<{ __typename?: 'Room', name: string }>, tags: Array<{ __typename?: 'CalendarTag', label: string, context: Calendar_TagContext }>, followInfo: Array<{ __typename?: 'CalendarEvent_FollowInfo', followId: number, followerParties: Array<{ __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number }>, followedParties: Array<{ __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number }> }> }> } | { __typename?: 'RoomCalendar', resourceId: number, gridsIds: Array<number>, events: Array<{ __typename?: 'CalendarEvent', eventId: number, sourceId?: string | null, name: string, startTime: string, endTime: string, type: CalendarEventType, colour?: Colour | null, status: CalendarEventStatus, cancellations: Array<{ __typename?: 'Calendar_EventCancelled', id: number, contextId: string, context: Calendar_CancellationContext, reason?: string | null, note?: string | null }>, attendees: Array<{ __typename?: 'CalendarEventAttendee', type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', partyId: number } | { __typename: 'ProgrammeStageEnrollment', partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number } | { __typename: 'StudentContact', partyId: number } | { __typename: 'SubjectGroup', name: string, actualName: string, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', partyId: number } | null }>, exclusions: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number } | null }>, rooms: Array<{ __typename?: 'Room', name: string }>, tags: Array<{ __typename?: 'CalendarTag', label: string, context: Calendar_TagContext }>, followInfo: Array<{ __typename?: 'CalendarEvent_FollowInfo', followId: number, followerParties: Array<{ __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number }>, followedParties: Array<{ __typename: 'GeneralGroup', generalGroupType: GeneralGroupType, name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', name: string, avatarUrl?: string | null, partyId: number }> }> }> }> } | null };

export type Calendar_UpdateCalendarBellTimesMutationVariables = Exact<{
  input: Calendar_UpdateCalendarBellTimesInput;
}>;


export type Calendar_UpdateCalendarBellTimesMutation = { __typename?: 'Mutation', calendar_updateCalendarBellTimes?: { __typename?: 'Success', success?: boolean | null } | null };

export type Calendar_UpdateCalendarDayTimesMutationVariables = Exact<{
  input: Calendar_UpdateCalendarDayTimesInput;
}>;


export type Calendar_UpdateCalendarDayTimesMutation = { __typename?: 'Mutation', calendar_updateCalendarDayTimes?: { __typename?: 'Success', success?: boolean | null } | null };

export type Core_BlocksQueryVariables = Exact<{
  filter?: InputMaybe<BlockFilter>;
}>;


export type Core_BlocksQuery = { __typename?: 'Query', core_blocks: Array<{ __typename?: 'CoreBlock', blockId: string, name: string, description?: string | null, subjectGroupNamesJoined?: string | null, subjectGroupIds: Array<number>, isRotation: boolean, rotations: Array<{ __typename?: 'BlockRotation', iteration: number, startDate: string, endDate: string }> }> };

export type Enrollment_Ire_BlockMembershipsQueryVariables = Exact<{
  filter: EnrollmentIre_BlockEnrollmentFilter;
}>;


export type Enrollment_Ire_BlockMembershipsQuery = { __typename?: 'Query', enrollment_ire_blockMemberships: { __typename?: 'EnrollmentIre_BlockMemberships', blockId: string, isRotation: boolean, block: { __typename?: 'CoreBlock', blockId: string, name: string, description?: string | null, classGroupIds: Array<number>, subjectGroupIds: Array<number> }, groups: Array<{ __typename?: 'EnrollmentIre_BlockMembershipsDetails', rotationIteration: number, unenrolledStudents: Array<{ __typename?: 'EnrollmentIre_BlockMembershipStudent', isDuplicate: boolean, classGroupName?: string | null, gender?: Gender | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }>, subjectGroups: Array<{ __typename?: 'EnrollmentIre_BlockMembershipSubjectGroup', partyId: number, name: string, students: Array<{ __typename?: 'EnrollmentIre_BlockMembershipStudent', isDuplicate: boolean, classGroupName?: string | null, gender?: Gender | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }>, staff: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }> }> }> } };

export type Enrollment_Ire_UpsertBlockMembershipsMutationVariables = Exact<{
  input: EnrollmentIre_UpsertBlockMembership;
}>;


export type Enrollment_Ire_UpsertBlockMembershipsMutation = { __typename?: 'Mutation', enrollment_ire_upsertBlockMemberships: { __typename?: 'EnrollmentIre_BlockMemberships', blockId: string } };

export type Core_EnableBlockRotationsMutationVariables = Exact<{
  input: Core_EnableBlockRotationInput;
}>;


export type Core_EnableBlockRotationsMutation = { __typename?: 'Mutation', core_enableBlockRotations?: { __typename?: 'Success', success?: boolean | null } | null };

export type Enrollment_Ire_AutoAssignBlocksMutationVariables = Exact<{
  input: EnrollmentIre_AutoAssignBlockMembershipInput;
}>;


export type Enrollment_Ire_AutoAssignBlocksMutation = { __typename?: 'Mutation', enrollment_ire_autoAssignBlocks: { __typename?: 'Success', success?: boolean | null } };

export type Enrollment_Ire_CoreMembershipsQueryVariables = Exact<{
  filter: EnrollmentIre_CoreEnrollmentFilter;
}>;


export type Enrollment_Ire_CoreMembershipsQuery = { __typename?: 'Query', enrollment_ire_coreMemberships: { __typename?: 'EnrollmentIre_CoreMemberships', yearGroupEnrollment?: { __typename?: 'YearGroupEnrollment', yearGroupId: number, name: string } | null, unenrolledStudents: Array<{ __typename?: 'Student', personalInformation?: { __typename?: 'PersonalInformation', gender?: Gender | null } | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }>, classGroups: Array<{ __typename?: 'GeneralGroup', partyId: number, name: string, groupTags: Array<{ __typename?: 'GroupTag', id: number, name: string, type?: GroupTagType | null }>, students: Array<{ __typename?: 'Student', personalInformation?: { __typename?: 'PersonalInformation', gender?: Gender | null } | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }>, staff: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }> }> } };

export type Enrollment_Ire_UpsertCoreMembershipsMutationVariables = Exact<{
  input: EnrollmentIre_UpsertCoreMembership;
}>;


export type Enrollment_Ire_UpsertCoreMembershipsMutation = { __typename?: 'Mutation', enrollment_ire_upsertCoreMemberships: { __typename?: 'EnrollmentIre_CoreMemberships', yearGroupEnrollment?: { __typename?: 'YearGroupEnrollment', yearGroupId: number } | null } };

export type Enrollment_Ire_AutoAssignCoreMutationVariables = Exact<{
  input: EnrollmentIre_AutoAssignCoreMembershipInput;
}>;


export type Enrollment_Ire_AutoAssignCoreMutation = { __typename?: 'Mutation', enrollment_ire_autoAssignCore: { __typename?: 'Success', success?: boolean | null } };

export type Clm_OptionsSourceListQueryVariables = Exact<{
  filter?: InputMaybe<Options_OptionFilter>;
}>;


export type Clm_OptionsSourceListQuery = { __typename?: 'Query', options_options: Array<{ __typename?: 'Options_Option', id: number, name: string, studentCount: number, yearGroup: { __typename?: 'YearGroup', name: string } }> };

export type Clm_OptionsSourceBlocksQueryVariables = Exact<{
  filter?: InputMaybe<Options_OptionIdFilter>;
}>;


export type Clm_OptionsSourceBlocksQuery = { __typename?: 'Query', options_solutions: { __typename?: 'Options_Solution', optionId: number, solverStatus: SolutionStatus, pools: Array<{ __typename?: 'Options_SolutionPool', blocks: Array<{ __typename?: 'Options_Block', blockIdx: number, name: string }> }> } };

export type Clm_OptionsSourceClmQueryVariables = Exact<{
  filter: Options_ClmFilter;
}>;


export type Clm_OptionsSourceClmQuery = { __typename?: 'Query', options_clm: { __typename?: 'Options_CLM', blockIdx: number, subjectGroups: Array<{ __typename?: 'Options_SubjectGroupMembership', id: number, subjectGroupName: string, studentPartyIds: Array<number> }> } };

export type Print_ClmQueryVariables = Exact<{
  filter: Print_Clm;
}>;


export type Print_ClmQuery = { __typename?: 'Query', print_clm: { __typename?: 'TemporaryDownload', url?: string | null, html?: string | null } };

export type Rot_AddBlockRotationsMutationVariables = Exact<{
  input?: InputMaybe<Rot_AddRotation>;
}>;


export type Rot_AddBlockRotationsMutation = { __typename?: 'Mutation', rot_addBlockRotations?: { __typename?: 'Success', success?: boolean | null } | null };

export type Rot_RemoveBlockRotationDateMutationVariables = Exact<{
  input?: InputMaybe<Rot_RemoveRotationDate>;
}>;


export type Rot_RemoveBlockRotationDateMutation = { __typename?: 'Mutation', rot_removeBlockRotationDate?: { __typename?: 'Success', success?: boolean | null } | null };

export type Rot_DeleteRotationMutationVariables = Exact<{
  input?: InputMaybe<Rot_DeleteRotation>;
}>;


export type Rot_DeleteRotationMutation = { __typename?: 'Mutation', rot_deleteRotation?: { __typename?: 'Success', success?: boolean | null } | null };

export type Core_RotateBlockStudentsMutationVariables = Exact<{
  input: Core_RotateBlockStudentsInput;
}>;


export type Core_RotateBlockStudentsMutation = { __typename?: 'Mutation', core_rotateBlockStudents: { __typename?: 'Success', success?: boolean | null } };

export type Documentation_Admin_ChangeRequestsQueryVariables = Exact<{
  filter?: InputMaybe<Documentation_ChangeRequestFilter>;
}>;


export type Documentation_Admin_ChangeRequestsQuery = { __typename?: 'Query', documentation_admin_changeRequests: Array<{ __typename?: 'Documentation_ChangeRequest', id: number, title: string, description?: string | null, status: Documentation_ChangeRequestStatus, source: Documentation_ChangeRequestSource, rejectionReason?: string | null, cancellationReason?: string | null, releaseTag?: string | null, createdByUserId?: number | null, createdOn?: string | null, updatedOn?: string | null }> };

export type Documentation_Admin_ChangeRequestQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type Documentation_Admin_ChangeRequestQuery = { __typename?: 'Query', documentation_admin_changeRequest?: { __typename?: 'Documentation_ChangeRequest', id: number, title: string, description?: string | null, status: Documentation_ChangeRequestStatus, source: Documentation_ChangeRequestSource, rejectionReason?: string | null, cancellationReason?: string | null, releaseTag?: string | null, createdByUserId?: number | null, createdOn?: string | null, updatedOn?: string | null } | null };

export type Documentation_Admin_ChangeRequestDiffQueryVariables = Exact<{
  changeRequestId: Scalars['Int']['input'];
}>;


export type Documentation_Admin_ChangeRequestDiffQuery = { __typename?: 'Query', documentation_admin_changeRequestDiff: Array<{ __typename?: 'Documentation_ChangeRequestDiff', itemId: number, pageId?: number | null, operation: string, proposedContent?: string | null, currentContent?: string | null, currentPublishedVersionId?: number | null, proposedVideoData?: { __typename?: 'Documentation_PageVideoData', sourceUrl: string, provider: Documentation_VideoProvider, embedUrl: string, thumbnailUrl?: string | null, durationSec?: number | null, aspectRatio?: string | null } | null, currentVideoData?: { __typename?: 'Documentation_PageVideoData', sourceUrl: string, provider: Documentation_VideoProvider, embedUrl: string, thumbnailUrl?: string | null, durationSec?: number | null, aspectRatio?: string | null } | null }> };

export type Documentation_Admin_CreateChangeRequestMutationVariables = Exact<{
  input: Documentation_CreateChangeRequestInput;
}>;


export type Documentation_Admin_CreateChangeRequestMutation = { __typename?: 'Mutation', documentation_admin_createChangeRequest: { __typename?: 'Documentation_ChangeRequest', id: number, title: string, status: Documentation_ChangeRequestStatus } };

export type Documentation_Admin_AddChangeRequestItemMutationVariables = Exact<{
  input: Documentation_AddChangeRequestItemInput;
}>;


export type Documentation_Admin_AddChangeRequestItemMutation = { __typename?: 'Mutation', documentation_admin_addChangeRequestItem: { __typename?: 'Documentation_ChangeRequestItem', id: number, changeRequestId: number, pageId?: number | null, operation: Documentation_ItemOperation } };

export type Documentation_Admin_SubmitChangeRequestsMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type Documentation_Admin_SubmitChangeRequestsMutation = { __typename?: 'Mutation', documentation_admin_submitChangeRequests: Array<{ __typename?: 'Documentation_ChangeRequest', id: number, status: Documentation_ChangeRequestStatus }> };

export type Documentation_Admin_ApproveChangeRequestsMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type Documentation_Admin_ApproveChangeRequestsMutation = { __typename?: 'Mutation', documentation_admin_approveChangeRequests: Array<{ __typename?: 'Documentation_ChangeRequest', id: number, status: Documentation_ChangeRequestStatus }> };

export type Documentation_Admin_RejectChangeRequestsMutationVariables = Exact<{
  input: Documentation_RejectChangeRequestsInput;
}>;


export type Documentation_Admin_RejectChangeRequestsMutation = { __typename?: 'Mutation', documentation_admin_rejectChangeRequests: Array<{ __typename?: 'Documentation_ChangeRequest', id: number, status: Documentation_ChangeRequestStatus }> };

export type Documentation_Admin_CancelChangeRequestsMutationVariables = Exact<{
  input: Documentation_CancelChangeRequestsInput;
}>;


export type Documentation_Admin_CancelChangeRequestsMutation = { __typename?: 'Mutation', documentation_admin_cancelChangeRequests: Array<{ __typename?: 'Documentation_ChangeRequest', id: number, status: Documentation_ChangeRequestStatus }> };

export type Documentation_Admin_RevertChangeRequestToDraftMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type Documentation_Admin_RevertChangeRequestToDraftMutation = { __typename?: 'Mutation', documentation_admin_revertChangeRequestToDraft: { __typename?: 'Documentation_ChangeRequest', id: number, status: Documentation_ChangeRequestStatus } };

export type Documentation_Admin_QuickMergeChangeRequestMutationVariables = Exact<{
  input: Documentation_QuickMergeChangeRequestInput;
}>;


export type Documentation_Admin_QuickMergeChangeRequestMutation = { __typename?: 'Mutation', documentation_admin_quickMergeChangeRequest: { __typename?: 'Documentation_ChangeRequest', id: number, status: Documentation_ChangeRequestStatus } };

export type Documentation_Admin_QuickPublishMutationVariables = Exact<{
  input: Documentation_QuickPublishInput;
}>;


export type Documentation_Admin_QuickPublishMutation = { __typename?: 'Mutation', documentation_admin_quickPublish: { __typename?: 'Documentation_ChangeRequest', id: number, status: Documentation_ChangeRequestStatus } };

export type Documentation_Admin_RemoveChangeRequestItemMutationVariables = Exact<{
  input: Documentation_RemoveChangeRequestItemInput;
}>;


export type Documentation_Admin_RemoveChangeRequestItemMutation = { __typename?: 'Mutation', documentation_admin_removeChangeRequestItem?: { __typename?: 'Success', success?: boolean | null } | null };

export type Documentation_Admin_ConflictingChangeRequestsQueryVariables = Exact<{
  changeRequestId: Scalars['Int']['input'];
}>;


export type Documentation_Admin_ConflictingChangeRequestsQuery = { __typename?: 'Query', documentation_admin_conflictingChangeRequests: Array<{ __typename?: 'Documentation_ChangeRequest', id: number, title: string, status: Documentation_ChangeRequestStatus }> };

export type Documentation_Admin_UpdateChangeRequestReleaseTagMutationVariables = Exact<{
  input: Documentation_UpdateChangeRequestReleaseTagInput;
}>;


export type Documentation_Admin_UpdateChangeRequestReleaseTagMutation = { __typename?: 'Mutation', documentation_admin_updateChangeRequestReleaseTag: { __typename?: 'Documentation_ChangeRequest', id: number, status: Documentation_ChangeRequestStatus, releaseTag?: string | null } };

export type Documentation_User_PagesQueryVariables = Exact<{
  filter: Documentation_PageFilter;
}>;


export type Documentation_User_PagesQuery = { __typename?: 'Query', documentation_user_pages: Array<{ __typename?: 'Documentation_Page', id: number, spaceId: number, parentPageId?: number | null, slug: string, title: string, sortOrder: number, userTypes: Array<string>, publishedVersionId?: number | null, entityType: string, videoData?: { __typename?: 'Documentation_PageVideoData', durationSec?: number | null } | null }> };

export type Documentation_Admin_PagesQueryVariables = Exact<{
  filter: Documentation_PageFilter;
}>;


export type Documentation_Admin_PagesQuery = { __typename?: 'Query', documentation_admin_pages: Array<{ __typename?: 'Documentation_AdminPageListItem', activeCrStatus?: Documentation_ChangeRequestStatus | null, page: { __typename?: 'Documentation_Page', id: number, spaceId: number, parentPageId?: number | null, slug: string, title: string, sortOrder: number, userTypes: Array<string>, publishedVersionId?: number | null, entityType: string, videoData?: { __typename?: 'Documentation_PageVideoData', durationSec?: number | null } | null }, metadata: Array<{ __typename?: 'Documentation_PageMetadata', id: number, pageId: number, blockId?: string | null, key: Documentation_PageMetadataKey, value: string }> }> };

export type Documentation_User_PageQueryVariables = Exact<{
  filter: Documentation_SinglePageFilter;
}>;


export type Documentation_User_PageQuery = { __typename?: 'Query', documentation_user_page?: { __typename?: 'Documentation_Page', id: number, spaceId: number, parentPageId?: number | null, slug: string, title: string, sortOrder: number, userTypes: Array<string>, publishedVersionId?: number | null, contentMd?: string | null, entityType: string, brokenLinkCount: number, pendingLinkCount: number, videoData?: { __typename?: 'Documentation_PageVideoData', sourceUrl: string, provider: Documentation_VideoProvider, embedUrl: string, thumbnailUrl?: string | null, durationSec?: number | null, aspectRatio?: string | null } | null } | null };

export type Documentation_User_PageMetadataQueryVariables = Exact<{
  pageIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type Documentation_User_PageMetadataQuery = { __typename?: 'Query', documentation_user_pageMetadata: Array<{ __typename?: 'Documentation_PageMetadata', id: number, pageId: number, blockId?: string | null, key: Documentation_PageMetadataKey, value: string }> };

export type Documentation_Admin_PageDetailQueryVariables = Exact<{
  filter: Documentation_SinglePageFilter;
}>;


export type Documentation_Admin_PageDetailQuery = { __typename?: 'Query', documentation_admin_pageDetail?: { __typename?: 'Documentation_PageDetail', page?: { __typename?: 'Documentation_Page', id: number, spaceId: number, parentPageId?: number | null, slug: string, title: string, sortOrder: number, userTypes: Array<string>, publishedVersionId?: number | null, contentMd?: string | null, entityType: string, brokenLinkCount: number, pendingLinkCount: number, videoData?: { __typename?: 'Documentation_PageVideoData', sourceUrl: string, provider: Documentation_VideoProvider, embedUrl: string, thumbnailUrl?: string | null, durationSec?: number | null, aspectRatio?: string | null } | null } | null, metadata: Array<{ __typename?: 'Documentation_PageMetadata', id: number, pageId: number, blockId?: string | null, key: Documentation_PageMetadataKey, value: string }>, activeChangeRequest?: { __typename?: 'Documentation_ActiveChangeRequestForPage', contentMd?: string | null, changeRequest: { __typename?: 'Documentation_ChangeRequest', id: number, title: string, status: Documentation_ChangeRequestStatus, createdOn?: string | null, releaseTag?: string | null }, videoData?: { __typename?: 'Documentation_PageVideoData', sourceUrl: string, provider: Documentation_VideoProvider, embedUrl: string, thumbnailUrl?: string | null, durationSec?: number | null, aspectRatio?: string | null } | null } | null } | null };

export type Documentation_Admin_RefreshVideoDataMutationVariables = Exact<{
  input: Documentation_RefreshVideoDataInput;
}>;


export type Documentation_Admin_RefreshVideoDataMutation = { __typename?: 'Mutation', documentation_admin_refreshVideoData: { __typename?: 'Documentation_PageVideoData', sourceUrl: string, provider: Documentation_VideoProvider, embedUrl: string, thumbnailUrl?: string | null, durationSec?: number | null, aspectRatio?: string | null } };

export type Documentation_Admin_ReplacePageVideoUrlMutationVariables = Exact<{
  input: Documentation_ReplacePageVideoUrlInput;
}>;


export type Documentation_Admin_ReplacePageVideoUrlMutation = { __typename?: 'Mutation', documentation_admin_replacePageVideoUrl: { __typename?: 'Documentation_PageVideoData', sourceUrl: string, provider: Documentation_VideoProvider, embedUrl: string, thumbnailUrl?: string | null, durationSec?: number | null, aspectRatio?: string | null } };

export type Documentation_Admin_CreatePageMutationVariables = Exact<{
  input: Documentation_CreatePageInput;
}>;


export type Documentation_Admin_CreatePageMutation = { __typename?: 'Mutation', documentation_admin_createPage: { __typename?: 'Documentation_Page', id: number, spaceId: number, slug: string, title: string } };

export type Documentation_Admin_UpdatePageMutationVariables = Exact<{
  input: Documentation_UpdatePageInput;
}>;


export type Documentation_Admin_UpdatePageMutation = { __typename?: 'Mutation', documentation_admin_updatePage: { __typename?: 'Documentation_Page', id: number, title: string, userTypes: Array<string> } };

export type Documentation_Admin_DeletePagesMutationVariables = Exact<{
  pageIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type Documentation_Admin_DeletePagesMutation = { __typename?: 'Mutation', documentation_admin_deletePages?: { __typename?: 'Success', success?: boolean | null } | null };

export type Documentation_Admin_MovePageMutationVariables = Exact<{
  input: Documentation_MovePageInput;
}>;


export type Documentation_Admin_MovePageMutation = { __typename?: 'Mutation', documentation_admin_movePage?: { __typename?: 'Success', success?: boolean | null } | null };

export type Documentation_Admin_SetPageMetadataMutationVariables = Exact<{
  input: Documentation_SetPageMetadataInput;
}>;


export type Documentation_Admin_SetPageMetadataMutation = { __typename?: 'Mutation', documentation_admin_setPageMetadata?: { __typename?: 'Success', success?: boolean | null } | null };

export type Documentation_Admin_AllPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type Documentation_Admin_AllPagesQuery = { __typename?: 'Query', documentation_admin_allPages: Array<{ __typename?: 'Documentation_AdminPageSummary', id: number, spaceId: number, spaceSlug: string, spaceName: string, slug: string, title: string, entityType: string, publishedVersionId?: number | null }> };

export type Documentation_User_RelatedPagesQueryVariables = Exact<{
  filter?: InputMaybe<Documentation_RelatedPagesFilter>;
}>;


export type Documentation_User_RelatedPagesQuery = { __typename?: 'Query', documentation_user_relatedPages: Array<{ __typename?: 'Documentation_RelatedPage', pageId: number, spaceId: number, title: string, spaceSlug: string, spaceName: string, pageSlug: string, entityType: string, ancestorTitles: Array<string> }> };

export type Documentation_Admin_PermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type Documentation_Admin_PermissionsQuery = { __typename?: 'Query', documentation_admin_permissions: Array<{ __typename?: 'Documentation_PermissionInfo', name: string, displayName: string }> };

export type Documentation_Admin_ReleaseTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type Documentation_Admin_ReleaseTagsQuery = { __typename?: 'Query', documentation_admin_releaseTags: Array<{ __typename?: 'Documentation_ReleaseTag', releaseTag: string, draftCount: number, inReviewCount: number, approvedCount: number, mergedCount: number }> };

export type Documentation_Admin_PromoteReleaseMutationVariables = Exact<{
  releaseTag: Scalars['String']['input'];
}>;


export type Documentation_Admin_PromoteReleaseMutation = { __typename?: 'Mutation', documentation_admin_promoteRelease: { __typename?: 'Documentation_PromotionResult', promotedItemIds: Array<number>, conflictingItemIds: Array<number>, promotedCrIds: Array<number> } };

export type Documentation_User_SearchQueryVariables = Exact<{
  filter: Documentation_SearchFilter;
}>;


export type Documentation_User_SearchQuery = { __typename?: 'Query', documentation_user_search: Array<{ __typename?: 'Documentation_SearchResult', pageId: number, title: string, spaceSlug: string, spaceName: string, pageSlug: string, entityType: string, snippet: string, rank: number, ancestorTitles: Array<string> }> };

export type Documentation_User_SpacesQueryVariables = Exact<{ [key: string]: never; }>;


export type Documentation_User_SpacesQuery = { __typename?: 'Query', documentation_user_spaces: Array<{ __typename?: 'Documentation_Space', id: number, name: string, slug: string, icon?: string | null, description?: string | null, sortOrder: number, articleCount: number, videoCount: number }> };

export type Documentation_Admin_CreateSpaceMutationVariables = Exact<{
  input: Documentation_CreateSpaceInput;
}>;


export type Documentation_Admin_CreateSpaceMutation = { __typename?: 'Mutation', documentation_admin_createSpace: { __typename?: 'Documentation_Space', id: number, name: string, slug: string } };

export type Documentation_Admin_UpdateSpaceMutationVariables = Exact<{
  input: Documentation_UpdateSpaceInput;
}>;


export type Documentation_Admin_UpdateSpaceMutation = { __typename?: 'Mutation', documentation_admin_updateSpace: { __typename?: 'Documentation_Space', id: number, name: string, slug: string } };

export type Documentation_Admin_DeleteSpaceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type Documentation_Admin_DeleteSpaceMutation = { __typename?: 'Mutation', documentation_admin_deleteSpace?: { __typename?: 'Success', success?: boolean | null } | null };

export type Documentation_Admin_ReorderSpacesMutationVariables = Exact<{
  input: Documentation_ReorderSpacesInput;
}>;


export type Documentation_Admin_ReorderSpacesMutation = { __typename?: 'Mutation', documentation_admin_reorderSpaces?: { __typename?: 'Success', success?: boolean | null } | null };

export type Tyrone_RefreshDocumentationIndexMutationVariables = Exact<{ [key: string]: never; }>;


export type Tyrone_RefreshDocumentationIndexMutation = { __typename?: 'Mutation', tyrone_refreshDocumentationIndex: { __typename?: 'Success', success?: boolean | null } };

export type Documentation_Admin_PageVersionsQueryVariables = Exact<{
  pageId: Scalars['Int']['input'];
}>;


export type Documentation_Admin_PageVersionsQuery = { __typename?: 'Query', documentation_admin_pageVersions: Array<{ __typename?: 'Documentation_PageVersion', id: number, pageId: number, versionNumber: number, status: Documentation_VersionStatus, changeRequestId?: number | null, createdOn?: string | null }> };

export type Documentation_Admin_PageVersionContentQueryVariables = Exact<{
  versionId: Scalars['Int']['input'];
}>;


export type Documentation_Admin_PageVersionContentQuery = { __typename?: 'Query', documentation_admin_pageVersionContent?: { __typename?: 'Documentation_PageVersion', id: number, pageId: number, versionNumber: number, contentMd?: string | null, status: Documentation_VersionStatus, createdOn?: string | null } | null };

export type Documentation_Admin_RestoreVersionMutationVariables = Exact<{
  input: Documentation_RestoreVersionInput;
}>;


export type Documentation_Admin_RestoreVersionMutation = { __typename?: 'Mutation', documentation_admin_restoreVersion: number };

export type Drive_SetFolderTypeMutationVariables = Exact<{
  input: Folders_DriveSetFolderTypeInput;
}>;


export type Drive_SetFolderTypeMutation = { __typename?: 'Mutation', drive_setFolderType: { __typename?: 'Folders_Folder', id: number, type: Folders_FolderType } };

export type Drive_UpdateFolderAclMutationVariables = Exact<{
  input: Folders_DriveUpdateFolderAclInput;
}>;


export type Drive_UpdateFolderAclMutation = { __typename?: 'Mutation', drive_updateFolderAcl: { __typename?: 'Folders_FolderAcl', subjects: Array<{ __typename?: 'Folders_FolderAclSubject', partyId: number, name?: string | null, isGroup: boolean }> } };

export type Drive_FolderAclQueryVariables = Exact<{
  input: Folders_DriveFolderAclInput;
}>;


export type Drive_FolderAclQuery = { __typename?: 'Query', drive_folderAcl?: { __typename?: 'Folders_FolderAcl', subjects: Array<{ __typename?: 'Folders_FolderAclSubject', partyId: number, name?: string | null, isGroup: boolean }> } | null };

export type Drive_FolderGrantsForCurrentUserQueryVariables = Exact<{
  input: Folders_DriveFolderGrantsInput;
}>;


export type Drive_FolderGrantsForCurrentUserQuery = { __typename?: 'Query', drive_folderGrantsForCurrentUser: Array<{ __typename?: 'Folders_FolderGrantPathEntry', entityType: Folders_ItemType, entityId: string, paths: Array<{ __typename?: 'Folders_FolderGrantPath', ancestorFolderId: number, ancestorFolderName: string }> }> };

export type Drive_PreviewAclSubjectRemovalQueryVariables = Exact<{
  input: Folders_DriveAclRemovalPreviewInput;
}>;


export type Drive_PreviewAclSubjectRemovalQuery = { __typename?: 'Query', drive_previewAclSubjectRemoval: { __typename?: 'Folders_ResidualAccessPreview', totalItemsInSubtree: number, itemsRetained: number, itemsLost: number, items: Array<{ __typename?: 'Folders_ResidualAccessItem', entityType: Folders_ItemType, entityId: string, status: Folders_ResidualAccessStatus }> } };

export type Drive_CreateFolderMutationVariables = Exact<{
  input: Folders_DriveCreateFolderInput;
}>;


export type Drive_CreateFolderMutation = { __typename?: 'Mutation', drive_createFolder: { __typename?: 'Folders_Folder', id: number, name: string } };

export type Drive_UpdateFolderMutationVariables = Exact<{
  input: Folders_DriveUpdateFolderInput;
}>;


export type Drive_UpdateFolderMutation = { __typename?: 'Mutation', drive_updateFolder: { __typename?: 'Folders_Folder', id: number, name: string } };

export type Drive_ArchiveFolderMutationVariables = Exact<{
  input: Folders_DriveArchiveFolderInput;
}>;


export type Drive_ArchiveFolderMutation = { __typename?: 'Mutation', drive_archiveFolder: { __typename?: 'Folders_Folder', id: number, status: Folders_Status } };

export type Drive_RestoreFolderMutationVariables = Exact<{
  input: Folders_DriveRestoreFolderInput;
}>;


export type Drive_RestoreFolderMutation = { __typename?: 'Mutation', drive_restoreFolder: { __typename?: 'Folders_Folder', id: number, status: Folders_Status } };

export type Drive_DeleteFolderMutationVariables = Exact<{
  input: Folders_DriveDeleteFolderInput;
}>;


export type Drive_DeleteFolderMutation = { __typename?: 'Mutation', drive_deleteFolder: { __typename?: 'Success', success?: boolean | null } };

export type Drive_ItemsQueryVariables = Exact<{
  input: Folders_DriveItemsInput;
}>;


export type Drive_ItemsQuery = { __typename?: 'Query', drive_items: Array<{ __typename?: 'Folders_FolderItem', entityType: Folders_ItemType, entityId: string, title?: string | null, previewUrl?: string | null, createdAt?: string | null, createdByPartyId?: number | null, addedByPartyId?: number | null, addedAt?: string | null, folderCount: number, available: boolean, createdBy?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null } | null, addedBy?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null } | null, pbac?: { __typename?: 'Pbac_ResourceResult', isSecured: boolean, canRead: boolean, canWrite: boolean, canDelete: boolean, canChangePbac: boolean } | null }> };

export type Drive_AddItemMutationVariables = Exact<{
  input: Folders_DriveAddItemInput;
}>;


export type Drive_AddItemMutation = { __typename?: 'Mutation', drive_addItem: { __typename?: 'Folders_FolderItemLink', id: number, folderId?: number | null, entityType: Folders_ItemType, entityId: string } };

export type Drive_RemoveItemMutationVariables = Exact<{
  input: Folders_DriveRemoveItemInput;
}>;


export type Drive_RemoveItemMutation = { __typename?: 'Mutation', drive_removeItem: { __typename?: 'Success', success?: boolean | null } };

export type Drive_CreateNoteMutationVariables = Exact<{
  filter: Notesv2_UpsertNotes;
}>;


export type Drive_CreateNoteMutation = { __typename?: 'Mutation', notesv2_upsertNote: Array<number> };

export type Drive_AddQuickLinkMutationVariables = Exact<{
  input: Folders_DriveAddQuickLinkInput;
}>;


export type Drive_AddQuickLinkMutation = { __typename?: 'Mutation', drive_addQuickLink: { __typename?: 'Folders_FolderQuickLink', id: number, folderId?: number | null, title: string, url: string, description?: string | null, isGlobal: boolean } };

export type Drive_DeleteQuickLinkMutationVariables = Exact<{
  input: Folders_DriveDeleteQuickLinkInput;
}>;


export type Drive_DeleteQuickLinkMutation = { __typename?: 'Mutation', drive_deleteQuickLink: { __typename?: 'Success', success?: boolean | null } };

export type Drive_TreeQueryVariables = Exact<{
  input: Folders_DriveTreeInput;
}>;


export type Drive_TreeQuery = { __typename?: 'Query', drive_tree: Array<{ __typename?: 'Folders_Folder', id: number, name: string, description?: string | null, parentFolderId?: number | null, namespace: string, contextEntityType?: string | null, contextEntityId?: string | null, status: Folders_Status, type: Folders_FolderType, icon?: string | null, colour?: string | null, sortOrder: number, itemCount: number, createdByPartyId?: number | null, createdBy?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null } | null, quickLinks: Array<{ __typename?: 'Folders_FolderQuickLink', id: number, folderId?: number | null, title: string, url: string, description?: string | null, isGlobal: boolean }> }> };

export type Fees_AccountingCodesQueryVariables = Exact<{
  filter?: InputMaybe<AccountingCodeFilter>;
}>;


export type Fees_AccountingCodesQuery = { __typename?: 'Query', fees_accountingCodes: Array<{ __typename?: 'AccountingCode', id: number, code: string, description?: string | null, active: boolean, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> };

export type Fees_BulkApplyIndividualDiscountsMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<IndividualDiscountInput>> | InputMaybe<IndividualDiscountInput>>;
}>;


export type Fees_BulkApplyIndividualDiscountsMutation = { __typename?: 'Mutation', fees_bulkApplyIndividualDiscounts: { __typename?: 'Success', success?: boolean | null } };

export type Fees_CardPaymentPlansQueryVariables = Exact<{
  filter?: InputMaybe<CardPaymentPlanFilter>;
}>;


export type Fees_CardPaymentPlansQuery = { __typename?: 'Query', fees_cardPaymentPlans: Array<{ __typename?: 'CardPaymentPlan', paymentMethodId: string, paymentPlanId: number, feeName: string, status: PaymentPlanStatus, paymentPlanStartDate: string }> };

export type CreatePaymentMutationVariables = Exact<{
  input?: InputMaybe<MakePaymentInput>;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', fees_createPayment: { __typename?: 'CreatePaymentResponse', clientSecret?: string | null, bankTransferInstructions?: { __typename?: 'BankTransferInstructions', reference: string, iban: string, bic: string, accountHolderName: string, amountDue: number } | null } };

export type Fees_StripeCustomerInfoQueryVariables = Exact<{
  filter?: InputMaybe<OnBehalfOfInput>;
}>;


export type Fees_StripeCustomerInfoQuery = { __typename?: 'Query', fees_stripeCustomerInfo: { __typename?: 'StripeCustomerInfo', customerId: string, ephemeralKey: string } };

export type Fees_DebtorsQueryVariables = Exact<{
  filter?: InputMaybe<FeeFilter>;
}>;


export type Fees_DebtorsQuery = { __typename?: 'Query', fees_fees: Array<{ __typename?: 'Fee', debtors?: Array<{ __typename?: 'Debtor', id: number, feeId: number, feeStatus: FeeStatus, amount: number, amountPaid: number, amountDue: number, amountDiscounted: number, writeOffNote?: string | null, amountWrittenOff: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup: { __typename?: 'GeneralGroup', name: string }, discounts: Array<{ __typename?: 'Discount', id: number, name: string, discountType: DiscountType, value: number }> }> | null }> };

export type Fees_DeleteCardMutationVariables = Exact<{
  input?: InputMaybe<DeleteCardInput>;
}>;


export type Fees_DeleteCardMutation = { __typename?: 'Mutation', fees_deleteCard: { __typename?: 'Success', success?: boolean | null } };

export type Fees_DeleteDiscountMutationVariables = Exact<{
  input: DeleteDiscountInput;
}>;


export type Fees_DeleteDiscountMutation = { __typename?: 'Mutation', fees_deleteDiscount: { __typename?: 'Success', success?: boolean | null } };

export type Fees_DeleteFeeMutationVariables = Exact<{
  input: DeleteFeeInput;
}>;


export type Fees_DeleteFeeMutation = { __typename?: 'Mutation', fees_deleteFee: { __typename?: 'Success', success?: boolean | null } };

export type Fees_DiscountsQueryVariables = Exact<{
  filter?: InputMaybe<DiscountFilter>;
}>;


export type Fees_DiscountsQuery = { __typename?: 'Query', fees_discounts: Array<{ __typename?: 'Discount', id: number, name: string, description?: string | null, discountType: DiscountType, value: number, siblingDiscount?: boolean | null, active: boolean, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> };

export type Fees_CategoriesQueryVariables = Exact<{
  filter?: InputMaybe<CategoryFilter>;
}>;


export type Fees_CategoriesQuery = { __typename?: 'Query', fees_categories: Array<{ __typename?: 'Category', id: number, name: string, description?: string | null, active: boolean, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> };

export type Fees_FeesQueryVariables = Exact<{
  filter?: InputMaybe<FeeFilter>;
}>;


export type Fees_FeesQuery = { __typename?: 'Query', fees_fees: Array<{ __typename?: 'Fee', id?: number | null, name: string, description?: string | null, dueDate: string, amount: number, feeType: FeeType, absorbFees: boolean, published: boolean, publishedOn?: string | null, total: number, paid: number, due: number, writtenOff: number, feeStatus: FeeStatus, allowPartialPayments: boolean, paymentPlan: boolean, paymentPlanInterval?: PaymentPlanInterval | null, paymentPlanIntervalCount?: number | null, assignedToParties?: Array<{ __typename: 'GeneralGroup', partyId: number, name: string } | { __typename: 'ProgrammeStageEnrollment', partyId: number, name: string } | { __typename: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', partyId: number, name: string }> | null, categories?: Array<{ __typename?: 'Category', id: number, name: string }> | null, discounts?: Array<{ __typename?: 'Discount', id: number, name: string, discountType: DiscountType, value: number }> | null, individualDiscounts?: Array<{ __typename?: 'IndividualDiscount', personPartyId: number, adHocAmount?: number | null, discount: { __typename?: 'Discount', id: number, name: string, discountType: DiscountType, value: number } }> | null, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, exclusions: Array<{ __typename?: 'ExcludedPerson', excludedOn: string, excludedPerson: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, excludedBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }>, accountingCode?: { __typename?: 'AccountingCode', id: number, code: string } | null, installments?: Array<{ __typename?: 'FeeInstallment', id: number, feeId: number, installment: number, amount: number, serviceCharges: number, stripePriceId: string }> | null }> };

export type Fees_MigrateFeeMutationVariables = Exact<{
  input: FeeMigrationInput;
}>;


export type Fees_MigrateFeeMutation = { __typename?: 'Mutation', fees_migrateFee: { __typename?: 'Success', success?: boolean | null } };

export type Fees_PaymentPlanInstallmentsQueryVariables = Exact<{
  filter?: InputMaybe<CalculatePaymentPlanFilter>;
}>;


export type Fees_PaymentPlanInstallmentsQuery = { __typename?: 'Query', fees_paymentPlanInstallments: Array<{ __typename?: 'PaymentPlanInstallments', id: { __typename?: 'PaymentPlanId', feeId: number, studentPartyId: number }, installments: Array<{ __typename?: 'PaymentPlanInstallment', installment: number, installmentDate: string, amount: number, serviceCharges: number, absorbFees: boolean }> }> };

export type Fees_PaymentsQueryVariables = Exact<{
  filter?: InputMaybe<PaymentFilter>;
}>;


export type Fees_PaymentsQuery = { __typename?: 'Query', fees_payments: Array<{ __typename?: 'Payment', id: number, studentPartyId: number, amount: number, paymentIntentId: string, paymentMethod: PaymentMethod, transactionDate: string, serviceFeesAmount: number, note?: string | null, cardType: string, installment?: number | null, fee: { __typename?: 'Fee', id?: number | null, name: string }, student?: { __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | null, payee: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, refunds: Array<{ __typename?: 'Refund', id: number, amount: number, refundType: RefundType, refundStatus: RefundStatus, refundDate: string }> }> };

export type PrintFeesQueryVariables = Exact<{
  filter: Print_FeeOptions;
}>;


export type PrintFeesQuery = { __typename?: 'Query', print_fees: { __typename?: 'TemporaryDownload', url?: string | null, html?: string | null } };

export type Fees_PublishMutationVariables = Exact<{
  input: PublishInput;
}>;


export type Fees_PublishMutation = { __typename?: 'Mutation', fees_publish: { __typename?: 'Success', success?: boolean | null } };

export type Fees_RefundMutationVariables = Exact<{
  input: RefundInput;
}>;


export type Fees_RefundMutation = { __typename?: 'Mutation', fees_refund: { __typename?: 'Success', success?: boolean | null } };

export type Fees_SaveAccountingCodeMutationVariables = Exact<{
  input?: InputMaybe<SaveAccountCodeInput>;
}>;


export type Fees_SaveAccountingCodeMutation = { __typename?: 'Mutation', fees_saveAccountingCode: { __typename?: 'AccountingCode', id: number } };

export type Fees_SaveDiscountMutationVariables = Exact<{
  input?: InputMaybe<SaveDiscountInput>;
}>;


export type Fees_SaveDiscountMutation = { __typename?: 'Mutation', fees_saveDiscount: { __typename?: 'Discount', id: number } };

export type Fees_SaveCategoryMutationVariables = Exact<{
  input?: InputMaybe<SaveCategoryInput>;
}>;


export type Fees_SaveCategoryMutation = { __typename?: 'Mutation', fees_saveCategory: { __typename?: 'Category', id: number } };

export type Fees_SaveFeeMutationVariables = Exact<{
  input?: InputMaybe<SaveFeeInput>;
}>;


export type Fees_SaveFeeMutation = { __typename?: 'Mutation', fees_saveFee: { __typename?: 'Fee', id?: number | null } };

export type Fees_SavedCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type Fees_SavedCardsQuery = { __typename?: 'Query', fees_savedCards: Array<{ __typename?: 'SavedCard', id: string, last4: string, brand: string, expiry: string }> };

export type Fees_ScheduledPaymentsQueryVariables = Exact<{
  filter?: InputMaybe<FeeFilter>;
}>;


export type Fees_ScheduledPaymentsQuery = { __typename?: 'Query', fees_fees: Array<{ __typename?: 'Fee', paymentPlanInterval?: PaymentPlanInterval | null, paymentPlanIntervalCount?: number | null, debtors?: Array<{ __typename?: 'Debtor', id: number, feeId: number, amount: number, amountPaid: number, amountDue: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup: { __typename?: 'GeneralGroup', name: string }, installments?: Array<{ __typename?: 'DebtorInstallment', installment: number, installmentDate: string, installmentStatus?: InstallmentStatus | null, amount: number, serviceCharges: number, absorbFees: boolean, cardUsed: string }> | null }> | null }> };

export type Fees_ServiceChargesQueryVariables = Exact<{
  filter?: InputMaybe<ChargesFilter>;
}>;


export type Fees_ServiceChargesQuery = { __typename?: 'Query', fees_serviceCharges: { __typename?: 'ServiceCharge', amount: number, userServiceCharge: number, userVat: number } };

export type Fees_CreateSetupIntentMutationVariables = Exact<{
  input?: InputMaybe<OnBehalfOfInput>;
}>;


export type Fees_CreateSetupIntentMutation = { __typename?: 'Mutation', fees_createSetupIntent: { __typename?: 'CreatePaymentResponse', clientSecret?: string | null } };

export type SimulateBankTransferMutationVariables = Exact<{
  input?: InputMaybe<SimulateBankTransferInput>;
}>;


export type SimulateBankTransferMutation = { __typename?: 'Mutation', fees_simulateBankTransfer: { __typename?: 'Success', success?: boolean | null } };

export type Fees_StripeAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type Fees_StripeAccountQuery = { __typename?: 'Query', fees_stripeAccount: { __typename?: 'StripeAccount', signUpStarted: boolean, onboardingComplete: boolean, onboardingLink?: string | null } };

export type Fees_StudentFeesQueryVariables = Exact<{
  filter?: InputMaybe<StudentFeeFilter>;
}>;


export type Fees_StudentFeesQuery = { __typename?: 'Query', fees_studentFees: Array<{ __typename?: 'StudentFee', feeName: string, description?: string | null, dueDate: string, amount: number, amountPaid: number, amountDue: number, feeType: FeeType, feeStatus: FeeStatus, amountDiscounted: number, adHocAmount?: number | null, amountWrittenOff: number, writeOffNote?: string | null, allowPartialPayments: boolean, paymentPlan: boolean, paymentPlanInterval?: PaymentPlanInterval | null, paymentPlanIntervalCount?: number | null, id: { __typename?: 'FeeIdStudent', feeId: number, studentPartyId: number }, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, discounts: Array<{ __typename?: 'Discount', id: number, name: string, description?: string | null, discountType: DiscountType, value: number, siblingDiscount?: boolean | null }>, classGroup: { __typename?: 'GeneralGroup', name: string }, paymentPlans?: Array<{ __typename?: 'PaymentPlan', id: number, absorbFees: boolean, status: PaymentPlanStatus, cardUsed: string, payee: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, installments: Array<{ __typename?: 'PaymentPlanInstallment', installment: number, installmentDate: string, status: InstallmentStatus, amount: number, serviceCharges: number }> }> | null }> };

export type Fees_ExcludeFromFeeMutationVariables = Exact<{
  input: FeeExclusionInput;
}>;


export type Fees_ExcludeFromFeeMutation = { __typename?: 'Mutation', fees_excludeFromFee: { __typename?: 'FeeExclusion', validations: Array<string>, success: { __typename?: 'Success', success?: boolean | null } } };

export type Fees_UpdatePaymentPlanCardMutationVariables = Exact<{
  input?: InputMaybe<UpdateSubscriptionCardInput>;
}>;


export type Fees_UpdatePaymentPlanCardMutation = { __typename?: 'Mutation', fees_updatePaymentPlanCard: { __typename?: 'Success', success?: boolean | null } };

export type Fees_WriteOffStudentsFeeMutationVariables = Exact<{
  input?: InputMaybe<Array<WriteOffInput> | WriteOffInput>;
}>;


export type Fees_WriteOffStudentsFeeMutation = { __typename?: 'Mutation', fees_writeOffStudentsFee: { __typename?: 'Success', success?: boolean | null } };

export type Forms_ChartQueryVariables = Exact<{
  filter: Dtab_ChartTableFilter;
}>;


export type Forms_ChartQuery = { __typename?: 'Query', forms_charts: Array<{ __typename?: 'Charts_Chart', title: string, type: Charts_ChartType, labels: Array<string>, categories: Array<string>, datasets: Array<{ __typename?: 'Charts_Dataset', label: string, meta?: any | null, data: Array<{ __typename?: 'Charts_Datapoint', value: number, label?: string | null }> }> }> };

export type FormsAdmin_DeleteFormDefinitionMutationVariables = Exact<{
  input: FormsAdmin_FormDefinitionsFilter;
}>;


export type FormsAdmin_DeleteFormDefinitionMutation = { __typename?: 'Mutation', formsAdmin_deleteFormDefinition?: { __typename?: 'Success', success?: boolean | null } | null };

export type Forms_DeleteFormSubmissionMutationVariables = Exact<{
  input: Forms_FormIdInput;
}>;


export type Forms_DeleteFormSubmissionMutation = { __typename?: 'Mutation', forms_deleteFormSubmission: { __typename?: 'Success', success?: boolean | null } };

export type FormsAdmin_DisableFormDefinitionsMutationVariables = Exact<{
  input: FormsFd_DisableFormDefinition;
}>;


export type FormsAdmin_DisableFormDefinitionsMutation = { __typename?: 'Mutation', formsAdmin_disableFormDefinitions: Array<{ __typename?: 'FormsFd_DefinitionId', id?: number | null, provider: string } | null> };

export type FormsAdmin_ExtensionPointsQueryVariables = Exact<{
  filter?: InputMaybe<Dtab_ExtensionPointAdminFilter>;
}>;


export type FormsAdmin_ExtensionPointsQuery = { __typename?: 'Query', formsAdmin_extensionPoints: Array<{ __typename?: 'Dtab_ExtensionPointConfig', extensionPointId: number, area: Dtab_ExtensionArea, type: Dtab_ExtensionAreaType, isSystemDefined: boolean, canView?: boolean | null, canWrite?: boolean | null, canEditTableDefinition?: boolean | null, disabled?: boolean | null, table: { __typename?: 'Dtab_Table', name: string, columns: Array<{ __typename?: 'FormsFd_FormDefinitionField', label: string, type: Form_FormFieldItemType, id: { __typename?: 'FormsFd_FormDefinitionFieldId', formId: number, fieldId: string } }> }, tenantConfigs?: Array<{ __typename?: 'Dtab_TenantExtensionPointConfig', extensionPointId: number, tenant: number, canView: boolean, canWrite: boolean, canEditTableDefinition: boolean, disabled: boolean }> | null }> };

export type FormsAdmin_DeleteExtensionPointMutationVariables = Exact<{
  input: Dtab_DeleteExtensionPointInput;
}>;


export type FormsAdmin_DeleteExtensionPointMutation = { __typename?: 'Mutation', formsAdmin_deleteExtensionPoint?: { __typename?: 'Success', success?: boolean | null } | null };

export type FormsAdmin_RegisterExtensionPointMutationVariables = Exact<{
  input: Dtab_RegisterExtensionPointInput;
}>;


export type FormsAdmin_RegisterExtensionPointMutation = { __typename?: 'Mutation', formsAdmin_registerExtensionPoint: { __typename?: 'Dtab_TenantExtensionPointConfig', extensionPointId: number, tenant: number, canView: boolean, canWrite: boolean, disabled: boolean } };

export type FormsAdmin_UnregisterExtensionPointMutationVariables = Exact<{
  input: Dtab_UnregisterExtensionPointInput;
}>;


export type FormsAdmin_UnregisterExtensionPointMutation = { __typename?: 'Mutation', formsAdmin_unregisterExtensionPoint?: { __typename?: 'Success', success?: boolean | null } | null };

export type FormsAdmin_InformationRequestQueryVariables = Exact<{
  filter?: InputMaybe<FormsAdmin_InformationRequestFilter>;
}>;


export type FormsAdmin_InformationRequestQuery = { __typename?: 'Query', formsAdmin_informationRequest: Array<{ __typename?: 'FormsAdmin_InformationRequestDefinition', name: string, description?: string | null, informationRequestType: Forms_InformationRequestResponderType, dueDate?: string | null, publishDate?: string | null, currentlyVisibleForResponders: boolean, metaConfigType?: FormAdmin_InformationRequestConfigMetaType | null, id: { __typename?: 'FormsAdmin_InformationRequestDefinitionId', id?: number | null, provider?: string | null }, formId: { __typename?: 'FormsFd_DefinitionId', id?: number | null, provider: string }, requestAboutParties?: Array<{ __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null }> | null, stats: { __typename?: 'Forms_InformationRequestDefinitionStats', responseExpected: number, responseCount: number, responseCompleteCount: number, responseConfirmationCount: number, responseRejectedCount: number }, tags: Array<{ __typename?: 'Dtab_Tag', id: number, name: string, systemTag: boolean }>, links: Array<{ __typename?: 'DyRel_Entity', id: string, type: DyRel_EntityType }>, metaConfig?: { __typename?: 'Timetable_OnCallAssignerOptions', type: FormAdmin_InformationRequestConfigMetaType, timetableId: number, periodsToChooseFrom: number, minPeriodsToBeSelected: number, dueDate: string, publishDate: string, excludeTeachers?: Array<number> | null } | null }> };

export type FormsAdmin_FormDefinitionsQueryVariables = Exact<{
  filter?: InputMaybe<FormsAdmin_FormDefinitionsFilter>;
}>;


export type FormsAdmin_FormDefinitionsQuery = { __typename?: 'Query', formsAdmin_formDefinitions: Array<{ __typename?: 'FormsFd_FormDefinition', title: string, description?: string | null, isReusableTemplate?: boolean | null, allowPartialCompletion: boolean, disabled?: boolean | null, tenantCanEdit: boolean, usageCount: number, id: { __typename?: 'FormsFd_DefinitionId', id?: number | null, provider: string }, tags: Array<{ __typename?: 'Dtab_Tag', id: number, name: string }>, fields: Array<{ __typename?: 'FormsFd_FormDefinitionFieldGroup', id?: number | null, header?: string | null, sortOrder?: number | null, fields: Array<{ __typename?: 'FormsFd_FormDefinitionField', sortOrder?: number | null, label: string, type: Form_FormFieldItemType, defaultValue?: string | null, required: boolean, isMandatoryOnFormDefinition?: boolean | null, id: { __typename?: 'FormsFd_FormDefinitionFieldId', formId: number, fieldId: string }, selectInfo?: { __typename?: 'FormsFd_FormDefinitionFieldSelect', options?: Array<{ __typename?: 'FormsFd_FormDefinitionFieldSelectOptions', id?: string | null, value: string }> | null } | null }> }> }> };

export type FormsAdmin_FormDefinitionsForSelectQueryVariables = Exact<{
  filter?: InputMaybe<FormsAdmin_FormDefinitionsFilter>;
}>;


export type FormsAdmin_FormDefinitionsForSelectQuery = { __typename?: 'Query', formsAdmin_formDefinitions: Array<{ __typename?: 'FormsFd_FormDefinition', title: string, description?: string | null, id: { __typename?: 'FormsFd_DefinitionId', id?: number | null, provider: string }, tags: Array<{ __typename?: 'Dtab_Tag', id: number, name: string }> }> };

export type FormsAdmin_InformationRequestTableViewQueryVariables = Exact<{
  filter: FormsAdmin_InformationRequestTableFilter;
}>;


export type FormsAdmin_InformationRequestTableViewQuery = { __typename?: 'Query', formsAdmin_informationRequestTableView?: { __typename?: 'Forms_InformationRequestResponseTable', id: { __typename?: 'FormsAdmin_InformationRequestDefinitionId', id?: number | null, provider?: string | null }, informationRequest: { __typename?: 'FormsAdmin_InformationRequestDefinition', name: string, informationRequestType: Forms_InformationRequestResponderType, isConfirmable: boolean }, headers: Array<{ __typename?: 'Forms_InformationRequestResponseTableHeader', id: string, label: string, type: Form_FormFieldItemType }>, rows: Array<{ __typename?: 'Forms_InformationRequestResponseTableRow', completionStatus: RequestStatus, confirmationStatus: Forms_ConfirmationStatus, aboutParty: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, responderParty?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null, columns: Array<{ __typename?: 'Forms_InformationRequestResponseTableColumn', id?: string | null, value?: string | null }> }>, form: { __typename?: 'FormsFd_FormDefinition', fields: Array<{ __typename?: 'FormsFd_FormDefinitionFieldGroup', id?: number | null, fields: Array<{ __typename?: 'FormsFd_FormDefinitionField', id: { __typename?: 'FormsFd_FormDefinitionFieldId', formId: number, fieldId: string }, selectInfo?: { __typename?: 'FormsFd_FormDefinitionFieldSelect', options?: Array<{ __typename?: 'FormsFd_FormDefinitionFieldSelectOptions', id?: string | null, value: string }> | null } | null }> }> } } | null };

export type FormsAdmin_BlankFormQueryVariables = Exact<{
  filter?: InputMaybe<FormsAdmin_FormDefinitionViewFilter>;
}>;


export type FormsAdmin_BlankFormQuery = { __typename?: 'Query', formsAdmin_blankForm: { __typename?: 'Forms_FormView', title?: string | null, description?: string | null, status: RequestStatus, allowPartialCompletion: boolean, readOnly: boolean, id: { __typename?: 'Forms_FormId', provider: string, forPartyId?: string | null, objectId?: number | null }, gridWidth: { __typename?: 'Forms_FormFieldGridWidth', xs?: number | null, sm?: number | null, md?: number | null, lg?: number | null, xl?: number | null }, fields: Array<{ __typename?: 'Forms_FormFieldGroup', header: string, fields: Array<{ __typename: 'Forms_FormFieldItem', formFieldType: Forms_FormFieldType, id: string, fieldGroupIdx: number, label: string, type: Form_FormFieldItemType, required?: boolean | null, defaultValue?: string | null, options: Array<{ __typename?: 'Forms_FormFieldSelectOptions', id: string, name: string }>, gridWidth: { __typename?: 'Forms_FormFieldGridWidth', xs?: number | null, sm?: number | null, md?: number | null, lg?: number | null, xl?: number | null } } | { __typename: 'Forms_FormFieldSubGroup', formFieldType: Forms_FormFieldType, header: string, fields: Array<{ __typename?: 'Forms_FormFieldItem', formFieldType: Forms_FormFieldType, id: string, fieldGroupIdx: number, label: string, type: Form_FormFieldItemType, required?: boolean | null, options: Array<{ __typename?: 'Forms_FormFieldSelectOptions', id: string, name: string }>, gridWidth: { __typename?: 'Forms_FormFieldGridWidth', xs?: number | null, sm?: number | null, md?: number | null, lg?: number | null, xl?: number | null } }>, gridWidth: { __typename?: 'Forms_FormFieldGridWidth', xs?: number | null, sm?: number | null, md?: number | null, lg?: number | null, xl?: number | null } }> }> } };

export type Forms_SearchFormsSubmissionsQueryVariables = Exact<{
  filter: Forms_SearchSubmissionFilter;
}>;


export type Forms_SearchFormsSubmissionsQuery = { __typename?: 'Query', forms_searchFormsSubmissions: Array<{ __typename?: 'Form_FormResponseInfo', title: string, description?: string | null, type: FormType, updatedOn: string, id: { __typename?: 'Forms_FormId', provider: string, forPartyId?: string | null, objectId?: number | null }, singleSubmissionInfo?: { __typename?: 'Form_FormResponseSingleSubmissionInfo', status: RequestStatus, confirmationStatus: Forms_ConfirmationStatus, submissionCount: number } | null, infoRequestInfo?: { __typename?: 'Form_FormResponseInfoRequestInfo', responseExpected: number, responseCount: number, responseCompleteCount: number, responseConfirmationCount: number, responseRejectedCount: number, dueDate?: string | null, publishDate?: string | null, isConfirmable: boolean, currentlyVisibleForResponders: boolean, metaConfigType?: FormAdmin_InformationRequestConfigMetaType | null, id: { __typename?: 'FormsAdmin_InformationRequestDefinitionId', id?: number | null, provider?: string | null }, metaConfig?: { __typename?: 'Timetable_OnCallAssignerOptions', type: FormAdmin_InformationRequestConfigMetaType, timetableId: number, periodsToChooseFrom: number, minPeriodsToBeSelected: number, dueDate: string, publishDate: string, excludeTeachers?: Array<number> | null } | null } | null, links: Array<{ __typename?: 'DyRel_Entity', id: string, type: DyRel_EntityType }>, tags?: Array<{ __typename?: 'Dtab_Tag', id: number, name: string, type?: Dtab_TagType | null, systemTag: boolean }> | null, updatedBy: { __typename?: 'AuditPerson', person?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null } }> };

export type Forms_TableQueryVariables = Exact<{
  filter: Dtab_TableFilter;
}>;


export type Forms_TableQuery = { __typename?: 'Query', forms_table: { __typename?: 'Dtab_Table', name: string, id: { __typename?: 'FormsFd_DefinitionId', id?: number | null, provider: string }, columns: Array<{ __typename?: 'FormsFd_FormDefinitionField', sortOrder?: number | null, label: string, type: Form_FormFieldItemType, defaultValue?: string | null, required: boolean, isMandatoryOnFormDefinition?: boolean | null, groupId: number, id: { __typename?: 'FormsFd_FormDefinitionFieldId', formId: number, fieldId: string }, selectInfo?: { __typename?: 'FormsFd_FormDefinitionFieldSelect', options?: Array<{ __typename?: 'FormsFd_FormDefinitionFieldSelectOptions', id?: string | null, value: string }> | null } | null }>, columnGroups: Array<{ __typename?: 'Dtab_ColumnGroup', id?: number | null, header?: string | null, sortOrder?: number | null }>, rows: Array<{ __typename?: 'Dtab_Row', completionStatus: RequestStatus, confirmationStatus: Forms_ConfirmationStatus, rowId: { __typename?: 'Dtab_RowId', rowId: string, tableId: number }, header: { __typename: 'Dtab_RowHeader_FormInfoRequest', type: Dtab_RowHeaderType, rowId: { __typename?: 'Dtab_RowId', rowId: string, tableId: number }, aboutParty: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, responderParty?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null } | { __typename: 'Dtab_RowHeader_FormSubmission', type: Dtab_RowHeaderType, entityType: DyRel_EntityType, id: string, entityPartyId?: number | null, createdOn?: string | null, rowId: { __typename?: 'Dtab_RowId', rowId: string, tableId: number }, entity?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null, createdBy?: { __typename?: 'AuditPerson', person?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null } | null, lastUpdatedBy?: { __typename?: 'AuditPerson', person?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null } | null, headerFields: Array<{ __typename?: 'Dtab_RowHeader_FormSubmissionItem', label: string, type: Form_FormFieldItemType, value?: string | null, sortOrder?: number | null }> }, cells: Array<{ __typename?: 'Dtab_CellValue', id: string, columnId: string, value?: string | null, version: number, isLatest: boolean, rowId: string }> }>, displayOptions?: { __typename?: 'Dtab_TableDisplayOptions', displayCompletedOnRow: boolean, displayConfirmedOnRow: boolean } | null, validationRules: { __typename?: 'Dtab_TableValidationRules', allowedDyRelEntityTypes: Array<DyRel_EntityType> }, pbac: { __typename?: 'Pbac_ResourceResult', isSecured: boolean } } };

export type FormsAdmin_TagsQueryVariables = Exact<{
  filter?: InputMaybe<FormsAdminTagsFilter>;
}>;


export type FormsAdmin_TagsQuery = { __typename?: 'Query', formsAdmin_tags: Array<{ __typename?: 'Dtab_Tag', id: number, name: string, disabled: boolean, tenantCanEdit: boolean, systemTag: boolean, type?: Dtab_TagType | null, pbac: { __typename?: 'Pbac_ResourceResult', isSecured: boolean } }> };

export type FormsAdmin_UpsertFormDefinitionsMutationVariables = Exact<{
  input: FormsFd_UpsertFormDefinition;
}>;


export type FormsAdmin_UpsertFormDefinitionsMutation = { __typename?: 'Mutation', formsAdmin_upsertFormDefinitions: { __typename?: 'FormsFd_FormDefinition', id: { __typename?: 'FormsFd_DefinitionId', provider: string } } };

export type FormsAdmin_UpsertInformationRequestMutationVariables = Exact<{
  input: FormsAdmin_UpsertInformationRequest;
}>;


export type FormsAdmin_UpsertInformationRequestMutation = { __typename?: 'Mutation', formsAdmin_upsertInformationRequest: { __typename?: 'FormsAdmin_InformationRequestDefinition', id: { __typename?: 'FormsAdmin_InformationRequestDefinitionId', id?: number | null, provider?: string | null } } };

export type FormsAdmin_UpsertInformationRequestUsingMetaConfigMutationVariables = Exact<{
  input: FormsAdmin_UpsertInformationRequestUsingMetaConfigObj;
}>;


export type FormsAdmin_UpsertInformationRequestUsingMetaConfigMutation = { __typename?: 'Mutation', formsAdmin_upsertInformationRequestUsingMetaConfig: { __typename?: 'FormsAdmin_InformationRequestDefinitionId', id?: number | null, provider?: string | null } };

export type Forms_UpsertRowsMutationVariables = Exact<{
  input: Forms_SubmitFormFieldInputs;
}>;


export type Forms_UpsertRowsMutation = { __typename?: 'Mutation', forms_upsertRows: { __typename?: 'Forms_UpsertRowsResponse', success: Forms_UpsertRowsSuccess, rowDetails: Array<{ __typename?: 'Forms_UpsertRowResponse', success: boolean, topLevelErrors: Array<string>, rowIdentifier: { __typename?: 'Forms_UpsertRowsId', rowId?: string | null, rowIndex: number } }> } };

export type FormsAdmin_UpsertTagsMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<Dtab_UpsertTag>> | InputMaybe<Dtab_UpsertTag>>;
}>;


export type FormsAdmin_UpsertTagsMutation = { __typename?: 'Mutation', formsAdmin_upsertTags: Array<{ __typename?: 'Dtab_Tag', id: number, name: string }> };

export type Forms_ViewSubmissionQueryVariables = Exact<{
  filter: Forms_ViewSubmissionFilter;
}>;


export type Forms_ViewSubmissionQuery = { __typename?: 'Query', forms_viewSubmission?: { __typename?: 'Forms_FormView', title?: string | null, description?: string | null, status: RequestStatus, allowPartialCompletion: boolean, readOnly: boolean, id: { __typename?: 'Forms_FormId', provider: string, forPartyId?: string | null, objectId?: number | null }, gridWidth: { __typename?: 'Forms_FormFieldGridWidth', xs?: number | null, sm?: number | null, md?: number | null, lg?: number | null, xl?: number | null }, fields: Array<{ __typename?: 'Forms_FormFieldGroup', header: string, fields: Array<{ __typename: 'Forms_FormFieldItem', formFieldType: Forms_FormFieldType, id: string, fieldGroupIdx: number, label: string, type: Form_FormFieldItemType, required?: boolean | null, defaultValue?: string | null, options: Array<{ __typename?: 'Forms_FormFieldSelectOptions', id: string, name: string }>, gridWidth: { __typename?: 'Forms_FormFieldGridWidth', xs?: number | null, sm?: number | null, md?: number | null, lg?: number | null, xl?: number | null } } | { __typename: 'Forms_FormFieldSubGroup', formFieldType: Forms_FormFieldType, header: string, fields: Array<{ __typename?: 'Forms_FormFieldItem', formFieldType: Forms_FormFieldType, id: string, fieldGroupIdx: number, label: string, type: Form_FormFieldItemType, required?: boolean | null, options: Array<{ __typename?: 'Forms_FormFieldSelectOptions', id: string, name: string }>, gridWidth: { __typename?: 'Forms_FormFieldGridWidth', xs?: number | null, sm?: number | null, md?: number | null, lg?: number | null, xl?: number | null } }>, gridWidth: { __typename?: 'Forms_FormFieldGridWidth', xs?: number | null, sm?: number | null, md?: number | null, lg?: number | null, xl?: number | null } }> }> } | null };

export type Tt_LiveTimetableClassGroupsQueryVariables = Exact<{
  filter: Tt_LiveTimetableClassGroupsFilter;
}>;


export type Tt_LiveTimetableClassGroupsQuery = { __typename?: 'Query', tt_liveTimetableClassGroups: Array<{ __typename?: 'TT_ClassGroup', ttClassGroupId: number, partyId?: number | null, name: string }> };

export type Tt_AttachClassGroupsToTimetableMutationVariables = Exact<{
  input: Tt_AttachClassGroupsToTimetableInput;
}>;


export type Tt_AttachClassGroupsToTimetableMutation = { __typename?: 'Mutation', tt_attachClassGroupsToTimetable: { __typename?: 'TT_AttachClassGroupsResult', results: Array<{ __typename?: 'TT_AttachClassGroupResult', classGroupPartyId: number, ttClassGroupId: number, status: Tt_AttachClassGroupStatus, message?: string | null }> } };

export type Core_BlocksListQueryVariables = Exact<{
  filter?: InputMaybe<BlockFilter>;
}>;


export type Core_BlocksListQuery = { __typename?: 'Query', core_blocks: Array<{ __typename?: 'CoreBlock', blockId: string, name: string, description?: string | null, subjectGroupNamesJoined?: string | null, subjectGroupIds: Array<number>, isRotation: boolean }> };

export type ClassGroupsListQueryVariables = Exact<{
  filter: GeneralGroupFilter;
}>;


export type ClassGroupsListQuery = { __typename?: 'Query', generalGroups?: Array<{ __typename?: 'GeneralGroup', partyId: number, source?: Core_PartySource | null, name: string, code?: string | null, avatarUrl?: string | null, generalGroupType: GeneralGroupType, studentMembers?: { __typename?: 'Group', memberCount: number } | null, programmeStages: Array<{ __typename?: 'ProgrammeStage', programme?: { __typename?: 'Programme', name: string } | null }>, tutors: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }>, students: Array<{ __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }>, yearGroupLeads: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }>, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', yearGroupId: number, name: string }> }> | null };

export type ClassGroupsByIdQueryVariables = Exact<{
  filter: GeneralGroupFilter;
}>;


export type ClassGroupsByIdQuery = { __typename?: 'Query', generalGroups?: Array<{ __typename?: 'GeneralGroup', partyId: number, name: string, students: Array<{ __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', nameTextId: number, id: number, name: string } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null }>, relatedSubjectGroups: Array<{ __typename?: 'SubjectGroup', name: string, partyId: number, avatarUrl?: string | null, studentMembershipType?: { __typename?: 'SubjectGroupStudentMembershipType', type: SubjectGroupStudentMembershipTypeEnum } | null, subjects: Array<{ __typename?: 'Subject', name: string, colour?: Colour | null, icon?: string | null }>, programmeStages: Array<{ __typename?: 'ProgrammeStage', name: string }>, staff: Array<{ __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null }>, irePP?: { __typename?: 'SubjectGroupIrePP', level?: StudyLevel | null } | null, studentMembers?: { __typename?: 'Group', memberCount: number } | null }>, blocks: Array<{ __typename?: 'CoreBlock', blockId: string, name: string }> }> | null };

export type Core_UpdateClassGroupsMutationVariables = Exact<{
  input?: InputMaybe<Array<UpdateClassGroupGroupInput> | UpdateClassGroupGroupInput>;
}>;


export type Core_UpdateClassGroupsMutation = { __typename?: 'Mutation', core_updateClassGroups?: { __typename?: 'Success', success?: boolean | null } | null };

export type Groups_UpsertCoreMembershipsMutationVariables = Exact<{
  input: EnrollmentIre_UpsertCoreMembership;
}>;


export type Groups_UpsertCoreMembershipsMutation = { __typename?: 'Mutation', enrollment_ire_upsertCoreMemberships: { __typename?: 'EnrollmentIre_CoreMemberships', yearGroupEnrollment?: { __typename?: 'YearGroupEnrollment', yearGroupId: number } | null } };

export type Groups_ChangeProgrammeStageMutationVariables = Exact<{
  input: EnrollmentIre_ChangeProgrammeStages;
}>;


export type Groups_ChangeProgrammeStageMutation = { __typename?: 'Mutation', enrollment_ire_changeProgrammeStage: { __typename?: 'Success', success?: boolean | null } };

export type Catalogue_GroupTagsQueryVariables = Exact<{
  filter: Catalogue_GroupTagFilter;
}>;


export type Catalogue_GroupTagsQuery = { __typename?: 'Query', catalogue_groupTags: Array<{ __typename?: 'GroupTag', id: number, type?: GroupTagType | null, uniqueName?: string | null, systemTag: boolean, name: string, description?: string | null, colour: Colour, refId?: string | null }> };

export type Catalogue_UpsertGroupTagMutationVariables = Exact<{
  input: Array<Catalogue_UpsertGroupTag> | Catalogue_UpsertGroupTag;
}>;


export type Catalogue_UpsertGroupTagMutation = { __typename?: 'Mutation', catalogue_upsertGroupTag?: { __typename?: 'CatalogueSuccess', success: boolean, message?: string | null } | null };

export type Catalogue_DeleteGroupTagMutationVariables = Exact<{
  input: Catalogue_DeleteGroupTag;
}>;


export type Catalogue_DeleteGroupTagMutation = { __typename?: 'Mutation', catalogue_deleteGroupTag?: { __typename?: 'CatalogueSuccess', success: boolean, message?: string | null } | null };

export type Core_CopyGroupsMutationVariables = Exact<{
  input: Array<InputMaybe<Core_CopyGroups>> | InputMaybe<Core_CopyGroups>;
}>;


export type Core_CopyGroupsMutation = { __typename?: 'Mutation', core_copyGroups: { __typename?: 'Success', success?: boolean | null } };

export type Core_CustomGroupDefinitionQueryVariables = Exact<{
  filter: Core_CustomGroupDefinitionFilter;
}>;


export type Core_CustomGroupDefinitionQuery = { __typename?: 'Query', core_customGroupDefinition: { __typename?: 'Core_CustomGroupDefinition', id?: number | null, name: string, organisers?: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }> | null, staffStatic?: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }> | null, studentsStatic?: Array<{ __typename?: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup?: { __typename?: 'GeneralGroup', partyId: number, name: string } | null, programmeStages?: Array<{ __typename?: 'ProgrammeStage', id: number, name: string }> | null, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null }> | null } };

export type SaveCustomGroupDefinitionMutationVariables = Exact<{
  input: Core_UpsertCustomGroupDefinition;
}>;


export type SaveCustomGroupDefinitionMutation = { __typename?: 'Mutation', core_upsertCustomGroupDefinition: { __typename?: 'Success', success?: boolean | null } };

export type CustomGroupsListQueryVariables = Exact<{
  filter: GeneralGroupFilter;
}>;


export type CustomGroupsListQuery = { __typename?: 'Query', generalGroups?: Array<{ __typename?: 'GeneralGroup', partyId: number, name: string, avatarUrl?: string | null, studentMembers?: { __typename?: 'Group', memberCount: number } | null, staffMembers?: { __typename?: 'Group', memberCount: number, members: Array<{ __typename?: 'GroupMembership', partyId: number, roles?: Array<string | null> | null }> } | null, contactMembers?: { __typename?: 'Group', memberCount: number } | null }> | null };

export type CustomGroupByIdQueryVariables = Exact<{
  filter: GeneralGroupFilter;
}>;


export type CustomGroupByIdQuery = { __typename?: 'Query', generalGroups?: Array<{ __typename?: 'GeneralGroup', partyId: number, name: string, avatarUrl?: string | null, students: Array<{ __typename?: 'Student', partyId: number, classGroup?: { __typename?: 'GeneralGroup', name: string } | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null }> }> | null };

export type Core_DeleteGroupsMutationVariables = Exact<{
  input: Core_DeleteGroupInput;
}>;


export type Core_DeleteGroupsMutation = { __typename?: 'Mutation', core_deleteGroups: { __typename?: 'Success', success?: boolean | null } };

export type GroupSearchQueryQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
}>;


export type GroupSearchQueryQuery = { __typename?: 'Query', search_search: Array<{ __typename?: 'Search', partyId: number, type: SearchType, text: string, avatarUrl?: string | null }> };

export type Core_ModifyBlocksMutationVariables = Exact<{
  input: Core_ModifyBlocks;
}>;


export type Core_ModifyBlocksMutation = { __typename?: 'Mutation', core_modifyBlocks: { __typename?: 'Success', success?: boolean | null } };

export type Core_ModifyGroupMembershipsMutationVariables = Exact<{
  input: Core_ModifyMemberships;
}>;


export type Core_ModifyGroupMembershipsMutation = { __typename?: 'Mutation', core_modifyGroupMemberships: { __typename?: 'Success', success?: boolean | null } };

export type CoreModifySubjectGroupMembershipTypeMutationVariables = Exact<{
  input: Array<InputMaybe<Core_ModifySubjectGroupMembershipType>> | InputMaybe<Core_ModifySubjectGroupMembershipType>;
}>;


export type CoreModifySubjectGroupMembershipTypeMutation = { __typename?: 'Mutation', core_modifySubjectGroupMembershipType: { __typename?: 'Success', success?: boolean | null } };

export type PrintGroupMembersQueryVariables = Exact<{
  filter: Print_GroupMembers;
}>;


export type PrintGroupMembersQuery = { __typename?: 'Query', print_groupMembers: { __typename?: 'TemporaryDownload', url?: string | null, html?: string | null } };

export type ProgrammeStagesQueryVariables = Exact<{
  filter?: InputMaybe<ProgrammeStageEnrollmentFilter>;
}>;


export type ProgrammeStagesQuery = { __typename?: 'Query', core_programmeStageEnrollments: Array<{ __typename?: 'ProgrammeStageEnrollment', avatarUrl?: string | null, name: string, partyId: number, programmeStageEnrollmentPartyId: number, programmeStageId: number, programmeStageLeads: Array<{ __typename?: 'Person', type?: PartyPersonType | null, partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null }>, programmeStage?: { __typename?: 'ProgrammeStage', yearGroupId: number, name: string, description?: string | null, shortName?: string | null } | null, studentMembers?: { __typename?: 'Group', memberCount: number } | null, students: Array<{ __typename?: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup?: { __typename?: 'GeneralGroup', partyId: number, name: string } | null, tutors: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }>, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null, yearGroupLeads: Array<{ __typename?: 'Person', avatarUrl?: string | null, type?: PartyPersonType | null, partyId: number, firstName?: string | null, lastName?: string | null }>, programmeStages?: Array<{ __typename?: 'ProgrammeStage', id: number, programmeId: number, name: string }> | null }> }> };

export type Core_UpdateProgrammeStageEnrollmentsMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<UpdateProgrammeStageEnrollmentInput>> | InputMaybe<UpdateProgrammeStageEnrollmentInput>>;
}>;


export type Core_UpdateProgrammeStageEnrollmentsMutation = { __typename?: 'Mutation', core_updateProgrammeStageEnrollments?: { __typename?: 'Success', success?: boolean | null } | null };

export type StaffSearchQueryQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
}>;


export type StaffSearchQueryQuery = { __typename?: 'Query', search_search: Array<{ __typename?: 'Search', partyId: number, type: SearchType, text: string, avatarUrl?: string | null }> };

export type StudentsSearchQueryQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
}>;


export type StudentsSearchQueryQuery = { __typename?: 'Query', search_search: Array<{ __typename?: 'Search', partyId: number, type: SearchType, text: string, avatarUrl?: string | null }> };

export type Calendar_CalendarEventsIteratorQueryVariables = Exact<{
  filter: CalendarEventIteratorFilter;
}>;


export type Calendar_CalendarEventsIteratorQuery = { __typename?: 'Query', calendar_calendarEventsIterator_v2?: { __typename?: 'Calendar_EventIteratorResult', event?: { __typename?: 'CalendarEvent', eventId: number, name: string, colour?: Colour | null, calendarIds: Array<number | null>, startTime: string, endTime: string, type: CalendarEventType, attendees: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename?: 'GeneralGroup', partyId: number } | { __typename?: 'ProgrammeStageEnrollment', partyId: number } | { __typename?: 'Staff', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename?: 'Student', partyId: number } | { __typename?: 'StudentContact', partyId: number } | { __typename?: 'SubjectGroup', partyId: number } | { __typename?: 'YearGroupEnrollment', partyId: number } | null }>, rooms: Array<{ __typename?: 'Room', name: string }>, extensions?: { __typename?: 'CalendarEventExtension', eventAttendance?: Array<{ __typename?: 'EventAttendance', eventId: number, note?: string | null, attendanceCodeId: number, personPartyId: number, adminSubmitted: boolean, updatedAt?: string | null, groupAttendanceTaken?: string | null, attendanceCode: { __typename?: 'AttendanceCode', name: string, codeType: AttendanceCodeType }, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, updatedBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | null> | null, previousEventAttendance?: Array<{ __typename?: 'EventAttendance', personPartyId: number, attendanceCode: { __typename?: 'AttendanceCode', codeType: AttendanceCodeType } } | null> | null } | null } | null, eventsOnSameDayForSameGroup?: Array<{ __typename?: 'CalendarEvent', eventId: number, name: string, colour?: Colour | null, type: CalendarEventType, startTime: string, endTime: string, rooms: Array<{ __typename?: 'Room', name: string }>, tags: Array<{ __typename?: 'CalendarTag', label: string, context: Calendar_TagContext }> }> | null } | null };

export type SubjectGroupsQueryVariables = Exact<{
  filter: SubjectGroupFilter;
}>;


export type SubjectGroupsQuery = { __typename?: 'Query', subjectGroups?: Array<{ __typename?: 'SubjectGroup', partyId: number, source?: Core_PartySource | null, name: string, avatarUrl?: string | null, subjects: Array<{ __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null, icon?: string | null }>, studentMembers?: { __typename?: 'Group', memberCount: number } | null, staff: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }>, irePP?: { __typename?: 'SubjectGroupIrePP', level?: StudyLevel | null, examinable: boolean } | null, programmeStages: Array<{ __typename?: 'ProgrammeStage', programme?: { __typename?: 'Programme', name: string } | null }>, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', name: string }>, studentMembershipType?: { __typename?: 'SubjectGroupStudentMembershipType', type: SubjectGroupStudentMembershipTypeEnum, classGroupId?: number | null, blockId?: string | null, classGroupName?: string | null } | null }> | null };

export type SubjectGroupByIdQueryVariables = Exact<{
  filter: SubjectGroupFilter;
}>;


export type SubjectGroupByIdQuery = { __typename?: 'Query', subjectGroups?: Array<{ __typename?: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', name: string }>, subjects: Array<{ __typename?: 'Subject', name: string, colour?: Colour | null, icon?: string | null }>, studentMembershipType?: { __typename?: 'SubjectGroupStudentMembershipType', type: SubjectGroupStudentMembershipTypeEnum, classGroupId?: number | null, blockId?: string | null, classGroupName?: string | null } | null, staff: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }>, students: Array<{ __typename?: 'Student', partyId: number, classGroup?: { __typename?: 'GeneralGroup', name: string } | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null }> }> | null };

export type Core_UpdateSubjectGroupsMutationVariables = Exact<{
  input?: InputMaybe<Array<UpdateSubjectGroupInput> | UpdateSubjectGroupInput>;
}>;


export type Core_UpdateSubjectGroupsMutation = { __typename?: 'Mutation', core_updateSubjectGroups?: { __typename?: 'Success', success?: boolean | null } | null };

export type Core_SwitchSubjectGroupTypeMutationVariables = Exact<{
  input: Core_SwitchSubjectGroupType;
}>;


export type Core_SwitchSubjectGroupTypeMutation = { __typename?: 'Mutation', core_switchSubjectGroupType: { __typename?: 'Success', success?: boolean | null } };

export type Core_SubjectGroupStaffMembersQueryVariables = Exact<{
  filter: SubjectGroupStudentFilter;
}>;


export type Core_SubjectGroupStaffMembersQuery = { __typename?: 'Query', core_subjectGroupStudents: Array<{ __typename?: 'StudentSubjectGroup', subjectGroup?: { __typename?: 'SubjectGroup', staffMembers?: { __typename?: 'Group', members: Array<{ __typename?: 'GroupMembership', partyId: number, roles?: Array<string | null> | null, person?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null }> } | null } | null }> };

export type SupportGroupsQueryVariables = Exact<{
  filter: SubjectGroupFilter;
}>;


export type SupportGroupsQuery = { __typename?: 'Query', subjectGroups?: Array<{ __typename?: 'SubjectGroup', partyId: number, source?: Core_PartySource | null, name: string, avatarUrl?: string | null, subjects: Array<{ __typename?: 'Subject', name: string, colour?: Colour | null }>, studentMembers?: { __typename?: 'Group', memberCount: number } | null, staff: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }>, irePP?: { __typename?: 'SubjectGroupIrePP', level?: StudyLevel | null, examinable: boolean } | null, programmeStages: Array<{ __typename?: 'ProgrammeStage', programme?: { __typename?: 'Programme', name: string } | null }>, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', name: string }> }> | null };

export type SupportGroupByIdQueryVariables = Exact<{
  filter: SubjectGroupFilter;
}>;


export type SupportGroupByIdQuery = { __typename?: 'Query', subjectGroups?: Array<{ __typename?: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', name: string }>, subjects: Array<{ __typename?: 'Subject', name: string, colour?: Colour | null }>, staff: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }>, students: Array<{ __typename?: 'Student', partyId: number, classGroup?: { __typename?: 'GeneralGroup', name: string } | null, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }> | null };

export type YearGroupEnrollmentsListQueryVariables = Exact<{
  filter?: InputMaybe<YearGroupEnrollmentFilter>;
}>;


export type YearGroupEnrollmentsListQuery = { __typename?: 'Query', core_yearGroupEnrollments: Array<{ __typename?: 'YearGroupEnrollment', partyId: number, yearGroupEnrollmentPartyId: number, name: string, avatarUrl?: string | null, nationalCode: string, yearGroupId: number, shortName: string, description?: string | null, yearGroupLeads: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }>, studentMembers: { __typename?: 'Group', memberCount: number } }> };

export type YearGroupEnrollmentsDetailsQueryVariables = Exact<{
  filter?: InputMaybe<YearGroupEnrollmentFilter>;
}>;


export type YearGroupEnrollmentsDetailsQuery = { __typename?: 'Query', core_yearGroupEnrollments: Array<{ __typename?: 'YearGroupEnrollment', yearGroupEnrollmentPartyId: number, yearGroupId: number, name: string, avatarUrl?: string | null, students: Array<{ __typename?: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup?: { __typename?: 'GeneralGroup', partyId: number, name: string } | null, tutors: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }>, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null }>, studentMembers: { __typename?: 'Group', memberCount: number }, yearGroupLeads: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }> }> };

export type Core_UpdateYearGroupEnrollmentsMutationVariables = Exact<{
  input?: InputMaybe<Array<UpdateYearGroupEnrollmentInput> | UpdateYearGroupEnrollmentInput>;
}>;


export type Core_UpdateYearGroupEnrollmentsMutation = { __typename?: 'Mutation', core_updateYearGroupEnrollments?: { __typename?: 'Success', success?: boolean | null } | null };

export type Forms_ListInformationRequestFormsQueryVariables = Exact<{
  filter?: InputMaybe<Forms_InformationRequestListFormFilter>;
}>;


export type Forms_ListInformationRequestFormsQuery = { __typename?: 'Query', forms_listInformationRequestForms: Array<{ __typename?: 'Forms_FormListing', name: string, status: RequestStatus, completionDate?: string | null, dueDate?: string | null, id: { __typename?: 'Forms_FormId', provider: string, forPartyId?: string | null, objectId?: number | null }, forPerson: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null } }> };

export type Forms_ViewInformationRequestFormsQueryVariables = Exact<{
  filter?: InputMaybe<Forms_InformationRequestViewFormFilter>;
}>;


export type Forms_ViewInformationRequestFormsQuery = { __typename?: 'Query', forms_viewInformationRequestForms: { __typename?: 'Forms_FormView', title?: string | null, description?: string | null, status: RequestStatus, readOnly: boolean, allowPartialCompletion: boolean, id: { __typename?: 'Forms_FormId', provider: string, forPartyId?: string | null, objectId?: number | null }, gridWidth: { __typename?: 'Forms_FormFieldGridWidth', xs?: number | null, sm?: number | null, md?: number | null, lg?: number | null, xl?: number | null }, fields: Array<{ __typename?: 'Forms_FormFieldGroup', header: string, fields: Array<{ __typename: 'Forms_FormFieldItem', formFieldType: Forms_FormFieldType, id: string, fieldGroupIdx: number, label: string, type: Form_FormFieldItemType, required?: boolean | null, defaultValue?: string | null, options: Array<{ __typename?: 'Forms_FormFieldSelectOptions', id: string, name: string }>, gridWidth: { __typename?: 'Forms_FormFieldGridWidth', xs?: number | null, sm?: number | null, md?: number | null, lg?: number | null, xl?: number | null } } | { __typename: 'Forms_FormFieldSubGroup', formFieldType: Forms_FormFieldType, header: string, fields: Array<{ __typename?: 'Forms_FormFieldItem', formFieldType: Forms_FormFieldType, id: string, fieldGroupIdx: number, label: string, type: Form_FormFieldItemType, required?: boolean | null, options: Array<{ __typename?: 'Forms_FormFieldSelectOptions', id: string, name: string }>, gridWidth: { __typename?: 'Forms_FormFieldGridWidth', xs?: number | null, sm?: number | null, md?: number | null, lg?: number | null, xl?: number | null } }>, gridWidth: { __typename?: 'Forms_FormFieldGridWidth', xs?: number | null, sm?: number | null, md?: number | null, lg?: number | null, xl?: number | null } }> }> } };

export type Forms_SubmitInformationRequestFormsMutationVariables = Exact<{
  input: Forms_SubmitFormInput;
}>;


export type Forms_SubmitInformationRequestFormsMutation = { __typename?: 'Mutation', forms_submitInformationRequestForms: { __typename?: 'Forms_SubmitFormResponse', globalId: number, success: boolean, id: { __typename?: 'Forms_FormId', provider: string, forPartyId?: string | null, objectId?: number | null }, validations?: { __typename?: 'Forms_SubmitFormValidationError', fieldErrors?: any | null, globalErrors: Array<string> } | null } };

export type Communications_ArchiveMailMutationVariables = Exact<{
  input?: InputMaybe<ArchiveMailInput>;
}>;


export type Communications_ArchiveMailMutation = { __typename?: 'Mutation', communications_archiveMail: { __typename?: 'Success', success?: boolean | null } };

export type Communications_LabelQueryVariables = Exact<{
  filter?: InputMaybe<LabelFilter>;
}>;


export type Communications_LabelQuery = { __typename?: 'Query', communications_label: Array<{ __typename?: 'Label', id: number, name: string, personPartyId: number, colour?: Colour | null, custom?: boolean | null, type: LabelType }> };

export type Update_Communications_LabelMutationVariables = Exact<{
  input?: InputMaybe<LabelInput>;
}>;


export type Update_Communications_LabelMutation = { __typename?: 'Mutation', communications_saveLabel?: { __typename?: 'Label', id: number, name: string, personPartyId: number, colour?: Colour | null, custom?: boolean | null } | null };

export type Communications_UnreadCountQueryVariables = Exact<{
  filter?: InputMaybe<UnreadCountFilter>;
}>;


export type Communications_UnreadCountQuery = { __typename?: 'Query', communications_unreadCount: Array<{ __typename?: 'UnreadCount', personPartyId: number, labelId: number, labelType: LabelType, count: number }> };

export type Communications_AssignLabelMutationVariables = Exact<{
  input?: InputMaybe<AssignLabelInput>;
}>;


export type Communications_AssignLabelMutation = { __typename?: 'Mutation', communications_assignLabel?: { __typename?: 'Mail', id: number } | null };

export type Communications_RecipientsQueryVariables = Exact<{
  filter?: InputMaybe<RecipientFilter>;
}>;


export type Communications_RecipientsQuery = { __typename?: 'Query', communications_recipients: Array<{ __typename?: 'Search', partyId: number, type: SearchType, text: string, avatarUrl?: string | null }> };

export type MailSearchQueryQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
}>;


export type MailSearchQueryQuery = { __typename?: 'Query', search_search: Array<{ __typename?: 'Search', partyId: number, type: SearchType, text: string, avatarUrl?: string | null }> };

export type MailListQueryVariables = Exact<{
  filter?: InputMaybe<MailFilter>;
}>;


export type MailListQuery = { __typename?: 'Query', communications_mail: Array<{ __typename?: 'Mail', id: number, threadId: number, subject: string, hasAttachments: boolean, lastThreadMessageId: number, lastThreadMessageBody: string, lastThreadMessage: string, read: boolean, senders: Array<{ __typename?: 'MailSender', sender: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, resolvedRecipients: Array<{ __typename: 'ResolvedRecipient', id: number, recipientPartyId: number, resolvedName: string, recipientType: RecipientType, searchType: SearchType, person?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } | null }> }> };

export type SearchMailListQueryVariables = Exact<{
  filter?: InputMaybe<MailSearchFilter>;
}>;


export type SearchMailListQuery = { __typename?: 'Query', communications_mailSearch: Array<{ __typename?: 'Mail', id: number, threadId: number, subject: string, hasAttachments: boolean, lastThreadMessageId: number, lastThreadMessageBody: string, lastThreadMessage: string, read: boolean, senders: Array<{ __typename?: 'MailSender', sender: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, resolvedRecipients: Array<{ __typename: 'ResolvedRecipient', id: number, recipientPartyId: number, resolvedName: string, recipientType: RecipientType, searchType: SearchType, person?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } | null }>, labels: Array<{ __typename?: 'Label', id: number, name: string, personPartyId: number, colour?: Colour | null, custom?: boolean | null, type: LabelType }> }> };

export type Communications_MailThreadQueryVariables = Exact<{
  filter?: InputMaybe<MailThreadFilter>;
}>;


export type Communications_MailThreadQuery = { __typename?: 'Query', communications_mailThread: Array<{ __typename?: 'MailThread', id: number, threadId?: number | null, threadMessageId?: number | null, subject: string, body?: string | null, senderPartyId: number, sentOn: string, scheduleFor?: string | null, latestMessage?: string | null, canReply: boolean, starred?: boolean | null, readOn?: string | null, sender: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null }, resolvedRecipients: Array<{ __typename: 'ResolvedRecipient', id: number, recipientPartyId: number, resolvedName: string, recipientType: RecipientType, searchType: SearchType, person?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } | null }>, recipients: Array<{ __typename?: 'Recipient', id: number, recipientPartyId: number, recipientType: RecipientType, resolvedRecipientId?: number | null, recipient: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, attachments: Array<{ __typename?: 'Attachment', id: number, url: string }>, labels: Array<{ __typename?: 'Label', id: number, name: string, personPartyId: number, colour?: Colour | null, custom?: boolean | null, type: LabelType }> }> };

export type Communications_SendMailMutationVariables = Exact<{
  input?: InputMaybe<SendMailInput>;
}>;


export type Communications_SendMailMutation = { __typename?: 'Mutation', communications_sendMail?: { __typename?: 'Mail', id: number, threadId: number } | null };

export type Communications_StarredMutationVariables = Exact<{
  input?: InputMaybe<MailStarredInput>;
}>;


export type Communications_StarredMutation = { __typename?: 'Mutation', communications_starred?: string | null };

export type Communications_ReadMutationVariables = Exact<{
  input?: InputMaybe<MailReadInput>;
}>;


export type Communications_ReadMutation = { __typename?: 'Mutation', communications_read?: string | null };

export type Communications_MailReadReceiptQueryVariables = Exact<{
  filter?: InputMaybe<ReadReceiptFilter>;
}>;


export type Communications_MailReadReceiptQuery = { __typename?: 'Query', communications_mailReadReceipt: Array<{ __typename?: 'ReadRecipient', id: number, threadMessageId: number, readOn?: string | null, recipient: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> };

export type Communications_RecallMailMutationVariables = Exact<{
  input?: InputMaybe<RecallMailInput>;
}>;


export type Communications_RecallMailMutation = { __typename?: 'Mutation', communications_recallMail?: { __typename?: 'Success', success?: boolean | null } | null };

export type Communications_PartiesQueryVariables = Exact<{
  filter?: InputMaybe<RecipientFilter>;
}>;


export type Communications_PartiesQuery = { __typename?: 'Query', communications_parties: Array<{ __typename?: 'Search', partyId: number, type: SearchType, text: string, avatarUrl?: string | null }> };

export type Communications_DeleteScheduledMailMutationVariables = Exact<{
  input: DeleteScheduledMailInput;
}>;


export type Communications_DeleteScheduledMailMutation = { __typename?: 'Mutation', communications_deleteScheduledMail: { __typename?: 'Success', success?: boolean | null } };

export type Communications_ArchiveNoticeMutationVariables = Exact<{
  input?: InputMaybe<NoticeAction>;
}>;


export type Communications_ArchiveNoticeMutation = { __typename?: 'Mutation', communications_archiveNotice: { __typename?: 'Success', success?: boolean | null } };

export type Communications_DeleteNoticeMutationVariables = Exact<{
  input: NoticeAction;
}>;


export type Communications_DeleteNoticeMutation = { __typename?: 'Mutation', communications_deleteNotice: { __typename?: 'Success', success?: boolean | null } };

export type Communications_NoticeboardQueryVariables = Exact<{
  filter?: InputMaybe<NoticeboardFilter>;
}>;


export type Communications_NoticeboardQuery = { __typename?: 'Query', communications_noticeboard: Array<{ __typename?: 'Notice', id?: number | null, title: string, notice: string, priority?: number | null, validFrom?: string | null, validUntil?: string | null, pinned: boolean, publicNotice: boolean, images: Array<{ __typename?: 'NoticeImage', id: number, url: string, isCover: boolean }>, recipients: Array<{ __typename?: 'NoticeRecipient', acknowledged: boolean, acknowledgedOn?: string | null, id: { __typename?: 'NoticeRecipientId', noticeId: number, partyId: number } }>, socialPosts: Array<{ __typename?: 'SocialPost', id: number, socialPostId?: string | null, platform: SocialPlatform, status: SocialPostStatus, retryCount: number, maxRetries: number, errorMessage?: string | null, nextRetryAt?: string | null }> }> };

export type Communications_NoticeboardDetailsQueryVariables = Exact<{
  filter?: InputMaybe<NoticeboardFilter>;
}>;


export type Communications_NoticeboardDetailsQuery = { __typename?: 'Query', communications_noticeboard: Array<{ __typename?: 'Notice', id?: number | null, title: string, notice: string, priority?: number | null, validFrom?: string | null, validUntil?: string | null, allStaff: boolean, allContacts: boolean, allStudents: boolean, pinned: boolean, archived: boolean, publicNotice: boolean, archivedByPartyId?: number | null, images: Array<{ __typename?: 'NoticeImage', id: number, url: string, isCover: boolean }>, assignedToParties: Array<{ __typename?: 'NoticeAssignee', staff?: boolean | null, contact?: boolean | null, student?: boolean | null, id: { __typename?: 'NoticeAssigneeId', noticeId: number, partyId: number }, party: { __typename: 'GeneralGroup', name: string, partyId: number, avatarUrl?: string | null } | { __typename: 'ProgrammeStageEnrollment', partyId: number, name: string } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, partyId: number, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', name: string, partyId: number } }>, recipients: Array<{ __typename?: 'NoticeRecipient', acknowledged: boolean, acknowledgedOn?: string | null, id: { __typename?: 'NoticeRecipientId', noticeId: number, partyId: number } }>, socialPosts: Array<{ __typename?: 'SocialPost', id: number, socialPostId?: string | null, platform: SocialPlatform, status: SocialPostStatus, retryCount: number, maxRetries: number, errorMessage?: string | null, nextRetryAt?: string | null }>, archivedBy?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, name: string } | null } | null }> };

export type Communications_AcknowledgeNoticeMutationVariables = Exact<{
  input?: InputMaybe<NoticeAction>;
}>;


export type Communications_AcknowledgeNoticeMutation = { __typename?: 'Mutation', communications_acknowledgeNotice: { __typename?: 'Success', success?: boolean | null } };

export type Communications_RetrySocialPostMutationVariables = Exact<{
  input: RetrySocialPostInput;
}>;


export type Communications_RetrySocialPostMutation = { __typename?: 'Mutation', communications_retrySocialPost: { __typename?: 'Success', success?: boolean | null } };

export type Communications_NoticeboardConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type Communications_NoticeboardConfigQuery = { __typename?: 'Query', communications_noticeboardConfig?: { __typename?: 'Communications_NoticeboardConfig', enabled: boolean, publicNoticeboardId?: string | null, publicNoticeboardLink?: string | null } | null };

export type Communications_NoticeboardConfigureMutationVariables = Exact<{
  input: Communications_NoticeboardConfigInput;
}>;


export type Communications_NoticeboardConfigureMutation = { __typename?: 'Mutation', communications_noticeboardConfigure: { __typename?: 'Success', success?: boolean | null } };

export type Communications_SaveNoticeMutationVariables = Exact<{
  input: Array<SaveNoticeInput> | SaveNoticeInput;
}>;


export type Communications_SaveNoticeMutation = { __typename?: 'Mutation', communications_saveNotice: Array<{ __typename?: 'Notice', id?: number | null, title: string, notice: string }> };

export type Notes_BehaviourCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<Notes_BehaviourCategoryFilter>;
}>;


export type Notes_BehaviourCategoriesQuery = { __typename?: 'Query', notes_behaviourCategories: Array<{ __typename?: 'Notes_BehaviourCategory', behaviourCategoryId: number, name: string, description: string, behaviourType: Notes_BehaviourType }> };

export type Notes_BehaviourLevelsQueryVariables = Exact<{
  filter?: InputMaybe<Notes_BehaviourCategoryFilter>;
}>;


export type Notes_BehaviourLevelsQuery = { __typename?: 'Query', notes_behaviourCategories: Array<{ __typename?: 'Notes_BehaviourCategory', behaviourType: Notes_BehaviourType, behaviourCategoryId: number, name: string, description: string, tags: Array<{ __typename?: 'Notes_Tag', id: number, category: Notes_TagCategory, name: string, nameTextId: number, description?: string | null, descriptionTextId: number, tag_l1?: string | null, tag_l2?: string | null, tag_l3?: string | null, behaviourType?: Notes_BehaviourType | null }> }> };

export type Notes_BehaviourTagUsageQueryVariables = Exact<{
  filter: Notes_BehaviourTagUsageFilter;
}>;


export type Notes_BehaviourTagUsageQuery = { __typename?: 'Query', notes_behaviourTagUsage?: { __typename?: 'Notes_BehaviourTagUsage', tagId: number, linkedBehaviourCount: number } | null };

export type Notes_Tags_BehavioursQueryVariables = Exact<{
  filter: Notes_TagFilter;
}>;


export type Notes_Tags_BehavioursQuery = { __typename?: 'Query', notes_tags: Array<{ __typename?: 'Notes_Tag', id: number, name: string, description?: string | null, behaviourType?: Notes_BehaviourType | null, tag_l2?: string | null, category: Notes_TagCategory, points?: number | null, availableToContacts?: boolean | null, availableToStaff?: boolean | null, availableToStudents?: boolean | null, behaviourCategory?: { __typename?: 'Notes_BehaviourCategory', behaviourCategoryId: number, name: string } | null }> };

export type Notes_DeleteBehaviourTagMutationVariables = Exact<{
  input: Notes_DeleteBehaviourTagInput;
}>;


export type Notes_DeleteBehaviourTagMutation = { __typename?: 'Mutation', notes_deleteBehaviourTag?: { __typename?: 'Success', success?: boolean | null } | null };

export type Notes_DeleteBehaviourNoteMutationVariables = Exact<{
  input: Notes_DeleteBehaviourNote;
}>;


export type Notes_DeleteBehaviourNoteMutation = { __typename?: 'Mutation', notes_deleteBehaviourNote?: { __typename?: 'Success', success?: boolean | null } | null };

export type Notes_Notes_BehaviourQueryVariables = Exact<{
  filter: Notes_NotesFilter;
}>;


export type Notes_Notes_BehaviourQuery = { __typename?: 'Query', notes_notes: Array<{ __typename?: 'Notes_Note', id?: number | null, note?: string | null, createdOn: string, createdBy: number, incidentDate?: string | null, createdByPerson?: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null, tags: Array<{ __typename?: 'Notes_Tag', id: number, name: string, category: Notes_TagCategory, behaviourType?: Notes_BehaviourType | null, descriptionTextId: number, nameTextId: number }>, associatedGroups?: Array<{ __typename: 'GeneralGroup', partyId: number } | { __typename: 'ProgrammeStageEnrollment', partyId: number } | { __typename: 'SubjectGroup', partyId: number, subjects: Array<{ __typename?: 'Subject', name: string, colour?: Colour | null }> } | { __typename: 'YearGroupEnrollment', partyId: number } | null> | null }> };

export type Notes_ResetBehaviourPointsMutationVariables = Exact<{
  input?: InputMaybe<Notes_BehaviourResetPoints>;
}>;


export type Notes_ResetBehaviourPointsMutation = { __typename?: 'Mutation', notes_resetBehaviourPoints?: { __typename?: 'Success', success?: boolean | null } | null };

export type Notes_BehaviourQueryVariables = Exact<{
  filter?: InputMaybe<Notes_BehaviourFilter>;
}>;


export type Notes_BehaviourQuery = { __typename?: 'Query', notes_behaviour?: { __typename?: 'Notes_StudentBehaviourOverview', behaviours?: Array<{ __typename?: 'Notes_StudentBehaviour', noteId: number, incidentDate: string, associatedPartyIds?: Array<number | null> | null, category: string, details: string, takenByPartyId: number, tagIds?: Array<number | null> | null, points?: number | null, referencedParties: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null }>, associatedParties: Array<{ __typename: 'GeneralGroup', name: string, partyId: number, avatarUrl?: string | null } | { __typename: 'ProgrammeStageEnrollment', partyId: number, name: string } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, partyId: number, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', name: string, partyId: number } | null>, takenBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null }, tags?: Array<{ __typename?: 'Notes_Tag', id: number, name: string, description?: string | null, behaviourType?: Notes_BehaviourType | null, points?: number | null } | null> | null }> | null, categories: Array<{ __typename?: 'Notes_StudentBehaviourCategory', behaviourCategoryId: number, name: string, count: number, behaviourType: Notes_BehaviourType }> } | null };

export type Notes_UpsertBehaviourCategoryMutationVariables = Exact<{
  input?: InputMaybe<Notes_BehaviourCategoryInput>;
}>;


export type Notes_UpsertBehaviourCategoryMutation = { __typename?: 'Mutation', notes_upsertBehaviourCategory?: { __typename?: 'Success', success?: boolean | null } | null };

export type Notes_UpsertBehaviourTagsMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<Notes_UpsertBehaviourTagInput>> | InputMaybe<Notes_UpsertBehaviourTagInput>>;
}>;


export type Notes_UpsertBehaviourTagsMutation = { __typename?: 'Mutation', notes_upsertBehaviourTags: Array<{ __typename?: 'Notes_Tag', id: number }> };

export type Notes_UpsertBehaviourNoteMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<Notes_UpsertNote>> | InputMaybe<Notes_UpsertNote>>;
}>;


export type Notes_UpsertBehaviourNoteMutation = { __typename?: 'Mutation', notes_upsertNotes: Array<{ __typename?: 'Notes_Note', id?: number | null, tags: Array<{ __typename?: 'Notes_Tag', behaviourType?: Notes_BehaviourType | null }> }> };

export type Core_PeopleQueryVariables = Exact<{
  filter: Core_PeopleFilter;
}>;


export type Core_PeopleQuery = { __typename?: 'Query', core_people: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }> };

export type Catalogue_PersonalTitlesQueryVariables = Exact<{ [key: string]: never; }>;


export type Catalogue_PersonalTitlesQuery = { __typename?: 'Query', catalogue_personalTitles: Array<{ __typename?: 'PersonalTitle', id: number, name: string }> };

export type PrintPersonsGroupMembershipsQueryVariables = Exact<{
  filter: Print_PersonsGroupMemberships;
}>;


export type PrintPersonsGroupMembershipsQuery = { __typename?: 'Query', print_personsGroupMemberships: { __typename?: 'TemporaryDownload', url?: string | null, html?: string | null } };

export type Users_UserPermissionsQueryVariables = Exact<{
  partyPersonId: Scalars['Long']['input'];
}>;


export type Users_UserPermissionsQuery = { __typename?: 'Query', users_userPermissions: Array<{ __typename?: 'Users_UserPermission', id: string, name: string, description: string, feature: Feature, permissionGroups: Array<{ __typename?: 'Users_UserPermissionGroup', id: number, name: string }> }> };

export type Core_ArchiveStudentContactsMutationVariables = Exact<{
  input: ArchiveStudentContactInput;
}>;


export type Core_ArchiveStudentContactsMutation = { __typename?: 'Mutation', core_archiveStudentContacts: { __typename?: 'Success', success?: boolean | null } };

export type Core_StudentContactsQueryVariables = Exact<{
  filter: StudentContactFilter;
}>;


export type Core_StudentContactsQuery = { __typename?: 'Query', core_studentContacts?: Array<{ __typename?: 'StudentContact', partyId: number, spokenLanguages: Array<string>, requiresInterpreter?: boolean | null, occupation?: string | null, postalTitle?: string | null, person: { __typename?: 'Person', avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, personalInformation?: { __typename?: 'PersonalInformation', gender?: Gender | null, primaryAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, country?: string | null, postCode?: string | null } | null, primaryPhoneNumber?: { __typename?: 'PhoneNumber', number?: string | null, areaCode?: string | null, countryCode?: string | null } | null, primaryEmail?: { __typename?: 'EmailAddress', email?: string | null } | null } | null, relationships: Array<{ __typename?: 'StudentContactRelationshipInfo', allowedToContact: boolean, includeInSms: boolean, legalGuardian: boolean, pickupRights: boolean, allowAccessToStudentData: boolean, includeInTemplating: boolean, priority: number, relationshipType: StudentContactType, includeInTmail: boolean, student: { __typename?: 'Student', partyId: number, person: { __typename?: 'Person', avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', name: string }> } }> }> | null };

export type Core_StudentContactsForSelectQueryVariables = Exact<{
  filter: StudentContactFilter;
}>;


export type Core_StudentContactsForSelectQuery = { __typename?: 'Query', core_studentContacts?: Array<{ __typename?: 'StudentContact', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', nameTextId: number, id: number, name: string } | null }, personalInformation?: { __typename?: 'PersonalInformation', primaryEmail?: { __typename?: 'EmailAddress', email?: string | null } | null } | null }> | null };

export type Core_StudentContacts_PersonalQueryVariables = Exact<{
  filter: StudentContactFilter;
}>;


export type Core_StudentContacts_PersonalQuery = { __typename?: 'Query', core_studentContacts?: Array<{ __typename?: 'StudentContact', partyId: number, occupation?: string | null, requiresInterpreter?: boolean | null, spokenLanguages: Array<string>, postalTitle?: string | null, person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null, customFields?: Array<{ __typename?: 'Core_PartyCustomField', id: number, name: string, value: string, customFieldId: number, partyId: number, source: Core_CustomFieldPartySource, type: Core_CustomFieldType }> | null }, personalInformation?: { __typename?: 'PersonalInformation', firstName: string, lastName: string, preferredFirstName?: string | null, middleName?: string | null, gender?: Gender | null, dateOfBirth?: string | null, nationality?: string | null, mothersMaidenName?: string | null, ire?: { __typename?: 'PersonalInformationIre', ppsNumber?: string | null, religion?: string | null, countryOfBirth?: string | null } | null, primaryAddress?: { __typename?: 'Address', id?: number | null, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, country?: string | null, postCode?: string | null } | null, primaryPhoneNumber?: { __typename?: 'PhoneNumber', phoneNumberId?: number | null, number?: string | null, areaCode?: string | null, countryCode?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', phoneNumberId?: number | null, primaryPhoneNumber?: boolean | null, number?: string | null, areaCode?: string | null, countryCode?: string | null } | null> | null, primaryEmail?: { __typename?: 'EmailAddress', emailId?: number | null, email?: string | null } | null } | null, relationships: Array<{ __typename?: 'StudentContactRelationshipInfo', relationshipType: StudentContactType, studentPartyId: number, priority: number, allowedToContact: boolean, includeInSms: boolean, includeInTmail: boolean, includeInTemplating: boolean, pickupRights: boolean, legalGuardian: boolean, allowAccessToStudentData: boolean }> }> | null };

export type Users_ResetPasswordBySmsMutationVariables = Exact<{
  input: Users_ResetPassword;
}>;


export type Users_ResetPasswordBySmsMutation = { __typename?: 'Mutation', users_resetPasswordBySms?: { __typename?: 'SuccessFailure', success?: boolean | null, error?: Array<string | null> | null } | null };

export type Core_StudentContacts_StudentsQueryVariables = Exact<{
  filter: StudentContactFilter;
}>;


export type Core_StudentContacts_StudentsQuery = { __typename?: 'Query', core_studentContacts?: Array<{ __typename?: 'StudentContact', partyId: number, relationships: Array<{ __typename?: 'StudentContactRelationshipInfo', studentPartyId: number, relationshipType: StudentContactType, priority: number, allowedToContact: boolean, includeInSms: boolean, includeInTmail: boolean, includeInTemplating: boolean, pickupRights: boolean, legalGuardian: boolean, allowAccessToStudentData: boolean, student: { __typename?: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null, classGroup?: { __typename?: 'GeneralGroup', name: string } | null } }> }> | null };

export type Core_UpdateStudentContactsMutationVariables = Exact<{
  input: Array<UpdateStudentContactInput> | UpdateStudentContactInput;
}>;


export type Core_UpdateStudentContactsMutation = { __typename?: 'Mutation', core_updateStudentContacts: { __typename?: 'Success', success?: boolean | null } };

export type Core_UpsertStudentContactMutationVariables = Exact<{
  input: UpsertStudentContactInput;
}>;


export type Core_UpsertStudentContactMutation = { __typename?: 'Mutation', core_upsertStudentContact: { __typename?: 'StudentContact', partyId: number } };

export type Delete_File_TransferMutationVariables = Exact<{
  input: DeleteFileTransferInput;
}>;


export type Delete_File_TransferMutation = { __typename?: 'Mutation', delete_file_transfer?: { __typename?: 'Success', success?: boolean | null } | null };

export type MoveDocsMutationVariables = Exact<{
  input: MoveFileTransferInput;
}>;


export type MoveDocsMutation = { __typename?: 'Mutation', move_file_transfer?: { __typename?: 'Success', success?: boolean | null } | null };

export type Notes_DeleteNoteMutationVariables = Exact<{
  input: Notes_DeleteNotes;
}>;


export type Notes_DeleteNoteMutation = { __typename?: 'Mutation', notes_deleteNote?: { __typename?: 'Success', success?: boolean | null } | null };

export type Notes_NotesQueryVariables = Exact<{
  filter: Notes_NotesFilter;
}>;


export type Notes_NotesQuery = { __typename?: 'Query', notes_notes: Array<{ __typename?: 'Notes_Note', id?: number | null, note?: string | null, createdOn: string, createdBy: number, priorityNote?: boolean | null, priorityStartDate?: string | null, priorityEndDate?: string | null, createdByPerson?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null, tags: Array<{ __typename?: 'Notes_Tag', id: number, name: string, category: Notes_TagCategory, descriptionTextId: number, nameTextId: number, colour: Colour }>, pbac: { __typename?: 'Pbac_ResourceResult', isSecured: boolean } }> };

export type Notes_TagsQueryVariables = Exact<{
  filter: Notes_TagFilter;
}>;


export type Notes_TagsQuery = { __typename?: 'Query', notes_tags: Array<{ __typename?: 'Notes_Tag', id: number, name: string, description?: string | null, category: Notes_TagCategory, tag_l1?: string | null, colour: Colour, pbac?: { __typename?: 'Pbac_ResourceResult', isSecured: boolean } | null }> };

export type Notesv2_NotesQueryVariables = Exact<{
  filter: Notesv2_NoteFilter;
}>;


export type Notesv2_NotesQuery = { __typename?: 'Query', notesv2_notes: { __typename?: 'Notesv2_ReadNotes', notes: Array<{ __typename?: 'Notesv2_Note', id: number, note: string, fromDate?: string | null, toDate?: string | null, createdOn: string, updatedOn: string, tags: Array<{ __typename?: 'Notesv2_Tag', id: number, name: string, colour: Colour }>, createdBy?: { __typename?: 'AuditPerson', person?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null } | null }> } };

export type Notes_UpsertNotesTagsMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<Notes_UpsertNotesTagInput>> | InputMaybe<Notes_UpsertNotesTagInput>>;
}>;


export type Notes_UpsertNotesTagsMutation = { __typename?: 'Mutation', notes_upsertNotesTags: Array<{ __typename?: 'Notes_Tag', id: number }> };

export type Notes_UpsertNotesMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<Notes_UpsertNote>> | InputMaybe<Notes_UpsertNote>>;
}>;


export type Notes_UpsertNotesMutation = { __typename?: 'Mutation', notes_upsertNotes: Array<{ __typename?: 'Notes_Note', id?: number | null }> };

export type PersonStatusQueryVariables = Exact<{
  filter?: InputMaybe<PersonStatusFilter>;
}>;


export type PersonStatusQuery = { __typename?: 'Query', composite_personStatus: { __typename?: 'PersonStatus', partyId: number, priorityStudent?: boolean | null, activeSupportPlan?: boolean | null, sessionAttendance?: Array<{ __typename?: 'SessionAttendanceStatus', name?: string | null, status?: string | null } | null> | null, currentLocation?: { __typename?: 'CurrentLocation', partyId?: number | null, eventId?: number | null, lesson?: string | null, teacher?: string | null, room?: Array<{ __typename?: 'Room', roomId: number, name: string, capacity?: number | null } | null> | null, currentAttendance?: { __typename?: 'CurrentAttendance', attendanceCodeName?: string | null, codeType?: AttendanceCodeType | null } | null } | null } };

export type Eire_DeleteNonClassContactHoursMutationVariables = Exact<{
  input: DeleteNonClassContactHoursInput;
}>;


export type Eire_DeleteNonClassContactHoursMutation = { __typename?: 'Mutation', eire_deleteNonClassContactHours?: { __typename?: 'Success', success?: boolean | null } | null };

export type Core_DiscontinueInAcademicNamespaceMutationVariables = Exact<{
  input: Core_DiscontinueAcademicNamespaceInput;
}>;


export type Core_DiscontinueInAcademicNamespaceMutation = { __typename?: 'Mutation', core_discontinueInAcademicNamespace: { __typename?: 'Success', success?: boolean | null } };

export type Catalogue_StaffCapacitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type Catalogue_StaffCapacitiesQuery = { __typename?: 'Query', catalogue_staffCapacities: Array<{ __typename?: 'StaffCapacity', id: string, name: string }> };

export type Core_EnrolInAcademicNamespaceMutationVariables = Exact<{
  input: Core_EnrolInAcademicNamespaceInput;
}>;


export type Core_EnrolInAcademicNamespaceMutation = { __typename?: 'Mutation', core_enrolInAcademicNamespace: { __typename?: 'Success', success?: boolean | null } };

export type Core_StaffEnrolmentQueryVariables = Exact<{
  filter?: InputMaybe<StaffFilter>;
}>;


export type Core_StaffEnrolmentQuery = { __typename?: 'Query', core_staff: Array<{ __typename?: 'Staff', partyId: number, displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, enrolledNamespaces: Array<{ __typename?: 'AcademicNamespace', academicNamespaceId: number, name: string, year: number, startDate: string, endDate: string, isActiveDefaultNamespace: boolean }> }> };

export type Core_StaffQueryVariables = Exact<{
  filter?: InputMaybe<StaffFilter>;
}>;


export type Core_StaffQuery = { __typename?: 'Query', core_staff: Array<{ __typename?: 'Staff', partyId: number, externalSystemId?: string | null, startDate?: string | null, endDate?: string | null, carRegistrationNumber?: string | null, parking?: string | null, position?: string | null, displayCode?: string | null, payrollNumber?: string | null, jobSharing?: boolean | null, availableForTeaching: boolean, availableForSubstitution: boolean, availableForSupportClasses: boolean, qualifications?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, employmentCapacity?: { __typename?: 'StaffCapacity', name: string } | null, personalInformation?: { __typename?: 'PersonalInformation', dateOfBirth?: string | null, gender?: Gender | null, primaryAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, line3?: string | null, postCode?: string | null, county?: string | null, country?: string | null, city?: string | null } | null, primaryPhoneNumber?: { __typename?: 'PhoneNumber', number?: string | null, areaCode?: string | null, countryCode?: string | null } | null, primaryEmail?: { __typename?: 'EmailAddress', email?: string | null } | null, emails?: Array<{ __typename?: 'EmailAddress', emailId?: number | null, email?: string | null, primaryEmail?: boolean | null } | null> | null, ire?: { __typename?: 'PersonalInformationIre', ppsNumber?: string | null } | null } | null, staffIre?: { __typename?: 'StaffIre', teacherCouncilNumber?: string | null, staffPost?: { __typename?: 'StaffPost', id: number, name: string } | null } | null, competencySubjects: Array<{ __typename?: 'Subject', id: number, name: string, colour?: Colour | null }>, peopleTags: Array<{ __typename?: 'PeopleTag', id: number, name: string, colour: Colour }> }> };

export type Core_StaffInfoForSelectQueryVariables = Exact<{
  filter?: InputMaybe<StaffFilter>;
}>;


export type Core_StaffInfoForSelectQuery = { __typename?: 'Query', core_staff: Array<{ __typename?: 'Staff', externalSystemId?: string | null, displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', nameTextId: number, id: number, name: string } | null }, personalInformation?: { __typename?: 'PersonalInformation', ire?: { __typename?: 'PersonalInformationIre', ppsNumber?: string | null } | null } | null }> };

export type Eire_NonClassContactHoursQueryVariables = Exact<{
  filter?: InputMaybe<NonClassContactHoursFilter>;
}>;


export type Eire_NonClassContactHoursQuery = { __typename?: 'Query', eire_nonClassContactHours?: Array<{ __typename?: 'NonClassContactHours', academicNameSpaceId: number, activity: Activity, dayOfTheWeek: Day, description?: string | null, hours: number, minutes: number, nonClassContactHoursId: number, programme?: Ncch_Programme | null, staffPartyId: number, staff?: { __typename?: 'Staff', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, partyId: number, type?: PartyPersonType | null } } | null } | null> | null };

export type Catalogue_PeopleTagsQueryVariables = Exact<{
  filter: Catalogue_PeopleTagFilter;
}>;


export type Catalogue_PeopleTagsQuery = { __typename?: 'Query', catalogue_peopleTags: Array<{ __typename?: 'PeopleTag', id: number, name: string, colour: Colour }> };

export type Core_Staff_PersonalQueryVariables = Exact<{
  filter?: InputMaybe<StaffFilter>;
}>;


export type Core_Staff_PersonalQuery = { __typename?: 'Query', core_staff: Array<{ __typename?: 'Staff', partyId: number, externalSystemId?: string | null, startDate?: string | null, endDate?: string | null, noLongerStaffMember?: boolean | null, payrollNumber?: string | null, displayCode?: string | null, carRegistrationNumber?: string | null, makeAndModel?: string | null, parking?: string | null, jobSharing?: boolean | null, qualifications?: string | null, competencies?: Array<number | null> | null, availableForTeaching: boolean, availableForSubstitution: boolean, availableForSupportClasses: boolean, position?: string | null, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null, customFields?: Array<{ __typename?: 'Core_PartyCustomField', id: number, name: string, value: string, customFieldId: number, partyId: number, source: Core_CustomFieldPartySource, type: Core_CustomFieldType }> | null }, personalInformation?: { __typename?: 'PersonalInformation', gender?: Gender | null, dateOfBirth?: string | null, ire?: { __typename?: 'PersonalInformationIre', ppsNumber?: string | null } | null, primaryAddress?: { __typename?: 'Address', id?: number | null, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, country?: string | null, postCode?: string | null } | null, primaryPhoneNumber?: { __typename?: 'PhoneNumber', phoneNumberId?: number | null, number?: string | null, areaCode?: string | null, countryCode?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', phoneNumberId?: number | null, primaryPhoneNumber?: boolean | null, number?: string | null, areaCode?: string | null, countryCode?: string | null } | null> | null, primaryEmail?: { __typename?: 'EmailAddress', emailId?: number | null, email?: string | null } | null, emails?: Array<{ __typename?: 'EmailAddress', emailId?: number | null, email?: string | null, primaryEmail?: boolean | null } | null> | null, nextOfKin?: { __typename?: 'NextOfKin', firstName?: string | null, lastName?: string | null, phoneNumbers?: Array<string | null> | null } | null } | null, staffIre?: { __typename?: 'StaffIre', qualifications2?: string | null, qualifications3?: string | null, qualifications4?: string | null, teacherCouncilNumber?: string | null, staffPost?: { __typename?: 'StaffPost', id: number, name: string } | null } | null, employmentCapacity?: { __typename?: 'StaffCapacity', id: string, name: string } | null, emergencyContact?: { __typename?: 'StaffEmergencyContact', firstName?: string | null, lastName?: string | null, primaryNumber?: string | null, additionalNumber?: string | null } | null, competencySubjects: Array<{ __typename?: 'Subject', id: number, name: string, colour?: Colour | null }> }> };

export type Core_ReinstateStaffMutationVariables = Exact<{
  input: Core_ReinstateMemberInput;
}>;


export type Core_ReinstateStaffMutation = { __typename?: 'Mutation', core_reinstateStaff: { __typename?: 'Success', success?: boolean | null } };

export type Eire_RollOverNonClassContactHoursMutationVariables = Exact<{
  input: RollOverNonClassContactHoursInput;
}>;


export type Eire_RollOverNonClassContactHoursMutation = { __typename?: 'Mutation', eire_rollOverNonClassContactHours?: { __typename?: 'Success', success?: boolean | null } | null };

export type Core_StaffAvailabilityQueryVariables = Exact<{
  filter: Core_StaffAvailabilityFilter;
}>;


export type Core_StaffAvailabilityQuery = { __typename?: 'Query', core_staffAvailability: Array<{ __typename?: 'Core_StaffAvailability', staffPartyId: number, noLongerStaffMember: boolean, activeInYear: boolean, availableForTeaching: boolean, availableForTeachingIsOverridden: boolean, availableForSubstitution: boolean, availableForSubstitutionIsOverridden: boolean, defaultAvailableForTeaching: boolean, defaultAvailableForSubstitution: boolean, defaultAvailableForSupportClasses: boolean, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null } }> };

export type Core_UpdateStaffAvailabilityMutationVariables = Exact<{
  input: Core_UpdateStaffAvailabilityInput;
}>;


export type Core_UpdateStaffAvailabilityMutation = { __typename?: 'Mutation', core_updateStaffAvailability: { __typename?: 'Success', success?: boolean | null } };

export type Catalogue_StaffPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type Catalogue_StaffPostsQuery = { __typename?: 'Query', catalogue_staffPosts: Array<{ __typename?: 'StaffPost', id: number, name: string }> };

export type Core_Staff_SubjectGroupsQueryVariables = Exact<{
  filter?: InputMaybe<StaffFilter>;
  filter2?: InputMaybe<SubjectGroupRelationshipFilter>;
}>;


export type Core_Staff_SubjectGroupsQuery = { __typename?: 'Query', core_staff: Array<{ __typename?: 'Staff', subjectGroups: Array<{ __typename?: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null, subjects: Array<{ __typename?: 'Subject', name: string, colour?: Colour | null, icon?: string | null }>, irePP?: { __typename?: 'SubjectGroupIrePP', level?: StudyLevel | null } | null, studentMembers?: { __typename?: 'Group', memberCount: number } | null }> }> };

export type Eire_UpdateNonClassContactHoursMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<UpdateNonClassContactHoursInput>> | InputMaybe<UpdateNonClassContactHoursInput>>;
}>;


export type Eire_UpdateNonClassContactHoursMutation = { __typename?: 'Mutation', eire_updateNonClassContactHours?: { __typename?: 'Success', success?: boolean | null } | null };

export type Core_UpdateStaffMutationVariables = Exact<{
  input: Array<UpdateStaffInput> | UpdateStaffInput;
}>;


export type Core_UpdateStaffMutation = { __typename?: 'Mutation', core_updateStaff: { __typename?: 'Success', success?: boolean | null } };

export type Eire_UpsertNonClassContactHoursMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<SaveNonClassContactHoursInput>> | InputMaybe<SaveNonClassContactHoursInput>>;
}>;


export type Eire_UpsertNonClassContactHoursMutation = { __typename?: 'Mutation', eire_upsertNonClassContactHours?: { __typename?: 'Success', success?: boolean | null } | null };

export type Core_UpsertStaffMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<UpsertStaffInput>> | InputMaybe<UpsertStaffInput>>;
}>;


export type Core_UpsertStaffMutation = { __typename?: 'Mutation', core_upsertStaff?: Array<{ __typename?: 'Staff', partyId: number } | null> | null };

export type Core_StudentsWithEmailForSelectQueryVariables = Exact<{
  filter?: InputMaybe<StudentFilter>;
}>;


export type Core_StudentsWithEmailForSelectQuery = { __typename?: 'Query', core_students: Array<{ __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', name: string }>, personalInformation?: { __typename?: 'PersonalInformation', primaryEmail?: { __typename?: 'EmailAddress', email?: string | null } | null } | null }> };

export type Wellbeing_DeleteStudentAenMutationVariables = Exact<{
  input: Wellbeing_DeleteStudentAenInput;
}>;


export type Wellbeing_DeleteStudentAenMutation = { __typename?: 'Mutation', wellbeing_deleteStudentAen: { __typename?: 'Success', success?: boolean | null } };

export type Wellbeing_StudentAenQueryVariables = Exact<{
  filter: StudentAenFilter;
}>;


export type Wellbeing_StudentAenQuery = { __typename?: 'Query', wellbeing_studentAen: Array<{ __typename?: 'Wellbeing_StudentAen', studentPartyId: number, entries: Array<{ __typename?: 'Wellbeing_StudentAenEntry', id: number, studentPartyId: number, startDate?: string | null, endDate?: string | null, type?: string | null, typeNote?: string | null, contact?: string | null, snaSupport?: string | null, provision?: string | null, note?: string | null, supportType?: SupportType | null }> }> };

export type Wellbeing_UpsertStudentAenMutationVariables = Exact<{
  input: Wellbeing_UpsertStudentAenInput;
}>;


export type Wellbeing_UpsertStudentAenMutation = { __typename?: 'Mutation', wellbeing_upsertStudentAen: { __typename?: 'Success', success?: boolean | null } };

export type Enrollment_Ire_ChangeProgrammeStageMutationVariables = Exact<{
  input: EnrollmentIre_ChangeProgrammeStages;
}>;


export type Enrollment_Ire_ChangeProgrammeStageMutation = { __typename?: 'Mutation', enrollment_ire_changeProgrammeStage: { __typename?: 'Success', success?: boolean | null } };

export type Enrollment_Ire_CreateStudentMutationVariables = Exact<{
  input: EnrollmentIre_CreateStudent;
}>;


export type Enrollment_Ire_CreateStudentMutation = { __typename?: 'Mutation', enrollment_ire_createStudent?: { __typename?: 'Student', partyId: number } | null };

export type CustomStudentExtensionPointQueryVariables = Exact<{
  filter: StudentFilter;
  custExtFilter?: InputMaybe<Dtab_CustomExtensionPointLinkFilter>;
}>;


export type CustomStudentExtensionPointQuery = { __typename?: 'Query', core_students: Array<{ __typename?: 'Student', partyId: number, extensions?: { __typename?: 'StudentGraphqlExtension', customExtensionPoint?: { __typename?: 'Dtab_CustomExtensionPointLinkList', result: Array<{ __typename?: 'Dtab_CustomExtensionPointLink', area: Dtab_ExtensionArea, table: { __typename?: 'Dtab_Table', name: string, id: { __typename?: 'FormsFd_DefinitionId', id?: number | null, provider: string }, columns: Array<{ __typename?: 'FormsFd_FormDefinitionField', sortOrder?: number | null, label: string, type: Form_FormFieldItemType, defaultValue?: string | null, required: boolean, id: { __typename?: 'FormsFd_FormDefinitionFieldId', formId: number, fieldId: string }, selectInfo?: { __typename?: 'FormsFd_FormDefinitionFieldSelect', options?: Array<{ __typename?: 'FormsFd_FormDefinitionFieldSelectOptions', id?: string | null, value: string }> | null } | null }> }, data?: { __typename?: 'Dtab_Row', rowId: { __typename?: 'Dtab_RowId', rowId: string }, cells: Array<{ __typename?: 'Dtab_CellValue', columnId: string, value?: string | null }> } | null }> } | null } | null }> };

export type UpsertCustomExtensionPointMutationVariables = Exact<{
  input: Forms_SubmitFormFieldInputs;
}>;


export type UpsertCustomExtensionPointMutation = { __typename?: 'Mutation', forms_upsertRows: { __typename?: 'Forms_UpsertRowsResponse', success: Forms_UpsertRowsSuccess, rowDetails: Array<{ __typename?: 'Forms_UpsertRowResponse', success: boolean, topLevelErrors: Array<string> }> } };

export type Composite_DeleteStudentsMutationVariables = Exact<{
  input: DeleteStudentsInput;
}>;


export type Composite_DeleteStudentsMutation = { __typename?: 'Mutation', composite_deleteStudents: { __typename?: 'Success', success?: boolean | null } };

export type Wellbeing_DeleteStudentMedicalConditionMutationVariables = Exact<{
  input: DeleteStudentMedicalConditionInput;
}>;


export type Wellbeing_DeleteStudentMedicalConditionMutation = { __typename?: 'Mutation', wellbeing_deleteStudentMedicalCondition: { __typename?: 'StudentMedical', studentPartyId: number, conditions: Array<{ __typename?: 'StudentMedicalCondition', id: number, name: string, description?: string | null }> } };

export type Wellbeing_DeleteStudentMedicalContactMutationVariables = Exact<{
  input: DeleteStudentMedicalContactInput;
}>;


export type Wellbeing_DeleteStudentMedicalContactMutation = { __typename?: 'Mutation', wellbeing_deleteStudentMedicalContact: { __typename?: 'StudentMedical', studentPartyId: number, medicalContacts: Array<{ __typename?: 'StudentMedicalContact', id?: number | null }> } };

export type Wellbeing_StudentMedicalConditionLookupQueryVariables = Exact<{ [key: string]: never; }>;


export type Wellbeing_StudentMedicalConditionLookupQuery = { __typename?: 'Query', wellbeing_studentMedicalConditionLookup?: { __typename?: 'ListString', values: Array<string> } | null };

export type Wellbeing_StudentMedicalQueryVariables = Exact<{
  filter?: InputMaybe<StudentMedicalFilter>;
}>;


export type Wellbeing_StudentMedicalQuery = { __typename?: 'Query', wellbeing_studentMedical?: { __typename?: 'StudentMedical', studentPartyId: number, student?: { __typename?: 'Student', contacts?: Array<{ __typename?: 'StudentContact', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, personalInformation?: { __typename?: 'PersonalInformation', preferredFirstName?: string | null, preferredLastName?: string | null, primaryPhoneNumber?: { __typename?: 'PhoneNumber', number?: string | null } | null } | null, relationships: Array<{ __typename?: 'StudentContactRelationshipInfo', relationshipType: StudentContactType }> }> | null, siblings?: { __typename?: 'Core_Siblings', enrolledSiblings: Array<{ __typename?: 'Student', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null }>, nonEnrolledSiblings: Array<{ __typename?: 'Core_NonEnrolledSibling', partyId: number, firstName?: string | null, lastName?: string | null }> } | null } | null, conditions: Array<{ __typename?: 'StudentMedicalCondition', id: number, name: string, description?: string | null, emergencyPlan?: string | null, equipment: Array<{ __typename?: 'StudentMedicalConditionEquipment', id: number, name: string, expiryDate?: string | null, location?: string | null, notes?: string | null }> }>, medicalContacts: Array<{ __typename?: 'StudentMedicalContact', id?: number | null, personalTitle?: string | null, firstName?: string | null, lastName?: string | null, occupation?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, county?: string | null, postcode?: string | null, primaryPhone?: string | null, email?: string | null }> } | null };

export type Wellbeing_StudentMedicalConditionsQueryVariables = Exact<{
  filter?: InputMaybe<StudentMedicalFilter>;
}>;


export type Wellbeing_StudentMedicalConditionsQuery = { __typename?: 'Query', wellbeing_studentMedical?: { __typename?: 'StudentMedical', conditions: Array<{ __typename?: 'StudentMedicalCondition', id: number, name: string, description?: string | null, emergencyPlan?: string | null, equipment: Array<{ __typename?: 'StudentMedicalConditionEquipment', id: number, name: string, expiryDate?: string | null, location?: string | null, notes?: string | null }> }> } | null };

export type Wellbeing_UpsertStudentMedicalConditionMutationVariables = Exact<{
  input: UpsertStudentMedicalConditionInput;
}>;


export type Wellbeing_UpsertStudentMedicalConditionMutation = { __typename?: 'Mutation', wellbeing_upsertStudentMedicalCondition: { __typename?: 'StudentMedical', studentPartyId: number, conditions: Array<{ __typename?: 'StudentMedicalCondition', id: number, name: string, description?: string | null, equipment: Array<{ __typename?: 'StudentMedicalConditionEquipment', id: number, name: string, location?: string | null }> }> } };

export type Wellbeing_UpsertStudentMedicalContactMutationVariables = Exact<{
  input: UpsertStudentMedicalContactInput;
}>;


export type Wellbeing_UpsertStudentMedicalContactMutation = { __typename?: 'Mutation', wellbeing_upsertStudentMedicalContact: { __typename?: 'StudentMedical', studentPartyId: number, medicalContacts: Array<{ __typename?: 'StudentMedicalContact', id?: number | null, personalTitleId?: number | null, firstName?: string | null, lastName?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, county?: string | null, postcode?: string | null, primaryPhone?: string | null, email?: string | null, occupation?: string | null }> } };

export type Core_Student_ContactsQueryVariables = Exact<{
  filter: StudentFilter;
}>;


export type Core_Student_ContactsQuery = { __typename?: 'Query', core_students: Array<{ __typename?: 'Student', partyId: number, contacts?: Array<{ __typename?: 'StudentContact', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, personalInformation?: { __typename?: 'PersonalInformation', gender?: Gender | null, nationality?: string | null, primaryAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, country?: string | null, postCode?: string | null } | null, primaryPhoneNumber?: { __typename?: 'PhoneNumber', number?: string | null, areaCode?: string | null, countryCode?: string | null } | null, primaryEmail?: { __typename?: 'EmailAddress', email?: string | null } | null } | null, relationships: Array<{ __typename?: 'StudentContactRelationshipInfo', relationshipType: StudentContactType, priority: number, allowedToContact: boolean, includeInSms: boolean, includeInTmail: boolean, pickupRights: boolean, legalGuardian: boolean, allowAccessToStudentData: boolean, includeInTemplating: boolean }> }> | null }> };

export type Core_SubjectGroupStudentsQueryVariables = Exact<{
  filter: SubjectGroupStudentFilter;
}>;


export type Core_SubjectGroupStudentsQuery = { __typename?: 'Query', core_subjectGroupStudents: Array<{ __typename?: 'StudentSubjectGroup', students: Array<{ __typename?: 'SubjectGroupStudent', examinable: boolean, studyLevel?: StudyLevel | null, extensions?: { __typename?: 'SubjectGroupStudentGraphqlExtension', targets?: Array<{ __typename?: 'TargetGrade', partyId: number, subjectId: number, targetResult?: number | null, targetGradeSetGradeId?: number | null }> | null } | null, student: { __typename?: 'Student', partyId: number, classGroup?: { __typename?: 'GeneralGroup', name: string } | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, programmeStages?: Array<{ __typename?: 'ProgrammeStage', programme?: { __typename?: 'Programme', shortName?: string | null } | null }> | null, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null } }>, subjectGroup?: { __typename?: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null, subjects: Array<{ __typename?: 'Subject', id: number, name: string, colour?: Colour | null, icon?: string | null }>, staff: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }>, studentMembershipType?: { __typename?: 'SubjectGroupStudentMembershipType', type: SubjectGroupStudentMembershipTypeEnum, classGroupId?: number | null, blockId?: string | null, classGroupName?: string | null } | null, irePP?: { __typename?: 'SubjectGroupIrePP', level?: StudyLevel | null, examinable: boolean } | null } | null }> };

export type Core_Student_PersonalQueryVariables = Exact<{
  filter: StudentFilter;
}>;


export type Core_Student_PersonalQuery = { __typename?: 'Query', core_students: Array<{ __typename?: 'Student', partyId: number, externalSystemId?: string | null, startDate?: string | null, leftEarly?: boolean | null, endDate?: string | null, guardianshipNote?: string | null, exemptions?: Array<{ __typename?: 'StudentExemption', id: number, exemption: string, exemptionTypeCode: number, grantor: string, startDate?: string | null, endDate?: string | null }> | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null, customFields?: Array<{ __typename?: 'Core_PartyCustomField', id: number, name: string, value: string, customFieldId: number, partyId: number, source: Core_CustomFieldPartySource, type: Core_CustomFieldType }> | null }, personalInformation?: { __typename?: 'PersonalInformation', firstName: string, lastName: string, preferredFirstName?: string | null, preferredLastName?: string | null, middleName?: string | null, gender?: Gender | null, dateOfBirth?: string | null, birthCertFirstName?: string | null, birthCertLastName?: string | null, nationality?: string | null, mothersMaidenName?: string | null, ire?: { __typename?: 'PersonalInformationIre', ppsNumber?: string | null, religion?: string | null, countryOfBirth?: string | null } | null, primaryAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, line3?: string | null, line4?: string | null, line5?: string | null, city?: string | null, country?: string | null, postCode?: string | null } | null, addresses?: Array<{ __typename?: 'Address', line1?: string | null, line2?: string | null, line3?: string | null, line4?: string | null, line5?: string | null, city?: string | null, country?: string | null, postCode?: string | null, primaryAddress?: boolean | null } | null> | null, primaryPhoneNumber?: { __typename?: 'PhoneNumber', number?: string | null, areaCode?: string | null, countryCode?: string | null } | null, primaryEmail?: { __typename?: 'EmailAddress', email?: string | null } | null } | null, studentIrePP?: { __typename?: 'StudentIrePP', medicalCard?: boolean | null, travellerHeritage?: boolean | null, languageSupportApplicant?: boolean | null, borderIndicator?: boolean | null, examNumber?: string | null, lockerNumber?: string | null, previousSchoolRollNumber?: string | null, dpin?: number | null, examEntrant?: boolean | null, repeatYear?: boolean | null, boardingDays?: string | null, shortTermPupil?: boolean | null, shortTermPupilNumWeeks?: number | null, reasonForLeaving?: StudentLeavingReason | null, destinationRollNo?: string | null, previousSchoolName?: string | null, previousSchoolType?: string | null } | null, classGroup?: { __typename?: 'GeneralGroup', name: string } | null, tutors: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }>, yearGroupLeads: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }>, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', name: string }>, programmeStages?: Array<{ __typename?: 'ProgrammeStage', name: string, programme?: { __typename?: 'Programme', name: string } | null }> | null, siblings?: { __typename?: 'Core_Siblings', enrolledSiblings: Array<{ __typename?: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null }>, nonEnrolledSiblings: Array<{ __typename?: 'Core_NonEnrolledSibling', partyId: number, firstName?: string | null, lastName?: string | null }> } | null }> };

export type Core_ReinstateStudentMutationVariables = Exact<{
  input: Core_ReinstateMemberInput;
}>;


export type Core_ReinstateStudentMutation = { __typename?: 'Mutation', core_reinstateStudent: { __typename?: 'Success', success?: boolean | null } };

export type StudentsForSiblingSearchQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentsForSiblingSearchQuery = { __typename?: 'Query', core_students: Array<{ __typename?: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null, contacts?: Array<{ __typename?: 'StudentContact', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, relationships: Array<{ __typename?: 'StudentContactRelationshipInfo', relationshipType: StudentContactType, studentPartyId: number, contactPartyId: number, priority: number, allowedToContact: boolean, includeInSms: boolean, includeInTmail: boolean, pickupRights: boolean, legalGuardian: boolean, allowAccessToStudentData: boolean, includeInTemplating: boolean }> }> | null }> };

export type Core_StudentsQueryVariables = Exact<{ [key: string]: never; }>;


export type Core_StudentsQuery = { __typename?: 'Query', core_students: Array<{ __typename?: 'Student', partyId: number, externalSystemId?: string | null, person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string, staff: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null }> } | null, personalInformation?: { __typename?: 'PersonalInformation', gender?: Gender | null, preferredFirstName?: string | null, dateOfBirth?: string | null, primaryPhoneNumber?: { __typename?: 'PhoneNumber', number?: string | null, areaCode?: string | null, countryCode?: string | null } | null, primaryEmail?: { __typename?: 'EmailAddress', email?: string | null } | null } | null, studentIrePP?: { __typename?: 'StudentIrePP', examNumber?: string | null, previousSchoolName?: string | null, dpin?: number | null, lockerNumber?: string | null } | null, tutors: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }>, yearGroupLeads: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }>, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', name: string }>, programmeStages?: Array<{ __typename?: 'ProgrammeStage', id: number, name: string, programme?: { __typename?: 'Programme', name: string } | null }> | null, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null }> };

export type Core_StudentQueryVariables = Exact<{
  filter: StudentFilter;
}>;


export type Core_StudentQuery = { __typename?: 'Query', core_students: Array<{ __typename?: 'Student', partyId: number, externalSystemId?: string | null, person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, studentIrePP?: { __typename?: 'StudentIrePP', dpin?: number | null } | null, classGroup?: { __typename?: 'GeneralGroup', name: string, staff: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null }> } | null, yearGroupLeads: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }>, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', shortName: string, yearGroupId: number }>, tutors: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null }>, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null }> };

export type Core_StudentsInfoForSelectQueryVariables = Exact<{
  filter?: InputMaybe<StudentFilter>;
}>;


export type Core_StudentsInfoForSelectQuery = { __typename?: 'Query', core_students: Array<{ __typename?: 'Student', externalSystemId?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', name: string }>, personalInformation?: { __typename?: 'PersonalInformation', ire?: { __typename?: 'PersonalInformationIre', ppsNumber?: string | null } | null } | null }> };

export type StudentDetailsForNtkQueryVariables = Exact<{
  filter: StudentFilter;
}>;


export type StudentDetailsForNtkQuery = { __typename?: 'Query', core_students: Array<{ __typename?: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string, staff: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null }> } | null, yearGroupLeads: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null }>, yearGroups: Array<{ __typename?: 'YearGroupEnrollment', shortName: string }>, tutors: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null }>, personalInformation?: { __typename?: 'PersonalInformation', primaryAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, country?: string | null, postCode?: string | null } | null } | null, contacts?: Array<{ __typename?: 'StudentContact', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, personalInformation?: { __typename?: 'PersonalInformation', primaryPhoneNumber?: { __typename?: 'PhoneNumber', number?: string | null, areaCode?: string | null, countryCode?: string | null } | null } | null, relationships: Array<{ __typename?: 'StudentContactRelationshipInfo', studentPartyId: number, relationshipType: StudentContactType, priority: number, allowedToContact: boolean }> }> | null }> };

export type Core_StudentsEnrolmentHistoryQueryVariables = Exact<{
  filter?: InputMaybe<StudentFilter>;
}>;


export type Core_StudentsEnrolmentHistoryQuery = { __typename?: 'Query', core_students: Array<{ __typename?: 'Student', enrolmentHistory?: Array<{ __typename?: 'EnrollmentHistory', studentPartyId: number, academicNamespaceId: number, academicNamespace: string, classGroupId: number, classGroupName: string }> | null }> };

export type UpdateCoreStudentsMutationVariables = Exact<{
  input: Array<InputMaybe<UpdateStudentInput>> | InputMaybe<UpdateStudentInput>;
}>;


export type UpdateCoreStudentsMutation = { __typename?: 'Mutation', core_updateStudents?: { __typename?: 'Success', success?: boolean | null } | null };

export type Timeline_StudentTimelineQueryVariables = Exact<{
  filter: Timeline_TimelineFilter;
}>;


export type Timeline_StudentTimelineQuery = { __typename?: 'Query', timeline_studentTimeline?: { __typename?: 'Timeline_Timeline', events: Array<{ __typename?: 'Timeline_TimelineEvent', startDatetime: string, endDatetime?: string | null, startDate: string, endDate?: string | null, headline: string, details?: string | null, studentId: number, timelineId?: { __typename?: 'Timeline_TimelineEventId', entityType: Timeline_EventType, entityId: string, studentPartyId: number } | null, meta?: { __typename: 'Timeline_EventMeta_Absent', note?: string | null, time?: string | null, type?: Timeline_EventType | null } | { __typename: 'Timeline_EventMeta_Behaviour', behaviourType?: Notes_BehaviourType | null, tag?: string | null, colour?: Colour | null, type?: Timeline_EventType | null } | { __typename: 'Timeline_EventMeta_Late', note?: string | null, time?: string | null, type?: Timeline_EventType | null } | { __typename: 'Timeline_EventMeta_Note', tag?: string | null, colour?: Colour | null, type?: Timeline_EventType | null } | { __typename: 'Timeline_EventMeta_SignInOut', type?: Timeline_EventType | null } | { __typename: 'Timeline_EventMeta_StudentDocs', link: string, type?: Timeline_EventType | null } | null, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> } | null };

export type Timeline_StudentHighlightsQueryVariables = Exact<{
  filter: Timeline_HighlightFilter;
}>;


export type Timeline_StudentHighlightsQuery = { __typename?: 'Query', timeline_studentHighlights: Array<{ __typename?: 'Timeline_Highlight', id: number, studentPartyId: number, title: string, highlight: string, status: HighlightStatus, createdOn: string, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, assignedToParties: Array<{ __typename?: 'GeneralGroup', partyId: number } | { __typename?: 'ProgrammeStageEnrollment', partyId: number } | { __typename?: 'Staff', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename?: 'Student', partyId: number } | { __typename?: 'StudentContact', partyId: number } | { __typename?: 'SubjectGroup', partyId: number } | { __typename?: 'YearGroupEnrollment', partyId: number }>, comments: Array<{ __typename?: 'Timeline_HighlightComment', commentId: number, comment: string, createdOn: string, commenter: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, likedByParties?: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }> | null }>, events: Array<{ __typename?: 'Timeline_TimelineEvent', startDatetime: string, endDatetime?: string | null, startDate: string, endDate?: string | null, headline: string, details?: string | null, studentId: number, timelineId?: { __typename?: 'Timeline_TimelineEventId', entityType: Timeline_EventType, entityId: string, studentPartyId: number } | null, meta?: { __typename: 'Timeline_EventMeta_Absent', note?: string | null, time?: string | null, type?: Timeline_EventType | null } | { __typename: 'Timeline_EventMeta_Behaviour', behaviourType?: Notes_BehaviourType | null, tag?: string | null, colour?: Colour | null, type?: Timeline_EventType | null } | { __typename: 'Timeline_EventMeta_Late', note?: string | null, time?: string | null, type?: Timeline_EventType | null } | { __typename: 'Timeline_EventMeta_Note', tag?: string | null, colour?: Colour | null, type?: Timeline_EventType | null } | { __typename: 'Timeline_EventMeta_SignInOut', note?: string | null, time?: string | null, type?: Timeline_EventType | null } | { __typename: 'Timeline_EventMeta_StudentDocs', link: string, type?: Timeline_EventType | null } | null, student: { __typename?: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } }> }> };

export type Timeline_SaveHighlightMutationVariables = Exact<{
  input: Timeline_SaveHighlight;
}>;


export type Timeline_SaveHighlightMutation = { __typename?: 'Mutation', timeline_saveHighlight: { __typename?: 'Timeline_Highlight', id: number } };

export type Timeline_SaveHighlightCommentMutationVariables = Exact<{
  input: Timeline_SaveHighlightComment;
}>;


export type Timeline_SaveHighlightCommentMutation = { __typename?: 'Mutation', timeline_saveHighlightComment: { __typename?: 'Timeline_HighlightComment', commentId: number } };

export type Timeline_DeleteHighlightMutationVariables = Exact<{
  input: Timeline_RemoveHighlight;
}>;


export type Timeline_DeleteHighlightMutation = { __typename?: 'Mutation', timeline_deleteHighlight: { __typename?: 'Success', success?: boolean | null } };

export type Core_LinkSiblingsAndContactsMutationVariables = Exact<{
  input: Core_LinkSiblingsAndContacts;
}>;


export type Core_LinkSiblingsAndContactsMutation = { __typename?: 'Mutation', core_linkSiblingsAndContacts: { __typename?: 'Success', success?: boolean | null } };

export type Core_UpdateStudentContactRelationshipsMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<Core_UpdateStudentContactRelationshipInput>> | InputMaybe<Core_UpdateStudentContactRelationshipInput>>;
}>;


export type Core_UpdateStudentContactRelationshipsMutation = { __typename?: 'Mutation', core_updateStudentContactRelationships?: { __typename?: 'Success', success?: boolean | null } | null };

export type Assessment_UpdateStudentSubjectGroupMutationVariables = Exact<{
  input: Array<UpsertStudentSubjectGroup> | UpsertStudentSubjectGroup;
}>;


export type Assessment_UpdateStudentSubjectGroupMutation = { __typename?: 'Mutation', assessment_updateStudentSubjectGroup: { __typename?: 'Success', success?: boolean | null } };

export type UpdateStudentMutationVariables = Exact<{
  input: Array<InputMaybe<UpdateStudentInput>> | InputMaybe<UpdateStudentInput>;
}>;


export type UpdateStudentMutation = { __typename?: 'Mutation', core_updateStudents?: { __typename?: 'Success', success?: boolean | null } | null };

export type Templating_ResolveLabelTemplateQueryVariables = Exact<{
  filter: Templating_ResolveLabelTemplateInput;
}>;


export type Templating_ResolveLabelTemplateQuery = { __typename?: 'Query', templating_resolveLabelTemplate: { __typename?: 'Templating_ResolvedTemplate', temporaryUrl?: string | null, html?: string | null } };

export type Templating_ResolveDataTemplateQueryVariables = Exact<{
  filter: Templating_ResolveDataTemplateInput;
}>;


export type Templating_ResolveDataTemplateQuery = { __typename?: 'Query', templating_resolveDataTemplate: { __typename?: 'Templating_ResolvedTemplate', temporaryUrl?: string | null, html?: string | null } };

export type Templating_GetLabelTemplatesQueryVariables = Exact<{
  filter: Templating_LabelTemplateFilter;
}>;


export type Templating_GetLabelTemplatesQuery = { __typename?: 'Query', templating_getLabelTemplates: Array<{ __typename?: 'Templating_LabelTemplate', id: number, name: string, paddingTop?: number | null, paddingBottom?: number | null, paddingLeft?: number | null, paddingRight?: number | null, paddingColumn?: number | null, paddingRow?: number | null, fontSize?: number | null, labelType?: LabelSizeType | null }> };

export type Templating_GetDemoLabelTemplateQueryVariables = Exact<{
  filter: Templating_DemoLabelTemplateInput;
}>;


export type Templating_GetDemoLabelTemplateQuery = { __typename?: 'Query', templating_getDemoLabelTemplate: { __typename?: 'Templating_DemoLabelTemplate', html?: string | null } };

export type Templating_UpsertLabelTemplateMutationVariables = Exact<{
  input: Templating_UpsertLabelTemplateInput;
}>;


export type Templating_UpsertLabelTemplateMutation = { __typename?: 'Mutation', templating_upsertLabelTemplate: { __typename?: 'Templating_LabelTemplate', id: number } };

export type Templating_DeleteLabelTemplatesMutationVariables = Exact<{
  input: Templating_DeleteLabelTemplateInput;
}>;


export type Templating_DeleteLabelTemplatesMutation = { __typename?: 'Mutation', templating_deleteLabelTemplates: { __typename?: 'Success', success?: boolean | null } };

export type Templating_GetSavedVariableTemplatesQueryVariables = Exact<{
  filter: Templating_SavedVariableTemplateFilter;
}>;


export type Templating_GetSavedVariableTemplatesQuery = { __typename?: 'Query', templating_getSavedVariableTemplates: Array<{ __typename?: 'Templating_SavedVariableTemplate', id: number, name: string, templateType: TemplateType, labelTemplate?: { __typename?: 'Templating_LabelTemplate', id: number, fontSize?: number | null } | null, variables: Array<{ __typename?: 'Templating_Variable', id: number, name: string, value: string, context: TemplatingContextType }> }> };

export type Templating_UpsertSavedVariableTemplateMutationVariables = Exact<{
  input: Templating_UpsertSavedVariableTemplateInput;
}>;


export type Templating_UpsertSavedVariableTemplateMutation = { __typename?: 'Mutation', templating_upsertSavedVariableTemplate: { __typename?: 'Success', success?: boolean | null } };

export type Templating_DeleteSavedVariableTemplatesMutationVariables = Exact<{
  input: Templating_DeleteSavedVariableTemplateInput;
}>;


export type Templating_DeleteSavedVariableTemplatesMutation = { __typename?: 'Mutation', templating_deleteSavedVariableTemplates: { __typename?: 'Success', success?: boolean | null } };

export type PrintAssessmentQueryVariables = Exact<{
  filter: Print_AssessmentOptions;
}>;


export type PrintAssessmentQuery = { __typename?: 'Query', print_assessment: { __typename?: 'TemporaryDownload', url?: string | null, html?: string | null } };

export type PrintAssessmentTemplateQueryVariables = Exact<{
  filter: Templating_ResolveTemplateInput;
}>;


export type PrintAssessmentTemplateQuery = { __typename?: 'Query', print_assessmentTemplate: { __typename?: 'Scheduling_SubmitJobResult', executionId: string, hasValidationErrors: boolean, validationFailures: Array<{ __typename?: 'Scheduling_JobValidationFailure', code: string, severity: Scheduling_JobValidationSeverity, message: string, affectedEntities: Array<{ __typename?: 'Scheduling_JobValidationEntity', entityType: Scheduling_JobValidationEntityType, id: number, name: string }> }> } };

export type Print_FireDrillQueryVariables = Exact<{ [key: string]: never; }>;


export type Print_FireDrillQuery = { __typename?: 'Query', print_fireDrill: { __typename?: 'TemporaryDownload', url?: string | null, html?: string | null } };

export type PrintLetterTemplateQueryVariables = Exact<{
  filter: Templating_ResolveTemplateInput;
}>;


export type PrintLetterTemplateQuery = { __typename?: 'Query', print_letterTemplate: { __typename?: 'Scheduling_SubmitJobResult', executionId: string, hasValidationErrors: boolean } };

export type Print_SubjectOptionsQueryVariables = Exact<{
  filter: Print_SubjectOptions;
}>;


export type Print_SubjectOptionsQuery = { __typename?: 'Query', print_subjectOptions: { __typename?: 'TemporaryDownload', url?: string | null, html?: string | null } };

export type PrintTimetableQueryVariables = Exact<{
  filter: Print_TimetableOptions;
}>;


export type PrintTimetableQuery = { __typename?: 'Query', print_printTimetable: { __typename?: 'TemporaryDownload', url?: string | null, html?: string | null } };

export type Reporting_AnalyseReportQueryVariables = Exact<{
  input: Reporting_AnalyseInput;
}>;


export type Reporting_AnalyseReportQuery = { __typename?: 'Query', reporting_analyseReport: { __typename?: 'Reporting_AnalyseResult', rows?: Array<any | null> | null, debug?: { __typename?: 'Reporting_TableReportDebug', sql?: string | null } | null, chart?: { __typename?: 'Reporting_AnalyticsChartResponse', type: Reporting_AnalyticsChartType, validTypes: Array<Reporting_AnalyticsChartType>, metadata?: { __typename?: 'Reporting_AnalyticsChartMetadata', xAxisLabel?: string | null, yAxisLabel?: string | null, stacked?: boolean | null, unit?: string | null, currency?: string | null, dateFormat?: string | null } | null, series: Array<{ __typename?: 'Reporting_AnalyticsChartSeries', key: string, label?: string | null, color?: string | null, data: Array<{ __typename?: 'Reporting_AnalyticsChartDataPoint', x: any, y: number, z?: number | null, label?: string | null, meta?: any | null }> }> } | null, reportMeta: { __typename?: 'Reporting_AnalyticsMeta', metrics: Array<{ __typename?: 'Reporting_AnalyticsMetricInfo', id: string, label: string, description?: string | null, defaultChartType?: Reporting_AnalyticsChartType | null }>, groupableFields: Array<{ __typename?: 'Reporting_GroupableFieldInfo', fieldId: string, label: string, isDateField: boolean, availableBuckets?: Array<Reporting_TimeBucket> | null }>, aggregatableFields: Array<{ __typename?: 'Reporting_AggregatableFieldInfo', fieldId: string, label: string, supportedAggregations: Array<Reporting_AggregationType> }> } } };

export type Reporting_ExportReportMutationVariables = Exact<{
  filter: Reporting_ExportReportInput;
}>;


export type Reporting_ExportReportMutation = { __typename?: 'Mutation', reporting_exportReport: { __typename?: 'Reporting_ExportReportResult', executionId: string } };

export type Reporting_ReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type Reporting_ReportsQuery = { __typename?: 'Query', reporting_reports: Array<{ __typename?: 'Reporting_ReportInfoTopLevel', info: { __typename?: 'Reporting_ReportInfo', id: string, name: string }, reports: Array<{ __typename?: 'Reporting_ReportInfo', id: string, name: string }> }> };

export type Reporting_RunReportExpandQueryVariables = Exact<{
  filter?: InputMaybe<Reporting_ReportFilterExpand>;
}>;


export type Reporting_RunReportExpandQuery = { __typename?: 'Query', reporting_runReportExpand?: { __typename?: 'Reporting_TableReport', id: string, data?: Array<any | null> | null, fields: Array<{ __typename?: 'Reporting_TableReportField', id: string, label: string, visibleByDefault: boolean }> } | null };

export type Reporting_RunReportMetaQueryVariables = Exact<{
  filter?: InputMaybe<Reporting_ReportFilter>;
}>;


export type Reporting_RunReportMetaQuery = { __typename?: 'Query', reporting_runReport?: { __typename?: 'Reporting_TableReport', id: string, info: { __typename?: 'Reporting_ReportInfo', name: string, supportsExpandRow: boolean, isInteractive?: boolean | null, isServerSide?: boolean | null, analyticsEnabled?: boolean | null, defaultMetricId?: string | null }, innerReports: Array<{ __typename?: 'Reporting_ReportInfo', id: string, name: string }>, filters: Array<{ __typename?: 'Reporting_TableFilter', id: string, inputType: Reporting_TableFilterType, label: string, defaultValue?: any | null, required: boolean, minValue?: any | null, maxValue?: any | null, values?: Array<{ __typename?: 'Reporting_TableFilterValues', id?: any | null, value?: string | null } | null> | null }>, fields: Array<{ __typename?: 'Reporting_TableReportField', id: string, label: string, visibleByDefault: boolean, checkExpandedRows: boolean, hideMenu: boolean, sortable: boolean, searchable?: boolean | null, maxWidth?: number | null, minWidth?: number | null, pinned?: Reporting_Pinned | null, rowGroup?: boolean | null, cellType?: Reporting_ReportCellType | null, type: Reporting_TableFieldType, meta?: { __typename?: 'Reporting_ReportCellMeta', chipSize?: Reporting_MetaChipSize | null, chipVariant?: Reporting_MetaChipVariant | null, currency?: string | null, dateFormat?: string | null, showAvatar?: boolean | null, avatarSize?: number | null, enableLink?: boolean | null, numberFormat?: { __typename?: 'Reporting_CellNumberFormat', style?: Reporting_CellNumberFormatStyle | null, maximumFractionDigits?: number | null } | null } | null }>, metrics?: { __typename?: 'Reporting_TableMetric', defaultValue: string, values: Array<{ __typename?: 'Reporting_TableMetricValue', id: string, name: string }> } | null, timeGroupBy?: { __typename?: 'Reporting_TimeGroupBy', defaultValue: string, values: Array<{ __typename?: 'Reporting_TimeGroupByValues', id: string, name: string, description: string }> } | null, groupBy?: { __typename?: 'Reporting_GroupBy', defaultValue: string, values: Array<{ __typename?: 'Reporting_GroupByValue', id: string, name: string, description: string }> } | null, actions?: { __typename?: 'Reporting_ReportActionRel', id: number, reportId: string, actions?: Array<Reporting_ReportAction> | null, tenant: number, mappings?: Array<{ __typename?: 'Reporting_ReportActionMapping', fieldId: string, field: Reporting_ReportActionField }> | null } | null } | null };

export type Reporting_RunReportPaginatedQueryVariables = Exact<{
  filter?: InputMaybe<Reporting_PaginatedReportFilter>;
}>;


export type Reporting_RunReportPaginatedQuery = { __typename?: 'Query', reporting_runReportPaginated?: { __typename?: 'Reporting_PaginatedReportResult', data?: Array<any | null> | null, debug?: { __typename?: 'Reporting_TableReportDebug', sql?: string | null } | null } | null };

export type Reporting_RunReportQueryVariables = Exact<{
  filter?: InputMaybe<Reporting_ReportFilter>;
}>;


export type Reporting_RunReportQuery = { __typename?: 'Query', reporting_runReport?: { __typename?: 'Reporting_TableReport', id: string, data?: Array<any | null> | null, debug?: { __typename?: 'Reporting_TableReportDebug', sql?: string | null } | null, fields: Array<{ __typename?: 'Reporting_TableReportField', id: string, label: string, visibleByDefault: boolean, checkExpandedRows: boolean, hideMenu: boolean, sortable: boolean, maxWidth?: number | null, minWidth?: number | null, pinned?: Reporting_Pinned | null, rowGroup?: boolean | null, cellType?: Reporting_ReportCellType | null, type: Reporting_TableFieldType, meta?: { __typename?: 'Reporting_ReportCellMeta', chipSize?: Reporting_MetaChipSize | null, chipVariant?: Reporting_MetaChipVariant | null, currency?: string | null, dateFormat?: string | null, showAvatar?: boolean | null, avatarSize?: number | null, enableLink?: boolean | null, numberFormat?: { __typename?: 'Reporting_CellNumberFormat', style?: Reporting_CellNumberFormatStyle | null, maximumFractionDigits?: number | null } | null } | null }>, tableDisplayOptions: { __typename?: 'Reporting_TableDisplayOptions', gridOptions?: any | null, tableContainerSx?: any | null }, statusPanels?: Array<{ __typename?: 'Reporting_StatusPanel', statusPanel: string, statusPanelParams: { __typename?: 'Reporting_StatusPanelParams', columns: Array<{ __typename?: 'Reporting_StatusPanelColumn', id: string, aggregationTypes: Array<Reporting_AggregationType>, onSelectOnly: boolean }> } } | null> | null } | null };

export type Reporting_RunChartQueryQueryVariables = Exact<{
  filter?: InputMaybe<Reporting_ReportFilter>;
}>;


export type Reporting_RunChartQueryQuery = { __typename?: 'Query', reporting_runQuery: { __typename?: 'Reporting_QueryResult', charts: Array<{ __typename?: 'Reporting_Chart', type: Reporting_ChartType, categories: Array<string>, colours: Array<string>, series: Array<{ __typename?: 'Reporting_ChartSeries', id: string, name: string, series: Array<number>, colour?: string | null, sortOrder: number }>, debug?: { __typename?: 'Reporting_TableReportDebug', sql?: string | null } | null }> } };

export type Reporting_DashboardFilterSchemaQueryVariables = Exact<{
  filter?: InputMaybe<Reporting_ReportFilter>;
}>;


export type Reporting_DashboardFilterSchemaQuery = { __typename?: 'Query', reporting_runReport?: { __typename?: 'Reporting_TableReport', id: string, filters: Array<{ __typename?: 'Reporting_TableFilter', id: string, inputType: Reporting_TableFilterType, label: string, defaultValue?: any | null, required: boolean, minValue?: any | null, maxValue?: any | null, values?: Array<{ __typename?: 'Reporting_TableFilterValues', id?: any | null, value?: string | null } | null> | null }> } | null };

export type Rules_ActionTypesMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type Rules_ActionTypesMetadataQuery = { __typename?: 'Query', rules_actionTypesMetadata: Array<{ __typename?: 'Rules_ActionMetaData', actionType: Rules_ActionType, name: string, description: string, inputObject: string, canRevert: boolean }> };

export type Rules_DeleteTriggeredLogMutationVariables = Exact<{
  input: Rules_DeleteTriggeredLog;
}>;


export type Rules_DeleteTriggeredLogMutation = { __typename?: 'Mutation', rules_deleteTriggeredLog: { __typename?: 'Rules_Success', success?: boolean | null } };

export type Rules_RevertTriggeredActionsMutationVariables = Exact<{
  input: Rules_RevertTriggeredActions;
}>;


export type Rules_RevertTriggeredActionsMutation = { __typename?: 'Mutation', rules_revertTriggeredActions: { __typename?: 'Rules_Success', success?: boolean | null } };

export type Rules_RuleTypesMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type Rules_RuleTypesMetadataQuery = { __typename?: 'Query', rules_ruleTypesMetadata: Array<{ __typename?: 'Rules_RuleMetaData_AggregateMatch', allowedTimeFrames: Array<Rules_TimeFrameType>, name: string, description?: string | null, criteriaType: Rules_CriteriaType, ruleType: Rules_RuleType, about: Rules_AboutType, filterFields: Array<{ __typename?: 'QueryBuilderField', name: string, label: string, valueEditorType: QueryBuilderValueTypeEditor, defaultValue?: string | null, operators: Array<{ __typename?: 'QueryBuilderOperator', name: string, label: string, allowsMultiple: boolean }>, selectOptions: Array<{ __typename?: 'QueryBuilderOptions', label: string, value: string }> }>, aggregateFields: Array<{ __typename?: 'Rules_RuleMetaData_AggregateMatch_AggregateMeta', aggType: Rules_AggregateType, possibleFields: Array<{ __typename?: 'Rules_RuleMetaData_AggregateMatch_AggregateMetaField', label: string, value: string }> }> }> };

export type Rules_RulesQueryVariables = Exact<{
  filter: Rules_RulesViewFilter;
}>;


export type Rules_RulesQuery = { __typename?: 'Query', rules_rules: Array<{ __typename?: 'Rules_RuleView', ruleId: number, name: string, description?: string | null, ruleTriggeredCount: number, actionTakenCount: number, createdOn: string, updatedOn?: string | null, lastRanAt?: string | null, lastRunSuccess?: boolean | null, disabled?: boolean | null }> };

export type Rule_DetailsQueryVariables = Exact<{
  filter: Rules_RulesViewFilter;
}>;


export type Rule_DetailsQuery = { __typename?: 'Query', rules_rules: Array<{ __typename?: 'Rules_RuleView', ruleId: number, name: string, ruleType: Rules_RuleType, description?: string | null, partyIds: Array<number>, maxTriggersAllowed?: number | null, schedule: { __typename: 'Rules_ScheduleTypeAuto', type: Rules_ScheduleType } | { __typename: 'Rules_ScheduleTypeDaily', time: string, type: Rules_ScheduleType } | { __typename: 'Rules_ScheduleWeekly', time: string, isoDayOfWeek: number, type: Rules_ScheduleType }, parties: Array<{ __typename: 'GeneralGroup', partyId: number, name: string } | { __typename: 'ProgrammeStageEnrollment', partyId: number, name: string } | { __typename: 'Staff', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', partyId: number, name: string }>, excludeParties: Array<{ __typename: 'GeneralGroup', partyId: number, name: string } | { __typename: 'ProgrammeStageEnrollment', partyId: number, name: string } | { __typename: 'Staff', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', partyId: number, name: string }>, criteria: { __typename?: 'Rules_Criteria_AggregateMatch2', criteriaType: Rules_CriteriaType, filterCondition?: string | null, ruleType: Rules_RuleType, timeframe: { __typename: 'Rules_TimeFrame_BetweenDates', from: string, to: string, type: Rules_TimeFrameType } | { __typename: 'Rules_TimeFrame_CurrentWeek', type: Rules_TimeFrameType } | { __typename: 'Rules_TimeFrame_FromDate', from: string, type: Rules_TimeFrameType } | { __typename: 'Rules_TimeFrame_PreviousOrSameDay', isoDayOfWeek: number, type: Rules_TimeFrameType } | { __typename: 'Rules_TimeFrame_Rolling', weeks: number, type: Rules_TimeFrameType } | { __typename: 'Rules_TimeFrame_Today', type: Rules_TimeFrameType } | { __typename: 'Rules_TimeFrame_YearToDate', type: Rules_TimeFrameType } }, triggers: Array<{ __typename?: 'Rules_TriggerView', triggerIdx: number, maxAllowed?: number | null, trigger: { __typename?: 'Rules_Criteria_AggregateMatch2_Trigger', type: Rules_AggregateType, field?: string | null, operator: Rules_AggregateResultOperators, value: number, triggerType: Rules_TriggerType } }>, actions: Array<{ __typename?: 'Rules_ActionView', ruleActionId?: number | null, triggerIdx: number, type: Rules_ActionType, hasError: boolean, errorRawData?: any | null, action: { __typename: 'Rules_ActionEmpty', type: Rules_ActionType } | { __typename: 'Rules_ActionMail', body: string, subject: string, type: Rules_ActionType, assignees?: { __typename?: 'Rules_ActionToParty', toContacts: boolean, toStaffRoles: Array<Rules_ActionToPartyType>, parties: Array<{ __typename: 'GeneralGroup', partyId: number, name: string } | { __typename: 'ProgrammeStageEnrollment', partyId: number, name: string } | { __typename: 'Staff', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', partyId: number, name: string }> } | null } | { __typename: 'Rules_ActionSms', message: string, type: Rules_ActionType, assignees?: { __typename?: 'Rules_ActionToParty', toContacts: boolean, toStaffRoles: Array<Rules_ActionToPartyType>, parties: Array<{ __typename: 'GeneralGroup', partyId: number, name: string } | { __typename: 'ProgrammeStageEnrollment', partyId: number, name: string } | { __typename: 'Staff', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', partyId: number, name: string }> } | null } | { __typename: 'Rules_Action_CreateHighlight', title?: string | null, highlight?: string | null, type: Rules_ActionType, assignees?: { __typename?: 'Rules_ActionToParty', toContacts: boolean, toStaffRoles: Array<Rules_ActionToPartyType>, parties: Array<{ __typename: 'GeneralGroup', partyId: number, name: string } | { __typename: 'ProgrammeStageEnrollment', partyId: number, name: string } | { __typename: 'Staff', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', partyId: number, name: string }> } | null } | { __typename: 'Rules_Action_Log', type: Rules_ActionType } | { __typename: 'Rules_Action_SendFormRequest', requestName: string, formType: Rules_Action_SendFormRequest_Type, numberDaysTillDue: number, type: Rules_ActionType, formDefinitionId?: { __typename?: 'FormsFd_DefinitionId', provider: string, id?: number | null } | null, teacherOfStaff?: { __typename?: 'Rules_Action_SendFormRequestTeacherOfStaff', roles?: Array<Forms_InfoRequestStaffRole> | null } | null } }> }> };

export type Rules_RunRuleMutationVariables = Exact<{
  input: Rules_RunRulesNow;
}>;


export type Rules_RunRuleMutation = { __typename?: 'Mutation', rules_runRule: { __typename?: 'Rules_Success', success?: boolean | null } };

export type TestRuleMutationVariables = Exact<{
  input: Rules_CustomRuleInput;
}>;


export type TestRuleMutation = { __typename?: 'Mutation', rules_testRule?: { __typename?: 'Rules_RuleTestResult', triggered: Array<{ __typename?: 'Rules_TriggeredView', id: number, ruleTriggerIdx: number, ruleId: number, ruleType: Rules_RuleType, entityId?: number | null, triggeredOn?: string | null, createdByUserId?: number | null, context: Array<{ __typename?: 'Rules_TriggeredContext_Student', contextId: string, datetime: string, criteriaType: Rules_CriteriaType, timelineType?: string | null, type: Rules_TriggeredContextType }>, party?: { __typename: 'GeneralGroup', partyId: number, name: string } | { __typename: 'ProgrammeStageEnrollment', partyId: number, name: string } | { __typename: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } } | { __typename: 'Student', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } } | { __typename: 'StudentContact', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } } | { __typename: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', partyId: number, name: string } | null }>, actionsToBeRan: Array<{ __typename?: 'Rules_RuleTestResultActionsToBeRan', type: Rules_ActionType, count: number }> } | null };

export type UpdateRuleMutationVariables = Exact<{
  input: Array<Rules_CustomRuleUpdateInput> | Rules_CustomRuleUpdateInput;
}>;


export type UpdateRuleMutation = { __typename?: 'Mutation', rules_updateCustomRule: { __typename?: 'Rules_Success', success?: boolean | null } };

export type SaveRuleMutationVariables = Exact<{
  input: Rules_CustomRuleInput;
}>;


export type SaveRuleMutation = { __typename?: 'Mutation', rules_upsertCustomRule: { __typename?: 'Rules_Success', success?: boolean | null } };

export type Rules_ViewTriggeredQueryVariables = Exact<{
  filter: Rules_TriggeredViewFilter;
}>;


export type Rules_ViewTriggeredQuery = { __typename?: 'Query', rules_viewTriggered: Array<{ __typename?: 'Rules_TriggeredView', id: number, ruleTriggerIdx: number, ruleId: number, ruleType: Rules_RuleType, entityId?: number | null, triggeredOn?: string | null, createdByUserId?: number | null, context: Array<{ __typename?: 'Rules_TriggeredContext_Student', contextId: string, datetime: string, criteriaType: Rules_CriteriaType, timelineType?: string | null, type: Rules_TriggeredContextType }>, actionsTaken: Array<{ __typename?: 'Rules_TriggeredActionView', ruleTriggeredActionId: number, status: Rules_TriggeredActionStatus, successId?: string | null, meta: { __typename?: 'Rules_ActionMetaData', canRevert: boolean, actionType: Rules_ActionType, name: string } }>, party?: { __typename: 'GeneralGroup', partyId: number, name: string } | { __typename: 'ProgrammeStageEnrollment', partyId: number, name: string } | { __typename: 'Staff', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null } | { __typename: 'StudentContact', person: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null, subjects: Array<{ __typename?: 'Subject', colour?: Colour | null }> } | { __typename: 'YearGroupEnrollment', partyId: number, name: string } | null }> };

export type Sa_ClassAwayQueryVariables = Exact<{
  filter: Sa_ClassAwayFilter;
}>;


export type Sa_ClassAwayQuery = { __typename?: 'Query', sa_classAway: Array<{ __typename?: 'Sa_ClassAway', freeStaffPartyIds: Array<number | null>, cancelled: boolean, staffAreFreed: boolean, studentsAttendingActivityTotal: number, studentsInGroupTotal: number, freeStaff: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, archived?: boolean | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } | null>, event: { __typename?: 'CalendarEvent', name: string, colour?: Colour | null, eventId: number, calendarIds: Array<number | null>, startTime: string, endTime: string, type: CalendarEventType, allDayEvent: boolean, roomIds: Array<number>, calendarEventId: { __typename?: 'CalendarEventId', eventId: number, date?: string | null }, attendees: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename?: 'GeneralGroup', partyId: number } | { __typename?: 'ProgrammeStageEnrollment', partyId: number } | { __typename?: 'Staff', partyId: number } | { __typename?: 'Student', partyId: number } | { __typename?: 'StudentContact', partyId: number } | { __typename?: 'SubjectGroup', partyId: number } | { __typename?: 'YearGroupEnrollment', partyId: number } | null }>, lessonInfo?: { __typename?: 'CalendarEventLessonRaw', subjectGroupId: number, lessonId?: number | null } | null, rooms: Array<{ __typename?: 'Room', roomId: number, name: string, capacity?: number | null, description?: string | null, includeInTimetable: boolean, externalSystemId?: string | null, location?: string | null, disabled: boolean, pools: Array<{ __typename?: 'RoomPool', id: number, name: string, colour: Colour }> }> }, affectedAttendees: Array<{ __typename?: 'GeneralGroup', partyId: number } | { __typename?: 'ProgrammeStageEnrollment', partyId: number } | { __typename?: 'Staff', partyId: number } | { __typename?: 'Student', partyId: number } | { __typename?: 'StudentContact', partyId: number } | { __typename?: 'SubjectGroup', partyId: number } | { __typename?: 'YearGroupEnrollment', partyId: number } | null> } | null> };

export type Sa_DeleteActivityMutationVariables = Exact<{
  input: Sa_SchoolActivityDelete;
}>;


export type Sa_DeleteActivityMutation = { __typename?: 'Mutation', sa_deleteActivity?: { __typename?: 'Success', success?: boolean | null } | null };

export type ActivitiesListQueryVariables = Exact<{
  filter: Sa_SchoolActivityFilter;
}>;


export type ActivitiesListQuery = { __typename?: 'Query', sa_activities: Array<{ __typename?: 'Sa_SchoolActivity', schoolActivityId: number, customGroupId?: number | null, lastPublished?: string | null, name?: string | null, createdOn: string, tripPurpose?: string | null, notes?: string | null, published: boolean, approval: { __typename?: 'Sa_SchoolActivityApproval', status: Sa_Status }, createdBy: { __typename?: 'AuditPerson', person?: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null }, dates: Array<{ __typename?: 'Sa_SchoolActivityDate', date: string, startTime?: string | null, endTime?: string | null, partial: boolean }>, location: { __typename?: 'Sa_SchoolActivityLocation', locationDetails?: string | null, inSchoolGrounds: boolean, roomIds: Array<number>, rooms: Array<{ __typename?: 'Room', roomId: number, name: string }> }, customGroup?: { __typename?: 'GeneralGroup', partyId: number, name: string, avatarUrl?: string | null, relatedSubjectGroups: Array<{ __typename?: 'SubjectGroup', partyId: number, name: string, subjects: Array<{ __typename?: 'Subject', name: string }> }>, studentMembers?: { __typename?: 'Group', groupPartyId: number, memberCount: number, members: Array<{ __typename?: 'GroupMembership', partyId: number, person?: { __typename?: 'Person', avatarUrl?: string | null, partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null }> } | null, staffMembers?: { __typename?: 'Group', groupPartyId: number, memberIds: Array<number>, memberCount: number, members: Array<{ __typename?: 'GroupMembership', partyId: number, person?: { __typename?: 'Person', avatarUrl?: string | null, partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null }> } | null } | null } | null> };

export type ActivitiesByIdQueryVariables = Exact<{
  filter: Sa_SchoolActivityFilter;
}>;


export type ActivitiesByIdQuery = { __typename?: 'Query', sa_activities: Array<{ __typename?: 'Sa_SchoolActivity', schoolActivityId: number, customGroupId?: number | null, lastPublished?: string | null, name?: string | null, staffAbsenceTypeId?: number | null, tripPurpose?: string | null, notes?: string | null, published: boolean, publicStaffCalendar: boolean, publicContactCalendar: boolean, publicStudentCalendar: boolean, dates: Array<{ __typename?: 'Sa_SchoolActivityDate', date: string, startTime?: string | null, endTime?: string | null, partial: boolean }>, location: { __typename?: 'Sa_SchoolActivityLocation', locationDetails?: string | null, inSchoolGrounds: boolean, roomIds: Array<number>, rooms: Array<{ __typename?: 'Room', roomId: number, name: string }> }, approval: { __typename?: 'Sa_SchoolActivityApproval', status: Sa_Status, approvalDate?: string | null, approvalNote?: string | null }, customGroup?: { __typename?: 'GeneralGroup', partyId: number, name: string, avatarUrl?: string | null, relatedSubjectGroups: Array<{ __typename?: 'SubjectGroup', partyId: number, name: string, subjects: Array<{ __typename?: 'Subject', name: string }> }>, studentMembers?: { __typename?: 'Group', groupPartyId: number, memberCount: number, members: Array<{ __typename?: 'GroupMembership', partyId: number, person?: { __typename?: 'Person', avatarUrl?: string | null, partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null }> } | null, staffMembers?: { __typename?: 'Group', groupPartyId: number, memberIds: Array<number>, memberCount: number, members: Array<{ __typename?: 'GroupMembership', partyId: number, roles?: Array<string | null> | null, person?: { __typename?: 'Person', avatarUrl?: string | null, partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null }> } | null } | null } | null> };

export type SaStudentListQueryVariables = Exact<{
  filter: Sa_SchoolActivityFilter;
}>;


export type SaStudentListQuery = { __typename?: 'Query', sa_activities: Array<{ __typename?: 'Sa_SchoolActivity', customGroup?: { __typename?: 'GeneralGroup', students: Array<{ __typename?: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, extensions?: { __typename?: 'StudentGraphqlExtension', priority?: boolean | null, aen?: boolean | null, medical?: boolean | null } | null, classGroup?: { __typename?: 'GeneralGroup', name: string } | null }> } | null } | null> };

export type Sa_LessonsNeedingCoverQueryVariables = Exact<{
  filter: Sa_LessonsNeedingCoverFilter;
}>;


export type Sa_LessonsNeedingCoverQuery = { __typename?: 'Query', sa_lessonsNeedingCover: Array<{ __typename?: 'Sa_LessonNeedingCover', awayStaffPartyIds: Array<number | null>, studentsAttendingActivityTotal: number, studentsInGroupTotal: number, awayStaff: Array<{ __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null } | null>, event: { __typename?: 'CalendarEvent', colour?: Colour | null, name: string, eventId: number, startTime: string, endTime: string, calendarEventId: { __typename?: 'CalendarEventId', eventId: number }, rooms: Array<{ __typename?: 'Room', name: string }> }, affectedAttendees: Array<{ __typename?: 'GeneralGroup', partyId: number } | { __typename?: 'ProgrammeStageEnrollment', partyId: number } | { __typename?: 'Staff', partyId: number } | { __typename?: 'Student', partyId: number } | { __typename?: 'StudentContact', partyId: number } | { __typename?: 'SubjectGroup', partyId: number } | { __typename?: 'YearGroupEnrollment', partyId: number } | null> } | null> };

export type Sa_UpsertPublishMutationVariables = Exact<{
  input?: InputMaybe<Sa_PublishInput>;
}>;


export type Sa_UpsertPublishMutation = { __typename?: 'Mutation', sa_upsertPublish?: { __typename?: 'Success', success?: boolean | null } | null };

export type Sa_ApproveActivityMutationVariables = Exact<{
  input?: InputMaybe<Sa_ApproveInput>;
}>;


export type Sa_ApproveActivityMutation = { __typename?: 'Mutation', sa_approveActivity?: { __typename?: 'Success', success?: boolean | null } | null };

export type Sa_AddRemoveStaffMutationVariables = Exact<{
  input: Sa_AddRemoveStaff;
}>;


export type Sa_AddRemoveStaffMutation = { __typename?: 'Mutation', sa_addRemoveStaff?: { __typename?: 'Success', success?: boolean | null } | null };

export type Sa_AddRemoveStudentsMutationVariables = Exact<{
  input: Sa_AddRemoveStudents;
}>;


export type Sa_AddRemoveStudentsMutation = { __typename?: 'Mutation', sa_addRemoveStudents?: { __typename?: 'Success', success?: boolean | null } | null };

export type Sa_UpsertActivityMutationVariables = Exact<{
  input?: InputMaybe<Sa_SchoolActivityInput>;
}>;


export type Sa_UpsertActivityMutation = { __typename?: 'Mutation', sa_upsertActivity?: { __typename?: 'Success', success?: boolean | null } | null };

export type Core_UpsertAcademicNamespaceMutationVariables = Exact<{
  input?: InputMaybe<SaveAcademicNamespaceInput>;
}>;


export type Core_UpsertAcademicNamespaceMutation = { __typename?: 'Mutation', core_upsertAcademicNamespace?: { __typename?: 'AcademicNamespace', academicNamespaceId: number } | null };

export type Core_SetActiveActiveAcademicNamespaceMutationVariables = Exact<{
  input?: InputMaybe<SetActiveAcademicNamespace>;
}>;


export type Core_SetActiveActiveAcademicNamespaceMutation = { __typename?: 'Mutation', core_setActiveActiveAcademicNamespace?: { __typename?: 'AcademicNamespace', academicNamespaceId: number, type: AcademicNamespaceType, name: string, year: number, description?: string | null, isActiveDefaultNamespace: boolean } | null };

export type Assessment_CommentBankQueryVariables = Exact<{
  filter?: InputMaybe<CommentBankFilter>;
}>;


export type Assessment_CommentBankQuery = { __typename?: 'Query', assessment_commentBank?: Array<{ __typename?: 'CommentBank', id: number, name: string, description?: string | null, active: boolean, comments?: Array<{ __typename?: 'Comment', id: number, comment: string, active: boolean }> | null }> | null };

export type CommentBankByIdQueryVariables = Exact<{
  filter?: InputMaybe<CommentBankFilter>;
}>;


export type CommentBankByIdQuery = { __typename?: 'Query', assessment_commentBank?: Array<{ __typename?: 'CommentBank', id: number, name: string, comments?: Array<{ __typename?: 'Comment', id: number, comment: string, active: boolean }> | null }> | null };

export type Assessment_SaveCommentBankMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<SaveCommentBankInput>> | InputMaybe<SaveCommentBankInput>>;
}>;


export type Assessment_SaveCommentBankMutation = { __typename?: 'Mutation', assessment_saveCommentBank?: Array<{ __typename?: 'CommentBank', id: number, name: string, description?: string | null, active: boolean, comments?: Array<{ __typename?: 'Comment', id: number, comment: string, active: boolean }> | null } | null> | null };

export type CustomFieldsQueryVariables = Exact<{
  filter?: InputMaybe<Core_CustomFieldFilter>;
}>;


export type CustomFieldsQuery = { __typename?: 'Query', core_customFields: Array<{ __typename?: 'Core_CustomField', id: number, name: string, type: Core_CustomFieldType, options: Array<string>, source: Core_CustomFieldPartySource }> };

export type Core_DeleteCustomFieldsMutationVariables = Exact<{
  input: Core_DeleteCustomFields;
}>;


export type Core_DeleteCustomFieldsMutation = { __typename?: 'Mutation', core_deleteCustomFields: { __typename?: 'Success', success?: boolean | null } };

export type Core_UpsertCustomFieldsMutationVariables = Exact<{
  input: Array<Core_UpsertCustomFields> | Core_UpsertCustomFields;
}>;


export type Core_UpsertCustomFieldsMutation = { __typename?: 'Mutation', core_upsertCustomFields: { __typename?: 'Success', success?: boolean | null } };

export type Core_Staff_Form_BQueryVariables = Exact<{
  filter?: InputMaybe<StaffFilter>;
}>;


export type Core_Staff_Form_BQuery = { __typename?: 'Query', core_staff: Array<{ __typename?: 'Staff', partyId: number, payrollNumber?: string | null, jobSharing?: boolean | null, qualifications?: string | null, person: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, title?: { __typename?: 'PersonalTitle', nameTextId: number, id: number, name: string } | null }, personalInformation?: { __typename?: 'PersonalInformation', gender?: Gender | null, ire?: { __typename?: 'PersonalInformationIre', ppsNumber?: string | null } | null } | null, employmentCapacity?: { __typename?: 'StaffCapacity', id: string, name: string } | null, staffIre?: { __typename?: 'StaffIre', teacherCouncilNumber?: string | null, teacherReferenceNumber?: string | null, includeDtrReturns?: boolean | null, qualifications2?: string | null, qualifications3?: string | null, qualifications4?: string | null, otherSchool1?: string | null, otherSchool2?: string | null, previousSchool1?: string | null, previousSchool2?: string | null, staffPost?: { __typename?: 'StaffPost', id: number, name: string } | null } | null }> };

export type Export_PtmQueryVariables = Exact<{
  filter: Export_PtmoFilter;
}>;


export type Export_PtmQuery = { __typename?: 'Query', export_ptm: { __typename?: 'TemporaryDownload', url?: string | null } };

export type Composite_ExtractStudentDataQueryVariables = Exact<{
  input: DataExtraction_ExtractInput;
}>;


export type Composite_ExtractStudentDataQuery = { __typename?: 'Query', composite_extractStudentData: { __typename?: 'TemporaryDownload', url?: string | null } };

export type Pbac_AreaMetaDataQueryVariables = Exact<{ [key: string]: never; }>;


export type Pbac_AreaMetaDataQuery = { __typename?: 'Query', pbac_areaMetaData: Array<{ __typename?: 'Pbac_AreaMetaData', entityType: Pbac_EntityType, resourceLevel: { __typename?: 'Pbac_AreaMetaData_ResourceLevel', supportsPolicyUpdates: boolean }, groupLevel: { __typename?: 'Pbac_AreaMetaData_GroupLevel', supportsPolicyUpdates: boolean } }> };

export type Pbac_PermittedPartiesQueryVariables = Exact<{
  filter: Pbac_SearchForParties;
}>;


export type Pbac_PermittedPartiesQuery = { __typename?: 'Query', pbac_permittedParties: Array<{ __typename?: 'Pbac_SearchResult', partyId: number, canRead: boolean, canWrite: boolean, canDelete: boolean, canChangeAuth: boolean, party: { __typename: 'GeneralGroup', avatarUrl?: string | null, name: string } | { __typename: 'ProgrammeStageEnrollment', avatarUrl?: string | null, name: string } | { __typename: 'Staff', person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', avatarUrl?: string | null, name: string } }> };

export type Pbac_ViewResolvedAuthQueryVariables = Exact<{
  filter: Pbac_ResolvedAuthFilter;
}>;


export type Pbac_ViewResolvedAuthQuery = { __typename?: 'Query', pbac_viewResolvedAuth: { __typename?: 'Pbac_ResolvedAuth', isPbacSecured: boolean, rows: Array<{ __typename?: 'Pbac_ResolvedAuthRow', randomIdentifier: string, name: string, canRead: boolean, canWrite: boolean, canDelete: boolean, canChangeAuth: boolean, parties?: Array<{ __typename?: 'Pbac_ResolvedAuthOtherParties', partyId: number, party: { __typename: 'GeneralGroup', avatarUrl?: string | null, name: string } | { __typename: 'ProgrammeStageEnrollment', avatarUrl?: string | null, name: string } | { __typename: 'Staff', person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', avatarUrl?: string | null, name: string } } | null> | null }> } };

export type Pbac_ViewResourcePolicyQueryVariables = Exact<{
  filter: Pbac_ResourcePolicyFilter;
}>;


export type Pbac_ViewResourcePolicyQuery = { __typename?: 'Query', pbac_viewResourcePolicy: Array<{ __typename?: 'Pbac_Resource', entityType: Pbac_EntityType, entityId: string, pbacPolicyId: number, entityName: string, activeUserCanChangeAuth: boolean, overview?: { __typename?: 'Pbac_ResourceOverview', rows: Array<{ __typename?: 'Pbac_ResourceOverviewRow', partyId: number, canRead: boolean, canWrite: boolean, canDelete: boolean, canChangeAuth: boolean, editStatus: Pbac_ResourceOverviewEditEnum, hintMessage?: string | null, party: { __typename: 'GeneralGroup', avatarUrl?: string | null, name: string, partyId: number } | { __typename: 'ProgrammeStageEnrollment', avatarUrl?: string | null, name: string, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'YearGroupEnrollment', avatarUrl?: string | null, name: string, partyId: number } }> } | null, policies: Array<{ __typename?: 'Pbac_ResourcePolicy', name: string, policyType: PolicyType, parties: Array<{ __typename?: 'Pbac_ResourcePolicyParty', partyId: number, canRead: boolean, canWrite: boolean, canDelete: boolean, canChangeAuth: boolean, party: { __typename: 'GeneralGroup', avatarUrl?: string | null, name: string, partyId: number } | { __typename: 'ProgrammeStageEnrollment', avatarUrl?: string | null, name: string, partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', name: string, avatarUrl?: string | null, partyId: number } | { __typename: 'YearGroupEnrollment', avatarUrl?: string | null, name: string, partyId: number } }> }> }> };

export type Pbac_UpsertFromOverviewMutationVariables = Exact<{
  input: Pbac_UpsertFromOverview;
}>;


export type Pbac_UpsertFromOverviewMutation = { __typename?: 'Mutation', pbac_upsertFromOverview: { __typename?: 'Pbac_UpsertResourcePolicyResult', success: Pbac_UpsertResourcePolicyResultEnum, errors?: Array<{ __typename?: 'Pbac_UpsertResourcePolicyResultError', partyIds: Array<number>, errorType: Pbac_UpsertResourcePolicyResulErrorTypeEnum, message: string }> | null } };

export type Users_DeletePermissionGroupMutationVariables = Exact<{
  input: Users_DeletePermissionGroup;
}>;


export type Users_DeletePermissionGroupMutation = { __typename?: 'Mutation', users_deletePermissionGroup: { __typename?: 'Success', success?: boolean | null } };

export type SavePermissionGroupMutationVariables = Exact<{
  input?: InputMaybe<SavePermissionGroup>;
}>;


export type SavePermissionGroupMutation = { __typename?: 'Mutation', users_savePermissionGroup?: { __typename?: 'PermissionGroup', id: number } | null };

export type Users_UpdatePermissionSetMutationVariables = Exact<{
  input: Array<UpdatePermissionSet> | UpdatePermissionSet;
}>;


export type Users_UpdatePermissionSetMutation = { __typename?: 'Mutation', users_updatePermissionSet: { __typename?: 'Success', success?: boolean | null } };

export type Composite_PermissionGroupsQueryVariables = Exact<{
  filter: PermissionGroupFilter;
}>;


export type Composite_PermissionGroupsQuery = { __typename?: 'Query', composite_permissionGroups: Array<{ __typename?: 'PermissionGroup', id: number, name: string, description: string, memberType: MemberType, memberPartyIds: Array<number>, custom?: boolean | null, permissionSets: Array<{ __typename?: 'PermissionGroupPermissionSet', id: string, toggle?: boolean | null, permissionType?: PermissionType | null, feature?: Feature | null }> } | null> };

export type Users_PermissionSetsQueryVariables = Exact<{
  filter: PermissionSetFilter;
}>;


export type Users_PermissionSetsQuery = { __typename?: 'Query', users_permissionSets?: Array<{ __typename?: 'PermissionSet', id: string, name: string, description: string, permissionType?: PermissionType | null, toggle?: boolean | null, feature?: Feature | null, context?: string | null, visibleToSchools: boolean, contact: boolean, staff: boolean, student: boolean } | null> | null };

export type Ppod_EnrolmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type Ppod_EnrolmentsQuery = { __typename?: 'Query', ppod_enrolments: Array<{ __typename?: 'PPODSyncEnrolment', enrolmentId: number, dpin: number, forename?: string | null, surname?: string | null, academicYear: number, programme: string, programmeYear: number, rollClass?: string | null, enrolmentDate?: string | null, earlyLeaving?: boolean | null, earlyLeavingDate?: string | null, leavingReason?: string | null, boarding?: boolean | null, newEntrant?: boolean | null, repeat?: boolean | null }> };

export type Ppod_ExemptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type Ppod_ExemptionsQuery = { __typename?: 'Query', ppod_exemptions: Array<{ __typename?: 'PPODSyncExemption', dpin: number, forename?: string | null, surname?: string | null, exemptionId: number, exemption: string, exemptionTypeCode: number, programmeCode: number, programmeYear?: number | null, grantor?: string | null, startDate?: string | null, endDate?: string | null, comments?: string | null }> };

export type Ppod_PpodCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type Ppod_PpodCredentialsQuery = { __typename?: 'Query', ppod_PPODCredentials?: { __typename?: 'PPODCredentials', username: string, password: string, lastSyncSuccessful: boolean } | null };

export type Ppod_SavePpodCredentialsMutationVariables = Exact<{
  input: SavePpodCredentials;
}>;


export type Ppod_SavePpodCredentialsMutation = { __typename?: 'Mutation', ppod_savePPODCredentials: { __typename?: 'PPODCredentials', username: string, password: string } };

export type Users_SchoolInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type Users_SchoolInfoQuery = { __typename?: 'Query', users_schoolInfo?: { __typename?: 'SchoolInfo', id?: number | null, rollNo?: string | null, name?: string | null, email?: string | null, website?: string | null, fax?: string | null, principal?: string | null, boardingFeeFiveDay?: number | null, boardingFeeSixOrSevenDay?: number | null, schoolGender?: string | null, parentAssociation?: boolean | null, studentCouncil?: boolean | null, boardOfManagement?: boolean | null, irishClassification?: string | null, coOperatingSchoolRollNo1?: string | null, coOperatingSchoolRollNo2?: string | null, octoberReturnsContact?: string | null, octoberReturnsPhoneNo?: string | null, octoberReturnsFaxNo?: string | null, octoberReturnsEmail?: string | null, phones?: Array<{ __typename?: 'SchoolPhoneNo', phone?: string | null } | null> | null, addresses?: Array<{ __typename?: 'SchoolAddress', address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, county?: string | null, localAuthority?: string | null } | null> | null, chairPeople?: Array<{ __typename?: 'ChairPerson', chairPersonId?: number | null, forename?: string | null, surname?: string | null, phoneNo?: string | null, startDate?: string | null, endDate?: string | null } | null> | null, owners?: Array<{ __typename?: 'Owner', ownerId?: number | null, forename?: string | null, surname?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressLine4?: string | null, startDate?: string | null, endDate?: string | null } | null> | null, trustees?: Array<{ __typename?: 'Trustee', trusteeId?: number | null, forename?: string | null, surname?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, addressLine4?: string | null, startDate?: string | null, endDate?: string | null } | null> | null } | null };

export type Ppod_ShortCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type Ppod_ShortCoursesQuery = { __typename?: 'Query', ppod_shortCourses: Array<{ __typename?: 'PPODSyncShortCourse', enrolmentId: number, dpin: number, forename?: string | null, surname?: string | null, academicYear: number, shortCourseCode: number, shortCourse?: string | null, shortCourseLevelCode: number, shortCourseMediumCode: number }> };

export type Ppod_StudentsQueryVariables = Exact<{ [key: string]: never; }>;


export type Ppod_StudentsQuery = { __typename?: 'Query', ppod_students: Array<{ __typename?: 'PPODSyncStudent', dpin: number, forename?: string | null, surname?: string | null, birthCertForename?: string | null, birthCertSurname?: string | null, mothersMaidenName?: string | null, gender?: string | null, dateOfBirth?: string | null, ppsn?: string | null, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, county?: string | null, eircode?: string | null, country?: string | null, nationality?: string | null, countryOfBirth?: string | null, birthCertChecked?: boolean | null, deceased?: boolean | null, deceasedDate?: string | null }> };

export type Ppod_SubjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type Ppod_SubjectsQuery = { __typename?: 'Query', ppod_subjects: Array<{ __typename?: 'PPODSyncSubject', enrolmentId: number, dpin: number, forename?: string | null, surname?: string | null, academicYear: number, subjectCode: number, subject?: string | null, subjectLevelCode: number, subjectMediumCode: number, abInitio?: boolean | null, classGroupId?: string | null }> };

export type Ppod_SyncRequestsQueryVariables = Exact<{
  filter: SyncRequestsFilter;
}>;


export type Ppod_SyncRequestsQuery = { __typename?: 'Query', ppod_syncRequests: Array<{ __typename?: 'SyncRequest', id: number, syncRequestStatus: SyncRequestStatus, requesterPartyId: number, failureReason?: string | null, requestedOn: string, requester: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> };

export type Catalogue_ImportProgrammeDataMutationVariables = Exact<{
  input: Catalogue_ImportProgrammeData;
}>;


export type Catalogue_ImportProgrammeDataMutation = { __typename?: 'Mutation', catalogue_importProgrammeData?: { __typename?: 'Catalogue_ImportProgrammeDataResult', dryRun: boolean, programmesCreated: number, programmesUpdated: number, stagesCreated: number, stagesUpdated: number, subjectsCreated: number, subjectsAlreadyExisted: number, stageSubjectsLinked: number, stageSubjectsAlreadyLinked: number, errors: Array<{ __typename?: 'Catalogue_ImportProgrammeRowError', section: string, rowIndex: number, nationalCode?: string | null, message: string }> } | null };

export type Catalogue_ProgrammesQueryVariables = Exact<{
  filter?: InputMaybe<ProgrammeFilter>;
}>;


export type Catalogue_ProgrammesQuery = { __typename?: 'Query', catalogue_programmes: Array<{ __typename?: 'Programme', id: number, name: string, shortName?: string | null, nationalCode?: string | null, description?: string | null, discontinued: boolean, editable: boolean, stages?: Array<{ __typename?: 'ProgrammeStage', id: number, name: string, shortName?: string | null, nationalCode: string, programmeId: number, yearGroupId: number, editable: boolean, discontinued: boolean, subjects?: Array<{ __typename?: 'Subject', id: number, name: string } | null> | null }> | null }> };

export type Catalogue_UpsertProgrammeStageSubjectsMutationVariables = Exact<{
  input: Array<Catalogue_UpsertProgrammeStageSubjects> | Catalogue_UpsertProgrammeStageSubjects;
}>;


export type Catalogue_UpsertProgrammeStageSubjectsMutation = { __typename?: 'Mutation', catalogue_upsertProgrammeStageSubjects?: { __typename?: 'CatalogueSuccess', success: boolean, message?: string | null } | null };

export type Catalogue_UpsertProgrammeStageMutationVariables = Exact<{
  input: Array<Catalogue_UpsertProgrammeStage> | Catalogue_UpsertProgrammeStage;
}>;


export type Catalogue_UpsertProgrammeStageMutation = { __typename?: 'Mutation', catalogue_upsertProgrammeStage?: { __typename?: 'CatalogueSuccess', success: boolean, message?: string | null } | null };

export type Catalogue_UpsertProgrammeStagesMutationVariables = Exact<{
  input: Array<Catalogue_UpsertProgrammeStages> | Catalogue_UpsertProgrammeStages;
}>;


export type Catalogue_UpsertProgrammeStagesMutation = { __typename?: 'Mutation', catalogue_upsertProgrammeStages?: { __typename?: 'CatalogueSuccess', success: boolean, message?: string | null } | null };

export type Catalogue_UpsertProgrammeMutationVariables = Exact<{
  input: Array<Catalogue_UpsertProgramme> | Catalogue_UpsertProgramme;
}>;


export type Catalogue_UpsertProgrammeMutation = { __typename?: 'Mutation', catalogue_upsertProgramme?: { __typename?: 'CatalogueSuccess', success: boolean, message?: string | null } | null };

export type Core_UpsertRoomsMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<UpsertRoomInput>> | InputMaybe<UpsertRoomInput>>;
}>;


export type Core_UpsertRoomsMutation = { __typename?: 'Mutation', core_upsertRooms: Array<{ __typename?: 'Room', roomId: number }> };

export type Core_BuildingsQueryVariables = Exact<{
  filter?: InputMaybe<BuildingFilter>;
}>;


export type Core_BuildingsQuery = { __typename?: 'Query', core_buildings: Array<{ __typename?: 'Building', id: number, name: string, description?: string | null, campusId: number, campus: { __typename?: 'Campus', id: number, name: string } }> };

export type Core_UpsertBuildingsMutationVariables = Exact<{
  input: Array<UpsertBuildingInput> | UpsertBuildingInput;
}>;


export type Core_UpsertBuildingsMutation = { __typename?: 'Mutation', core_upsertBuildings: Array<{ __typename?: 'Building', id: number }> };

export type Core_DeleteBuildingsMutationVariables = Exact<{
  input: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type Core_DeleteBuildingsMutation = { __typename?: 'Mutation', core_deleteBuildings: { __typename?: 'Success', success?: boolean | null } };

export type Core_CampusesQueryVariables = Exact<{
  filter?: InputMaybe<CampusFilter>;
}>;


export type Core_CampusesQuery = { __typename?: 'Query', core_campuses: Array<{ __typename?: 'Campus', id: number, name: string, description?: string | null }> };

export type Core_UpsertCampusesMutationVariables = Exact<{
  input: Array<UpsertCampusInput> | UpsertCampusInput;
}>;


export type Core_UpsertCampusesMutation = { __typename?: 'Mutation', core_upsertCampuses: Array<{ __typename?: 'Campus', id: number }> };

export type Core_DeleteCampusesMutationVariables = Exact<{
  input: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type Core_DeleteCampusesMutation = { __typename?: 'Mutation', core_deleteCampuses: { __typename?: 'Success', success?: boolean | null } };

export type Core_RoomPoolsQueryVariables = Exact<{
  filter?: InputMaybe<RoomPoolFilter>;
}>;


export type Core_RoomPoolsQuery = { __typename?: 'Query', core_roomPools?: Array<{ __typename?: 'RoomPool', id: number, name: string, description?: string | null, colour: Colour, rooms: Array<{ __typename?: 'Room', roomId: number, name: string }> }> | null };

export type RoomPoolsSelectQueryVariables = Exact<{
  filter?: InputMaybe<RoomPoolFilter>;
}>;


export type RoomPoolsSelectQuery = { __typename?: 'Query', core_roomPools?: Array<{ __typename?: 'RoomPool', id: number, name: string, colour: Colour }> | null };

export type Core_UpsertRoomPoolsMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<UpsertRoomPool>> | InputMaybe<UpsertRoomPool>>;
}>;


export type Core_UpsertRoomPoolsMutation = { __typename?: 'Mutation', core_upsertRoomPools: Array<{ __typename?: 'RoomPool', id: number }> };

export type Core_RoomsQueryVariables = Exact<{
  filter?: InputMaybe<RoomFilter>;
}>;


export type Core_RoomsQuery = { __typename?: 'Query', core_rooms?: Array<{ __typename?: 'Room', roomId: number, name: string, capacity?: number | null, description?: string | null, includeInTimetable: boolean, externalSystemId?: string | null, location?: string | null, disabled: boolean, buildingId?: number | null, pools: Array<{ __typename?: 'RoomPool', id: number, name: string, description?: string | null, colour: Colour }>, building?: { __typename?: 'Building', id: number, name: string } | null }> | null };

export type CalendarDayInfoQueryVariables = Exact<{
  filter?: InputMaybe<CalendarFilter>;
}>;


export type CalendarDayInfoQuery = { __typename?: 'Query', calendar_calendar: Array<{ __typename?: 'Calendar', id: number, dayInfo: Array<{ __typename?: 'CalendarDayInfo', date: string, dayType: DayType, startTime?: string | null, description?: string | null, endTime?: string | null, periods: Array<{ __typename?: 'CalendarGridPeriodInfo', type: CalendarGridPeriodType, startTime: string, endTime: string }> }> }> };

export type CalendarGridInfoQueryVariables = Exact<{
  filter?: InputMaybe<CalendarGridFilter>;
}>;


export type CalendarGridInfoQuery = { __typename?: 'Query', calendar_grids: Array<{ __typename?: 'CalendarGrid', gridIdx: number, name: string }> };

export type UpdateClaendarDaysMutationVariables = Exact<{
  input?: InputMaybe<Calendar_UpdateDays>;
}>;


export type UpdateClaendarDaysMutation = { __typename?: 'Mutation', calendar_updateCalendarDays?: { __typename?: 'Success', success?: boolean | null } | null };

export type Sds_DeleteSdsSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type Sds_DeleteSdsSettingsMutation = { __typename?: 'Mutation', sds_deleteSDSSettings: { __typename?: 'Success', success?: boolean | null } };

export type Sds_SettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type Sds_SettingsQuery = { __typename?: 'Query', sds_settings: { __typename?: 'SDS_Settings', prefix: string, includeAcademicYear: boolean, includeClassGroups: boolean, includeYearGroups: boolean, includeNextYearsFirstYears: boolean } };

export type Sds_UpdateSdsSettingsMutationVariables = Exact<{
  input: Sds_UpdateSettingsInput;
}>;


export type Sds_UpdateSdsSettingsMutation = { __typename?: 'Mutation', sds_updateSDSSettings: { __typename?: 'Success', success?: boolean | null } };

export type CatalogueSubjectsQueryVariables = Exact<{
  filter?: InputMaybe<SubjectFilter>;
}>;


export type CatalogueSubjectsQuery = { __typename?: 'Query', catalogue_subjects: Array<{ __typename?: 'Subject', id: number, name: string, description?: string | null, shortCode: string, nationalCode?: string | null, subjectSource: SubjectSource, examinable: boolean, colour?: Colour | null, icon?: string | null, active: boolean }> };

export type Catalogue_CreateSubjectMutationVariables = Exact<{
  input?: InputMaybe<CreateSubjectInput>;
}>;


export type Catalogue_CreateSubjectMutation = { __typename?: 'Mutation', catalogue_createSubject?: { __typename?: 'Subject', id: number, name: string, shortCode: string, subjectSource: SubjectSource, active: boolean, inUseHistorically: boolean, examinable: boolean } | null };

export type Catalogue_UpdateSubjectsMutationVariables = Exact<{
  input: Array<UpdateSubject> | UpdateSubject;
}>;


export type Catalogue_UpdateSubjectsMutation = { __typename?: 'Mutation', catalogue_updateSubjects?: { __typename?: 'CatalogueSuccess', success: boolean, message?: string | null } | null };

export type SocialIntegrationLinkQueryVariables = Exact<{
  filter: SocialMediaFilter;
}>;


export type SocialIntegrationLinkQuery = { __typename?: 'Query', communications_socialIntegration: { __typename?: 'SocialIntegration', uri: string, platform: SocialPlatform } };

export type Communications_DisconnectPlatformMutationVariables = Exact<{
  input: DisconnectPlatformInput;
}>;


export type Communications_DisconnectPlatformMutation = { __typename?: 'Mutation', communications_disconnectPlatform: { __typename?: 'Success', success?: boolean | null } };

export type Catalogue_SystemSettingsUpdateMutationVariables = Exact<{
  input: Catalogue_SystemSettingsUpdates;
}>;


export type Catalogue_SystemSettingsUpdateMutation = { __typename?: 'Mutation', catalogue_systemSettingsUpdate: Array<{ __typename?: 'Catalogue_SystemSettingsUpdateResult', success: boolean, id: { __typename?: 'Catalogue_SystemSettingsId', module: string, category: string, nameId: string } }> };

export type Catalogue_SystemSettingsViewQueryVariables = Exact<{
  filter: Catalogue_SystemSettingsFilter;
}>;


export type Catalogue_SystemSettingsViewQuery = { __typename?: 'Query', catalogue_systemSettingsView: Array<{ __typename?: 'Catalogue_SystemSettings', moduleName: string, categoryName: string, label: string, labelTextId: number, description: string, fieldType: Catalogue_SystemSettingFieldType, value?: any | null, metadata?: string | null, id: { __typename?: 'Catalogue_SystemSettingsId', module: string, category: string, nameId: string }, selectValues: Array<{ __typename?: 'Catalogue_SystemSettingDropDown', label: string, value: any }> }> };

export type Users_BlockUserMutationVariables = Exact<{
  input: AccountAction;
}>;


export type Users_BlockUserMutation = { __typename?: 'Mutation', users_blockUser: { __typename?: 'Success', success?: boolean | null } };

export type Users_DeactivateProfilesMutationVariables = Exact<{
  input?: InputMaybe<DeactivateProfiles>;
}>;


export type Users_DeactivateProfilesMutation = { __typename?: 'Mutation', users_deactivateProfiles?: { __typename?: 'Success', success?: boolean | null } | null };

export type Users_InviteUsersMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<InviteUser>> | InputMaybe<InviteUser>>;
}>;


export type Users_InviteUsersMutation = { __typename?: 'Mutation', users_inviteUsers?: { __typename?: 'InviteUsersResponse', userAccesses: Array<{ __typename?: 'UserAccess', personPartyId: number, webLastLogin?: string | null, mobileLastLogin?: string | null, status?: UserAccessStatus | null, invitationId?: number | null, invitingPersonPartyId?: number | null, invitedOn?: string | null }>, validations?: Array<{ __typename?: 'UserAccessValidation', message: string, associatedUsers: Array<string> } | null> | null } | null };

export type Users_ProvisionMicrosoftEntraIdsMutationVariables = Exact<{
  input?: InputMaybe<Users_ProvisionMicroSoftEntraIdsInput>;
}>;


export type Users_ProvisionMicrosoftEntraIdsMutation = { __typename?: 'Mutation', users_provisionMicrosoftEntraIds?: { __typename?: 'Success', success?: boolean | null } | null };

export type Users_DeleteThirdPartyAccountMutationVariables = Exact<{
  input?: InputMaybe<Users_DeleteThirdPartyAccountInput>;
}>;


export type Users_DeleteThirdPartyAccountMutation = { __typename?: 'Mutation', users_deleteThirdPartyAccount?: { __typename?: 'Success', success?: boolean | null } | null };

export type Users_ThirdPartiesQueryVariables = Exact<{ [key: string]: never; }>;


export type Users_ThirdPartiesQuery = { __typename?: 'Query', users_thirdParties: Array<{ __typename?: 'Users_ThirdParty', id?: number | null, type: ThirdPartyUserType, createdBy: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> };

export type Users_ProvisionThirdPartyAccountMutationVariables = Exact<{
  input?: InputMaybe<Users_ProvisionThirdPartyInput>;
}>;


export type Users_ProvisionThirdPartyAccountMutation = { __typename?: 'Mutation', users_provisionThirdPartyAccount?: { __typename?: 'Users_ThirdPartyProvisionResponse', secret?: string | null } | null };

export type Core_UpdateStudentMutationVariables = Exact<{
  input: Array<UpdateStudentInput> | UpdateStudentInput;
}>;


export type Core_UpdateStudentMutation = { __typename?: 'Mutation', core_updateStudents?: { __typename?: 'Success', success?: boolean | null } | null };

export type Users_UserAccessQueryVariables = Exact<{
  filter?: InputMaybe<UserAccessFilter>;
}>;


export type Users_UserAccessQuery = { __typename?: 'Query', users_userAccess: Array<{ __typename?: 'UserAccess', globalUserId?: number | null, invitedEmail?: string | null, profileId: number, personPartyId: number, avatarUrl?: string | null, webLastLogin?: string | null, mobileLastLogin?: string | null, status?: UserAccessStatus | null, invitedOn?: string | null, mobileAppVersion?: string | null, microsoftEntraId?: string | null, blocked: boolean, personalInfo: { __typename?: 'PersonalInformation', firstName: string, lastName: string, primaryEmail?: { __typename?: 'EmailAddress', email?: string | null } | null, primaryPhoneNumber?: { __typename?: 'PhoneNumber', number?: string | null, areaCode?: string | null, countryCode?: string | null } | null }, contactStudents?: Array<{ __typename?: 'Person', firstName?: string | null, lastName?: string | null } | null> | null, contactInfo?: Array<{ __typename?: 'UserAccess_Contact_Info', priority?: string | null, relationship?: string | null, classGroup?: string | null } | null> | null, yearGroup?: { __typename?: 'YearGroupEnrollment', shortName: string } | null, yearGroupContacts?: Array<{ __typename?: 'YearGroupEnrollment', shortName: string } | null> | null }> };

export type Communications_PurchaseAddOnMutationVariables = Exact<{
  input?: InputMaybe<PurchaseAddOnInput>;
}>;


export type Communications_PurchaseAddOnMutation = { __typename?: 'Mutation', communications_purchaseAddOn: { __typename?: 'Success', success?: boolean | null } };

export type Communications_ScheduledSmsQueryVariables = Exact<{
  filter?: InputMaybe<ScheduledSmsFilter>;
}>;


export type Communications_ScheduledSmsQuery = { __typename?: 'Query', communications_scheduledSms: Array<{ __typename?: 'ScheduledSms', id: number, body: string, sendAt: string, canReply: boolean, totalCost: number, sender: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, recipients: Array<{ __typename?: 'ScheduledSmsRecipient', id: number, scheduledSmsId: number, recipientPartyId: number, smsRecipientType: SmsRecipientType, party: { __typename: 'GeneralGroup', partyId: number, generalGroupType: GeneralGroupType, name: string, classGroupInfo?: { __typename: 'ClassGroupInfo' } | null } | { __typename: 'ProgrammeStageEnrollment', partyId: number, name: string } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'StudentContact', partyId: number, person: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'SubjectGroup', partyId: number, actualName: string, name: string, avatarUrl?: string | null } | { __typename: 'YearGroupEnrollment', partyId: number, name: string } }> }> };

export type SendSmsMutationVariables = Exact<{
  input?: InputMaybe<SendSmsInput>;
}>;


export type SendSmsMutation = { __typename?: 'Mutation', communications_sendSms?: string | null };

export type Communications_SmsQueryVariables = Exact<{
  filter?: InputMaybe<SmsFilter>;
}>;


export type Communications_SmsQuery = { __typename?: 'Query', communications_sms: Array<{ __typename?: 'Sms', id: number, name: string, body: string, sentOn: string, canReply: boolean, numRecipients: number, totalCost: number, sender: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, recipients: Array<{ __typename?: 'SmsRecipient', recipientPhoneNumber: string, smsStatus: SmsStatus, id?: { __typename?: 'SmsRecipientId', tenant: number, smsId: number, recipientPartyId: number } | null, recipient?: { __typename?: 'Person', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null }> }> };

export type Communications_CurrentBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type Communications_CurrentBalanceQuery = { __typename?: 'Query', communications_currentBalance?: { __typename?: 'SmsCurrentBalance', currentBalance: number } | null };

export type Communications_SmsCostQueryVariables = Exact<{
  filter?: InputMaybe<SmsCostFilter>;
}>;


export type Communications_SmsCostQuery = { __typename?: 'Query', communications_smsCost?: { __typename?: 'SmsCost', total?: number | null } | null };

export type Communications_DeleteScheduledSmsMutationVariables = Exact<{
  input: DeleteScheduledSmsInput;
}>;


export type Communications_DeleteScheduledSmsMutation = { __typename?: 'Mutation', communications_deleteScheduledSms: { __typename?: 'Success', success?: boolean | null } };

export type Options_CloneMutationVariables = Exact<{
  input: Options_Clone;
}>;


export type Options_CloneMutation = { __typename?: 'Mutation', options_clone: { __typename?: 'Success', success?: boolean | null } };

export type Options_DeleteMutationVariables = Exact<{
  input: DeleteOption;
}>;


export type Options_DeleteMutation = { __typename?: 'Mutation', options_delete: { __typename?: 'Success', success?: boolean | null } };

export type Print_OptionsMailQueryVariables = Exact<{
  filter: Print_OptionsMail;
}>;


export type Print_OptionsMailQuery = { __typename?: 'Query', print_optionsMail: { __typename?: 'Success', success?: boolean | null } };

export type Options_ClmQueryVariables = Exact<{
  filter: Options_ClmFilter;
}>;


export type Options_ClmQuery = { __typename?: 'Query', options_clm: { __typename?: 'Options_CLM', blockIdx: number, subjectGroups: Array<{ __typename?: 'Options_SubjectGroupMembership', id: number, subjectGroupName: string, students: Array<{ __typename?: 'Student', classGroup?: { __typename?: 'GeneralGroup', name: string } | null, personalInformation?: { __typename?: 'PersonalInformation', gender?: Gender | null } | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }> } };

export type OptionsSol_UpsertSubjectGroupMembershipsMutationVariables = Exact<{
  input: OptionsSol_UpsertSubjectGroupMembership;
}>;


export type OptionsSol_UpsertSubjectGroupMembershipsMutation = { __typename?: 'Mutation', optionsSol_upsertSubjectGroupMemberships: { __typename?: 'Success', success?: boolean | null } };

export type Options_AvailableEnrollmentGroupsQueryVariables = Exact<{
  filter?: InputMaybe<Options_AvailableGroupsFilter>;
}>;


export type Options_AvailableEnrollmentGroupsQuery = { __typename?: 'Query', options_availableEnrollmentGroups: Array<{ __typename?: 'Options_AvailableGroups', name: string, id: string }> };

export type Options_EnrollmentGroupsStudentsQueryVariables = Exact<{
  filter?: InputMaybe<Options_AvailableGroupsFilter>;
}>;


export type Options_EnrollmentGroupsStudentsQuery = { __typename?: 'Query', options_availableEnrollmentGroups: Array<{ __typename?: 'Options_AvailableGroups', name: string, id: string, students: Array<{ __typename?: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null }> }> };

export type Options_PreferencesQueryVariables = Exact<{
  filter?: InputMaybe<Options_PreferencesFilter>;
}>;


export type Options_PreferencesQuery = { __typename?: 'Query', options_preferences: Array<{ __typename?: 'Options_StudentPreference', id: { __typename?: 'Options_PreferenceId', optionId: number, studentPartyId: number }, student: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null }, choices: Array<{ __typename?: 'Options_StudentChoice', id: { __typename?: 'Options_ChoiceId', subjectSetIdx: number, preferenceIdx: number }, subject: { __typename?: 'Subject', id: number, name: string, shortCode: string, colour?: Colour | null } }> }> };

export type Options_SolutionsQueryVariables = Exact<{
  filter?: InputMaybe<Options_OptionIdFilter>;
}>;


export type Options_SolutionsQuery = { __typename?: 'Query', options_solutions: { __typename?: 'Options_Solution', optionId: number, solverStatus: SolutionStatus, minSubjectsPerBlock?: number | null, pools: Array<{ __typename?: 'Options_SolutionPool', poolIdx: number, blocks: Array<{ __typename?: 'Options_Block', blockIdx: number, subjectGroups: Array<{ __typename?: 'Options_SubjectGroup', id: number, poolIdx: number, blockIdx: number, name: string, subjectId: number, numStudents: number, pinned: boolean, subject: { __typename?: 'Subject', name: string, shortCode: string, colour?: Colour | null } }> }>, subjectSets: Array<{ __typename?: 'Options_SolutionSubjectSet', mustGet: number, id: { __typename?: 'Options_OptionsId', optionId: number, idx: number }, studentChoices: Array<{ __typename?: 'Options_StudentChoices', studentPartyId: number, subjectsAllocated: number, reservedUsed: number, subjectSetChoices: Array<{ __typename?: 'Options_Choice', choiceIdx: number, blockIdx?: number | null, subjectId?: number | null, subjectGroupName?: string | null, subject?: { __typename?: 'Subject', name: string, shortCode: string, colour?: Colour | null } | null }> }> }>, subjects: Array<{ __typename?: 'Options_SolutionSubject', poolIdx: number, subjectId: number, maxSize: number, numClasses: number, numPreferences: number, missed: number, maxPerBlock?: number | null, subject: { __typename?: 'Subject', name: string, shortCode: string, colour?: Colour | null } }> }> } };

export type Options_OptionsQueryVariables = Exact<{
  filter?: InputMaybe<Options_OptionFilter>;
}>;


export type Options_OptionsQuery = { __typename?: 'Query', options_options: Array<{ __typename?: 'Options_Option', id: number, name: string, publishedToParents: boolean, parentsDueByDate?: string | null, parentsDescription?: string | null, studentCount: number, studentPreferencesCompleteCount: number, yearGroup: { __typename?: 'YearGroup', name: string } }> };

export type OptionsSetupQueryVariables = Exact<{
  filter?: InputMaybe<Options_OptionFilter>;
}>;


export type OptionsSetupQuery = { __typename?: 'Query', options_options: Array<{ __typename?: 'Options_Option', id: number, name: string, yearGroup: { __typename?: 'YearGroup', yearGroupId: number, name: string }, students?: Array<{ __typename?: 'Student', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, classGroup?: { __typename?: 'GeneralGroup', name: string } | null }> | null, subjectSets: Array<{ __typename?: 'Options_OptionSubjectSet', name: string, canChoose: number, mustGet: number, poolIdx?: number | null, id: { __typename?: 'Options_OptionsId', optionId: number, idx: number }, subjects: Array<{ __typename?: 'Subject', id: number, name: string, shortCode: string, colour?: Colour | null }> }> }> };

export type PrintOptionsGroupMembersQueryVariables = Exact<{
  filter: Print_StudentOptionsMembers;
}>;


export type PrintOptionsGroupMembersQuery = { __typename?: 'Query', print_optionsGroupMembers: { __typename?: 'TemporaryDownload', url?: string | null, html?: string | null } };

export type Options_PublishMutationVariables = Exact<{
  input: Options_OptionsPublish;
}>;


export type Options_PublishMutation = { __typename?: 'Mutation', options_publish: { __typename?: 'Success', success?: boolean | null } };

export type Options_SaveOptionsMutationVariables = Exact<{
  input: Options_SaveOptions;
}>;


export type Options_SaveOptionsMutation = { __typename?: 'Mutation', options_saveOptions: { __typename?: 'Options_Option', id: number, validations?: Array<string> | null } };

export type OptionsSol_ModifySolutionSettingsMutationVariables = Exact<{
  input: OptionsSol_ModifySolutionSettings;
}>;


export type OptionsSol_ModifySolutionSettingsMutation = { __typename?: 'Mutation', optionsSol_modifySolutionSettings: { __typename?: 'Success', success?: boolean | null } };

export type Options_SaveStudentPreferencesMutationVariables = Exact<{
  input: Array<InputMaybe<Options_SaveStudentPreference>> | InputMaybe<Options_SaveStudentPreference>;
}>;


export type Options_SaveStudentPreferencesMutation = { __typename?: 'Mutation', options_saveStudentPreferences: { __typename?: 'Success', success?: boolean | null } };

export type OptionsSol_FillInOptionsMutationVariables = Exact<{
  input: Options_OptionIdFilter;
}>;


export type OptionsSol_FillInOptionsMutation = { __typename?: 'Mutation', optionsSol_fillInOptions: { __typename?: 'Success', success?: boolean | null } };

export type OptionsSol_SolveMutationVariables = Exact<{
  input: OptionsSol_Solve;
}>;


export type OptionsSol_SolveMutation = { __typename?: 'Mutation', optionsSol_solve: { __typename?: 'Options_Solve', problemId?: string | null } };

export type OptionsSol_BlocksQueryVariables = Exact<{
  filter?: InputMaybe<Options_OptionFilter>;
}>;


export type OptionsSol_BlocksQuery = { __typename?: 'Query', optionsSol_blocks: { __typename?: 'OptionsSol_SubjectSetBlocks', subjectSet: Array<{ __typename?: 'OptionsSol_SubjectSetBlock', blocks: Array<{ __typename?: 'OptionsSol_Block', blockIdx: number, name?: string | null, subjectGroups: Array<{ __typename?: 'OptionsSol_SubjectGroup', id: number, poolIdx: number, blockIdx: number, name: string, subjectId: string, numStudents: number, pinned: boolean, subject: { __typename?: 'Subject', name: string, shortCode: string, colour?: Colour | null } }> }>, subjectSet: { __typename?: 'Options_OptionSubjectSet', name: string, poolIdx?: number | null, id: { __typename?: 'Options_OptionsId', optionId: number, idx: number } } } | null> } };

export type OptionsSol_SubjectStatsQueryVariables = Exact<{
  filter?: InputMaybe<Options_OptionFilter>;
}>;


export type OptionsSol_SubjectStatsQuery = { __typename?: 'Query', optionsSol_subjectStats: Array<{ __typename?: 'OptionsSol_Subject', subjectId: number, maxSize: number, preferencesTotal: number, preferencesGotten: number, subject: { __typename?: 'Subject', name: string, shortCode: string, colour?: Colour | null }, teachingGroups: Array<{ __typename?: 'OptionsSol_SubjectGroup', id: number, poolIdx: number, blockIdx: number, name: string, numStudents: number }> }> };

export type Options_SolverInputQueryVariables = Exact<{
  filter?: InputMaybe<Options_OptionIdFilter>;
}>;


export type Options_SolverInputQuery = { __typename?: 'Query', options_solverInput: { __typename?: 'Options_SolverInput', input: any } };

export type Swm_AbsenceRequestsQueryVariables = Exact<{
  filter?: InputMaybe<Swm_StaffAbsenceRequestFilter>;
}>;


export type Swm_AbsenceRequestsQuery = { __typename?: 'Query', swm_absenceRequests: Array<{ __typename?: 'SWM_StaffAbsenceRequest', staffAbsenceRequestId: number, status?: Swm_StaffAbsenceRequestStatusEnum | null, createdAt: string, absenceNoteText?: string | null, rejectionReasonText?: string | null, attachments?: Array<string> | null, staff?: { __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | null, dates: Array<{ __typename?: 'SWM_StaffAbsenceDate', continuousStartDate?: string | null, continuousEndDate?: string | null, individualDates?: Array<string> | null, partialAbsence: boolean, leavesAt?: string | null, returnsAt?: string | null }>, absenceType?: { __typename?: 'SWM_StaffAbsenceType', absenceTypeId: number, name: string, code: string } | null, completedBy?: { __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | null }> };

export type Swm_CountAbsenceRequestsQueryVariables = Exact<{
  filter?: InputMaybe<Swm_StaffAbsenceRequestCounterFilter>;
}>;


export type Swm_CountAbsenceRequestsQuery = { __typename?: 'Query', swm_countAbsenceRequests: { __typename?: 'SWM_StaffAbsenceRequestCounterResult', count: number } };

export type Swm_UpsertAbsenceRequestMutationVariables = Exact<{
  input: Swm_UpsertStaffAbsenceRequest;
}>;


export type Swm_UpsertAbsenceRequestMutation = { __typename?: 'Mutation', swm_upsertAbsenceRequest: { __typename?: 'SWM_StaffAbsenceRequest', staffAbsenceRequestId: number } };

export type Swm_ChangeAbsenceRequestStatusMutationVariables = Exact<{
  input?: InputMaybe<Swm_ChangeStaffAbsenceRequestStatus>;
}>;


export type Swm_ChangeAbsenceRequestStatusMutation = { __typename?: 'Mutation', swm_changeAbsenceRequestStatus: Array<{ __typename?: 'SWM_StaffAbsenceRequest', staffAbsenceRequestId: number }> };

export type Swm_ApplySubstitutionsMutationVariables = Exact<{
  input: Swm_InsertSubstitution;
}>;


export type Swm_ApplySubstitutionsMutation = { __typename?: 'Mutation', swm_applySubstitutions: { __typename?: 'Success', success?: boolean | null } };

export type Swm_SendCoverNotificationsMutationVariables = Exact<{
  input: Swm_SendNotifications;
}>;


export type Swm_SendCoverNotificationsMutation = { __typename?: 'Mutation', swm_sendCoverNotifications: { __typename?: 'Success', success?: boolean | null } };

export type Tt_RefreshGridMutationVariables = Exact<{ [key: string]: never; }>;


export type Tt_RefreshGridMutation = { __typename?: 'Mutation', tt_refreshGrid: { __typename?: 'Success', success?: boolean | null } };

export type Swm_DeleteSubstitutionsMutationVariables = Exact<{
  input: Swm_DeleteSubstitution;
}>;


export type Swm_DeleteSubstitutionsMutation = { __typename?: 'Mutation', swm_deleteSubstitutions: { __typename?: 'Success', success?: boolean | null } };

export type Swm_AbsenceTypesQueryVariables = Exact<{
  filter?: InputMaybe<Swm_StaffAbsenceTypeFilter>;
}>;


export type Swm_AbsenceTypesQuery = { __typename?: 'Query', swm_absenceTypes: Array<{ __typename?: 'SWM_StaffAbsenceType', absenceTypeId: number, name: string, nameTextId?: number | null, description?: string | null, descriptionTextId?: number | null, code: string, availableForRequests: boolean, dcsCodeId?: number | null, dcsCode?: string | null }> };

export type Swm_UpsertAbsenceTypeMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<Swm_UpsertStaffAbsenceType>> | InputMaybe<Swm_UpsertStaffAbsenceType>>;
}>;


export type Swm_UpsertAbsenceTypeMutation = { __typename?: 'Mutation', swm_upsertAbsenceType: Array<{ __typename?: 'SWM_StaffAbsenceType', absenceTypeId: number }> };

export type Swm_DcsCodesQueryVariables = Exact<{
  filter?: InputMaybe<Swm_DcsCodeFilter>;
}>;


export type Swm_DcsCodesQuery = { __typename?: 'Query', swm_dcsCodes: Array<{ __typename?: 'SWM_DcsCode', id: number, code: string }> };

export type Swm_AbsencesQueryVariables = Exact<{
  filter?: InputMaybe<Swm_StaffAbsenceFilter>;
}>;


export type Swm_AbsencesQuery = { __typename?: 'Query', swm_absences: Array<{ __typename?: 'SWM_StaffAbsence', absenceId: number, absenceTypeId: number, staffPartyId: number, isLongTermLeave: boolean, longTermLeaveGroupsRequired?: number | null, longTermLeaveGroupsApplied?: number | null, absenceReasonText?: string | null, substitutionRequired?: boolean | null, absenceType: { __typename?: 'SWM_StaffAbsenceType', absenceTypeId: number, name: string, code: string }, staff?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null, dates: Array<{ __typename?: 'SWM_StaffAbsenceDate', continuousStartDate?: string | null, continuousEndDate?: string | null, individualDates?: Array<string> | null, partialAbsence: boolean, leavesAt?: string | null, returnsAt?: string | null }>, longTermLeaveGroups: Array<{ __typename?: 'SWM_StaffAbsenceLongTermLeaveGroup', groupId: number, coveringStaffId?: number | null, group: { __typename?: 'GeneralGroup', name: string, avatarUrl?: string | null } | { __typename?: 'ProgrammeStageEnrollment', name: string, avatarUrl?: string | null } | { __typename?: 'SubjectGroup', name: string, avatarUrl?: string | null } | { __typename?: 'YearGroupEnrollment', name: string, avatarUrl?: string | null }, coveringStaff?: { __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | null }> }> };

export type Swm_UpsertAbsenceMutationVariables = Exact<{
  input: Swm_UpsertStaffAbsences;
}>;


export type Swm_UpsertAbsenceMutation = { __typename?: 'Mutation', swm_upsertAbsence: { __typename?: 'SWM_UpsertStaffAbsencesResponse', wasApplied: boolean, wrongYear?: boolean | null, substitutionsPresent: Array<{ __typename?: 'CalendarEvent', eventId: number, name: string, startTime: string, endTime: string, exclusions: Array<{ __typename?: 'CalendarEventAttendee', partyInfo?: { __typename: 'GeneralGroup', partyId: number } | { __typename: 'ProgrammeStageEnrollment', partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number } | { __typename: 'StudentContact', partyId: number } | { __typename: 'SubjectGroup', partyId: number } | { __typename: 'YearGroupEnrollment', partyId: number } | null }> }> } };

export type Swm_DeleteAbsenceMutationVariables = Exact<{
  input: Swm_DeleteStaffAbsence;
}>;


export type Swm_DeleteAbsenceMutation = { __typename?: 'Mutation', swm_deleteAbsence: { __typename?: 'Success', success?: boolean | null } };

export type Swm_SubstitutionLookupQueryVariables = Exact<{
  filter?: InputMaybe<Swm_SubstitutionLookupFilter>;
}>;


export type Swm_SubstitutionLookupQuery = { __typename?: 'Query', swm_substitutionLookup: { __typename?: 'SWM_SubstitutionLookup', staff: Array<{ __typename?: 'SWM_SubstitutionLookupStaff', available: boolean, clashingEvents?: Array<string> | null, staff: { __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, competencySubjects: Array<{ __typename?: 'Subject', id: number, name: string, colour?: Colour | null }>, extensions?: { __typename?: 'StaffGraphqlExtension', timetableSummary?: { __typename?: 'TT_TeacherTimetableSummary', fulltimePeriods: number } | null, substitutionSummary?: { __typename?: 'SWM_SubstitutionSummary', substitutionCountThisWeek: number, substitutionTimeThisWeekMinutes: number, substitutionCountThisYear: number, substitutionTimeThisYearMinutes: number } | null } | null, employmentCapacity?: { __typename?: 'StaffCapacity', id: string, name: string } | null }, substitutionStats: { __typename?: 'SWM_SubstitutionSummaryForWeek', sandsWeekCount: number, sandsWeekMinutes: number, sandsYearCount: number, sandsYearMinutes: number, casualWeekCount: number, casualWeekMinutes: number, emer35WeekCount: number, emer35YearCount: number, emer35WeekMinutes: number, emer35YearMinutes: number, windfallWeekCount: number, windfallWeekMinutes: number, windfallYearCount: number, windfallYearMinutes: number } }>, freeRooms: Array<{ __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string, colour: Colour }> }>, clashingRooms: Array<{ __typename?: 'ClashingRooms', clash: Array<string>, room: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string, colour: Colour }> } }> } };

export type Swm_EventsForSubstitutionsByStaffByPeriodQueryVariables = Exact<{
  filter?: InputMaybe<Swm_EventsForSubstitutionFilter>;
}>;


export type Swm_EventsForSubstitutionsByStaffByPeriodQuery = { __typename?: 'Query', swm_eventsForSubstitutionsByStaffByPeriod: { __typename?: 'SWM_StaffSubstitutionEventByDay', eventsByStaff: Array<{ __typename?: 'SWM_EventsForSubstitutionStaff', staff: { __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }, substitutionEventsByDay: Array<{ __typename?: 'SWM_EventsForSubstitutionStaffByDay', dayInfo: { __typename?: 'CalendarDayInfo', date: string, startTime?: string | null, endTime?: string | null, dayType: DayType, periods: Array<{ __typename?: 'CalendarGridPeriodInfo', startTime: string, endTime: string, type: CalendarGridPeriodType }>, gridPeriods: Array<{ __typename?: 'CalendarGridPeriodsInfo', gridIdx: number, name: string, periods: Array<{ __typename?: 'CalendarGridPeriodInfo', startTime: string, endTime: string, type: CalendarGridPeriodType, name?: string | null, periodIdx?: number | null }> }> }, requireSubstitutionReason?: { __typename?: 'SWM_RequireSubstitutionDetails', reason?: string | null, note?: string | null } | null, substitutionEventsByPeriod: Array<{ __typename?: 'SWM_CalendarSubstitutionPeriod', eventSubstitutions: Array<{ __typename?: 'SWM_CalendarSubstitution', ignored?: boolean | null, ignoredNote?: string | null, absenceId?: number | null, staffPartyId: number, key: { __typename?: 'SWM_CalendarSubstitutionKey', eventId: number, date: string, absentStaffId: number }, coverTeacherDuplicatedAtSameTime?: Array<{ __typename?: 'SWM_CalendarSubstitution', staffPartyId: number, event: { __typename?: 'CalendarEvent', eventId: number, startTime: string, endTime: string, type: CalendarEventType, gridIdx?: number | null, periodIdx?: number | null, allDayEvent: boolean, colour?: Colour | null, name: string, description?: string | null, attendees: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', partyId: number } | { __typename: 'ProgrammeStageEnrollment', partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number } | { __typename: 'StudentContact', partyId: number } | { __typename: 'SubjectGroup', subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', partyId: number } | null }>, rooms: Array<{ __typename?: 'Room', name: string, roomId: number }>, tags: Array<{ __typename?: 'CalendarTag', label: string, context: Calendar_TagContext }>, cancellations: Array<{ __typename?: 'Calendar_EventCancelled', id: number, contextId: string, context: Calendar_CancellationContext, reason?: string | null, note?: string | null }> }, substitution?: { __typename?: 'SWM_Substitution', substitutionId?: number | null, note?: string | null, originalStaff: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, substituteStaff: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, substitutionType: { __typename?: 'SWM_SubstitutionType', substitutionTypeId: number, name: string, description?: string | null, code: string }, substituteRoom?: { __typename?: 'Room', name: string, roomId: number } | null } | null }> | null, event: { __typename?: 'CalendarEvent', eventId: number, startTime: string, endTime: string, type: CalendarEventType, allDayEvent: boolean, gridIdx?: number | null, colour?: Colour | null, name: string, description?: string | null, attendees: Array<{ __typename?: 'CalendarEventAttendee', partyId: number, type: CalendarEventAttendeeType, partyInfo?: { __typename: 'GeneralGroup', partyId: number } | { __typename: 'ProgrammeStageEnrollment', partyId: number } | { __typename: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | { __typename: 'Student', partyId: number } | { __typename: 'StudentContact', partyId: number } | { __typename: 'SubjectGroup', subjectGroupType: SubjectGroupType, partyId: number } | { __typename: 'YearGroupEnrollment', partyId: number } | null }>, rooms: Array<{ __typename?: 'Room', name: string, roomId: number }>, tags: Array<{ __typename?: 'CalendarTag', label: string, context: Calendar_TagContext }>, cancellations: Array<{ __typename?: 'Calendar_EventCancelled', id: number, contextId: string, context: Calendar_CancellationContext, reason?: string | null, note?: string | null }> }, substitution?: { __typename?: 'SWM_Substitution', substitutionId?: number | null, note?: string | null, originalStaff: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, substituteStaff: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null }, substitutionType: { __typename?: 'SWM_SubstitutionType', substitutionTypeId: number, name: string, description?: string | null, code: string }, substituteRoom?: { __typename?: 'Room', name: string, roomId: number } | null } | null, linkedEvents: Array<{ __typename?: 'SWM_LinkedEvents', context: Swm_AlsoApplyToEventContext, event: { __typename?: 'CalendarEvent', eventId: number, name: string, startTime: string } }> }> }> }> }> } };

export type Swm_SubstitutionTypesQueryVariables = Exact<{
  filter?: InputMaybe<Swm_StaffSubstitutionTypeFilter>;
}>;


export type Swm_SubstitutionTypesQuery = { __typename?: 'Query', swm_substitutionTypes: Array<{ __typename?: 'SWM_SubstitutionType', substitutionTypeId: number, name: string, description?: string | null, code: string }> };

export type DeleteAssessmentTemplateMutationVariables = Exact<{
  input: DeleteFileTransferInput;
}>;


export type DeleteAssessmentTemplateMutation = { __typename?: 'Mutation', delete_file_transfer?: { __typename?: 'Success', success?: boolean | null } | null };

export type DeleteTemplateMutationVariables = Exact<{
  input?: InputMaybe<Templating_DeleteTemplateInput>;
}>;


export type DeleteTemplateMutation = { __typename?: 'Mutation', templating_deleteTemplates: { __typename?: 'Success', success?: boolean | null } };

export type Templating_GetTemplateDownloadUrlQueryVariables = Exact<{
  templateId?: InputMaybe<Scalars['Long']['input']>;
}>;


export type Templating_GetTemplateDownloadUrlQuery = { __typename?: 'Query', templating_getTemplateDownloadUrl: { __typename?: 'Templating_ResolvedTemplate', temporaryUrl?: string | null } };

export type ResolveTemplateQueryVariables = Exact<{
  filter?: InputMaybe<Templating_ResolveTemplateInput>;
}>;


export type ResolveTemplateQuery = { __typename?: 'Query', templating_resolveTemplate: { __typename?: 'Templating_ResolvedTemplate', temporaryUrl?: string | null, html?: string | null } };

export type Templating_SaveTemplateMutationVariables = Exact<{
  input?: InputMaybe<Templating_SaveTemplateInput>;
}>;


export type Templating_SaveTemplateMutation = { __typename?: 'Mutation', templating_saveTemplate: { __typename?: 'Success', success?: boolean | null } };

export type SchoolInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type SchoolInfoQuery = { __typename?: 'Query', users_schoolInfo?: { __typename?: 'SchoolInfo', id?: number | null, name?: string | null, addresses?: Array<{ __typename?: 'SchoolAddress', address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, county?: string | null, localAuthority?: string | null } | null> | null } | null };

export type GetTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<Templating_TemplateFilter>;
}>;


export type GetTemplatesQuery = { __typename?: 'Query', templating_getTemplates: Array<{ __typename?: 'Templating_Template', id: number, name: string, createdByPartyId?: number | null, createdOn?: string | null, template?: string | null, draft?: boolean | null, context: TemplatingContextType, area: TemplatingArea, format?: TemplateFormat | null, docxFileName?: string | null, createdBy?: { __typename?: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } } | null }> };

export type GetVariablesQueryVariables = Exact<{
  filter?: InputMaybe<Templating_VariablesFilter>;
}>;


export type GetVariablesQuery = { __typename?: 'Query', templating_getVariables: Array<{ __typename?: 'Templating_Variable', id: number, name: string, value: string, context: TemplatingContextType, category?: string | null, nested: boolean }> };

export type TtBlocksQueryVariables = Exact<{
  filter: Tt_BlockFilter;
}>;


export type TtBlocksQuery = { __typename?: 'Query', tt_blocks: Array<{ __typename?: 'TT_Block', blockId: string, name: string, shortName: string, ttClassGroupIds: Array<number> }> };

export type TtClassGroupsQueryVariables = Exact<{
  filter: Tt_ClassGroupsFilter;
}>;


export type TtClassGroupsQuery = { __typename?: 'Query', tt_classGroups: Array<{ __typename?: 'TT_ClassGroup', ttClassGroupId: number, partyId?: number | null, name: string, code: string, groupTagIds: Array<number>, groupTags: Array<{ __typename?: 'GroupTag', id: number, name: string }> }> };

export type Tt_UpsertClassGroupMutationVariables = Exact<{
  input: Tt_UpsertClassGroup;
}>;


export type Tt_UpsertClassGroupMutation = { __typename?: 'Mutation', tt_upsertClassGroup: { __typename?: 'Success', success?: boolean | null } };

export type Tt_DeleteClassGroupMutationVariables = Exact<{
  input: Tt_DeleteClassGroups;
}>;


export type Tt_DeleteClassGroupMutation = { __typename?: 'Mutation', tt_deleteClassGroup: { __typename?: 'Success', success?: boolean | null } };

export type Tt_CoScheduleChainsQueryVariables = Exact<{
  filter: Tt_CoScheduleChainsFilter;
}>;


export type Tt_CoScheduleChainsQuery = { __typename?: 'Query', tt_coScheduleChains: Array<{ __typename?: 'TT_CoScheduleChain', chainId: string, groups: Array<{ __typename?: 'TT_Groups', timetableGroupId: number, name: string, subject?: { __typename?: 'Subject', colour?: Colour | null } | null }> }> };

export type Tt_GridsQueryVariables = Exact<{
  filter: TtGridFilter;
}>;


export type Tt_GridsQuery = { __typename?: 'Query', tt_grids: Array<{ __typename?: 'TTGrid', idx: number, name: string, timetableId: number, description?: string | null, appliesToGroupTagIds: Array<number>, appliesToGroupTags: Array<{ __typename?: 'GroupTag', id: number, name: string }>, days: Array<{ __typename?: 'TTGridDay', dayOfWeek: number, idx: number, halfDayAfterPeriod: number, periods: Array<{ __typename?: 'TTGridPeriod', idx: number, name: string, startTime: string, endTime: string, type: TtGridPeriodType }> }> }> };

export type Tt_GridListQueryVariables = Exact<{
  filter: TtGridFilter;
}>;


export type Tt_GridListQuery = { __typename?: 'Query', tt_grids: Array<{ __typename?: 'TTGrid', idx: number, name: string }> };

export type Tt_MigrateGridMutationVariables = Exact<{
  input: Tt_MigrateGrid;
}>;


export type Tt_MigrateGridMutation = { __typename?: 'Mutation', tt_migrateGrid: { __typename?: 'Success', success?: boolean | null } };

export type Tt_AddPeriodToStartMutationVariables = Exact<{
  input: Tt_AddPeriodsToStart;
}>;


export type Tt_AddPeriodToStartMutation = { __typename?: 'Mutation', tt_addPeriodToStart: { __typename?: 'Success', success?: boolean | null } };

export type Tt_AddPeriodToEndMutationVariables = Exact<{
  input: Tt_AddPeriodsToEnd;
}>;


export type Tt_AddPeriodToEndMutation = { __typename?: 'Mutation', tt_addPeriodToEnd: { __typename?: 'Success', success?: boolean | null } };

export type Tt_SplitPeriodMutationVariables = Exact<{
  input: Tt_SplitPeriods;
}>;


export type Tt_SplitPeriodMutation = { __typename?: 'Mutation', tt_splitPeriod: { __typename?: 'Success', success?: boolean | null } };

export type Tt_PublishHistoryQueryVariables = Exact<{
  filter?: InputMaybe<TtTimetableFilter>;
}>;


export type Tt_PublishHistoryQuery = { __typename?: 'Query', tt_timetable: { __typename?: 'TTTimetable', timetableId: number, liveStatus?: { __typename?: 'TT_LiveStatus', publishHistory: Array<{ __typename?: 'TT_Published', datetime: string, lessonChanges: number, timetableGroupChanges: number, publishedByPartyId?: number | null, publishedByName?: string | null, changes: Array<{ __typename?: 'TT_PublishChange', entityType: Tt_PublishChangeEntityType, changeType: Tt_DiffType, entityId: string, name: string, changedByPartyId?: number | null, changedByName?: string | null, changedFields: Array<{ __typename?: 'TT_PublishFieldChange', field: string, from?: string | null, to?: string | null }> }> }> } | null } };

export type Tt_RemoveLessonBulkMutationVariables = Exact<{
  input: Tt_RemoveLessonBulk;
}>;


export type Tt_RemoveLessonBulkMutation = { __typename?: 'Mutation', tt_removeLessonBulk: { __typename?: 'Success', success?: boolean | null } };

export type Tt_SwapTimeslotOptionsQueryVariables = Exact<{
  filter?: InputMaybe<TtSwapTimeslotFilter>;
}>;


export type Tt_SwapTimeslotOptionsQuery = { __typename?: 'Query', tt_swapTimeslotOptions: { __typename?: 'TTSwapTimeslotOptions', lessons: Array<{ __typename?: 'TTSwapTimeslotInfo', lesson: { __typename?: 'TTIndividualViewLesson', id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timetableGroup: { __typename?: 'TT_Groups', name: string }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string, name: string } | null, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string } | null }, roomsClashes: Array<{ __typename?: 'TT_RoomClash', room: { __typename?: 'Room', roomId: number, name: string }, lesson: { __typename?: 'TTIndividualViewLesson', timetableGroup: { __typename?: 'TT_Groups', name: string }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string, name: string } | null } }>, teacherClashes: Array<{ __typename?: 'TT_TeacherClash', teacherId: number, teacher: { __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }, lesson: { __typename?: 'TTIndividualViewLesson', timetableGroup: { __typename?: 'TT_Groups', name: string }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string, name: string } | null } }> }> } };

export type Tt_SwapMutationVariables = Exact<{
  input: TtSwapsInput;
}>;


export type Tt_SwapMutation = { __typename?: 'Mutation', tt_swap: { __typename?: 'Success', success?: boolean | null } };

export type Tt_TimetableQueryVariables = Exact<{
  filter?: InputMaybe<TtTimetableFilter>;
}>;


export type Tt_TimetableQuery = { __typename?: 'Query', tt_timetable: { __typename?: 'TTTimetable', timetableId: number, name: string, created: string, updatedAt: string, liveStatus?: { __typename?: 'TT_LiveStatus', totalChanges: number, lessonChanges: number, timetableGroupChanges: number, lastPublishedDate?: string | null } | null, checkpointStatus?: { __typename?: 'TT_CheckpointStatus', totalChanges: number } | null } };

export type Tt_TimetablesQueryVariables = Exact<{
  filter?: InputMaybe<TtTimetableListFilter>;
}>;


export type Tt_TimetablesQuery = { __typename?: 'Query', tt_timetables: Array<{ __typename?: 'TTTimetable', timetableId: number, name: string, created: string, updatedAt: string, liveTimetable: boolean, constructionInfo: { __typename?: 'TTTimetableConstructionInfo', classGroupsPublished?: string | null, fullPublish?: string | null }, createdBy: { __typename?: 'AuditPerson', person?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null }, updatedBy: { __typename?: 'AuditPerson', person?: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null }, liveStatus?: { __typename?: 'TT_LiveStatus', totalChanges: number, lessonChanges: number, timetableGroupChanges: number, lastPublishedDate?: string | null } | null, pbac: { __typename?: 'Pbac_ResourceResult', isSecured: boolean } }> };

export type Tt_GroupsQueryVariables = Exact<{
  filter: Tt_GroupsFilter;
}>;


export type Tt_GroupsQuery = { __typename?: 'Query', tt_groups: Array<{ __typename: 'TT_Groups', name: string, timetableGroupId: number, partyId?: number | null, allowAutoTeacherSwaps: boolean, groupType: Tt_GroupType, subjectId?: number | null, classGroupId?: number | null, blockId?: string | null, groupTagIds: Array<number>, studentMembershipType: TtGroupStudentMembershipTypeEnum, spread: Array<number>, totalLessonNoSpread?: number | null, subject?: { __typename?: 'Subject', id: number, name: string, description?: string | null, shortCode: string, nationalCode?: string | null, subjectSource: SubjectSource, examinable: boolean, colour?: Colour | null, icon?: string | null, active: boolean } | null, groupTag: Array<{ __typename?: 'GroupTag', id: number, name: string }>, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, subject?: { __typename?: 'Subject', colour?: Colour | null } | null } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, timetableGroup: { __typename: 'TT_Groups', timetableGroupId: number, name: string, subject?: { __typename?: 'Subject', name: string, colour?: Colour | null } | null }, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }> }> };

export type Tt_UpdateTeacherMutationVariables = Exact<{
  input: Tt_UpdateTeacherAssignments;
}>;


export type Tt_UpdateTeacherMutation = { __typename?: 'Mutation', tt_updateTeacher: { __typename?: 'Success', success?: boolean | null } };

export type Tt_UpsertTimetableGroupMutationVariables = Exact<{
  input: Tt_UpsertTimetableGroup;
}>;


export type Tt_UpsertTimetableGroupMutation = { __typename?: 'Mutation', tt_upsertTimetableGroup: { __typename?: 'Success', success?: boolean | null } };

export type Tt_UpsertGridsMutationVariables = Exact<{
  input: TtUpsertGrids;
}>;


export type Tt_UpsertGridsMutation = { __typename?: 'Mutation', tt_upsertGrids: { __typename?: 'Success', success?: boolean | null } };

export type Tt_UpsertBlockMutationVariables = Exact<{
  input: Tt_UpsertBlock;
}>;


export type Tt_UpsertBlockMutation = { __typename?: 'Mutation', tt_upsertBlock: { __typename?: 'Success', success?: boolean | null } };

export type Tt_DeleteBlockMutationVariables = Exact<{
  input: Tt_DeleteBlocks;
}>;


export type Tt_DeleteBlockMutation = { __typename?: 'Mutation', tt_deleteBlock: { __typename?: 'Success', success?: boolean | null } };

export type Tt_CheckpointStatusQueryVariables = Exact<{
  filter?: InputMaybe<TtTimetableFilter>;
}>;


export type Tt_CheckpointStatusQuery = { __typename?: 'Query', tt_timetable: { __typename?: 'TTTimetable', timetableId: number, checkpointStatus?: { __typename?: 'TT_CheckpointStatus', checkpointTimetableId: number, totalChanges: number, lessonChanges: number, timetableGroupChanges: number, lastCheckpointDate?: string | null, checkpoints: Array<{ __typename?: 'TT_CheckPointHistory', checkpointTimetableId: number, createdOn: string, checkpointName: string }> } | null } };

export type Tt_ClassGroupRolloverViewQueryVariables = Exact<{
  filter: Tt_ClassGroupRolloverViewFilter;
}>;


export type Tt_ClassGroupRolloverViewQuery = { __typename?: 'Query', tt_classGroupRolloverView: { __typename?: 'TT_ClassGroupRolloverView', currentTimetableId: number, previousTimetableId?: number | null, previousAcademicNamespaceId?: number | null, currentClassGroups: Array<{ __typename?: 'TT_ClassGroup', ttClassGroupId: number, partyId?: number | null, name: string, code: string, groupTagIds: Array<number>, source?: { __typename?: 'TT_SourceId', source: Tt_DataSource, id: string } | null }>, previousClassGroups: Array<{ __typename?: 'TT_ClassGroup', ttClassGroupId: number, partyId?: number | null, name: string, code: string, groupTagIds: Array<number> }> } };

export type Ttsolve_ClearTimeslotsMutationVariables = Exact<{
  input?: InputMaybe<TtSolve_ClearTimeslots>;
}>;


export type Ttsolve_ClearTimeslotsMutation = { __typename?: 'Mutation', ttsolve_clearTimeslots: { __typename?: 'Success', success?: boolean | null } };

export type Tt_CloneTimetableMutationVariables = Exact<{
  input: TtCloneTimetableInput;
}>;


export type Tt_CloneTimetableMutation = { __typename?: 'Mutation', tt_cloneTimetable: { __typename?: 'TTTimetable', timetableId: number } };

export type Tt_CreateCheckpointMutationVariables = Exact<{
  input: Tt_CreateCheckpoint;
}>;


export type Tt_CreateCheckpointMutation = { __typename?: 'Mutation', tt_createCheckpoint: { __typename?: 'Success', success?: boolean | null } };

export type Tt_CreateTimetableMutationVariables = Exact<{
  input: Tt_CreateTimetableInput;
}>;


export type Tt_CreateTimetableMutation = { __typename?: 'Mutation', tt_createTimetable: { __typename?: 'TTTimetable', timetableId: number } };

export type Ttsolve_ClassDataSetSpreadOnCoreSubjectsMutationVariables = Exact<{
  input: TtSolve_ClassDataSetSpreadOnCoreSubject;
}>;


export type Ttsolve_ClassDataSetSpreadOnCoreSubjectsMutation = { __typename?: 'Mutation', ttsolve_classDataSetSpreadOnCoreSubjects: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_ClassDataSetSpreadOnBlockMutationVariables = Exact<{
  input: TtSolve_ClassDataSetSpreadOnBlock;
}>;


export type Ttsolve_ClassDataSetSpreadOnBlockMutation = { __typename?: 'Mutation', ttsolve_classDataSetSpreadOnBlock: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_ClassDataDropOnBlockMutationVariables = Exact<{
  input: TtSolve_ClassDataDropOnBlock;
}>;


export type Ttsolve_ClassDataDropOnBlockMutation = { __typename?: 'Mutation', ttsolve_classDataDropOnBlock: { __typename?: 'Success', success?: boolean | null } };

export type Ttoptions_AvailableOptionsForImportQueryVariables = Exact<{
  filter: TtTimetableFilter;
}>;


export type Ttoptions_AvailableOptionsForImportQuery = { __typename?: 'Query', ttoptions_availableOptionsForImport: Array<{ __typename?: 'TtOptions_AvailableOption', possibleGroupTagIds: Array<number>, options: { __typename?: 'Options_Option', id: number, name: string } }> };

export type Ttoptions_ImportOptionsMutationVariables = Exact<{
  input: TtStudentOptions_Import;
}>;


export type Ttoptions_ImportOptionsMutation = { __typename?: 'Mutation', ttoptions_importOptions: { __typename?: 'Success', success?: boolean | null } };

export type Tt_IndividualLessonsQueryVariables = Exact<{
  filter: TtIndividualViewLessonFilter;
}>;


export type Tt_IndividualLessonsQuery = { __typename?: 'Query', tt_individualLessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string, periodType: TtGridPeriodType, name: string } | null, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timetableGroup: { __typename?: 'TT_Groups', name: string, partyId?: number | null, groupTagIds: Array<number>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, icon?: string | null } | null }, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }> };

export type Tt_PublishConstructionMutationVariables = Exact<{
  input: TtPublishConstructionInput;
}>;


export type Tt_PublishConstructionMutation = { __typename?: 'Mutation', tt_publishConstruction: { __typename?: 'TT_PublishConstructionResult', success: boolean } };

export type Ttsolve_StackGroupsMutationVariables = Exact<{
  input: TtSolve_StackGroups;
}>;


export type Ttsolve_StackGroupsMutation = { __typename?: 'Mutation', ttsolve_stackGroups: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_ClassDataAddSubjectMutationVariables = Exact<{
  input: TtSolve_ClassDataAddSubject;
}>;


export type Ttsolve_ClassDataAddSubjectMutation = { __typename?: 'Mutation', ttsolve_classDataAddSubject: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_ClassDataDeleteCoreSubjectsMutationVariables = Exact<{
  input: TtSolve_ClassDataDeleteCoreSubject;
}>;


export type Ttsolve_ClassDataDeleteCoreSubjectsMutation = { __typename?: 'Mutation', ttsolve_classDataDeleteCoreSubjects: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_ClassDataViewQueryVariables = Exact<{
  filter: TtSolve_ClassDataFilter;
}>;


export type Ttsolve_ClassDataViewQuery = { __typename?: 'Query', ttsolve_classDataView: { __typename?: 'TtSolve_ClassData', classGroups: Array<{ __typename?: 'TtSolve_ClassDataClassGroup', uiBlockLessonCountOnColumn: number, uiCoreLessonCountOnColumn: number, uiTotalLessonCountOnColumn: number, classGroup: { __typename?: 'TT_ClassGroup', ttClassGroupId: number, partyId?: number | null, name: string, code: string, groupTags: Array<{ __typename?: 'GroupTag', id: number, name: string }> } }>, blocks: Array<{ __typename?: 'TtSolve_ClassDataBlock', block: { __typename?: 'TT_Block', blockId: string, name: string, shortName: string, classGroups: Array<{ __typename?: 'TT_ClassGroup', ttClassGroupId: number, name: string }> }, timetableGroups: Array<{ __typename?: 'TtSolve_ClassDataBlockGroupList', classGroupId: number, blockGroup: Array<{ __typename?: 'TtSolve_ClassDataBlockGroup', isStack: boolean, classGroupIsPresentInBlock: boolean, groups: Array<{ __typename?: 'TT_Groups', timetableGroupId: number, name: string, allowAutoTeacherSwaps: boolean, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, totalLessonNoSpread?: number | null, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null } | null, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, name: string, startTime: string, endTime: string } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null }> }> }>, spillOverTimetableGroups: Array<{ __typename?: 'TT_Groups_ClassData', isStack: boolean, groups: Array<{ __typename?: 'TT_Groups', timetableGroupId: number, name: string, allowAutoTeacherSwaps: boolean, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, totalLessonNoSpread?: number | null, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null } | null, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, name: string, startTime: string, endTime: string } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null }> }>, supportGroups: Array<{ __typename?: 'TT_Groups_ClassData', isStack: boolean, groups: Array<{ __typename?: 'TT_Groups', timetableGroupId: number, name: string, allowAutoTeacherSwaps: boolean, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, totalLessonNoSpread?: number | null, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null } | null, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, name: string, startTime: string, endTime: string } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null }> }>, coScheduleGroups: Array<{ __typename?: 'TT_Groups_ClassData', isStack: boolean, groups: Array<{ __typename?: 'TT_Groups', timetableGroupId: number, name: string, allowAutoTeacherSwaps: boolean, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, totalLessonNoSpread?: number | null, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null } | null, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, name: string, startTime: string, endTime: string } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null }> }> }>, core: Array<{ __typename?: 'TtSolve_ClassDataCore', subjectId: number, subject: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null }, timetableGroups: Array<{ __typename?: 'TtSolve_ClassDataCoreList', classGroupId: number, timetableGroups: Array<{ __typename?: 'TT_Groups', timetableGroupId: number, name: string, allowAutoTeacherSwaps: boolean, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, totalLessonNoSpread?: number | null, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null } | null, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, name: string, startTime: string, endTime: string } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null }> }> }> } };

export type Ttsolve_DeleteRestrictionMutationVariables = Exact<{
  input: TtSolve_DeleteRestrictions;
}>;


export type Ttsolve_DeleteRestrictionMutation = { __typename?: 'Mutation', ttsolve_deleteRestriction: { __typename?: 'Success', success?: boolean | null } };

export type Tt_DeleteTimetablesMutationVariables = Exact<{
  input: Tt_DeleteTimetables;
}>;


export type Tt_DeleteTimetablesMutation = { __typename?: 'Mutation', tt_deleteTimetables: { __typename?: 'Success', success?: boolean | null } };

export type Tt_DeleteTimetableGroupMutationVariables = Exact<{
  input: Tt_DeleteTimetableGroups;
}>;


export type Tt_DeleteTimetableGroupMutation = { __typename?: 'Mutation', tt_deleteTimetableGroup: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_ImportSubjectCompetenciesFromCoreMutationVariables = Exact<{
  input: Tt_ImportSubjectCompetenciesFromCore;
}>;


export type Ttsolve_ImportSubjectCompetenciesFromCoreMutation = { __typename?: 'Mutation', ttsolve_importSubjectCompetenciesFromCore: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_RestrictionsMetaQueryVariables = Exact<{
  filter: TtSolve_RestrictionParams;
}>;


export type Ttsolve_RestrictionsMetaQuery = { __typename?: 'Query', ttsolve_restrictionsMeta: { __typename?: 'TtSolve_RestrictionsMeta', restriction: Array<{ __typename?: 'TtSolve_RestrictionMeta', ruleId: TtSolve_RestrictionRuleId, arguments?: Array<{ __typename?: 'TtSolve_RestrictionArgumentMetaField', type: TtSolve_RestrictionArgumentInputType, label: string, description?: string | null, required: boolean, selectValues?: Array<{ __typename?: 'TtSolve_RestrictionDropdownValues', id?: any | null, value?: string | null }> | null } | null> | null }> } };

export type Ttsolve_RestrictionsQueryVariables = Exact<{
  filter: TtSolve_RestrictionParams;
}>;


export type Ttsolve_RestrictionsQuery = { __typename?: 'Query', ttsolve_restrictions: { __typename?: 'TtSolve_Restrictions', resctriction: Array<{ __typename?: 'TtSolve_Restriction', restrictionIdx: number, type: TtSolve_RestrictionType, ruleId: TtSolve_RestrictionRuleId, description: string, enabled: boolean, hasError?: boolean | null, arguments?: Array<{ __typename?: 'TtSolve_RestrictionArgumentField', type: TtSolve_RestrictionArgumentInputType, value?: any | null, rawValue?: any | null }> | null, createdBy: { __typename?: 'AuditPerson', userId?: number | null, partyId?: number | null, person?: { __typename?: 'Person', type?: PartyPersonType | null, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null } }> } };

export type Tt_RolloverAutoMatchQueryVariables = Exact<{
  filter: Tt_RolloverAutoMatchFilter;
}>;


export type Tt_RolloverAutoMatchQuery = { __typename?: 'Query', tt_rolloverAutoMatch: { __typename?: 'TT_RolloverAutoMatch', subjectGroupMatches: Array<{ __typename?: 'TT_RolloverGroupMatch', timetableGroupId: number, previousYearTimetableGroupPartyId: number }>, classGroupMatches: Array<{ __typename?: 'TT_RolloverClassGroupMatch', ttClassGroupId: number, previousYearClassGroupPartyId: number }> } };

export type Tt_RolloverProgrammeStagesQueryVariables = Exact<{
  filter: Tt_RolloverProgrammeStagesFilter;
}>;


export type Tt_RolloverProgrammeStagesQuery = { __typename?: 'Query', tt_rolloverProgrammeStages: Array<{ __typename?: 'TT_RolloverProgrammeStage', fromProgrammeStageTagId: number, toProgrammeStageTagId: number, from: { __typename?: 'GroupTag', id: number, name: string, colour: Colour }, to: { __typename?: 'GroupTag', id: number, name: string, colour: Colour } }> };

export type Tt_SetTimetableGroupRolloverSourcesMutationVariables = Exact<{
  input: Tt_SetTimetableGroupRolloverSourcesInput;
}>;


export type Tt_SetTimetableGroupRolloverSourcesMutation = { __typename?: 'Mutation', tt_setTimetableGroupRolloverSources: { __typename?: 'Success', success?: boolean | null } };

export type Tt_RoomAssignmentStatsQueryVariables = Exact<{
  filter: Tt_RoomAssignmentFilter;
}>;


export type Tt_RoomAssignmentStatsQuery = { __typename?: 'Query', tt_roomAssignments: { __typename?: 'Tt_RoomAssignments', assignments: Array<{ __typename?: 'Tt_RoomAssignment', roomId: number, maxLoadPeriods: number, currentLoadPeriods: number }> } };

export type Tt_RoomAssignmentsQueryVariables = Exact<{
  filter: Tt_RoomAssignmentFilter;
}>;


export type Tt_RoomAssignmentsQuery = { __typename?: 'Query', tt_roomAssignments: { __typename?: 'Tt_RoomAssignments', solverStatus?: { __typename?: 'TtSolve_SolverStatus', solverStatus: Tt_SolverStatus, score?: string | null } | null, stats: { __typename?: 'Tt_RoomAssignmentsStats', roomCountTotal: number, roomsOverAllocatedCount: number, roomsFullyAllocatedCount: number, roomsUnderAllocatedCount: number, mainstreamCount: number, mainstreamRoomsAssignedCount: number, mainstreamRoomsUnassignedCount: number, freeformCount: number, freeformRoomsAssignedCount: number, freeformRoomsUnassignedCount: number, nonTeachingCount: number, nonTeachingRoomsAssignedCount: number, nonTeachingRoomsUnassignedCount: number }, assignments: Array<{ __typename?: 'Tt_RoomAssignment', roomId: number, maxLoadPeriods: number, currentLoadPeriods: number, lessonsAssigned: number, room: { __typename?: 'Room', name: string, capacity?: number | null, pools: Array<{ __typename?: 'RoomPool', id: number, name: string, colour: Colour }> }, mainstream: Array<{ __typename?: 'Tt_RoomAssignmentGroup', lessonsAssigned: number, lessonsTotal: number, splitIndicator: boolean, isMultipleOTeachersOnLesson: boolean, group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null } | null, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null } }>, freeform: Array<{ __typename?: 'Tt_RoomAssignmentGroup', lessonsAssigned: number, lessonsTotal: number, splitIndicator: boolean, isMultipleOTeachersOnLesson: boolean, group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null } | null, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null } }>, nonTeaching: Array<{ __typename?: 'Tt_RoomAssignmentGroup', lessonsAssigned: number, lessonsTotal: number, splitIndicator: boolean, isMultipleOTeachersOnLesson: boolean, group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null } | null, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null } }> }>, unassigned: { __typename?: 'Tt_RoomAssignmentUnassigned', maxLoadPeriods: number, currentLoadPeriods: number, lessonsAssigned: number, mainstream: Array<{ __typename?: 'Tt_RoomAssignmentGroup', lessonsAssigned: number, lessonsTotal: number, splitIndicator: boolean, isMultipleOTeachersOnLesson: boolean, group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null } | null, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null } }>, freeform: Array<{ __typename?: 'Tt_RoomAssignmentGroup', lessonsAssigned: number, lessonsTotal: number, splitIndicator: boolean, isMultipleOTeachersOnLesson: boolean, group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null } | null, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null } }>, nonTeaching: Array<{ __typename?: 'Tt_RoomAssignmentGroup', lessonsAssigned: number, lessonsTotal: number, splitIndicator: boolean, isMultipleOTeachersOnLesson: boolean, group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null } | null, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null } }> } } };

export type Ttsolve_ClearRoomsMutationVariables = Exact<{
  input?: InputMaybe<TtSolve_ClearRooms>;
}>;


export type Ttsolve_ClearRoomsMutation = { __typename?: 'Mutation', ttsolve_clearRooms: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_ScheduleLessonOptionsQueryVariables = Exact<{
  filter: TtSolver_ScheduleLessonFilter;
}>;


export type Ttsolve_ScheduleLessonOptionsQuery = { __typename?: 'Query', ttsolve_scheduleLessonOptions: { __typename?: 'TtSolve_ScheduleLessonOptions', timeslotValidations: Array<{ __typename?: 'TtValidation_ValidationTimeslotMove', valid: ValidationMoveValidity, validations: Array<{ __typename?: 'TtValidation_Validation', id: string, rootMessage?: string | null, contextMessage?: string | null, validationLevel: TtValidation_Level, validationRuleId: TtValidation_RuleId, validationAction?: TtValidation_Action | null }>, timeslotId: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } }> } };

export type Ttsolve_ResourceSlackReportQueryVariables = Exact<{
  filter: TtSolve_SolveParams;
}>;


export type Ttsolve_ResourceSlackReportQuery = { __typename?: 'Query', ttsolve_resourceSlackReport: { __typename?: 'TtSolve_ResourceSlackReport', schemaVersion?: string | null, generatedAtEpochMs?: number | null, inputHash?: number | null, difficulty?: TtSolve_SlackDifficulty | null, feasibility?: TtSolve_SlackFeasibility | null, shape?: { __typename?: 'TtSolve_SlackShape', totalLessons?: number | null, mandatoryLessons?: number | null, blockLessons?: number | null, mandatoryOrMeetingSgs?: number | null, blockSgs?: number | null, meetingSgs?: number | null, blocks?: number | null, stackedBlocks?: number | null, teachers?: number | null, baseClasses?: number | null, rooms?: number | null, roomPools?: number | null, totalSlots?: number | null, totalDays?: number | null, avgSlotsPerDay?: number | null, cycles?: number | null, twoWeek?: boolean | null, dualGrid?: boolean | null } | null, feasibilityErrors: Array<{ __typename?: 'TtSolve_SlackInfeasibleMessage', code?: string | null, constraintId?: string | null, constraintName?: string | null, level?: string | null, message?: string | null }>, capacity?: { __typename?: 'TtSolve_SlackCapacity', maxBaseClassLoad?: number | null, maxTeacherTimeslotLoad?: number | null, maxTeacherWeeklyTimeLoad?: number | null, maxPoolGlobalLoad?: number | null, teacherSlotOver09Count?: number | null, roomedLessons?: number | null, roomedFraction?: number | null, maxRoomLoad?: number | null, overbookedBaseClasses: Array<{ __typename?: 'TtSolve_SlackOverbookedBaseClass', baseClassId?: number | null, name?: string | null, required?: number | null, available?: number | null, over?: number | null }>, overbookedTeachersTimeslots: Array<{ __typename?: 'TtSolve_SlackOverbookedTeacher', teacherId?: number | null, name?: string | null, required?: number | null, available?: number | null, ratio?: number | null }>, overbookedTeachersWeeklyTime: Array<{ __typename?: 'TtSolve_SlackOverbookedTeacher', teacherId?: number | null, name?: string | null, required?: number | null, available?: number | null, ratio?: number | null }>, overbookedPools: Array<{ __typename?: 'TtSolve_SlackOverbookedPool', roomPoolId?: number | null, name?: string | null, demand?: number | null, capacity?: number | null }> } | null, spread?: { __typename?: 'TtSolve_SlackSpread', isHardAtLeastOnce?: boolean | null, maxDifficulty?: number | null, totalDifficulty?: number | null, comfortableCount?: number | null, snugCount?: number | null, zeroSlackCount?: number | null, infeasibleCount?: number | null, totalEvaluated?: number | null, multiplePairCount?: number | null, spreadStrain?: number | null, pressureIndex?: number | null, pressureLabel?: TtSolve_SlackDifficulty | null, pressuredSpreads: Array<{ __typename?: 'TtSolve_SlackPressuredSpread', subjectGroupId?: number | null, blockId?: number | null, sgName?: string | null, spread?: string | null, daysNeeded?: number | null, daysAvail?: number | null, tightness?: number | null, difficulty?: number | null, reason?: string | null, inBlock?: boolean | null, hardSpread?: boolean | null }> } | null, blocks?: { __typename?: 'TtSolve_SlackBlocks', bigBlocks: Array<{ __typename?: 'TtSolve_SlackBigBlock', blockId?: number | null, name?: string | null, rows?: number | null, cols?: number | null, lessons?: number | null }>, bigBlockGroups: Array<{ __typename?: 'TtSolve_SlackBigBlockGroup', blockId?: number | null, blockName?: string | null, blockGroupId?: string | null, lessons?: number | null }> } | null, multiples?: { __typename?: 'TtSolve_SlackMultiples', inBlocks?: number | null, inMandatory?: number | null } | null, restrictions?: { __typename?: 'TtSolve_SlackRestrictions', topTeachers: Array<{ __typename?: 'TtSolve_SlackTopTeacher', teacherId?: number | null, name?: string | null, hardDaysOff?: number | null, hardHalfDaysOff?: number | null, hardExcludedSlots?: number | null }>, topSubjectGroups: Array<{ __typename?: 'TtSolve_SlackTopSubjectGroup', subjectGroupId?: number | null, name?: string | null, hardDaysOff?: number | null, hardExcludedSlots?: number | null }> } | null, pinning?: { __typename?: 'TtSolve_SlackPinning', lessons?: number | null, fraction?: number | null } | null, coSchedule?: { __typename?: 'TtSolve_SlackCoSchedule', chains?: number | null, chainsWithBlocks?: number | null } | null } };

export type Ttsolve_ScheduleViewQueryVariables = Exact<{
  filter: TtSolver_ScheduleFilter;
}>;


export type Ttsolve_ScheduleViewQuery = { __typename?: 'Query', ttsolve_scheduleView: { __typename?: 'TtSolve_ScheduleView', byGroupTag: Array<{ __typename?: 'TtSolve_ScheduleViewGroupTag', groupTagId: number, groupTag: { __typename?: 'GroupTag', name: string }, timeslots: Array<{ __typename?: 'TTTimeslot', id: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number }, info: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string, periodType: TtGridPeriodType, name: string, meta: { __typename?: 'TTGridPeriodMeta', placementDisabled: boolean } } }>, timetableGroups: Array<{ __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, shortCode: string } | null, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', timeslotState?: Tt_FieldStatus | null, spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string, periodType: TtGridPeriodType, name: string } | null, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, schedulingStats?: { __typename?: 'TT_LessonSchedulingStats', brokenFeasibility?: number | null, brokenSpreadOnly?: number | null, brokenAllConstraints?: number | null } | null }> }>, rows: Array<{ __typename?: 'TtSolve_ScheduleViewGroupTagRow', name: string, id: number, allowMultiple: boolean, grid: Array<{ __typename?: 'TtSolve_ScheduleViewGroupTagRowGrid', included: boolean, timeslotId: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number }, lessonInstanceIds: Array<{ __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }> }> }> }> } };

export type Ttsolve_ConfigurationQueryVariables = Exact<{
  filter: TtSolve_SolveParams;
}>;


export type Ttsolve_ConfigurationQuery = { __typename?: 'Query', ttsolve_configuration: { __typename?: 'TtSolve_Configuration', user: { __typename?: 'TtSolve_ConfigurationUser', globalConstraints: Array<{ __typename?: 'TtSolve_ConfigurationConstraint', id: string, label: string, isDiamond: boolean, weighting: number, isAdvanced: boolean }>, weightings: Array<{ __typename?: 'TtSolve_ConfigurationWeighting', id: string, label: string, weighting: number }> }, defaults: { __typename?: 'TtSolve_ConfigurationDefaults', globalConstraints: Array<{ __typename?: 'TtSolve_ConfigurationConstraint', id: string, label: string, isDiamond: boolean, weighting: number, isAdvanced: boolean }>, weightings: Array<{ __typename?: 'TtSolve_ConfigurationWeighting', id: string, label: string, weighting: number }> } } };

export type Ttsolve_TopBrokenConstraintsQueryVariables = Exact<{
  filter: TtSolve_TopBrokenConstraintsFilter;
}>;


export type Ttsolve_TopBrokenConstraintsQuery = { __typename?: 'Query', ttsolve_topBrokenConstraints: { __typename?: 'TtSolve_TopBrokenConstraints', distinctConstraints: number, totalViolations: number, dataNote: string, entries: Array<{ __typename?: 'TtSolve_BrokenConstraintEntry', constraintName: string, totalFrequency: number, distinctLessonInstances: number }> } };

export type Ttsolve_GroupViolationSummaryQueryVariables = Exact<{
  filter: TtSolve_GroupViolationSummaryFilter;
}>;


export type Ttsolve_GroupViolationSummaryQuery = { __typename?: 'Query', ttsolve_groupViolationSummary: { __typename?: 'TtSolve_GroupViolationSummary', timetableGroupId: number, totalFrequency: number, distinctConstraints: number, distinctLessonInstances: number, dataNote: string, topConstraints: Array<{ __typename?: 'TtSolve_BrokenConstraintEntry', constraintName: string, totalFrequency: number, distinctLessonInstances: number }> } };

export type Ttsolve_HotspotLessonsQueryVariables = Exact<{
  filter: TtSolve_HotspotLessonsFilter;
}>;


export type Ttsolve_HotspotLessonsQuery = { __typename?: 'Query', ttsolve_hotspotLessons: { __typename?: 'TtSolve_HotspotLessons', totalLessons: number, dataNote: string, entries: Array<{ __typename?: 'TtSolve_HotspotLesson', timetableGroupId: number, subjectGroupName?: string | null, lessonIdx?: number | null, lessonInstanceIdx?: number | null, totalFrequency: number, distinctConstraints: number }> } };

export type Ttsolve_TeacherViolationSummaryQueryVariables = Exact<{
  filter: TtSolve_TeacherViolationSummaryFilter;
}>;


export type Ttsolve_TeacherViolationSummaryQuery = { __typename?: 'Query', ttsolve_teacherViolationSummary: { __typename?: 'TtSolve_TeacherViolationSummary', staffPartyId: number, totalFrequency: number, distinctConstraints: number, distinctLessonInstances: number, distinctSubjectGroups: number, dataNote: string, topConstraints: Array<{ __typename?: 'TtSolve_BrokenConstraintEntry', constraintName: string, totalFrequency: number, distinctLessonInstances: number }> } };

export type Ttsolve_ConstraintEdgesQueryVariables = Exact<{
  filter: TtSolve_ConstraintEdgesFilter;
}>;


export type Ttsolve_ConstraintEdgesQuery = { __typename?: 'Query', ttsolve_constraintEdges: { __typename?: 'TtSolve_ConstraintEdges', entityAxis: TtSolve_CascadeTarget, minWeight: number, topConstraintsRequested: number, topEntitiesRequested: number, dataNote: string, edges: Array<{ __typename?: 'TtSolve_ConstraintEdge', constraint: string, entityId: string, entityLabel: string, weight: number }>, constraintTotals: Array<{ __typename?: 'TtSolve_AxisTotal', id: string, label: string, total: number }>, entityTotals: Array<{ __typename?: 'TtSolve_AxisTotal', id: string, label: string, total: number }> } };

export type Ttsolve_SolveRunsQueryVariables = Exact<{
  filter: TtSolve_SolveRunsFilter;
}>;


export type Ttsolve_SolveRunsQuery = { __typename?: 'Query', ttsolve_solveRuns: Array<{ __typename?: 'TtSolve_SolveRunSummary', solveRunId: number, rowCount: number, isLatest: boolean }> };

export type Ttsolve_ConstraintCellLessonsQueryVariables = Exact<{
  filter: TtSolve_ConstraintCellLessonsFilter;
}>;


export type Ttsolve_ConstraintCellLessonsQuery = { __typename?: 'Query', ttsolve_constraintCellLessons: { __typename?: 'TtSolve_ConstraintCellLessons', totalFrequency: number, distinctLessons: number, dataNote: string, entries: Array<{ __typename?: 'TtSolve_ConstraintCellLesson', timetableGroupId: number, subjectGroupName?: string | null, lessonIdx: number, lessonInstanceIdx: number, frequency: number }> } };

export type Ttsolve_ExplainSpreadConflictQueryVariables = Exact<{
  filter: TtSolve_SpreadConflictFilter;
}>;


export type Ttsolve_ExplainSpreadConflictQuery = { __typename?: 'Query', ttsolve_explainSpreadConflict: { __typename?: 'TtSolve_SpreadConflictExplanation', unknowns: Array<string>, resolution: { __typename?: 'TtSolve_SpreadConflictResolution', resolved: boolean, matchedName: string, timetableGroupId?: number | null, message: string }, subjectGroup?: { __typename?: 'TtSolve_SpreadConflictSubjectGroup', timetableGroupId?: number | null, name?: string | null, lessonCount?: number | null, spread: Array<number>, blockId?: string | null, classGroupId?: number | null } | null, tightSpread?: { __typename?: 'TtSolve_SpreadConflictTightSpread', pattern: Array<number>, daysNeeded?: number | null, daysAvailable?: number | null, rawReasons: Array<string>, structuredReasons: Array<{ __typename?: 'TtSolve_SpreadConflictStructuredReason', kind: TtSolve_SpreadConflictReasonKind, original: string, detail?: string | null }> } | null, assignedTeachers: Array<{ __typename?: 'TtSolve_SpreadConflictAssignedTeacher', staffPartyId: number, name?: string | null }> } };

export type Ttsolve_TeacherLoadBreakdownQueryVariables = Exact<{
  filter: TtSolve_TeacherLoadFilter;
}>;


export type Ttsolve_TeacherLoadBreakdownQuery = { __typename?: 'Query', ttsolve_teacherLoadBreakdown: { __typename?: 'TtSolve_TeacherLoadBreakdown', teacher: { __typename?: 'TtSolve_TeacherLoadInfo', staffPartyId: number, name: string, weeklyAllowanceMinutes: number, requiredMinutes: number, load: number }, lessonGroups: Array<{ __typename?: 'TtSolve_TeacherLoadContribution', timetableGroupId: number, subjectGroupName: string, subjectId?: number | null, subjectName?: string | null, lessonCount: number, minutesPerLesson: number, totalMinutes: number, role: TtSolve_TeacherLoadRole, blockName?: string | null, alternativeStaffPartyIds: Array<number> }>, suggestions: Array<{ __typename?: 'TtSolve_TeacherLoadSuggestion', timetableGroupId: number, subjectGroupName: string, candidateStaffPartyId: number, candidateName: string, candidateCurrentLoad: number, candidateSpareMinutes: number, shiftableLessons: number, competencyPreference: number }> } };

export type Tyrone_PromptQueryVariables = Exact<{
  filter: Tyrone_Prompt;
}>;


export type Tyrone_PromptQuery = { __typename?: 'Query', tyrone_prompt: { __typename?: 'Tyrone_PromptResult', conversationId: string, result: string } };

export type Tt_UpdateLessonsMutationVariables = Exact<{
  input: Tt_UpdateLessons;
}>;


export type Tt_UpdateLessonsMutation = { __typename?: 'Mutation', tt_updateLessons: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_GetSolverInputQueryVariables = Exact<{
  filter: TtSolve_SolveParams;
}>;


export type Ttsolve_GetSolverInputQuery = { __typename?: 'Query', ttsolve_getSolverInput: { __typename?: 'TtSolve_SolverInput', input?: any | null } };

export type Ttsolve_StatusQueryVariables = Exact<{
  filter: TtSolve_SolveParams;
}>;


export type Ttsolve_StatusQuery = { __typename?: 'Query', ttsolve_status: { __typename?: 'TtSolve_SolverStatus', score?: string | null, solverStatus: Tt_SolverStatus, solverRunType: SolverRunType, stats: { __typename?: 'TtSolve_Stats', lessonsTotal: number, lessonsScheduled: number, lessonsWithRoom: number, lessonsWithTeacher: number, spreadsExpected: number, spreadsAchieved: number, spreadsMissed?: number | null }, groupTagStats: Array<{ __typename?: 'TtSolve_GroupTagStats', groupTagId: number, stats: { __typename?: 'TtSolve_Stats', lessonsTotal: number, lessonsScheduled: number, lessonsWithRoom: number, lessonsWithTeacher: number } }> } };

export type Ttsolve_SolveMutationVariables = Exact<{
  input?: InputMaybe<TtSolve_RunSolverParams>;
}>;


export type Ttsolve_SolveMutation = { __typename?: 'Mutation', ttsolve_solve: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_CompetenciesMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type Ttsolve_CompetenciesMetaQuery = { __typename?: 'Query', ttsolve_competenciesMeta: { __typename?: 'TtSolve_CompetenciesMeta', groups: Array<{ __typename?: 'TtSolve_CompetenciesMetaGroup', id: number, name: string }> } };

export type Ttsolve_SubjectCompetenciesQueryVariables = Exact<{
  filter: TtSolve_SubjectCompetenciesFilter;
}>;


export type Ttsolve_SubjectCompetenciesQuery = { __typename?: 'Query', ttsolve_subjectCompetencies: { __typename?: 'TtSolve_SubjectCompetencies', groups: Array<{ __typename?: 'TtSolve_CompetenciesGroup', groupId: number, subjects: Array<{ __typename?: 'TtSolve_CompetenciesGroupSubject', subjectId: number, subject: { __typename?: 'Subject', id: number, nationalCode?: string | null, name: string }, preference1Staff: Array<{ __typename?: 'Staff', partyId: number, displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }>, preference2Staff: Array<{ __typename?: 'Staff', partyId: number, displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }>, preference3Staff: Array<{ __typename?: 'Staff', partyId: number, displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }> }> } };

export type Tt_SubjectGroupRolloverViewQueryVariables = Exact<{
  filter: Tt_SubjectGroupRolloverViewFilter;
}>;


export type Tt_SubjectGroupRolloverViewQuery = { __typename?: 'Query', tt_subjectGroupRolloverView: { __typename?: 'TT_SubjectGroupRolloverView', currentTimetableId: number, previousTimetableId?: number | null, previousAcademicNamespaceId?: number | null, currentGroups: Array<{ __typename?: 'TT_Groups', timetableGroupId: number, partyId?: number | null, name: string, groupTagIds: Array<number>, subjectId?: number | null, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } }>, source?: { __typename?: 'TT_SourceId', source: Tt_DataSource, id: string } | null }>, previousGroups: Array<{ __typename?: 'TT_Groups', timetableGroupId: number, partyId?: number | null, name: string, groupTagIds: Array<number>, subjectId?: number | null, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } }> }> } };

export type Tt_TeacherAssignmentsStatsQueryVariables = Exact<{
  filter: Tt_TeacherAssignmentFilter;
}>;


export type Tt_TeacherAssignmentsStatsQuery = { __typename?: 'Query', tt_teacherAssignments: { __typename?: 'Tt_TeacherAssignments', assignments: Array<{ __typename?: 'Tt_TeacherAssignment', staffId: number, maxLoadMinutes: number, currentLoadMinutes: number, lessonsAssigned: number }> } };

export type Tt_TeacherAssignmentsQueryVariables = Exact<{
  filter: Tt_TeacherAssignmentFilter;
}>;


export type Tt_TeacherAssignmentsQuery = { __typename?: 'Query', tt_teacherAssignments: { __typename?: 'Tt_TeacherAssignments', solverStatus?: { __typename?: 'TtSolve_SolverStatus', solverStatus: Tt_SolverStatus, score?: string | null } | null, stats: { __typename?: 'Tt_TeacherAssignmentsStats', teacherCountTotal: number, teachersOverAllocatedCount: number, teachersFullyAllocatedCount: number, teachersUnderAllocatedCount: number, mainstreamCount: number, mainstreamTeachersAssignedCount: number, mainstreamTeachersUnassignedCount: number, freeformCount: number, freeformTeachersAssignedCount: number, freeformTeachersUnassignedCount: number }, assignments: Array<{ __typename?: 'Tt_TeacherAssignment', staffId: number, maxLoadMinutes: number, currentLoadMinutes: number, lessonsAssigned: number, staff: { __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }, mainstream: Array<{ __typename?: 'Tt_TeacherAssignmentGroup', lessonsAssigned: number, lessonsTotal: number, splitIndicator: boolean, isMultipleOTeachersOnLesson: boolean, group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null } | null, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null } }>, freeform: Array<{ __typename?: 'Tt_TeacherAssignmentGroup', lessonsAssigned: number, lessonsTotal: number, splitIndicator: boolean, isMultipleOTeachersOnLesson: boolean, group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null } | null, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null } }>, nonTeaching: Array<{ __typename?: 'Tt_TeacherAssignmentGroup', lessonsAssigned: number, lessonsTotal: number, splitIndicator: boolean, isMultipleOTeachersOnLesson: boolean, group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null } | null, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null } }> }>, unassigned: { __typename?: 'Tt_TeacherAssignmentUnassigned', maxLoadMinutes: number, currentLoadMinutes: number, lessonsAssigned: number, mainstream: Array<{ __typename?: 'Tt_TeacherAssignmentGroup', lessonsAssigned: number, lessonsTotal: number, splitIndicator: boolean, isMultipleOTeachersOnLesson: boolean, group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null } | null, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null } }>, freeform: Array<{ __typename?: 'Tt_TeacherAssignmentGroup', lessonsAssigned: number, lessonsTotal: number, splitIndicator: boolean, isMultipleOTeachersOnLesson: boolean, group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null } | null, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null } }>, nonTeaching: Array<{ __typename?: 'Tt_TeacherAssignmentGroup', lessonsAssigned: number, lessonsTotal: number, splitIndicator: boolean, isMultipleOTeachersOnLesson: boolean, group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, groupTagIds: Array<number>, spread: Array<number>, lessonCount: number, blockIdx?: number | null, blockId?: string | null, classGroupId?: number | null, maxClassSize: number, teachers: Array<{ __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, subject?: { __typename?: 'Subject', id: number, name: string, colour?: Colour | null, nationalCode?: string | null } | null, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, name: string, dayOfWeek: number } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, archived?: boolean | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, room?: { __typename?: 'Room', roomId: number, name: string, pools: Array<{ __typename?: 'RoomPool', id: number, name: string }> } | null, roomPool?: { __typename?: 'RoomPool', id: number, name: string } | null }>, coScheduleTtGroup?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null } }> } } };

export type Ttsolve_SubjectCompetenciesCondensedQueryVariables = Exact<{
  filter: TtSolve_SubjectCompetenciesFilter;
}>;


export type Ttsolve_SubjectCompetenciesCondensedQuery = { __typename?: 'Query', ttsolve_subjectCompetenciesCondensed: { __typename?: 'TtSolve_SubjectCompetenciesCondensed', staff: Array<{ __typename?: 'TtSolve_CompetenciesGroupCondensed', staffId: number, subjects: Array<{ __typename?: 'Subject', id: number, name: string, colour?: Colour | null }> }> } };

export type Ttsolve_SolverSwappedTeachersQueryVariables = Exact<{
  filter: TtTimetableFilter;
}>;


export type Ttsolve_SolverSwappedTeachersQuery = { __typename?: 'Query', ttsolve_solverSwappedTeachers: Array<{ __typename?: 'TtSolve_SolverSwappedTeachers', originalTeacher: { __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }, swappedTeacher: { __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }, group?: { __typename?: 'TT_Groups', timetableGroupId: number, name: string } | null }> };

export type Ttsolve_SolverSwappedTeacherAcceptRejectMutationVariables = Exact<{
  input: TtSolve_SolverSwappedTeachersAccept;
}>;


export type Ttsolve_SolverSwappedTeacherAcceptRejectMutation = { __typename?: 'Mutation', ttsolve_solverSwappedTeacherAcceptReject: { __typename?: 'Success', success?: boolean | null } };

export type Tt_DiffQueryVariables = Exact<{
  filter?: InputMaybe<Tt_DiffFilter>;
}>;


export type Tt_DiffQuery = { __typename?: 'Query', tt_diff?: { __typename?: 'TT_Diff', sourceTimetableId: number, compareToTimetableId: number, totalChanges: number, lessonChanges: number, timetableGroupChanges: number, lessonDiffs: Array<{ __typename?: 'TTPublishDiffLesson', type: Tt_DiffType, roomChanged: boolean, teachersChanged: boolean, timeslotChanged: boolean, newLesson: { __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, dayOfWeek: number, name: string } | null, timetableGroup: { __typename: 'TT_Groups', timetableGroupId: number, name: string, subject?: { __typename?: 'Subject', name: string, colour?: Colour | null } | null }, room?: { __typename?: 'Room', roomId: number, name: string } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }, oldLesson: { __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, dayOfWeek: number, name: string } | null, timetableGroup: { __typename: 'TT_Groups', timetableGroupId: number, name: string, subject?: { __typename?: 'Subject', name: string, colour?: Colour | null } | null }, room?: { __typename?: 'Room', roomId: number, name: string } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> } }>, groupDiffs: Array<{ __typename?: 'TTPublishDiffGroup', type: Tt_DiffType, teachersChanged: boolean, nameChanged: boolean, subjectChanged: boolean, groupTypeChanged: boolean, studentMembershipTypeChanged: boolean, blockIdChanged: boolean, classGroupIdChanged: boolean, tagsChanged: boolean, newGroup: { __typename: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, blockId?: string | null, classGroupId?: number | null, subject?: { __typename?: 'Subject', name: string, colour?: Colour | null } | null, groupTag: Array<{ __typename?: 'GroupTag', id: number, name: string }>, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }, oldGroup: { __typename: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, blockId?: string | null, classGroupId?: number | null, subject?: { __typename?: 'Subject', name: string, colour?: Colour | null } | null, groupTag: Array<{ __typename?: 'GroupTag', id: number, name: string }>, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> } }>, blockDiffs: Array<{ __typename?: 'TTPublishDiffBlock', type: Tt_DiffType, nameChanged: boolean, classGroupsChanged: boolean, newGroup: { __typename?: 'TT_Block', blockId: string, name: string, shortName: string, ttClassGroupIds: Array<number> }, oldGroup: { __typename?: 'TT_Block', blockId: string, name: string, shortName: string, ttClassGroupIds: Array<number> } }>, classGroupDiffs: Array<{ __typename?: 'TTPublishDiffClassGroup', type: Tt_DiffType, nameChanged: boolean, newGroup: { __typename?: 'TT_ClassGroup', ttClassGroupId: number, name: string, code: string }, oldGroup: { __typename?: 'TT_ClassGroup', ttClassGroupId: number, name: string, code: string } }> } | null };

export type Ttsolve_UpsertRestrictionMutationVariables = Exact<{
  input: TtSolve_UpsertRestrictions;
}>;


export type Ttsolve_UpsertRestrictionMutation = { __typename?: 'Mutation', ttsolve_upsertRestriction: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_UpdateSubjectCompetenciesMutationVariables = Exact<{
  input: TtSolve_UpdateSubjectCompetenciesInput;
}>;


export type Ttsolve_UpdateSubjectCompetenciesMutation = { __typename?: 'Mutation', ttsolve_updateSubjectCompetencies: { __typename?: 'Success', success?: boolean | null } };

export type Ttvalidation_ValidateQueryVariables = Exact<{
  filter: TtValidation_Filter;
}>;


export type Ttvalidation_ValidateQuery = { __typename?: 'Query', ttvalidation_validate: { __typename?: 'TtValidation_Validations', validations: Array<{ __typename?: 'TtValidation_Validation', id: string, rootMessage?: string | null, validationLevel: TtValidation_Level, validationName: string, catalogueKey?: string | null, stopsSolver: boolean, actions: Array<{ __typename: 'Tt_AcceptRejectSolverSwappedTeacher', type: Tt_Type, label?: string | null } | { __typename: 'Tt_SwapRoomAction', type: Tt_Type, label?: string | null, lessonIds: Array<{ __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }> } | { __typename: 'Tt_SwapTeacherAction', type: Tt_Type, label?: string | null, lessonIds: Array<{ __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }> }> }> } };

export type Tt_AddLessonMutationVariables = Exact<{
  input?: InputMaybe<Tt_AddLessonInput>;
}>;


export type Tt_AddLessonMutation = { __typename?: 'Mutation', tt_addLesson: { __typename?: 'Success', success?: boolean | null } };

export type Tt_AddLessonOptionsQueryVariables = Exact<{
  filter?: InputMaybe<Tt_AddLessonFilter>;
}>;


export type Tt_AddLessonOptionsQuery = { __typename?: 'Query', tt_addLessonOptions: { __typename?: 'Tt_AddLessonOptions', freeStaff: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, freeTimetableGroups: Array<{ __typename?: 'TT_Groups', timetableGroupId: number, name: string }>, freeRooms: Array<{ __typename?: 'Room', roomId: number, name: string, capacity?: number | null, description?: string | null, includeInTimetable: boolean, externalSystemId?: string | null, location?: string | null, disabled: boolean, pools: Array<{ __typename?: 'RoomPool', id: number, name: string, description?: string | null, colour: Colour }> }>, clashingStaff: Array<{ __typename?: 'Tt_ClashingStaff', staff: { __typename?: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }, clashes: Array<{ __typename?: 'TTIndividualViewLesson', id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string, name: string } | null, timetableGroup: { __typename?: 'TT_Groups', name: string } }> }>, clashingGroups: Array<{ __typename?: 'Tt_ClashingGroup', group: { __typename?: 'TT_Groups', timetableGroupId: number, name: string }, clashes: Array<{ __typename?: 'TTIndividualViewLesson', id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string, name: string } | null, timetableGroup: { __typename?: 'TT_Groups', name: string } }> }>, clashingRooms: Array<{ __typename?: 'Tt_ClashingRoom', room: { __typename?: 'Room', roomId: number, name: string, capacity?: number | null, description?: string | null, includeInTimetable: boolean, externalSystemId?: string | null, location?: string | null, disabled: boolean, pools: Array<{ __typename?: 'RoomPool', id: number, name: string, description?: string | null, colour: Colour }> }, clashes: Array<{ __typename?: 'TTIndividualViewLesson', id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string, name: string } | null, timetableGroup: { __typename?: 'TT_Groups', name: string } }> }> } };

export type Tt_SwapTeacherOptionsQueryVariables = Exact<{
  filter: TtSwapTeacherFilter;
}>;


export type Tt_SwapTeacherOptionsQuery = { __typename?: 'Query', tt_swapTeacherOptions: { __typename?: 'TTSwapTeacherOptions', timeslots: Array<{ __typename?: 'TTTimeslot', id: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number }, info: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string } }>, teachers: Array<{ __typename?: 'TTSwapTeacherTeacherInfo', staffId: number, teacher: { __typename?: 'Staff', displayCode?: string | null, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }, lessonOnTimeslots: Array<{ __typename?: 'TTSwapLessonsToSwap', lessons?: Array<{ __typename?: 'TTIndividualViewLesson', id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timetableGroup: { __typename?: 'TT_Groups', name: string } }> | null }> }> } };

export type Tt_SwapRoomOptionsQueryVariables = Exact<{
  filter: TtSwapRoomFilter;
}>;


export type Tt_SwapRoomOptionsQuery = { __typename?: 'Query', tt_swapRoomOptions: { __typename?: 'TTSwapRoomOptions', timeslots: Array<{ __typename?: 'TTTimeslot', id: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number }, info: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string } }>, rooms: Array<{ __typename?: 'TTSwapRoomRoomInfo', roomId: number, room: { __typename?: 'Room', name: string, capacity?: number | null, description?: string | null, pools: Array<{ __typename?: 'RoomPool', id: number, name: string, description?: string | null, colour: Colour }> }, lessonOnTimeslots: Array<{ __typename?: 'TTSwapLessonsToSwap', lessons?: Array<{ __typename?: 'TTIndividualViewLesson', id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timetableGroup: { __typename?: 'TT_Groups', name: string }, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }> | null }> }> } };

export type Tt_RemoveLessonMutationVariables = Exact<{
  input?: InputMaybe<Array<Tt_RemoveLessonInput> | Tt_RemoveLessonInput>;
}>;


export type Tt_RemoveLessonMutation = { __typename?: 'Mutation', tt_removeLesson: { __typename?: 'Success', success?: boolean | null } };

export type Tt_EditLessonOptionsQueryVariables = Exact<{
  filter?: InputMaybe<Tt_EditLessonFilter>;
}>;


export type Tt_EditLessonOptionsQuery = { __typename?: 'Query', tt_editLessonOptions: Array<{ __typename?: 'Tt_EditLessonOptions', lessonId: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, freeStaff: Array<{ __typename?: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }>, freeRooms: Array<{ __typename?: 'Room', roomId: number, name: string, capacity?: number | null, description?: string | null, includeInTimetable: boolean, externalSystemId?: string | null, location?: string | null, disabled: boolean, pools: Array<{ __typename?: 'RoomPool', id: number, name: string, description?: string | null, colour: Colour }> }>, clashingStaff: Array<{ __typename?: 'Tt_ClashingStaff', staff: { __typename?: 'Staff', partyId: number, person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, nameTextId: number, name: string } | null } }, clashes: Array<{ __typename?: 'TTIndividualViewLesson', id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string, name: string } | null, timetableGroup: { __typename?: 'TT_Groups', name: string } }> }>, clashingRooms: Array<{ __typename?: 'Tt_ClashingRoom', room: { __typename?: 'Room', roomId: number, name: string, capacity?: number | null, description?: string | null, includeInTimetable: boolean, externalSystemId?: string | null, location?: string | null, disabled: boolean, pools: Array<{ __typename?: 'RoomPool', id: number, name: string, description?: string | null, colour: Colour }> }, clashes: Array<{ __typename?: 'TTIndividualViewLesson', id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string, name: string } | null, timetableGroup: { __typename?: 'TT_Groups', name: string } }> }> }> };

export type Tt_LookupCoreGroupsNotInTimetableQueryVariables = Exact<{
  filter?: InputMaybe<TtTimetableFilter>;
}>;


export type Tt_LookupCoreGroupsNotInTimetableQuery = { __typename?: 'Query', tt_lookupCoreGroupsNotInTimetable: Array<{ __typename?: 'GeneralGroup', partyId: number, name: string, avatarUrl?: string | null } | { __typename?: 'ProgrammeStageEnrollment', partyId: number, name: string, avatarUrl?: string | null } | { __typename?: 'SubjectGroup', partyId: number, name: string, avatarUrl?: string | null } | { __typename?: 'YearGroupEnrollment', partyId: number, name: string, avatarUrl?: string | null }> };

export type Tt_ImportGroupsFromCoreMutationVariables = Exact<{
  input: Tt_ImportGroupsFromCore;
}>;


export type Tt_ImportGroupsFromCoreMutation = { __typename?: 'Mutation', tt_importGroupsFromCore: { __typename?: 'Success', success?: boolean | null } };

export type Tt_PublishMutationVariables = Exact<{
  input: TtPublishTimetableInput;
}>;


export type Tt_PublishMutation = { __typename?: 'Mutation', tt_publish: { __typename?: 'TT_PublishResult', success: boolean } };

export type Tt_ResetMutationVariables = Exact<{
  input: Tt_Reset;
}>;


export type Tt_ResetMutation = { __typename?: 'Mutation', tt_reset: { __typename?: 'Success', success?: boolean | null } };

export type Tt_ResourceTimetableViewQueryVariables = Exact<{
  filter: TtResourceTimetableViewFilter;
}>;


export type Tt_ResourceTimetableViewQuery = { __typename?: 'Query', tt_resourceTimetableView: { __typename?: 'TTResourceTimetableView', timeslots: Array<{ __typename?: 'TTResourceTimeslotView', timeslotIds?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslots?: { __typename?: 'TTTimeslotInfo', dayOfWeek: number, startTime: string, endTime: string, periodType: TtGridPeriodType, name: string } | null, lessons: Array<{ __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, dayOfWeek: number, name: string } | null, timetableGroup: { __typename: 'TT_Groups', timetableGroupId: number, name: string, subject?: { __typename?: 'Subject', name: string, colour?: Colour | null } | null, groupTag: Array<{ __typename?: 'GroupTag', id: number, type?: GroupTagType | null, name: string }> }, room?: { __typename?: 'Room', roomId: number, name: string } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }> }> } };

export type Tt_UnpublishedChangesQueryVariables = Exact<{
  filter?: InputMaybe<TtTimetableFilter>;
}>;


export type Tt_UnpublishedChangesQuery = { __typename?: 'Query', tt_timetable: { __typename?: 'TTTimetable', timetableId: number, liveStatus?: { __typename?: 'TT_LiveStatus', totalChanges: number, publishDiff?: { __typename?: 'TTPublishDiff', lessonDiffs: Array<{ __typename?: 'TTPublishDiffLesson', type: Tt_DiffType, roomChanged: boolean, teachersChanged: boolean, timeslotChanged: boolean, newLesson: { __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, dayOfWeek: number, name: string } | null, timetableGroup: { __typename: 'TT_Groups', timetableGroupId: number, name: string, subject?: { __typename?: 'Subject', name: string, colour?: Colour | null } | null }, room?: { __typename?: 'Room', roomId: number, name: string } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }, oldLesson: { __typename?: 'TTIndividualViewLesson', spread: number, id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number }, timeslotId?: { __typename?: 'TTTimeslotId', gridIdx: number, dayIdx: number, periodIdx: number } | null, timeslotInfo?: { __typename?: 'TTTimeslotInfo', startTime: string, endTime: string, dayOfWeek: number, name: string } | null, timetableGroup: { __typename: 'TT_Groups', timetableGroupId: number, name: string, subject?: { __typename?: 'Subject', name: string, colour?: Colour | null } | null }, room?: { __typename?: 'Room', roomId: number, name: string } | null, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> } }>, groupDiffs: Array<{ __typename?: 'TTPublishDiffGroup', type: Tt_DiffType, teachersChanged: boolean, nameChanged: boolean, subjectChanged: boolean, groupTypeChanged: boolean, studentMembershipTypeChanged: boolean, blockIdChanged: boolean, classGroupIdChanged: boolean, tagsChanged: boolean, newGroup: { __typename: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, blockId?: string | null, classGroupId?: number | null, subject?: { __typename?: 'Subject', name: string, colour?: Colour | null } | null, groupTag: Array<{ __typename?: 'GroupTag', id: number, name: string }>, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> }, oldGroup: { __typename: 'TT_Groups', timetableGroupId: number, name: string, groupType: Tt_GroupType, studentMembershipType: TtGroupStudentMembershipTypeEnum, blockId?: string | null, classGroupId?: number | null, subject?: { __typename?: 'Subject', name: string, colour?: Colour | null } | null, groupTag: Array<{ __typename?: 'GroupTag', id: number, name: string }>, teachers: Array<{ __typename?: 'Staff', person: { __typename?: 'Person', partyId: number, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } }> } }>, blockDiffs: Array<{ __typename?: 'TTPublishDiffBlock', type: Tt_DiffType, nameChanged: boolean, classGroupsChanged: boolean, newGroup: { __typename?: 'TT_Block', blockId: string, name: string, shortName: string, ttClassGroupIds: Array<number> }, oldGroup: { __typename?: 'TT_Block', blockId: string, name: string, shortName: string, ttClassGroupIds: Array<number> } }>, classGroupDiffs: Array<{ __typename?: 'TTPublishDiffClassGroup', type: Tt_DiffType, nameChanged: boolean, newGroup: { __typename?: 'TT_ClassGroup', ttClassGroupId: number, name: string, code: string }, oldGroup: { __typename?: 'TT_ClassGroup', ttClassGroupId: number, name: string, code: string } }> } | null } | null } };

export type Tt_UpdateClassGroupMutationVariables = Exact<{
  input: Tt_UpdateClassGroupInput;
}>;


export type Tt_UpdateClassGroupMutation = { __typename?: 'Mutation', tt_updateClassGroup: { __typename?: 'Success', success?: boolean | null } };

export type Tt_UpdateTimetableGroupMutationVariables = Exact<{
  input: Tt_UpdateTimetableGroupInput;
}>;


export type Tt_UpdateTimetableGroupMutation = { __typename?: 'Mutation', tt_updateTimetableGroup: { __typename?: 'Success', success?: boolean | null } };

export type Tt_UpsertCoScheduleChainsMutationVariables = Exact<{
  input: Tt_UpsertCoScheduleChainsInput;
}>;


export type Tt_UpsertCoScheduleChainsMutation = { __typename?: 'Mutation', tt_upsertCoScheduleChains: { __typename?: 'Success', success?: boolean | null } };

export type Tt_OnCallSetBlankMutationVariables = Exact<{
  input: TtTimetableFilter;
}>;


export type Tt_OnCallSetBlankMutation = { __typename?: 'Mutation', tt_onCallSetBlank: { __typename?: 'Success', success?: boolean | null } };

export type Tt_InfoReqRunsolverMutationVariables = Exact<{
  input: TtRunOnCallSolverParams;
}>;


export type Tt_InfoReqRunsolverMutation = { __typename?: 'Mutation', tt_infoReqRunsolver: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_SolverCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type Ttsolve_SolverCatalogQuery = { __typename?: 'Query', ttsolve_solverCatalog: { __typename?: 'TtSolve_SolverCatalog', version: string, constraints: Array<{ __typename?: 'TtSolve_CatalogConstraint', solverName: string, key: string, hardness: TtSolve_CatalogHardness, category: TtSolve_CatalogCategory, drivesDifficulty: boolean, humanName?: string | null, description?: string | null, ruleId?: TtSolve_RestrictionRuleId | null, makesInfeasible: boolean, stopsSolver: boolean, hidden: boolean, resolutions: Array<{ __typename?: 'TtSolve_ResolutionHint', action: TtSolve_ResolutionAction, appliesTo?: string | null, detail?: string | null, likelihood: TtSolve_Likelihood }> }>, messages: Array<{ __typename?: 'TtSolve_MessageTemplate', key: string, constraintKey?: string | null, defaultMessage: string, severity: TtSolve_CatalogSeverity, description?: string | null, type: TtSolve_MessageType, makesInfeasible: boolean, stopsSolver: boolean, hidden: boolean, resolutions: Array<{ __typename?: 'TtSolve_ResolutionHint', action: TtSolve_ResolutionAction, appliesTo?: string | null, detail?: string | null, likelihood: TtSolve_Likelihood }> }> } };

export type Ttsolve_UpsertCatalogueOverrideMutationVariables = Exact<{
  input: TtSolve_UpsertCatalogueOverride;
}>;


export type Ttsolve_UpsertCatalogueOverrideMutation = { __typename?: 'Mutation', ttsolve_upsertCatalogueOverride: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_DeleteCatalogueOverrideMutationVariables = Exact<{
  input: TtSolve_DeleteCatalogueOverride;
}>;


export type Ttsolve_DeleteCatalogueOverrideMutation = { __typename?: 'Mutation', ttsolve_deleteCatalogueOverride: { __typename?: 'Success', success?: boolean | null } };

export type TimetableSearchQueryQueryVariables = Exact<{
  filter: Tt_SearchFilter;
}>;


export type TimetableSearchQueryQuery = { __typename?: 'Query', tt_search: Array<{ __typename?: 'Search', partyId: number, type: SearchType, text: string, avatarUrl?: string | null }> };

export type Tt_EditLessonInstanceMutationVariables = Exact<{
  input: TtEditLessonPeriodInstanceWrapper;
}>;


export type Tt_EditLessonInstanceMutation = { __typename?: 'Mutation', tt_editLessonInstance: Array<{ __typename?: 'TTIndividualViewLesson', id: { __typename?: 'TTIndividualViewLessonId', lessonIdx: number, lessonInstanceIdx: number, timetableGroupId: number } }> };

export type Users_Admin__AddUserToTenantMutationVariables = Exact<{
  input: Users_Admin_AddUserToTenantInput;
}>;


export type Users_Admin__AddUserToTenantMutation = { __typename?: 'Mutation', users_admin__addUserToTenant: { __typename?: 'Users_AdminPerson', account: { __typename?: 'Users_AdminPersonalInfo', tenant: number, tenantName: string, partyId: number, firstName: string, lastName: string, type?: PartyPersonType | null, avatarUrl?: string | null, primaryEmail?: { __typename?: 'EmailAddress', email?: string | null } | null } } };

export type Ttsolve_CancelSolveMutationVariables = Exact<{
  input: TtSolve_CancelSolveInput;
}>;


export type Ttsolve_CancelSolveMutation = { __typename?: 'Mutation', ttsolve_cancelSolve: { __typename?: 'Success', success?: boolean | null } };

export type Users_Admin__ClearPreAuthCacheMutationVariables = Exact<{
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type Users_Admin__ClearPreAuthCacheMutation = { __typename?: 'Mutation', users_admin__clearPreAuthCache: { __typename?: 'Success', success?: boolean | null } };

export type ImportVsware2_DeleteSchoolIdentifierMutationVariables = Exact<{
  input: ImportVsware2_DeleteSchoolIdentifierInput;
}>;


export type ImportVsware2_DeleteSchoolIdentifierMutation = { __typename?: 'Mutation', importVsware2_deleteSchoolIdentifier?: { __typename?: 'Success', success?: boolean | null } | null };

export type ImportVsware2_UpsertSchoolIdentifierMutationVariables = Exact<{
  input: ImportVsware2_UpsertSchoolIdentifierInput;
}>;


export type ImportVsware2_UpsertSchoolIdentifierMutation = { __typename?: 'Mutation', importVsware2_upsertSchoolIdentifier?: { __typename?: 'Success', success?: boolean | null } | null };

export type ImportVsware_ImportsQueryVariables = Exact<{
  filter?: InputMaybe<ImportVsware_Filter>;
}>;


export type ImportVsware_ImportsQuery = { __typename?: 'Query', importVsware_imports: { __typename?: 'ImportVsware_ImportMetaPage', totalCount: number, data: Array<{ __typename?: 'ImportVsware_ImportMeta', id?: number | null, startedOn?: string | null, tenant?: number | null, fileName?: string | null }> } };

export type ImportVsware2_ImportsQueryVariables = Exact<{
  filter?: InputMaybe<ImportVsware2_Filter>;
}>;


export type ImportVsware2_ImportsQuery = { __typename?: 'Query', importVsware2_imports: { __typename?: 'ImportVsware2_ImportMetaPage', totalCount: number, data: Array<{ __typename?: 'ImportVsware2_ImportMeta', id?: number | null, startedOn?: string | null, tenant?: number | null, fileName?: string | null }> } };

export type ImportVsware2_SchoolIdentifiersQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportVsware2_SchoolIdentifiersQuery = { __typename?: 'Query', importVsware2_schoolIdentifiers: Array<{ __typename?: 'ImportVsware2_SchoolIdentifier', vsIdentifier: number, name: string, tenant: number }> };

export type Users_Admin__DefaultPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type Users_Admin__DefaultPermissionsQuery = { __typename?: 'Query', users_admin__defaultPermissions: Array<{ __typename?: 'Users_DefaultPermission', id: number, group: string, permissionSetId: string, permissionType?: PermissionType | null }> };

export type Ttsolve_DefaultSolverConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type Ttsolve_DefaultSolverConfigurationQuery = { __typename?: 'Query', ttsolve_defaultSolverConfiguration: { __typename?: 'TtSolve_DefaultSolverConfiguration', parallelSolvers?: number | null, useIncremental?: boolean | null, minutesSpentlimit?: number | null, unimprovedMinutesSpentlimit?: number | null, weightings?: Array<{ __typename?: 'TtSolve_ConfigurationWeighting', id: string, label: string, weighting: number }> | null, globalConstraints?: Array<{ __typename?: 'TtSolve_ConfigurationConstraint', id: string, label: string, isDiamond: boolean, weighting: number, isAdvanced: boolean }> | null } };

export type Ttsolve_UpdateDefaultSolverConfigurationMutationVariables = Exact<{
  input: TtSolve_SolverConfiguration;
}>;


export type Ttsolve_UpdateDefaultSolverConfigurationMutation = { __typename?: 'Mutation', ttsolve_updateDefaultSolverConfiguration: { __typename?: 'Success', success?: boolean | null } };

export type Users_Admin__DeleteDefaultPermissionMutationVariables = Exact<{
  input: Users_DeleteDefaultPermission;
}>;


export type Users_Admin__DeleteDefaultPermissionMutation = { __typename?: 'Mutation', users_admin__deleteDefaultPermission: { __typename?: 'Success', success?: boolean | null } };

export type Users_MergeDuplicateUserProfilesMutationVariables = Exact<{
  input?: InputMaybe<MergeDuplicateProfilesInput>;
}>;


export type Users_MergeDuplicateUserProfilesMutation = { __typename?: 'Mutation', users_mergeDuplicateUserProfiles?: { __typename?: 'Success', success?: boolean | null } | null };

export type Users_MergeUserProfilesMutationVariables = Exact<{
  input?: InputMaybe<MergeUserProfiles>;
}>;


export type Users_MergeUserProfilesMutation = { __typename?: 'Mutation', users_mergeUserProfiles?: { __typename?: 'Success', success?: boolean | null } | null };

export type Users_Admin__Party_PeopleQueryVariables = Exact<{
  tenant: Scalars['Int']['input'];
}>;


export type Users_Admin__Party_PeopleQuery = { __typename?: 'Query', users_admin__party_people?: Array<{ __typename?: 'Users_AdminPerson', account: { __typename?: 'Users_AdminPersonalInfo', tenant: number, tenantName: string, partyId: number, firstName: string, lastName: string, type?: PartyPersonType | null, avatarUrl?: string | null, primaryEmail?: { __typename?: 'EmailAddress', email?: string | null } | null }, otherAccounts: Array<{ __typename?: 'Users_AdminPersonalInfo', tenant: number, tenantName: string, partyId: number, firstName: string, lastName: string, type?: PartyPersonType | null, avatarUrl?: string | null, primaryEmail?: { __typename?: 'EmailAddress', email?: string | null } | null }> }> | null };

export type Users_Admin__PermissionGroupsForTenantQueryVariables = Exact<{
  tenant: Scalars['Int']['input'];
}>;


export type Users_Admin__PermissionGroupsForTenantQuery = { __typename?: 'Query', users_admin__permissionGroupsForTenant: Array<{ __typename?: 'Users_Admin_PermissionGroupOption', id: number, name?: string | null, description?: string | null, memberType?: MemberType | null, custom?: boolean | null }> };

export type Users_Admin__SaveDefaultPermissionMutationVariables = Exact<{
  input: Users_SaveDefaultPermission;
}>;


export type Users_Admin__SaveDefaultPermissionMutation = { __typename?: 'Mutation', users_admin__saveDefaultPermission: { __typename?: 'Users_DefaultPermission', id: number } };

export type Scheduling_JobHandlersQueryVariables = Exact<{ [key: string]: never; }>;


export type Scheduling_JobHandlersQuery = { __typename?: 'Query', scheduling_jobHandlers: Array<{ __typename?: 'Scheduling_JobHandlerDefinition', name: string, parameters: Array<{ __typename?: 'Scheduling_JobHandlerParameter', name: string, type: string }> }> };

export type Scheduling_JobHistoryQueryVariables = Exact<{
  filter?: InputMaybe<Scheduling_JobHistoryFilter>;
}>;


export type Scheduling_JobHistoryQuery = { __typename?: 'Query', scheduling_jobHistory: Array<{ __typename?: 'Scheduling_JobExecution', executionId: string, handlerName: string, jobType: Scheduling_JobType, status: Scheduling_JobStatus, parameters?: any | null, submittedAt: string, startedAt?: string | null, finishedAt?: string | null, successCount: number, failCount: number, durationMs?: number | null, tenantId: number, triggeredBy?: number | null }> };

export type Scheduling_JobExecutionQueryVariables = Exact<{
  filter: Scheduling_JobExecutionFilter;
}>;


export type Scheduling_JobExecutionQuery = { __typename?: 'Query', scheduling_jobExecution?: { __typename?: 'Scheduling_JobExecution', executionId: string, handlerName: string, jobType: Scheduling_JobType, status: Scheduling_JobStatus, parameters?: any | null, submittedAt: string, startedAt?: string | null, finishedAt?: string | null, successCount: number, failCount: number, durationMs?: number | null, exceptionClass?: string | null, exceptionMessage?: string | null, executionCount: number, tenantId: number, triggeredBy?: number | null, workerNode?: string | null, retryOfExecutionId?: string | null } | null };

export type Scheduling_JobLogEntriesQueryVariables = Exact<{
  filter: Scheduling_JobLogEntriesFilter;
}>;


export type Scheduling_JobLogEntriesQuery = { __typename?: 'Query', scheduling_jobLogEntries: Array<{ __typename?: 'Scheduling_JobLogEntry', level: Scheduling_JobLogLevel, message?: string | null, reference?: string | null, timestamp: string }> };

export type Scheduling_SubmitOneTimeJobMutationVariables = Exact<{
  input: Scheduling_SubmitOneTimeJobInput;
}>;


export type Scheduling_SubmitOneTimeJobMutation = { __typename?: 'Mutation', scheduling_submitOneTimeJob: { __typename?: 'Scheduling_SubmitJobResult', executionId: string } };

export type Scheduling_SubmitPollingJobMutationVariables = Exact<{
  input: Scheduling_SubmitPollingJobInput;
}>;


export type Scheduling_SubmitPollingJobMutation = { __typename?: 'Mutation', scheduling_submitPollingJob: { __typename?: 'Scheduling_SubmitJobResult', executionId: string } };

export type Scheduling_CancelJobMutationVariables = Exact<{
  input: Scheduling_CancelJobInput;
}>;


export type Scheduling_CancelJobMutation = { __typename?: 'Mutation', scheduling_cancelJob: { __typename?: 'Success', success?: boolean | null } };

export type Scheduling_CronJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type Scheduling_CronJobsQuery = { __typename?: 'Query', scheduling_cronJobs: Array<{ __typename?: 'Scheduling_CronJobDefinition', jobId: string, handlerName: string, displayName?: string | null, description?: string | null, cronExpression: string, enabled: boolean, systemTask: boolean, maxConcurrent?: number | null }> };

export type Scheduling_UpdateCronJobsMutationVariables = Exact<{
  input: Scheduling_UpdateCronJobsInput;
}>;


export type Scheduling_UpdateCronJobsMutation = { __typename?: 'Mutation', scheduling_updateCronJobs: { __typename?: 'Success', success?: boolean | null } };

export type Scheduling_TriggerCronNowMutationVariables = Exact<{
  input: Scheduling_TriggerCronNowInput;
}>;


export type Scheduling_TriggerCronNowMutation = { __typename?: 'Mutation', scheduling_triggerCronNow: { __typename?: 'Scheduling_SubmitJobResult', executionId: string } };

export type Scheduling_RetryFailedJobMutationVariables = Exact<{
  input: Scheduling_RetryFailedJobInput;
}>;


export type Scheduling_RetryFailedJobMutation = { __typename?: 'Mutation', scheduling_retryFailedJob: { __typename?: 'Scheduling_SubmitJobResult', executionId: string } };

export type Ttsolve_SolverReconcileQueryVariables = Exact<{ [key: string]: never; }>;


export type Ttsolve_SolverReconcileQuery = { __typename?: 'Query', ttsolve_solverReconcile: Array<{ __typename?: 'TtSolve_SolverReconcileRow', serverId: string, problemId?: string | null, timetableId?: number | null, presence: string, reachable?: boolean | null, solverStatus?: string | null, solverScore?: string | null, solverDurationSec?: number | null, dbStatus?: string | null, reservedCpus?: number | null }> };

export type Ttsolve_SolverServerHealthQueryVariables = Exact<{ [key: string]: never; }>;


export type Ttsolve_SolverServerHealthQuery = { __typename?: 'Query', ttsolve_solverServerHealth: Array<{ __typename?: 'TtSolve_SolverServerHealth', id: string, reachable: boolean, message?: string | null, latencyMs?: number | null, activeProblems?: number | null, problems?: Array<{ __typename?: 'TtSolve_SolverProblem', problemId?: string | null, problemType?: string | null, score?: string | null, status?: string | null, durationSec?: number | null }> | null }> };

export type Ttsolve_SolverServersQueryVariables = Exact<{
  filter: TtSolve_SolverServersFilter;
}>;


export type Ttsolve_SolverServersQuery = { __typename?: 'Query', ttsolve_solverServers: Array<{ __typename?: 'TtSolve_SolverServer', id: string, name?: string | null, protocol: string, host: string, port: number, token?: string | null, cpus: number, permanent: boolean, enabled: boolean, reservedCpus?: number | null, freeCpus?: number | null }> };

export type Ttsolve_UpsertSolverServerMutationVariables = Exact<{
  input: TtSolve_UpsertSolverServerInput;
}>;


export type Ttsolve_UpsertSolverServerMutation = { __typename?: 'Mutation', ttsolve_upsertSolverServer: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_DeleteSolverServerMutationVariables = Exact<{
  input: TtSolve_DeleteSolverServerInput;
}>;


export type Ttsolve_DeleteSolverServerMutation = { __typename?: 'Mutation', ttsolve_deleteSolverServer: { __typename?: 'Success', success?: boolean | null } };

export type Ttsolve_SolverStateOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type Ttsolve_SolverStateOverviewQuery = { __typename?: 'Query', ttsolve_solverStateOverview: Array<{ __typename?: 'TtSolve_SolverStateOverview', timetableId: number, tenant?: number | null, academicNamespaceId?: number | null, solverType?: string | null, status?: string | null, solverServerId?: string | null, reservedCpus?: number | null, restartCount?: number | null, stopReason?: string | null, score?: string | null, problemId?: string | null, source?: string | null, updatedOn?: string | null }> };

export type Composite_TenantSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type Composite_TenantSettingsQuery = { __typename?: 'Query', composite_tenantSettings: { __typename?: 'Composite_TenantSettings', xeroId?: string | null, comregName?: string | null, goLiveOn?: string | null, organizationTenant?: { __typename?: 'Tenant', tenant: number, name: string, description: string, imgUrl?: string | null, location?: string | null, type?: string | null, liveSchool: boolean, rollNo?: string | null, tenantType: TenantType, subTenants?: Array<number> | null } | null } };

export type Composite_UpsertTenantSettingsMutationVariables = Exact<{
  input: UpsertTenantSettingsInput;
}>;


export type Composite_UpsertTenantSettingsMutation = { __typename?: 'Mutation', composite_upsertTenantSettings: { __typename?: 'Success', success?: boolean | null } };

export type Admin__TenantsQueryVariables = Exact<{
  filter?: InputMaybe<TenantsFilter>;
}>;


export type Admin__TenantsQuery = { __typename?: 'Query', admin__tenants?: Array<{ __typename?: 'Tenant', tenant: number, name: string, imgUrl?: string | null, liveSchool: boolean, rollNo?: string | null, description: string, location?: string | null, latitude?: number | null, longitude?: number | null, organizationTenant?: string | null }> | null };

export type Users_Admin__UpdateTenantsMutationVariables = Exact<{
  input: Users_UpdateTenantsInput;
}>;


export type Users_Admin__UpdateTenantsMutation = { __typename?: 'Mutation', users_admin__updateTenants: { __typename?: 'Success', success?: boolean | null } };

export type Admin__ResetTenantCacheMutationVariables = Exact<{
  input?: InputMaybe<Scalars['Int']['input']>;
}>;


export type Admin__ResetTenantCacheMutation = { __typename?: 'Mutation', admin__resetTenantCache: { __typename?: 'Success', success?: boolean | null } };

export type Admin__RefreshTenantSearchMutationVariables = Exact<{
  input: Search_RefreshTenantSearchInput;
}>;


export type Admin__RefreshTenantSearchMutation = { __typename?: 'Mutation', admin__refreshTenantSearch: { __typename?: 'Success', success?: boolean | null } };

export type Users_Admin__CreateEmptyTenantMutationVariables = Exact<{
  input: Users_CreateEmptyTenantInput;
}>;


export type Users_Admin__CreateEmptyTenantMutation = { __typename?: 'Mutation', users_admin__createEmptyTenant: { __typename?: 'Tenant', tenant: number, name: string } };

export type Users_Admin__User_LookupQueryVariables = Exact<{
  filter: AdminLookupFilter;
}>;


export type Users_Admin__User_LookupQuery = { __typename?: 'Query', users_admin__user_lookup: Array<{ __typename?: 'Users_AdminPersonalInfo', tenant: number, tenantName: string, globalUserId: number, profileId: number, partyId: number, firstName: string, lastName: string, avatarUrl?: string | null, type?: PartyPersonType | null, primaryEmail?: { __typename?: 'EmailAddress', email?: string | null } | null }> };

export type Core_AcademicNamespacesQueryVariables = Exact<{ [key: string]: never; }>;


export type Core_AcademicNamespacesQuery = { __typename?: 'Query', core_academicNamespaces?: Array<{ __typename?: 'AcademicNamespace', academicNamespaceId: number, type: AcademicNamespaceType, name: string, year: number, description?: string | null, isActiveDefaultNamespace: boolean, startDate: string, endDate: string }> | null };

export type Composite_CmsConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type Composite_CmsConfigQuery = { __typename?: 'Query', composite_cmsConfig?: { __typename?: 'Cms_Config', url: string, token: string } | null };

export type File_Transfer_ListQueryVariables = Exact<{
  filter?: InputMaybe<FileTransferFilter>;
}>;


export type File_Transfer_ListQuery = { __typename?: 'Query', file_transfer_list?: Array<{ __typename?: 'FileTransferResponse', id: number, feature: FileTransferFeature, fileName: string, fileUrl: string, referenceId: string, timestamp?: string | null, uploaderPartyId?: number | null, uploader?: { __typename?: 'Person', partyId: number, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, type?: PartyPersonType | null, title?: { __typename?: 'PersonalTitle', id: number, name: string, nameTextId: number } | null } | null }> | null };

export type Layout_GetConfigQueryVariables = Exact<{
  filter: Layout_ConfigFilter;
}>;


export type Layout_GetConfigQuery = { __typename?: 'Query', layout_getConfig?: { __typename?: 'Layout_Config', id: number, configKey: string, userId?: number | null, widgets: any, lockedWidgets?: Array<string> | null } | null };

export type Layout_GetConfigsQueryVariables = Exact<{
  filter: Layout_ConfigsFilter;
}>;


export type Layout_GetConfigsQuery = { __typename?: 'Query', layout_getConfigs: Array<{ __typename?: 'Layout_Config', id: number, configKey: string, userId?: number | null, widgets: any, lockedWidgets?: Array<string> | null }> };

export type Layout_UpsertConfigMutationVariables = Exact<{
  input: Layout_UpsertConfigInput;
}>;


export type Layout_UpsertConfigMutation = { __typename?: 'Mutation', layout_upsertConfig: { __typename?: 'Layout_Config', id: number, configKey: string, userId?: number | null, widgets: any, lockedWidgets?: Array<string> | null } };

export type Layout_DeleteConfigMutationVariables = Exact<{
  input: Layout_DeleteConfigInput;
}>;


export type Layout_DeleteConfigMutation = { __typename?: 'Mutation', layout_deleteConfig: boolean };

export type Users_OrganizationTenantQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationTenantFilter>;
}>;


export type Users_OrganizationTenantQuery = { __typename?: 'Query', users_organizationTenant?: { __typename?: 'Tenant', tenant: number, name: string, imgUrl?: string | null } | null };

export type Catalogue_ProgrammeStagesQueryVariables = Exact<{
  filter?: InputMaybe<ProgrammeStageFilter>;
}>;


export type Catalogue_ProgrammeStagesQuery = { __typename?: 'Query', catalogue_programmeStages: Array<{ __typename?: 'ProgrammeStage', id: number, name: string, shortName?: string | null, nationalCode: string, programmeId: number, editable: boolean, discontinued: boolean, yearGroupId: number, programme?: { __typename?: 'Programme', id: number, name: string, shortName?: string | null, nationalCode?: string | null, description?: string | null } | null, subjects?: Array<{ __typename?: 'Subject', id: number, name: string } | null> | null }> };

export type Catalogue_SystemSettingsValuesQueryVariables = Exact<{
  filter: Catalogue_SystemSettingsFilter;
}>;


export type Catalogue_SystemSettingsValuesQuery = { __typename?: 'Query', catalogue_systemSettingsValues: { __typename?: 'dyn_SystemSettings', attendance_subjectGroupAttendance_customSubjectGroupAttendanceCodes: Array<number>, attendance_shareAttendanceNote_enabled?: boolean | null, security_dataPrivacy_confirmBeforeShowingSensitiveData?: boolean | null, security_logout_inactiveTimeUntilLogoutMinutes?: number | null, substitution_display_showAbsenceReason?: boolean | null, substitution_display_teacherDisplayNameType: Core_StaffNameDisplayType, people_display_teacherDisplayNameType: Core_StaffNameDisplayType, noticeboard_display_alwaysShowPinned?: boolean | null, communications_sms_studentSms?: boolean | null, schoolActivity_attendance_defaultAttendanceCode?: number | null, timetable_twoWeekTimetable_enabled?: boolean | null, timetable_construction_defaultToTableViewInBlockCores?: boolean | null, language_translation_enableSwitching?: boolean | null, language_translation_glossary?: any | null, featureFlag_settings_peapod: Catalogue_FeatureFlag, featureFlag_attendance_sessionAttendance: Catalogue_FeatureFlag, featureFlag_rulesEngine_rulesEnginePlus: Catalogue_FeatureFlag, featureFlag_assessments_stateCba: Catalogue_FeatureFlag, featureFlag_forms_newFormsSection: Catalogue_FeatureFlag, featureFlag_security_advancedPermissions: Catalogue_FeatureFlag, featureFlag_studentOptions_fullFeature: Catalogue_FeatureFlag, featureFlag_userAccess_sds: Catalogue_FeatureFlag, groupTags_groupsMenu_showProgrammeStages?: boolean | null, groupTags_groupsMenu_showYears?: boolean | null, groupTags_groupsMenu_showHouse?: boolean | null, groupTags_programmeStage_enabledStages: Array<number>, security_summerMode_enabled?: boolean | null, behaviour_quickActions_list?: any | null, social_thirdParties_facebook?: boolean | null, social_thirdParties_instagram?: boolean | null, social_thirdParties_twitter?: boolean | null, attendance_signInOut_collectedBy: CollectedByMode, attendance_overdue_numberOfDaysWidgetShows?: number | null, fees_feeForm_hideAbsorbFees?: boolean | null } };

export type Users_SubTenantsQueryVariables = Exact<{
  filter?: InputMaybe<SubTenantsFilter>;
}>;


export type Users_SubTenantsQuery = { __typename?: 'Query', users_subTenants: Array<{ __typename?: 'Tenant', tenant: number, name: string, imgUrl?: string | null }> };

export type Tasks_TasksQueryVariables = Exact<{
  filter?: InputMaybe<Tasks_MyTasksFilter>;
}>;


export type Tasks_TasksQuery = { __typename?: 'Query', tasks_tasks: Array<{ __typename?: 'Tasks_TaskExecution', executionId: string, handlerName: string, status: Scheduling_JobStatus, submittedAt: string, startedAt?: string | null, finishedAt?: string | null, durationMs?: number | null, successCount: number, failCount: number, exceptionMessage?: string | null, taskResults: Array<{ __typename?: 'Scheduling_TaskResult', type: Scheduling_TaskResultType, title?: string | null, payload: string }> }> };

export type Tasks_CancelTaskMutationVariables = Exact<{
  input: Tasks_CancelTaskInput;
}>;


export type Tasks_CancelTaskMutation = { __typename?: 'Mutation', tasks_cancelTask: { __typename?: 'Success', success?: boolean | null } };

export type Users_LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type Users_LogoutMutation = { __typename?: 'Mutation', users_logout?: { __typename?: 'Success', success?: boolean | null } | null };

export type YearsQueryVariables = Exact<{
  filter?: InputMaybe<YearGroupFilter>;
}>;


export type YearsQuery = { __typename?: 'Query', catalogue_years: Array<{ __typename?: 'YearGroup', yearGroupId: number, name: string }> };

export type MyAuthDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAuthDetailsQuery = { __typename?: 'Query', myAuthDetails?: { __typename?: 'GlobalUser', id: number, email?: string | null, name?: string | null, defaultProfileId?: number | null, activeProfileId?: number | null, isEmulatingAsTyroUser?: boolean | null, profiles: Array<{ __typename?: 'Profile', id: number, nickName?: string | null, avatarUrl?: string | null, permissionIds?: Array<string | null> | null, partyId?: number | null, tenantId?: number | null, blocked?: Blocked | null, tenant: { __typename?: 'Tenant', tenant: number, name: string, imgUrl?: string | null, tenantType: TenantType }, profileType?: { __typename?: 'ProfileType', name: string, description: string, userType: UserType } | null }> } | null };

export type BackgroundTasksActiveTasksQueryVariables = Exact<{
  filter?: InputMaybe<Tasks_MyTasksFilter>;
}>;


export type BackgroundTasksActiveTasksQuery = { __typename?: 'Query', tasks_tasks: Array<{ __typename?: 'Tasks_TaskExecution', executionId: string }> };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const Calendar_ViewAnaConnectsDocument = new TypedDocumentString(`
    query calendar_viewAnaConnects($filter: Calender_FollowFilter) {
  calendar_viewFollows(filter: $filter) {
    followId
    followerParties {
      __typename
      ... on Staff {
        partyId
        person {
          partyId
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
      }
    }
    followedParties {
      __typename
      ... on Student {
        partyId
        person {
          partyId
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
      }
    }
    fromDate
    toDate
    eventIds
    events {
      eventId
      startTime
      endTime
      colour
      name
    }
    createdBy {
      person {
        partyId
        avatarUrl
        firstName
        lastName
        type
        title {
          id
          name
          nameTextId
        }
      }
    }
    updatedBy {
      person {
        partyId
        avatarUrl
        firstName
        lastName
        type
        title {
          id
          name
          nameTextId
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_ViewAnaConnectsQuery, Calendar_ViewAnaConnectsQueryVariables>;
export const Calendar_UpsertAnaConnectsDocument = new TypedDocumentString(`
    mutation calendar_upsertAnaConnects($input: Calendar_FollowUpsert!) {
  calendar_upsertFollower(input: $input) {
    success
    clashes {
      followEventId
      followEventName
      clashingEvents {
        eventName
        startTime
        clashingParties {
          ... on Staff {
            partyId
            person {
              partyId
              avatarUrl
              firstName
              lastName
              type
              title {
                id
                name
                nameTextId
              }
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_UpsertAnaConnectsMutation, Calendar_UpsertAnaConnectsMutationVariables>;
export const Calendar_DeleteAnaConnectsDocument = new TypedDocumentString(`
    mutation calendar_deleteAnaConnects($input: Calendar_FollowDelete!) {
  calendar_deleteFollowers(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Calendar_DeleteAnaConnectsMutation, Calendar_DeleteAnaConnectsMutationVariables>;
export const Communications_NotificationsDocument = new TypedDocumentString(`
    query communications_notifications($filter: NotificationFilter) {
  communications_notifications(filter: $filter) {
    id
    title
    text
    notificationType
    sentOn
    sender {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    recipients {
      recipientPartyId
      readOn
      status
      metaData {
        partyId
        feeId
        mailId
        threadMessageId
        notificationType
        optionId
        studentPartyId
        substitutionDate
        schoolActivityId
        assessmentId
        formId
        highlightId
        highlightCommentId
        eventStartTime
        staffAbsenceRequestId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Communications_NotificationsQuery, Communications_NotificationsQueryVariables>;
export const Communications_ReadNotificationDocument = new TypedDocumentString(`
    mutation communications_readNotification($input: NotificationReadInput) {
  communications_readNotification(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Communications_ReadNotificationMutation, Communications_ReadNotificationMutationVariables>;
export const Communications_NotificationCountDocument = new TypedDocumentString(`
    query communications_notificationCount {
  communications_notificationCount {
    count
  }
}
    `) as unknown as TypedDocumentString<Communications_NotificationCountQuery, Communications_NotificationCountQueryVariables>;
export const SearchQueryDocument = new TypedDocumentString(`
    query searchQuery($filter: SearchFilter) {
  search_search(filter: $filter) {
    partyId
    type
    text
    avatarUrl
    meta {
      studentPartyId
    }
  }
}
    `) as unknown as TypedDocumentString<SearchQueryQuery, SearchQueryQueryVariables>;
export const Composite_SwitchProfileDocument = new TypedDocumentString(`
    mutation composite_switchProfile($input: SwitchProfileInput!) {
  composite_switchProfile(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Composite_SwitchProfileMutation, Composite_SwitchProfileMutationVariables>;
export const Users_SetDefaultProfileDocument = new TypedDocumentString(`
    mutation users_setDefaultProfile($input: DefaultProfileInput!) {
  users_setDefaultProfile {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_SetDefaultProfileMutation, Users_SetDefaultProfileMutationVariables>;
export const Tyrone_ConversationHistoryDocument = new TypedDocumentString(`
    query tyrone_conversationHistory($conversationId: String!) {
  tyrone_conversationHistory(conversationId: $conversationId) {
    messages {
      id
      conversationId
      requestNumber
      prompt
      response
    }
  }
}
    `) as unknown as TypedDocumentString<Tyrone_ConversationHistoryQuery, Tyrone_ConversationHistoryQueryVariables>;
export const Tyrone_MyConversationsDocument = new TypedDocumentString(`
    query tyrone_myConversations {
  tyrone_myConversations {
    id
    partyId
    initialMessage
    createdOn
    updatedOn
  }
}
    `) as unknown as TypedDocumentString<Tyrone_MyConversationsQuery, Tyrone_MyConversationsQueryVariables>;
export const Assessment_ArchiveClassAssessmentDocument = new TypedDocumentString(`
    mutation assessment_archiveClassAssessment($input: Long!) {
  assessment_archiveClassAssessment(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Assessment_ArchiveClassAssessmentMutation, Assessment_ArchiveClassAssessmentMutationVariables>;
export const Assessment_ArchiveStateCbaAssessmentDocument = new TypedDocumentString(`
    mutation assessment_archiveStateCbaAssessment($input: Long!) {
  assessment_archiveStateCbaAssessment(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Assessment_ArchiveStateCbaAssessmentMutation, Assessment_ArchiveStateCbaAssessmentMutationVariables>;
export const Assessment_ArchiveTermAssessmentDocument = new TypedDocumentString(`
    mutation assessment_archiveTermAssessment($input: Long!) {
  assessment_archiveTermAssessment(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Assessment_ArchiveTermAssessmentMutation, Assessment_ArchiveTermAssessmentMutationVariables>;
export const Assessment_AssessmentResultDocument = new TypedDocumentString(`
    query assessment_assessmentResult($filter: AssessmentResultFilter) {
  assessment_assessmentResult(filter: $filter) {
    id
    assessmentId
    studentPartyId
    student {
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      extensions {
        priority
        aen
        medical
      }
    }
    studentClassGroup
    studentProgramme {
      shortName
    }
    subjectGroup {
      partyId
      name
      irePP {
        examinable
      }
    }
    studentStudyLevel
    result
    gradeId
    gradeResult
    targetResult
    targetGradeId
    targetGradeResult
    teacherComment {
      id
      assessmentId
      studentPartyId
      comment
      commentBankCommentId
      commenterUserType
      commenterPartyId
      subjectGroupPartyId
    }
    extraFields {
      id
      extraFieldType
      assessmentResultId
      assessmentExtraFieldId
      result
      gradeSetGradeId
      gradeNameTextId
      commentBankCommentId
    }
    examinable
    absent
    ppodPublished
    ppodErrorMessage
    ppodResult
  }
}
    `) as unknown as TypedDocumentString<Assessment_AssessmentResultQuery, Assessment_AssessmentResultQueryVariables>;
export const Assessment_SaveAssessmentResultsDocument = new TypedDocumentString(`
    mutation assessment_saveAssessmentResults($input: [SaveAssessmentResultInput!]) {
  assessment_saveAssessmentResults(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Assessment_SaveAssessmentResultsMutation, Assessment_SaveAssessmentResultsMutationVariables>;
export const AssessmentSubjectGroupsDocument = new TypedDocumentString(`
    query assessmentSubjectGroups($filter: AssessmentSubjectGroupsFilter) {
  assessment_assessmentSubjectGroups(filter: $filter) {
    subjectGroup {
      partyId
      name
      avatarUrl
      subjects {
        name
        colour
        nationalCode
      }
      staff {
        partyId
        title {
          id
          name
          nameTextId
        }
        avatarUrl
        firstName
        lastName
      }
      yearGroups {
        yearGroupId
        name
      }
    }
    resultsTotal
    resultsEntered
    commentsEntered
    commentsTotal
    extraFieldResultsEntered
    extraFieldResultsTotal
    ppodSyncStatus
    ppodErrorMessages
    published
  }
}
    `) as unknown as TypedDocumentString<AssessmentSubjectGroupsQuery, AssessmentSubjectGroupsQueryVariables>;
export const AssessmentsListDocument = new TypedDocumentString(`
    query assessmentsList($filter: AssessmentFilter) {
  assessment_assessment(filter: $filter) {
    id
    name
    assessmentType
    stateCbaType
    academicNamespaceId
    subjectGroups {
      name
      yearGroups {
        partyId
        name
      }
    }
    years {
      yearGroupId
      name
    }
    programmeStages {
      id
      name
      yearGroupId
    }
    publish
    publishedFrom
    publishLearner
    allowLearnerPrint
    openForResultEntry
    archived
    docxFileTransferId
    startDate
    endDate
    createdBy {
      partyId
      firstName
      lastName
      type
      avatarUrl
      title {
        id
        name
        nameTextId
      }
    }
    canEnterOverallComments
    ppodSyncedSubjectGroupCount
    ppodTotalSubjectGroupCount
  }
}
    `) as unknown as TypedDocumentString<AssessmentsListQuery, AssessmentsListQueryVariables>;
export const AssessmentDocument = new TypedDocumentString(`
    query assessment($filter: AssessmentFilter) {
  assessment_assessment(filter: $filter) {
    id
    name
    description
    assessmentType
    academicNamespaceId
    years {
      yearGroupId
      name
    }
    programmeStages {
      id
      name
      yearGroupId
      programme {
        shortName
      }
    }
    yearGroupEnrolments {
      partyId
      yearGroupEnrollmentPartyId
      yearGroupId
      name
    }
    publish
    createdOn
    gradeType
    showType
    gradeSets {
      id
      name
    }
    passFailThreshold
    captureTarget
    commentType
    commentLength
    commentBank {
      commentBankId
      commentBankName
    }
    publish
    publishLearner
    allowLearnerPrint
    openForResultEntry
    docxFileTransferId
    extraFields {
      id
      order
      name
      assessmentId
      extraFieldType
      gradeSetId
      commentBankId
      commentBankName
      selectOptions
      commentLength
      resultsEntered
    }
    createdBy {
      partyId
      type
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
    }
    stateCbaType
    subjectGroups {
      partyId
      name
      subjects {
        name
        id
        colour
      }
    }
    startDate
    endDate
    captureTutorComment
    capturePrincipalComment
    captureYearHeadComment
    captureHouseMasterComment
    tutorCommentType
    tutorCommentBank {
      commentBankId
      commentBankName
    }
    tutorCommentLength
    yearHeadCommentType
    yearHeadCommentBank {
      commentBankId
      commentBankName
    }
    yearHeadCommentLength
    principalCommentType
    principalCommentBank {
      commentBankId
      commentBankName
    }
    principalCommentLength
    housemasterCommentType
    housemasterCommentBank {
      commentBankId
      commentBankName
    }
    housemasterCommentLength
  }
}
    `) as unknown as TypedDocumentString<AssessmentQuery, AssessmentQueryVariables>;
export const CommentBankAssessmentDocument = new TypedDocumentString(`
    query commentBankAssessment($filter: CommentBankFilter) {
  assessment_commentBank(filter: $filter) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<CommentBankAssessmentQuery, CommentBankAssessmentQueryVariables>;
export const CommentBanksWithCommentsDocument = new TypedDocumentString(`
    query commentBanksWithComments($filter: CommentBankFilter) {
  assessment_commentBank(filter: $filter) {
    id
    name
    comments {
      id
      comment
      active
    }
  }
}
    `) as unknown as TypedDocumentString<CommentBanksWithCommentsQuery, CommentBanksWithCommentsQueryVariables>;
export const Assessment_GradesDocument = new TypedDocumentString(`
    query assessment_grades($filter: GradeFilter) {
  assessment_grades(filter: $filter) {
    id
    name
    start
    end
    active
    studyLevels
  }
}
    `) as unknown as TypedDocumentString<Assessment_GradesQuery, Assessment_GradesQueryVariables>;
export const Assessment_GradeSetDocument = new TypedDocumentString(`
    query assessment_gradeSet($filter: GradeSetFilter) {
  assessment_gradeSet(filter: $filter) {
    id
    name
    description
    active
    customGradeSet
    isCba
    grades {
      id
      name
      nameTextId
      start
      end
      active
    }
    years
    type
  }
}
    `) as unknown as TypedDocumentString<Assessment_GradeSetQuery, Assessment_GradeSetQueryVariables>;
export const Assessment_SaveGradeSetDocument = new TypedDocumentString(`
    mutation assessment_saveGradeSet($input: SaveGradeSetInput) {
  assessment_saveGradeSet(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Assessment_SaveGradeSetMutation, Assessment_SaveGradeSetMutationVariables>;
export const Assessment_UpdateGradeSetDocument = new TypedDocumentString(`
    mutation assessment_updateGradeSet($input: [UpdateGradeSetInput]) {
  assessment_updateGradeSet(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Assessment_UpdateGradeSetMutation, Assessment_UpdateGradeSetMutationVariables>;
export const InClassAssessmentsDocument = new TypedDocumentString(`
    query inClassAssessments($filter: AssessmentFilter) {
  assessment_assessment(filter: $filter) {
    id
    name
    assessmentType
  }
}
    `) as unknown as TypedDocumentString<InClassAssessmentsQuery, InClassAssessmentsQueryVariables>;
export const Assessment_SaveClassAssessmentDocument = new TypedDocumentString(`
    mutation assessment_saveClassAssessment($input: SaveClassAssessmentInput) {
  assessment_saveClassAssessment(input: $input) {
    id
    academicNamespaceId
    name
    assessmentType
    startDate
    endDate
    gradeSets {
      id
    }
    captureTarget
    commentType
    capturePrincipalComment
    captureYearHeadComment
    captureTutorComment
    captureHouseMasterComment
    publish
    publishLearner
    yearGroupIds
    years {
      yearGroupId
      nameTextId
      shortNameTextId
      nationalCode
      name
      shortName
    }
    canEnterOverallComments
    createdOn
  }
}
    `) as unknown as TypedDocumentString<Assessment_SaveClassAssessmentMutation, Assessment_SaveClassAssessmentMutationVariables>;
export const Assessment_SetOpenForResultEntryDocument = new TypedDocumentString(`
    mutation assessment_setOpenForResultEntry($input: SetOpenForResultEntryInput) {
  assessment_setOpenForResultEntry(input: $input) {
    id
    openForResultEntry
  }
}
    `) as unknown as TypedDocumentString<Assessment_SetOpenForResultEntryMutation, Assessment_SetOpenForResultEntryMutationVariables>;
export const Assessment_OverallCommentsDocument = new TypedDocumentString(`
    query assessment_overallComments($filter: OverallCommentsFilter) {
  assessment_overallComments(filter: $filter) {
    tutorCommentsEntered
    yearHeadCommentsEntered
    principalCommentsEntered
    totalCommentsToEnter
    students {
      studentPartyId
      student {
        person {
          partyId
          firstName
          lastName
          avatarUrl
          type
          title {
            id
            name
            nameTextId
          }
        }
        classGroup {
          partyId
          name
        }
        programmeStages {
          id
          name
          programme {
            shortName
          }
        }
        subjectGroups {
          partyId
          name
          subjects {
            id
            name
            colour
          }
          staff {
            partyId
            firstName
            lastName
            avatarUrl
            type
            title {
              id
              name
              nameTextId
            }
          }
        }
      }
      commentStatus
      principalComment
      yearHeadComment
      tutorComment
    }
  }
}
    `) as unknown as TypedDocumentString<Assessment_OverallCommentsQuery, Assessment_OverallCommentsQueryVariables>;
export const Assessment_PublishStateCbaDocument = new TypedDocumentString(`
    mutation assessment_publishStateCba($input: PublishAssessmentInput) {
  assessment_publishStateCba(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Assessment_PublishStateCbaMutation, Assessment_PublishStateCbaMutationVariables>;
export const Assessment_PublishDocument = new TypedDocumentString(`
    mutation assessment_publish($input: PublishAssessmentInput) {
  assessment_publish(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Assessment_PublishMutation, Assessment_PublishMutationVariables>;
export const SaveTermAssessmentDocument = new TypedDocumentString(`
    mutation saveTermAssessment($input: SaveTermAssessmentInput) {
  assessment_saveTermAssessment(input: $input) {
    name
    years {
      name
    }
    startDate
    endDate
  }
}
    `) as unknown as TypedDocumentString<SaveTermAssessmentMutation, SaveTermAssessmentMutationVariables>;
export const Assessment_PublishPpodResultsDocument = new TypedDocumentString(`
    mutation assessment_publishPPODResults($input: PPODPublishResultsInput) {
  assessment_publishPPODResults(input: $input) {
    id
    assessmentId
    studentPartyId
  }
}
    `) as unknown as TypedDocumentString<Assessment_PublishPpodResultsMutation, Assessment_PublishPpodResultsMutationVariables>;
export const Assessment_SaveStateCbaAssessmentDocument = new TypedDocumentString(`
    mutation assessment_saveStateCbaAssessment($input: SaveStateCbaAssessmentInput) {
  assessment_saveStateCbaAssessment(input: $input) {
    id
    academicNamespaceId
    name
    assessmentType
    startDate
    endDate
    yearGroupIds
    years {
      yearGroupId
      name
    }
    extraFields {
      id
      order
      name
      assessmentId
      extraFieldType
      gradeSetId
      commentBankId
      commentBankName
      selectOptions
      commentLength
    }
    createdBy {
      partyId
      firstName
      lastName
      type
      avatarUrl
      title {
        id
        name
        nameTextId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Assessment_SaveStateCbaAssessmentMutation, Assessment_SaveStateCbaAssessmentMutationVariables>;
export const Assessment_VerifyPpodResultsDocument = new TypedDocumentString(`
    mutation assessment_verifyPPODResults($input: PPODPublishResultsInput) {
  assessment_verifyPPODResults(input: $input) {
    matchCount
    mismatchCount
    notFoundOnPpodCount
    unexpectedOnPpodCount
    notPublishedCount
    results {
      assessmentResultId
      studentPartyId
      nationalCode
      lastPublishedGrade
      ppodGrade
      status
    }
  }
}
    `) as unknown as TypedDocumentString<Assessment_VerifyPpodResultsMutation, Assessment_VerifyPpodResultsMutationVariables>;
export const Assessment_StudentAssessmentExclusionDocument = new TypedDocumentString(`
    mutation assessment_studentAssessmentExclusion($input: [StudentAssessmentExclusionInput]) {
  assessment_studentAssessmentExclusion(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Assessment_StudentAssessmentExclusionMutation, Assessment_StudentAssessmentExclusionMutationVariables>;
export const DashboardAssessmentDocument = new TypedDocumentString(`
    query dashboardAssessment($filter: DashboardAssessmentFilter) {
  assessment_dashboardAssessment(filter: $filter) {
    id
    name
    description
    assessmentType
    startDate
    endDate
    results {
      id
      subject
      result
      grade
      studyLevel
    }
    publishedFrom
  }
}
    `) as unknown as TypedDocumentString<DashboardAssessmentQuery, DashboardAssessmentQueryVariables>;
export const Assessment_AssessmentCommentDocument = new TypedDocumentString(`
    query assessment_assessmentComment($filter: AssessmentCommentFilter) {
  assessment_assessmentComment(filter: $filter) {
    id
    comment
    commentBankCommentId
    commenterUserType
    commenterPartyId
  }
}
    `) as unknown as TypedDocumentString<Assessment_AssessmentCommentQuery, Assessment_AssessmentCommentQueryVariables>;
export const Assessment_SaveAssessmentCommentsDocument = new TypedDocumentString(`
    mutation assessment_saveAssessmentComments($input: [SaveAssessmentCommentInput!]) {
  assessment_saveAssessmentComments(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Assessment_SaveAssessmentCommentsMutation, Assessment_SaveAssessmentCommentsMutationVariables>;
export const Core_ProgrammeStageEnrollmentsDocument = new TypedDocumentString(`
    query core_programmeStageEnrollments {
  core_programmeStageEnrollments {
    name
    programmeStageId
    programmeStage {
      yearGroupId
    }
  }
}
    `) as unknown as TypedDocumentString<Core_ProgrammeStageEnrollmentsQuery, Core_ProgrammeStageEnrollmentsQueryVariables>;
export const Assessment_StudentResultDocument = new TypedDocumentString(`
    query assessment_studentResult($filter: StudentResultFilter) {
  assessment_studentResult(filter: $filter) {
    id
    assessmentId
    studentPartyId
    student {
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      extensions {
        priority
        aen
        medical
      }
    }
    studentClassGroup
    studentProgramme {
      shortName
    }
    subjectGroup {
      partyId
      name
      staff {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      subjects {
        name
        colour
        nationalCode
      }
    }
    studentStudyLevel
    result
    targetResult
    gradeResult
    gradeNameTextId
    targetGradeResult
    targetGradeNameTextId
    examinable
    teacherComment {
      id
      assessmentId
      studentPartyId
      comment
      commentBankCommentId
      commenterUserType
      commenterPartyId
      subjectGroupPartyId
    }
    extraFields {
      id
      extraFieldType
      assessmentResultId
      assessmentExtraFieldId
      result
      gradeSetGradeId
      gradeNameTextId
      commentBankCommentId
    }
  }
}
    `) as unknown as TypedDocumentString<Assessment_StudentResultQuery, Assessment_StudentResultQueryVariables>;
export const Assessment_UnarchiveClassAssessmentDocument = new TypedDocumentString(`
    mutation assessment_unarchiveClassAssessment($input: Long!) {
  assessment_unarchiveClassAssessment(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Assessment_UnarchiveClassAssessmentMutation, Assessment_UnarchiveClassAssessmentMutationVariables>;
export const Assessment_UnarchiveStateCbaAssessmentDocument = new TypedDocumentString(`
    mutation assessment_unarchiveStateCbaAssessment($input: Long!) {
  assessment_unarchiveStateCbaAssessment(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Assessment_UnarchiveStateCbaAssessmentMutation, Assessment_UnarchiveStateCbaAssessmentMutationVariables>;
export const Assessment_UnarchiveTermAssessmentDocument = new TypedDocumentString(`
    mutation assessment_unarchiveTermAssessment($input: Long!) {
  assessment_unarchiveTermAssessment(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Assessment_UnarchiveTermAssessmentMutation, Assessment_UnarchiveTermAssessmentMutationVariables>;
export const Attendance_ParentalAttendanceRequestsDocument = new TypedDocumentString(`
    query attendance_parentalAttendanceRequests($filter: ParentalAttendanceRequestFilter) {
  attendance_parentalAttendanceRequests(filter: $filter) {
    id
    adminNote
    attendanceCode {
      id
      code
      name
      description
    }
    approvedBy {
      avatarUrl
      firstName
      lastName
      type
      title {
        id
        name
        nameTextId
      }
    }
    approvedByPartyId
    attendanceCodeId
    contactPartyId
    from
    parentNote
    attendanceNote
    requestType
    status
    studentPartyId
    to
    classGroup {
      name
      yearGroups {
        name
      }
    }
    contact {
      person {
        avatarUrl
        firstName
        lastName
        type
        title {
          id
          name
          nameTextId
        }
      }
      relationships {
        relationshipType
        studentPartyId
      }
    }
    submittedBy {
      avatarUrl
      firstName
      lastName
      type
      title {
        id
        name
        nameTextId
      }
    }
    createdOn
    attachments
    studentNew {
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      extensions {
        priority
        aen
        medical
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Attendance_ParentalAttendanceRequestsQuery, Attendance_ParentalAttendanceRequestsQueryVariables>;
export const Attendance_ParentalRequestCountDocument = new TypedDocumentString(`
    query attendance_parentalRequestCount($filter: String) {
  attendance_parentalRequestCount {
    count
  }
}
    `) as unknown as TypedDocumentString<Attendance_ParentalRequestCountQuery, Attendance_ParentalRequestCountQueryVariables>;
export const Attendance_SaveParentalAttendanceRequestDocument = new TypedDocumentString(`
    mutation attendance_saveParentalAttendanceRequest($input: [SaveParentalAttendanceRequest]) {
  attendance_saveParentalAttendanceRequest(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Attendance_SaveParentalAttendanceRequestMutation, Attendance_SaveParentalAttendanceRequestMutationVariables>;
export const Attendance_UpdateParentalAttendanceRequestDocument = new TypedDocumentString(`
    mutation attendance_updateParentalAttendanceRequest($input: [UpdateParentalAttendanceRequest]) {
  attendance_updateParentalAttendanceRequest(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Attendance_UpdateParentalAttendanceRequestMutation, Attendance_UpdateParentalAttendanceRequestMutationVariables>;
export const Attendance_WithdrawParentalAttendanceRequestDocument = new TypedDocumentString(`
    mutation attendance_withdrawParentalAttendanceRequest($input: WithdrawParentalAttendanceRequest) {
  attendance_withdrawParentalAttendanceRequest(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Attendance_WithdrawParentalAttendanceRequestMutation, Attendance_WithdrawParentalAttendanceRequestMutationVariables>;
export const Attendance_UndoParentalAttendanceRequestDocument = new TypedDocumentString(`
    mutation attendance_undoParentalAttendanceRequest($input: Attendance_RollbackParentalAttendanceInput) {
  attendance_undoParentalAttendanceRequest(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Attendance_UndoParentalAttendanceRequestMutation, Attendance_UndoParentalAttendanceRequestMutationVariables>;
export const Attendance_AttendanceCodesDocument = new TypedDocumentString(`
    query attendance_attendanceCodes($filter: AttendanceCodeFilter) {
  attendance_attendanceCodes(filter: $filter) {
    id
    name
    description
    code
    active
    visibleForTeacher
    visibleForContact
    nameTextId
    codeType
    sessionCodeType
    custom
  }
}
    `) as unknown as TypedDocumentString<Attendance_AttendanceCodesQuery, Attendance_AttendanceCodesQueryVariables>;
export const Attendance_SaveAttendanceCodeDocument = new TypedDocumentString(`
    mutation attendance_saveAttendanceCode($input: [SaveAttendanceCodeInput]) {
  attendance_saveAttendanceCode(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Attendance_SaveAttendanceCodeMutation, Attendance_SaveAttendanceCodeMutationVariables>;
export const Attendance_SaveEventAttendanceDocument = new TypedDocumentString(`
    mutation attendance_saveEventAttendance($input: [SaveEventAttendanceInput]) {
  attendance_saveEventAttendance(input: $input) {
    id
    eventId
    attendanceCodeId
    personPartyId
    date
  }
}
    `) as unknown as TypedDocumentString<Attendance_SaveEventAttendanceMutation, Attendance_SaveEventAttendanceMutationVariables>;
export const Attendance_BulkAttendanceActionsDocument = new TypedDocumentString(`
    query attendance_bulkAttendanceActions($filter: Attendance_BulkAttendanceActionFilter!) {
  attendance_bulkAttendanceActions(filter: $filter) {
    id
    attendanceForPartyIds
    parties {
      ... on Student {
        __typename
        partyId
        person {
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
      ... on SubjectGroup {
        partyId
        actualName
        name
        avatarUrl
        __typename
      }
      ... on GeneralGroup {
        __typename
        partyId
        generalGroupType
        name
        classGroupInfo {
          __typename
        }
      }
      ... on ProgrammeStageEnrollment {
        __typename
        partyId
        name
      }
      ... on YearGroupEnrollment {
        __typename
        partyId
        name
      }
      ... on Staff {
        __typename
        partyId
        person {
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
      ... on StudentContact {
        __typename
        partyId
        person {
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
    }
    attendanceCodeId
    attendanceCode {
      id
      name
      description
      code
      active
      visibleForTeacher
      visibleForContact
      nameTextId
      descriptionTextId
      codeType
      sessionCodeType
      custom
    }
    startDate
    endDate
    leavesAt
    returnsAt
    partial
    note
    createdBy {
      userId
      partyId
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
    }
    createdOn
    action
  }
}
    `) as unknown as TypedDocumentString<Attendance_BulkAttendanceActionsQuery, Attendance_BulkAttendanceActionsQueryVariables>;
export const Attendance_SaveBulkAttendanceDocument = new TypedDocumentString(`
    mutation attendance_saveBulkAttendance($input: Attendance_SaveBulkAttendanceInput) {
  attendance_saveBulkAttendance(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Attendance_SaveBulkAttendanceMutation, Attendance_SaveBulkAttendanceMutationVariables>;
export const BulkAttendanceSearchDocument = new TypedDocumentString(`
    query bulkAttendanceSearch($filter: SearchFilter) {
  search_search(filter: $filter) {
    partyId
    type
    text
    avatarUrl
    meta {
      studentPartyId
    }
  }
}
    `) as unknown as TypedDocumentString<BulkAttendanceSearchQuery, BulkAttendanceSearchQueryVariables>;
export const Attendance_RollBackAndSaveNewBulkAttendanceDocument = new TypedDocumentString(`
    mutation attendance_rollBackAndSaveNewBulkAttendance($input: Attendance_RollBackAndSaveBulkAttendanceInput) {
  attendance_rollBackAndSaveNewBulkAttendance(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Attendance_RollBackAndSaveNewBulkAttendanceMutation, Attendance_RollBackAndSaveNewBulkAttendanceMutationVariables>;
export const Attendance_RollBackBulkAttendanceDocument = new TypedDocumentString(`
    mutation attendance_rollBackBulkAttendance($input: Attendance_RollBackBulkAttendanceInput) {
  attendance_rollBackBulkAttendance(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Attendance_RollBackBulkAttendanceMutation, Attendance_RollBackBulkAttendanceMutationVariables>;
export const Attendance_CalendarAttendanceDocument = new TypedDocumentString(`
    query attendance_calendarAttendance($filter: CalendarAttendanceFilter) {
  attendance_calendarAttendance(filter: $filter) {
    totalPresent
    totalLate
    totalAbsent
    totalUnexplained
    totalNotTaken
    totalPartial
    attendances {
      date
      status
      partiallyTaken
    }
  }
}
    `) as unknown as TypedDocumentString<Attendance_CalendarAttendanceQuery, Attendance_CalendarAttendanceQueryVariables>;
export const Calendar_CalendarDayBellTimesDocument = new TypedDocumentString(`
    query calendar_calendarDayBellTimes($filter: CalendarDayBellTimeFilter) {
  calendar_calendarDayBellTimes(filter: $filter) {
    date
    bellTimeIds
    dayType
    bellTimes {
      id
      time
      name
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_CalendarDayBellTimesQuery, Calendar_CalendarDayBellTimesQueryVariables>;
export const Calendar_CalendarLessonTimesDocument = new TypedDocumentString(`
    query calendar_calendarLessonTimes($filter: CalendarEventFilter) {
  calendar_calendarEvents(filter: $filter) {
    resources {
      events {
        name
        eventId
        startTime
        endTime
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_CalendarLessonTimesQuery, Calendar_CalendarLessonTimesQueryVariables>;
export const Calendar_CalendarInformationDocument = new TypedDocumentString(`
    query calendar_calendarInformation($filter: CalendarEventFilter) {
  calendar_calendarEvents(filter: $filter) {
    resources {
      events {
        eventId
        startTime
        endTime
        type
        lessonInfo {
          subjectGroupId
        }
        colour
        name
        extensions {
          eventAttendance {
            id
            eventId
            attendanceCodeId
            attendanceCode {
              name
              codeType
            }
            personPartyId
            date
            note
            createdByPartyId
            createdBy {
              partyId
              firstName
              lastName
              type
              avatarUrl
              title {
                id
                name
                nameTextId
              }
            }
            updatedAt
            updatedByPartyId
            updatedBy {
              partyId
              firstName
              lastName
              type
              avatarUrl
              title {
                id
                name
                nameTextId
              }
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_CalendarInformationQuery, Calendar_CalendarInformationQueryVariables>;
export const StudentSessionAttendanceDocument = new TypedDocumentString(`
    query studentSessionAttendance($filter: StudentSessionAttendanceFilter) {
  attendance_studentSessionAttendance(filter: $filter) {
    dateAttendance {
      date
      bellTimeAttendance {
        bellTimeId
        bellTime {
          time
          name
        }
        attendanceCode {
          id
          name
          description
          code
          codeType
        }
        note
        createdBy {
          partyId
          firstName
          lastName
          type
          avatarUrl
          title {
            id
            name
            nameTextId
          }
        }
        createdByPartyId
        updatedBy {
          partyId
          firstName
          lastName
          type
          avatarUrl
          title {
            id
            name
            nameTextId
          }
        }
        updatedAt
        updatedByPartyId
      }
    }
    studentPartyId
    student {
      person {
        partyId
        firstName
        lastName
        type
        avatarUrl
        title {
          id
          name
          nameTextId
        }
      }
    }
    classGroup {
      name
      staff {
        partyId
        firstName
        lastName
        type
        avatarUrl
        title {
          id
          name
          nameTextId
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StudentSessionAttendanceQuery, StudentSessionAttendanceQueryVariables>;
export const Attendance_MergeAttendanceCodesDocument = new TypedDocumentString(`
    mutation attendance_mergeAttendanceCodes($input: Attendance_MergeAttendanceCodeInput!) {
  attendance_mergeAttendanceCodes(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Attendance_MergeAttendanceCodesMutation, Attendance_MergeAttendanceCodesMutationVariables>;
export const Attendance_RollBookAttendanceDocument = new TypedDocumentString(`
    query attendance_rollBookAttendance($filter: Attendance_RollBookFilter) {
  attendance_rollBookAttendance(filter: $filter) {
    studentPartyId
    student {
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      extensions {
        priority
        aen
        medical
      }
    }
    classGroup {
      name
    }
    dateAttendance {
      date
      eventAttendance {
        eventId
        date
        time
        attendanceCode {
          id
          name
          codeType
        }
        note
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Attendance_RollBookAttendanceQuery, Attendance_RollBookAttendanceQueryVariables>;
export const SaveStudentSessionAttendanceDocument = new TypedDocumentString(`
    mutation saveStudentSessionAttendance($input: SaveStudentSessionAttendanceInput) {
  attendance_saveStudentSessionAttendance(input: $input) {
    studentPartyId
  }
}
    `) as unknown as TypedDocumentString<SaveStudentSessionAttendanceMutation, SaveStudentSessionAttendanceMutationVariables>;
export const Attendance_SaveSchoolActivityEventAttendanceDocument = new TypedDocumentString(`
    mutation attendance_saveSchoolActivityEventAttendance($input: [SaveSchoolActivityAttendanceInput!]!) {
  attendance_saveSchoolActivityEventAttendance(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Attendance_SaveSchoolActivityEventAttendanceMutation, Attendance_SaveSchoolActivityEventAttendanceMutationVariables>;
export const Attendance_SessionAttendanceReportDocument = new TypedDocumentString(`
    query attendance_sessionAttendanceReport($filter: SessionAttendanceListFilter) {
  attendance_sessionAttendanceList(filter: $filter) {
    id
    studentPartyId
    attendanceCode {
      id
      code
      name
    }
    student {
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      extensions {
        priority
        aen
        medical
      }
      yearGroups {
        name
      }
    }
    bellTime {
      id
      time
      name
    }
    attendanceCodeId
    classGroup {
      name
    }
    date
    note
  }
}
    `) as unknown as TypedDocumentString<Attendance_SessionAttendanceReportQuery, Attendance_SessionAttendanceReportQueryVariables>;
export const Attendance_StudentSessionAttendanceDocument = new TypedDocumentString(`
    query attendance_studentSessionAttendance($filter: StudentSessionAttendanceFilter) {
  attendance_studentSessionAttendance(filter: $filter) {
    studentPartyId
    student {
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      extensions {
        priority
        aen
        medical
      }
    }
    classGroup {
      name
    }
    dateAttendance {
      date
      bellTimeAttendance {
        bellTimeId
        attendanceCode {
          id
          name
          codeType
        }
        note
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Attendance_StudentSessionAttendanceQuery, Attendance_StudentSessionAttendanceQueryVariables>;
export const Attendance_SaveStudentSessionAttendanceDocument = new TypedDocumentString(`
    mutation attendance_saveStudentSessionAttendance($input: SaveStudentSessionAttendanceInput) {
  attendance_saveStudentSessionAttendance(input: $input) {
    studentPartyId
  }
}
    `) as unknown as TypedDocumentString<Attendance_SaveStudentSessionAttendanceMutation, Attendance_SaveStudentSessionAttendanceMutationVariables>;
export const SessionPartySearchQueryDocument = new TypedDocumentString(`
    query sessionPartySearchQuery($filter: SearchFilter) {
  search_search(filter: $filter) {
    partyId
    type
    text
    avatarUrl
  }
}
    `) as unknown as TypedDocumentString<SessionPartySearchQueryQuery, SessionPartySearchQueryQueryVariables>;
export const Attendance_SignInOutReportDocument = new TypedDocumentString(`
    query attendance_signInOutReport($filter: Attendance_SignInOutReportFilter!) {
  attendance_signInOutReport(filter: $filter) {
    id
    dateTime
    note
    type
    signInOutPersonType
    createdByPartyId
    createdBy {
      partyId
      person {
        avatarUrl
        firstName
        lastName
        type
        title {
          id
          name
          nameTextId
        }
      }
    }
    __typename
    ... on StudentSignInOut {
      student {
        person {
          partyId
          firstName
          lastName
          avatarUrl
          type
          title {
            id
            name
            nameTextId
          }
        }
        classGroup {
          name
        }
      }
      attendanceCodeId
      attendanceCode {
        id
        name
      }
      parentalAttendanceRequest {
        id
        requestType
        contact {
          person {
            avatarUrl
            firstName
            lastName
            type
            title {
              id
              name
              nameTextId
            }
          }
          relationships {
            relationshipType
            studentPartyId
          }
        }
        attendanceCode {
          id
          code
          name
          description
        }
        from
        to
        parentNote
      }
      collectedBy
    }
    ... on VisitorSignInOut {
      firstname
      lastname
      visitingStaff {
        person {
          partyId
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Attendance_SignInOutReportQuery, Attendance_SignInOutReportQueryVariables>;
export const Attendance_DeleteSignInOutDocument = new TypedDocumentString(`
    mutation attendance_deleteSignInOut($input: Attendance_SignInOutDeleteInput) {
  attendance_deleteSignInOut(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Attendance_DeleteSignInOutMutation, Attendance_DeleteSignInOutMutationVariables>;
export const Attendance_SaveSignInOutDocument = new TypedDocumentString(`
    mutation attendance_saveSignInOut($input: [Attendance_SignInOutInput]) {
  attendance_saveSignInOut(input: $input) {
    id
    dateTime
    note
    type
    signInOutPersonType
    createdBy {
      person {
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
    }
    createdByPartyId
  }
}
    `) as unknown as TypedDocumentString<Attendance_SaveSignInOutMutation, Attendance_SaveSignInOutMutationVariables>;
export const Attendance_StudentRollBookAttendanceDocument = new TypedDocumentString(`
    query attendance_studentRollBookAttendance($filter: Attendance_StudentRollBookFilter) {
  attendance_studentRollBookAttendance(filter: $filter) {
    events {
      eventId
      gridIdx
      startTime
      endTime
      name
      colour
      attendees {
        partyId
        type
        partyInfo {
          partyId
          __typename
          ... on Staff {
            person {
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              type
            }
          }
        }
      }
      rooms {
        roomId
        name
      }
    }
    students {
      student {
        person {
          partyId
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
        extensions {
          priority
          aen
          medical
        }
      }
      classGroup {
        name
      }
      dateAttendance {
        date
        periodAttendance {
          periodIdx
          eventId
          attendanceCode {
            id
            name
            codeType
          }
          note
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Attendance_StudentRollBookAttendanceQuery, Attendance_StudentRollBookAttendanceQueryVariables>;
export const TableSessionAttendanceViewDocument = new TypedDocumentString(`
    query tableSessionAttendanceView($filter: StudentSessionAttendanceFilter) {
  attendance_studentSessionAttendance(filter: $filter) {
    dateAttendance {
      date
      bellTimeAttendance {
        bellTimeId
        bellTime {
          time
          name
        }
        attendanceCode {
          id
          name
          description
          code
          codeType
        }
        note
        createdBy {
          partyId
          firstName
          lastName
          type
          avatarUrl
          title {
            id
            name
            nameTextId
          }
        }
        createdByPartyId
        updatedByPartyId
        updatedBy {
          partyId
          firstName
          lastName
          type
          avatarUrl
          title {
            id
            name
            nameTextId
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TableSessionAttendanceViewQuery, TableSessionAttendanceViewQueryVariables>;
export const Users_ValidateUserProfileDocument = new TypedDocumentString(`
    mutation users_validateUserProfile($input: ValidateUserProfile!) {
  users_validateUserProfile(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_ValidateUserProfileMutation, Users_ValidateUserProfileMutationVariables>;
export const Calendar_FindFreeResourcesDocument = new TypedDocumentString(`
    query calendar_findFreeResources($filter: FindFreeResourcesFilter) {
  calendar_findFreeResources(filter: $filter) {
    freeRooms {
      roomId
      name
    }
    clashingRooms {
      room {
        roomId
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_FindFreeResourcesQuery, Calendar_FindFreeResourcesQueryVariables>;
export const Calendar_CreateCalendarEventsDocument = new TypedDocumentString(`
    mutation calendar_createCalendarEvents($input: CreateCalendarEventsInput!) {
  calendar_createCalendarEvents(input: $input) {
    success
    clashes {
      eventId
      event
      startTime
      endTime
      clashingRooms {
        roomId
        name
      }
      clashingParties {
        __typename
        ... on Staff {
          partyId
          person {
            partyId
            firstName
            lastName
            avatarUrl
            type
            title {
              id
              name
              nameTextId
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_CreateCalendarEventsMutation, Calendar_CreateCalendarEventsMutationVariables>;
export const CalendarSearchQueryDocument = new TypedDocumentString(`
    query calendarSearchQuery($filter: SearchFilter) {
  search_search(filter: $filter) {
    partyId
    type
    text
    avatarUrl
  }
}
    `) as unknown as TypedDocumentString<CalendarSearchQueryQuery, CalendarSearchQueryQueryVariables>;
export const Calendar_CancellationRecommendationsDocument = new TypedDocumentString(`
    query calendar_cancellationRecommendations($filter: Calendar_CancellationRecommendationFilter!) {
  calendar_cancellationRecommendations(filter: $filter) {
    recommendations {
      event {
        name
        colour
        calendarEventId {
          eventId
          date
        }
        eventId
        calendarIds
        startTime
        endTime
        type
        allDayEvent
        attendees {
          partyId
          type
          partyInfo {
            partyId
            __typename
            ... on PartyPerson {
              person {
                firstName
                lastName
                avatarUrl
                type
                title {
                  id
                  name
                  nameTextId
                }
              }
            }
          }
        }
        lessonInfo {
          subjectGroupId
          lessonId
        }
        roomIds
        rooms {
          roomId
          name
          capacity
          description
          pools {
            id
            name
            colour
          }
          includeInTimetable
          externalSystemId
          location
          disabled
        }
      }
      totalStudents
      awayStudents
      remainingStudents
      studentAwayReasons {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_CancellationRecommendationsQuery, Calendar_CancellationRecommendationsQueryVariables>;
export const Calendar_ManuallyCancelEventsDocument = new TypedDocumentString(`
    mutation calendar_manuallyCancelEvents($input: Calendar_ManuallyCancelEventInput!) {
  calendar_manuallyCancelEvents(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Calendar_ManuallyCancelEventsMutation, Calendar_ManuallyCancelEventsMutationVariables>;
export const Calendar_DeleteEventCancellationsDocument = new TypedDocumentString(`
    mutation calendar_deleteEventCancellations($input: Calendar_DeleteEventCancellationInput!) {
  calendar_deleteEventCancellations(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Calendar_DeleteEventCancellationsMutation, Calendar_DeleteEventCancellationsMutationVariables>;
export const Calendar_CloneEventDocument = new TypedDocumentString(`
    mutation calendar_cloneEvent($input: Calendar_CloneEvent!) {
  calendar_cloneEvent(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Calendar_CloneEventMutation, Calendar_CloneEventMutationVariables>;
export const Calendar_DeleteCalendarEventsDocument = new TypedDocumentString(`
    mutation calendar_deleteCalendarEvents($input: Calendar_DeleteEvent!) {
  calendar_deleteCalendarEvents(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Calendar_DeleteCalendarEventsMutation, Calendar_DeleteCalendarEventsMutationVariables>;
export const Calendar_EditCalendarEventsDocument = new TypedDocumentString(`
    mutation calendar_editCalendarEvents($input: Calendar_EditEvents!) {
  calendar_editCalendarEvents(input: $input) {
    success
    clashes {
      eventId
      event
      startTime
      endTime
      clashingRooms {
        roomId
        name
      }
      clashingParties {
        __typename
        ... on Staff {
          partyId
          person {
            partyId
            firstName
            lastName
            avatarUrl
            type
            title {
              id
              name
              nameTextId
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_EditCalendarEventsMutation, Calendar_EditCalendarEventsMutationVariables>;
export const Calendar_Ical_SchoolCalendarDocument = new TypedDocumentString(`
    query calendar_ical_schoolCalendar {
  calendar_ical_schoolCalendar {
    enabled
    externalCalendarId
    externalCalendarLink
  }
}
    `) as unknown as TypedDocumentString<Calendar_Ical_SchoolCalendarQuery, Calendar_Ical_SchoolCalendarQueryVariables>;
export const Calendar_Ical_SchoolCalendarConfigureDocument = new TypedDocumentString(`
    mutation calendar_ical_schoolCalendarConfigure($input: Calendar_Ical_SchoolCalendarConfigure!) {
  calendar_ical_schoolCalendarConfigure(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Calendar_Ical_SchoolCalendarConfigureMutation, Calendar_Ical_SchoolCalendarConfigureMutationVariables>;
export const Calendar_CalendarEventsForEditDocument = new TypedDocumentString(`
    query calendar_calendarEventsForEdit($filter: CalendarEventRawFilter!) {
  calendar_calendarEventsForEdit(filter: $filter) {
    eventId
    calendarIds
    type
    editable
    schedule {
      scheduleId
      startTime
      endTime
      startDate
      endDate
      recurrenceRule
      recurrenceEnum
      allDayEvent
      gridIdx
      dayIdx
      periodIdx
    }
    lessonInfo {
      lessonId
      subjectGroupId
    }
    name
    colour
    description
    source
    sourceId
    tags {
      label
      context
    }
    attendees {
      partyId
      type
      partyInfo {
        partyId
        __typename
        ... on GeneralGroup {
          generalGroupType
        }
        ... on PartyGroup {
          name
          avatarUrl
        }
        ... on PartyPerson {
          person {
            title {
              id
              name
              nameTextId
            }
            type
            firstName
            lastName
            avatarUrl
          }
        }
        ... on SubjectGroup {
          subjectGroupType
        }
      }
    }
    rooms {
      room {
        roomId
        name
      }
    }
    createdBy {
      userId
      partyId
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
    }
    publicStaffCalendar
    publicContactCalendar
    publicStudentCalendar
    eventTags {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_CalendarEventsForEditQuery, Calendar_CalendarEventsForEditQueryVariables>;
export const Calendar_CalendarEventsDocument = new TypedDocumentString(`
    query calendar_calendarEvents($filter: CalendarEventFilter!) {
  calendar_calendarEvents(filter: $filter) {
    otherEvents {
      name
      eventId
      calendarIds
      startTime
      endTime
      type
      colour
      description
      allDayEvent
      editable
      sourceId
      status
      cancellations {
        id
        contextId
        context
        reason
        note
      }
      lessonInfo {
        subjectGroupId
        lessonId
      }
      exclusions {
        partyId
        type
      }
      attendees {
        partyId
        type
        partyInfo {
          partyId
          __typename
          ... on GeneralGroup {
            generalGroupType
          }
          ... on PartyGroup {
            name
            avatarUrl
          }
          ... on PartyPerson {
            person {
              type
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
            }
          }
          ... on SubjectGroup {
            subjectGroupType
          }
        }
      }
      rooms {
        roomId
        name
      }
      tags {
        label
        context
      }
      eventTags {
        id
        name
      }
      alsoShowForParties
      followInfo {
        followId
        followerParties {
          partyId
          __typename
          ... on Staff {
            person {
              type
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
            }
          }
          ... on GeneralGroup {
            generalGroupType
          }
          ... on PartyGroup {
            name
            avatarUrl
          }
          ... on PartyPerson {
            person {
              type
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
            }
          }
          ... on SubjectGroup {
            subjectGroupType
          }
        }
        followedParties {
          partyId
          __typename
          ... on Student {
            person {
              type
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
            }
          }
          ... on GeneralGroup {
            generalGroupType
          }
          ... on PartyGroup {
            name
            avatarUrl
          }
          ... on PartyPerson {
            person {
              type
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
            }
          }
          ... on SubjectGroup {
            subjectGroupType
          }
        }
      }
    }
    resources {
      resourceId
      ... on PartyCalendar {
        __typename
        partyInfo {
          __typename
          ... on PartyGroup {
            name
            avatarUrl
          }
          ... on PartyPerson {
            person {
              avatarUrl
              firstName
              lastName
              type
              title {
                id
                name
                nameTextId
              }
            }
          }
        }
      }
      ... on RoomCalendar {
        room {
          name
        }
      }
      events {
        name
        eventId
        calendarIds
        startTime
        endTime
        type
        colour
        description
        allDayEvent
        editable
        sourceId
        status
        gridIdx
        periodIdx
        dayIdx
        cancellations {
          id
          contextId
          context
          reason
          note
        }
        lessonInfo {
          subjectGroupId
          lessonId
        }
        exclusions {
          partyId
          type
          partyInfo {
            partyId
            __typename
            ... on GeneralGroup {
              generalGroupType
            }
            ... on PartyGroup {
              name
              avatarUrl
            }
            ... on PartyPerson {
              person {
                type
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
              }
            }
            ... on SubjectGroup {
              subjectGroupType
            }
          }
        }
        attendees {
          partyId
          type
          partyInfo {
            partyId
            __typename
            ... on GeneralGroup {
              generalGroupType
            }
            ... on PartyGroup {
              name
              avatarUrl
            }
            ... on PartyPerson {
              person {
                type
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
              }
            }
            ... on SubjectGroup {
              subjectGroupType
            }
          }
        }
        rooms {
          roomId
          name
        }
        tags {
          label
          context
        }
        eventTags {
          id
          name
        }
        alsoShowForParties
        followInfo {
          followId
          followerParties {
            partyId
            __typename
            ... on Staff {
              person {
                type
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
              }
            }
            ... on GeneralGroup {
              generalGroupType
            }
            ... on PartyGroup {
              name
              avatarUrl
            }
            ... on PartyPerson {
              person {
                type
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
              }
            }
            ... on SubjectGroup {
              subjectGroupType
            }
          }
          followedParties {
            partyId
            __typename
            ... on Student {
              person {
                type
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
              }
            }
            ... on GeneralGroup {
              generalGroupType
            }
            ... on PartyGroup {
              name
              avatarUrl
            }
            ... on PartyPerson {
              person {
                type
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
              }
            }
            ... on SubjectGroup {
              subjectGroupType
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_CalendarEventsQuery, Calendar_CalendarEventsQueryVariables>;
export const CalendarGridPeriodsDocument = new TypedDocumentString(`
    query calendarGridPeriods($filter: CalendarGridFilter) {
  calendar_grids(filter: $filter) {
    gridIdx
    name
    days {
      isoDayOfWeek
      dayIdx
      startTime
      endTime
      periods {
        gridIdx
        periodIdx
        name
        dayIdx
        startTime
        endTime
        type
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CalendarGridPeriodsQuery, CalendarGridPeriodsQueryVariables>;
export const Calendar_WidgetDocument = new TypedDocumentString(`
    query calendar_widget($filter: CalendarEventFilter!) {
  calendar_calendarEvents(filter: $filter) {
    otherEvents {
      name
      eventId
      startTime
      endTime
      type
      colour
      allDayEvent
      sourceId
      lessonInfo {
        subjectGroupId
        lessonId
      }
      attendees {
        partyId
        type
        partyInfo {
          partyId
          __typename
          ... on GeneralGroup {
            generalGroupType
          }
          ... on PartyGroup {
            name
            avatarUrl
          }
          ... on PartyPerson {
            person {
              type
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
            }
          }
          ... on SubjectGroup {
            subjectGroupType
          }
        }
      }
    }
    resources {
      resourceId
      events {
        name
        eventId
        startTime
        endTime
        type
        colour
        allDayEvent
        sourceId
        lessonInfo {
          subjectGroupId
          lessonId
        }
        attendees {
          partyId
          type
          partyInfo {
            partyId
            __typename
            ... on GeneralGroup {
              generalGroupType
            }
            ... on PartyGroup {
              name
              avatarUrl
            }
            ... on PartyPerson {
              person {
                type
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
              }
            }
            ... on SubjectGroup {
              subjectGroupType
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_WidgetQuery, Calendar_WidgetQueryVariables>;
export const Calendar_EventTagsDocument = new TypedDocumentString(`
    query calendar_eventTags($filter: Calendar_EventTagFilter) {
  calendar_eventTags(filter: $filter) {
    id
    type
    systemTag
    name
    description
    colour
    refId
    icon
  }
}
    `) as unknown as TypedDocumentString<Calendar_EventTagsQuery, Calendar_EventTagsQueryVariables>;
export const Calendar_UpsertEventTagDocument = new TypedDocumentString(`
    mutation calendar_upsertEventTag($input: Calendar_UpsertEventTag!) {
  calendar_upsertEventTag(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Calendar_UpsertEventTagMutation, Calendar_UpsertEventTagMutationVariables>;
export const TimetableInfoDocument = new TypedDocumentString(`
    query timetableInfo($filter: CalendarDayInfoFilter) {
  calendar_dayInfo(filter: $filter) {
    date
    startTime
    endTime
    dayType
    gridPeriods {
      gridIdx
      periods {
        startTime
        endTime
        type
        name
        periodIdx
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TimetableInfoQuery, TimetableInfoQueryVariables>;
export const Calendar_PartyTimetableDocument = new TypedDocumentString(`
    query calendar_partyTimetable($filter: CalendarEventFilter!) {
  calendar_calendarEvents(filter: $filter) {
    resources {
      resourceId
      events {
        cancellations {
          id
          contextId
          context
          reason
          note
        }
        eventId
        sourceId
        name
        startTime
        endTime
        type
        colour
        status
        attendees {
          type
          partyInfo {
            __typename
            partyId
            ... on Staff {
              person {
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                type
              }
            }
            ... on SubjectGroup {
              name
              actualName
              subjectGroupType
            }
          }
        }
        exclusions {
          partyId
          type
          partyInfo {
            partyId
            __typename
            ... on GeneralGroup {
              generalGroupType
            }
            ... on PartyGroup {
              name
              avatarUrl
            }
            ... on PartyPerson {
              person {
                type
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
              }
            }
            ... on SubjectGroup {
              subjectGroupType
            }
          }
        }
        rooms {
          name
        }
        tags {
          label
          context
        }
        followInfo {
          followId
          followerParties {
            partyId
            __typename
            ... on Staff {
              person {
                type
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
              }
            }
            ... on GeneralGroup {
              generalGroupType
            }
            ... on PartyGroup {
              name
              avatarUrl
            }
            ... on PartyPerson {
              person {
                type
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
              }
            }
            ... on SubjectGroup {
              subjectGroupType
            }
          }
          followedParties {
            partyId
            __typename
            ... on Student {
              person {
                type
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
              }
            }
            ... on GeneralGroup {
              generalGroupType
            }
            ... on PartyGroup {
              name
              avatarUrl
            }
            ... on PartyPerson {
              person {
                type
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
              }
            }
            ... on SubjectGroup {
              subjectGroupType
            }
          }
        }
      }
      gridsIds
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_PartyTimetableQuery, Calendar_PartyTimetableQueryVariables>;
export const Calendar_UpdateCalendarBellTimesDocument = new TypedDocumentString(`
    mutation calendar_updateCalendarBellTimes($input: Calendar_UpdateCalendarBellTimesInput!) {
  calendar_updateCalendarBellTimes(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Calendar_UpdateCalendarBellTimesMutation, Calendar_UpdateCalendarBellTimesMutationVariables>;
export const Calendar_UpdateCalendarDayTimesDocument = new TypedDocumentString(`
    mutation calendar_updateCalendarDayTimes($input: Calendar_UpdateCalendarDayTimesInput!) {
  calendar_updateCalendarDayTimes(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Calendar_UpdateCalendarDayTimesMutation, Calendar_UpdateCalendarDayTimesMutationVariables>;
export const Core_BlocksDocument = new TypedDocumentString(`
    query core_blocks($filter: BlockFilter) {
  core_blocks(filter: $filter) {
    blockId
    name
    description
    subjectGroupNamesJoined
    subjectGroupIds
    isRotation
    rotations {
      iteration
      startDate
      endDate
    }
  }
}
    `) as unknown as TypedDocumentString<Core_BlocksQuery, Core_BlocksQueryVariables>;
export const Enrollment_Ire_BlockMembershipsDocument = new TypedDocumentString(`
    query enrollment_ire_blockMemberships($filter: EnrollmentIre_BlockEnrollmentFilter!) {
  enrollment_ire_blockMemberships(filter: $filter) {
    blockId
    block {
      blockId
      name
      description
      classGroupIds
      subjectGroupIds
    }
    isRotation
    groups {
      rotationIteration
      unenrolledStudents {
        isDuplicate
        classGroupName
        gender
        person {
          partyId
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
      subjectGroups {
        partyId
        name
        students {
          isDuplicate
          classGroupName
          gender
          person {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
        }
        staff {
          partyId
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Enrollment_Ire_BlockMembershipsQuery, Enrollment_Ire_BlockMembershipsQueryVariables>;
export const Enrollment_Ire_UpsertBlockMembershipsDocument = new TypedDocumentString(`
    mutation enrollment_ire_upsertBlockMemberships($input: EnrollmentIre_UpsertBlockMembership!) {
  enrollment_ire_upsertBlockMemberships(input: $input) {
    blockId
  }
}
    `) as unknown as TypedDocumentString<Enrollment_Ire_UpsertBlockMembershipsMutation, Enrollment_Ire_UpsertBlockMembershipsMutationVariables>;
export const Core_EnableBlockRotationsDocument = new TypedDocumentString(`
    mutation core_enableBlockRotations($input: Core_EnableBlockRotationInput!) {
  core_enableBlockRotations(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_EnableBlockRotationsMutation, Core_EnableBlockRotationsMutationVariables>;
export const Enrollment_Ire_AutoAssignBlocksDocument = new TypedDocumentString(`
    mutation enrollment_ire_autoAssignBlocks($input: EnrollmentIre_AutoAssignBlockMembershipInput!) {
  enrollment_ire_autoAssignBlocks(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Enrollment_Ire_AutoAssignBlocksMutation, Enrollment_Ire_AutoAssignBlocksMutationVariables>;
export const Enrollment_Ire_CoreMembershipsDocument = new TypedDocumentString(`
    query enrollment_ire_coreMemberships($filter: EnrollmentIre_CoreEnrollmentFilter!) {
  enrollment_ire_coreMemberships(filter: $filter) {
    yearGroupEnrollment {
      yearGroupId
      name
    }
    unenrolledStudents {
      personalInformation {
        gender
      }
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    classGroups {
      partyId
      name
      groupTags {
        id
        name
        type
      }
      students {
        personalInformation {
          gender
        }
        person {
          partyId
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
      staff {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Enrollment_Ire_CoreMembershipsQuery, Enrollment_Ire_CoreMembershipsQueryVariables>;
export const Enrollment_Ire_UpsertCoreMembershipsDocument = new TypedDocumentString(`
    mutation enrollment_ire_upsertCoreMemberships($input: EnrollmentIre_UpsertCoreMembership!) {
  enrollment_ire_upsertCoreMemberships(input: $input) {
    yearGroupEnrollment {
      yearGroupId
    }
  }
}
    `) as unknown as TypedDocumentString<Enrollment_Ire_UpsertCoreMembershipsMutation, Enrollment_Ire_UpsertCoreMembershipsMutationVariables>;
export const Enrollment_Ire_AutoAssignCoreDocument = new TypedDocumentString(`
    mutation enrollment_ire_autoAssignCore($input: EnrollmentIre_AutoAssignCoreMembershipInput!) {
  enrollment_ire_autoAssignCore(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Enrollment_Ire_AutoAssignCoreMutation, Enrollment_Ire_AutoAssignCoreMutationVariables>;
export const Clm_OptionsSourceListDocument = new TypedDocumentString(`
    query clm_optionsSourceList($filter: Options_OptionFilter) {
  options_options(filter: $filter) {
    id
    name
    yearGroup {
      name
    }
    studentCount
  }
}
    `) as unknown as TypedDocumentString<Clm_OptionsSourceListQuery, Clm_OptionsSourceListQueryVariables>;
export const Clm_OptionsSourceBlocksDocument = new TypedDocumentString(`
    query clm_optionsSourceBlocks($filter: Options_OptionIdFilter) {
  options_solutions(filter: $filter) {
    optionId
    solverStatus
    pools {
      blocks {
        blockIdx
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Clm_OptionsSourceBlocksQuery, Clm_OptionsSourceBlocksQueryVariables>;
export const Clm_OptionsSourceClmDocument = new TypedDocumentString(`
    query clm_optionsSourceClm($filter: Options_ClmFilter!) {
  options_clm(filter: $filter) {
    blockIdx
    subjectGroups {
      id
      subjectGroupName
      studentPartyIds
    }
  }
}
    `) as unknown as TypedDocumentString<Clm_OptionsSourceClmQuery, Clm_OptionsSourceClmQueryVariables>;
export const Print_ClmDocument = new TypedDocumentString(`
    query print_clm($filter: Print_CLM!) {
  print_clm(filter: $filter) {
    url
    html
  }
}
    `) as unknown as TypedDocumentString<Print_ClmQuery, Print_ClmQueryVariables>;
export const Rot_AddBlockRotationsDocument = new TypedDocumentString(`
    mutation rot_addBlockRotations($input: Rot_AddRotation) {
  rot_addBlockRotations(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Rot_AddBlockRotationsMutation, Rot_AddBlockRotationsMutationVariables>;
export const Rot_RemoveBlockRotationDateDocument = new TypedDocumentString(`
    mutation rot_removeBlockRotationDate($input: Rot_RemoveRotationDate) {
  rot_removeBlockRotationDate(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Rot_RemoveBlockRotationDateMutation, Rot_RemoveBlockRotationDateMutationVariables>;
export const Rot_DeleteRotationDocument = new TypedDocumentString(`
    mutation rot_deleteRotation($input: Rot_DeleteRotation) {
  rot_deleteRotation(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Rot_DeleteRotationMutation, Rot_DeleteRotationMutationVariables>;
export const Core_RotateBlockStudentsDocument = new TypedDocumentString(`
    mutation core_rotateBlockStudents($input: Core_RotateBlockStudentsInput!) {
  core_rotateBlockStudents(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_RotateBlockStudentsMutation, Core_RotateBlockStudentsMutationVariables>;
export const Documentation_Admin_ChangeRequestsDocument = new TypedDocumentString(`
    query documentation_admin_changeRequests($filter: Documentation_ChangeRequestFilter) {
  documentation_admin_changeRequests(filter: $filter) {
    id
    title
    description
    status
    source
    rejectionReason
    cancellationReason
    releaseTag
    createdByUserId
    createdOn
    updatedOn
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_ChangeRequestsQuery, Documentation_Admin_ChangeRequestsQueryVariables>;
export const Documentation_Admin_ChangeRequestDocument = new TypedDocumentString(`
    query documentation_admin_changeRequest($id: Int!) {
  documentation_admin_changeRequest(id: $id) {
    id
    title
    description
    status
    source
    rejectionReason
    cancellationReason
    releaseTag
    createdByUserId
    createdOn
    updatedOn
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_ChangeRequestQuery, Documentation_Admin_ChangeRequestQueryVariables>;
export const Documentation_Admin_ChangeRequestDiffDocument = new TypedDocumentString(`
    query documentation_admin_changeRequestDiff($changeRequestId: Int!) {
  documentation_admin_changeRequestDiff(changeRequestId: $changeRequestId) {
    itemId
    pageId
    operation
    proposedContent
    currentContent
    currentPublishedVersionId
    proposedVideoData {
      sourceUrl
      provider
      embedUrl
      thumbnailUrl
      durationSec
      aspectRatio
    }
    currentVideoData {
      sourceUrl
      provider
      embedUrl
      thumbnailUrl
      durationSec
      aspectRatio
    }
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_ChangeRequestDiffQuery, Documentation_Admin_ChangeRequestDiffQueryVariables>;
export const Documentation_Admin_CreateChangeRequestDocument = new TypedDocumentString(`
    mutation documentation_admin_createChangeRequest($input: Documentation_CreateChangeRequestInput!) {
  documentation_admin_createChangeRequest(input: $input) {
    id
    title
    status
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_CreateChangeRequestMutation, Documentation_Admin_CreateChangeRequestMutationVariables>;
export const Documentation_Admin_AddChangeRequestItemDocument = new TypedDocumentString(`
    mutation documentation_admin_addChangeRequestItem($input: Documentation_AddChangeRequestItemInput!) {
  documentation_admin_addChangeRequestItem(input: $input) {
    id
    changeRequestId
    pageId
    operation
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_AddChangeRequestItemMutation, Documentation_Admin_AddChangeRequestItemMutationVariables>;
export const Documentation_Admin_SubmitChangeRequestsDocument = new TypedDocumentString(`
    mutation documentation_admin_submitChangeRequests($ids: [Int!]!) {
  documentation_admin_submitChangeRequests(ids: $ids) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_SubmitChangeRequestsMutation, Documentation_Admin_SubmitChangeRequestsMutationVariables>;
export const Documentation_Admin_ApproveChangeRequestsDocument = new TypedDocumentString(`
    mutation documentation_admin_approveChangeRequests($ids: [Int!]!) {
  documentation_admin_approveChangeRequests(ids: $ids) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_ApproveChangeRequestsMutation, Documentation_Admin_ApproveChangeRequestsMutationVariables>;
export const Documentation_Admin_RejectChangeRequestsDocument = new TypedDocumentString(`
    mutation documentation_admin_rejectChangeRequests($input: Documentation_RejectChangeRequestsInput!) {
  documentation_admin_rejectChangeRequests(input: $input) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_RejectChangeRequestsMutation, Documentation_Admin_RejectChangeRequestsMutationVariables>;
export const Documentation_Admin_CancelChangeRequestsDocument = new TypedDocumentString(`
    mutation documentation_admin_cancelChangeRequests($input: Documentation_CancelChangeRequestsInput!) {
  documentation_admin_cancelChangeRequests(input: $input) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_CancelChangeRequestsMutation, Documentation_Admin_CancelChangeRequestsMutationVariables>;
export const Documentation_Admin_RevertChangeRequestToDraftDocument = new TypedDocumentString(`
    mutation documentation_admin_revertChangeRequestToDraft($id: Int!) {
  documentation_admin_revertChangeRequestToDraft(id: $id) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_RevertChangeRequestToDraftMutation, Documentation_Admin_RevertChangeRequestToDraftMutationVariables>;
export const Documentation_Admin_QuickMergeChangeRequestDocument = new TypedDocumentString(`
    mutation documentation_admin_quickMergeChangeRequest($input: Documentation_QuickMergeChangeRequestInput!) {
  documentation_admin_quickMergeChangeRequest(input: $input) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_QuickMergeChangeRequestMutation, Documentation_Admin_QuickMergeChangeRequestMutationVariables>;
export const Documentation_Admin_QuickPublishDocument = new TypedDocumentString(`
    mutation documentation_admin_quickPublish($input: Documentation_QuickPublishInput!) {
  documentation_admin_quickPublish(input: $input) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_QuickPublishMutation, Documentation_Admin_QuickPublishMutationVariables>;
export const Documentation_Admin_RemoveChangeRequestItemDocument = new TypedDocumentString(`
    mutation documentation_admin_removeChangeRequestItem($input: Documentation_RemoveChangeRequestItemInput!) {
  documentation_admin_removeChangeRequestItem(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_RemoveChangeRequestItemMutation, Documentation_Admin_RemoveChangeRequestItemMutationVariables>;
export const Documentation_Admin_ConflictingChangeRequestsDocument = new TypedDocumentString(`
    query documentation_admin_conflictingChangeRequests($changeRequestId: Int!) {
  documentation_admin_conflictingChangeRequests(changeRequestId: $changeRequestId) {
    id
    title
    status
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_ConflictingChangeRequestsQuery, Documentation_Admin_ConflictingChangeRequestsQueryVariables>;
export const Documentation_Admin_UpdateChangeRequestReleaseTagDocument = new TypedDocumentString(`
    mutation documentation_admin_updateChangeRequestReleaseTag($input: Documentation_UpdateChangeRequestReleaseTagInput!) {
  documentation_admin_updateChangeRequestReleaseTag(input: $input) {
    id
    status
    releaseTag
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_UpdateChangeRequestReleaseTagMutation, Documentation_Admin_UpdateChangeRequestReleaseTagMutationVariables>;
export const Documentation_User_PagesDocument = new TypedDocumentString(`
    query documentation_user_pages($filter: Documentation_PageFilter!) {
  documentation_user_pages(filter: $filter) {
    id
    spaceId
    parentPageId
    slug
    title
    sortOrder
    userTypes
    publishedVersionId
    entityType
    videoData {
      durationSec
    }
  }
}
    `) as unknown as TypedDocumentString<Documentation_User_PagesQuery, Documentation_User_PagesQueryVariables>;
export const Documentation_Admin_PagesDocument = new TypedDocumentString(`
    query documentation_admin_pages($filter: Documentation_PageFilter!) {
  documentation_admin_pages(filter: $filter) {
    page {
      id
      spaceId
      parentPageId
      slug
      title
      sortOrder
      userTypes
      publishedVersionId
      entityType
      videoData {
        durationSec
      }
    }
    activeCrStatus
    metadata {
      id
      pageId
      blockId
      key
      value
    }
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_PagesQuery, Documentation_Admin_PagesQueryVariables>;
export const Documentation_User_PageDocument = new TypedDocumentString(`
    query documentation_user_page($filter: Documentation_SinglePageFilter!) {
  documentation_user_page(filter: $filter) {
    id
    spaceId
    parentPageId
    slug
    title
    sortOrder
    userTypes
    publishedVersionId
    contentMd
    entityType
    videoData {
      sourceUrl
      provider
      embedUrl
      thumbnailUrl
      durationSec
      aspectRatio
    }
    brokenLinkCount
    pendingLinkCount
  }
}
    `) as unknown as TypedDocumentString<Documentation_User_PageQuery, Documentation_User_PageQueryVariables>;
export const Documentation_User_PageMetadataDocument = new TypedDocumentString(`
    query documentation_user_pageMetadata($pageIds: [Int!]!) {
  documentation_user_pageMetadata(pageIds: $pageIds) {
    id
    pageId
    blockId
    key
    value
  }
}
    `) as unknown as TypedDocumentString<Documentation_User_PageMetadataQuery, Documentation_User_PageMetadataQueryVariables>;
export const Documentation_Admin_PageDetailDocument = new TypedDocumentString(`
    query documentation_admin_pageDetail($filter: Documentation_SinglePageFilter!) {
  documentation_admin_pageDetail(filter: $filter) {
    page {
      id
      spaceId
      parentPageId
      slug
      title
      sortOrder
      userTypes
      publishedVersionId
      contentMd
      entityType
      videoData {
        sourceUrl
        provider
        embedUrl
        thumbnailUrl
        durationSec
        aspectRatio
      }
      brokenLinkCount
      pendingLinkCount
    }
    metadata {
      id
      pageId
      blockId
      key
      value
    }
    activeChangeRequest {
      changeRequest {
        id
        title
        status
        createdOn
        releaseTag
      }
      contentMd
      videoData {
        sourceUrl
        provider
        embedUrl
        thumbnailUrl
        durationSec
        aspectRatio
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_PageDetailQuery, Documentation_Admin_PageDetailQueryVariables>;
export const Documentation_Admin_RefreshVideoDataDocument = new TypedDocumentString(`
    mutation documentation_admin_refreshVideoData($input: Documentation_RefreshVideoDataInput!) {
  documentation_admin_refreshVideoData(input: $input) {
    sourceUrl
    provider
    embedUrl
    thumbnailUrl
    durationSec
    aspectRatio
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_RefreshVideoDataMutation, Documentation_Admin_RefreshVideoDataMutationVariables>;
export const Documentation_Admin_ReplacePageVideoUrlDocument = new TypedDocumentString(`
    mutation documentation_admin_replacePageVideoUrl($input: Documentation_ReplacePageVideoUrlInput!) {
  documentation_admin_replacePageVideoUrl(input: $input) {
    sourceUrl
    provider
    embedUrl
    thumbnailUrl
    durationSec
    aspectRatio
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_ReplacePageVideoUrlMutation, Documentation_Admin_ReplacePageVideoUrlMutationVariables>;
export const Documentation_Admin_CreatePageDocument = new TypedDocumentString(`
    mutation documentation_admin_createPage($input: Documentation_CreatePageInput!) {
  documentation_admin_createPage(input: $input) {
    id
    spaceId
    slug
    title
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_CreatePageMutation, Documentation_Admin_CreatePageMutationVariables>;
export const Documentation_Admin_UpdatePageDocument = new TypedDocumentString(`
    mutation documentation_admin_updatePage($input: Documentation_UpdatePageInput!) {
  documentation_admin_updatePage(input: $input) {
    id
    title
    userTypes
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_UpdatePageMutation, Documentation_Admin_UpdatePageMutationVariables>;
export const Documentation_Admin_DeletePagesDocument = new TypedDocumentString(`
    mutation documentation_admin_deletePages($pageIds: [Int!]!) {
  documentation_admin_deletePages(pageIds: $pageIds) {
    success
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_DeletePagesMutation, Documentation_Admin_DeletePagesMutationVariables>;
export const Documentation_Admin_MovePageDocument = new TypedDocumentString(`
    mutation documentation_admin_movePage($input: Documentation_MovePageInput!) {
  documentation_admin_movePage(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_MovePageMutation, Documentation_Admin_MovePageMutationVariables>;
export const Documentation_Admin_SetPageMetadataDocument = new TypedDocumentString(`
    mutation documentation_admin_setPageMetadata($input: Documentation_SetPageMetadataInput!) {
  documentation_admin_setPageMetadata(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_SetPageMetadataMutation, Documentation_Admin_SetPageMetadataMutationVariables>;
export const Documentation_Admin_AllPagesDocument = new TypedDocumentString(`
    query documentation_admin_allPages {
  documentation_admin_allPages {
    id
    spaceId
    spaceSlug
    spaceName
    slug
    title
    entityType
    publishedVersionId
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_AllPagesQuery, Documentation_Admin_AllPagesQueryVariables>;
export const Documentation_User_RelatedPagesDocument = new TypedDocumentString(`
    query documentation_user_relatedPages($filter: Documentation_RelatedPagesFilter) {
  documentation_user_relatedPages(filter: $filter) {
    pageId
    spaceId
    title
    spaceSlug
    spaceName
    pageSlug
    entityType
    ancestorTitles
  }
}
    `) as unknown as TypedDocumentString<Documentation_User_RelatedPagesQuery, Documentation_User_RelatedPagesQueryVariables>;
export const Documentation_Admin_PermissionsDocument = new TypedDocumentString(`
    query documentation_admin_permissions {
  documentation_admin_permissions {
    name
    displayName
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_PermissionsQuery, Documentation_Admin_PermissionsQueryVariables>;
export const Documentation_Admin_ReleaseTagsDocument = new TypedDocumentString(`
    query documentation_admin_releaseTags {
  documentation_admin_releaseTags {
    releaseTag
    draftCount
    inReviewCount
    approvedCount
    mergedCount
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_ReleaseTagsQuery, Documentation_Admin_ReleaseTagsQueryVariables>;
export const Documentation_Admin_PromoteReleaseDocument = new TypedDocumentString(`
    mutation documentation_admin_promoteRelease($releaseTag: String!) {
  documentation_admin_promoteRelease(releaseTag: $releaseTag) {
    promotedItemIds
    conflictingItemIds
    promotedCrIds
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_PromoteReleaseMutation, Documentation_Admin_PromoteReleaseMutationVariables>;
export const Documentation_User_SearchDocument = new TypedDocumentString(`
    query documentation_user_search($filter: Documentation_SearchFilter!) {
  documentation_user_search(filter: $filter) {
    pageId
    title
    spaceSlug
    spaceName
    pageSlug
    entityType
    snippet
    rank
    ancestorTitles
  }
}
    `) as unknown as TypedDocumentString<Documentation_User_SearchQuery, Documentation_User_SearchQueryVariables>;
export const Documentation_User_SpacesDocument = new TypedDocumentString(`
    query documentation_user_spaces {
  documentation_user_spaces {
    id
    name
    slug
    icon
    description
    sortOrder
    articleCount
    videoCount
  }
}
    `) as unknown as TypedDocumentString<Documentation_User_SpacesQuery, Documentation_User_SpacesQueryVariables>;
export const Documentation_Admin_CreateSpaceDocument = new TypedDocumentString(`
    mutation documentation_admin_createSpace($input: Documentation_CreateSpaceInput!) {
  documentation_admin_createSpace(input: $input) {
    id
    name
    slug
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_CreateSpaceMutation, Documentation_Admin_CreateSpaceMutationVariables>;
export const Documentation_Admin_UpdateSpaceDocument = new TypedDocumentString(`
    mutation documentation_admin_updateSpace($input: Documentation_UpdateSpaceInput!) {
  documentation_admin_updateSpace(input: $input) {
    id
    name
    slug
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_UpdateSpaceMutation, Documentation_Admin_UpdateSpaceMutationVariables>;
export const Documentation_Admin_DeleteSpaceDocument = new TypedDocumentString(`
    mutation documentation_admin_deleteSpace($id: Int!) {
  documentation_admin_deleteSpace(id: $id) {
    success
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_DeleteSpaceMutation, Documentation_Admin_DeleteSpaceMutationVariables>;
export const Documentation_Admin_ReorderSpacesDocument = new TypedDocumentString(`
    mutation documentation_admin_reorderSpaces($input: Documentation_ReorderSpacesInput!) {
  documentation_admin_reorderSpaces(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_ReorderSpacesMutation, Documentation_Admin_ReorderSpacesMutationVariables>;
export const Tyrone_RefreshDocumentationIndexDocument = new TypedDocumentString(`
    mutation tyrone_refreshDocumentationIndex {
  tyrone_refreshDocumentationIndex {
    success
  }
}
    `) as unknown as TypedDocumentString<Tyrone_RefreshDocumentationIndexMutation, Tyrone_RefreshDocumentationIndexMutationVariables>;
export const Documentation_Admin_PageVersionsDocument = new TypedDocumentString(`
    query documentation_admin_pageVersions($pageId: Int!) {
  documentation_admin_pageVersions(pageId: $pageId) {
    id
    pageId
    versionNumber
    status
    changeRequestId
    createdOn
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_PageVersionsQuery, Documentation_Admin_PageVersionsQueryVariables>;
export const Documentation_Admin_PageVersionContentDocument = new TypedDocumentString(`
    query documentation_admin_pageVersionContent($versionId: Int!) {
  documentation_admin_pageVersionContent(versionId: $versionId) {
    id
    pageId
    versionNumber
    contentMd
    status
    createdOn
  }
}
    `) as unknown as TypedDocumentString<Documentation_Admin_PageVersionContentQuery, Documentation_Admin_PageVersionContentQueryVariables>;
export const Documentation_Admin_RestoreVersionDocument = new TypedDocumentString(`
    mutation documentation_admin_restoreVersion($input: Documentation_RestoreVersionInput!) {
  documentation_admin_restoreVersion(input: $input)
}
    `) as unknown as TypedDocumentString<Documentation_Admin_RestoreVersionMutation, Documentation_Admin_RestoreVersionMutationVariables>;
export const Drive_SetFolderTypeDocument = new TypedDocumentString(`
    mutation drive_setFolderType($input: Folders_DriveSetFolderTypeInput!) {
  drive_setFolderType(input: $input) {
    id
    type
  }
}
    `) as unknown as TypedDocumentString<Drive_SetFolderTypeMutation, Drive_SetFolderTypeMutationVariables>;
export const Drive_UpdateFolderAclDocument = new TypedDocumentString(`
    mutation drive_updateFolderAcl($input: Folders_DriveUpdateFolderAclInput!) {
  drive_updateFolderAcl(input: $input) {
    subjects {
      partyId
      name
      isGroup
    }
  }
}
    `) as unknown as TypedDocumentString<Drive_UpdateFolderAclMutation, Drive_UpdateFolderAclMutationVariables>;
export const Drive_FolderAclDocument = new TypedDocumentString(`
    query drive_folderAcl($input: Folders_DriveFolderAclInput!) {
  drive_folderAcl(input: $input) {
    subjects {
      partyId
      name
      isGroup
    }
  }
}
    `) as unknown as TypedDocumentString<Drive_FolderAclQuery, Drive_FolderAclQueryVariables>;
export const Drive_FolderGrantsForCurrentUserDocument = new TypedDocumentString(`
    query drive_folderGrantsForCurrentUser($input: Folders_DriveFolderGrantsInput!) {
  drive_folderGrantsForCurrentUser(input: $input) {
    entityType
    entityId
    paths {
      ancestorFolderId
      ancestorFolderName
    }
  }
}
    `) as unknown as TypedDocumentString<Drive_FolderGrantsForCurrentUserQuery, Drive_FolderGrantsForCurrentUserQueryVariables>;
export const Drive_PreviewAclSubjectRemovalDocument = new TypedDocumentString(`
    query drive_previewAclSubjectRemoval($input: Folders_DriveAclRemovalPreviewInput!) {
  drive_previewAclSubjectRemoval(input: $input) {
    totalItemsInSubtree
    itemsRetained
    itemsLost
    items {
      entityType
      entityId
      status
    }
  }
}
    `) as unknown as TypedDocumentString<Drive_PreviewAclSubjectRemovalQuery, Drive_PreviewAclSubjectRemovalQueryVariables>;
export const Drive_CreateFolderDocument = new TypedDocumentString(`
    mutation drive_createFolder($input: Folders_DriveCreateFolderInput!) {
  drive_createFolder(input: $input) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<Drive_CreateFolderMutation, Drive_CreateFolderMutationVariables>;
export const Drive_UpdateFolderDocument = new TypedDocumentString(`
    mutation drive_updateFolder($input: Folders_DriveUpdateFolderInput!) {
  drive_updateFolder(input: $input) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<Drive_UpdateFolderMutation, Drive_UpdateFolderMutationVariables>;
export const Drive_ArchiveFolderDocument = new TypedDocumentString(`
    mutation drive_archiveFolder($input: Folders_DriveArchiveFolderInput!) {
  drive_archiveFolder(input: $input) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<Drive_ArchiveFolderMutation, Drive_ArchiveFolderMutationVariables>;
export const Drive_RestoreFolderDocument = new TypedDocumentString(`
    mutation drive_restoreFolder($input: Folders_DriveRestoreFolderInput!) {
  drive_restoreFolder(input: $input) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<Drive_RestoreFolderMutation, Drive_RestoreFolderMutationVariables>;
export const Drive_DeleteFolderDocument = new TypedDocumentString(`
    mutation drive_deleteFolder($input: Folders_DriveDeleteFolderInput!) {
  drive_deleteFolder(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Drive_DeleteFolderMutation, Drive_DeleteFolderMutationVariables>;
export const Drive_ItemsDocument = new TypedDocumentString(`
    query drive_items($input: Folders_DriveItemsInput!) {
  drive_items(input: $input) {
    entityType
    entityId
    title
    previewUrl
    createdAt
    createdByPartyId
    createdBy {
      partyId
      firstName
      lastName
    }
    addedByPartyId
    addedBy {
      partyId
      firstName
      lastName
    }
    addedAt
    folderCount
    available
    pbac {
      isSecured
      canRead
      canWrite
      canDelete
      canChangePbac
    }
  }
}
    `) as unknown as TypedDocumentString<Drive_ItemsQuery, Drive_ItemsQueryVariables>;
export const Drive_AddItemDocument = new TypedDocumentString(`
    mutation drive_addItem($input: Folders_DriveAddItemInput!) {
  drive_addItem(input: $input) {
    id
    folderId
    entityType
    entityId
  }
}
    `) as unknown as TypedDocumentString<Drive_AddItemMutation, Drive_AddItemMutationVariables>;
export const Drive_RemoveItemDocument = new TypedDocumentString(`
    mutation drive_removeItem($input: Folders_DriveRemoveItemInput!) {
  drive_removeItem(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Drive_RemoveItemMutation, Drive_RemoveItemMutationVariables>;
export const Drive_CreateNoteDocument = new TypedDocumentString(`
    mutation drive_createNote($filter: Notesv2_UpsertNotes!) {
  notesv2_upsertNote(filter: $filter)
}
    `) as unknown as TypedDocumentString<Drive_CreateNoteMutation, Drive_CreateNoteMutationVariables>;
export const Drive_AddQuickLinkDocument = new TypedDocumentString(`
    mutation drive_addQuickLink($input: Folders_DriveAddQuickLinkInput!) {
  drive_addQuickLink(input: $input) {
    id
    folderId
    title
    url
    description
    isGlobal
  }
}
    `) as unknown as TypedDocumentString<Drive_AddQuickLinkMutation, Drive_AddQuickLinkMutationVariables>;
export const Drive_DeleteQuickLinkDocument = new TypedDocumentString(`
    mutation drive_deleteQuickLink($input: Folders_DriveDeleteQuickLinkInput!) {
  drive_deleteQuickLink(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Drive_DeleteQuickLinkMutation, Drive_DeleteQuickLinkMutationVariables>;
export const Drive_TreeDocument = new TypedDocumentString(`
    query drive_tree($input: Folders_DriveTreeInput!) {
  drive_tree(input: $input) {
    id
    name
    description
    parentFolderId
    namespace
    contextEntityType
    contextEntityId
    status
    type
    icon
    colour
    sortOrder
    itemCount
    createdByPartyId
    createdBy {
      partyId
      firstName
      lastName
    }
    quickLinks {
      id
      folderId
      title
      url
      description
      isGlobal
    }
  }
}
    `) as unknown as TypedDocumentString<Drive_TreeQuery, Drive_TreeQueryVariables>;
export const Fees_AccountingCodesDocument = new TypedDocumentString(`
    query fees_accountingCodes($filter: AccountingCodeFilter) {
  fees_accountingCodes(filter: $filter) {
    id
    code
    description
    active
    createdBy {
      partyId
      firstName
      lastName
      type
      avatarUrl
      title {
        id
        name
        nameTextId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Fees_AccountingCodesQuery, Fees_AccountingCodesQueryVariables>;
export const Fees_BulkApplyIndividualDiscountsDocument = new TypedDocumentString(`
    mutation fees_bulkApplyIndividualDiscounts($input: [IndividualDiscountInput]) {
  fees_bulkApplyIndividualDiscounts(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Fees_BulkApplyIndividualDiscountsMutation, Fees_BulkApplyIndividualDiscountsMutationVariables>;
export const Fees_CardPaymentPlansDocument = new TypedDocumentString(`
    query fees_cardPaymentPlans($filter: CardPaymentPlanFilter) {
  fees_cardPaymentPlans(filter: $filter) {
    paymentMethodId
    paymentPlanId
    feeName
    status
    paymentPlanStartDate
  }
}
    `) as unknown as TypedDocumentString<Fees_CardPaymentPlansQuery, Fees_CardPaymentPlansQueryVariables>;
export const CreatePaymentDocument = new TypedDocumentString(`
    mutation createPayment($input: MakePaymentInput) {
  fees_createPayment(input: $input) {
    clientSecret
    bankTransferInstructions {
      reference
      iban
      bic
      accountHolderName
      amountDue
    }
  }
}
    `) as unknown as TypedDocumentString<CreatePaymentMutation, CreatePaymentMutationVariables>;
export const Fees_StripeCustomerInfoDocument = new TypedDocumentString(`
    query fees_stripeCustomerInfo($filter: OnBehalfOfInput) {
  fees_stripeCustomerInfo(filter: $filter) {
    customerId
    ephemeralKey
  }
}
    `) as unknown as TypedDocumentString<Fees_StripeCustomerInfoQuery, Fees_StripeCustomerInfoQueryVariables>;
export const Fees_DebtorsDocument = new TypedDocumentString(`
    query fees_debtors($filter: FeeFilter) {
  fees_fees(filter: $filter) {
    debtors {
      id
      feeId
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      classGroup {
        name
      }
      feeStatus
      amount
      amountPaid
      amountDue
      amountDiscounted
      discounts {
        id
        name
        discountType
        value
      }
      writeOffNote
      amountWrittenOff
    }
  }
}
    `) as unknown as TypedDocumentString<Fees_DebtorsQuery, Fees_DebtorsQueryVariables>;
export const Fees_DeleteCardDocument = new TypedDocumentString(`
    mutation fees_deleteCard($input: DeleteCardInput) {
  fees_deleteCard(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Fees_DeleteCardMutation, Fees_DeleteCardMutationVariables>;
export const Fees_DeleteDiscountDocument = new TypedDocumentString(`
    mutation fees_deleteDiscount($input: DeleteDiscountInput!) {
  fees_deleteDiscount(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Fees_DeleteDiscountMutation, Fees_DeleteDiscountMutationVariables>;
export const Fees_DeleteFeeDocument = new TypedDocumentString(`
    mutation fees_deleteFee($input: DeleteFeeInput!) {
  fees_deleteFee(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Fees_DeleteFeeMutation, Fees_DeleteFeeMutationVariables>;
export const Fees_DiscountsDocument = new TypedDocumentString(`
    query fees_discounts($filter: DiscountFilter) {
  fees_discounts(filter: $filter) {
    id
    name
    description
    discountType
    value
    siblingDiscount
    active
    createdBy {
      partyId
      firstName
      lastName
      type
      avatarUrl
      title {
        id
        name
        nameTextId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Fees_DiscountsQuery, Fees_DiscountsQueryVariables>;
export const Fees_CategoriesDocument = new TypedDocumentString(`
    query fees_categories($filter: CategoryFilter) {
  fees_categories(filter: $filter) {
    id
    name
    description
    active
    createdBy {
      partyId
      firstName
      lastName
      type
      avatarUrl
      title {
        id
        name
        nameTextId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Fees_CategoriesQuery, Fees_CategoriesQueryVariables>;
export const Fees_FeesDocument = new TypedDocumentString(`
    query fees_fees($filter: FeeFilter) {
  fees_fees(filter: $filter) {
    id
    name
    description
    dueDate
    amount
    feeType
    absorbFees
    published
    publishedOn
    assignedToParties {
      ... on PartyPerson {
        __typename
        person {
          partyId
          firstName
          lastName
          avatarUrl
          type
          title {
            id
            name
            nameTextId
          }
        }
      }
      ... on SubjectGroup {
        __typename
        partyId
        name
        avatarUrl
      }
      ... on GeneralGroup {
        __typename
        partyId
        name
      }
      ... on YearGroupEnrollment {
        __typename
        partyId
        name
      }
      ... on ProgrammeStageEnrollment {
        __typename
        partyId
        name
      }
    }
    categories {
      id
      name
    }
    discounts {
      id
      name
      discountType
      value
    }
    individualDiscounts {
      personPartyId
      adHocAmount
      discount {
        id
        name
        discountType
        value
      }
    }
    total
    paid
    due
    writtenOff
    feeStatus
    createdBy {
      partyId
      firstName
      lastName
      type
      avatarUrl
      title {
        id
        name
        nameTextId
      }
    }
    exclusions {
      excludedPerson {
        partyId
        firstName
        lastName
        type
        avatarUrl
        title {
          id
          name
          nameTextId
        }
      }
      excludedBy {
        partyId
        firstName
        lastName
        type
        avatarUrl
        title {
          id
          name
          nameTextId
        }
      }
      excludedOn
    }
    accountingCode {
      id
      code
    }
    allowPartialPayments
    paymentPlan
    paymentPlanInterval
    paymentPlanIntervalCount
    installments {
      id
      feeId
      installment
      amount
      serviceCharges
      stripePriceId
    }
  }
}
    `) as unknown as TypedDocumentString<Fees_FeesQuery, Fees_FeesQueryVariables>;
export const Fees_MigrateFeeDocument = new TypedDocumentString(`
    mutation fees_migrateFee($input: FeeMigrationInput!) {
  fees_migrateFee(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Fees_MigrateFeeMutation, Fees_MigrateFeeMutationVariables>;
export const Fees_PaymentPlanInstallmentsDocument = new TypedDocumentString(`
    query fees_paymentPlanInstallments($filter: CalculatePaymentPlanFilter) {
  fees_paymentPlanInstallments(filter: $filter) {
    id {
      feeId
      studentPartyId
    }
    installments {
      installment
      installmentDate
      amount
      serviceCharges
      absorbFees
    }
  }
}
    `) as unknown as TypedDocumentString<Fees_PaymentPlanInstallmentsQuery, Fees_PaymentPlanInstallmentsQueryVariables>;
export const Fees_PaymentsDocument = new TypedDocumentString(`
    query fees_payments($filter: PaymentFilter) {
  fees_payments(filter: $filter) {
    id
    fee {
      id
      name
    }
    studentPartyId
    student {
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    payee {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    amount
    paymentIntentId
    paymentMethod
    transactionDate
    serviceFeesAmount
    note
    cardType
    installment
    refunds {
      id
      amount
      refundType
      refundStatus
      refundDate
    }
  }
}
    `) as unknown as TypedDocumentString<Fees_PaymentsQuery, Fees_PaymentsQueryVariables>;
export const PrintFeesDocument = new TypedDocumentString(`
    query printFees($filter: Print_FeeOptions!) {
  print_fees(filter: $filter) {
    url
    html
  }
}
    `) as unknown as TypedDocumentString<PrintFeesQuery, PrintFeesQueryVariables>;
export const Fees_PublishDocument = new TypedDocumentString(`
    mutation fees_publish($input: PublishInput!) {
  fees_publish(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Fees_PublishMutation, Fees_PublishMutationVariables>;
export const Fees_RefundDocument = new TypedDocumentString(`
    mutation fees_refund($input: RefundInput!) {
  fees_refund(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Fees_RefundMutation, Fees_RefundMutationVariables>;
export const Fees_SaveAccountingCodeDocument = new TypedDocumentString(`
    mutation fees_saveAccountingCode($input: SaveAccountCodeInput) {
  fees_saveAccountingCode(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Fees_SaveAccountingCodeMutation, Fees_SaveAccountingCodeMutationVariables>;
export const Fees_SaveDiscountDocument = new TypedDocumentString(`
    mutation fees_saveDiscount($input: SaveDiscountInput) {
  fees_saveDiscount(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Fees_SaveDiscountMutation, Fees_SaveDiscountMutationVariables>;
export const Fees_SaveCategoryDocument = new TypedDocumentString(`
    mutation fees_saveCategory($input: SaveCategoryInput) {
  fees_saveCategory(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Fees_SaveCategoryMutation, Fees_SaveCategoryMutationVariables>;
export const Fees_SaveFeeDocument = new TypedDocumentString(`
    mutation fees_saveFee($input: SaveFeeInput) {
  fees_saveFee(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Fees_SaveFeeMutation, Fees_SaveFeeMutationVariables>;
export const Fees_SavedCardsDocument = new TypedDocumentString(`
    query fees_savedCards {
  fees_savedCards {
    id
    last4
    brand
    expiry
  }
}
    `) as unknown as TypedDocumentString<Fees_SavedCardsQuery, Fees_SavedCardsQueryVariables>;
export const Fees_ScheduledPaymentsDocument = new TypedDocumentString(`
    query fees_scheduledPayments($filter: FeeFilter) {
  fees_fees(filter: $filter) {
    paymentPlanInterval
    paymentPlanIntervalCount
    debtors {
      id
      feeId
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      classGroup {
        name
      }
      amount
      amountPaid
      amountDue
      installments {
        installment
        installmentDate
        installmentStatus
        amount
        serviceCharges
        absorbFees
        cardUsed
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Fees_ScheduledPaymentsQuery, Fees_ScheduledPaymentsQueryVariables>;
export const Fees_ServiceChargesDocument = new TypedDocumentString(`
    query fees_serviceCharges($filter: ChargesFilter) {
  fees_serviceCharges(filter: $filter) {
    amount
    userServiceCharge
    userVat
  }
}
    `) as unknown as TypedDocumentString<Fees_ServiceChargesQuery, Fees_ServiceChargesQueryVariables>;
export const Fees_CreateSetupIntentDocument = new TypedDocumentString(`
    mutation fees_createSetupIntent($input: OnBehalfOfInput) {
  fees_createSetupIntent(input: $input) {
    clientSecret
  }
}
    `) as unknown as TypedDocumentString<Fees_CreateSetupIntentMutation, Fees_CreateSetupIntentMutationVariables>;
export const SimulateBankTransferDocument = new TypedDocumentString(`
    mutation simulateBankTransfer($input: SimulateBankTransferInput) {
  fees_simulateBankTransfer(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<SimulateBankTransferMutation, SimulateBankTransferMutationVariables>;
export const Fees_StripeAccountDocument = new TypedDocumentString(`
    query fees_stripeAccount {
  fees_stripeAccount {
    signUpStarted
    onboardingComplete
    onboardingLink
  }
}
    `) as unknown as TypedDocumentString<Fees_StripeAccountQuery, Fees_StripeAccountQueryVariables>;
export const Fees_StudentFeesDocument = new TypedDocumentString(`
    query fees_studentFees($filter: StudentFeeFilter) {
  fees_studentFees(filter: $filter) {
    id {
      feeId
      studentPartyId
    }
    person {
      partyId
      firstName
      lastName
      avatarUrl
      type
      title {
        id
        name
        nameTextId
      }
    }
    feeName
    description
    dueDate
    amount
    amountPaid
    amountDue
    feeType
    feeStatus
    amountDiscounted
    adHocAmount
    discounts {
      id
      name
      description
      discountType
      value
      siblingDiscount
    }
    amountWrittenOff
    writeOffNote
    allowPartialPayments
    classGroup {
      name
    }
    paymentPlan
    paymentPlanInterval
    paymentPlanIntervalCount
    paymentPlans {
      id
      absorbFees
      status
      cardUsed
      payee {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      installments {
        installment
        installmentDate
        status
        amount
        serviceCharges
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Fees_StudentFeesQuery, Fees_StudentFeesQueryVariables>;
export const Fees_ExcludeFromFeeDocument = new TypedDocumentString(`
    mutation fees_excludeFromFee($input: FeeExclusionInput!) {
  fees_excludeFromFee(input: $input) {
    success {
      success
    }
    validations
  }
}
    `) as unknown as TypedDocumentString<Fees_ExcludeFromFeeMutation, Fees_ExcludeFromFeeMutationVariables>;
export const Fees_UpdatePaymentPlanCardDocument = new TypedDocumentString(`
    mutation fees_updatePaymentPlanCard($input: UpdateSubscriptionCardInput) {
  fees_updatePaymentPlanCard(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Fees_UpdatePaymentPlanCardMutation, Fees_UpdatePaymentPlanCardMutationVariables>;
export const Fees_WriteOffStudentsFeeDocument = new TypedDocumentString(`
    mutation fees_writeOffStudentsFee($input: [WriteOffInput!]) {
  fees_writeOffStudentsFee(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Fees_WriteOffStudentsFeeMutation, Fees_WriteOffStudentsFeeMutationVariables>;
export const Forms_ChartDocument = new TypedDocumentString(`
    query forms_chart($filter: Dtab_ChartTableFilter!) {
  forms_charts(input: $filter) {
    title
    type
    labels
    categories
    datasets {
      label
      meta
      data {
        value
        label
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Forms_ChartQuery, Forms_ChartQueryVariables>;
export const FormsAdmin_DeleteFormDefinitionDocument = new TypedDocumentString(`
    mutation formsAdmin_deleteFormDefinition($input: FormsAdmin_FormDefinitionsFilter!) {
  formsAdmin_deleteFormDefinition(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_DeleteFormDefinitionMutation, FormsAdmin_DeleteFormDefinitionMutationVariables>;
export const Forms_DeleteFormSubmissionDocument = new TypedDocumentString(`
    mutation forms_deleteFormSubmission($input: Forms_FormIdInput!) {
  forms_deleteFormSubmission(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Forms_DeleteFormSubmissionMutation, Forms_DeleteFormSubmissionMutationVariables>;
export const FormsAdmin_DisableFormDefinitionsDocument = new TypedDocumentString(`
    mutation formsAdmin_disableFormDefinitions($input: FormsFd_DisableFormDefinition!) {
  formsAdmin_disableFormDefinitions(input: $input) {
    id
    provider
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_DisableFormDefinitionsMutation, FormsAdmin_DisableFormDefinitionsMutationVariables>;
export const FormsAdmin_ExtensionPointsDocument = new TypedDocumentString(`
    query formsAdmin_extensionPoints($filter: Dtab_ExtensionPointAdminFilter) {
  formsAdmin_extensionPoints(filter: $filter) {
    extensionPointId
    area
    type
    isSystemDefined
    canView
    canWrite
    canEditTableDefinition
    disabled
    table {
      name
      columns {
        id {
          formId
          fieldId
        }
        label
        type
      }
    }
    tenantConfigs {
      extensionPointId
      tenant
      canView
      canWrite
      canEditTableDefinition
      disabled
    }
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_ExtensionPointsQuery, FormsAdmin_ExtensionPointsQueryVariables>;
export const FormsAdmin_DeleteExtensionPointDocument = new TypedDocumentString(`
    mutation formsAdmin_deleteExtensionPoint($input: Dtab_DeleteExtensionPointInput!) {
  formsAdmin_deleteExtensionPoint(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_DeleteExtensionPointMutation, FormsAdmin_DeleteExtensionPointMutationVariables>;
export const FormsAdmin_RegisterExtensionPointDocument = new TypedDocumentString(`
    mutation formsAdmin_registerExtensionPoint($input: Dtab_RegisterExtensionPointInput!) {
  formsAdmin_registerExtensionPoint(input: $input) {
    extensionPointId
    tenant
    canView
    canWrite
    disabled
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_RegisterExtensionPointMutation, FormsAdmin_RegisterExtensionPointMutationVariables>;
export const FormsAdmin_UnregisterExtensionPointDocument = new TypedDocumentString(`
    mutation formsAdmin_unregisterExtensionPoint($input: Dtab_UnregisterExtensionPointInput!) {
  formsAdmin_unregisterExtensionPoint(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_UnregisterExtensionPointMutation, FormsAdmin_UnregisterExtensionPointMutationVariables>;
export const FormsAdmin_InformationRequestDocument = new TypedDocumentString(`
    query formsAdmin_informationRequest($filter: FormsAdmin_InformationRequestFilter) {
  formsAdmin_informationRequest(filter: $filter) {
    id {
      id
      provider
    }
    formId {
      id
      provider
    }
    name
    description
    requestAboutParties {
      partyId
      avatarUrl
      firstName
      lastName
      type
    }
    informationRequestType
    stats {
      responseExpected
      responseCount
      responseCompleteCount
      responseConfirmationCount
      responseRejectedCount
    }
    dueDate
    publishDate
    tags {
      id
      name
      systemTag
    }
    links {
      id
      type
    }
    currentlyVisibleForResponders
    metaConfigType
    metaConfig {
      type
      ... on Timetable_OnCallAssignerOptions {
        type
        timetableId
        periodsToChooseFrom
        minPeriodsToBeSelected
        dueDate
        publishDate
        excludeTeachers
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_InformationRequestQuery, FormsAdmin_InformationRequestQueryVariables>;
export const FormsAdmin_FormDefinitionsDocument = new TypedDocumentString(`
    query formsAdmin_formDefinitions($filter: FormsAdmin_FormDefinitionsFilter) {
  formsAdmin_formDefinitions(filter: $filter) {
    id {
      id
      provider
    }
    title
    description
    tags {
      id
      name
    }
    isReusableTemplate
    allowPartialCompletion
    disabled
    tenantCanEdit
    usageCount
    fields {
      id
      header
      sortOrder
      fields {
        id {
          formId
          fieldId
        }
        sortOrder
        label
        type
        selectInfo {
          options {
            id
            value
          }
        }
        defaultValue
        required
        isMandatoryOnFormDefinition
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_FormDefinitionsQuery, FormsAdmin_FormDefinitionsQueryVariables>;
export const FormsAdmin_FormDefinitionsForSelectDocument = new TypedDocumentString(`
    query formsAdmin_formDefinitionsForSelect($filter: FormsAdmin_FormDefinitionsFilter) {
  formsAdmin_formDefinitions(filter: $filter) {
    id {
      id
      provider
    }
    title
    description
    tags {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_FormDefinitionsForSelectQuery, FormsAdmin_FormDefinitionsForSelectQueryVariables>;
export const FormsAdmin_InformationRequestTableViewDocument = new TypedDocumentString(`
    query formsAdmin_informationRequestTableView($filter: FormsAdmin_InformationRequestTableFilter!) {
  formsAdmin_informationRequestTableView(filter: $filter) {
    id {
      id
      provider
    }
    informationRequest {
      name
      informationRequestType
      isConfirmable
    }
    headers {
      id
      label
      type
    }
    rows {
      aboutParty {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      responderParty {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      completionStatus
      confirmationStatus
      columns {
        id
        value
      }
    }
    form {
      fields {
        id
        fields {
          id {
            formId
            fieldId
          }
          selectInfo {
            options {
              id
              value
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_InformationRequestTableViewQuery, FormsAdmin_InformationRequestTableViewQueryVariables>;
export const FormsAdmin_BlankFormDocument = new TypedDocumentString(`
    query formsAdmin_blankForm($filter: FormsAdmin_FormDefinitionViewFilter) {
  formsAdmin_blankForm(filter: $filter) {
    id {
      provider
      forPartyId
      objectId
    }
    title
    description
    status
    allowPartialCompletion
    gridWidth {
      xs
      sm
      md
      lg
      xl
    }
    readOnly
    fields {
      header
      fields {
        __typename
        ... on Forms_FormFieldSubGroup {
          formFieldType
          header
          fields {
            formFieldType
            id
            fieldGroupIdx
            label
            type
            required
            options {
              id
              name
            }
            gridWidth {
              xs
              sm
              md
              lg
              xl
            }
          }
          gridWidth {
            xs
            sm
            md
            lg
            xl
          }
        }
        ... on Forms_FormFieldItem {
          formFieldType
          id
          fieldGroupIdx
          label
          type
          required
          options {
            id
            name
          }
          gridWidth {
            xs
            sm
            md
            lg
            xl
          }
          defaultValue
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_BlankFormQuery, FormsAdmin_BlankFormQueryVariables>;
export const Forms_SearchFormsSubmissionsDocument = new TypedDocumentString(`
    query forms_searchFormsSubmissions($filter: Forms_SearchSubmissionFilter!) {
  forms_searchFormsSubmissions(filter: $filter) {
    id {
      provider
      forPartyId
      objectId
    }
    title
    description
    type
    singleSubmissionInfo {
      status
      confirmationStatus
      submissionCount
    }
    infoRequestInfo {
      id {
        id
        provider
      }
      responseExpected
      responseCount
      responseCompleteCount
      responseConfirmationCount
      responseRejectedCount
      dueDate
      publishDate
      isConfirmable
      currentlyVisibleForResponders
      metaConfigType
      metaConfig {
        type
        ... on Timetable_OnCallAssignerOptions {
          type
          timetableId
          periodsToChooseFrom
          minPeriodsToBeSelected
          dueDate
          publishDate
          excludeTeachers
        }
      }
    }
    links {
      id
      type
    }
    tags {
      id
      name
      type
      systemTag
      type
    }
    updatedBy {
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    updatedOn
  }
}
    `) as unknown as TypedDocumentString<Forms_SearchFormsSubmissionsQuery, Forms_SearchFormsSubmissionsQueryVariables>;
export const Forms_TableDocument = new TypedDocumentString(`
    query forms_table($filter: Dtab_TableFilter!) {
  forms_table(input: $filter) {
    id {
      id
      provider
    }
    name
    columns {
      id {
        formId
        fieldId
      }
      sortOrder
      label
      type
      selectInfo {
        options {
          id
          value
        }
      }
      defaultValue
      required
      isMandatoryOnFormDefinition
      groupId
    }
    columnGroups {
      id
      header
      sortOrder
    }
    rows {
      rowId {
        rowId
        tableId
      }
      header {
        type
        rowId {
          rowId
          tableId
        }
        __typename
        ... on Dtab_RowHeader_FormInfoRequest {
          type
          rowId {
            rowId
            tableId
          }
          aboutParty {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
          responderParty {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
        }
        ... on Dtab_RowHeader_FormSubmission {
          type
          rowId {
            rowId
            tableId
          }
          entityType
          id
          entity {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            type
          }
          entityPartyId
          createdOn
          createdBy {
            person {
              partyId
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              type
            }
          }
          lastUpdatedBy {
            person {
              partyId
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              type
            }
          }
          headerFields {
            label
            type
            value
            sortOrder
          }
        }
      }
      completionStatus
      confirmationStatus
      cells {
        id
        columnId
        value
        version
        isLatest
        rowId
      }
    }
    displayOptions {
      displayCompletedOnRow
      displayConfirmedOnRow
    }
    validationRules {
      allowedDyRelEntityTypes
    }
    pbac {
      isSecured
    }
  }
}
    `) as unknown as TypedDocumentString<Forms_TableQuery, Forms_TableQueryVariables>;
export const FormsAdmin_TagsDocument = new TypedDocumentString(`
    query formsAdmin_tags($filter: FormsAdminTagsFilter) {
  formsAdmin_tags(filter: $filter) {
    id
    name
    disabled
    tenantCanEdit
    systemTag
    type
    pbac {
      isSecured
    }
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_TagsQuery, FormsAdmin_TagsQueryVariables>;
export const FormsAdmin_UpsertFormDefinitionsDocument = new TypedDocumentString(`
    mutation formsAdmin_upsertFormDefinitions($input: FormsFd_UpsertFormDefinition!) {
  formsAdmin_upsertFormDefinitions(input: $input) {
    id {
      provider
    }
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_UpsertFormDefinitionsMutation, FormsAdmin_UpsertFormDefinitionsMutationVariables>;
export const FormsAdmin_UpsertInformationRequestDocument = new TypedDocumentString(`
    mutation formsAdmin_upsertInformationRequest($input: FormsAdmin_UpsertInformationRequest!) {
  formsAdmin_upsertInformationRequest(input: $input) {
    id {
      id
      provider
    }
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_UpsertInformationRequestMutation, FormsAdmin_UpsertInformationRequestMutationVariables>;
export const FormsAdmin_UpsertInformationRequestUsingMetaConfigDocument = new TypedDocumentString(`
    mutation formsAdmin_upsertInformationRequestUsingMetaConfig($input: FormsAdmin_UpsertInformationRequestUsingMetaConfigObj!) {
  formsAdmin_upsertInformationRequestUsingMetaConfig(input: $input) {
    id
    provider
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_UpsertInformationRequestUsingMetaConfigMutation, FormsAdmin_UpsertInformationRequestUsingMetaConfigMutationVariables>;
export const Forms_UpsertRowsDocument = new TypedDocumentString(`
    mutation forms_upsertRows($input: Forms_SubmitFormFieldInputs!) {
  forms_upsertRows(input: $input) {
    success
    rowDetails {
      rowIdentifier {
        rowId
        rowIndex
      }
      success
      topLevelErrors
    }
  }
}
    `) as unknown as TypedDocumentString<Forms_UpsertRowsMutation, Forms_UpsertRowsMutationVariables>;
export const FormsAdmin_UpsertTagsDocument = new TypedDocumentString(`
    mutation formsAdmin_upsertTags($input: [Dtab_UpsertTag]) {
  formsAdmin_upsertTags(input: $input) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<FormsAdmin_UpsertTagsMutation, FormsAdmin_UpsertTagsMutationVariables>;
export const Forms_ViewSubmissionDocument = new TypedDocumentString(`
    query forms_viewSubmission($filter: Forms_ViewSubmissionFilter!) {
  forms_viewSubmission(filter: $filter) {
    id {
      provider
      forPartyId
      objectId
    }
    title
    description
    status
    allowPartialCompletion
    gridWidth {
      xs
      sm
      md
      lg
      xl
    }
    readOnly
    fields {
      header
      fields {
        __typename
        ... on Forms_FormFieldSubGroup {
          formFieldType
          header
          fields {
            formFieldType
            id
            fieldGroupIdx
            label
            type
            required
            options {
              id
              name
            }
            gridWidth {
              xs
              sm
              md
              lg
              xl
            }
          }
          gridWidth {
            xs
            sm
            md
            lg
            xl
          }
        }
        ... on Forms_FormFieldItem {
          formFieldType
          id
          fieldGroupIdx
          label
          type
          required
          options {
            id
            name
          }
          gridWidth {
            xs
            sm
            md
            lg
            xl
          }
          defaultValue
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Forms_ViewSubmissionQuery, Forms_ViewSubmissionQueryVariables>;
export const Tt_LiveTimetableClassGroupsDocument = new TypedDocumentString(`
    query tt_liveTimetableClassGroups($filter: TT_LiveTimetableClassGroupsFilter!) {
  tt_liveTimetableClassGroups(filter: $filter) {
    ttClassGroupId
    partyId
    name
  }
}
    `) as unknown as TypedDocumentString<Tt_LiveTimetableClassGroupsQuery, Tt_LiveTimetableClassGroupsQueryVariables>;
export const Tt_AttachClassGroupsToTimetableDocument = new TypedDocumentString(`
    mutation tt_attachClassGroupsToTimetable($input: TT_AttachClassGroupsToTimetableInput!) {
  tt_attachClassGroupsToTimetable(input: $input) {
    results {
      classGroupPartyId
      ttClassGroupId
      status
      message
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_AttachClassGroupsToTimetableMutation, Tt_AttachClassGroupsToTimetableMutationVariables>;
export const Core_BlocksListDocument = new TypedDocumentString(`
    query core_blocksList($filter: BlockFilter) {
  core_blocks(filter: $filter) {
    blockId
    name
    description
    subjectGroupNamesJoined
    subjectGroupIds
    isRotation
  }
}
    `) as unknown as TypedDocumentString<Core_BlocksListQuery, Core_BlocksListQueryVariables>;
export const ClassGroupsListDocument = new TypedDocumentString(`
    query classGroupsList($filter: GeneralGroupFilter!) {
  generalGroups(filter: $filter) {
    partyId
    source
    name
    code
    avatarUrl
    studentMembers {
      memberCount
    }
    generalGroupType
    programmeStages {
      programme {
        name
      }
    }
    tutors {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      type
    }
    students {
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    yearGroupLeads {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      type
    }
    yearGroups {
      yearGroupId
      name
    }
  }
}
    `) as unknown as TypedDocumentString<ClassGroupsListQuery, ClassGroupsListQueryVariables>;
export const ClassGroupsByIdDocument = new TypedDocumentString(`
    query classGroupsById($filter: GeneralGroupFilter!) {
  generalGroups(filter: $filter) {
    partyId
    name
    students {
      person {
        partyId
        title {
          nameTextId
          id
          name
        }
        firstName
        lastName
        avatarUrl
        type
      }
      extensions {
        priority
        aen
        medical
      }
    }
    relatedSubjectGroups {
      name
      partyId
      avatarUrl
      studentMembershipType {
        type
      }
      subjects {
        name
        colour
        icon
      }
      programmeStages {
        name
      }
      staff {
        title {
          id
          nameTextId
          name
        }
        type
        firstName
        lastName
      }
      irePP {
        level
      }
      studentMembers {
        memberCount
      }
    }
    blocks {
      blockId
      name
    }
  }
}
    `) as unknown as TypedDocumentString<ClassGroupsByIdQuery, ClassGroupsByIdQueryVariables>;
export const Core_UpdateClassGroupsDocument = new TypedDocumentString(`
    mutation core_updateClassGroups($input: [UpdateClassGroupGroupInput!]) {
  core_updateClassGroups(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_UpdateClassGroupsMutation, Core_UpdateClassGroupsMutationVariables>;
export const Groups_UpsertCoreMembershipsDocument = new TypedDocumentString(`
    mutation groups_upsertCoreMemberships($input: EnrollmentIre_UpsertCoreMembership!) {
  enrollment_ire_upsertCoreMemberships(input: $input) {
    yearGroupEnrollment {
      yearGroupId
    }
  }
}
    `) as unknown as TypedDocumentString<Groups_UpsertCoreMembershipsMutation, Groups_UpsertCoreMembershipsMutationVariables>;
export const Groups_ChangeProgrammeStageDocument = new TypedDocumentString(`
    mutation groups_changeProgrammeStage($input: EnrollmentIre_ChangeProgrammeStages!) {
  enrollment_ire_changeProgrammeStage(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Groups_ChangeProgrammeStageMutation, Groups_ChangeProgrammeStageMutationVariables>;
export const Catalogue_GroupTagsDocument = new TypedDocumentString(`
    query catalogue_groupTags($filter: Catalogue_GroupTagFilter!) {
  catalogue_groupTags(filter: $filter) {
    id
    type
    uniqueName
    systemTag
    name
    description
    colour
    refId
  }
}
    `) as unknown as TypedDocumentString<Catalogue_GroupTagsQuery, Catalogue_GroupTagsQueryVariables>;
export const Catalogue_UpsertGroupTagDocument = new TypedDocumentString(`
    mutation catalogue_upsertGroupTag($input: [Catalogue_UpsertGroupTag!]!) {
  catalogue_upsertGroupTag(input: $input) {
    success
    message
  }
}
    `) as unknown as TypedDocumentString<Catalogue_UpsertGroupTagMutation, Catalogue_UpsertGroupTagMutationVariables>;
export const Catalogue_DeleteGroupTagDocument = new TypedDocumentString(`
    mutation catalogue_deleteGroupTag($input: Catalogue_DeleteGroupTag!) {
  catalogue_deleteGroupTag(input: $input) {
    success
    message
  }
}
    `) as unknown as TypedDocumentString<Catalogue_DeleteGroupTagMutation, Catalogue_DeleteGroupTagMutationVariables>;
export const Core_CopyGroupsDocument = new TypedDocumentString(`
    mutation core_copyGroups($input: [Core_CopyGroups]!) {
  core_copyGroups(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_CopyGroupsMutation, Core_CopyGroupsMutationVariables>;
export const Core_CustomGroupDefinitionDocument = new TypedDocumentString(`
    query core_customGroupDefinition($filter: Core_CustomGroupDefinitionFilter!) {
  core_customGroupDefinition(filter: $filter) {
    id
    name
    organisers {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
    }
    staffStatic {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    studentsStatic {
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      partyId
      classGroup {
        partyId
        name
      }
      programmeStages {
        id
        name
      }
      extensions {
        priority
        aen
        medical
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Core_CustomGroupDefinitionQuery, Core_CustomGroupDefinitionQueryVariables>;
export const SaveCustomGroupDefinitionDocument = new TypedDocumentString(`
    mutation saveCustomGroupDefinition($input: Core_UpsertCustomGroupDefinition!) {
  core_upsertCustomGroupDefinition(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<SaveCustomGroupDefinitionMutation, SaveCustomGroupDefinitionMutationVariables>;
export const CustomGroupsListDocument = new TypedDocumentString(`
    query customGroupsList($filter: GeneralGroupFilter!) {
  generalGroups(filter: $filter) {
    partyId
    name
    avatarUrl
    studentMembers {
      memberCount
    }
    staffMembers {
      memberCount
      members {
        partyId
        roles
      }
    }
    contactMembers {
      memberCount
    }
  }
}
    `) as unknown as TypedDocumentString<CustomGroupsListQuery, CustomGroupsListQueryVariables>;
export const CustomGroupByIdDocument = new TypedDocumentString(`
    query customGroupById($filter: GeneralGroupFilter!) {
  generalGroups(filter: $filter) {
    partyId
    name
    avatarUrl
    students {
      partyId
      classGroup {
        name
      }
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      extensions {
        priority
        aen
        medical
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CustomGroupByIdQuery, CustomGroupByIdQueryVariables>;
export const Core_DeleteGroupsDocument = new TypedDocumentString(`
    mutation core_deleteGroups($input: Core_DeleteGroupInput!) {
  core_deleteGroups(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_DeleteGroupsMutation, Core_DeleteGroupsMutationVariables>;
export const GroupSearchQueryDocument = new TypedDocumentString(`
    query groupSearchQuery($filter: SearchFilter) {
  search_search(filter: $filter) {
    partyId
    type
    text
    avatarUrl
  }
}
    `) as unknown as TypedDocumentString<GroupSearchQueryQuery, GroupSearchQueryQueryVariables>;
export const Core_ModifyBlocksDocument = new TypedDocumentString(`
    mutation core_modifyBlocks($input: Core_ModifyBlocks!) {
  core_modifyBlocks(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_ModifyBlocksMutation, Core_ModifyBlocksMutationVariables>;
export const Core_ModifyGroupMembershipsDocument = new TypedDocumentString(`
    mutation core_modifyGroupMemberships($input: Core_ModifyMemberships!) {
  core_modifyGroupMemberships(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_ModifyGroupMembershipsMutation, Core_ModifyGroupMembershipsMutationVariables>;
export const CoreModifySubjectGroupMembershipTypeDocument = new TypedDocumentString(`
    mutation coreModifySubjectGroupMembershipType($input: [Core_ModifySubjectGroupMembershipType]!) {
  core_modifySubjectGroupMembershipType(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<CoreModifySubjectGroupMembershipTypeMutation, CoreModifySubjectGroupMembershipTypeMutationVariables>;
export const PrintGroupMembersDocument = new TypedDocumentString(`
    query printGroupMembers($filter: Print_GroupMembers!) {
  print_groupMembers(filter: $filter) {
    url
    html
  }
}
    `) as unknown as TypedDocumentString<PrintGroupMembersQuery, PrintGroupMembersQueryVariables>;
export const ProgrammeStagesDocument = new TypedDocumentString(`
    query programmeStages($filter: ProgrammeStageEnrollmentFilter) {
  core_programmeStageEnrollments(filter: $filter) {
    avatarUrl
    name
    partyId
    programmeStageEnrollmentPartyId
    programmeStageId
    programmeStageLeads {
      type
      partyId
      avatarUrl
      firstName
      lastName
    }
    programmeStage {
      yearGroupId
      name
      description
      shortName
    }
    studentMembers {
      memberCount
    }
    students {
      partyId
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      classGroup {
        partyId
        name
      }
      tutors {
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      extensions {
        priority
        aen
        medical
      }
      yearGroupLeads {
        avatarUrl
        type
        partyId
        firstName
        lastName
      }
      programmeStages {
        id
        programmeId
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ProgrammeStagesQuery, ProgrammeStagesQueryVariables>;
export const Core_UpdateProgrammeStageEnrollmentsDocument = new TypedDocumentString(`
    mutation core_updateProgrammeStageEnrollments($input: [UpdateProgrammeStageEnrollmentInput]) {
  core_updateProgrammeStageEnrollments(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_UpdateProgrammeStageEnrollmentsMutation, Core_UpdateProgrammeStageEnrollmentsMutationVariables>;
export const StaffSearchQueryDocument = new TypedDocumentString(`
    query staffSearchQuery($filter: SearchFilter) {
  search_search(filter: $filter) {
    partyId
    type
    text
    avatarUrl
  }
}
    `) as unknown as TypedDocumentString<StaffSearchQueryQuery, StaffSearchQueryQueryVariables>;
export const StudentsSearchQueryDocument = new TypedDocumentString(`
    query studentsSearchQuery($filter: SearchFilter) {
  search_search(filter: $filter) {
    partyId
    type
    text
    avatarUrl
  }
}
    `) as unknown as TypedDocumentString<StudentsSearchQueryQuery, StudentsSearchQueryQueryVariables>;
export const Calendar_CalendarEventsIteratorDocument = new TypedDocumentString(`
    query calendar_calendarEventsIterator($filter: CalendarEventIteratorFilter!) {
  calendar_calendarEventsIterator_v2(filter: $filter) {
    event {
      eventId
      name
      colour
      calendarIds
      startTime
      endTime
      type
      attendees {
        partyId
        type
        partyInfo {
          partyId
          ... on Staff {
            person {
              firstName
              lastName
              avatarUrl
              type
              title {
                id
                name
                nameTextId
              }
            }
          }
        }
      }
      rooms {
        name
      }
      extensions {
        eventAttendance {
          eventId
          note
          attendanceCodeId
          attendanceCode {
            name
            codeType
          }
          personPartyId
          adminSubmitted
          createdBy {
            partyId
            firstName
            lastName
            type
            avatarUrl
            title {
              id
              name
              nameTextId
            }
          }
          updatedAt
          updatedBy {
            partyId
            firstName
            lastName
            type
            avatarUrl
            title {
              id
              name
              nameTextId
            }
          }
          groupAttendanceTaken
        }
        previousEventAttendance {
          attendanceCode {
            codeType
          }
          personPartyId
        }
      }
    }
    eventsOnSameDayForSameGroup {
      eventId
      name
      colour
      type
      startTime
      endTime
      rooms {
        name
      }
      tags {
        label
        context
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Calendar_CalendarEventsIteratorQuery, Calendar_CalendarEventsIteratorQueryVariables>;
export const SubjectGroupsDocument = new TypedDocumentString(`
    query subjectGroups($filter: SubjectGroupFilter!) {
  subjectGroups(filter: $filter) {
    partyId
    source
    name
    avatarUrl
    subjects {
      id
      name
      colour
      nationalCode
      icon
    }
    studentMembers {
      memberCount
    }
    staff {
      firstName
      lastName
      avatarUrl
    }
    irePP {
      level
      examinable
    }
    programmeStages {
      programme {
        name
      }
    }
    yearGroups {
      name
    }
    studentMembershipType {
      type
      classGroupId
      blockId
      classGroupName
    }
  }
}
    `) as unknown as TypedDocumentString<SubjectGroupsQuery, SubjectGroupsQueryVariables>;
export const SubjectGroupByIdDocument = new TypedDocumentString(`
    query subjectGroupById($filter: SubjectGroupFilter!) {
  subjectGroups(filter: $filter) {
    partyId
    name
    avatarUrl
    yearGroups {
      name
    }
    subjects {
      name
      colour
      icon
    }
    studentMembershipType {
      type
      classGroupId
      blockId
      classGroupName
    }
    staff {
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      type
    }
    students {
      partyId
      classGroup {
        name
      }
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      extensions {
        priority
        aen
        medical
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SubjectGroupByIdQuery, SubjectGroupByIdQueryVariables>;
export const Core_UpdateSubjectGroupsDocument = new TypedDocumentString(`
    mutation core_updateSubjectGroups($input: [UpdateSubjectGroupInput!]) {
  core_updateSubjectGroups(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_UpdateSubjectGroupsMutation, Core_UpdateSubjectGroupsMutationVariables>;
export const Core_SwitchSubjectGroupTypeDocument = new TypedDocumentString(`
    mutation core_switchSubjectGroupType($input: Core_SwitchSubjectGroupType!) {
  core_switchSubjectGroupType(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_SwitchSubjectGroupTypeMutation, Core_SwitchSubjectGroupTypeMutationVariables>;
export const Core_SubjectGroupStaffMembersDocument = new TypedDocumentString(`
    query core_subjectGroupStaffMembers($filter: SubjectGroupStudentFilter!) {
  core_subjectGroupStudents(filter: $filter) {
    subjectGroup {
      staffMembers {
        members {
          partyId
          person {
            partyId
            firstName
            lastName
            avatarUrl
            type
            title {
              id
              name
              nameTextId
            }
          }
          roles
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Core_SubjectGroupStaffMembersQuery, Core_SubjectGroupStaffMembersQueryVariables>;
export const SupportGroupsDocument = new TypedDocumentString(`
    query supportGroups($filter: SubjectGroupFilter!) {
  subjectGroups(filter: $filter) {
    partyId
    source
    name
    avatarUrl
    subjects {
      name
      colour
    }
    studentMembers {
      memberCount
    }
    staff {
      firstName
      lastName
      avatarUrl
    }
    irePP {
      level
      examinable
    }
    programmeStages {
      programme {
        name
      }
    }
    yearGroups {
      name
    }
  }
}
    `) as unknown as TypedDocumentString<SupportGroupsQuery, SupportGroupsQueryVariables>;
export const SupportGroupByIdDocument = new TypedDocumentString(`
    query supportGroupById($filter: SubjectGroupFilter!) {
  subjectGroups(filter: $filter) {
    partyId
    name
    avatarUrl
    yearGroups {
      name
    }
    subjects {
      name
      colour
    }
    staff {
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      type
    }
    students {
      partyId
      classGroup {
        name
      }
      person {
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportGroupByIdQuery, SupportGroupByIdQueryVariables>;
export const YearGroupEnrollmentsListDocument = new TypedDocumentString(`
    query yearGroupEnrollmentsList($filter: YearGroupEnrollmentFilter) {
  core_yearGroupEnrollments(filter: $filter) {
    partyId
    yearGroupEnrollmentPartyId
    name
    avatarUrl
    nationalCode
    yearGroupId
    shortName
    description
    yearGroupLeads {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    studentMembers {
      memberCount
    }
  }
}
    `) as unknown as TypedDocumentString<YearGroupEnrollmentsListQuery, YearGroupEnrollmentsListQueryVariables>;
export const YearGroupEnrollmentsDetailsDocument = new TypedDocumentString(`
    query yearGroupEnrollmentsDetails($filter: YearGroupEnrollmentFilter) {
  core_yearGroupEnrollments(filter: $filter) {
    yearGroupEnrollmentPartyId
    yearGroupId
    name
    avatarUrl
    students {
      partyId
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      classGroup {
        partyId
        name
      }
      tutors {
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      extensions {
        priority
        aen
        medical
      }
    }
    studentMembers {
      memberCount
    }
    yearGroupLeads {
      firstName
      lastName
      avatarUrl
    }
  }
}
    `) as unknown as TypedDocumentString<YearGroupEnrollmentsDetailsQuery, YearGroupEnrollmentsDetailsQueryVariables>;
export const Core_UpdateYearGroupEnrollmentsDocument = new TypedDocumentString(`
    mutation core_updateYearGroupEnrollments($input: [UpdateYearGroupEnrollmentInput!]) {
  core_updateYearGroupEnrollments(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_UpdateYearGroupEnrollmentsMutation, Core_UpdateYearGroupEnrollmentsMutationVariables>;
export const Forms_ListInformationRequestFormsDocument = new TypedDocumentString(`
    query forms_listInformationRequestForms($filter: Forms_InformationRequestListFormFilter) {
  forms_listInformationRequestForms(filter: $filter) {
    name
    id {
      provider
      forPartyId
      objectId
    }
    status
    completionDate
    dueDate
    forPerson {
      partyId
      firstName
      lastName
      avatarUrl
      type
    }
  }
}
    `) as unknown as TypedDocumentString<Forms_ListInformationRequestFormsQuery, Forms_ListInformationRequestFormsQueryVariables>;
export const Forms_ViewInformationRequestFormsDocument = new TypedDocumentString(`
    query forms_viewInformationRequestForms($filter: Forms_InformationRequestViewFormFilter) {
  forms_viewInformationRequestForms(filter: $filter) {
    id {
      provider
      forPartyId
      objectId
    }
    title
    description
    status
    gridWidth {
      xs
      sm
      md
      lg
      xl
    }
    readOnly
    allowPartialCompletion
    fields {
      header
      fields {
        __typename
        ... on Forms_FormFieldSubGroup {
          formFieldType
          header
          fields {
            formFieldType
            id
            fieldGroupIdx
            label
            type
            required
            options {
              id
              name
            }
            gridWidth {
              xs
              sm
              md
              lg
              xl
            }
          }
          gridWidth {
            xs
            sm
            md
            lg
            xl
          }
        }
        ... on Forms_FormFieldItem {
          formFieldType
          id
          fieldGroupIdx
          label
          type
          required
          options {
            id
            name
          }
          gridWidth {
            xs
            sm
            md
            lg
            xl
          }
          defaultValue
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Forms_ViewInformationRequestFormsQuery, Forms_ViewInformationRequestFormsQueryVariables>;
export const Forms_SubmitInformationRequestFormsDocument = new TypedDocumentString(`
    mutation forms_submitInformationRequestForms($input: Forms_SubmitFormInput!) {
  forms_submitInformationRequestForms(input: $input) {
    id {
      provider
      forPartyId
      objectId
    }
    globalId
    success
    validations {
      fieldErrors
      globalErrors
    }
  }
}
    `) as unknown as TypedDocumentString<Forms_SubmitInformationRequestFormsMutation, Forms_SubmitInformationRequestFormsMutationVariables>;
export const Communications_ArchiveMailDocument = new TypedDocumentString(`
    mutation communications_archiveMail($input: ArchiveMailInput) {
  communications_archiveMail(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Communications_ArchiveMailMutation, Communications_ArchiveMailMutationVariables>;
export const Communications_LabelDocument = new TypedDocumentString(`
    query communications_label($filter: LabelFilter) {
  communications_label(filter: $filter) {
    id
    name
    personPartyId
    colour
    custom
    type
  }
}
    `) as unknown as TypedDocumentString<Communications_LabelQuery, Communications_LabelQueryVariables>;
export const Update_Communications_LabelDocument = new TypedDocumentString(`
    mutation update_communications_label($input: LabelInput) {
  communications_saveLabel(input: $input) {
    id
    name
    personPartyId
    colour
    custom
  }
}
    `) as unknown as TypedDocumentString<Update_Communications_LabelMutation, Update_Communications_LabelMutationVariables>;
export const Communications_UnreadCountDocument = new TypedDocumentString(`
    query communications_unreadCount($filter: UnreadCountFilter) {
  communications_unreadCount(filter: $filter) {
    personPartyId
    labelId
    labelType
    count
  }
}
    `) as unknown as TypedDocumentString<Communications_UnreadCountQuery, Communications_UnreadCountQueryVariables>;
export const Communications_AssignLabelDocument = new TypedDocumentString(`
    mutation communications_assignLabel($input: AssignLabelInput) {
  communications_assignLabel(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Communications_AssignLabelMutation, Communications_AssignLabelMutationVariables>;
export const Communications_RecipientsDocument = new TypedDocumentString(`
    query communications_recipients($filter: RecipientFilter) {
  communications_recipients(filter: $filter) {
    partyId
    type
    text
    avatarUrl
  }
}
    `) as unknown as TypedDocumentString<Communications_RecipientsQuery, Communications_RecipientsQueryVariables>;
export const MailSearchQueryDocument = new TypedDocumentString(`
    query mailSearchQuery($filter: SearchFilter) {
  search_search(filter: $filter) {
    partyId
    type
    text
    avatarUrl
  }
}
    `) as unknown as TypedDocumentString<MailSearchQueryQuery, MailSearchQueryQueryVariables>;
export const MailListDocument = new TypedDocumentString(`
    query mailList($filter: MailFilter) {
  communications_mail(filter: $filter) {
    id
    threadId
    subject
    hasAttachments
    lastThreadMessageId
    lastThreadMessageBody
    lastThreadMessage
    read
    senders {
      sender {
        partyId
        title {
          id
          nameTextId
          name
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    resolvedRecipients {
      __typename
      id
      recipientPartyId
      resolvedName
      recipientType
      searchType
      person {
        partyId
        title {
          id
          nameTextId
          name
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
  }
}
    `) as unknown as TypedDocumentString<MailListQuery, MailListQueryVariables>;
export const SearchMailListDocument = new TypedDocumentString(`
    query searchMailList($filter: MailSearchFilter) {
  communications_mailSearch(filter: $filter) {
    id
    threadId
    subject
    hasAttachments
    lastThreadMessageId
    lastThreadMessageBody
    lastThreadMessage
    read
    senders {
      sender {
        partyId
        title {
          id
          nameTextId
          name
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    resolvedRecipients {
      __typename
      id
      recipientPartyId
      resolvedName
      recipientType
      searchType
      person {
        partyId
        title {
          id
          nameTextId
          name
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    labels {
      id
      name
      personPartyId
      colour
      custom
      type
    }
  }
}
    `) as unknown as TypedDocumentString<SearchMailListQuery, SearchMailListQueryVariables>;
export const Communications_MailThreadDocument = new TypedDocumentString(`
    query communications_mailThread($filter: MailThreadFilter) {
  communications_mailThread(filter: $filter) {
    id
    threadId
    threadMessageId
    subject
    body
    senderPartyId
    sender {
      partyId
      title {
        id
        nameTextId
        name
      }
      firstName
      lastName
      avatarUrl
      type
    }
    sentOn
    scheduleFor
    latestMessage
    canReply
    starred
    readOn
    resolvedRecipients {
      __typename
      id
      recipientPartyId
      resolvedName
      recipientType
      searchType
      person {
        partyId
        title {
          id
          nameTextId
          name
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    recipients {
      id
      recipientPartyId
      recipientType
      resolvedRecipientId
      recipient {
        partyId
        title {
          id
          nameTextId
          name
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    attachments {
      id
      url
    }
    labels {
      id
      name
      personPartyId
      colour
      custom
      type
    }
  }
}
    `) as unknown as TypedDocumentString<Communications_MailThreadQuery, Communications_MailThreadQueryVariables>;
export const Communications_SendMailDocument = new TypedDocumentString(`
    mutation communications_sendMail($input: SendMailInput) {
  communications_sendMail(input: $input) {
    id
    threadId
  }
}
    `) as unknown as TypedDocumentString<Communications_SendMailMutation, Communications_SendMailMutationVariables>;
export const Communications_StarredDocument = new TypedDocumentString(`
    mutation communications_starred($input: MailStarredInput) {
  communications_starred(input: $input)
}
    `) as unknown as TypedDocumentString<Communications_StarredMutation, Communications_StarredMutationVariables>;
export const Communications_ReadDocument = new TypedDocumentString(`
    mutation communications_read($input: MailReadInput) {
  communications_read(input: $input)
}
    `) as unknown as TypedDocumentString<Communications_ReadMutation, Communications_ReadMutationVariables>;
export const Communications_MailReadReceiptDocument = new TypedDocumentString(`
    query communications_mailReadReceipt($filter: ReadReceiptFilter) {
  communications_mailReadReceipt(filter: $filter) {
    id
    threadMessageId
    recipient {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    readOn
  }
}
    `) as unknown as TypedDocumentString<Communications_MailReadReceiptQuery, Communications_MailReadReceiptQueryVariables>;
export const Communications_RecallMailDocument = new TypedDocumentString(`
    mutation communications_recallMail($input: RecallMailInput) {
  communications_recallMail(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Communications_RecallMailMutation, Communications_RecallMailMutationVariables>;
export const Communications_PartiesDocument = new TypedDocumentString(`
    query communications_parties($filter: RecipientFilter) {
  communications_parties(filter: $filter) {
    partyId
    type
    text
    avatarUrl
  }
}
    `) as unknown as TypedDocumentString<Communications_PartiesQuery, Communications_PartiesQueryVariables>;
export const Communications_DeleteScheduledMailDocument = new TypedDocumentString(`
    mutation communications_deleteScheduledMail($input: DeleteScheduledMailInput!) {
  communications_deleteScheduledMail(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Communications_DeleteScheduledMailMutation, Communications_DeleteScheduledMailMutationVariables>;
export const Communications_ArchiveNoticeDocument = new TypedDocumentString(`
    mutation communications_archiveNotice($input: NoticeAction) {
  communications_archiveNotice(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Communications_ArchiveNoticeMutation, Communications_ArchiveNoticeMutationVariables>;
export const Communications_DeleteNoticeDocument = new TypedDocumentString(`
    mutation communications_deleteNotice($input: NoticeAction!) {
  communications_deleteNotice(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Communications_DeleteNoticeMutation, Communications_DeleteNoticeMutationVariables>;
export const Communications_NoticeboardDocument = new TypedDocumentString(`
    query communications_noticeboard($filter: NoticeboardFilter) {
  communications_noticeboard(filter: $filter) {
    id
    title
    notice
    priority
    validFrom
    validUntil
    images {
      id
      url
      isCover
    }
    recipients {
      id {
        noticeId
        partyId
      }
      acknowledged
      acknowledgedOn
    }
    pinned
    publicNotice
    socialPosts {
      id
      socialPostId
      platform
      status
      retryCount
      maxRetries
      errorMessage
      nextRetryAt
    }
  }
}
    `) as unknown as TypedDocumentString<Communications_NoticeboardQuery, Communications_NoticeboardQueryVariables>;
export const Communications_NoticeboardDetailsDocument = new TypedDocumentString(`
    query communications_noticeboardDetails($filter: NoticeboardFilter) {
  communications_noticeboard(filter: $filter) {
    id
    title
    notice
    priority
    validFrom
    validUntil
    images {
      id
      url
      isCover
    }
    allStaff
    allContacts
    allStudents
    assignedToParties {
      id {
        noticeId
        partyId
      }
      staff
      contact
      student
      party {
        __typename
        ... on GeneralGroup {
          name
          partyId
          avatarUrl
        }
        ... on ProgrammeStageEnrollment {
          partyId
          name
        }
        ... on SubjectGroup {
          name
          partyId
          avatarUrl
        }
        ... on YearGroupEnrollment {
          name
          partyId
        }
        ... on Staff {
          partyId
          person {
            partyId
            firstName
            lastName
            avatarUrl
            type
            title {
              id
              name
              nameTextId
            }
          }
        }
        ... on Student {
          partyId
          person {
            partyId
            firstName
            lastName
            avatarUrl
            type
            title {
              id
              name
              nameTextId
            }
          }
        }
        ... on StudentContact {
          partyId
          person {
            partyId
            firstName
            lastName
            avatarUrl
            type
            title {
              id
              name
              nameTextId
            }
          }
        }
      }
    }
    recipients {
      id {
        noticeId
        partyId
      }
      acknowledged
      acknowledgedOn
    }
    pinned
    archived
    publicNotice
    socialPosts {
      id
      socialPostId
      platform
      status
      retryCount
      maxRetries
      errorMessage
      nextRetryAt
    }
    archivedByPartyId
    archivedBy {
      partyId
      title {
        id
        name
      }
      firstName
      lastName
      avatarUrl
      type
      archived
    }
  }
}
    `) as unknown as TypedDocumentString<Communications_NoticeboardDetailsQuery, Communications_NoticeboardDetailsQueryVariables>;
export const Communications_AcknowledgeNoticeDocument = new TypedDocumentString(`
    mutation communications_acknowledgeNotice($input: NoticeAction) {
  communications_acknowledgeNotice(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Communications_AcknowledgeNoticeMutation, Communications_AcknowledgeNoticeMutationVariables>;
export const Communications_RetrySocialPostDocument = new TypedDocumentString(`
    mutation communications_retrySocialPost($input: RetrySocialPostInput!) {
  communications_retrySocialPost(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Communications_RetrySocialPostMutation, Communications_RetrySocialPostMutationVariables>;
export const Communications_NoticeboardConfigDocument = new TypedDocumentString(`
    query communications_noticeboardConfig {
  communications_noticeboardConfig {
    enabled
    publicNoticeboardId
    publicNoticeboardLink
  }
}
    `) as unknown as TypedDocumentString<Communications_NoticeboardConfigQuery, Communications_NoticeboardConfigQueryVariables>;
export const Communications_NoticeboardConfigureDocument = new TypedDocumentString(`
    mutation communications_noticeboardConfigure($input: Communications_NoticeboardConfigInput!) {
  communications_noticeboardConfigure(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Communications_NoticeboardConfigureMutation, Communications_NoticeboardConfigureMutationVariables>;
export const Communications_SaveNoticeDocument = new TypedDocumentString(`
    mutation communications_saveNotice($input: [SaveNoticeInput!]!) {
  communications_saveNotice(input: $input) {
    id
    title
    notice
  }
}
    `) as unknown as TypedDocumentString<Communications_SaveNoticeMutation, Communications_SaveNoticeMutationVariables>;
export const Notes_BehaviourCategoriesDocument = new TypedDocumentString(`
    query notes_behaviourCategories($filter: Notes_BehaviourCategoryFilter) {
  notes_behaviourCategories(filter: $filter) {
    behaviourCategoryId
    name
    description
    behaviourType
  }
}
    `) as unknown as TypedDocumentString<Notes_BehaviourCategoriesQuery, Notes_BehaviourCategoriesQueryVariables>;
export const Notes_BehaviourLevelsDocument = new TypedDocumentString(`
    query notes_behaviourLevels($filter: Notes_BehaviourCategoryFilter) {
  notes_behaviourCategories(filter: $filter) {
    behaviourType
    behaviourCategoryId
    name
    description
    behaviourType
    tags {
      id
      category
      name
      nameTextId
      description
      descriptionTextId
      tag_l1
      tag_l2
      tag_l3
      behaviourType
    }
  }
}
    `) as unknown as TypedDocumentString<Notes_BehaviourLevelsQuery, Notes_BehaviourLevelsQueryVariables>;
export const Notes_BehaviourTagUsageDocument = new TypedDocumentString(`
    query notes_behaviourTagUsage($filter: Notes_BehaviourTagUsageFilter!) {
  notes_behaviourTagUsage(filter: $filter) {
    tagId
    linkedBehaviourCount
  }
}
    `) as unknown as TypedDocumentString<Notes_BehaviourTagUsageQuery, Notes_BehaviourTagUsageQueryVariables>;
export const Notes_Tags_BehavioursDocument = new TypedDocumentString(`
    query notes_tags_behaviours($filter: Notes_TagFilter!) {
  notes_tags(filter: $filter) {
    id
    name
    description
    behaviourType
    tag_l2
    category
    behaviourCategory {
      behaviourCategoryId
      name
    }
    points
    availableToContacts
    availableToStaff
    availableToStudents
  }
}
    `) as unknown as TypedDocumentString<Notes_Tags_BehavioursQuery, Notes_Tags_BehavioursQueryVariables>;
export const Notes_DeleteBehaviourTagDocument = new TypedDocumentString(`
    mutation notes_deleteBehaviourTag($input: Notes_DeleteBehaviourTagInput!) {
  notes_deleteBehaviourTag(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Notes_DeleteBehaviourTagMutation, Notes_DeleteBehaviourTagMutationVariables>;
export const Notes_DeleteBehaviourNoteDocument = new TypedDocumentString(`
    mutation notes_deleteBehaviourNote($input: Notes_DeleteBehaviourNote!) {
  notes_deleteBehaviourNote(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Notes_DeleteBehaviourNoteMutation, Notes_DeleteBehaviourNoteMutationVariables>;
export const Notes_Notes_BehaviourDocument = new TypedDocumentString(`
    query notes_notes_behaviour($filter: Notes_NotesFilter!) {
  notes_notes(filter: $filter) {
    id
    note
    createdOn
    createdBy
    incidentDate
    createdByPerson {
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
    }
    tags {
      id
      name
      category
      behaviourType
      descriptionTextId
      nameTextId
    }
    associatedGroups {
      __typename
      partyId
      ... on SubjectGroup {
        subjects {
          name
          colour
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Notes_Notes_BehaviourQuery, Notes_Notes_BehaviourQueryVariables>;
export const Notes_ResetBehaviourPointsDocument = new TypedDocumentString(`
    mutation notes_resetBehaviourPoints($input: Notes_BehaviourResetPoints) {
  notes_resetBehaviourPoints(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Notes_ResetBehaviourPointsMutation, Notes_ResetBehaviourPointsMutationVariables>;
export const Notes_BehaviourDocument = new TypedDocumentString(`
    query notes_behaviour($filter: Notes_BehaviourFilter) {
  notes_behaviour(filter: $filter) {
    behaviours {
      noteId
      incidentDate
      referencedParties {
        partyId
        firstName
        lastName
        avatarUrl
        type
      }
      associatedParties {
        __typename
        partyId
        ... on GeneralGroup {
          name
          partyId
          avatarUrl
        }
        ... on ProgrammeStageEnrollment {
          partyId
          name
        }
        ... on SubjectGroup {
          name
          partyId
          avatarUrl
        }
        ... on YearGroupEnrollment {
          name
          partyId
        }
        ... on Staff {
          partyId
          person {
            partyId
            firstName
            lastName
            avatarUrl
            type
            title {
              id
              name
              nameTextId
            }
          }
        }
        ... on Student {
          partyId
          person {
            partyId
            firstName
            lastName
            avatarUrl
            type
            title {
              id
              name
              nameTextId
            }
          }
        }
        ... on StudentContact {
          partyId
          person {
            partyId
            firstName
            lastName
            avatarUrl
            type
            title {
              id
              name
              nameTextId
            }
          }
        }
      }
      associatedPartyIds
      category
      details
      takenByPartyId
      takenBy {
        partyId
        firstName
        lastName
        avatarUrl
        type
      }
      tags {
        id
        name
        description
        behaviourType
        points
      }
      tagIds
      points
    }
    categories {
      behaviourCategoryId
      name
      count
      behaviourType
    }
  }
}
    `) as unknown as TypedDocumentString<Notes_BehaviourQuery, Notes_BehaviourQueryVariables>;
export const Notes_UpsertBehaviourCategoryDocument = new TypedDocumentString(`
    mutation notes_upsertBehaviourCategory($input: Notes_BehaviourCategoryInput) {
  notes_upsertBehaviourCategory(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Notes_UpsertBehaviourCategoryMutation, Notes_UpsertBehaviourCategoryMutationVariables>;
export const Notes_UpsertBehaviourTagsDocument = new TypedDocumentString(`
    mutation notes_upsertBehaviourTags($input: [Notes_UpsertBehaviourTagInput]) {
  notes_upsertBehaviourTags(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Notes_UpsertBehaviourTagsMutation, Notes_UpsertBehaviourTagsMutationVariables>;
export const Notes_UpsertBehaviourNoteDocument = new TypedDocumentString(`
    mutation notes_upsertBehaviourNote($input: [Notes_UpsertNote]) {
  notes_upsertNotes(input: $input) {
    id
    tags {
      behaviourType
    }
  }
}
    `) as unknown as TypedDocumentString<Notes_UpsertBehaviourNoteMutation, Notes_UpsertBehaviourNoteMutationVariables>;
export const Core_PeopleDocument = new TypedDocumentString(`
    query core_people($filter: Core_PeopleFilter!) {
  core_people(filter: $filter) {
    partyId
    title {
      id
      name
      nameTextId
    }
    firstName
    lastName
    avatarUrl
    type
  }
}
    `) as unknown as TypedDocumentString<Core_PeopleQuery, Core_PeopleQueryVariables>;
export const Catalogue_PersonalTitlesDocument = new TypedDocumentString(`
    query catalogue_personalTitles {
  catalogue_personalTitles {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<Catalogue_PersonalTitlesQuery, Catalogue_PersonalTitlesQueryVariables>;
export const PrintPersonsGroupMembershipsDocument = new TypedDocumentString(`
    query printPersonsGroupMemberships($filter: Print_PersonsGroupMemberships!) {
  print_personsGroupMemberships(filter: $filter) {
    url
    html
  }
}
    `) as unknown as TypedDocumentString<PrintPersonsGroupMembershipsQuery, PrintPersonsGroupMembershipsQueryVariables>;
export const Users_UserPermissionsDocument = new TypedDocumentString(`
    query users_userPermissions($partyPersonId: Long!) {
  users_userPermissions(partyPersonId: $partyPersonId) {
    id
    name
    description
    feature
    permissionGroups {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<Users_UserPermissionsQuery, Users_UserPermissionsQueryVariables>;
export const Core_ArchiveStudentContactsDocument = new TypedDocumentString(`
    mutation core_archiveStudentContacts($input: ArchiveStudentContactInput!) {
  core_archiveStudentContacts(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_ArchiveStudentContactsMutation, Core_ArchiveStudentContactsMutationVariables>;
export const Core_StudentContactsDocument = new TypedDocumentString(`
    query core_studentContacts($filter: StudentContactFilter!) {
  core_studentContacts(filter: $filter) {
    partyId
    spokenLanguages
    requiresInterpreter
    occupation
    person {
      avatarUrl
      firstName
      lastName
      type
      title {
        id
        name
        nameTextId
      }
    }
    personalInformation {
      gender
      primaryAddress {
        line1
        line2
        line3
        city
        country
        postCode
      }
      primaryPhoneNumber {
        number
        areaCode
        countryCode
      }
      primaryEmail {
        email
      }
    }
    postalTitle
    relationships {
      allowedToContact
      includeInSms
      legalGuardian
      pickupRights
      allowAccessToStudentData
      allowedToContact
      includeInTemplating
      priority
      relationshipType
      student {
        partyId
        person {
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
        classGroup {
          name
        }
        yearGroups {
          name
        }
      }
      allowedToContact
      pickupRights
      legalGuardian
      allowAccessToStudentData
      includeInTmail
      includeInTemplating
      includeInSms
    }
  }
}
    `) as unknown as TypedDocumentString<Core_StudentContactsQuery, Core_StudentContactsQueryVariables>;
export const Core_StudentContactsForSelectDocument = new TypedDocumentString(`
    query core_studentContactsForSelect($filter: StudentContactFilter!) {
  core_studentContacts(filter: $filter) {
    person {
      partyId
      title {
        nameTextId
        id
        name
      }
      firstName
      lastName
      avatarUrl
      type
    }
    personalInformation {
      primaryEmail {
        email
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Core_StudentContactsForSelectQuery, Core_StudentContactsForSelectQueryVariables>;
export const Core_StudentContacts_PersonalDocument = new TypedDocumentString(`
    query core_studentContacts_personal($filter: StudentContactFilter!) {
  core_studentContacts(filter: $filter) {
    partyId
    person {
      partyId
      title {
        id
        name
        nameTextId
      }
      avatarUrl
      firstName
      lastName
      type
      customFields {
        id
        name
        value
        customFieldId
        partyId
        source
        type
      }
    }
    personalInformation {
      firstName
      lastName
      preferredFirstName
      middleName
      gender
      dateOfBirth
      ire {
        ppsNumber
        religion
        countryOfBirth
      }
      nationality
      mothersMaidenName
      primaryAddress {
        id
        line1
        line2
        line3
        city
        country
        postCode
      }
      primaryPhoneNumber {
        phoneNumberId
        number
        areaCode
        countryCode
      }
      phoneNumbers {
        phoneNumberId
        primaryPhoneNumber
        number
        areaCode
        countryCode
      }
      primaryEmail {
        emailId
        email
      }
    }
    occupation
    requiresInterpreter
    spokenLanguages
    postalTitle
    relationships {
      relationshipType
      studentPartyId
      priority
      allowedToContact
      includeInSms
      includeInTmail
      includeInTemplating
      pickupRights
      legalGuardian
      allowAccessToStudentData
      includeInTemplating
    }
  }
}
    `) as unknown as TypedDocumentString<Core_StudentContacts_PersonalQuery, Core_StudentContacts_PersonalQueryVariables>;
export const Users_ResetPasswordBySmsDocument = new TypedDocumentString(`
    mutation users_resetPasswordBySms($input: Users_ResetPassword!) {
  users_resetPasswordBySms(input: $input) {
    success
    error
  }
}
    `) as unknown as TypedDocumentString<Users_ResetPasswordBySmsMutation, Users_ResetPasswordBySmsMutationVariables>;
export const Core_StudentContacts_StudentsDocument = new TypedDocumentString(`
    query core_studentContacts_students($filter: StudentContactFilter!) {
  core_studentContacts(filter: $filter) {
    partyId
    relationships {
      studentPartyId
      relationshipType
      priority
      allowedToContact
      includeInSms
      includeInTmail
      includeInTemplating
      pickupRights
      legalGuardian
      allowAccessToStudentData
      ... on StudentContactRelationshipInfo {
        student {
          partyId
          classGroup {
            name
          }
          ... on Student {
            person {
              partyId
              firstName
              lastName
              avatarUrl
              type
              title {
                id
                name
                nameTextId
              }
            }
            extensions {
              priority
              aen
              medical
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Core_StudentContacts_StudentsQuery, Core_StudentContacts_StudentsQueryVariables>;
export const Core_UpdateStudentContactsDocument = new TypedDocumentString(`
    mutation core_updateStudentContacts($input: [UpdateStudentContactInput!]!) {
  core_updateStudentContacts(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_UpdateStudentContactsMutation, Core_UpdateStudentContactsMutationVariables>;
export const Core_UpsertStudentContactDocument = new TypedDocumentString(`
    mutation core_upsertStudentContact($input: UpsertStudentContactInput!) {
  core_upsertStudentContact(input: $input) {
    partyId
  }
}
    `) as unknown as TypedDocumentString<Core_UpsertStudentContactMutation, Core_UpsertStudentContactMutationVariables>;
export const Delete_File_TransferDocument = new TypedDocumentString(`
    mutation delete_file_transfer($input: DeleteFileTransferInput!) {
  delete_file_transfer(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Delete_File_TransferMutation, Delete_File_TransferMutationVariables>;
export const MoveDocsDocument = new TypedDocumentString(`
    mutation moveDocs($input: MoveFileTransferInput!) {
  move_file_transfer(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<MoveDocsMutation, MoveDocsMutationVariables>;
export const Notes_DeleteNoteDocument = new TypedDocumentString(`
    mutation notes_deleteNote($input: Notes_DeleteNotes!) {
  notes_deleteNote(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Notes_DeleteNoteMutation, Notes_DeleteNoteMutationVariables>;
export const Notes_NotesDocument = new TypedDocumentString(`
    query notes_notes($filter: Notes_NotesFilter!) {
  notes_notes(filter: $filter) {
    id
    note
    createdOn
    createdBy
    createdByPerson {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    tags {
      id
      name
      category
      descriptionTextId
      nameTextId
      colour
    }
    priorityNote
    priorityStartDate
    priorityEndDate
    pbac {
      isSecured
    }
  }
}
    `) as unknown as TypedDocumentString<Notes_NotesQuery, Notes_NotesQueryVariables>;
export const Notes_TagsDocument = new TypedDocumentString(`
    query notes_tags($filter: Notes_TagFilter!) {
  notes_tags(filter: $filter) {
    id
    name
    description
    category
    tag_l1
    colour
    pbac {
      isSecured
    }
  }
}
    `) as unknown as TypedDocumentString<Notes_TagsQuery, Notes_TagsQueryVariables>;
export const Notesv2_NotesDocument = new TypedDocumentString(`
    query notesv2_notes($filter: Notesv2_NoteFilter!) {
  notesv2_notes(filter: $filter) {
    notes {
      id
      note
      fromDate
      toDate
      createdOn
      updatedOn
      tags {
        id
        name
        colour
      }
      createdBy {
        person {
          partyId
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Notesv2_NotesQuery, Notesv2_NotesQueryVariables>;
export const Notes_UpsertNotesTagsDocument = new TypedDocumentString(`
    mutation notes_upsertNotesTags($input: [Notes_UpsertNotesTagInput]) {
  notes_upsertNotesTags(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Notes_UpsertNotesTagsMutation, Notes_UpsertNotesTagsMutationVariables>;
export const Notes_UpsertNotesDocument = new TypedDocumentString(`
    mutation notes_upsertNotes($input: [Notes_UpsertNote]) {
  notes_upsertNotes(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Notes_UpsertNotesMutation, Notes_UpsertNotesMutationVariables>;
export const PersonStatusDocument = new TypedDocumentString(`
    query personStatus($filter: PersonStatusFilter) {
  composite_personStatus(filter: $filter) {
    partyId
    sessionAttendance {
      name
      status
    }
    currentLocation {
      partyId
      eventId
      room {
        roomId
        name
        capacity
      }
      lesson
      teacher
      currentAttendance {
        attendanceCodeName
        codeType
      }
    }
    priorityStudent
    activeSupportPlan
  }
}
    `) as unknown as TypedDocumentString<PersonStatusQuery, PersonStatusQueryVariables>;
export const Eire_DeleteNonClassContactHoursDocument = new TypedDocumentString(`
    mutation eire_deleteNonClassContactHours($input: DeleteNonClassContactHoursInput!) {
  eire_deleteNonClassContactHours(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Eire_DeleteNonClassContactHoursMutation, Eire_DeleteNonClassContactHoursMutationVariables>;
export const Core_DiscontinueInAcademicNamespaceDocument = new TypedDocumentString(`
    mutation core_discontinueInAcademicNamespace($input: Core_DiscontinueAcademicNamespaceInput!) {
  core_discontinueInAcademicNamespace(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_DiscontinueInAcademicNamespaceMutation, Core_DiscontinueInAcademicNamespaceMutationVariables>;
export const Catalogue_StaffCapacitiesDocument = new TypedDocumentString(`
    query catalogue_staffCapacities {
  catalogue_staffCapacities {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<Catalogue_StaffCapacitiesQuery, Catalogue_StaffCapacitiesQueryVariables>;
export const Core_EnrolInAcademicNamespaceDocument = new TypedDocumentString(`
    mutation core_enrolInAcademicNamespace($input: Core_EnrolInAcademicNamespaceInput!) {
  core_enrolInAcademicNamespace(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_EnrolInAcademicNamespaceMutation, Core_EnrolInAcademicNamespaceMutationVariables>;
export const Core_StaffEnrolmentDocument = new TypedDocumentString(`
    query core_staffEnrolment($filter: StaffFilter) {
  core_staff(filter: $filter) {
    partyId
    person {
      partyId
      firstName
      lastName
      avatarUrl
      type
      title {
        id
        name
        nameTextId
      }
    }
    displayCode
    enrolledNamespaces {
      academicNamespaceId
      name
      year
      startDate
      endDate
      isActiveDefaultNamespace
    }
  }
}
    `) as unknown as TypedDocumentString<Core_StaffEnrolmentQuery, Core_StaffEnrolmentQueryVariables>;
export const Core_StaffDocument = new TypedDocumentString(`
    query core_staff($filter: StaffFilter) {
  core_staff(filter: $filter) {
    partyId
    externalSystemId
    person {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    employmentCapacity {
      name
    }
    startDate
    endDate
    personalInformation {
      dateOfBirth
      primaryAddress {
        line1
        line2
        line3
        postCode
        county
        country
        city
      }
      gender
      primaryPhoneNumber {
        number
        areaCode
        countryCode
      }
      primaryEmail {
        email
      }
      emails {
        emailId
        email
        primaryEmail
      }
      ire {
        ppsNumber
      }
    }
    staffIre {
      teacherCouncilNumber
      staffPost {
        id
        name
      }
    }
    carRegistrationNumber
    parking
    position
    displayCode
    payrollNumber
    jobSharing
    availableForTeaching
    availableForSubstitution
    availableForSupportClasses
    competencySubjects {
      id
      name
      colour
    }
    qualifications
    peopleTags {
      id
      name
      colour
    }
  }
}
    `) as unknown as TypedDocumentString<Core_StaffQuery, Core_StaffQueryVariables>;
export const Core_StaffInfoForSelectDocument = new TypedDocumentString(`
    query core_staffInfoForSelect($filter: StaffFilter) {
  core_staff(filter: $filter) {
    person {
      partyId
      title {
        nameTextId
        id
        name
      }
      firstName
      lastName
      avatarUrl
      type
    }
    externalSystemId
    displayCode
    personalInformation {
      ire {
        ppsNumber
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Core_StaffInfoForSelectQuery, Core_StaffInfoForSelectQueryVariables>;
export const Eire_NonClassContactHoursDocument = new TypedDocumentString(`
    query eire_nonClassContactHours($filter: NonClassContactHoursFilter) {
  eire_nonClassContactHours(filter: $filter) {
    academicNameSpaceId
    activity
    dayOfTheWeek
    description
    hours
    minutes
    nonClassContactHoursId
    programme
    staffPartyId
    staff {
      partyId
      person {
        firstName
        lastName
        avatarUrl
        partyId
        type
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Eire_NonClassContactHoursQuery, Eire_NonClassContactHoursQueryVariables>;
export const Catalogue_PeopleTagsDocument = new TypedDocumentString(`
    query catalogue_peopleTags($filter: Catalogue_PeopleTagFilter!) {
  catalogue_peopleTags(filter: $filter) {
    id
    name
    colour
  }
}
    `) as unknown as TypedDocumentString<Catalogue_PeopleTagsQuery, Catalogue_PeopleTagsQueryVariables>;
export const Core_Staff_PersonalDocument = new TypedDocumentString(`
    query core_staff_personal($filter: StaffFilter) {
  core_staff(filter: $filter) {
    partyId
    externalSystemId
    person {
      type
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      customFields {
        id
        name
        value
        customFieldId
        partyId
        source
        type
      }
    }
    startDate
    endDate
    noLongerStaffMember
    personalInformation {
      gender
      dateOfBirth
      ire {
        ppsNumber
      }
      primaryAddress {
        id
        line1
        line2
        line3
        city
        country
        postCode
      }
      primaryPhoneNumber {
        phoneNumberId
        number
        areaCode
        countryCode
      }
      phoneNumbers {
        phoneNumberId
        primaryPhoneNumber
        number
        areaCode
        countryCode
      }
      primaryEmail {
        emailId
        email
      }
      emails {
        emailId
        email
        primaryEmail
      }
      nextOfKin {
        firstName
        lastName
        phoneNumbers
      }
    }
    staffIre {
      qualifications2
      qualifications3
      qualifications4
      teacherCouncilNumber
      staffPost {
        id
        name
      }
    }
    payrollNumber
    employmentCapacity {
      id
      name
    }
    emergencyContact {
      firstName
      lastName
      primaryNumber
      additionalNumber
    }
    displayCode
    carRegistrationNumber
    makeAndModel
    parking
    jobSharing
    qualifications
    competencies
    availableForTeaching
    availableForSubstitution
    availableForSupportClasses
    position
    competencySubjects {
      id
      name
      colour
    }
  }
}
    `) as unknown as TypedDocumentString<Core_Staff_PersonalQuery, Core_Staff_PersonalQueryVariables>;
export const Core_ReinstateStaffDocument = new TypedDocumentString(`
    mutation core_reinstateStaff($input: Core_ReinstateMemberInput!) {
  core_reinstateStaff(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_ReinstateStaffMutation, Core_ReinstateStaffMutationVariables>;
export const Eire_RollOverNonClassContactHoursDocument = new TypedDocumentString(`
    mutation eire_rollOverNonClassContactHours($input: RollOverNonClassContactHoursInput!) {
  eire_rollOverNonClassContactHours(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Eire_RollOverNonClassContactHoursMutation, Eire_RollOverNonClassContactHoursMutationVariables>;
export const Core_StaffAvailabilityDocument = new TypedDocumentString(`
    query core_staffAvailability($filter: Core_StaffAvailabilityFilter!) {
  core_staffAvailability(filter: $filter) {
    staffPartyId
    person {
      partyId
      firstName
      lastName
      avatarUrl
      type
    }
    noLongerStaffMember
    activeInYear
    availableForTeaching
    availableForTeachingIsOverridden
    availableForSubstitution
    availableForSubstitutionIsOverridden
    defaultAvailableForTeaching
    defaultAvailableForSubstitution
    defaultAvailableForSupportClasses
  }
}
    `) as unknown as TypedDocumentString<Core_StaffAvailabilityQuery, Core_StaffAvailabilityQueryVariables>;
export const Core_UpdateStaffAvailabilityDocument = new TypedDocumentString(`
    mutation core_updateStaffAvailability($input: Core_UpdateStaffAvailabilityInput!) {
  core_updateStaffAvailability(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_UpdateStaffAvailabilityMutation, Core_UpdateStaffAvailabilityMutationVariables>;
export const Catalogue_StaffPostsDocument = new TypedDocumentString(`
    query catalogue_staffPosts {
  catalogue_staffPosts {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<Catalogue_StaffPostsQuery, Catalogue_StaffPostsQueryVariables>;
export const Core_Staff_SubjectGroupsDocument = new TypedDocumentString(`
    query core_staff_subjectGroups($filter: StaffFilter, $filter2: SubjectGroupRelationshipFilter) {
  core_staff(filter: $filter) {
    subjectGroups(filter: $filter2) {
      partyId
      name
      avatarUrl
      subjects {
        name
        colour
        icon
      }
      irePP {
        level
      }
      studentMembers {
        memberCount
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Core_Staff_SubjectGroupsQuery, Core_Staff_SubjectGroupsQueryVariables>;
export const Eire_UpdateNonClassContactHoursDocument = new TypedDocumentString(`
    mutation eire_updateNonClassContactHours($input: [UpdateNonClassContactHoursInput]) {
  eire_updateNonClassContactHours(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Eire_UpdateNonClassContactHoursMutation, Eire_UpdateNonClassContactHoursMutationVariables>;
export const Core_UpdateStaffDocument = new TypedDocumentString(`
    mutation core_updateStaff($input: [UpdateStaffInput!]!) {
  core_updateStaff(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_UpdateStaffMutation, Core_UpdateStaffMutationVariables>;
export const Eire_UpsertNonClassContactHoursDocument = new TypedDocumentString(`
    mutation eire_upsertNonClassContactHours($input: [SaveNonClassContactHoursInput]) {
  eire_upsertNonClassContactHours(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Eire_UpsertNonClassContactHoursMutation, Eire_UpsertNonClassContactHoursMutationVariables>;
export const Core_UpsertStaffDocument = new TypedDocumentString(`
    mutation core_upsertStaff($input: [UpsertStaffInput]) {
  core_upsertStaff(input: $input) {
    partyId
  }
}
    `) as unknown as TypedDocumentString<Core_UpsertStaffMutation, Core_UpsertStaffMutationVariables>;
export const Core_StudentsWithEmailForSelectDocument = new TypedDocumentString(`
    query core_studentsWithEmailForSelect($filter: StudentFilter) {
  core_students(filter: $filter) {
    person {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    classGroup {
      name
    }
    yearGroups {
      name
    }
    personalInformation {
      primaryEmail {
        email
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Core_StudentsWithEmailForSelectQuery, Core_StudentsWithEmailForSelectQueryVariables>;
export const Wellbeing_DeleteStudentAenDocument = new TypedDocumentString(`
    mutation wellbeing_deleteStudentAen($input: Wellbeing_DeleteStudentAenInput!) {
  wellbeing_deleteStudentAen(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Wellbeing_DeleteStudentAenMutation, Wellbeing_DeleteStudentAenMutationVariables>;
export const Wellbeing_StudentAenDocument = new TypedDocumentString(`
    query wellbeing_studentAen($filter: StudentAenFilter!) {
  wellbeing_studentAen(filter: $filter) {
    studentPartyId
    entries {
      id
      studentPartyId
      startDate
      endDate
      type
      typeNote
      contact
      snaSupport
      provision
      note
      supportType
    }
  }
}
    `) as unknown as TypedDocumentString<Wellbeing_StudentAenQuery, Wellbeing_StudentAenQueryVariables>;
export const Wellbeing_UpsertStudentAenDocument = new TypedDocumentString(`
    mutation wellbeing_upsertStudentAen($input: Wellbeing_UpsertStudentAenInput!) {
  wellbeing_upsertStudentAen(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Wellbeing_UpsertStudentAenMutation, Wellbeing_UpsertStudentAenMutationVariables>;
export const Enrollment_Ire_ChangeProgrammeStageDocument = new TypedDocumentString(`
    mutation enrollment_ire_changeProgrammeStage($input: EnrollmentIre_ChangeProgrammeStages!) {
  enrollment_ire_changeProgrammeStage(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Enrollment_Ire_ChangeProgrammeStageMutation, Enrollment_Ire_ChangeProgrammeStageMutationVariables>;
export const Enrollment_Ire_CreateStudentDocument = new TypedDocumentString(`
    mutation enrollment_ire_createStudent($input: EnrollmentIre_CreateStudent!) {
  enrollment_ire_createStudent(input: $input) {
    partyId
  }
}
    `) as unknown as TypedDocumentString<Enrollment_Ire_CreateStudentMutation, Enrollment_Ire_CreateStudentMutationVariables>;
export const CustomStudentExtensionPointDocument = new TypedDocumentString(`
    query customStudentExtensionPoint($filter: StudentFilter!, $custExtFilter: Dtab_CustomExtensionPointLinkFilter) {
  core_students(filter: $filter) {
    partyId
    extensions {
      customExtensionPoint {
        result(custExtFilter: $custExtFilter) {
          area
          table {
            id {
              id
              provider
            }
            name
            columns {
              id {
                formId
                fieldId
              }
              sortOrder
              label
              type
              selectInfo {
                options {
                  id
                  value
                }
              }
              defaultValue
              required
            }
          }
          data {
            rowId {
              rowId
            }
            cells {
              columnId
              value
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CustomStudentExtensionPointQuery, CustomStudentExtensionPointQueryVariables>;
export const UpsertCustomExtensionPointDocument = new TypedDocumentString(`
    mutation upsertCustomExtensionPoint($input: Forms_SubmitFormFieldInputs!) {
  forms_upsertRows(input: $input) {
    success
    rowDetails {
      success
      topLevelErrors
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertCustomExtensionPointMutation, UpsertCustomExtensionPointMutationVariables>;
export const Composite_DeleteStudentsDocument = new TypedDocumentString(`
    mutation composite_deleteStudents($input: DeleteStudentsInput!) {
  composite_deleteStudents(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Composite_DeleteStudentsMutation, Composite_DeleteStudentsMutationVariables>;
export const Wellbeing_DeleteStudentMedicalConditionDocument = new TypedDocumentString(`
    mutation wellbeing_deleteStudentMedicalCondition($input: DeleteStudentMedicalConditionInput!) {
  wellbeing_deleteStudentMedicalCondition(input: $input) {
    studentPartyId
    conditions {
      id
      name
      description
    }
  }
}
    `) as unknown as TypedDocumentString<Wellbeing_DeleteStudentMedicalConditionMutation, Wellbeing_DeleteStudentMedicalConditionMutationVariables>;
export const Wellbeing_DeleteStudentMedicalContactDocument = new TypedDocumentString(`
    mutation wellbeing_deleteStudentMedicalContact($input: DeleteStudentMedicalContactInput!) {
  wellbeing_deleteStudentMedicalContact(input: $input) {
    studentPartyId
    medicalContacts {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<Wellbeing_DeleteStudentMedicalContactMutation, Wellbeing_DeleteStudentMedicalContactMutationVariables>;
export const Wellbeing_StudentMedicalConditionLookupDocument = new TypedDocumentString(`
    query wellbeing_studentMedicalConditionLookup {
  wellbeing_studentMedicalConditionLookup {
    values
  }
}
    `) as unknown as TypedDocumentString<Wellbeing_StudentMedicalConditionLookupQuery, Wellbeing_StudentMedicalConditionLookupQueryVariables>;
export const Wellbeing_StudentMedicalDocument = new TypedDocumentString(`
    query wellbeing_studentMedical($filter: StudentMedicalFilter) {
  wellbeing_studentMedical(filter: $filter) {
    studentPartyId
    student {
      contacts {
        partyId
        person {
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
        personalInformation {
          preferredFirstName
          preferredLastName
          primaryPhoneNumber {
            number
          }
        }
        relationships {
          relationshipType
        }
      }
      siblings {
        enrolledSiblings {
          partyId
          person {
            title {
              id
              nameTextId
              name
            }
            firstName
            lastName
            avatarUrl
            type
          }
          classGroup {
            name
          }
        }
        nonEnrolledSiblings {
          partyId
          firstName
          lastName
        }
      }
    }
    conditions {
      id
      name
      description
      equipment {
        id
        name
        expiryDate
        location
        notes
      }
      emergencyPlan
    }
    medicalContacts {
      id
      personalTitle
      firstName
      lastName
      occupation
      addressLine1
      addressLine2
      addressLine3
      county
      postcode
      primaryPhone
      email
    }
  }
}
    `) as unknown as TypedDocumentString<Wellbeing_StudentMedicalQuery, Wellbeing_StudentMedicalQueryVariables>;
export const Wellbeing_StudentMedicalConditionsDocument = new TypedDocumentString(`
    query wellbeing_studentMedicalConditions($filter: StudentMedicalFilter) {
  wellbeing_studentMedical(filter: $filter) {
    conditions {
      id
      name
      description
      equipment {
        id
        name
        expiryDate
        location
        notes
      }
      emergencyPlan
    }
  }
}
    `) as unknown as TypedDocumentString<Wellbeing_StudentMedicalConditionsQuery, Wellbeing_StudentMedicalConditionsQueryVariables>;
export const Wellbeing_UpsertStudentMedicalConditionDocument = new TypedDocumentString(`
    mutation wellbeing_upsertStudentMedicalCondition($input: UpsertStudentMedicalConditionInput!) {
  wellbeing_upsertStudentMedicalCondition(input: $input) {
    studentPartyId
    conditions {
      id
      name
      description
      equipment {
        id
        name
        location
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Wellbeing_UpsertStudentMedicalConditionMutation, Wellbeing_UpsertStudentMedicalConditionMutationVariables>;
export const Wellbeing_UpsertStudentMedicalContactDocument = new TypedDocumentString(`
    mutation wellbeing_upsertStudentMedicalContact($input: UpsertStudentMedicalContactInput!) {
  wellbeing_upsertStudentMedicalContact(input: $input) {
    studentPartyId
    medicalContacts {
      id
      personalTitleId
      firstName
      lastName
      addressLine1
      addressLine2
      addressLine3
      county
      postcode
      primaryPhone
      email
      occupation
    }
  }
}
    `) as unknown as TypedDocumentString<Wellbeing_UpsertStudentMedicalContactMutation, Wellbeing_UpsertStudentMedicalContactMutationVariables>;
export const Core_Student_ContactsDocument = new TypedDocumentString(`
    query core_student_contacts($filter: StudentFilter!) {
  core_students(filter: $filter) {
    partyId
    contacts {
      partyId
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      personalInformation {
        gender
        nationality
        primaryAddress {
          line1
          line2
          line3
          city
          country
          postCode
        }
        primaryPhoneNumber {
          number
          areaCode
          countryCode
        }
        primaryEmail {
          email
        }
      }
      relationships {
        relationshipType
        priority
        allowedToContact
        includeInSms
        includeInTmail
        pickupRights
        legalGuardian
        allowAccessToStudentData
        includeInTemplating
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Core_Student_ContactsQuery, Core_Student_ContactsQueryVariables>;
export const Core_SubjectGroupStudentsDocument = new TypedDocumentString(`
    query core_subjectGroupStudents($filter: SubjectGroupStudentFilter!) {
  core_subjectGroupStudents(filter: $filter) {
    students {
      examinable
      studyLevel
      extensions {
        targets {
          partyId
          subjectId
          targetResult
          targetGradeSetGradeId
        }
      }
      student {
        partyId
        classGroup {
          name
        }
        person {
          partyId
          firstName
          lastName
          avatarUrl
          type
          title {
            id
            name
            nameTextId
          }
        }
        programmeStages {
          programme {
            shortName
          }
        }
        extensions {
          priority
          aen
          medical
        }
      }
    }
    subjectGroup {
      partyId
      name
      avatarUrl
      subjects {
        id
        name
        colour
        icon
      }
      staff {
        firstName
        lastName
        avatarUrl
      }
      studentMembershipType {
        type
        classGroupId
        blockId
        classGroupName
      }
      irePP {
        level
        examinable
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Core_SubjectGroupStudentsQuery, Core_SubjectGroupStudentsQueryVariables>;
export const Core_Student_PersonalDocument = new TypedDocumentString(`
    query core_student_personal($filter: StudentFilter!) {
  core_students(filter: $filter) {
    partyId
    externalSystemId
    startDate
    leftEarly
    endDate
    guardianshipNote
    exemptions {
      id
      exemption
      exemptionTypeCode
      grantor
      startDate
      endDate
    }
    person {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
      customFields {
        id
        name
        value
        customFieldId
        partyId
        source
        type
      }
    }
    personalInformation {
      firstName
      lastName
      preferredFirstName
      preferredLastName
      middleName
      gender
      dateOfBirth
      birthCertFirstName
      birthCertLastName
      ire {
        ppsNumber
        religion
        countryOfBirth
      }
      nationality
      mothersMaidenName
      primaryAddress {
        line1
        line2
        line3
        line4
        line5
        city
        country
        postCode
      }
      addresses {
        line1
        line2
        line3
        line4
        line5
        city
        country
        postCode
        primaryAddress
      }
      primaryPhoneNumber {
        number
        areaCode
        countryCode
      }
      primaryEmail {
        email
      }
    }
    studentIrePP {
      medicalCard
      travellerHeritage
      languageSupportApplicant
      borderIndicator
      examNumber
      lockerNumber
      previousSchoolRollNumber
      dpin
      examEntrant
      repeatYear
      boardingDays
      shortTermPupil
      shortTermPupilNumWeeks
      reasonForLeaving
      destinationRollNo
      previousSchoolName
      previousSchoolType
    }
    classGroup {
      name
    }
    tutors {
      partyId
      firstName
      lastName
      avatarUrl
    }
    yearGroupLeads {
      partyId
      firstName
      lastName
      avatarUrl
    }
    yearGroups {
      name
    }
    programmeStages {
      name
      programme {
        name
      }
    }
    siblings {
      enrolledSiblings {
        partyId
        person {
          partyId
          type
          title {
            id
            nameTextId
            name
          }
          firstName
          lastName
          avatarUrl
        }
        classGroup {
          name
        }
      }
      nonEnrolledSiblings {
        partyId
        firstName
        lastName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Core_Student_PersonalQuery, Core_Student_PersonalQueryVariables>;
export const Core_ReinstateStudentDocument = new TypedDocumentString(`
    mutation core_reinstateStudent($input: Core_ReinstateMemberInput!) {
  core_reinstateStudent(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_ReinstateStudentMutation, Core_ReinstateStudentMutationVariables>;
export const StudentsForSiblingSearchDocument = new TypedDocumentString(`
    query studentsForSiblingSearch {
  core_students {
    partyId
    person {
      partyId
      title {
        id
        nameTextId
        name
      }
      firstName
      lastName
      avatarUrl
      type
    }
    classGroup {
      name
    }
    contacts {
      partyId
      person {
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      relationships {
        relationshipType
        studentPartyId
        contactPartyId
        priority
        allowedToContact
        includeInSms
        includeInTmail
        pickupRights
        legalGuardian
        allowAccessToStudentData
        includeInTemplating
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StudentsForSiblingSearchQuery, StudentsForSiblingSearchQueryVariables>;
export const Core_StudentsDocument = new TypedDocumentString(`
    query core_students {
  core_students {
    partyId
    externalSystemId
    person {
      partyId
      avatarUrl
      firstName
      lastName
      type
      title {
        id
        name
        nameTextId
      }
    }
    classGroup {
      name
      staff {
        firstName
        lastName
      }
    }
    personalInformation {
      gender
      preferredFirstName
      dateOfBirth
      primaryPhoneNumber {
        number
        areaCode
        countryCode
      }
      primaryEmail {
        email
      }
    }
    studentIrePP {
      examNumber
      previousSchoolName
      dpin
      lockerNumber
    }
    tutors {
      partyId
      firstName
      lastName
      avatarUrl
    }
    yearGroupLeads {
      partyId
      firstName
      lastName
      avatarUrl
    }
    yearGroups {
      name
    }
    programmeStages {
      id
      name
      programme {
        name
      }
    }
    extensions {
      priority
      aen
      medical
    }
  }
}
    `) as unknown as TypedDocumentString<Core_StudentsQuery, Core_StudentsQueryVariables>;
export const Core_StudentDocument = new TypedDocumentString(`
    query core_student($filter: StudentFilter!) {
  core_students(filter: $filter) {
    partyId
    externalSystemId
    person {
      partyId
      avatarUrl
      firstName
      lastName
      type
      title {
        id
        name
        nameTextId
      }
    }
    studentIrePP {
      dpin
    }
    classGroup {
      name
      staff {
        firstName
        lastName
      }
    }
    yearGroupLeads {
      firstName
      lastName
      avatarUrl
    }
    yearGroups {
      shortName
      yearGroupId
    }
    tutors {
      partyId
      firstName
      lastName
      avatarUrl
      type
    }
    extensions {
      priority
      aen
      medical
    }
  }
}
    `) as unknown as TypedDocumentString<Core_StudentQuery, Core_StudentQueryVariables>;
export const Core_StudentsInfoForSelectDocument = new TypedDocumentString(`
    query core_studentsInfoForSelect($filter: StudentFilter) {
  core_students(filter: $filter) {
    person {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    externalSystemId
    classGroup {
      name
    }
    yearGroups {
      name
    }
    personalInformation {
      ire {
        ppsNumber
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Core_StudentsInfoForSelectQuery, Core_StudentsInfoForSelectQueryVariables>;
export const StudentDetailsForNtkDocument = new TypedDocumentString(`
    query studentDetailsForNTK($filter: StudentFilter!) {
  core_students(filter: $filter) {
    partyId
    person {
      partyId
      avatarUrl
      firstName
      lastName
      type
      title {
        id
        name
        nameTextId
      }
    }
    classGroup {
      name
      staff {
        firstName
        lastName
      }
    }
    yearGroupLeads {
      firstName
      lastName
      avatarUrl
    }
    yearGroups {
      shortName
    }
    tutors {
      partyId
      firstName
      lastName
      avatarUrl
      type
    }
    personalInformation {
      primaryAddress {
        line1
        line2
        line3
        city
        country
        postCode
      }
    }
    contacts {
      partyId
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      personalInformation {
        primaryPhoneNumber {
          number
          areaCode
          countryCode
        }
      }
      relationships {
        studentPartyId
        relationshipType
        priority
        allowedToContact
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StudentDetailsForNtkQuery, StudentDetailsForNtkQueryVariables>;
export const Core_StudentsEnrolmentHistoryDocument = new TypedDocumentString(`
    query core_studentsEnrolmentHistory($filter: StudentFilter) {
  core_students(filter: $filter) {
    enrolmentHistory {
      studentPartyId
      academicNamespaceId
      academicNamespace
      classGroupId
      classGroupName
    }
  }
}
    `) as unknown as TypedDocumentString<Core_StudentsEnrolmentHistoryQuery, Core_StudentsEnrolmentHistoryQueryVariables>;
export const UpdateCoreStudentsDocument = new TypedDocumentString(`
    mutation updateCoreStudents($input: [UpdateStudentInput]!) {
  core_updateStudents(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpdateCoreStudentsMutation, UpdateCoreStudentsMutationVariables>;
export const Timeline_StudentTimelineDocument = new TypedDocumentString(`
    query timeline_studentTimeline($filter: Timeline_TimelineFilter!) {
  timeline_studentTimeline(filter: $filter) {
    events {
      timelineId {
        entityType
        entityId
        studentPartyId
      }
      startDatetime
      endDatetime
      startDate
      endDate
      headline
      details
      meta {
        __typename
        type
        ... on Timeline_EventMeta_Absent {
          note
          time
        }
        ... on Timeline_EventMeta_Behaviour {
          behaviourType
          tag
          colour
        }
        ... on Timeline_EventMeta_Late {
          note
          time
        }
        ... on Timeline_EventMeta_Late {
          note
          time
        }
        ... on Timeline_EventMeta_Note {
          tag
          colour
        }
        ... on Timeline_EventMeta_StudentDocs {
          link
        }
      }
      studentId
      createdBy {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Timeline_StudentTimelineQuery, Timeline_StudentTimelineQueryVariables>;
export const Timeline_StudentHighlightsDocument = new TypedDocumentString(`
    query timeline_studentHighlights($filter: Timeline_HighlightFilter!) {
  timeline_studentHighlights(filter: $filter) {
    id
    studentPartyId
    title
    highlight
    status
    createdOn
    createdBy {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    assignedToParties {
      partyId
      ... on Staff {
        person {
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
    }
    comments {
      commentId
      comment
      commenter {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      createdOn
      likedByParties {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    events {
      timelineId {
        entityType
        entityId
        studentPartyId
      }
      startDatetime
      endDatetime
      startDate
      endDate
      headline
      details
      meta {
        __typename
        type
        ... on Timeline_EventMeta_Absent {
          note
          time
        }
        ... on Timeline_EventMeta_Behaviour {
          behaviourType
          tag
          colour
        }
        ... on Timeline_EventMeta_Late {
          note
          time
        }
        ... on Timeline_EventMeta_Note {
          tag
          colour
        }
        ... on Timeline_EventMeta_SignInOut {
          note
          time
        }
        ... on Timeline_EventMeta_StudentDocs {
          link
        }
      }
      studentId
      student {
        person {
          partyId
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Timeline_StudentHighlightsQuery, Timeline_StudentHighlightsQueryVariables>;
export const Timeline_SaveHighlightDocument = new TypedDocumentString(`
    mutation timeline_saveHighlight($input: Timeline_SaveHighlight!) {
  timeline_saveHighlight(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Timeline_SaveHighlightMutation, Timeline_SaveHighlightMutationVariables>;
export const Timeline_SaveHighlightCommentDocument = new TypedDocumentString(`
    mutation timeline_saveHighlightComment($input: Timeline_SaveHighlightComment!) {
  timeline_saveHighlightComment(input: $input) {
    commentId
  }
}
    `) as unknown as TypedDocumentString<Timeline_SaveHighlightCommentMutation, Timeline_SaveHighlightCommentMutationVariables>;
export const Timeline_DeleteHighlightDocument = new TypedDocumentString(`
    mutation timeline_deleteHighlight($input: Timeline_RemoveHighlight!) {
  timeline_deleteHighlight(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Timeline_DeleteHighlightMutation, Timeline_DeleteHighlightMutationVariables>;
export const Core_LinkSiblingsAndContactsDocument = new TypedDocumentString(`
    mutation core_linkSiblingsAndContacts($input: Core_LinkSiblingsAndContacts!) {
  core_linkSiblingsAndContacts(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_LinkSiblingsAndContactsMutation, Core_LinkSiblingsAndContactsMutationVariables>;
export const Core_UpdateStudentContactRelationshipsDocument = new TypedDocumentString(`
    mutation core_updateStudentContactRelationships($input: [Core_UpdateStudentContactRelationshipInput]) {
  core_updateStudentContactRelationships(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_UpdateStudentContactRelationshipsMutation, Core_UpdateStudentContactRelationshipsMutationVariables>;
export const Assessment_UpdateStudentSubjectGroupDocument = new TypedDocumentString(`
    mutation assessment_updateStudentSubjectGroup($input: [UpsertStudentSubjectGroup!]!) {
  assessment_updateStudentSubjectGroup(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Assessment_UpdateStudentSubjectGroupMutation, Assessment_UpdateStudentSubjectGroupMutationVariables>;
export const UpdateStudentDocument = new TypedDocumentString(`
    mutation updateStudent($input: [UpdateStudentInput]!) {
  core_updateStudents(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpdateStudentMutation, UpdateStudentMutationVariables>;
export const Templating_ResolveLabelTemplateDocument = new TypedDocumentString(`
    query templating_resolveLabelTemplate($filter: Templating_ResolveLabelTemplateInput!) {
  templating_resolveLabelTemplate(filter: $filter) {
    temporaryUrl
    html
  }
}
    `) as unknown as TypedDocumentString<Templating_ResolveLabelTemplateQuery, Templating_ResolveLabelTemplateQueryVariables>;
export const Templating_ResolveDataTemplateDocument = new TypedDocumentString(`
    query templating_resolveDataTemplate($filter: Templating_ResolveDataTemplateInput!) {
  templating_resolveDataTemplate(filter: $filter) {
    temporaryUrl
    html
  }
}
    `) as unknown as TypedDocumentString<Templating_ResolveDataTemplateQuery, Templating_ResolveDataTemplateQueryVariables>;
export const Templating_GetLabelTemplatesDocument = new TypedDocumentString(`
    query templating_getLabelTemplates($filter: Templating_LabelTemplateFilter!) {
  templating_getLabelTemplates(filter: $filter) {
    id
    name
    paddingTop
    paddingBottom
    paddingLeft
    paddingRight
    paddingColumn
    paddingRow
    fontSize
    labelType
  }
}
    `) as unknown as TypedDocumentString<Templating_GetLabelTemplatesQuery, Templating_GetLabelTemplatesQueryVariables>;
export const Templating_GetDemoLabelTemplateDocument = new TypedDocumentString(`
    query templating_getDemoLabelTemplate($filter: Templating_DemoLabelTemplateInput!) {
  templating_getDemoLabelTemplate(filter: $filter) {
    html
  }
}
    `) as unknown as TypedDocumentString<Templating_GetDemoLabelTemplateQuery, Templating_GetDemoLabelTemplateQueryVariables>;
export const Templating_UpsertLabelTemplateDocument = new TypedDocumentString(`
    mutation templating_upsertLabelTemplate($input: Templating_UpsertLabelTemplateInput!) {
  templating_upsertLabelTemplate(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Templating_UpsertLabelTemplateMutation, Templating_UpsertLabelTemplateMutationVariables>;
export const Templating_DeleteLabelTemplatesDocument = new TypedDocumentString(`
    mutation templating_deleteLabelTemplates($input: Templating_DeleteLabelTemplateInput!) {
  templating_deleteLabelTemplates(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Templating_DeleteLabelTemplatesMutation, Templating_DeleteLabelTemplatesMutationVariables>;
export const Templating_GetSavedVariableTemplatesDocument = new TypedDocumentString(`
    query templating_getSavedVariableTemplates($filter: Templating_SavedVariableTemplateFilter!) {
  templating_getSavedVariableTemplates(filter: $filter) {
    id
    name
    templateType
    labelTemplate {
      id
      fontSize
    }
    variables {
      id
      name
      value
      context
    }
  }
}
    `) as unknown as TypedDocumentString<Templating_GetSavedVariableTemplatesQuery, Templating_GetSavedVariableTemplatesQueryVariables>;
export const Templating_UpsertSavedVariableTemplateDocument = new TypedDocumentString(`
    mutation templating_upsertSavedVariableTemplate($input: Templating_UpsertSavedVariableTemplateInput!) {
  templating_upsertSavedVariableTemplate(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Templating_UpsertSavedVariableTemplateMutation, Templating_UpsertSavedVariableTemplateMutationVariables>;
export const Templating_DeleteSavedVariableTemplatesDocument = new TypedDocumentString(`
    mutation templating_deleteSavedVariableTemplates($input: Templating_DeleteSavedVariableTemplateInput!) {
  templating_deleteSavedVariableTemplates(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Templating_DeleteSavedVariableTemplatesMutation, Templating_DeleteSavedVariableTemplatesMutationVariables>;
export const PrintAssessmentDocument = new TypedDocumentString(`
    query printAssessment($filter: Print_AssessmentOptions!) {
  print_assessment(filter: $filter) {
    url
    html
  }
}
    `) as unknown as TypedDocumentString<PrintAssessmentQuery, PrintAssessmentQueryVariables>;
export const PrintAssessmentTemplateDocument = new TypedDocumentString(`
    query printAssessmentTemplate($filter: Templating_ResolveTemplateInput!) {
  print_assessmentTemplate(filter: $filter) {
    executionId
    hasValidationErrors
    validationFailures {
      code
      severity
      message
      affectedEntities {
        entityType
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PrintAssessmentTemplateQuery, PrintAssessmentTemplateQueryVariables>;
export const Print_FireDrillDocument = new TypedDocumentString(`
    query print_fireDrill {
  print_fireDrill {
    url
    html
  }
}
    `) as unknown as TypedDocumentString<Print_FireDrillQuery, Print_FireDrillQueryVariables>;
export const PrintLetterTemplateDocument = new TypedDocumentString(`
    query printLetterTemplate($filter: Templating_ResolveTemplateInput!) {
  print_letterTemplate(filter: $filter) {
    executionId
    hasValidationErrors
  }
}
    `) as unknown as TypedDocumentString<PrintLetterTemplateQuery, PrintLetterTemplateQueryVariables>;
export const Print_SubjectOptionsDocument = new TypedDocumentString(`
    query print_subjectOptions($filter: Print_SubjectOptions!) {
  print_subjectOptions(filter: $filter) {
    url
    html
  }
}
    `) as unknown as TypedDocumentString<Print_SubjectOptionsQuery, Print_SubjectOptionsQueryVariables>;
export const PrintTimetableDocument = new TypedDocumentString(`
    query printTimetable($filter: Print_TimetableOptions!) {
  print_printTimetable(filter: $filter) {
    url
    html
  }
}
    `) as unknown as TypedDocumentString<PrintTimetableQuery, PrintTimetableQueryVariables>;
export const Reporting_AnalyseReportDocument = new TypedDocumentString(`
    query reporting_analyseReport($input: Reporting_AnalyseInput!) {
  reporting_analyseReport(input: $input) {
    debug {
      sql
    }
    chart {
      type
      validTypes
      metadata {
        xAxisLabel
        yAxisLabel
        stacked
        unit
        currency
        dateFormat
      }
      series {
        key
        label
        color
        data {
          x
          y
          z
          label
          meta
        }
      }
    }
    rows
    reportMeta {
      metrics {
        id
        label
        description
        defaultChartType
      }
      groupableFields {
        fieldId
        label
        isDateField
        availableBuckets
      }
      aggregatableFields {
        fieldId
        label
        supportedAggregations
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Reporting_AnalyseReportQuery, Reporting_AnalyseReportQueryVariables>;
export const Reporting_ExportReportDocument = new TypedDocumentString(`
    mutation reporting_exportReport($filter: Reporting_ExportReportInput!) {
  reporting_exportReport(filter: $filter) {
    executionId
  }
}
    `) as unknown as TypedDocumentString<Reporting_ExportReportMutation, Reporting_ExportReportMutationVariables>;
export const Reporting_ReportsDocument = new TypedDocumentString(`
    query reporting_reports {
  reporting_reports {
    info {
      id
      name
    }
    reports {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<Reporting_ReportsQuery, Reporting_ReportsQueryVariables>;
export const Reporting_RunReportExpandDocument = new TypedDocumentString(`
    query reporting_runReportExpand($filter: Reporting_ReportFilterExpand) {
  reporting_runReportExpand(filter: $filter) {
    id
    fields {
      id
      label
      visibleByDefault
    }
    data
  }
}
    `) as unknown as TypedDocumentString<Reporting_RunReportExpandQuery, Reporting_RunReportExpandQueryVariables>;
export const Reporting_RunReportMetaDocument = new TypedDocumentString(`
    query reporting_runReportMeta($filter: Reporting_ReportFilter) {
  reporting_runReport(filter: $filter) {
    id
    info {
      name
      supportsExpandRow
      isInteractive
      isServerSide
      analyticsEnabled
      defaultMetricId
    }
    innerReports {
      id
      name
    }
    filters {
      id
      inputType
      label
      defaultValue
      required
      values {
        id
        value
      }
      minValue
      maxValue
    }
    fields {
      id
      label
      visibleByDefault
      checkExpandedRows
      hideMenu
      sortable
      searchable
      maxWidth
      minWidth
      pinned
      rowGroup
      cellType
      type
      meta {
        chipSize
        chipVariant
        currency
        dateFormat
        showAvatar
        avatarSize
        enableLink
        numberFormat {
          style
          maximumFractionDigits
        }
      }
    }
    metrics {
      defaultValue
      values {
        id
        name
      }
    }
    timeGroupBy {
      defaultValue
      values {
        id
        name
        description
      }
    }
    groupBy {
      defaultValue
      values {
        id
        name
        description
      }
    }
    actions {
      id
      reportId
      actions
      tenant
      mappings {
        fieldId
        field
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Reporting_RunReportMetaQuery, Reporting_RunReportMetaQueryVariables>;
export const Reporting_RunReportPaginatedDocument = new TypedDocumentString(`
    query reporting_runReportPaginated($filter: Reporting_PaginatedReportFilter) {
  reporting_runReportPaginated(filter: $filter) {
    data
    debug {
      sql
    }
  }
}
    `) as unknown as TypedDocumentString<Reporting_RunReportPaginatedQuery, Reporting_RunReportPaginatedQueryVariables>;
export const Reporting_RunReportDocument = new TypedDocumentString(`
    query reporting_runReport($filter: Reporting_ReportFilter) {
  reporting_runReport(filter: $filter) {
    id
    debug {
      sql
    }
    fields {
      id
      label
      visibleByDefault
      checkExpandedRows
      hideMenu
      sortable
      maxWidth
      minWidth
      pinned
      rowGroup
      cellType
      type
      meta {
        chipSize
        chipVariant
        currency
        dateFormat
        showAvatar
        avatarSize
        enableLink
        numberFormat {
          style
          maximumFractionDigits
        }
      }
    }
    data
    tableDisplayOptions {
      gridOptions
      tableContainerSx
    }
    statusPanels {
      statusPanel
      statusPanelParams {
        columns {
          id
          aggregationTypes
          onSelectOnly
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Reporting_RunReportQuery, Reporting_RunReportQueryVariables>;
export const Reporting_RunChartQueryDocument = new TypedDocumentString(`
    query reporting_runChartQuery($filter: Reporting_ReportFilter) {
  reporting_runQuery(filter: $filter) {
    charts {
      type
      series {
        id
        name
        series
        colour
        sortOrder
      }
      debug {
        sql
      }
      categories
      colours
    }
  }
}
    `) as unknown as TypedDocumentString<Reporting_RunChartQueryQuery, Reporting_RunChartQueryQueryVariables>;
export const Reporting_DashboardFilterSchemaDocument = new TypedDocumentString(`
    query reporting_dashboardFilterSchema($filter: Reporting_ReportFilter) {
  reporting_runReport(filter: $filter) {
    id
    filters {
      id
      inputType
      label
      defaultValue
      required
      values {
        id
        value
      }
      minValue
      maxValue
    }
  }
}
    `) as unknown as TypedDocumentString<Reporting_DashboardFilterSchemaQuery, Reporting_DashboardFilterSchemaQueryVariables>;
export const Rules_ActionTypesMetadataDocument = new TypedDocumentString(`
    query rules_actionTypesMetadata {
  rules_actionTypesMetadata {
    actionType
    name
    description
    inputObject
    canRevert
  }
}
    `) as unknown as TypedDocumentString<Rules_ActionTypesMetadataQuery, Rules_ActionTypesMetadataQueryVariables>;
export const Rules_DeleteTriggeredLogDocument = new TypedDocumentString(`
    mutation rules_deleteTriggeredLog($input: Rules_DeleteTriggeredLog!) {
  rules_deleteTriggeredLog(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Rules_DeleteTriggeredLogMutation, Rules_DeleteTriggeredLogMutationVariables>;
export const Rules_RevertTriggeredActionsDocument = new TypedDocumentString(`
    mutation rules_revertTriggeredActions($input: Rules_RevertTriggeredActions!) {
  rules_revertTriggeredActions(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Rules_RevertTriggeredActionsMutation, Rules_RevertTriggeredActionsMutationVariables>;
export const Rules_RuleTypesMetadataDocument = new TypedDocumentString(`
    query rules_ruleTypesMetadata {
  rules_ruleTypesMetadata {
    criteriaType
    ruleType
    name
    description
    about
    ... on Rules_RuleMetaData_AggregateMatch {
      filterFields {
        name
        label
        valueEditorType
        operators {
          name
          label
          allowsMultiple
        }
        selectOptions {
          label
          value
        }
        defaultValue
      }
      aggregateFields {
        aggType
        possibleFields {
          label
          value
        }
      }
      allowedTimeFrames
      name
      description
    }
  }
}
    `) as unknown as TypedDocumentString<Rules_RuleTypesMetadataQuery, Rules_RuleTypesMetadataQueryVariables>;
export const Rules_RulesDocument = new TypedDocumentString(`
    query rules_rules($filter: Rules_RulesViewFilter!) {
  rules_rules(filter: $filter) {
    ruleId
    name
    description
    ruleTriggeredCount
    actionTakenCount
    createdOn
    updatedOn
    lastRanAt
    lastRunSuccess
    disabled
  }
}
    `) as unknown as TypedDocumentString<Rules_RulesQuery, Rules_RulesQueryVariables>;
export const Rule_DetailsDocument = new TypedDocumentString(`
    query rule_details($filter: Rules_RulesViewFilter!) {
  rules_rules(filter: $filter) {
    ruleId
    name
    ruleType
    description
    partyIds
    maxTriggersAllowed
    schedule {
      type
      __typename
      ... on Rules_ScheduleTypeDaily {
        time
      }
      ... on Rules_ScheduleWeekly {
        time
        isoDayOfWeek
      }
    }
    parties {
      ... on Student {
        __typename
        person {
          partyId
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
      }
      ... on Staff {
        __typename
        person {
          partyId
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
      }
      ... on StudentContact {
        __typename
        person {
          partyId
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
      }
      ... on SubjectGroup {
        __typename
        partyId
        name
        avatarUrl
      }
      ... on GeneralGroup {
        __typename
        partyId
        name
      }
      ... on YearGroupEnrollment {
        __typename
        partyId
        name
      }
      ... on ProgrammeStageEnrollment {
        __typename
        partyId
        name
      }
    }
    excludeParties {
      ... on Student {
        __typename
        person {
          partyId
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
      }
      ... on Staff {
        __typename
        person {
          partyId
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
      }
      ... on StudentContact {
        __typename
        person {
          partyId
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
      }
      ... on SubjectGroup {
        __typename
        partyId
        name
        avatarUrl
      }
      ... on GeneralGroup {
        __typename
        partyId
        name
      }
      ... on YearGroupEnrollment {
        __typename
        partyId
        name
      }
      ... on ProgrammeStageEnrollment {
        __typename
        partyId
        name
      }
    }
    criteria {
      ruleType
      ... on Rules_Criteria_AggregateMatch2 {
        criteriaType
        filterCondition
        timeframe {
          __typename
          type
          ... on Rules_TimeFrame_Rolling {
            weeks
          }
          ... on Rules_TimeFrame_PreviousOrSameDay {
            isoDayOfWeek
          }
          ... on Rules_TimeFrame_FromDate {
            from
          }
          ... on Rules_TimeFrame_BetweenDates {
            from
            to
          }
        }
      }
    }
    triggers {
      triggerIdx
      maxAllowed
      trigger {
        triggerType
        ... on Rules_Criteria_AggregateMatch2_Trigger {
          type
          field
          operator
          value
        }
      }
    }
    actions {
      ruleActionId
      triggerIdx
      type
      hasError
      errorRawData
      action {
        type
        __typename
        ... on Rules_ActionSms {
          message
          assignees {
            toContacts
            toStaffRoles
            parties {
              ... on Student {
                __typename
                person {
                  partyId
                  avatarUrl
                  firstName
                  lastName
                  type
                  title {
                    id
                    name
                    nameTextId
                  }
                }
              }
              ... on Staff {
                __typename
                person {
                  partyId
                  avatarUrl
                  firstName
                  lastName
                  type
                  title {
                    id
                    name
                    nameTextId
                  }
                }
              }
              ... on StudentContact {
                __typename
                person {
                  partyId
                  avatarUrl
                  firstName
                  lastName
                  type
                  title {
                    id
                    name
                    nameTextId
                  }
                }
              }
              ... on SubjectGroup {
                __typename
                partyId
                name
                avatarUrl
              }
              ... on GeneralGroup {
                __typename
                partyId
                name
              }
              ... on YearGroupEnrollment {
                __typename
                partyId
                name
              }
              ... on ProgrammeStageEnrollment {
                __typename
                partyId
                name
              }
            }
          }
        }
        ... on Rules_Action_CreateHighlight {
          title
          highlight
          assignees {
            toContacts
            toStaffRoles
            parties {
              ... on Student {
                __typename
                person {
                  partyId
                  avatarUrl
                  firstName
                  lastName
                  type
                  title {
                    id
                    name
                    nameTextId
                  }
                }
              }
              ... on Staff {
                __typename
                person {
                  partyId
                  avatarUrl
                  firstName
                  lastName
                  type
                  title {
                    id
                    name
                    nameTextId
                  }
                }
              }
              ... on StudentContact {
                __typename
                person {
                  partyId
                  avatarUrl
                  firstName
                  lastName
                  type
                  title {
                    id
                    name
                    nameTextId
                  }
                }
              }
              ... on SubjectGroup {
                __typename
                partyId
                name
                avatarUrl
              }
              ... on GeneralGroup {
                __typename
                partyId
                name
              }
              ... on YearGroupEnrollment {
                __typename
                partyId
                name
              }
              ... on ProgrammeStageEnrollment {
                __typename
                partyId
                name
              }
            }
          }
        }
        ... on Rules_Action_SendFormRequest {
          formDefinitionId {
            provider
            id
          }
          requestName
          formType
          teacherOfStaff {
            roles
          }
          numberDaysTillDue
        }
        ... on Rules_ActionMail {
          body
          subject
          assignees {
            toContacts
            toStaffRoles
            parties {
              ... on Student {
                __typename
                person {
                  partyId
                  avatarUrl
                  firstName
                  lastName
                  type
                  title {
                    id
                    name
                    nameTextId
                  }
                }
              }
              ... on Staff {
                __typename
                person {
                  partyId
                  avatarUrl
                  firstName
                  lastName
                  type
                  title {
                    id
                    name
                    nameTextId
                  }
                }
              }
              ... on StudentContact {
                __typename
                person {
                  partyId
                  avatarUrl
                  firstName
                  lastName
                  type
                  title {
                    id
                    name
                    nameTextId
                  }
                }
              }
              ... on SubjectGroup {
                __typename
                partyId
                name
                avatarUrl
              }
              ... on GeneralGroup {
                __typename
                partyId
                name
              }
              ... on YearGroupEnrollment {
                __typename
                partyId
                name
              }
              ... on ProgrammeStageEnrollment {
                __typename
                partyId
                name
              }
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Rule_DetailsQuery, Rule_DetailsQueryVariables>;
export const Rules_RunRuleDocument = new TypedDocumentString(`
    mutation rules_runRule($input: Rules_RunRulesNow!) {
  rules_runRule(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Rules_RunRuleMutation, Rules_RunRuleMutationVariables>;
export const TestRuleDocument = new TypedDocumentString(`
    mutation testRule($input: Rules_CustomRuleInput!) {
  rules_testRule(input: $input) {
    triggered {
      id
      ruleTriggerIdx
      ruleId
      ruleType
      entityId
      context {
        type
        ... on Rules_TriggeredContext_Student {
          contextId
          datetime
          criteriaType
          timelineType
        }
      }
      triggeredOn
      createdByUserId
      party {
        ... on Student {
          __typename
          person {
            partyId
            firstName
            lastName
            avatarUrl
          }
        }
        ... on Staff {
          __typename
          person {
            partyId
            firstName
            lastName
            avatarUrl
          }
        }
        ... on StudentContact {
          __typename
          person {
            partyId
            firstName
            lastName
            avatarUrl
          }
        }
        ... on SubjectGroup {
          __typename
          partyId
          name
          avatarUrl
        }
        ... on GeneralGroup {
          __typename
          partyId
          name
        }
        ... on YearGroupEnrollment {
          __typename
          partyId
          name
        }
        ... on ProgrammeStageEnrollment {
          __typename
          partyId
          name
        }
      }
    }
    actionsToBeRan {
      type
      count
    }
  }
}
    `) as unknown as TypedDocumentString<TestRuleMutation, TestRuleMutationVariables>;
export const UpdateRuleDocument = new TypedDocumentString(`
    mutation updateRule($input: [Rules_CustomRuleUpdateInput!]!) {
  rules_updateCustomRule(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpdateRuleMutation, UpdateRuleMutationVariables>;
export const SaveRuleDocument = new TypedDocumentString(`
    mutation saveRule($input: Rules_CustomRuleInput!) {
  rules_upsertCustomRule(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<SaveRuleMutation, SaveRuleMutationVariables>;
export const Rules_ViewTriggeredDocument = new TypedDocumentString(`
    query rules_viewTriggered($filter: Rules_TriggeredViewFilter!) {
  rules_viewTriggered(input: $filter) {
    id
    ruleTriggerIdx
    ruleId
    ruleType
    entityId
    context {
      type
      ... on Rules_TriggeredContext_Student {
        contextId
        datetime
        criteriaType
        timelineType
      }
    }
    triggeredOn
    createdByUserId
    actionsTaken {
      ruleTriggeredActionId
      status
      successId
      meta {
        canRevert
        actionType
        name
      }
    }
    party {
      ... on Student {
        __typename
        person {
          partyId
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
        extensions {
          priority
          aen
          medical
        }
      }
      ... on Staff {
        __typename
        person {
          partyId
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
      }
      ... on StudentContact {
        __typename
        person {
          partyId
          avatarUrl
          firstName
          lastName
          type
          title {
            id
            name
            nameTextId
          }
        }
      }
      ... on SubjectGroup {
        __typename
        partyId
        name
        avatarUrl
        subjects {
          colour
        }
      }
      ... on GeneralGroup {
        __typename
        partyId
        name
      }
      ... on YearGroupEnrollment {
        __typename
        partyId
        name
      }
      ... on ProgrammeStageEnrollment {
        __typename
        partyId
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Rules_ViewTriggeredQuery, Rules_ViewTriggeredQueryVariables>;
export const Sa_ClassAwayDocument = new TypedDocumentString(`
    query sa_classAway($filter: Sa_ClassAwayFilter!) {
  sa_classAway(filter: $filter) {
    freeStaffPartyIds
    cancelled
    staffAreFreed
    freeStaff {
      partyId
      title {
        id
        nameTextId
        name
      }
      firstName
      lastName
      avatarUrl
      archived
      type
    }
    studentsAttendingActivityTotal
    studentsInGroupTotal
    event {
      name
      colour
      calendarEventId {
        eventId
        date
      }
      eventId
      calendarIds
      startTime
      endTime
      type
      allDayEvent
      attendees {
        partyId
        type
        partyInfo {
          partyId
        }
      }
      lessonInfo {
        subjectGroupId
        lessonId
      }
      roomIds
      rooms {
        roomId
        name
        capacity
        description
        pools {
          id
          name
          colour
        }
        includeInTimetable
        externalSystemId
        location
        disabled
      }
    }
    affectedAttendees {
      partyId
    }
  }
}
    `) as unknown as TypedDocumentString<Sa_ClassAwayQuery, Sa_ClassAwayQueryVariables>;
export const Sa_DeleteActivityDocument = new TypedDocumentString(`
    mutation sa_deleteActivity($input: Sa_SchoolActivityDelete!) {
  sa_deleteActivity(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Sa_DeleteActivityMutation, Sa_DeleteActivityMutationVariables>;
export const ActivitiesListDocument = new TypedDocumentString(`
    query activitiesList($filter: Sa_SchoolActivityFilter!) {
  sa_activities(filter: $filter) {
    schoolActivityId
    customGroupId
    lastPublished
    name
    approval {
      status
    }
    createdOn
    createdBy {
      person {
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
    }
    dates {
      date
      startTime
      endTime
      partial
    }
    location {
      locationDetails
      inSchoolGrounds
      roomIds
      rooms {
        roomId
        name
      }
    }
    tripPurpose
    notes
    published
    customGroup {
      partyId
      name
      avatarUrl
      relatedSubjectGroups {
        partyId
        name
        subjects {
          name
        }
      }
      studentMembers {
        groupPartyId
        memberCount
        members {
          partyId
          person {
            avatarUrl
            partyId
            firstName
            lastName
            type
            title {
              id
              name
              nameTextId
            }
          }
        }
      }
      staffMembers {
        groupPartyId
        memberIds
        members {
          partyId
          person {
            avatarUrl
            partyId
            firstName
            lastName
            type
            title {
              id
              name
              nameTextId
            }
          }
        }
        memberCount
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ActivitiesListQuery, ActivitiesListQueryVariables>;
export const ActivitiesByIdDocument = new TypedDocumentString(`
    query activitiesById($filter: Sa_SchoolActivityFilter!) {
  sa_activities(filter: $filter) {
    schoolActivityId
    customGroupId
    lastPublished
    name
    staffAbsenceTypeId
    dates {
      date
      startTime
      endTime
      partial
    }
    location {
      locationDetails
      inSchoolGrounds
      roomIds
      rooms {
        roomId
        name
      }
    }
    tripPurpose
    notes
    published
    approval {
      status
      approvalDate
      approvalNote
    }
    customGroup {
      partyId
      name
      avatarUrl
      relatedSubjectGroups {
        partyId
        name
        subjects {
          name
        }
      }
      studentMembers {
        groupPartyId
        memberCount
        members {
          partyId
          person {
            avatarUrl
            partyId
            firstName
            lastName
            type
            title {
              id
              name
              nameTextId
            }
          }
        }
      }
      staffMembers {
        groupPartyId
        memberIds
        members {
          partyId
          person {
            avatarUrl
            partyId
            firstName
            lastName
            type
            title {
              id
              name
              nameTextId
            }
          }
          roles
        }
        memberCount
      }
    }
    publicStaffCalendar
    publicContactCalendar
    publicStudentCalendar
  }
}
    `) as unknown as TypedDocumentString<ActivitiesByIdQuery, ActivitiesByIdQueryVariables>;
export const SaStudentListDocument = new TypedDocumentString(`
    query saStudentList($filter: Sa_SchoolActivityFilter!) {
  sa_activities(filter: $filter) {
    customGroup {
      students {
        partyId
        person {
          partyId
          firstName
          lastName
          avatarUrl
          type
          title {
            id
            name
            nameTextId
          }
        }
        extensions {
          priority
          aen
          medical
        }
        classGroup {
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SaStudentListQuery, SaStudentListQueryVariables>;
export const Sa_LessonsNeedingCoverDocument = new TypedDocumentString(`
    query sa_lessonsNeedingCover($filter: Sa_LessonsNeedingCoverFilter!) {
  sa_lessonsNeedingCover(filter: $filter) {
    awayStaffPartyIds
    awayStaff {
      partyId
      firstName
      lastName
      avatarUrl
      type
      archived
    }
    studentsAttendingActivityTotal
    studentsInGroupTotal
    event {
      colour
      calendarEventId {
        eventId
      }
      name
      eventId
      startTime
      endTime
      rooms {
        name
      }
    }
    affectedAttendees {
      partyId
    }
  }
}
    `) as unknown as TypedDocumentString<Sa_LessonsNeedingCoverQuery, Sa_LessonsNeedingCoverQueryVariables>;
export const Sa_UpsertPublishDocument = new TypedDocumentString(`
    mutation sa_upsertPublish($input: Sa_PublishInput) {
  sa_upsertPublish(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Sa_UpsertPublishMutation, Sa_UpsertPublishMutationVariables>;
export const Sa_ApproveActivityDocument = new TypedDocumentString(`
    mutation sa_approveActivity($input: Sa_ApproveInput) {
  sa_approveActivity(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Sa_ApproveActivityMutation, Sa_ApproveActivityMutationVariables>;
export const Sa_AddRemoveStaffDocument = new TypedDocumentString(`
    mutation sa_addRemoveStaff($input: Sa_AddRemoveStaff!) {
  sa_addRemoveStaff(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Sa_AddRemoveStaffMutation, Sa_AddRemoveStaffMutationVariables>;
export const Sa_AddRemoveStudentsDocument = new TypedDocumentString(`
    mutation sa_addRemoveStudents($input: Sa_AddRemoveStudents!) {
  sa_addRemoveStudents(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Sa_AddRemoveStudentsMutation, Sa_AddRemoveStudentsMutationVariables>;
export const Sa_UpsertActivityDocument = new TypedDocumentString(`
    mutation sa_upsertActivity($input: Sa_SchoolActivityInput) {
  sa_upsertActivity(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Sa_UpsertActivityMutation, Sa_UpsertActivityMutationVariables>;
export const Core_UpsertAcademicNamespaceDocument = new TypedDocumentString(`
    mutation core_upsertAcademicNamespace($input: SaveAcademicNamespaceInput) {
  core_upsertAcademicNamespace(input: $input) {
    academicNamespaceId
  }
}
    `) as unknown as TypedDocumentString<Core_UpsertAcademicNamespaceMutation, Core_UpsertAcademicNamespaceMutationVariables>;
export const Core_SetActiveActiveAcademicNamespaceDocument = new TypedDocumentString(`
    mutation core_setActiveActiveAcademicNamespace($input: SetActiveAcademicNamespace) {
  core_setActiveActiveAcademicNamespace(input: $input) {
    academicNamespaceId
    type
    name
    year
    description
    isActiveDefaultNamespace
  }
}
    `) as unknown as TypedDocumentString<Core_SetActiveActiveAcademicNamespaceMutation, Core_SetActiveActiveAcademicNamespaceMutationVariables>;
export const Assessment_CommentBankDocument = new TypedDocumentString(`
    query assessment_commentBank($filter: CommentBankFilter) {
  assessment_commentBank(filter: $filter) {
    id
    name
    description
    active
    comments {
      id
      comment
      active
    }
  }
}
    `) as unknown as TypedDocumentString<Assessment_CommentBankQuery, Assessment_CommentBankQueryVariables>;
export const CommentBankByIdDocument = new TypedDocumentString(`
    query commentBankById($filter: CommentBankFilter) {
  assessment_commentBank(filter: $filter) {
    id
    name
    comments {
      id
      comment
      active
    }
  }
}
    `) as unknown as TypedDocumentString<CommentBankByIdQuery, CommentBankByIdQueryVariables>;
export const Assessment_SaveCommentBankDocument = new TypedDocumentString(`
    mutation assessment_saveCommentBank($input: [SaveCommentBankInput]) {
  assessment_saveCommentBank(input: $input) {
    id
    name
    description
    active
    comments {
      id
      comment
      active
    }
  }
}
    `) as unknown as TypedDocumentString<Assessment_SaveCommentBankMutation, Assessment_SaveCommentBankMutationVariables>;
export const CustomFieldsDocument = new TypedDocumentString(`
    query customFields($filter: Core_CustomFieldFilter) {
  core_customFields(filter: $filter) {
    id
    name
    type
    options
    source
  }
}
    `) as unknown as TypedDocumentString<CustomFieldsQuery, CustomFieldsQueryVariables>;
export const Core_DeleteCustomFieldsDocument = new TypedDocumentString(`
    mutation core_deleteCustomFields($input: Core_DeleteCustomFields!) {
  core_deleteCustomFields(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_DeleteCustomFieldsMutation, Core_DeleteCustomFieldsMutationVariables>;
export const Core_UpsertCustomFieldsDocument = new TypedDocumentString(`
    mutation core_upsertCustomFields($input: [Core_UpsertCustomFields!]!) {
  core_upsertCustomFields(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_UpsertCustomFieldsMutation, Core_UpsertCustomFieldsMutationVariables>;
export const Core_Staff_Form_BDocument = new TypedDocumentString(`
    query core_staff_form_b($filter: StaffFilter) {
  core_staff(filter: $filter) {
    partyId
    person {
      type
      title {
        nameTextId
        id
        name
      }
      firstName
      lastName
    }
    personalInformation {
      gender
      ire {
        ppsNumber
      }
    }
    payrollNumber
    jobSharing
    qualifications
    employmentCapacity {
      id
      name
    }
    staffIre {
      teacherCouncilNumber
      teacherReferenceNumber
      includeDtrReturns
      staffPost {
        id
        name
      }
      qualifications2
      qualifications3
      qualifications4
      otherSchool1
      otherSchool2
      previousSchool1
      previousSchool2
    }
  }
}
    `) as unknown as TypedDocumentString<Core_Staff_Form_BQuery, Core_Staff_Form_BQueryVariables>;
export const Export_PtmDocument = new TypedDocumentString(`
    query export_ptm($filter: Export_PTMOFilter!) {
  export_ptm(filter: $filter) {
    url
  }
}
    `) as unknown as TypedDocumentString<Export_PtmQuery, Export_PtmQueryVariables>;
export const Composite_ExtractStudentDataDocument = new TypedDocumentString(`
    query composite_extractStudentData($input: DataExtraction_ExtractInput!) {
  composite_extractStudentData(input: $input) {
    url
  }
}
    `) as unknown as TypedDocumentString<Composite_ExtractStudentDataQuery, Composite_ExtractStudentDataQueryVariables>;
export const Pbac_AreaMetaDataDocument = new TypedDocumentString(`
    query pbac_areaMetaData {
  pbac_areaMetaData {
    entityType
    resourceLevel {
      supportsPolicyUpdates
    }
    groupLevel {
      supportsPolicyUpdates
    }
  }
}
    `) as unknown as TypedDocumentString<Pbac_AreaMetaDataQuery, Pbac_AreaMetaDataQueryVariables>;
export const Pbac_PermittedPartiesDocument = new TypedDocumentString(`
    query pbac_permittedParties($filter: Pbac_SearchForParties!) {
  pbac_permittedParties(filter: $filter) {
    partyId
    party {
      ... on GeneralGroup {
        __typename
        avatarUrl
        name
      }
      ... on ProgrammeStageEnrollment {
        __typename
        avatarUrl
        name
      }
      ... on Staff {
        __typename
        person {
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
      ... on Student {
        __typename
        person {
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
      ... on StudentContact {
        __typename
        person {
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
      ... on SubjectGroup {
        name
        avatarUrl
        __typename
      }
      ... on YearGroupEnrollment {
        __typename
        avatarUrl
        name
      }
    }
    canRead
    canWrite
    canDelete
    canChangeAuth
  }
}
    `) as unknown as TypedDocumentString<Pbac_PermittedPartiesQuery, Pbac_PermittedPartiesQueryVariables>;
export const Pbac_ViewResolvedAuthDocument = new TypedDocumentString(`
    query pbac_viewResolvedAuth($filter: Pbac_ResolvedAuthFilter!) {
  pbac_viewResolvedAuth(filter: $filter) {
    isPbacSecured
    rows {
      randomIdentifier
      name
      canRead
      canWrite
      canDelete
      canChangeAuth
      parties {
        partyId
        party {
          ... on GeneralGroup {
            __typename
            avatarUrl
            name
          }
          ... on ProgrammeStageEnrollment {
            __typename
            avatarUrl
            name
          }
          ... on Staff {
            __typename
            person {
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
              type
            }
          }
          ... on Student {
            __typename
            person {
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
              type
            }
          }
          ... on StudentContact {
            __typename
            person {
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
              type
            }
          }
          ... on SubjectGroup {
            name
            avatarUrl
            __typename
          }
          ... on YearGroupEnrollment {
            __typename
            avatarUrl
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Pbac_ViewResolvedAuthQuery, Pbac_ViewResolvedAuthQueryVariables>;
export const Pbac_ViewResourcePolicyDocument = new TypedDocumentString(`
    query pbac_viewResourcePolicy($filter: Pbac_ResourcePolicyFilter!) {
  pbac_viewResourcePolicy(filter: $filter) {
    entityType
    entityId
    pbacPolicyId
    entityName
    activeUserCanChangeAuth
    overview {
      rows {
        partyId
        party {
          partyId
          ... on GeneralGroup {
            __typename
            avatarUrl
            name
          }
          ... on ProgrammeStageEnrollment {
            __typename
            avatarUrl
            name
          }
          ... on Staff {
            __typename
            person {
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
              type
            }
          }
          ... on Student {
            __typename
            person {
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
              type
            }
          }
          ... on StudentContact {
            __typename
            person {
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
              type
            }
          }
          ... on SubjectGroup {
            name
            avatarUrl
            __typename
          }
          ... on YearGroupEnrollment {
            __typename
            avatarUrl
            name
          }
        }
        canRead
        canWrite
        canDelete
        canChangeAuth
        editStatus
        hintMessage
      }
    }
    policies {
      name
      policyType
      parties {
        partyId
        canRead
        canWrite
        canDelete
        canChangeAuth
        party {
          partyId
          ... on GeneralGroup {
            __typename
            avatarUrl
            name
          }
          ... on ProgrammeStageEnrollment {
            __typename
            avatarUrl
            name
          }
          ... on Staff {
            __typename
            person {
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
              type
            }
          }
          ... on Student {
            __typename
            person {
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
              type
            }
          }
          ... on StudentContact {
            __typename
            person {
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
              type
            }
          }
          ... on SubjectGroup {
            name
            avatarUrl
            __typename
          }
          ... on YearGroupEnrollment {
            __typename
            avatarUrl
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Pbac_ViewResourcePolicyQuery, Pbac_ViewResourcePolicyQueryVariables>;
export const Pbac_UpsertFromOverviewDocument = new TypedDocumentString(`
    mutation pbac_upsertFromOverview($input: Pbac_UpsertFromOverview!) {
  pbac_upsertFromOverview(input: $input) {
    success
    errors {
      partyIds
      errorType
      message
    }
  }
}
    `) as unknown as TypedDocumentString<Pbac_UpsertFromOverviewMutation, Pbac_UpsertFromOverviewMutationVariables>;
export const Users_DeletePermissionGroupDocument = new TypedDocumentString(`
    mutation users_deletePermissionGroup($input: Users_DeletePermissionGroup!) {
  users_deletePermissionGroup(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_DeletePermissionGroupMutation, Users_DeletePermissionGroupMutationVariables>;
export const SavePermissionGroupDocument = new TypedDocumentString(`
    mutation savePermissionGroup($input: SavePermissionGroup) {
  users_savePermissionGroup(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<SavePermissionGroupMutation, SavePermissionGroupMutationVariables>;
export const Users_UpdatePermissionSetDocument = new TypedDocumentString(`
    mutation users_updatePermissionSet($input: [UpdatePermissionSet!]!) {
  users_updatePermissionSet(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_UpdatePermissionSetMutation, Users_UpdatePermissionSetMutationVariables>;
export const Composite_PermissionGroupsDocument = new TypedDocumentString(`
    query composite_permissionGroups($filter: PermissionGroupFilter!) {
  composite_permissionGroups(filter: $filter) {
    id
    name
    description
    memberType
    memberPartyIds
    custom
    permissionSets {
      id
      toggle
      permissionType
      feature
    }
  }
}
    `) as unknown as TypedDocumentString<Composite_PermissionGroupsQuery, Composite_PermissionGroupsQueryVariables>;
export const Users_PermissionSetsDocument = new TypedDocumentString(`
    query users_permissionSets($filter: PermissionSetFilter!) {
  users_permissionSets(filter: $filter) {
    id
    name
    description
    permissionType
    toggle
    feature
    context
    visibleToSchools
    contact
    staff
    student
  }
}
    `) as unknown as TypedDocumentString<Users_PermissionSetsQuery, Users_PermissionSetsQueryVariables>;
export const Ppod_EnrolmentsDocument = new TypedDocumentString(`
    query ppod_enrolments {
  ppod_enrolments {
    enrolmentId
    dpin
    forename
    surname
    academicYear
    programme
    programmeYear
    rollClass
    enrolmentDate
    earlyLeaving
    earlyLeavingDate
    leavingReason
    boarding
    newEntrant
    repeat
  }
}
    `) as unknown as TypedDocumentString<Ppod_EnrolmentsQuery, Ppod_EnrolmentsQueryVariables>;
export const Ppod_ExemptionsDocument = new TypedDocumentString(`
    query ppod_exemptions {
  ppod_exemptions {
    dpin
    forename
    surname
    exemptionId
    exemption
    exemptionTypeCode
    programmeCode
    programmeYear
    grantor
    startDate
    endDate
    comments
  }
}
    `) as unknown as TypedDocumentString<Ppod_ExemptionsQuery, Ppod_ExemptionsQueryVariables>;
export const Ppod_PpodCredentialsDocument = new TypedDocumentString(`
    query ppod_PPODCredentials {
  ppod_PPODCredentials {
    username
    password
    lastSyncSuccessful
  }
}
    `) as unknown as TypedDocumentString<Ppod_PpodCredentialsQuery, Ppod_PpodCredentialsQueryVariables>;
export const Ppod_SavePpodCredentialsDocument = new TypedDocumentString(`
    mutation ppod_savePPODCredentials($input: SavePPODCredentials!) {
  ppod_savePPODCredentials(input: $input) {
    username
    password
  }
}
    `) as unknown as TypedDocumentString<Ppod_SavePpodCredentialsMutation, Ppod_SavePpodCredentialsMutationVariables>;
export const Users_SchoolInfoDocument = new TypedDocumentString(`
    query users_schoolInfo {
  users_schoolInfo {
    id
    rollNo
    name
    email
    website
    fax
    principal
    boardingFeeFiveDay
    boardingFeeSixOrSevenDay
    schoolGender
    parentAssociation
    studentCouncil
    boardOfManagement
    irishClassification
    coOperatingSchoolRollNo1
    coOperatingSchoolRollNo2
    octoberReturnsContact
    octoberReturnsPhoneNo
    octoberReturnsFaxNo
    octoberReturnsEmail
    phones {
      phone
    }
    addresses {
      address1
      address2
      address3
      address4
      county
      localAuthority
    }
    chairPeople {
      chairPersonId
      forename
      surname
      phoneNo
      startDate
      endDate
    }
    owners {
      ownerId
      forename
      surname
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      startDate
      endDate
    }
    trustees {
      trusteeId
      forename
      surname
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      startDate
      endDate
    }
  }
}
    `) as unknown as TypedDocumentString<Users_SchoolInfoQuery, Users_SchoolInfoQueryVariables>;
export const Ppod_ShortCoursesDocument = new TypedDocumentString(`
    query ppod_shortCourses {
  ppod_shortCourses {
    enrolmentId
    dpin
    forename
    surname
    academicYear
    shortCourseCode
    shortCourse
    shortCourseLevelCode
    shortCourseMediumCode
  }
}
    `) as unknown as TypedDocumentString<Ppod_ShortCoursesQuery, Ppod_ShortCoursesQueryVariables>;
export const Ppod_StudentsDocument = new TypedDocumentString(`
    query ppod_students {
  ppod_students {
    dpin
    forename
    surname
    birthCertForename
    birthCertSurname
    mothersMaidenName
    gender
    dateOfBirth
    ppsn
    address1
    address2
    address3
    address4
    county
    eircode
    country
    nationality
    countryOfBirth
    birthCertChecked
    deceased
    deceasedDate
  }
}
    `) as unknown as TypedDocumentString<Ppod_StudentsQuery, Ppod_StudentsQueryVariables>;
export const Ppod_SubjectsDocument = new TypedDocumentString(`
    query ppod_subjects {
  ppod_subjects {
    enrolmentId
    dpin
    forename
    surname
    academicYear
    subjectCode
    subject
    subjectLevelCode
    subjectMediumCode
    abInitio
    classGroupId
  }
}
    `) as unknown as TypedDocumentString<Ppod_SubjectsQuery, Ppod_SubjectsQueryVariables>;
export const Ppod_SyncRequestsDocument = new TypedDocumentString(`
    query ppod_syncRequests($filter: SyncRequestsFilter!) {
  ppod_syncRequests(filter: $filter) {
    id
    syncRequestStatus
    requesterPartyId
    requester {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    failureReason
    requestedOn
  }
}
    `) as unknown as TypedDocumentString<Ppod_SyncRequestsQuery, Ppod_SyncRequestsQueryVariables>;
export const Catalogue_ImportProgrammeDataDocument = new TypedDocumentString(`
    mutation catalogue_importProgrammeData($input: Catalogue_ImportProgrammeData!) {
  catalogue_importProgrammeData(input: $input) {
    dryRun
    programmesCreated
    programmesUpdated
    stagesCreated
    stagesUpdated
    subjectsCreated
    subjectsAlreadyExisted
    stageSubjectsLinked
    stageSubjectsAlreadyLinked
    errors {
      section
      rowIndex
      nationalCode
      message
    }
  }
}
    `) as unknown as TypedDocumentString<Catalogue_ImportProgrammeDataMutation, Catalogue_ImportProgrammeDataMutationVariables>;
export const Catalogue_ProgrammesDocument = new TypedDocumentString(`
    query catalogue_programmes($filter: ProgrammeFilter) {
  catalogue_programmes(filter: $filter) {
    id
    name
    shortName
    nationalCode
    description
    discontinued
    editable
    stages {
      id
      name
      shortName
      nationalCode
      programmeId
      yearGroupId
      editable
      discontinued
      subjects {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Catalogue_ProgrammesQuery, Catalogue_ProgrammesQueryVariables>;
export const Catalogue_UpsertProgrammeStageSubjectsDocument = new TypedDocumentString(`
    mutation catalogue_upsertProgrammeStageSubjects($input: [Catalogue_UpsertProgrammeStageSubjects!]!) {
  catalogue_upsertProgrammeStageSubjects(input: $input) {
    success
    message
  }
}
    `) as unknown as TypedDocumentString<Catalogue_UpsertProgrammeStageSubjectsMutation, Catalogue_UpsertProgrammeStageSubjectsMutationVariables>;
export const Catalogue_UpsertProgrammeStageDocument = new TypedDocumentString(`
    mutation catalogue_upsertProgrammeStage($input: [Catalogue_UpsertProgrammeStage!]!) {
  catalogue_upsertProgrammeStage(input: $input) {
    success
    message
  }
}
    `) as unknown as TypedDocumentString<Catalogue_UpsertProgrammeStageMutation, Catalogue_UpsertProgrammeStageMutationVariables>;
export const Catalogue_UpsertProgrammeStagesDocument = new TypedDocumentString(`
    mutation catalogue_upsertProgrammeStages($input: [Catalogue_UpsertProgrammeStages!]!) {
  catalogue_upsertProgrammeStages(input: $input) {
    success
    message
  }
}
    `) as unknown as TypedDocumentString<Catalogue_UpsertProgrammeStagesMutation, Catalogue_UpsertProgrammeStagesMutationVariables>;
export const Catalogue_UpsertProgrammeDocument = new TypedDocumentString(`
    mutation catalogue_upsertProgramme($input: [Catalogue_UpsertProgramme!]!) {
  catalogue_upsertProgramme(input: $input) {
    success
    message
  }
}
    `) as unknown as TypedDocumentString<Catalogue_UpsertProgrammeMutation, Catalogue_UpsertProgrammeMutationVariables>;
export const Core_UpsertRoomsDocument = new TypedDocumentString(`
    mutation core_upsertRooms($input: [UpsertRoomInput]) {
  core_upsertRooms(input: $input) {
    roomId
  }
}
    `) as unknown as TypedDocumentString<Core_UpsertRoomsMutation, Core_UpsertRoomsMutationVariables>;
export const Core_BuildingsDocument = new TypedDocumentString(`
    query core_buildings($filter: BuildingFilter) {
  core_buildings(filter: $filter) {
    id
    name
    description
    campusId
    campus {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<Core_BuildingsQuery, Core_BuildingsQueryVariables>;
export const Core_UpsertBuildingsDocument = new TypedDocumentString(`
    mutation core_upsertBuildings($input: [UpsertBuildingInput!]!) {
  core_upsertBuildings(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Core_UpsertBuildingsMutation, Core_UpsertBuildingsMutationVariables>;
export const Core_DeleteBuildingsDocument = new TypedDocumentString(`
    mutation core_deleteBuildings($input: [Int!]!) {
  core_deleteBuildings(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_DeleteBuildingsMutation, Core_DeleteBuildingsMutationVariables>;
export const Core_CampusesDocument = new TypedDocumentString(`
    query core_campuses($filter: CampusFilter) {
  core_campuses(filter: $filter) {
    id
    name
    description
  }
}
    `) as unknown as TypedDocumentString<Core_CampusesQuery, Core_CampusesQueryVariables>;
export const Core_UpsertCampusesDocument = new TypedDocumentString(`
    mutation core_upsertCampuses($input: [UpsertCampusInput!]!) {
  core_upsertCampuses(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Core_UpsertCampusesMutation, Core_UpsertCampusesMutationVariables>;
export const Core_DeleteCampusesDocument = new TypedDocumentString(`
    mutation core_deleteCampuses($input: [Int!]!) {
  core_deleteCampuses(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_DeleteCampusesMutation, Core_DeleteCampusesMutationVariables>;
export const Core_RoomPoolsDocument = new TypedDocumentString(`
    query core_roomPools($filter: RoomPoolFilter) {
  core_roomPools(filter: $filter) {
    id
    name
    description
    colour
    rooms {
      roomId
      name
    }
  }
}
    `) as unknown as TypedDocumentString<Core_RoomPoolsQuery, Core_RoomPoolsQueryVariables>;
export const RoomPoolsSelectDocument = new TypedDocumentString(`
    query roomPoolsSelect($filter: RoomPoolFilter) {
  core_roomPools(filter: $filter) {
    id
    name
    colour
  }
}
    `) as unknown as TypedDocumentString<RoomPoolsSelectQuery, RoomPoolsSelectQueryVariables>;
export const Core_UpsertRoomPoolsDocument = new TypedDocumentString(`
    mutation core_upsertRoomPools($input: [UpsertRoomPool]) {
  core_upsertRoomPools(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Core_UpsertRoomPoolsMutation, Core_UpsertRoomPoolsMutationVariables>;
export const Core_RoomsDocument = new TypedDocumentString(`
    query core_rooms($filter: RoomFilter) {
  core_rooms(filter: $filter) {
    roomId
    name
    capacity
    description
    pools {
      id
      name
      description
      colour
    }
    includeInTimetable
    externalSystemId
    location
    disabled
    buildingId
    building {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<Core_RoomsQuery, Core_RoomsQueryVariables>;
export const CalendarDayInfoDocument = new TypedDocumentString(`
    query calendarDayInfo($filter: CalendarFilter) {
  calendar_calendar(filter: $filter) {
    id
    dayInfo {
      date
      dayType
      startTime
      description
      endTime
      periods {
        type
        startTime
        endTime
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CalendarDayInfoQuery, CalendarDayInfoQueryVariables>;
export const CalendarGridInfoDocument = new TypedDocumentString(`
    query calendarGridInfo($filter: CalendarGridFilter) {
  calendar_grids(filter: $filter) {
    gridIdx
    name
  }
}
    `) as unknown as TypedDocumentString<CalendarGridInfoQuery, CalendarGridInfoQueryVariables>;
export const UpdateClaendarDaysDocument = new TypedDocumentString(`
    mutation updateClaendarDays($input: Calendar_UpdateDays) {
  calendar_updateCalendarDays(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpdateClaendarDaysMutation, UpdateClaendarDaysMutationVariables>;
export const Sds_DeleteSdsSettingsDocument = new TypedDocumentString(`
    mutation sds_deleteSDSSettings {
  sds_deleteSDSSettings {
    success
  }
}
    `) as unknown as TypedDocumentString<Sds_DeleteSdsSettingsMutation, Sds_DeleteSdsSettingsMutationVariables>;
export const Sds_SettingsDocument = new TypedDocumentString(`
    query sds_settings {
  sds_settings {
    prefix
    includeAcademicYear
    includeClassGroups
    includeYearGroups
    includeNextYearsFirstYears
  }
}
    `) as unknown as TypedDocumentString<Sds_SettingsQuery, Sds_SettingsQueryVariables>;
export const Sds_UpdateSdsSettingsDocument = new TypedDocumentString(`
    mutation sds_updateSDSSettings($input: SDS_UpdateSettingsInput!) {
  sds_updateSDSSettings(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Sds_UpdateSdsSettingsMutation, Sds_UpdateSdsSettingsMutationVariables>;
export const CatalogueSubjectsDocument = new TypedDocumentString(`
    query catalogueSubjects($filter: SubjectFilter) {
  catalogue_subjects(filter: $filter) {
    id
    name
    description
    shortCode
    nationalCode
    subjectSource
    examinable
    colour
    icon
    active
  }
}
    `) as unknown as TypedDocumentString<CatalogueSubjectsQuery, CatalogueSubjectsQueryVariables>;
export const Catalogue_CreateSubjectDocument = new TypedDocumentString(`
    mutation catalogue_createSubject($input: CreateSubjectInput) {
  catalogue_createSubject(input: $input) {
    id
    name
    shortCode
    subjectSource
    active
    inUseHistorically
    examinable
  }
}
    `) as unknown as TypedDocumentString<Catalogue_CreateSubjectMutation, Catalogue_CreateSubjectMutationVariables>;
export const Catalogue_UpdateSubjectsDocument = new TypedDocumentString(`
    mutation catalogue_updateSubjects($input: [UpdateSubject!]!) {
  catalogue_updateSubjects(input: $input) {
    success
    message
  }
}
    `) as unknown as TypedDocumentString<Catalogue_UpdateSubjectsMutation, Catalogue_UpdateSubjectsMutationVariables>;
export const SocialIntegrationLinkDocument = new TypedDocumentString(`
    query socialIntegrationLink($filter: SocialMediaFilter!) {
  communications_socialIntegration(filter: $filter) {
    uri
    platform
  }
}
    `) as unknown as TypedDocumentString<SocialIntegrationLinkQuery, SocialIntegrationLinkQueryVariables>;
export const Communications_DisconnectPlatformDocument = new TypedDocumentString(`
    mutation communications_disconnectPlatform($input: DisconnectPlatformInput!) {
  communications_disconnectPlatform(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Communications_DisconnectPlatformMutation, Communications_DisconnectPlatformMutationVariables>;
export const Catalogue_SystemSettingsUpdateDocument = new TypedDocumentString(`
    mutation catalogue_systemSettingsUpdate($input: Catalogue_SystemSettingsUpdates!) {
  catalogue_systemSettingsUpdate(input: $input) {
    id {
      module
      category
      nameId
    }
    success
  }
}
    `) as unknown as TypedDocumentString<Catalogue_SystemSettingsUpdateMutation, Catalogue_SystemSettingsUpdateMutationVariables>;
export const Catalogue_SystemSettingsViewDocument = new TypedDocumentString(`
    query catalogue_systemSettingsView($filter: Catalogue_SystemSettingsFilter!) {
  catalogue_systemSettingsView(filter: $filter) {
    id {
      module
      category
      nameId
    }
    moduleName
    categoryName
    label
    labelTextId
    description
    fieldType
    value
    metadata
    selectValues {
      label
      value
    }
  }
}
    `) as unknown as TypedDocumentString<Catalogue_SystemSettingsViewQuery, Catalogue_SystemSettingsViewQueryVariables>;
export const Users_BlockUserDocument = new TypedDocumentString(`
    mutation users_blockUser($input: AccountAction!) {
  users_blockUser(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_BlockUserMutation, Users_BlockUserMutationVariables>;
export const Users_DeactivateProfilesDocument = new TypedDocumentString(`
    mutation users_deactivateProfiles($input: DeactivateProfiles) {
  users_deactivateProfiles(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_DeactivateProfilesMutation, Users_DeactivateProfilesMutationVariables>;
export const Users_InviteUsersDocument = new TypedDocumentString(`
    mutation users_inviteUsers($input: [InviteUser]) {
  users_inviteUsers(input: $input) {
    userAccesses {
      personPartyId
      webLastLogin
      mobileLastLogin
      status
      invitationId
      invitingPersonPartyId
      invitedOn
    }
    validations {
      message
      associatedUsers
    }
  }
}
    `) as unknown as TypedDocumentString<Users_InviteUsersMutation, Users_InviteUsersMutationVariables>;
export const Users_ProvisionMicrosoftEntraIdsDocument = new TypedDocumentString(`
    mutation users_provisionMicrosoftEntraIds($input: Users_ProvisionMicroSoftEntraIdsInput) {
  users_provisionMicrosoftEntraIds(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_ProvisionMicrosoftEntraIdsMutation, Users_ProvisionMicrosoftEntraIdsMutationVariables>;
export const Users_DeleteThirdPartyAccountDocument = new TypedDocumentString(`
    mutation users_deleteThirdPartyAccount($input: Users_DeleteThirdPartyAccountInput) {
  users_deleteThirdPartyAccount(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_DeleteThirdPartyAccountMutation, Users_DeleteThirdPartyAccountMutationVariables>;
export const Users_ThirdPartiesDocument = new TypedDocumentString(`
    query users_thirdParties {
  users_thirdParties {
    id
    type
    createdBy {
      partyId
      firstName
      lastName
      avatarUrl
      type
      title {
        id
        name
        nameTextId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Users_ThirdPartiesQuery, Users_ThirdPartiesQueryVariables>;
export const Users_ProvisionThirdPartyAccountDocument = new TypedDocumentString(`
    mutation users_provisionThirdPartyAccount($input: Users_ProvisionThirdPartyInput) {
  users_provisionThirdPartyAccount(input: $input) {
    secret
  }
}
    `) as unknown as TypedDocumentString<Users_ProvisionThirdPartyAccountMutation, Users_ProvisionThirdPartyAccountMutationVariables>;
export const Core_UpdateStudentDocument = new TypedDocumentString(`
    mutation core_updateStudent($input: [UpdateStudentInput!]!) {
  core_updateStudents(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Core_UpdateStudentMutation, Core_UpdateStudentMutationVariables>;
export const Users_UserAccessDocument = new TypedDocumentString(`
    query users_userAccess($filter: UserAccessFilter) {
  users_userAccess(filter: $filter) {
    globalUserId
    invitedEmail
    profileId
    personPartyId
    avatarUrl
    personalInfo {
      firstName
      lastName
      primaryEmail {
        email
      }
      primaryPhoneNumber {
        number
        areaCode
        countryCode
      }
    }
    contactStudents {
      firstName
      lastName
    }
    contactInfo {
      priority
      relationship
      classGroup
    }
    webLastLogin
    mobileLastLogin
    status
    invitedOn
    yearGroup {
      shortName
    }
    yearGroupContacts {
      shortName
    }
    mobileAppVersion
    microsoftEntraId
    blocked
  }
}
    `) as unknown as TypedDocumentString<Users_UserAccessQuery, Users_UserAccessQueryVariables>;
export const Communications_PurchaseAddOnDocument = new TypedDocumentString(`
    mutation communications_purchaseAddOn($input: PurchaseAddOnInput) {
  communications_purchaseAddOn(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Communications_PurchaseAddOnMutation, Communications_PurchaseAddOnMutationVariables>;
export const Communications_ScheduledSmsDocument = new TypedDocumentString(`
    query communications_scheduledSms($filter: ScheduledSmsFilter) {
  communications_scheduledSms(filter: $filter) {
    id
    sender {
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    body
    sendAt
    canReply
    totalCost
    recipients {
      id
      scheduledSmsId
      recipientPartyId
      party {
        __typename
        ... on Student {
          partyId
          person {
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
        }
        ... on SubjectGroup {
          partyId
          actualName
          name
          avatarUrl
        }
        ... on GeneralGroup {
          partyId
          generalGroupType
          name
          classGroupInfo {
            __typename
          }
        }
        ... on ProgrammeStageEnrollment {
          partyId
          name
        }
        ... on YearGroupEnrollment {
          partyId
          name
        }
        ... on Staff {
          partyId
          person {
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
        }
        ... on StudentContact {
          partyId
          person {
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
        }
      }
      smsRecipientType
    }
  }
}
    `) as unknown as TypedDocumentString<Communications_ScheduledSmsQuery, Communications_ScheduledSmsQueryVariables>;
export const SendSmsDocument = new TypedDocumentString(`
    mutation sendSms($input: SendSmsInput) {
  communications_sendSms(input: $input)
}
    `) as unknown as TypedDocumentString<SendSmsMutation, SendSmsMutationVariables>;
export const Communications_SmsDocument = new TypedDocumentString(`
    query communications_sms($filter: SmsFilter) {
  communications_sms(filter: $filter) {
    id
    name
    sender {
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    body
    sentOn
    canReply
    numRecipients
    totalCost
    recipients {
      id {
        tenant
        smsId
        recipientPartyId
      }
      recipient {
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      recipientPhoneNumber
      smsStatus
    }
  }
}
    `) as unknown as TypedDocumentString<Communications_SmsQuery, Communications_SmsQueryVariables>;
export const Communications_CurrentBalanceDocument = new TypedDocumentString(`
    query communications_currentBalance {
  communications_currentBalance {
    currentBalance
  }
}
    `) as unknown as TypedDocumentString<Communications_CurrentBalanceQuery, Communications_CurrentBalanceQueryVariables>;
export const Communications_SmsCostDocument = new TypedDocumentString(`
    query communications_smsCost($filter: SmsCostFilter) {
  communications_smsCost(filter: $filter) {
    total
  }
}
    `) as unknown as TypedDocumentString<Communications_SmsCostQuery, Communications_SmsCostQueryVariables>;
export const Communications_DeleteScheduledSmsDocument = new TypedDocumentString(`
    mutation communications_deleteScheduledSms($input: DeleteScheduledSmsInput!) {
  communications_deleteScheduledSms(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Communications_DeleteScheduledSmsMutation, Communications_DeleteScheduledSmsMutationVariables>;
export const Options_CloneDocument = new TypedDocumentString(`
    mutation options_clone($input: Options_Clone!) {
  options_clone(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Options_CloneMutation, Options_CloneMutationVariables>;
export const Options_DeleteDocument = new TypedDocumentString(`
    mutation options_delete($input: DeleteOption!) {
  options_delete(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Options_DeleteMutation, Options_DeleteMutationVariables>;
export const Print_OptionsMailDocument = new TypedDocumentString(`
    query print_optionsMail($filter: Print_OptionsMail!) {
  print_optionsMail(filter: $filter) {
    success
  }
}
    `) as unknown as TypedDocumentString<Print_OptionsMailQuery, Print_OptionsMailQueryVariables>;
export const Options_ClmDocument = new TypedDocumentString(`
    query options_clm($filter: Options_ClmFilter!) {
  options_clm(filter: $filter) {
    blockIdx
    subjectGroups {
      id
      subjectGroupName
      students {
        classGroup {
          name
        }
        personalInformation {
          gender
        }
        person {
          partyId
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Options_ClmQuery, Options_ClmQueryVariables>;
export const OptionsSol_UpsertSubjectGroupMembershipsDocument = new TypedDocumentString(`
    mutation optionsSol_upsertSubjectGroupMemberships($input: OptionsSol_UpsertSubjectGroupMembership!) {
  optionsSol_upsertSubjectGroupMemberships(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<OptionsSol_UpsertSubjectGroupMembershipsMutation, OptionsSol_UpsertSubjectGroupMembershipsMutationVariables>;
export const Options_AvailableEnrollmentGroupsDocument = new TypedDocumentString(`
    query options_availableEnrollmentGroups($filter: Options_AvailableGroupsFilter) {
  options_availableEnrollmentGroups(filter: $filter) {
    name
    id
  }
}
    `) as unknown as TypedDocumentString<Options_AvailableEnrollmentGroupsQuery, Options_AvailableEnrollmentGroupsQueryVariables>;
export const Options_EnrollmentGroupsStudentsDocument = new TypedDocumentString(`
    query options_EnrollmentGroupsStudents($filter: Options_AvailableGroupsFilter) {
  options_availableEnrollmentGroups(filter: $filter) {
    name
    id
    students {
      partyId
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
      }
      classGroup {
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Options_EnrollmentGroupsStudentsQuery, Options_EnrollmentGroupsStudentsQueryVariables>;
export const Options_PreferencesDocument = new TypedDocumentString(`
    query options_preferences($filter: Options_PreferencesFilter) {
  options_preferences(filter: $filter) {
    id {
      optionId
      studentPartyId
    }
    student {
      partyId
      firstName
      lastName
      avatarUrl
      type
    }
    choices {
      id {
        subjectSetIdx
        preferenceIdx
      }
      subject {
        id
        name
        shortCode
        colour
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Options_PreferencesQuery, Options_PreferencesQueryVariables>;
export const Options_SolutionsDocument = new TypedDocumentString(`
    query options_solutions($filter: Options_OptionIdFilter) {
  options_solutions(filter: $filter) {
    optionId
    solverStatus
    minSubjectsPerBlock
    pools {
      poolIdx
      blocks {
        blockIdx
        subjectGroups {
          id
          poolIdx
          blockIdx
          name
          subjectId
          subject {
            name
            shortCode
            colour
          }
          numStudents
          pinned
        }
      }
      subjectSets {
        id {
          optionId
          idx
        }
        mustGet
        studentChoices {
          studentPartyId
          subjectsAllocated
          reservedUsed
          subjectSetChoices {
            choiceIdx
            blockIdx
            subjectId
            subjectGroupName
            subject {
              name
              shortCode
              colour
            }
          }
        }
      }
      subjects {
        poolIdx
        subjectId
        subject {
          name
          shortCode
          colour
        }
        maxSize
        numClasses
        numPreferences
        missed
        maxPerBlock
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Options_SolutionsQuery, Options_SolutionsQueryVariables>;
export const Options_OptionsDocument = new TypedDocumentString(`
    query options_options($filter: Options_OptionFilter) {
  options_options(filter: $filter) {
    id
    name
    yearGroup {
      name
    }
    publishedToParents
    parentsDueByDate
    parentsDescription
    studentCount
    studentPreferencesCompleteCount
  }
}
    `) as unknown as TypedDocumentString<Options_OptionsQuery, Options_OptionsQueryVariables>;
export const OptionsSetupDocument = new TypedDocumentString(`
    query optionsSetup($filter: Options_OptionFilter) {
  options_options(filter: $filter) {
    id
    name
    yearGroup {
      yearGroupId
      name
    }
    students {
      partyId
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
      classGroup {
        name
      }
    }
    subjectSets {
      id {
        optionId
        idx
      }
      name
      canChoose
      mustGet
      poolIdx
      subjects {
        id
        name
        shortCode
        colour
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OptionsSetupQuery, OptionsSetupQueryVariables>;
export const PrintOptionsGroupMembersDocument = new TypedDocumentString(`
    query printOptionsGroupMembers($filter: Print_StudentOptionsMembers!) {
  print_optionsGroupMembers(filter: $filter) {
    url
    html
  }
}
    `) as unknown as TypedDocumentString<PrintOptionsGroupMembersQuery, PrintOptionsGroupMembersQueryVariables>;
export const Options_PublishDocument = new TypedDocumentString(`
    mutation options_publish($input: Options_OptionsPublish!) {
  options_publish(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Options_PublishMutation, Options_PublishMutationVariables>;
export const Options_SaveOptionsDocument = new TypedDocumentString(`
    mutation options_saveOptions($input: Options_SaveOptions!) {
  options_saveOptions(input: $input) {
    id
    validations
  }
}
    `) as unknown as TypedDocumentString<Options_SaveOptionsMutation, Options_SaveOptionsMutationVariables>;
export const OptionsSol_ModifySolutionSettingsDocument = new TypedDocumentString(`
    mutation optionsSol_modifySolutionSettings($input: OptionsSol_ModifySolutionSettings!) {
  optionsSol_modifySolutionSettings(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<OptionsSol_ModifySolutionSettingsMutation, OptionsSol_ModifySolutionSettingsMutationVariables>;
export const Options_SaveStudentPreferencesDocument = new TypedDocumentString(`
    mutation options_saveStudentPreferences($input: [Options_SaveStudentPreference]!) {
  options_saveStudentPreferences(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Options_SaveStudentPreferencesMutation, Options_SaveStudentPreferencesMutationVariables>;
export const OptionsSol_FillInOptionsDocument = new TypedDocumentString(`
    mutation optionsSol_fillInOptions($input: Options_OptionIdFilter!) {
  optionsSol_fillInOptions(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<OptionsSol_FillInOptionsMutation, OptionsSol_FillInOptionsMutationVariables>;
export const OptionsSol_SolveDocument = new TypedDocumentString(`
    mutation optionsSol_solve($input: OptionsSol_Solve!) {
  optionsSol_solve(input: $input) {
    problemId
  }
}
    `) as unknown as TypedDocumentString<OptionsSol_SolveMutation, OptionsSol_SolveMutationVariables>;
export const OptionsSol_BlocksDocument = new TypedDocumentString(`
    query optionsSol_blocks($filter: Options_OptionFilter) {
  optionsSol_blocks(filter: $filter) {
    subjectSet {
      blocks {
        blockIdx
        name
        subjectGroups {
          id
          poolIdx
          blockIdx
          name
          subjectId
          subject {
            name
            shortCode
            colour
          }
          numStudents
          pinned
        }
      }
      subjectSet {
        id {
          optionId
          idx
        }
        name
        poolIdx
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OptionsSol_BlocksQuery, OptionsSol_BlocksQueryVariables>;
export const OptionsSol_SubjectStatsDocument = new TypedDocumentString(`
    query optionsSol_subjectStats($filter: Options_OptionFilter) {
  optionsSol_subjectStats(filter: $filter) {
    subjectId
    subject {
      name
      shortCode
      colour
    }
    maxSize
    preferencesTotal
    preferencesGotten
    teachingGroups {
      id
      poolIdx
      blockIdx
      name
      numStudents
    }
  }
}
    `) as unknown as TypedDocumentString<OptionsSol_SubjectStatsQuery, OptionsSol_SubjectStatsQueryVariables>;
export const Options_SolverInputDocument = new TypedDocumentString(`
    query options_solverInput($filter: Options_OptionIdFilter) {
  options_solverInput(filter: $filter) {
    input
  }
}
    `) as unknown as TypedDocumentString<Options_SolverInputQuery, Options_SolverInputQueryVariables>;
export const Swm_AbsenceRequestsDocument = new TypedDocumentString(`
    query swm_absenceRequests($filter: SWM_StaffAbsenceRequestFilter) {
  swm_absenceRequests(filter: $filter) {
    staffAbsenceRequestId
    staff {
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    dates {
      continuousStartDate
      continuousEndDate
      individualDates
      partialAbsence
      leavesAt
      returnsAt
    }
    absenceType {
      absenceTypeId
      name
      code
    }
    status
    createdAt
    absenceNoteText
    rejectionReasonText
    attachments
    completedBy {
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Swm_AbsenceRequestsQuery, Swm_AbsenceRequestsQueryVariables>;
export const Swm_CountAbsenceRequestsDocument = new TypedDocumentString(`
    query swm_countAbsenceRequests($filter: SWM_StaffAbsenceRequestCounterFilter) {
  swm_countAbsenceRequests(filter: $filter) {
    count
  }
}
    `) as unknown as TypedDocumentString<Swm_CountAbsenceRequestsQuery, Swm_CountAbsenceRequestsQueryVariables>;
export const Swm_UpsertAbsenceRequestDocument = new TypedDocumentString(`
    mutation swm_upsertAbsenceRequest($input: SWM_UpsertStaffAbsenceRequest!) {
  swm_upsertAbsenceRequest(input: $input) {
    staffAbsenceRequestId
  }
}
    `) as unknown as TypedDocumentString<Swm_UpsertAbsenceRequestMutation, Swm_UpsertAbsenceRequestMutationVariables>;
export const Swm_ChangeAbsenceRequestStatusDocument = new TypedDocumentString(`
    mutation swm_changeAbsenceRequestStatus($input: SWM_ChangeStaffAbsenceRequestStatus) {
  swm_changeAbsenceRequestStatus(input: $input) {
    staffAbsenceRequestId
  }
}
    `) as unknown as TypedDocumentString<Swm_ChangeAbsenceRequestStatusMutation, Swm_ChangeAbsenceRequestStatusMutationVariables>;
export const Swm_ApplySubstitutionsDocument = new TypedDocumentString(`
    mutation swm_applySubstitutions($input: SWM_InsertSubstitution!) {
  swm_applySubstitutions(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Swm_ApplySubstitutionsMutation, Swm_ApplySubstitutionsMutationVariables>;
export const Swm_SendCoverNotificationsDocument = new TypedDocumentString(`
    mutation swm_sendCoverNotifications($input: SWM_SendNotifications!) {
  swm_sendCoverNotifications(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Swm_SendCoverNotificationsMutation, Swm_SendCoverNotificationsMutationVariables>;
export const Tt_RefreshGridDocument = new TypedDocumentString(`
    mutation tt_refreshGrid {
  tt_refreshGrid {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_RefreshGridMutation, Tt_RefreshGridMutationVariables>;
export const Swm_DeleteSubstitutionsDocument = new TypedDocumentString(`
    mutation swm_deleteSubstitutions($input: SWM_DeleteSubstitution!) {
  swm_deleteSubstitutions(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Swm_DeleteSubstitutionsMutation, Swm_DeleteSubstitutionsMutationVariables>;
export const Swm_AbsenceTypesDocument = new TypedDocumentString(`
    query swm_absenceTypes($filter: SWM_StaffAbsenceTypeFilter) {
  swm_absenceTypes(filter: $filter) {
    absenceTypeId
    name
    nameTextId
    description
    descriptionTextId
    code
    availableForRequests
    dcsCodeId
    dcsCode
  }
}
    `) as unknown as TypedDocumentString<Swm_AbsenceTypesQuery, Swm_AbsenceTypesQueryVariables>;
export const Swm_UpsertAbsenceTypeDocument = new TypedDocumentString(`
    mutation swm_upsertAbsenceType($input: [SWM_UpsertStaffAbsenceType]) {
  swm_upsertAbsenceType(input: $input) {
    absenceTypeId
  }
}
    `) as unknown as TypedDocumentString<Swm_UpsertAbsenceTypeMutation, Swm_UpsertAbsenceTypeMutationVariables>;
export const Swm_DcsCodesDocument = new TypedDocumentString(`
    query swm_dcsCodes($filter: SWM_DcsCodeFilter) {
  swm_dcsCodes(filter: $filter) {
    id
    code
  }
}
    `) as unknown as TypedDocumentString<Swm_DcsCodesQuery, Swm_DcsCodesQueryVariables>;
export const Swm_AbsencesDocument = new TypedDocumentString(`
    query swm_absences($filter: SWM_StaffAbsenceFilter) {
  swm_absences(filter: $filter) {
    absenceId
    absenceTypeId
    staffPartyId
    absenceType {
      absenceTypeId
      name
      code
    }
    isLongTermLeave
    longTermLeaveGroupsRequired
    longTermLeaveGroupsApplied
    staff {
      partyId
      title {
        id
        name
        nameTextId
      }
      firstName
      lastName
      avatarUrl
      type
    }
    absenceReasonText
    substitutionRequired
    dates {
      continuousStartDate
      continuousEndDate
      individualDates
      partialAbsence
      leavesAt
      returnsAt
    }
    longTermLeaveGroups {
      groupId
      group {
        name
        avatarUrl
      }
      coveringStaffId
      coveringStaff {
        person {
          partyId
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Swm_AbsencesQuery, Swm_AbsencesQueryVariables>;
export const Swm_UpsertAbsenceDocument = new TypedDocumentString(`
    mutation swm_upsertAbsence($input: SWM_UpsertStaffAbsences!) {
  swm_upsertAbsence(input: $input) {
    wasApplied
    wrongYear
    substitutionsPresent {
      eventId
      name
      startTime
      endTime
      exclusions {
        partyInfo {
          __typename
          partyId
          ... on Staff {
            person {
              partyId
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
              type
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Swm_UpsertAbsenceMutation, Swm_UpsertAbsenceMutationVariables>;
export const Swm_DeleteAbsenceDocument = new TypedDocumentString(`
    mutation swm_deleteAbsence($input: SWM_DeleteStaffAbsence!) {
  swm_deleteAbsence(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Swm_DeleteAbsenceMutation, Swm_DeleteAbsenceMutationVariables>;
export const Swm_SubstitutionLookupDocument = new TypedDocumentString(`
    query swm_substitutionLookup($filter: SWM_SubstitutionLookupFilter) {
  swm_substitutionLookup(filter: $filter) {
    staff {
      staff {
        person {
          partyId
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
        competencySubjects {
          id
          name
          colour
        }
        extensions {
          timetableSummary {
            fulltimePeriods
          }
          substitutionSummary {
            substitutionCountThisWeek
            substitutionTimeThisWeekMinutes
            substitutionCountThisYear
            substitutionTimeThisYearMinutes
          }
        }
        employmentCapacity {
          id
          name
        }
      }
      available
      clashingEvents
      substitutionStats {
        sandsWeekCount
        sandsWeekMinutes
        sandsYearCount
        sandsYearMinutes
        casualWeekCount
        casualWeekMinutes
        emer35WeekCount
        emer35YearCount
        emer35WeekMinutes
        emer35YearMinutes
        windfallWeekCount
        windfallWeekMinutes
        windfallYearCount
        windfallYearMinutes
      }
    }
    freeRooms {
      roomId
      name
      pools {
        id
        name
        colour
      }
    }
    clashingRooms {
      room {
        roomId
        name
        pools {
          id
          name
          colour
        }
      }
      clash
    }
  }
}
    `) as unknown as TypedDocumentString<Swm_SubstitutionLookupQuery, Swm_SubstitutionLookupQueryVariables>;
export const Swm_EventsForSubstitutionsByStaffByPeriodDocument = new TypedDocumentString(`
    query swm_eventsForSubstitutionsByStaffByPeriod($filter: SWM_EventsForSubstitutionFilter) {
  swm_eventsForSubstitutionsByStaffByPeriod(filter: $filter) {
    eventsByStaff {
      staff {
        person {
          partyId
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
      substitutionEventsByDay {
        dayInfo {
          date
          startTime
          endTime
          dayType
          periods {
            startTime
            endTime
            type
          }
          gridPeriods {
            gridIdx
            name
            periods {
              startTime
              endTime
              type
              name
              periodIdx
            }
          }
        }
        requireSubstitutionReason {
          reason
          note
        }
        substitutionEventsByPeriod {
          eventSubstitutions {
            ignored
            ignoredNote
            key {
              eventId
              date
              absentStaffId
            }
            absenceId
            staffPartyId
            coverTeacherDuplicatedAtSameTime {
              staffPartyId
              event {
                eventId
                startTime
                endTime
                type
                gridIdx
                periodIdx
                allDayEvent
                attendees {
                  partyId
                  type
                  partyInfo {
                    partyId
                    __typename
                    ... on Staff {
                      person {
                        partyId
                        title {
                          id
                          name
                          nameTextId
                        }
                        firstName
                        lastName
                        avatarUrl
                        type
                      }
                    }
                    ... on SubjectGroup {
                      subjectGroupType
                    }
                  }
                }
                rooms {
                  name
                  roomId
                }
                tags {
                  label
                  context
                }
                colour
                name
                description
                cancellations {
                  id
                  contextId
                  context
                  reason
                  note
                }
              }
              substitution {
                substitutionId
                originalStaff {
                  partyId
                  title {
                    id
                    name
                    nameTextId
                  }
                  firstName
                  lastName
                  avatarUrl
                  type
                }
                substituteStaff {
                  partyId
                  title {
                    id
                    name
                    nameTextId
                  }
                  firstName
                  lastName
                  avatarUrl
                  type
                }
                substitutionType {
                  substitutionTypeId
                  name
                  description
                  code
                }
                substituteRoom {
                  name
                  roomId
                }
                note
              }
            }
            event {
              eventId
              startTime
              endTime
              type
              allDayEvent
              gridIdx
              attendees {
                partyId
                type
                partyInfo {
                  partyId
                  __typename
                  ... on Staff {
                    person {
                      partyId
                      title {
                        id
                        name
                        nameTextId
                      }
                      firstName
                      lastName
                      avatarUrl
                      type
                    }
                  }
                  ... on SubjectGroup {
                    subjectGroupType
                  }
                }
              }
              rooms {
                name
                roomId
              }
              tags {
                label
                context
              }
              colour
              name
              description
              cancellations {
                id
                contextId
                context
                reason
                note
              }
            }
            substitution {
              substitutionId
              originalStaff {
                partyId
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
                type
              }
              substituteStaff {
                partyId
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
                type
              }
              substitutionType {
                substitutionTypeId
                name
                description
                code
              }
              substituteRoom {
                name
                roomId
              }
              note
            }
            linkedEvents {
              context
              event {
                eventId
                name
                startTime
              }
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Swm_EventsForSubstitutionsByStaffByPeriodQuery, Swm_EventsForSubstitutionsByStaffByPeriodQueryVariables>;
export const Swm_SubstitutionTypesDocument = new TypedDocumentString(`
    query swm_substitutionTypes($filter: SWM_StaffSubstitutionTypeFilter) {
  swm_substitutionTypes(filter: $filter) {
    substitutionTypeId
    name
    description
    code
  }
}
    `) as unknown as TypedDocumentString<Swm_SubstitutionTypesQuery, Swm_SubstitutionTypesQueryVariables>;
export const DeleteAssessmentTemplateDocument = new TypedDocumentString(`
    mutation deleteAssessmentTemplate($input: DeleteFileTransferInput!) {
  delete_file_transfer(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<DeleteAssessmentTemplateMutation, DeleteAssessmentTemplateMutationVariables>;
export const DeleteTemplateDocument = new TypedDocumentString(`
    mutation deleteTemplate($input: Templating_DeleteTemplateInput) {
  templating_deleteTemplates(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<DeleteTemplateMutation, DeleteTemplateMutationVariables>;
export const Templating_GetTemplateDownloadUrlDocument = new TypedDocumentString(`
    query templating_getTemplateDownloadUrl($templateId: Long) {
  templating_getTemplateDownloadUrl(templateId: $templateId) {
    temporaryUrl
  }
}
    `) as unknown as TypedDocumentString<Templating_GetTemplateDownloadUrlQuery, Templating_GetTemplateDownloadUrlQueryVariables>;
export const ResolveTemplateDocument = new TypedDocumentString(`
    query resolveTemplate($filter: Templating_ResolveTemplateInput) {
  templating_resolveTemplate(filter: $filter) {
    temporaryUrl
    html
  }
}
    `) as unknown as TypedDocumentString<ResolveTemplateQuery, ResolveTemplateQueryVariables>;
export const Templating_SaveTemplateDocument = new TypedDocumentString(`
    mutation templating_saveTemplate($input: Templating_SaveTemplateInput) {
  templating_saveTemplate(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Templating_SaveTemplateMutation, Templating_SaveTemplateMutationVariables>;
export const SchoolInfoDocument = new TypedDocumentString(`
    query schoolInfo {
  users_schoolInfo {
    id
    name
    addresses {
      address1
      address2
      address3
      address4
      county
      localAuthority
    }
  }
}
    `) as unknown as TypedDocumentString<SchoolInfoQuery, SchoolInfoQueryVariables>;
export const GetTemplatesDocument = new TypedDocumentString(`
    query getTemplates($filter: Templating_TemplateFilter) {
  templating_getTemplates(filter: $filter) {
    id
    name
    createdByPartyId
    createdBy {
      partyId
      person {
        partyId
        firstName
        lastName
        type
        avatarUrl
        title {
          id
          name
          nameTextId
        }
      }
    }
    createdOn
    template
    draft
    context
    area
    format
    docxFileName
  }
}
    `) as unknown as TypedDocumentString<GetTemplatesQuery, GetTemplatesQueryVariables>;
export const GetVariablesDocument = new TypedDocumentString(`
    query getVariables($filter: Templating_VariablesFilter) {
  templating_getVariables(filter: $filter) {
    id
    name
    value
    context
    category
    nested
  }
}
    `) as unknown as TypedDocumentString<GetVariablesQuery, GetVariablesQueryVariables>;
export const TtBlocksDocument = new TypedDocumentString(`
    query ttBlocks($filter: TT_BlockFilter!) {
  tt_blocks(filter: $filter) {
    blockId
    name
    shortName
    ttClassGroupIds
  }
}
    `) as unknown as TypedDocumentString<TtBlocksQuery, TtBlocksQueryVariables>;
export const TtClassGroupsDocument = new TypedDocumentString(`
    query ttClassGroups($filter: TT_ClassGroupsFilter!) {
  tt_classGroups(filter: $filter) {
    ttClassGroupId
    partyId
    name
    code
    groupTagIds
    groupTags {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<TtClassGroupsQuery, TtClassGroupsQueryVariables>;
export const Tt_UpsertClassGroupDocument = new TypedDocumentString(`
    mutation tt_upsertClassGroup($input: Tt_UpsertClassGroup!) {
  tt_upsertClassGroup(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_UpsertClassGroupMutation, Tt_UpsertClassGroupMutationVariables>;
export const Tt_DeleteClassGroupDocument = new TypedDocumentString(`
    mutation tt_deleteClassGroup($input: Tt_DeleteClassGroups!) {
  tt_deleteClassGroup(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_DeleteClassGroupMutation, Tt_DeleteClassGroupMutationVariables>;
export const Tt_CoScheduleChainsDocument = new TypedDocumentString(`
    query tt_coScheduleChains($filter: TT_CoScheduleChainsFilter!) {
  tt_coScheduleChains(filter: $filter) {
    chainId
    groups {
      timetableGroupId
      name
      subject {
        colour
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_CoScheduleChainsQuery, Tt_CoScheduleChainsQueryVariables>;
export const Tt_GridsDocument = new TypedDocumentString(`
    query tt_grids($filter: TTGridFilter!) {
  tt_grids(filter: $filter) {
    idx
    name
    timetableId
    description
    appliesToGroupTagIds
    appliesToGroupTags {
      id
      name
    }
    days {
      dayOfWeek
      idx
      halfDayAfterPeriod
      periods {
        idx
        name
        startTime
        endTime
        type
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_GridsQuery, Tt_GridsQueryVariables>;
export const Tt_GridListDocument = new TypedDocumentString(`
    query tt_gridList($filter: TTGridFilter!) {
  tt_grids(filter: $filter) {
    idx
    name
  }
}
    `) as unknown as TypedDocumentString<Tt_GridListQuery, Tt_GridListQueryVariables>;
export const Tt_MigrateGridDocument = new TypedDocumentString(`
    mutation tt_migrateGrid($input: Tt_MigrateGrid!) {
  tt_migrateGrid(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_MigrateGridMutation, Tt_MigrateGridMutationVariables>;
export const Tt_AddPeriodToStartDocument = new TypedDocumentString(`
    mutation tt_addPeriodToStart($input: Tt_AddPeriodsToStart!) {
  tt_addPeriodToStart(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_AddPeriodToStartMutation, Tt_AddPeriodToStartMutationVariables>;
export const Tt_AddPeriodToEndDocument = new TypedDocumentString(`
    mutation tt_addPeriodToEnd($input: Tt_AddPeriodsToEnd!) {
  tt_addPeriodToEnd(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_AddPeriodToEndMutation, Tt_AddPeriodToEndMutationVariables>;
export const Tt_SplitPeriodDocument = new TypedDocumentString(`
    mutation tt_splitPeriod($input: Tt_SplitPeriods!) {
  tt_splitPeriod(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_SplitPeriodMutation, Tt_SplitPeriodMutationVariables>;
export const Tt_PublishHistoryDocument = new TypedDocumentString(`
    query tt_publishHistory($filter: TTTimetableFilter) {
  tt_timetable(filter: $filter) {
    timetableId
    liveStatus {
      publishHistory {
        datetime
        lessonChanges
        timetableGroupChanges
        publishedByPartyId
        publishedByName
        changes {
          entityType
          changeType
          entityId
          name
          changedFields {
            field
            from
            to
          }
          changedByPartyId
          changedByName
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_PublishHistoryQuery, Tt_PublishHistoryQueryVariables>;
export const Tt_RemoveLessonBulkDocument = new TypedDocumentString(`
    mutation tt_removeLessonBulk($input: Tt_RemoveLessonBulk!) {
  tt_removeLessonBulk(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_RemoveLessonBulkMutation, Tt_RemoveLessonBulkMutationVariables>;
export const Tt_SwapTimeslotOptionsDocument = new TypedDocumentString(`
    query tt_swapTimeslotOptions($filter: TTSwapTimeslotFilter) {
  tt_swapTimeslotOptions(filter: $filter) {
    lessons {
      lesson {
        id {
          lessonIdx
          lessonInstanceIdx
          timetableGroupId
        }
        timetableGroup {
          name
        }
        timeslotId {
          gridIdx
          dayIdx
          periodIdx
        }
        timeslotInfo {
          dayOfWeek
          startTime
          endTime
          name
        }
        teachers {
          person {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
          displayCode
        }
        room {
          roomId
          name
        }
      }
      roomsClashes {
        room {
          roomId
          name
        }
        lesson {
          timetableGroup {
            name
          }
          timeslotId {
            gridIdx
            dayIdx
            periodIdx
          }
          timeslotInfo {
            dayOfWeek
            startTime
            endTime
            name
          }
        }
      }
      teacherClashes {
        teacherId
        teacher {
          person {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
        }
        lesson {
          timetableGroup {
            name
          }
          timeslotId {
            gridIdx
            dayIdx
            periodIdx
          }
          timeslotInfo {
            dayOfWeek
            startTime
            endTime
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_SwapTimeslotOptionsQuery, Tt_SwapTimeslotOptionsQueryVariables>;
export const Tt_SwapDocument = new TypedDocumentString(`
    mutation tt_swap($input: TTSwapsInput!) {
  tt_swap(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_SwapMutation, Tt_SwapMutationVariables>;
export const Tt_TimetableDocument = new TypedDocumentString(`
    query tt_timetable($filter: TTTimetableFilter) {
  tt_timetable(filter: $filter) {
    timetableId
    name
    created
    updatedAt
    liveStatus {
      totalChanges
      lessonChanges
      timetableGroupChanges
      lastPublishedDate
    }
    checkpointStatus {
      totalChanges
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_TimetableQuery, Tt_TimetableQueryVariables>;
export const Tt_TimetablesDocument = new TypedDocumentString(`
    query tt_timetables($filter: TTTimetableListFilter) {
  tt_timetables(filter: $filter) {
    timetableId
    name
    created
    updatedAt
    liveTimetable
    constructionInfo {
      classGroupsPublished
      fullPublish
    }
    createdBy {
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    updatedBy {
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    liveStatus {
      totalChanges
      lessonChanges
      timetableGroupChanges
      lastPublishedDate
    }
    pbac {
      isSecured
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_TimetablesQuery, Tt_TimetablesQueryVariables>;
export const Tt_GroupsDocument = new TypedDocumentString(`
    query tt_groups($filter: TT_GroupsFilter!) {
  tt_groups(filter: $filter) {
    __typename
    name
    timetableGroupId
    partyId
    subject {
      id
      name
      description
      shortCode
      nationalCode
      subjectSource
      examinable
      colour
      icon
      active
    }
    allowAutoTeacherSwaps
    groupType
    subjectId
    classGroupId
    blockId
    groupTagIds
    groupTag {
      id
      name
    }
    studentMembershipType
    teachers {
      person {
        partyId
        title {
          id
          nameTextId
          name
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    room {
      roomId
      name
    }
    roomPool {
      id
      name
    }
    spread
    totalLessonNoSpread
    coScheduleTtGroup {
      timetableGroupId
      name
      subject {
        colour
      }
    }
    lessons {
      id {
        lessonIdx
        lessonInstanceIdx
        timetableGroupId
      }
      timeslotId {
        gridIdx
        dayIdx
        periodIdx
      }
      timeslotInfo {
        startTime
        endTime
        name
        dayOfWeek
      }
      timetableGroup {
        __typename
        timetableGroupId
        name
        subject {
          name
          colour
        }
      }
      room {
        roomId
        name
      }
      roomPool {
        id
        name
      }
      teachers {
        person {
          partyId
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
      spread
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_GroupsQuery, Tt_GroupsQueryVariables>;
export const Tt_UpdateTeacherDocument = new TypedDocumentString(`
    mutation tt_updateTeacher($input: Tt_UpdateTeacherAssignments!) {
  tt_updateTeacher(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_UpdateTeacherMutation, Tt_UpdateTeacherMutationVariables>;
export const Tt_UpsertTimetableGroupDocument = new TypedDocumentString(`
    mutation tt_upsertTimetableGroup($input: Tt_UpsertTimetableGroup!) {
  tt_upsertTimetableGroup(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_UpsertTimetableGroupMutation, Tt_UpsertTimetableGroupMutationVariables>;
export const Tt_UpsertGridsDocument = new TypedDocumentString(`
    mutation tt_upsertGrids($input: TTUpsertGrids!) {
  tt_upsertGrids(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_UpsertGridsMutation, Tt_UpsertGridsMutationVariables>;
export const Tt_UpsertBlockDocument = new TypedDocumentString(`
    mutation tt_upsertBlock($input: Tt_UpsertBlock!) {
  tt_upsertBlock(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_UpsertBlockMutation, Tt_UpsertBlockMutationVariables>;
export const Tt_DeleteBlockDocument = new TypedDocumentString(`
    mutation tt_deleteBlock($input: Tt_DeleteBlocks!) {
  tt_deleteBlock(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_DeleteBlockMutation, Tt_DeleteBlockMutationVariables>;
export const Tt_CheckpointStatusDocument = new TypedDocumentString(`
    query tt_checkpointStatus($filter: TTTimetableFilter) {
  tt_timetable(filter: $filter) {
    timetableId
    checkpointStatus {
      checkpointTimetableId
      totalChanges
      lessonChanges
      timetableGroupChanges
      lastCheckpointDate
      checkpoints {
        checkpointTimetableId
        createdOn
        checkpointName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_CheckpointStatusQuery, Tt_CheckpointStatusQueryVariables>;
export const Tt_ClassGroupRolloverViewDocument = new TypedDocumentString(`
    query tt_classGroupRolloverView($filter: TT_ClassGroupRolloverViewFilter!) {
  tt_classGroupRolloverView(filter: $filter) {
    currentTimetableId
    previousTimetableId
    previousAcademicNamespaceId
    currentClassGroups {
      ttClassGroupId
      partyId
      name
      code
      groupTagIds
      source {
        source
        id
      }
    }
    previousClassGroups {
      ttClassGroupId
      partyId
      name
      code
      groupTagIds
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_ClassGroupRolloverViewQuery, Tt_ClassGroupRolloverViewQueryVariables>;
export const Ttsolve_ClearTimeslotsDocument = new TypedDocumentString(`
    mutation ttsolve_clearTimeslots($input: TtSolve_ClearTimeslots) {
  ttsolve_clearTimeslots(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ClearTimeslotsMutation, Ttsolve_ClearTimeslotsMutationVariables>;
export const Tt_CloneTimetableDocument = new TypedDocumentString(`
    mutation tt_cloneTimetable($input: TTCloneTimetableInput!) {
  tt_cloneTimetable(input: $input) {
    timetableId
  }
}
    `) as unknown as TypedDocumentString<Tt_CloneTimetableMutation, Tt_CloneTimetableMutationVariables>;
export const Tt_CreateCheckpointDocument = new TypedDocumentString(`
    mutation tt_createCheckpoint($input: Tt_CreateCheckpoint!) {
  tt_createCheckpoint(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_CreateCheckpointMutation, Tt_CreateCheckpointMutationVariables>;
export const Tt_CreateTimetableDocument = new TypedDocumentString(`
    mutation tt_createTimetable($input: Tt_CreateTimetableInput!) {
  tt_createTimetable(input: $input) {
    timetableId
  }
}
    `) as unknown as TypedDocumentString<Tt_CreateTimetableMutation, Tt_CreateTimetableMutationVariables>;
export const Ttsolve_ClassDataSetSpreadOnCoreSubjectsDocument = new TypedDocumentString(`
    mutation ttsolve_classDataSetSpreadOnCoreSubjects($input: TtSolve_ClassDataSetSpreadOnCoreSubject!) {
  ttsolve_classDataSetSpreadOnCoreSubjects(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ClassDataSetSpreadOnCoreSubjectsMutation, Ttsolve_ClassDataSetSpreadOnCoreSubjectsMutationVariables>;
export const Ttsolve_ClassDataSetSpreadOnBlockDocument = new TypedDocumentString(`
    mutation ttsolve_classDataSetSpreadOnBlock($input: TtSolve_ClassDataSetSpreadOnBlock!) {
  ttsolve_classDataSetSpreadOnBlock(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ClassDataSetSpreadOnBlockMutation, Ttsolve_ClassDataSetSpreadOnBlockMutationVariables>;
export const Ttsolve_ClassDataDropOnBlockDocument = new TypedDocumentString(`
    mutation ttsolve_classDataDropOnBlock($input: TtSolve_ClassDataDropOnBlock!) {
  ttsolve_classDataDropOnBlock(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ClassDataDropOnBlockMutation, Ttsolve_ClassDataDropOnBlockMutationVariables>;
export const Ttoptions_AvailableOptionsForImportDocument = new TypedDocumentString(`
    query ttoptions_availableOptionsForImport($filter: TTTimetableFilter!) {
  ttoptions_availableOptionsForImport(filter: $filter) {
    options {
      id
      name
    }
    possibleGroupTagIds
  }
}
    `) as unknown as TypedDocumentString<Ttoptions_AvailableOptionsForImportQuery, Ttoptions_AvailableOptionsForImportQueryVariables>;
export const Ttoptions_ImportOptionsDocument = new TypedDocumentString(`
    mutation ttoptions_importOptions($input: TtStudentOptions_Import!) {
  ttoptions_importOptions(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttoptions_ImportOptionsMutation, Ttoptions_ImportOptionsMutationVariables>;
export const Tt_IndividualLessonsDocument = new TypedDocumentString(`
    query tt_individualLessons($filter: TTIndividualViewLessonFilter!) {
  tt_individualLessons(filter: $filter) {
    id {
      lessonIdx
      lessonInstanceIdx
      timetableGroupId
    }
    spread
    room {
      roomId
      name
    }
    roomPool {
      id
      name
    }
    timeslotInfo {
      dayOfWeek
      startTime
      endTime
      periodType
      name
    }
    timeslotId {
      gridIdx
      dayIdx
      periodIdx
    }
    timetableGroup {
      name
      partyId
      subject {
        id
        name
        colour
        icon
      }
      groupTagIds
    }
    teachers {
      person {
        partyId
        title {
          id
          name
          nameTextId
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_IndividualLessonsQuery, Tt_IndividualLessonsQueryVariables>;
export const Tt_PublishConstructionDocument = new TypedDocumentString(`
    mutation tt_publishConstruction($input: TTPublishConstructionInput!) {
  tt_publishConstruction(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_PublishConstructionMutation, Tt_PublishConstructionMutationVariables>;
export const Ttsolve_StackGroupsDocument = new TypedDocumentString(`
    mutation ttsolve_stackGroups($input: TtSolve_StackGroups!) {
  ttsolve_stackGroups(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_StackGroupsMutation, Ttsolve_StackGroupsMutationVariables>;
export const Ttsolve_ClassDataAddSubjectDocument = new TypedDocumentString(`
    mutation ttsolve_classDataAddSubject($input: TtSolve_ClassDataAddSubject!) {
  ttsolve_classDataAddSubject(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ClassDataAddSubjectMutation, Ttsolve_ClassDataAddSubjectMutationVariables>;
export const Ttsolve_ClassDataDeleteCoreSubjectsDocument = new TypedDocumentString(`
    mutation ttsolve_classDataDeleteCoreSubjects($input: TtSolve_ClassDataDeleteCoreSubject!) {
  ttsolve_classDataDeleteCoreSubjects(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ClassDataDeleteCoreSubjectsMutation, Ttsolve_ClassDataDeleteCoreSubjectsMutationVariables>;
export const Ttsolve_ClassDataViewDocument = new TypedDocumentString(`
    query ttsolve_classDataView($filter: TtSolve_ClassDataFilter!) {
  ttsolve_classDataView(filter: $filter) {
    classGroups {
      classGroup {
        ttClassGroupId
        partyId
        name
        code
        groupTags {
          id
          name
        }
      }
      uiBlockLessonCountOnColumn
      uiCoreLessonCountOnColumn
      uiTotalLessonCountOnColumn
    }
    blocks {
      block {
        blockId
        name
        shortName
        classGroups {
          ttClassGroupId
          name
        }
      }
      timetableGroups {
        classGroupId
        blockGroup {
          groups {
            timetableGroupId
            name
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
              displayCode
            }
            allowAutoTeacherSwaps
            subject {
              id
              name
              colour
            }
            groupType
            studentMembershipType
            groupTagIds
            spread
            totalLessonNoSpread
            lessonCount
            blockIdx
            blockId
            classGroupId
            room {
              roomId
              name
            }
            roomPool {
              id
              name
            }
            lessons {
              id {
                lessonIdx
                lessonInstanceIdx
                timetableGroupId
              }
              timeslotId {
                gridIdx
                dayIdx
                periodIdx
              }
              timeslotInfo {
                dayOfWeek
                name
                startTime
                endTime
              }
              teachers {
                person {
                  partyId
                  title {
                    id
                    nameTextId
                    name
                  }
                  firstName
                  lastName
                  avatarUrl
                  type
                  archived
                }
              }
              room {
                roomId
                name
              }
              roomPool {
                id
                name
              }
              spread
            }
            maxClassSize
            coScheduleTtGroup {
              timetableGroupId
              name
            }
          }
          isStack
          classGroupIsPresentInBlock
        }
      }
      spillOverTimetableGroups {
        groups {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          allowAutoTeacherSwaps
          subject {
            id
            name
            colour
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          totalLessonNoSpread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              dayOfWeek
              name
              startTime
              endTime
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
        isStack
      }
      supportGroups {
        groups {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          allowAutoTeacherSwaps
          subject {
            id
            name
            colour
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          totalLessonNoSpread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              dayOfWeek
              name
              startTime
              endTime
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
        isStack
      }
      coScheduleGroups {
        groups {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          allowAutoTeacherSwaps
          subject {
            id
            name
            colour
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          totalLessonNoSpread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              dayOfWeek
              name
              startTime
              endTime
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
        isStack
      }
    }
    core {
      subjectId
      subject {
        id
        name
        colour
        nationalCode
      }
      timetableGroups {
        classGroupId
        timetableGroups {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          allowAutoTeacherSwaps
          subject {
            id
            name
            colour
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          totalLessonNoSpread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              dayOfWeek
              name
              startTime
              endTime
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ClassDataViewQuery, Ttsolve_ClassDataViewQueryVariables>;
export const Ttsolve_DeleteRestrictionDocument = new TypedDocumentString(`
    mutation ttsolve_deleteRestriction($input: TtSolve_DeleteRestrictions!) {
  ttsolve_deleteRestriction(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_DeleteRestrictionMutation, Ttsolve_DeleteRestrictionMutationVariables>;
export const Tt_DeleteTimetablesDocument = new TypedDocumentString(`
    mutation tt_deleteTimetables($input: TT_DeleteTimetables!) {
  tt_deleteTimetables(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_DeleteTimetablesMutation, Tt_DeleteTimetablesMutationVariables>;
export const Tt_DeleteTimetableGroupDocument = new TypedDocumentString(`
    mutation tt_deleteTimetableGroup($input: Tt_DeleteTimetableGroups!) {
  tt_deleteTimetableGroup(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_DeleteTimetableGroupMutation, Tt_DeleteTimetableGroupMutationVariables>;
export const Ttsolve_ImportSubjectCompetenciesFromCoreDocument = new TypedDocumentString(`
    mutation ttsolve_importSubjectCompetenciesFromCore($input: Tt_ImportSubjectCompetenciesFromCore!) {
  ttsolve_importSubjectCompetenciesFromCore(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ImportSubjectCompetenciesFromCoreMutation, Ttsolve_ImportSubjectCompetenciesFromCoreMutationVariables>;
export const Ttsolve_RestrictionsMetaDocument = new TypedDocumentString(`
    query ttsolve_restrictionsMeta($filter: TtSolve_RestrictionParams!) {
  ttsolve_restrictionsMeta(filter: $filter) {
    restriction {
      ruleId
      arguments {
        type
        label
        description
        required
        selectValues {
          id
          value
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_RestrictionsMetaQuery, Ttsolve_RestrictionsMetaQueryVariables>;
export const Ttsolve_RestrictionsDocument = new TypedDocumentString(`
    query ttsolve_restrictions($filter: TtSolve_RestrictionParams!) {
  ttsolve_restrictions(filter: $filter) {
    resctriction {
      restrictionIdx
      type
      ruleId
      description
      enabled
      arguments {
        type
        value
        rawValue
      }
      createdBy {
        userId
        partyId
        person {
          type
          title {
            id
            name
            nameTextId
          }
          firstName
          lastName
          avatarUrl
        }
      }
      hasError
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_RestrictionsQuery, Ttsolve_RestrictionsQueryVariables>;
export const Tt_RolloverAutoMatchDocument = new TypedDocumentString(`
    query tt_rolloverAutoMatch($filter: TT_RolloverAutoMatchFilter!) {
  tt_rolloverAutoMatch(filter: $filter) {
    subjectGroupMatches {
      timetableGroupId
      previousYearTimetableGroupPartyId
    }
    classGroupMatches {
      ttClassGroupId
      previousYearClassGroupPartyId
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_RolloverAutoMatchQuery, Tt_RolloverAutoMatchQueryVariables>;
export const Tt_RolloverProgrammeStagesDocument = new TypedDocumentString(`
    query tt_rolloverProgrammeStages($filter: TT_RolloverProgrammeStagesFilter!) {
  tt_rolloverProgrammeStages(filter: $filter) {
    fromProgrammeStageTagId
    toProgrammeStageTagId
    from {
      id
      name
      colour
    }
    to {
      id
      name
      colour
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_RolloverProgrammeStagesQuery, Tt_RolloverProgrammeStagesQueryVariables>;
export const Tt_SetTimetableGroupRolloverSourcesDocument = new TypedDocumentString(`
    mutation tt_setTimetableGroupRolloverSources($input: TT_SetTimetableGroupRolloverSourcesInput!) {
  tt_setTimetableGroupRolloverSources(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_SetTimetableGroupRolloverSourcesMutation, Tt_SetTimetableGroupRolloverSourcesMutationVariables>;
export const Tt_RoomAssignmentStatsDocument = new TypedDocumentString(`
    query tt_roomAssignmentStats($filter: Tt_RoomAssignmentFilter!) {
  tt_roomAssignments(filter: $filter) {
    assignments {
      roomId
      maxLoadPeriods
      currentLoadPeriods
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_RoomAssignmentStatsQuery, Tt_RoomAssignmentStatsQueryVariables>;
export const Tt_RoomAssignmentsDocument = new TypedDocumentString(`
    query tt_roomAssignments($filter: Tt_RoomAssignmentFilter!) {
  tt_roomAssignments(filter: $filter) {
    solverStatus {
      solverStatus
      score
    }
    stats {
      roomCountTotal
      roomsOverAllocatedCount
      roomsFullyAllocatedCount
      roomsUnderAllocatedCount
      mainstreamCount
      mainstreamRoomsAssignedCount
      mainstreamRoomsUnassignedCount
      freeformCount
      freeformRoomsAssignedCount
      freeformRoomsUnassignedCount
      nonTeachingCount
      nonTeachingRoomsAssignedCount
      nonTeachingRoomsUnassignedCount
    }
    assignments {
      roomId
      room {
        name
        capacity
        pools {
          id
          name
          colour
        }
      }
      maxLoadPeriods
      currentLoadPeriods
      lessonsAssigned
      mainstream {
        lessonsAssigned
        lessonsTotal
        splitIndicator
        isMultipleOTeachersOnLesson
        group {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          subject {
            id
            name
            colour
            nationalCode
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
            pools {
              id
              name
            }
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              name
              dayOfWeek
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
              pools {
                id
                name
              }
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
      freeform {
        lessonsAssigned
        lessonsTotal
        splitIndicator
        isMultipleOTeachersOnLesson
        group {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          subject {
            id
            name
            colour
            nationalCode
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
            pools {
              id
              name
            }
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              name
              dayOfWeek
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
              pools {
                id
                name
              }
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
      nonTeaching {
        lessonsAssigned
        lessonsTotal
        splitIndicator
        isMultipleOTeachersOnLesson
        group {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          subject {
            id
            name
            colour
            nationalCode
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
            pools {
              id
              name
            }
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              name
              dayOfWeek
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
              pools {
                id
                name
              }
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
    }
    unassigned {
      maxLoadPeriods
      currentLoadPeriods
      lessonsAssigned
      mainstream {
        lessonsAssigned
        lessonsTotal
        splitIndicator
        isMultipleOTeachersOnLesson
        group {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          subject {
            id
            name
            colour
            nationalCode
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
            pools {
              id
              name
            }
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              name
              dayOfWeek
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
              pools {
                id
                name
              }
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
      freeform {
        lessonsAssigned
        lessonsTotal
        splitIndicator
        isMultipleOTeachersOnLesson
        group {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          subject {
            id
            name
            colour
            nationalCode
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
            pools {
              id
              name
            }
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              name
              dayOfWeek
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
              pools {
                id
                name
              }
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
      nonTeaching {
        lessonsAssigned
        lessonsTotal
        splitIndicator
        isMultipleOTeachersOnLesson
        group {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          subject {
            id
            name
            colour
            nationalCode
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
            pools {
              id
              name
            }
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              name
              dayOfWeek
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
              pools {
                id
                name
              }
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_RoomAssignmentsQuery, Tt_RoomAssignmentsQueryVariables>;
export const Ttsolve_ClearRoomsDocument = new TypedDocumentString(`
    mutation ttsolve_clearRooms($input: TtSolve_ClearRooms) {
  ttsolve_clearRooms(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ClearRoomsMutation, Ttsolve_ClearRoomsMutationVariables>;
export const Ttsolve_ScheduleLessonOptionsDocument = new TypedDocumentString(`
    query ttsolve_scheduleLessonOptions($filter: TtSolver_ScheduleLessonFilter!) {
  ttsolve_scheduleLessonOptions(filter: $filter) {
    timeslotValidations {
      valid
      validations {
        id
        rootMessage
        contextMessage
        validationLevel
        validationRuleId
        validationAction
      }
      timeslotId {
        gridIdx
        dayIdx
        periodIdx
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ScheduleLessonOptionsQuery, Ttsolve_ScheduleLessonOptionsQueryVariables>;
export const Ttsolve_ResourceSlackReportDocument = new TypedDocumentString(`
    query ttsolve_resourceSlackReport($filter: TtSolve_SolveParams!) {
  ttsolve_resourceSlackReport(filter: $filter) {
    schemaVersion
    generatedAtEpochMs
    inputHash
    difficulty
    feasibility
    shape {
      totalLessons
      mandatoryLessons
      blockLessons
      mandatoryOrMeetingSgs
      blockSgs
      meetingSgs
      blocks
      stackedBlocks
      teachers
      baseClasses
      rooms
      roomPools
      totalSlots
      totalDays
      avgSlotsPerDay
      cycles
      twoWeek
      dualGrid
    }
    feasibilityErrors {
      code
      constraintId
      constraintName
      level
      message
    }
    capacity {
      overbookedBaseClasses {
        baseClassId
        name
        required
        available
        over
      }
      overbookedTeachersTimeslots {
        teacherId
        name
        required
        available
        ratio
      }
      overbookedTeachersWeeklyTime {
        teacherId
        name
        required
        available
        ratio
      }
      overbookedPools {
        roomPoolId
        name
        demand
        capacity
      }
      maxBaseClassLoad
      maxTeacherTimeslotLoad
      maxTeacherWeeklyTimeLoad
      maxPoolGlobalLoad
      teacherSlotOver09Count
      roomedLessons
      roomedFraction
      maxRoomLoad
    }
    spread {
      pressuredSpreads {
        subjectGroupId
        blockId
        sgName
        spread
        daysNeeded
        daysAvail
        tightness
        difficulty
        reason
        inBlock
        hardSpread
      }
      isHardAtLeastOnce
      maxDifficulty
      totalDifficulty
      comfortableCount
      snugCount
      zeroSlackCount
      infeasibleCount
      totalEvaluated
      multiplePairCount
      spreadStrain
      pressureIndex
      pressureLabel
    }
    blocks {
      bigBlocks {
        blockId
        name
        rows
        cols
        lessons
      }
      bigBlockGroups {
        blockId
        blockName
        blockGroupId
        lessons
      }
    }
    multiples {
      inBlocks
      inMandatory
    }
    restrictions {
      topTeachers {
        teacherId
        name
        hardDaysOff
        hardHalfDaysOff
        hardExcludedSlots
      }
      topSubjectGroups {
        subjectGroupId
        name
        hardDaysOff
        hardExcludedSlots
      }
    }
    pinning {
      lessons
      fraction
    }
    coSchedule {
      chains
      chainsWithBlocks
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ResourceSlackReportQuery, Ttsolve_ResourceSlackReportQueryVariables>;
export const Ttsolve_ScheduleViewDocument = new TypedDocumentString(`
    query ttsolve_scheduleView($filter: TtSolver_ScheduleFilter!) {
  ttsolve_scheduleView(filter: $filter) {
    byGroupTag {
      groupTagId
      groupTag {
        name
      }
      timeslots {
        id {
          gridIdx
          dayIdx
          periodIdx
        }
        info {
          dayOfWeek
          startTime
          endTime
          periodType
          name
          meta {
            placementDisabled
          }
        }
      }
      timetableGroups {
        timetableGroupId
        name
        subject {
          id
          name
          colour
          shortCode
        }
        groupType
        studentMembershipType
        groupTagIds
        spread
        lessonCount
        blockIdx
        blockId
        classGroupId
        teachers {
          person {
            partyId
            title {
              id
              nameTextId
              name
            }
            firstName
            lastName
            avatarUrl
            type
            archived
          }
          displayCode
        }
        room {
          roomId
          name
        }
        roomPool {
          id
          name
        }
        lessons {
          id {
            lessonIdx
            lessonInstanceIdx
            timetableGroupId
          }
          timeslotInfo {
            dayOfWeek
            startTime
            endTime
            periodType
            name
          }
          timeslotState
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          room {
            roomId
            name
          }
          roomPool {
            id
            name
          }
          spread
          schedulingStats {
            brokenFeasibility
            brokenSpreadOnly
            brokenAllConstraints
          }
        }
      }
      rows {
        name
        id
        allowMultiple
        grid {
          timeslotId {
            gridIdx
            dayIdx
            periodIdx
          }
          lessonInstanceIds {
            lessonIdx
            lessonInstanceIdx
            timetableGroupId
          }
          included
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ScheduleViewQuery, Ttsolve_ScheduleViewQueryVariables>;
export const Ttsolve_ConfigurationDocument = new TypedDocumentString(`
    query ttsolve_configuration($filter: TtSolve_SolveParams!) {
  ttsolve_configuration(filter: $filter) {
    user {
      globalConstraints {
        id
        label
        isDiamond
        weighting
        isAdvanced
      }
      weightings {
        id
        label
        weighting
      }
    }
    defaults {
      globalConstraints {
        id
        label
        isDiamond
        weighting
        isAdvanced
      }
      weightings {
        id
        label
        weighting
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ConfigurationQuery, Ttsolve_ConfigurationQueryVariables>;
export const Ttsolve_TopBrokenConstraintsDocument = new TypedDocumentString(`
    query ttsolve_topBrokenConstraints($filter: TtSolve_TopBrokenConstraintsFilter!) {
  ttsolve_topBrokenConstraints(filter: $filter) {
    distinctConstraints
    totalViolations
    dataNote
    entries {
      constraintName
      totalFrequency
      distinctLessonInstances
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_TopBrokenConstraintsQuery, Ttsolve_TopBrokenConstraintsQueryVariables>;
export const Ttsolve_GroupViolationSummaryDocument = new TypedDocumentString(`
    query ttsolve_groupViolationSummary($filter: TtSolve_GroupViolationSummaryFilter!) {
  ttsolve_groupViolationSummary(filter: $filter) {
    timetableGroupId
    totalFrequency
    distinctConstraints
    distinctLessonInstances
    dataNote
    topConstraints {
      constraintName
      totalFrequency
      distinctLessonInstances
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_GroupViolationSummaryQuery, Ttsolve_GroupViolationSummaryQueryVariables>;
export const Ttsolve_HotspotLessonsDocument = new TypedDocumentString(`
    query ttsolve_hotspotLessons($filter: TtSolve_HotspotLessonsFilter!) {
  ttsolve_hotspotLessons(filter: $filter) {
    totalLessons
    dataNote
    entries {
      timetableGroupId
      subjectGroupName
      lessonIdx
      lessonInstanceIdx
      totalFrequency
      distinctConstraints
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_HotspotLessonsQuery, Ttsolve_HotspotLessonsQueryVariables>;
export const Ttsolve_TeacherViolationSummaryDocument = new TypedDocumentString(`
    query ttsolve_teacherViolationSummary($filter: TtSolve_TeacherViolationSummaryFilter!) {
  ttsolve_teacherViolationSummary(filter: $filter) {
    staffPartyId
    totalFrequency
    distinctConstraints
    distinctLessonInstances
    distinctSubjectGroups
    dataNote
    topConstraints {
      constraintName
      totalFrequency
      distinctLessonInstances
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_TeacherViolationSummaryQuery, Ttsolve_TeacherViolationSummaryQueryVariables>;
export const Ttsolve_ConstraintEdgesDocument = new TypedDocumentString(`
    query ttsolve_constraintEdges($filter: TtSolve_ConstraintEdgesFilter!) {
  ttsolve_constraintEdges(filter: $filter) {
    entityAxis
    minWeight
    topConstraintsRequested
    topEntitiesRequested
    dataNote
    edges {
      constraint
      entityId
      entityLabel
      weight
    }
    constraintTotals {
      id
      label
      total
    }
    entityTotals {
      id
      label
      total
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ConstraintEdgesQuery, Ttsolve_ConstraintEdgesQueryVariables>;
export const Ttsolve_SolveRunsDocument = new TypedDocumentString(`
    query ttsolve_solveRuns($filter: TtSolve_SolveRunsFilter!) {
  ttsolve_solveRuns(filter: $filter) {
    solveRunId
    rowCount
    isLatest
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_SolveRunsQuery, Ttsolve_SolveRunsQueryVariables>;
export const Ttsolve_ConstraintCellLessonsDocument = new TypedDocumentString(`
    query ttsolve_constraintCellLessons($filter: TtSolve_ConstraintCellLessonsFilter!) {
  ttsolve_constraintCellLessons(filter: $filter) {
    totalFrequency
    distinctLessons
    dataNote
    entries {
      timetableGroupId
      subjectGroupName
      lessonIdx
      lessonInstanceIdx
      frequency
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ConstraintCellLessonsQuery, Ttsolve_ConstraintCellLessonsQueryVariables>;
export const Ttsolve_ExplainSpreadConflictDocument = new TypedDocumentString(`
    query ttsolve_explainSpreadConflict($filter: TtSolve_SpreadConflictFilter!) {
  ttsolve_explainSpreadConflict(filter: $filter) {
    resolution {
      resolved
      matchedName
      timetableGroupId
      message
    }
    subjectGroup {
      timetableGroupId
      name
      lessonCount
      spread
      blockId
      classGroupId
    }
    tightSpread {
      pattern
      daysNeeded
      daysAvailable
      rawReasons
      structuredReasons {
        kind
        original
        detail
      }
    }
    assignedTeachers {
      staffPartyId
      name
    }
    unknowns
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_ExplainSpreadConflictQuery, Ttsolve_ExplainSpreadConflictQueryVariables>;
export const Ttsolve_TeacherLoadBreakdownDocument = new TypedDocumentString(`
    query ttsolve_teacherLoadBreakdown($filter: TtSolve_TeacherLoadFilter!) {
  ttsolve_teacherLoadBreakdown(filter: $filter) {
    teacher {
      staffPartyId
      name
      weeklyAllowanceMinutes
      requiredMinutes
      load
    }
    lessonGroups {
      timetableGroupId
      subjectGroupName
      subjectId
      subjectName
      lessonCount
      minutesPerLesson
      totalMinutes
      role
      blockName
      alternativeStaffPartyIds
    }
    suggestions {
      timetableGroupId
      subjectGroupName
      candidateStaffPartyId
      candidateName
      candidateCurrentLoad
      candidateSpareMinutes
      shiftableLessons
      competencyPreference
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_TeacherLoadBreakdownQuery, Ttsolve_TeacherLoadBreakdownQueryVariables>;
export const Tyrone_PromptDocument = new TypedDocumentString(`
    query tyrone_prompt($filter: Tyrone_Prompt!) {
  tyrone_prompt(filter: $filter) {
    conversationId
    result
  }
}
    `) as unknown as TypedDocumentString<Tyrone_PromptQuery, Tyrone_PromptQueryVariables>;
export const Tt_UpdateLessonsDocument = new TypedDocumentString(`
    mutation tt_updateLessons($input: Tt_UpdateLessons!) {
  tt_updateLessons(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_UpdateLessonsMutation, Tt_UpdateLessonsMutationVariables>;
export const Ttsolve_GetSolverInputDocument = new TypedDocumentString(`
    query ttsolve_getSolverInput($filter: TtSolve_SolveParams!) {
  ttsolve_getSolverInput(filter: $filter) {
    input
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_GetSolverInputQuery, Ttsolve_GetSolverInputQueryVariables>;
export const Ttsolve_StatusDocument = new TypedDocumentString(`
    query ttsolve_status($filter: TtSolve_SolveParams!) {
  ttsolve_status(filter: $filter) {
    score
    stats {
      lessonsTotal
      lessonsScheduled
      lessonsWithRoom
      lessonsWithTeacher
      spreadsExpected
      spreadsAchieved
      spreadsMissed
    }
    solverStatus
    groupTagStats {
      groupTagId
      stats {
        lessonsTotal
        lessonsScheduled
        lessonsWithRoom
        lessonsWithTeacher
      }
    }
    solverRunType
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_StatusQuery, Ttsolve_StatusQueryVariables>;
export const Ttsolve_SolveDocument = new TypedDocumentString(`
    mutation ttsolve_solve($input: TtSolve_RunSolverParams) {
  ttsolve_solve(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_SolveMutation, Ttsolve_SolveMutationVariables>;
export const Ttsolve_CompetenciesMetaDocument = new TypedDocumentString(`
    query ttsolve_competenciesMeta {
  ttsolve_competenciesMeta {
    groups {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_CompetenciesMetaQuery, Ttsolve_CompetenciesMetaQueryVariables>;
export const Ttsolve_SubjectCompetenciesDocument = new TypedDocumentString(`
    query ttsolve_subjectCompetencies($filter: TtSolve_SubjectCompetenciesFilter!) {
  ttsolve_subjectCompetencies(filter: $filter) {
    groups {
      groupId
      subjects {
        subjectId
        subject {
          id
          nationalCode
          name
        }
        preference1Staff {
          partyId
          person {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
          displayCode
        }
        preference2Staff {
          partyId
          person {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
          displayCode
        }
        preference3Staff {
          partyId
          person {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
          displayCode
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_SubjectCompetenciesQuery, Ttsolve_SubjectCompetenciesQueryVariables>;
export const Tt_SubjectGroupRolloverViewDocument = new TypedDocumentString(`
    query tt_subjectGroupRolloverView($filter: TT_SubjectGroupRolloverViewFilter!) {
  tt_subjectGroupRolloverView(filter: $filter) {
    currentTimetableId
    previousTimetableId
    previousAcademicNamespaceId
    currentGroups {
      timetableGroupId
      partyId
      name
      groupTagIds
      subjectId
      subject {
        id
        name
        colour
      }
      teachers {
        person {
          partyId
          firstName
          lastName
          avatarUrl
        }
      }
      source {
        source
        id
      }
    }
    previousGroups {
      timetableGroupId
      partyId
      name
      groupTagIds
      subjectId
      subject {
        id
        name
        colour
      }
      teachers {
        person {
          partyId
          firstName
          lastName
          avatarUrl
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_SubjectGroupRolloverViewQuery, Tt_SubjectGroupRolloverViewQueryVariables>;
export const Tt_TeacherAssignmentsStatsDocument = new TypedDocumentString(`
    query tt_teacherAssignmentsStats($filter: Tt_TeacherAssignmentFilter!) {
  tt_teacherAssignments(filter: $filter) {
    assignments {
      staffId
      maxLoadMinutes
      currentLoadMinutes
      lessonsAssigned
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_TeacherAssignmentsStatsQuery, Tt_TeacherAssignmentsStatsQueryVariables>;
export const Tt_TeacherAssignmentsDocument = new TypedDocumentString(`
    query tt_teacherAssignments($filter: Tt_TeacherAssignmentFilter!) {
  tt_teacherAssignments(filter: $filter) {
    solverStatus {
      solverStatus
      score
    }
    stats {
      teacherCountTotal
      teachersOverAllocatedCount
      teachersFullyAllocatedCount
      teachersUnderAllocatedCount
      mainstreamCount
      mainstreamTeachersAssignedCount
      mainstreamTeachersUnassignedCount
      freeformCount
      freeformTeachersAssignedCount
      freeformTeachersUnassignedCount
    }
    assignments {
      staffId
      staff {
        person {
          partyId
          title {
            id
            nameTextId
            name
          }
          firstName
          lastName
          avatarUrl
          type
        }
        displayCode
      }
      maxLoadMinutes
      currentLoadMinutes
      lessonsAssigned
      mainstream {
        lessonsAssigned
        lessonsTotal
        splitIndicator
        isMultipleOTeachersOnLesson
        group {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          subject {
            id
            name
            colour
            nationalCode
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
            pools {
              id
              name
            }
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              name
              dayOfWeek
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
              pools {
                id
                name
              }
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
      freeform {
        lessonsAssigned
        lessonsTotal
        splitIndicator
        isMultipleOTeachersOnLesson
        group {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          subject {
            id
            name
            colour
            nationalCode
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
            pools {
              id
              name
            }
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              name
              dayOfWeek
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
              pools {
                id
                name
              }
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
      nonTeaching {
        lessonsAssigned
        lessonsTotal
        splitIndicator
        isMultipleOTeachersOnLesson
        group {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          subject {
            id
            name
            colour
            nationalCode
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
            pools {
              id
              name
            }
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              name
              dayOfWeek
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
              pools {
                id
                name
              }
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
    }
    unassigned {
      maxLoadMinutes
      currentLoadMinutes
      lessonsAssigned
      mainstream {
        lessonsAssigned
        lessonsTotal
        splitIndicator
        isMultipleOTeachersOnLesson
        group {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          subject {
            id
            name
            colour
            nationalCode
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
            pools {
              id
              name
            }
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              name
              dayOfWeek
            }
            timeslotInfo {
              dayOfWeek
              startTime
              endTime
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
              pools {
                id
                name
              }
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
      freeform {
        lessonsAssigned
        lessonsTotal
        splitIndicator
        isMultipleOTeachersOnLesson
        group {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          subject {
            id
            name
            colour
            nationalCode
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
            pools {
              id
              name
            }
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              name
              dayOfWeek
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
              pools {
                id
                name
              }
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
      nonTeaching {
        lessonsAssigned
        lessonsTotal
        splitIndicator
        isMultipleOTeachersOnLesson
        group {
          timetableGroupId
          name
          teachers {
            person {
              partyId
              title {
                id
                nameTextId
                name
              }
              firstName
              lastName
              avatarUrl
              type
              archived
            }
            displayCode
          }
          subject {
            id
            name
            colour
            nationalCode
          }
          groupType
          studentMembershipType
          groupTagIds
          spread
          lessonCount
          blockIdx
          blockId
          classGroupId
          room {
            roomId
            name
            pools {
              id
              name
            }
          }
          roomPool {
            id
            name
          }
          lessons {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              name
              dayOfWeek
            }
            teachers {
              person {
                partyId
                title {
                  id
                  nameTextId
                  name
                }
                firstName
                lastName
                avatarUrl
                type
                archived
              }
            }
            room {
              roomId
              name
              pools {
                id
                name
              }
            }
            roomPool {
              id
              name
            }
            spread
          }
          maxClassSize
          coScheduleTtGroup {
            timetableGroupId
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_TeacherAssignmentsQuery, Tt_TeacherAssignmentsQueryVariables>;
export const Ttsolve_SubjectCompetenciesCondensedDocument = new TypedDocumentString(`
    query ttsolve_subjectCompetenciesCondensed($filter: TtSolve_SubjectCompetenciesFilter!) {
  ttsolve_subjectCompetenciesCondensed(filter: $filter) {
    staff {
      staffId
      subjects {
        id
        name
        colour
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_SubjectCompetenciesCondensedQuery, Ttsolve_SubjectCompetenciesCondensedQueryVariables>;
export const Ttsolve_SolverSwappedTeachersDocument = new TypedDocumentString(`
    query ttsolve_solverSwappedTeachers($filter: TTTimetableFilter!) {
  ttsolve_solverSwappedTeachers(filter: $filter) {
    originalTeacher {
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      displayCode
    }
    swappedTeacher {
      person {
        partyId
        firstName
        lastName
        avatarUrl
        type
        title {
          id
          name
          nameTextId
        }
      }
      displayCode
    }
    group {
      timetableGroupId
      name
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_SolverSwappedTeachersQuery, Ttsolve_SolverSwappedTeachersQueryVariables>;
export const Ttsolve_SolverSwappedTeacherAcceptRejectDocument = new TypedDocumentString(`
    mutation ttsolve_solverSwappedTeacherAcceptReject($input: TtSolve_SolverSwappedTeachersAccept!) {
  ttsolve_solverSwappedTeacherAcceptReject(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_SolverSwappedTeacherAcceptRejectMutation, Ttsolve_SolverSwappedTeacherAcceptRejectMutationVariables>;
export const Tt_DiffDocument = new TypedDocumentString(`
    query tt_diff($filter: Tt_DiffFilter) {
  tt_diff(filter: $filter) {
    sourceTimetableId
    compareToTimetableId
    totalChanges
    lessonChanges
    timetableGroupChanges
    lessonDiffs {
      newLesson {
        id {
          lessonIdx
          lessonInstanceIdx
          timetableGroupId
        }
        timeslotId {
          gridIdx
          dayIdx
          periodIdx
        }
        timeslotInfo {
          startTime
          endTime
          dayOfWeek
          name
        }
        timetableGroup {
          __typename
          timetableGroupId
          name
          subject {
            name
            colour
          }
        }
        room {
          roomId
          name
        }
        teachers {
          person {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
        }
        spread
      }
      oldLesson {
        id {
          lessonIdx
          lessonInstanceIdx
          timetableGroupId
        }
        timeslotId {
          gridIdx
          dayIdx
          periodIdx
        }
        timeslotInfo {
          startTime
          endTime
          dayOfWeek
          name
        }
        timetableGroup {
          __typename
          timetableGroupId
          name
          subject {
            name
            colour
          }
        }
        room {
          roomId
          name
        }
        teachers {
          person {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
        }
        spread
      }
      type
      roomChanged
      teachersChanged
      timeslotChanged
    }
    groupDiffs {
      newGroup {
        __typename
        timetableGroupId
        name
        subject {
          name
          colour
        }
        groupType
        studentMembershipType
        blockId
        classGroupId
        groupTag {
          id
          name
        }
        teachers {
          person {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
        }
      }
      oldGroup {
        __typename
        timetableGroupId
        name
        subject {
          name
          colour
        }
        groupType
        studentMembershipType
        blockId
        classGroupId
        groupTag {
          id
          name
        }
        teachers {
          person {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
        }
      }
      type
      teachersChanged
      nameChanged
      subjectChanged
      groupTypeChanged
      studentMembershipTypeChanged
      blockIdChanged
      classGroupIdChanged
      tagsChanged
    }
    blockDiffs {
      newGroup {
        blockId
        name
        shortName
        ttClassGroupIds
      }
      oldGroup {
        blockId
        name
        shortName
        ttClassGroupIds
      }
      type
      nameChanged
      classGroupsChanged
    }
    classGroupDiffs {
      newGroup {
        ttClassGroupId
        name
        code
      }
      oldGroup {
        ttClassGroupId
        name
        code
      }
      type
      nameChanged
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_DiffQuery, Tt_DiffQueryVariables>;
export const Ttsolve_UpsertRestrictionDocument = new TypedDocumentString(`
    mutation ttsolve_upsertRestriction($input: TtSolve_UpsertRestrictions!) {
  ttsolve_upsertRestriction(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_UpsertRestrictionMutation, Ttsolve_UpsertRestrictionMutationVariables>;
export const Ttsolve_UpdateSubjectCompetenciesDocument = new TypedDocumentString(`
    mutation ttsolve_updateSubjectCompetencies($input: TtSolve_UpdateSubjectCompetenciesInput!) {
  ttsolve_updateSubjectCompetencies(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_UpdateSubjectCompetenciesMutation, Ttsolve_UpdateSubjectCompetenciesMutationVariables>;
export const Ttvalidation_ValidateDocument = new TypedDocumentString(`
    query ttvalidation_validate($filter: TtValidation_Filter!) {
  ttvalidation_validate(filter: $filter) {
    validations {
      id
      rootMessage
      validationLevel
      validationName
      catalogueKey
      stopsSolver
      actions {
        label
        ... on Tt_SwapRoomAction {
          __typename
          type
          lessonIds {
            lessonIdx
            lessonInstanceIdx
            timetableGroupId
          }
        }
        ... on Tt_SwapTeacherAction {
          __typename
          type
          lessonIds {
            lessonIdx
            lessonInstanceIdx
            timetableGroupId
          }
        }
        ... on Tt_AcceptRejectSolverSwappedTeacher {
          __typename
          type
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Ttvalidation_ValidateQuery, Ttvalidation_ValidateQueryVariables>;
export const Tt_AddLessonDocument = new TypedDocumentString(`
    mutation tt_addLesson($input: Tt_AddLessonInput) {
  tt_addLesson(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_AddLessonMutation, Tt_AddLessonMutationVariables>;
export const Tt_AddLessonOptionsDocument = new TypedDocumentString(`
    query tt_addLessonOptions($filter: Tt_AddLessonFilter) {
  tt_addLessonOptions(filter: $filter) {
    freeStaff {
      person {
        partyId
        title {
          id
          nameTextId
          name
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    freeTimetableGroups {
      timetableGroupId
      name
    }
    freeRooms {
      roomId
      name
      capacity
      description
      pools {
        id
        name
        description
        colour
      }
      includeInTimetable
      externalSystemId
      location
      disabled
    }
    clashingStaff {
      staff {
        partyId
        person {
          partyId
          title {
            id
            nameTextId
            name
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
      clashes {
        id {
          lessonIdx
          lessonInstanceIdx
          timetableGroupId
        }
        timeslotId {
          gridIdx
          dayIdx
          periodIdx
        }
        timeslotInfo {
          dayOfWeek
          startTime
          endTime
          name
        }
        timetableGroup {
          name
        }
      }
    }
    clashingGroups {
      group {
        timetableGroupId
        name
      }
      clashes {
        id {
          lessonIdx
          lessonInstanceIdx
          timetableGroupId
        }
        timeslotId {
          gridIdx
          dayIdx
          periodIdx
        }
        timeslotInfo {
          dayOfWeek
          startTime
          endTime
          name
        }
        timetableGroup {
          name
        }
      }
    }
    clashingRooms {
      room {
        roomId
        name
        capacity
        description
        pools {
          id
          name
          description
          colour
        }
        includeInTimetable
        externalSystemId
        location
        disabled
      }
      clashes {
        id {
          lessonIdx
          lessonInstanceIdx
          timetableGroupId
        }
        timeslotId {
          gridIdx
          dayIdx
          periodIdx
        }
        timeslotInfo {
          dayOfWeek
          startTime
          endTime
          name
        }
        timetableGroup {
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_AddLessonOptionsQuery, Tt_AddLessonOptionsQueryVariables>;
export const Tt_SwapTeacherOptionsDocument = new TypedDocumentString(`
    query tt_swapTeacherOptions($filter: TTSwapTeacherFilter!) {
  tt_swapTeacherOptions(filter: $filter) {
    timeslots {
      id {
        gridIdx
        dayIdx
        periodIdx
      }
      info {
        dayOfWeek
        startTime
        endTime
      }
    }
    teachers {
      staffId
      teacher {
        person {
          partyId
          title {
            id
            nameTextId
            name
          }
          firstName
          lastName
          avatarUrl
          type
        }
        displayCode
      }
      lessonOnTimeslots {
        lessons {
          id {
            lessonIdx
            lessonInstanceIdx
            timetableGroupId
          }
          timetableGroup {
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_SwapTeacherOptionsQuery, Tt_SwapTeacherOptionsQueryVariables>;
export const Tt_SwapRoomOptionsDocument = new TypedDocumentString(`
    query tt_swapRoomOptions($filter: TTSwapRoomFilter!) {
  tt_swapRoomOptions(filter: $filter) {
    timeslots {
      id {
        gridIdx
        dayIdx
        periodIdx
      }
      info {
        dayOfWeek
        startTime
        endTime
      }
    }
    rooms {
      roomId
      room {
        name
        capacity
        description
        pools {
          id
          name
          description
          colour
        }
      }
      lessonOnTimeslots {
        lessons {
          id {
            lessonIdx
            lessonInstanceIdx
            timetableGroupId
          }
          timetableGroup {
            name
          }
          teachers {
            person {
              partyId
              title {
                id
                name
                nameTextId
              }
              firstName
              lastName
              avatarUrl
              type
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_SwapRoomOptionsQuery, Tt_SwapRoomOptionsQueryVariables>;
export const Tt_RemoveLessonDocument = new TypedDocumentString(`
    mutation tt_removeLesson($input: [Tt_RemoveLessonInput!]) {
  tt_removeLesson(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_RemoveLessonMutation, Tt_RemoveLessonMutationVariables>;
export const Tt_EditLessonOptionsDocument = new TypedDocumentString(`
    query tt_editLessonOptions($filter: Tt_EditLessonFilter) {
  tt_editLessonOptions(filter: $filter) {
    lessonId {
      lessonIdx
      lessonInstanceIdx
      timetableGroupId
    }
    freeStaff {
      partyId
      person {
        partyId
        title {
          id
          nameTextId
          name
        }
        firstName
        lastName
        avatarUrl
        type
      }
    }
    freeRooms {
      roomId
      name
      capacity
      description
      pools {
        id
        name
        description
        colour
      }
      includeInTimetable
      externalSystemId
      location
      disabled
    }
    clashingStaff {
      staff {
        partyId
        person {
          partyId
          title {
            id
            nameTextId
            name
          }
          firstName
          lastName
          avatarUrl
          type
        }
      }
      clashes {
        id {
          lessonIdx
          lessonInstanceIdx
          timetableGroupId
        }
        timeslotId {
          gridIdx
          dayIdx
          periodIdx
        }
        timeslotInfo {
          dayOfWeek
          startTime
          endTime
          name
        }
        timetableGroup {
          name
        }
      }
    }
    clashingRooms {
      room {
        roomId
        name
        capacity
        description
        pools {
          id
          name
          description
          colour
        }
        includeInTimetable
        externalSystemId
        location
        disabled
      }
      clashes {
        id {
          lessonIdx
          lessonInstanceIdx
          timetableGroupId
        }
        timeslotId {
          gridIdx
          dayIdx
          periodIdx
        }
        timeslotInfo {
          dayOfWeek
          startTime
          endTime
          name
        }
        timetableGroup {
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_EditLessonOptionsQuery, Tt_EditLessonOptionsQueryVariables>;
export const Tt_LookupCoreGroupsNotInTimetableDocument = new TypedDocumentString(`
    query tt_lookupCoreGroupsNotInTimetable($filter: TTTimetableFilter) {
  tt_lookupCoreGroupsNotInTimetable(filter: $filter) {
    partyId
    name
    avatarUrl
  }
}
    `) as unknown as TypedDocumentString<Tt_LookupCoreGroupsNotInTimetableQuery, Tt_LookupCoreGroupsNotInTimetableQueryVariables>;
export const Tt_ImportGroupsFromCoreDocument = new TypedDocumentString(`
    mutation tt_importGroupsFromCore($input: Tt_ImportGroupsFromCore!) {
  tt_importGroupsFromCore(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_ImportGroupsFromCoreMutation, Tt_ImportGroupsFromCoreMutationVariables>;
export const Tt_PublishDocument = new TypedDocumentString(`
    mutation tt_publish($input: TTPublishTimetableInput!) {
  tt_publish(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_PublishMutation, Tt_PublishMutationVariables>;
export const Tt_ResetDocument = new TypedDocumentString(`
    mutation tt_reset($input: TT_Reset!) {
  tt_reset(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_ResetMutation, Tt_ResetMutationVariables>;
export const Tt_ResourceTimetableViewDocument = new TypedDocumentString(`
    query tt_resourceTimetableView($filter: TTResourceTimetableViewFilter!) {
  tt_resourceTimetableView(filter: $filter) {
    timeslots {
      timeslotIds {
        gridIdx
        dayIdx
        periodIdx
      }
      timeslots {
        dayOfWeek
        startTime
        endTime
        periodType
        name
      }
      lessons {
        id {
          lessonIdx
          lessonInstanceIdx
          timetableGroupId
        }
        timeslotId {
          gridIdx
          dayIdx
          periodIdx
        }
        timeslotInfo {
          startTime
          endTime
          dayOfWeek
          name
        }
        timetableGroup {
          __typename
          timetableGroupId
          name
          subject {
            name
            colour
          }
          groupTag {
            id
            type
            name
          }
        }
        room {
          roomId
          name
        }
        teachers {
          person {
            partyId
            title {
              id
              name
              nameTextId
            }
            firstName
            lastName
            avatarUrl
            type
          }
        }
        spread
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_ResourceTimetableViewQuery, Tt_ResourceTimetableViewQueryVariables>;
export const Tt_UnpublishedChangesDocument = new TypedDocumentString(`
    query tt_unpublishedChanges($filter: TTTimetableFilter) {
  tt_timetable(filter: $filter) {
    timetableId
    liveStatus {
      totalChanges
      publishDiff {
        lessonDiffs {
          newLesson {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              dayOfWeek
              name
            }
            timetableGroup {
              __typename
              timetableGroupId
              name
              subject {
                name
                colour
              }
            }
            room {
              roomId
              name
            }
            teachers {
              person {
                partyId
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
                type
              }
            }
            spread
          }
          oldLesson {
            id {
              lessonIdx
              lessonInstanceIdx
              timetableGroupId
            }
            timeslotId {
              gridIdx
              dayIdx
              periodIdx
            }
            timeslotInfo {
              startTime
              endTime
              dayOfWeek
              name
            }
            timetableGroup {
              __typename
              timetableGroupId
              name
              subject {
                name
                colour
              }
            }
            room {
              roomId
              name
            }
            teachers {
              person {
                partyId
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
                type
              }
            }
            spread
          }
          type
          roomChanged
          teachersChanged
          timeslotChanged
        }
        groupDiffs {
          newGroup {
            __typename
            timetableGroupId
            name
            subject {
              name
              colour
            }
            groupType
            studentMembershipType
            blockId
            classGroupId
            groupTag {
              id
              name
            }
            teachers {
              person {
                partyId
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
                type
              }
            }
          }
          oldGroup {
            __typename
            timetableGroupId
            name
            subject {
              name
              colour
            }
            groupType
            studentMembershipType
            blockId
            classGroupId
            groupTag {
              id
              name
            }
            teachers {
              person {
                partyId
                title {
                  id
                  name
                  nameTextId
                }
                firstName
                lastName
                avatarUrl
                type
              }
            }
          }
          type
          teachersChanged
          nameChanged
          subjectChanged
          groupTypeChanged
          studentMembershipTypeChanged
          blockIdChanged
          classGroupIdChanged
          tagsChanged
        }
        blockDiffs {
          newGroup {
            blockId
            name
            shortName
            ttClassGroupIds
          }
          oldGroup {
            blockId
            name
            shortName
            ttClassGroupIds
          }
          type
          nameChanged
          classGroupsChanged
        }
        classGroupDiffs {
          newGroup {
            ttClassGroupId
            name
            code
          }
          oldGroup {
            ttClassGroupId
            name
            code
          }
          type
          nameChanged
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_UnpublishedChangesQuery, Tt_UnpublishedChangesQueryVariables>;
export const Tt_UpdateClassGroupDocument = new TypedDocumentString(`
    mutation tt_updateClassGroup($input: TT_UpdateClassGroupInput!) {
  tt_updateClassGroup(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_UpdateClassGroupMutation, Tt_UpdateClassGroupMutationVariables>;
export const Tt_UpdateTimetableGroupDocument = new TypedDocumentString(`
    mutation tt_updateTimetableGroup($input: TT_UpdateTimetableGroupInput!) {
  tt_updateTimetableGroup(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_UpdateTimetableGroupMutation, Tt_UpdateTimetableGroupMutationVariables>;
export const Tt_UpsertCoScheduleChainsDocument = new TypedDocumentString(`
    mutation tt_upsertCoScheduleChains($input: TT_UpsertCoScheduleChainsInput!) {
  tt_upsertCoScheduleChains(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_UpsertCoScheduleChainsMutation, Tt_UpsertCoScheduleChainsMutationVariables>;
export const Tt_OnCallSetBlankDocument = new TypedDocumentString(`
    mutation tt_onCallSetBlank($input: TTTimetableFilter!) {
  tt_onCallSetBlank(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_OnCallSetBlankMutation, Tt_OnCallSetBlankMutationVariables>;
export const Tt_InfoReqRunsolverDocument = new TypedDocumentString(`
    mutation tt_infoReqRunsolver($input: TtRunOnCallSolverParams!) {
  tt_infoReqRunsolver(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tt_InfoReqRunsolverMutation, Tt_InfoReqRunsolverMutationVariables>;
export const Ttsolve_SolverCatalogDocument = new TypedDocumentString(`
    query ttsolve_solverCatalog {
  ttsolve_solverCatalog {
    version
    constraints {
      solverName
      key
      hardness
      category
      drivesDifficulty
      humanName
      description
      ruleId
      makesInfeasible
      stopsSolver
      hidden
      resolutions {
        action
        appliesTo
        detail
        likelihood
      }
    }
    messages {
      key
      constraintKey
      defaultMessage
      severity
      description
      type
      makesInfeasible
      stopsSolver
      hidden
      resolutions {
        action
        appliesTo
        detail
        likelihood
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_SolverCatalogQuery, Ttsolve_SolverCatalogQueryVariables>;
export const Ttsolve_UpsertCatalogueOverrideDocument = new TypedDocumentString(`
    mutation ttsolve_upsertCatalogueOverride($input: TtSolve_UpsertCatalogueOverride!) {
  ttsolve_upsertCatalogueOverride(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_UpsertCatalogueOverrideMutation, Ttsolve_UpsertCatalogueOverrideMutationVariables>;
export const Ttsolve_DeleteCatalogueOverrideDocument = new TypedDocumentString(`
    mutation ttsolve_deleteCatalogueOverride($input: TtSolve_DeleteCatalogueOverride!) {
  ttsolve_deleteCatalogueOverride(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_DeleteCatalogueOverrideMutation, Ttsolve_DeleteCatalogueOverrideMutationVariables>;
export const TimetableSearchQueryDocument = new TypedDocumentString(`
    query timetableSearchQuery($filter: TT_SearchFilter!) {
  tt_search(filter: $filter) {
    partyId
    type
    text
    avatarUrl
  }
}
    `) as unknown as TypedDocumentString<TimetableSearchQueryQuery, TimetableSearchQueryQueryVariables>;
export const Tt_EditLessonInstanceDocument = new TypedDocumentString(`
    mutation tt_editLessonInstance($input: TTEditLessonPeriodInstanceWrapper!) {
  tt_editLessonInstance(input: $input) {
    id {
      lessonIdx
      lessonInstanceIdx
      timetableGroupId
    }
  }
}
    `) as unknown as TypedDocumentString<Tt_EditLessonInstanceMutation, Tt_EditLessonInstanceMutationVariables>;
export const Users_Admin__AddUserToTenantDocument = new TypedDocumentString(`
    mutation users_admin__addUserToTenant($input: Users_Admin_AddUserToTenantInput!) {
  users_admin__addUserToTenant(input: $input) {
    account {
      tenant
      tenantName
      partyId
      firstName
      lastName
      type
      avatarUrl
      primaryEmail {
        email
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Users_Admin__AddUserToTenantMutation, Users_Admin__AddUserToTenantMutationVariables>;
export const Ttsolve_CancelSolveDocument = new TypedDocumentString(`
    mutation ttsolve_cancelSolve($input: TtSolve_CancelSolveInput!) {
  ttsolve_cancelSolve(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_CancelSolveMutation, Ttsolve_CancelSolveMutationVariables>;
export const Users_Admin__ClearPreAuthCacheDocument = new TypedDocumentString(`
    mutation users_admin__clearPreAuthCache($emails: [String!]!) {
  users_admin__clearPreAuthCache(emails: $emails) {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_Admin__ClearPreAuthCacheMutation, Users_Admin__ClearPreAuthCacheMutationVariables>;
export const ImportVsware2_DeleteSchoolIdentifierDocument = new TypedDocumentString(`
    mutation importVsware2_deleteSchoolIdentifier($input: ImportVsware2_DeleteSchoolIdentifierInput!) {
  importVsware2_deleteSchoolIdentifier(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<ImportVsware2_DeleteSchoolIdentifierMutation, ImportVsware2_DeleteSchoolIdentifierMutationVariables>;
export const ImportVsware2_UpsertSchoolIdentifierDocument = new TypedDocumentString(`
    mutation importVsware2_upsertSchoolIdentifier($input: ImportVsware2_UpsertSchoolIdentifierInput!) {
  importVsware2_upsertSchoolIdentifier(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<ImportVsware2_UpsertSchoolIdentifierMutation, ImportVsware2_UpsertSchoolIdentifierMutationVariables>;
export const ImportVsware_ImportsDocument = new TypedDocumentString(`
    query importVsware_imports($filter: ImportVsware_Filter) {
  importVsware_imports(filter: $filter) {
    data {
      id
      startedOn
      tenant
      fileName
    }
    totalCount
  }
}
    `) as unknown as TypedDocumentString<ImportVsware_ImportsQuery, ImportVsware_ImportsQueryVariables>;
export const ImportVsware2_ImportsDocument = new TypedDocumentString(`
    query importVsware2_imports($filter: ImportVsware2_Filter) {
  importVsware2_imports(filter: $filter) {
    data {
      id
      startedOn
      tenant
      fileName
    }
    totalCount
  }
}
    `) as unknown as TypedDocumentString<ImportVsware2_ImportsQuery, ImportVsware2_ImportsQueryVariables>;
export const ImportVsware2_SchoolIdentifiersDocument = new TypedDocumentString(`
    query importVsware2_schoolIdentifiers {
  importVsware2_schoolIdentifiers {
    vsIdentifier
    name
    tenant
  }
}
    `) as unknown as TypedDocumentString<ImportVsware2_SchoolIdentifiersQuery, ImportVsware2_SchoolIdentifiersQueryVariables>;
export const Users_Admin__DefaultPermissionsDocument = new TypedDocumentString(`
    query users_admin__defaultPermissions {
  users_admin__defaultPermissions {
    id
    group
    permissionSetId
    permissionType
  }
}
    `) as unknown as TypedDocumentString<Users_Admin__DefaultPermissionsQuery, Users_Admin__DefaultPermissionsQueryVariables>;
export const Ttsolve_DefaultSolverConfigurationDocument = new TypedDocumentString(`
    query ttsolve_defaultSolverConfiguration {
  ttsolve_defaultSolverConfiguration {
    parallelSolvers
    useIncremental
    minutesSpentlimit
    unimprovedMinutesSpentlimit
    weightings {
      id
      label
      weighting
    }
    globalConstraints {
      id
      label
      isDiamond
      weighting
      isAdvanced
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_DefaultSolverConfigurationQuery, Ttsolve_DefaultSolverConfigurationQueryVariables>;
export const Ttsolve_UpdateDefaultSolverConfigurationDocument = new TypedDocumentString(`
    mutation ttsolve_updateDefaultSolverConfiguration($input: TTSolve_SolverConfiguration!) {
  ttsolve_updateDefaultSolverConfiguration(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_UpdateDefaultSolverConfigurationMutation, Ttsolve_UpdateDefaultSolverConfigurationMutationVariables>;
export const Users_Admin__DeleteDefaultPermissionDocument = new TypedDocumentString(`
    mutation users_admin__deleteDefaultPermission($input: Users_DeleteDefaultPermission!) {
  users_admin__deleteDefaultPermission(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_Admin__DeleteDefaultPermissionMutation, Users_Admin__DeleteDefaultPermissionMutationVariables>;
export const Users_MergeDuplicateUserProfilesDocument = new TypedDocumentString(`
    mutation users_mergeDuplicateUserProfiles($input: MergeDuplicateProfilesInput) {
  users_mergeDuplicateUserProfiles(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_MergeDuplicateUserProfilesMutation, Users_MergeDuplicateUserProfilesMutationVariables>;
export const Users_MergeUserProfilesDocument = new TypedDocumentString(`
    mutation users_mergeUserProfiles($input: MergeUserProfiles) {
  users_mergeUserProfiles(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_MergeUserProfilesMutation, Users_MergeUserProfilesMutationVariables>;
export const Users_Admin__Party_PeopleDocument = new TypedDocumentString(`
    query users_admin__party_people($tenant: Int!) {
  users_admin__party_people(tenant: $tenant) {
    account {
      tenant
      tenantName
      partyId
      firstName
      lastName
      type
      avatarUrl
      primaryEmail {
        email
      }
    }
    otherAccounts {
      tenant
      tenantName
      partyId
      firstName
      lastName
      type
      avatarUrl
      primaryEmail {
        email
      }
    }
  }
}
    `) as unknown as TypedDocumentString<Users_Admin__Party_PeopleQuery, Users_Admin__Party_PeopleQueryVariables>;
export const Users_Admin__PermissionGroupsForTenantDocument = new TypedDocumentString(`
    query users_admin__permissionGroupsForTenant($tenant: Int!) {
  users_admin__permissionGroupsForTenant(tenant: $tenant) {
    id
    name
    description
    memberType
    custom
  }
}
    `) as unknown as TypedDocumentString<Users_Admin__PermissionGroupsForTenantQuery, Users_Admin__PermissionGroupsForTenantQueryVariables>;
export const Users_Admin__SaveDefaultPermissionDocument = new TypedDocumentString(`
    mutation users_admin__saveDefaultPermission($input: Users_SaveDefaultPermission!) {
  users_admin__saveDefaultPermission(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<Users_Admin__SaveDefaultPermissionMutation, Users_Admin__SaveDefaultPermissionMutationVariables>;
export const Scheduling_JobHandlersDocument = new TypedDocumentString(`
    query scheduling_jobHandlers {
  scheduling_jobHandlers {
    name
    parameters {
      name
      type
    }
  }
}
    `) as unknown as TypedDocumentString<Scheduling_JobHandlersQuery, Scheduling_JobHandlersQueryVariables>;
export const Scheduling_JobHistoryDocument = new TypedDocumentString(`
    query scheduling_jobHistory($filter: Scheduling_JobHistoryFilter) {
  scheduling_jobHistory(filter: $filter) {
    executionId
    handlerName
    jobType
    status
    parameters
    submittedAt
    startedAt
    finishedAt
    successCount
    failCount
    durationMs
    tenantId
    triggeredBy
  }
}
    `) as unknown as TypedDocumentString<Scheduling_JobHistoryQuery, Scheduling_JobHistoryQueryVariables>;
export const Scheduling_JobExecutionDocument = new TypedDocumentString(`
    query scheduling_jobExecution($filter: Scheduling_JobExecutionFilter!) {
  scheduling_jobExecution(filter: $filter) {
    executionId
    handlerName
    jobType
    status
    parameters
    submittedAt
    startedAt
    finishedAt
    successCount
    failCount
    durationMs
    exceptionClass
    exceptionMessage
    executionCount
    tenantId
    triggeredBy
    workerNode
    retryOfExecutionId
  }
}
    `) as unknown as TypedDocumentString<Scheduling_JobExecutionQuery, Scheduling_JobExecutionQueryVariables>;
export const Scheduling_JobLogEntriesDocument = new TypedDocumentString(`
    query scheduling_jobLogEntries($filter: Scheduling_JobLogEntriesFilter!) {
  scheduling_jobLogEntries(filter: $filter) {
    level
    message
    reference
    timestamp
  }
}
    `) as unknown as TypedDocumentString<Scheduling_JobLogEntriesQuery, Scheduling_JobLogEntriesQueryVariables>;
export const Scheduling_SubmitOneTimeJobDocument = new TypedDocumentString(`
    mutation scheduling_submitOneTimeJob($input: Scheduling_SubmitOneTimeJobInput!) {
  scheduling_submitOneTimeJob(input: $input) {
    executionId
  }
}
    `) as unknown as TypedDocumentString<Scheduling_SubmitOneTimeJobMutation, Scheduling_SubmitOneTimeJobMutationVariables>;
export const Scheduling_SubmitPollingJobDocument = new TypedDocumentString(`
    mutation scheduling_submitPollingJob($input: Scheduling_SubmitPollingJobInput!) {
  scheduling_submitPollingJob(input: $input) {
    executionId
  }
}
    `) as unknown as TypedDocumentString<Scheduling_SubmitPollingJobMutation, Scheduling_SubmitPollingJobMutationVariables>;
export const Scheduling_CancelJobDocument = new TypedDocumentString(`
    mutation scheduling_cancelJob($input: Scheduling_CancelJobInput!) {
  scheduling_cancelJob(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Scheduling_CancelJobMutation, Scheduling_CancelJobMutationVariables>;
export const Scheduling_CronJobsDocument = new TypedDocumentString(`
    query scheduling_cronJobs {
  scheduling_cronJobs {
    jobId
    handlerName
    displayName
    description
    cronExpression
    enabled
    systemTask
    maxConcurrent
  }
}
    `) as unknown as TypedDocumentString<Scheduling_CronJobsQuery, Scheduling_CronJobsQueryVariables>;
export const Scheduling_UpdateCronJobsDocument = new TypedDocumentString(`
    mutation scheduling_updateCronJobs($input: Scheduling_UpdateCronJobsInput!) {
  scheduling_updateCronJobs(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Scheduling_UpdateCronJobsMutation, Scheduling_UpdateCronJobsMutationVariables>;
export const Scheduling_TriggerCronNowDocument = new TypedDocumentString(`
    mutation scheduling_triggerCronNow($input: Scheduling_TriggerCronNowInput!) {
  scheduling_triggerCronNow(input: $input) {
    executionId
  }
}
    `) as unknown as TypedDocumentString<Scheduling_TriggerCronNowMutation, Scheduling_TriggerCronNowMutationVariables>;
export const Scheduling_RetryFailedJobDocument = new TypedDocumentString(`
    mutation scheduling_retryFailedJob($input: Scheduling_RetryFailedJobInput!) {
  scheduling_retryFailedJob(input: $input) {
    executionId
  }
}
    `) as unknown as TypedDocumentString<Scheduling_RetryFailedJobMutation, Scheduling_RetryFailedJobMutationVariables>;
export const Ttsolve_SolverReconcileDocument = new TypedDocumentString(`
    query ttsolve_solverReconcile {
  ttsolve_solverReconcile {
    serverId
    problemId
    timetableId
    presence
    reachable
    solverStatus
    solverScore
    solverDurationSec
    dbStatus
    reservedCpus
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_SolverReconcileQuery, Ttsolve_SolverReconcileQueryVariables>;
export const Ttsolve_SolverServerHealthDocument = new TypedDocumentString(`
    query ttsolve_solverServerHealth {
  ttsolve_solverServerHealth {
    id
    reachable
    message
    latencyMs
    activeProblems
    problems {
      problemId
      problemType
      score
      status
      durationSec
    }
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_SolverServerHealthQuery, Ttsolve_SolverServerHealthQueryVariables>;
export const Ttsolve_SolverServersDocument = new TypedDocumentString(`
    query ttsolve_solverServers($filter: TtSolve_SolverServersFilter!) {
  ttsolve_solverServers(filter: $filter) {
    id
    name
    protocol
    host
    port
    token
    cpus
    permanent
    enabled
    reservedCpus
    freeCpus
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_SolverServersQuery, Ttsolve_SolverServersQueryVariables>;
export const Ttsolve_UpsertSolverServerDocument = new TypedDocumentString(`
    mutation ttsolve_upsertSolverServer($input: TtSolve_UpsertSolverServerInput!) {
  ttsolve_upsertSolverServer(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_UpsertSolverServerMutation, Ttsolve_UpsertSolverServerMutationVariables>;
export const Ttsolve_DeleteSolverServerDocument = new TypedDocumentString(`
    mutation ttsolve_deleteSolverServer($input: TtSolve_DeleteSolverServerInput!) {
  ttsolve_deleteSolverServer(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_DeleteSolverServerMutation, Ttsolve_DeleteSolverServerMutationVariables>;
export const Ttsolve_SolverStateOverviewDocument = new TypedDocumentString(`
    query ttsolve_solverStateOverview {
  ttsolve_solverStateOverview {
    timetableId
    tenant
    academicNamespaceId
    solverType
    status
    solverServerId
    reservedCpus
    restartCount
    stopReason
    score
    problemId
    source
    updatedOn
  }
}
    `) as unknown as TypedDocumentString<Ttsolve_SolverStateOverviewQuery, Ttsolve_SolverStateOverviewQueryVariables>;
export const Composite_TenantSettingsDocument = new TypedDocumentString(`
    query composite_tenantSettings {
  composite_tenantSettings {
    xeroId
    organizationTenant {
      tenant
      name
      description
      imgUrl
      location
      type
      liveSchool
      rollNo
      tenantType
      subTenants
    }
    comregName
    goLiveOn
  }
}
    `) as unknown as TypedDocumentString<Composite_TenantSettingsQuery, Composite_TenantSettingsQueryVariables>;
export const Composite_UpsertTenantSettingsDocument = new TypedDocumentString(`
    mutation composite_upsertTenantSettings($input: UpsertTenantSettingsInput!) {
  composite_upsertTenantSettings(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Composite_UpsertTenantSettingsMutation, Composite_UpsertTenantSettingsMutationVariables>;
export const Admin__TenantsDocument = new TypedDocumentString(`
    query admin__tenants($filter: TenantsFilter) {
  admin__tenants(filter: $filter) {
    tenant
    name
    imgUrl
    liveSchool
    rollNo
    description
    location
    latitude
    longitude
    organizationTenant
  }
}
    `) as unknown as TypedDocumentString<Admin__TenantsQuery, Admin__TenantsQueryVariables>;
export const Users_Admin__UpdateTenantsDocument = new TypedDocumentString(`
    mutation users_admin__updateTenants($input: Users_UpdateTenantsInput!) {
  users_admin__updateTenants(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_Admin__UpdateTenantsMutation, Users_Admin__UpdateTenantsMutationVariables>;
export const Admin__ResetTenantCacheDocument = new TypedDocumentString(`
    mutation admin__resetTenantCache($input: Int) {
  admin__resetTenantCache(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Admin__ResetTenantCacheMutation, Admin__ResetTenantCacheMutationVariables>;
export const Admin__RefreshTenantSearchDocument = new TypedDocumentString(`
    mutation admin__refreshTenantSearch($input: Search_RefreshTenantSearchInput!) {
  admin__refreshTenantSearch(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Admin__RefreshTenantSearchMutation, Admin__RefreshTenantSearchMutationVariables>;
export const Users_Admin__CreateEmptyTenantDocument = new TypedDocumentString(`
    mutation users_admin__createEmptyTenant($input: Users_CreateEmptyTenantInput!) {
  users_admin__createEmptyTenant(input: $input) {
    tenant
    name
  }
}
    `) as unknown as TypedDocumentString<Users_Admin__CreateEmptyTenantMutation, Users_Admin__CreateEmptyTenantMutationVariables>;
export const Users_Admin__User_LookupDocument = new TypedDocumentString(`
    query users_admin__user_lookup($filter: AdminLookupFilter!) {
  users_admin__user_lookup(filter: $filter) {
    tenant
    tenantName
    globalUserId
    profileId
    partyId
    firstName
    lastName
    avatarUrl
    primaryEmail {
      email
    }
    type
  }
}
    `) as unknown as TypedDocumentString<Users_Admin__User_LookupQuery, Users_Admin__User_LookupQueryVariables>;
export const Core_AcademicNamespacesDocument = new TypedDocumentString(`
    query core_academicNamespaces {
  core_academicNamespaces {
    academicNamespaceId
    type
    name
    year
    description
    isActiveDefaultNamespace
    startDate
    endDate
  }
}
    `) as unknown as TypedDocumentString<Core_AcademicNamespacesQuery, Core_AcademicNamespacesQueryVariables>;
export const Composite_CmsConfigDocument = new TypedDocumentString(`
    query composite_cmsConfig {
  composite_cmsConfig {
    url
    token
  }
}
    `) as unknown as TypedDocumentString<Composite_CmsConfigQuery, Composite_CmsConfigQueryVariables>;
export const File_Transfer_ListDocument = new TypedDocumentString(`
    query file_transfer_list($filter: FileTransferFilter) {
  file_transfer_list(filter: $filter) {
    id
    feature
    fileName
    fileUrl
    referenceId
    timestamp
    uploaderPartyId
    uploader {
      partyId
      avatarUrl
      firstName
      lastName
      type
      title {
        id
        name
        nameTextId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<File_Transfer_ListQuery, File_Transfer_ListQueryVariables>;
export const Layout_GetConfigDocument = new TypedDocumentString(`
    query layout_getConfig($filter: Layout_ConfigFilter!) {
  layout_getConfig(filter: $filter) {
    id
    configKey
    userId
    widgets
    lockedWidgets
  }
}
    `) as unknown as TypedDocumentString<Layout_GetConfigQuery, Layout_GetConfigQueryVariables>;
export const Layout_GetConfigsDocument = new TypedDocumentString(`
    query layout_getConfigs($filter: Layout_ConfigsFilter!) {
  layout_getConfigs(filter: $filter) {
    id
    configKey
    userId
    widgets
    lockedWidgets
  }
}
    `) as unknown as TypedDocumentString<Layout_GetConfigsQuery, Layout_GetConfigsQueryVariables>;
export const Layout_UpsertConfigDocument = new TypedDocumentString(`
    mutation layout_upsertConfig($input: Layout_UpsertConfigInput!) {
  layout_upsertConfig(input: $input) {
    id
    configKey
    userId
    widgets
    lockedWidgets
  }
}
    `) as unknown as TypedDocumentString<Layout_UpsertConfigMutation, Layout_UpsertConfigMutationVariables>;
export const Layout_DeleteConfigDocument = new TypedDocumentString(`
    mutation layout_deleteConfig($input: Layout_DeleteConfigInput!) {
  layout_deleteConfig(input: $input)
}
    `) as unknown as TypedDocumentString<Layout_DeleteConfigMutation, Layout_DeleteConfigMutationVariables>;
export const Users_OrganizationTenantDocument = new TypedDocumentString(`
    query users_organizationTenant($filter: OrganizationTenantFilter) {
  users_organizationTenant(filter: $filter) {
    tenant
    name
    imgUrl
  }
}
    `) as unknown as TypedDocumentString<Users_OrganizationTenantQuery, Users_OrganizationTenantQueryVariables>;
export const Catalogue_ProgrammeStagesDocument = new TypedDocumentString(`
    query catalogue_programmeStages($filter: ProgrammeStageFilter) {
  catalogue_programmeStages(filter: $filter) {
    id
    name
    shortName
    nationalCode
    programmeId
    editable
    discontinued
    programme {
      id
      name
      shortName
      nationalCode
      description
    }
    yearGroupId
    subjects {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<Catalogue_ProgrammeStagesQuery, Catalogue_ProgrammeStagesQueryVariables>;
export const Catalogue_SystemSettingsValuesDocument = new TypedDocumentString(`
    query catalogue_systemSettingsValues($filter: Catalogue_SystemSettingsFilter!) {
  catalogue_systemSettingsValues(filter: $filter) {
    attendance_subjectGroupAttendance_customSubjectGroupAttendanceCodes
    attendance_shareAttendanceNote_enabled
    security_dataPrivacy_confirmBeforeShowingSensitiveData
    security_logout_inactiveTimeUntilLogoutMinutes
    substitution_display_showAbsenceReason
    substitution_display_teacherDisplayNameType
    people_display_teacherDisplayNameType
    noticeboard_display_alwaysShowPinned
    communications_sms_studentSms
    schoolActivity_attendance_defaultAttendanceCode
    timetable_twoWeekTimetable_enabled
    timetable_construction_defaultToTableViewInBlockCores
    language_translation_enableSwitching
    language_translation_glossary
    featureFlag_settings_peapod
    featureFlag_attendance_sessionAttendance
    featureFlag_rulesEngine_rulesEnginePlus
    featureFlag_assessments_stateCba
    featureFlag_forms_newFormsSection
    featureFlag_security_advancedPermissions
    featureFlag_studentOptions_fullFeature
    featureFlag_userAccess_sds
    groupTags_groupsMenu_showProgrammeStages
    groupTags_groupsMenu_showYears
    groupTags_groupsMenu_showHouse
    groupTags_programmeStage_enabledStages
    security_summerMode_enabled
    behaviour_quickActions_list
    social_thirdParties_facebook
    social_thirdParties_instagram
    social_thirdParties_twitter
    attendance_signInOut_collectedBy
    attendance_overdue_numberOfDaysWidgetShows
    fees_feeForm_hideAbsorbFees
  }
}
    `) as unknown as TypedDocumentString<Catalogue_SystemSettingsValuesQuery, Catalogue_SystemSettingsValuesQueryVariables>;
export const Users_SubTenantsDocument = new TypedDocumentString(`
    query users_subTenants($filter: SubTenantsFilter) {
  users_subTenants(filter: $filter) {
    tenant
    name
    imgUrl
  }
}
    `) as unknown as TypedDocumentString<Users_SubTenantsQuery, Users_SubTenantsQueryVariables>;
export const Tasks_TasksDocument = new TypedDocumentString(`
    query tasks_tasks($filter: Tasks_MyTasksFilter) {
  tasks_tasks(filter: $filter) {
    executionId
    handlerName
    status
    submittedAt
    startedAt
    finishedAt
    durationMs
    successCount
    failCount
    exceptionMessage
    taskResults {
      type
      title
      payload
    }
  }
}
    `) as unknown as TypedDocumentString<Tasks_TasksQuery, Tasks_TasksQueryVariables>;
export const Tasks_CancelTaskDocument = new TypedDocumentString(`
    mutation tasks_cancelTask($input: Tasks_CancelTaskInput!) {
  tasks_cancelTask(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<Tasks_CancelTaskMutation, Tasks_CancelTaskMutationVariables>;
export const Users_LogoutDocument = new TypedDocumentString(`
    mutation users_logout {
  users_logout {
    success
  }
}
    `) as unknown as TypedDocumentString<Users_LogoutMutation, Users_LogoutMutationVariables>;
export const YearsDocument = new TypedDocumentString(`
    query years($filter: YearGroupFilter) {
  catalogue_years(filter: $filter) {
    yearGroupId
    name
  }
}
    `) as unknown as TypedDocumentString<YearsQuery, YearsQueryVariables>;
export const MyAuthDetailsDocument = new TypedDocumentString(`
    query myAuthDetails {
  myAuthDetails {
    id
    email
    name
    defaultProfileId
    activeProfileId
    isEmulatingAsTyroUser
    profiles {
      id
      nickName
      avatarUrl
      tenant {
        tenant
        name
        imgUrl
        tenantType
      }
      profileType {
        name
        description
        userType
      }
      permissionIds
      partyId
      tenantId
      blocked
    }
  }
}
    `) as unknown as TypedDocumentString<MyAuthDetailsQuery, MyAuthDetailsQueryVariables>;
export const BackgroundTasksActiveTasksDocument = new TypedDocumentString(`
    query backgroundTasksActiveTasks($filter: Tasks_MyTasksFilter) {
  tasks_tasks(filter: $filter) {
    executionId
  }
}
    `) as unknown as TypedDocumentString<BackgroundTasksActiveTasksQuery, BackgroundTasksActiveTasksQueryVariables>;